export const carouselTimeout = 7000;
export const carouselTransitionTime = 700;

export const getBaseUrl = () => {
  return isDev() ? "http://localhost:3001" : "https://socialsentinel.net/api";
};

export const ethnicityIds = {
  White: 1,
  Black: 2,
  EastAsian: 3,
  Hispanic: 5,
  Jewish: 6,
  MENA: 7,
  Mixed: 8,
  Other: 9,
  SouthAsian: 10,
  SoutheastAsian: 11,
  Unknown: 12,
};

export const individualPageLabels = {
  name: "NAME ",
  nativeName: "NATIVE NAME: ",
  aliases: "ALSO KNOWN AS: ",
  biography: "BIOGRAPHY: ",
  ethnicity: "ETHNICITY: ",
  ethnicityNotes: "ETHNICITY NOTES: ",
  sources: "SOURCES: ",
  nationality: "NATIONALITY: ",
  almaMater: "ALMA MATER: ",
  spouse: "SPOUSE: ",
  gender: "GENDER: ",
  sexuality: "SEXUALITY: ",
  dob: "DATE OF BIRTH: ",
  dateOfDeath: "DATE OF DEATH: ",
  studies: "Studies Featured In:",
  relationsAndAssociates: "Relations and Associates:",
  organizationalTies: "Organizational Ties:",
};

export const youTubeRegex =
  "^(https?://(www.)?|www.)?(youtube.com/@(.*)|youtube.com/c/(.*)|rumble.com/c/(.*))$";
export const twitterRegex =
  "(^(https://www.)|^(https://)|^(www.)|^())(twitter|x).com/.+$";
export const instagramRegex =
  "(^(https://www.)|^(https://)|^(www.)|^())(instagram).com/.+$";
export const wikipediaRegex =
  "(^(https://www.)|^(https://)|^(www.)|^())(en.wikipedia|wikipedia).org/.+$";
export const tiktokRegex =
  "(^(https://www.)|^(https://)|^(www.)|^())(tiktok).com/@.+$";
export const telegramRegex =
  "(^(https://www.)|^(https://)|^(www.)|^())(t).me/.+$ ";

export const chartColors = {
  Jewish: "#0038b8",
  White: "red",
  Black: "#4f02b5",
  MENA: "orange",
  Hispanic: "green",
  EastAsian: "#808000",
  SoutheastAsian: "yellow",
  SouthAsian: "#3d2104",
  Other: "pink",
  Mixed: "cyan",
  Unknown: "gray",
};

export const genderOptions = [
  { label: "Female", value: 0 },
  { label: "Male", value: 1 },
];

export const sexualityOptions = [
  { label: "Straight", value: 0 },
  { label: "Gay", value: 1 },
  { label: "Trans", value: 2 },
];

export const ethnicityOptions = [
  { label: "White", value: 1 },
  { label: "Black", value: 2 },
  { label: "East Asian", value: 3 },
  { label: "ERROR", value: 4 },
  { label: "Hispanic", value: 5 },
  { label: "Jewish", value: 6 },
  { label: "MENA", value: 7 },
  { label: "Mixed", value: 8 },
  { label: "Other", value: 9 },
  { label: "South Asian", value: 10 },
  { label: "Southeast Asian", value: 11 },
  { label: "Unknown", value: 12 },
];

export const countryOptions = [
  { label: "Afghanistan", value: "AFG" },
  { label: "Åland Islands", value: "ALA" },
  { label: "Albania", value: "ALB" },
  { label: "Algeria", value: "DZA" },
  { label: "American Samoa", value: "ASM" },
  { label: "Andorra", value: "AND" },
  { label: "Angola", value: "AGO" },
  { label: "Anguilla", value: "AIA" },
  { label: "Antarctica", value: "ATA" },
  { label: "Antigua and Barbuda", value: "ATG" },
  { label: "Argentina", value: "ARG" },
  { label: "Armenia", value: "ARM" },
  { label: "Aruba", value: "ABW" },
  { label: "Australia", value: "AUS" },
  { label: "Austria", value: "AUT" },
  { label: "Azerbaijan", value: "AZE" },
  { label: "Bahamas", value: "BHS" },
  { label: "Bahrain", value: "BHR" },
  { label: "Bangladesh", value: "BGD" },
  { label: "Barbados", value: "BRB" },
  { label: "Belarus", value: "BLR" },
  { label: "Belgium", value: "BEL" },
  { label: "Belize", value: "BLZ" },
  { label: "Benin", value: "BEN" },
  { label: "Bermuda", value: "BMU" },
  { label: "Bhutan", value: "BTN" },
  { label: "Bolivia", value: "BOL" },
  { label: "Bonaire, Sint Eustatius and Saba", value: "BES" },
  { label: "Bosnia and Herzegovina", value: "BIH" },
  { label: "Botswana", value: "BWA" },
  { label: "Bouvet Island", value: "BVT" },
  { label: "Brazil", value: "BRA" },
  { label: "British Indian Ocean Territory", value: "IOT" },
  { label: "Brunei Darussalam", value: "BRN" },
  { label: "Bulgaria", value: "BGR" },
  { label: "Burkina Faso", value: "BFA" },
  { label: "Burundi", value: "BDI" },
  { label: "Cabo Verde", value: "CPV" },
  { label: "Cambodia", value: "KHM" },
  { label: "Cameroon", value: "CMR" },
  { label: "Canada", value: "CAN" },
  { label: "Cayman Islands", value: "CYM" },
  { label: "Central African Republic", value: "CAF" },
  { label: "Chad", value: "TCD" },
  { label: "Chile", value: "CHL" },
  { label: "China", value: "CHN" },
  { label: "Christmas Island", value: "CXR" },
  { label: "Cocos (Keeling) Islands", value: "CCK" },
  { label: "Colombia", value: "COL" },
  { label: "Comoros", value: "COM" },
  { label: "Congo", value: "COG" },
  { label: "Congo (Democratic Republic of the)", value: "COD" },
  { label: "Cook Islands", value: "COK" },
  { label: "Costa Rica", value: "CRI" },
  { label: "Croatia", value: "HRV" },
  { label: "Cuba", value: "CUB" },
  { label: "Curaçao", value: "CUW" },
  { label: "Cyprus", value: "CYP" },
  { label: "Czech Republic", value: "CZE" },
  { label: "Denmark", value: "DNK" },
  { label: "Djibouti", value: "DJI" },
  { label: "Dominica", value: "DMA" },
  { label: "Dominican Republic", value: "DOM" },
  { label: "Ecuador", value: "ECU" },
  { label: "Egypt", value: "EGY" },
  { label: "El Salvador", value: "SLV" },
  { label: "Equatorial Guinea", value: "GNQ" },
  { label: "Eritrea", value: "ERI" },
  { label: "Estonia", value: "EST" },
  { label: "Ethiopia", value: "ETH" },
  { label: "Falkland Islands (Malvinas)", value: "FLK" },
  { label: "Faroe Islands", value: "FRO" },
  { label: "Fiji", value: "FJI" },
  { label: "Finland", value: "FIN" },
  { label: "France", value: "FRA" },
  { label: "French Guiana", value: "GUF" },
  { label: "French Polynesia", value: "PYF" },
  { label: "French Southern Territories", value: "ATF" },
  { label: "Gabon", value: "GAB" },
  { label: "Gambia", value: "GMB" },
  { label: "Georgia", value: "GEO" },
  { label: "Germany", value: "DEU" },
  { label: "Ghana", value: "GHA" },
  { label: "Gibraltar", value: "GIB" },
  { label: "Greece", value: "GRC" },
  { label: "Greenland", value: "GRL" },
  { label: "Grenada", value: "GRD" },
  { label: "Guadeloupe", value: "GLP" },
  { label: "Guam", value: "GUM" },
  { label: "Guatemala", value: "GTM" },
  { label: "Guernsey", value: "GGY" },
  { label: "Guinea", value: "GIN" },
  { label: "Guinea-Bissau", value: "GNB" },
  { label: "Guyana", value: "GUY" },
  { label: "Haiti", value: "HTI" },
  { label: "Heard Island and McDonald Islands", value: "HMD" },
  { label: "Vatican City", value: "VAT" },
  { label: "Honduras", value: "HND" },
  { label: "Hong Kong", value: "HKG" },
  { label: "Hungary", value: "HUN" },
  { label: "Iceland", value: "ISL" },
  { label: "India", value: "IND" },
  { label: "Indonesia", value: "IDN" },
  { label: "Iran", value: "IRN" },
  { label: "Iraq", value: "IRQ" },
  { label: "Ireland", value: "IRL" },
  { label: "Isle of Man", value: "IMN" },
  { label: "Israel", value: "ISR" },
  { label: "Italy", value: "ITA" },
  { label: "Jamaica", value: "JAM" },
  { label: "Japan", value: "JPN" },
  { label: "Jersey", value: "JEY" },
  { label: "Jordan", value: "JOR" },
  { label: "Kazakhstan", value: "KAZ" },
  { label: "Kenya", value: "KEN" },
  { label: "Kiribati", value: "KIR" },
  { label: "North Korea", value: "PRK" },
  { label: "South Korea", value: "KOR" },
  { label: "Kuwait", value: "KWT" },
  { label: "Kyrgyzstan", value: "KGZ" },
  { label: "Laos", value: "LAO" },
  { label: "Latvia", value: "LVA" },
  { label: "Lebanon", value: "LBN" },
  { label: "Lesotho", value: "LSO" },
  { label: "Liberia", value: "LBR" },
  { label: "Libya", value: "LBY" },
  { label: "Liechtenstein", value: "LIE" },
  { label: "Lithuania", value: "LTU" },
  { label: "Luxembourg", value: "LUX" },
  { label: "Macao", value: "MAC" },
  { label: "Macedonia", value: "MKD" },
  { label: "Madagascar", value: "MDG" },
  { label: "Malawi", value: "MWI" },
  { label: "Malaysia", value: "MYS" },
  { label: "Maldives", value: "MDV" },
  { label: "Mali", value: "MLI" },
  { label: "Malta", value: "MLT" },
  { label: "Marshall Islands", value: "MHL" },
  { label: "Martinique", value: "MTQ" },
  { label: "Mauritania", value: "MRT" },
  { label: "Mauritius", value: "MUS" },
  { label: "Mayotte", value: "MYT" },
  { label: "Mexico", value: "MEX" },
  { label: "Micronesia", value: "FSM" },
  { label: "Moldova", value: "MDA" },
  { label: "Monaco", value: "MCO" },
  { label: "Mongolia", value: "MNG" },
  { label: "Montenegro", value: "MNE" },
  { label: "Montserrat", value: "MSR" },
  { label: "Morocco", value: "MAR" },
  { label: "Mozambique", value: "MOZ" },
  { label: "Myanmar", value: "MMR" },
  { label: "Namibia", value: "NAM" },
  { label: "Nauru", value: "NRU" },
  { label: "Nepal", value: "NPL" },
  { label: "Netherlands", value: "NLD" },
  { label: "New Caledonia", value: "NCL" },
  { label: "New Zealand", value: "NZL" },
  { label: "Nicaragua", value: "NIC" },
  { label: "Niger", value: "NER" },
  { label: "Nigeria", value: "NGA" },
  { label: "Niue", value: "NIU" },
  { label: "Norfolk Island", value: "NFK" },
  { label: "Northern Mariana Islands", value: "MNP" },
  { label: "Norway", value: "NOR" },
  { label: "Oman", value: "OMN" },
  { label: "Pakistan", value: "PAK" },
  { label: "Palau", value: "PLW" },
  { label: "Palestine", value: "PSE" },
  { label: "Panama", value: "PAN" },
  { label: "Papua New Guinea", value: "PNG" },
  { label: "Paraguay", value: "PRY" },
  { label: "Peru", value: "PER" },
  { label: "Philippines", value: "PHL" },
  { label: "Pitcairn", value: "PCN" },
  { label: "Poland", value: "POL" },
  { label: "Portugal", value: "PRT" },
  { label: "Puerto Rico", value: "PRI" },
  { label: "Qatar", value: "QAT" },
  { label: "Réunion", value: "REU" },
  { label: "Romania", value: "ROM" },
  { label: "Russia", value: "RUS" },
  { label: "Rwanda", value: "RWA" },
  { label: "Saint Barthélemy", value: "BLM" },
  { label: "Saint Helena, Ascension and Tristan da Cunha", value: "SHN" },
  { label: "Saint Kitts and Nevis", value: "KNA" },
  { label: "Saint Lucia", value: "LCA" },
  { label: "Saint Martin (French part)", value: "MAF" },
  { label: "Saint Pierre and Miquelon", value: "SPM" },
  { label: "Saint Vincent and the Grenadines", value: "VCT" },
  { label: "Samoa", value: "WSM" },
  { label: "San Marino", value: "SMR" },
  { label: "Sao Tome and Principe", value: "STP" },
  { label: "Saudi Arabia", value: "SAU" },
  { label: "Senegal", value: "SEN" },
  { label: "Serbia", value: "SRB" },
  { label: "Seychelles", value: "SYC" },
  { label: "Sierra Leone", value: "SLE" },
  { label: "Singapore", value: "SGP" },
  { label: "Sint Maarten (Dutch part)", value: "SXM" },
  { label: "Slovakia", value: "SVK" },
  { label: "Slovenia", value: "SVN" },
  { label: "Solomon Islands", value: "SLB" },
  { label: "Somalia", value: "SOM" },
  { label: "South Africa", value: "ZAF" },
  { label: "South Georgia and the South Sandwich Islands", value: "SGS" },
  { label: "South Sudan", value: "SSD" },
  { label: "Spain", value: "ESP" },
  { label: "Sri Lanka", value: "LKA" },
  { label: "Sudan", value: "SDN" },
  { label: "Suriname", value: "SUR" },
  { label: "Svalbard and Jan Mayen", value: "SJM" },
  { label: "Eswatini", value: "SWZ" },
  { label: "Sweden", value: "SWE" },
  { label: "Switzerland", value: "CHE" },
  { label: "Syrian", value: "SYR" },
  { label: "Taiwan", value: "TWN" },
  { label: "Tajikistan", value: "TJK" },
  { label: "Tanzania", value: "TZA" },
  { label: "Thailand", value: "THA" },
  { label: "Timor-Leste", value: "TLS" },
  { label: "Togo", value: "TGO" },
  { label: "Tokelau", value: "TKL" },
  { label: "Tonga", value: "TON" },
  { label: "Trinidad and Tobago", value: "TTO" },
  { label: "Tunisia", value: "TUN" },
  { label: "Turkey", value: "TUR" },
  { label: "Turkmenistan", value: "TKM" },
  { label: "Turks and Caicos Islands", value: "TCA" },
  { label: "Tuvalu", value: "TUV" },
  { label: "Uganda", value: "UGA" },
  { label: "Ukraine", value: "UKR" },
  { label: "United Arab Emirates", value: "ARE" },
  { label: "United Kingdom", value: "GBR" },
  { label: "Scotland", value: "SCO" },
  { label: "United States Minor Outlying Islands", value: "UMI" },
  { label: "Uruguay", value: "URY" },
  { label: "United States", value: "USA" },
  { label: "Uzbekistan", value: "UZB" },
  { label: "Vanuatu", value: "VUT" },
  { label: "Venezuela", value: "VEN" },
  { label: "Vietnam", value: "VNM" },
  { label: "Virgin Islands (British)", value: "VGB" },
  { label: "Virgin Islands (U.S.)", value: "VIR" },
  { label: "Wallis and Futuna", value: "WLF" },
  { label: "Western Sahara", value: "ESH" },
  { label: "Yemen", value: "YEM" },
  { label: "Zambia", value: "ZMB" },
  { label: "Zimbabwe", value: "ZWE" },
  { label: "Global", value: "GLOBAL" },
];

export const countries = {
  AFG: "Afghanistan",
  ALA: "Åland Islands",
  ALB: "Albania",
  DZA: "Algeria",
  ASM: "American Samoa",
  AND: "Andorra",
  AGO: "Angola",
  AIA: "Anguilla",
  ATA: "Antarctica",
  ATG: "Antigua and Barbuda",
  ARG: "Argentina",
  ARM: "Armenia",
  ABW: "Aruba",
  AUS: "Australia",
  AUT: "Austria",
  AZE: "Azerbaijan",
  BHS: "Bahamas",
  BHR: "Bahrain",
  BGD: "Bangladesh",
  BRB: "Barbados",
  BLR: "Belarus",
  BEL: "Belgium",
  BLZ: "Belize",
  BEN: "Benin",
  BMU: "Bermuda",
  BTN: "Bhutan",
  BOL: "Bolivia",
  BES: "Bonaire, Sint Eustatius and Saba",
  BIH: "Bosnia and Herzegovina",
  BWA: "Botswana",
  BVT: "Bouvet Island",
  BRA: "Brazil",
  IOT: "British Indian Ocean Territory",
  BRN: "Brunei Darussalam",
  BGR: "Bulgaria",
  BFA: "Burkina Faso",
  BDI: "Burundi",
  CPV: "Cabo Verde",
  KHM: "Cambodia",
  CMR: "Cameroon",
  CAN: "Canada",
  CYM: "Cayman Islands",
  CAF: "Central African Republic",
  TCD: "Chad",
  CHL: "Chile",
  CHN: "China",
  CXR: "Christmas Island",
  CCK: "Cocos (Keeling) Islands",
  COL: "Colombia",
  COM: "Comoros",
  COG: "Congo",
  COD: "Congo (Democratic Republic of the)",
  COK: "Cook Islands",
  CRI: "Costa Rica",
  HRV: "Croatia",
  CUB: "Cuba",
  CUW: "Curaçao",
  CYP: "Cyprus",
  CZE: "Czech Republic",
  DNK: "Denmark",
  DJI: "Djibouti",
  DMA: "Dominica",
  DOM: "Dominican Republic",
  ECU: "Ecuador",
  EGY: "Egypt",
  SLV: "El Salvador",
  GNQ: "Equatorial Guinea",
  ERI: "Eritrea",
  EST: "Estonia",
  ETH: "Ethiopia",
  FLK: "Falkland Islands (Malvinas)",
  FRO: "Faroe Islands",
  FJI: "Fiji",
  FIN: "Finland",
  FRA: "France",
  GUF: "French Guiana",
  PYF: "French Polynesia",
  ATF: "French Southern Territories",
  GAB: "Gabon",
  GMB: "Gambia",
  GEO: "Georgia",
  DEU: "Germany",
  GHA: "Ghana",
  GIB: "Gibraltar",
  GRC: "Greece",
  GRL: "Greenland",
  GRD: "Grenada",
  GLP: "Guadeloupe",
  GUM: "Guam",
  GTM: "Guatemala",
  GGY: "Guernsey",
  GIN: "Guinea",
  GNB: "Guinea-Bissau",
  GUY: "Guyana",
  HTI: "Haiti",
  HMD: "Heard Island and McDonald Islands",
  VAT: "Vatican City",
  HND: "Honduras",
  HKG: "Hong Kong",
  HUN: "Hungary",
  ISL: "Iceland",
  IND: "India",
  IDN: "Indonesia",
  IRN: "Iran",
  IRQ: "Iraq",
  IRL: "Ireland",
  IMN: "Isle of Man",
  ISR: "Israel",
  ITA: "Italy",
  JAM: "Jamaica",
  JPN: "Japan",
  JEY: "Jersey",
  JOR: "Jordan",
  KAZ: "Kazakhstan",
  KEN: "Kenya",
  KIR: "Kiribati",
  PRK: "North Korea",
  KOR: "South Korea",
  KWT: "Kuwait",
  KGZ: "Kyrgyzstan",
  LAO: "Laos",
  LVA: "Latvia",
  LBN: "Lebanon",
  LSO: "Lesotho",
  LBR: "Liberia",
  LBY: "Libya",
  LIE: "Liechtenstein",
  LTU: "Lithuania",
  LUX: "Luxembourg",
  MAC: "Macao",
  MKD: "Macedonia",
  MDG: "Madagascar",
  MWI: "Malawi",
  MYS: "Malaysia",
  MDV: "Maldives",
  MLI: "Mali",
  MLT: "Malta",
  MHL: "Marshall Islands",
  MTQ: "Martinique",
  MRT: "Mauritania",
  MUS: "Mauritius",
  MYT: "Mayotte",
  MEX: "Mexico",
  FSM: "Micronesia",
  MDA: "Moldova",
  MCO: "Monaco",
  MNG: "Mongolia",
  MNE: "Montenegro",
  MSR: "Montserrat",
  MAR: "Morocco",
  MOZ: "Mozambique",
  MMR: "Myanmar",
  NAM: "Namibia",
  NRU: "Nauru",
  NPL: "Nepal",
  NLD: "Netherlands",
  NCL: "New Caledonia",
  NZL: "New Zealand",
  NIC: "Nicaragua",
  NER: "Niger",
  NGA: "Nigeria",
  NIU: "Niue",
  NFK: "Norfolk Island",
  MNP: "Northern Mariana Islands",
  NOR: "Norway",
  OMN: "Oman",
  PAK: "Pakistan",
  PLW: "Palau",
  PSE: "Palestine",
  PAN: "Panama",
  PNG: "Papua New Guinea",
  PRY: "Paraguay",
  PER: "Peru",
  PHL: "Philippines",
  PCN: "Pitcairn",
  POL: "Poland",
  PRT: "Portugal",
  PRI: "Puerto Rico",
  QAT: "Qatar",
  REU: "Réunion",
  ROM: "Romania",
  RUS: "Russia",
  RWA: "Rwanda",
  BLM: "Saint Barthélemy",
  SHN: "Saint Helena, Ascension and Tristan da Cunha",
  KNA: "Saint Kitts and Nevis",
  LCA: "Saint Lucia",
  MAF: "Saint Martin (French part)",
  SPM: "Saint Pierre and Miquelon",
  VCT: "Saint Vincent and the Grenadines",
  WSM: "Samoa",
  SMR: "San Marino",
  STP: "Sao Tome and Principe",
  SAU: "Saudi Arabia",
  SEN: "Senegal",
  SRB: "Serbia",
  SYC: "Seychelles",
  SLE: "Sierra Leone",
  SGP: "Singapore",
  SXM: "Sint Maarten (Dutch part)",
  SVK: "Slovakia",
  SVN: "Slovenia",
  SLB: "Solomon Islands",
  SOM: "Somalia",
  ZAF: "South Africa",
  SGS: "South Georgia and the South Sandwich Islands",
  SSD: "South Sudan",
  ESP: "Spain",
  LKA: "Sri Lanka",
  SDN: "Sudan",
  SUR: "Suriname",
  SJM: "Svalbard and Jan Mayen",
  SWZ: "Eswatini",
  SWE: "Sweden",
  CHE: "Switzerland",
  SYR: "Syrian",
  TWN: "Taiwan",
  TJK: "Tajikistan",
  TZA: "Tanzania",
  THA: "Thailand",
  TLS: "Timor-Leste",
  TGO: "Togo",
  TKL: "Tokelau",
  TON: "Tonga",
  TTO: "Trinidad and Tobago",
  TUN: "Tunisia",
  TUR: "Turkey",
  TKM: "Turkmenistan",
  TCA: "Turks and Caicos Islands",
  TUV: "Tuvalu",
  UGA: "Uganda",
  UKR: "Ukraine",
  ARE: "United Arab Emirates",
  GBR: "United Kingdom",
  UMI: "United States Minor Outlying Islands",
  URY: "Uruguay",
  USA: "United States",
  UZB: "Uzbekistan",
  VUT: "Vanuatu",
  VEN: "Venezuela",
  VNM: "Vietnam",
  VGB: "Virgin Islands (British)",
  VIR: "Virgin Islands (U.S.)",
  WLF: "Wallis and Futuna",
  ESH: "Western Sahara",
  YEM: "Yemen",
  ZMB: "Zambia",
  ZWE: "Zimbabwe",
  GLOBAL: "Global",
};

export function getCountryFullName(code) {
  const countryFullName = countries[code];

  if (countryFullName) {
    return countryFullName;
  } else {
    return "Country not found";
  }
}

export function isDev() {
  return false;
}

export function splitString(str) {
  // Using a regular expression to split the string based on bars
  var resultList = str.split("|");

  // Removing empty elements from the resulting array
  resultList = resultList.filter(function (element) {
    return element.trim() !== "";
  });

  return resultList;
}

// Given the name of an organization, return the second part or "tagline" of the title of the
// auto-generated meme. e.g. for "NBA Team Owners", return "Team Owners" as the "NBA" part is
// covered by the NBA logo that will be included at the top of the meme.
export function getOrganizationMemeTagline(str) {
  switch (str) {
    case "NBA Team Owners":
      return "Team Owners";
    default:
      return "";
  }
}

export function getFormattedDate(dateString) {

  const date = new Date(dateString);

  if (date.getFullYear() === 1900 && date.getMonth() === 0 && date.getDate() === 1) {
    return 'LIST COMPLETE'
  }

  return date.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
    day: "numeric",
  });
};

export function getIndividualAge(dateString) {
  const date = new Date(dateString);

  const today = new Date();
  let age = today.getFullYear() - date.getFullYear();
  const monthDiff = today.getMonth() - date.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
    age--;
  }

  return `(age ${age})`;
}

export function getIndividualAgeAtDeath(dateOfBirthString, dateOfDeathString) {
  const birthDate = new Date(dateOfBirthString);
  const deathDate = new Date(dateOfDeathString);

  let age = deathDate.getFullYear() - birthDate.getFullYear();
  const monthDiff = deathDate.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && deathDate.getDate() < birthDate.getDate())) {
    age--;
  }

  return `(aged ${age})`;
}

export function getOrganizationLogo(orgName, imgClass, isBanner) {
  orgName = orgName.replace(/_/g, " ");
  let imageFilename = orgName + (isBanner ? "_banner" : "") + ".jpg";

  try {
    let imagePath = require(`./res/organization_logos/${imageFilename}`);
    return <img src={imagePath} className={imgClass} alt={orgName} />;
  } catch (error) {
    return null;
  }
}

export function getPeopleRelationshipCleaned(name) {
  // Removes anything after the persons name. So anything after " - "
  return getIndividualUnderscored(name.split(" - ")[0]);
}

export function getIndividualUnderscored(name) {
  return "/individual/" + getUnderscoredString(name);
}

export function getOrganizationUnderscored(org) {
  return "/organization/" + getUnderscoredString(org);
}

export function getMemeUnderscored(org) {
  return "/memegenerator/" + getUnderscoredString(org);
}

function getUnderscoredString(str) {
  return str.replace(/\s+/g, "_");
}

export function getEthnicityPercentageByCountry(ethnicity, country) {
  if (country === "USA") {
    switch (ethnicity) {
      case "Jewish":
        return 2.4;
      case "White":
        return 60.1;
      case "Black":
        return 12.2;
      case "Mixed":
        return 2.8;
      default:
        return 1;
    }
  } else {
    switch (ethnicity) {
      case "Jewish":
        return 2.4;
      case "White":
        return 60.1;
      case "Black":
        return 12.2;
      case "Mixed":
        return 2.8;
      default:
        return 1;
    }
  }
}

export const completedStudies = [
  // {
  //   value: "All World Billionaires (Forbes)",
  //   label: "All World Billionaires (Forbes)",
  // },
  // {
  //   value: "Anti-Defamation League Leadership",
  //   label: "Anti-Defamation League Leadership",
  // },
  // {
  //   value: "Austrian Billionaires",
  //   label: "Austrian Billionaires",
  // },
  {
    value: "Ben Shapiro's Sunday Special",
    label: "Ben Shapiro's Sunday Special",
  },
  // {
  //   value: "British Billionaires",
  //   label: "British Billionaires",
  // },
  // {
  //   value: "Comedians (According to Wikipedia)",
  //   label: "Comedians (According to Wikipedia)",
  // },
  {
    value: "Critical Theorists (According to Wikipedia)",
    label: "Critical Theorists (According to Wikipedia)",
  },
  {
    value: "The Don Lemon Show",
    label: "The Don Lemon Show",
  },
  // {
  //   value: "Dark Horse Podcast (Bret Weinstein's Podcast)",
  //   label: "Dark Horse Podcast (Bret Weinstein's Podcast)",
  // },
  // {
  //   value: "David Pakman Show Guests (Since May 4 2020)",
  //   label: "David Pakman Show Guests (Since May 4 2020)",
  // },
  // {
  //   value: "Drag Queens (According to Wikipedia)",
  //   label: "Drag Queens (According to Wikipedia)",
  // },
  // {
  //   value: "Feminists (20th century onwards Wikipedia)",
  //   label: "Feminists (20th century onwards Wikipedia)",
  // },
  // {
  //   value: "Forbes Australias Wealthiest Top 50",
  //   label: "Forbes Top 50",
  // },
  // {
  //   value: "Forbes Top Billionaire Art Collectors",
  //   label: "Forbes Top Billionaire Art Collectors",
  // },
  // {
  //   value: "Forbes Wealthiest Top 100",
  //   label: "Forbes Top 100",
  // },
  {
    value: "Forbes Wealthiest Top 20",
    label: "Forbes Top 20",
  },
  {
    value: "Forbes Wealthiest Top 200",
    label: "Forbes Top 200",
  },
  {
    value: "Forbes Wealthiest Top 40",
    label: "Forbes Top 40",
  },
  {
    value: "Forbes Wealthiest Top 400",
    label: "Forbes Top 400",
  },
  // {
  //   value: "Former Employees of Goldman Sachs (According to Wikipedia)",
  //   label: "Former Employees of Goldman Sachs (According to Wikipedia)",
  // },
  // {
  //   value:
  //     "Former Employees of Goldman Sachs United States Based Only (According to Wikipedia)",
  //   label:
  //     "Former Employees of Goldman Sachs United States Based Only (According to Wikipedia)",
  // },
  // {
  //   value: "Former Ivy League Presidents",
  //   label: "Former Ivy League Presidents",
  // },
  // {
  //   value: "Freemasons (According to Wikipedia)",
  //   label: "Freemasons (According to Wikipedia)",
  // },
  // {
  //   value: "French Billionaires",
  //   label: "French Billionaires",
  // },
  // {
  //   value: "German Billionaires",
  //   label: "German Billionaires",
  // },
  // {
  //   value: "Gun Rights Activists (According to Wikipedia)",
  //   label: "Gun Rights Activists (According to Wikipedia)",
  // },
  {
    value: "Hollywood Walk of Fame (Fictitious characters excluded)",
    label: "Hollywood Walk of Fame (Fictitious characters excluded)",
  },
  // {
  //   value: "Huberman Lab Guests (Andrew Huberman Podcast)",
  //   label: "Huberman Lab Guests (Andrew Huberman Podcast)",
  // },
  // {
  //   value: "Hungarian Billionaires",
  //   label: "Hungarian Billionaires",
  // },
  // {
  //   value: "IMF Managing Directors",
  //   label: "IMF Managing Directors",
  // },
  // {
  //   value: "Irish Billionaires",
  //   label: "Irish Billionaires",
  // },
  // {
  //   value: "Israeli Billionaires",
  //   label: "Israeli Billionaires",
  // },
  // {
  //   value: "Italian Billionaires",
  //   label: "Italian Billionaires",
  // },
  // {
  //   value: "Ivy League Presidents",
  //   label: "Ivy League Presidents",
  // },
  // {
  //   value: "Joe Rogan Experience",
  //   label: "Joe Rogan Experience",
  // },
  // {
  //   value: "Making Sense with Sam Harris Podcast",
  //   label: "Making Sense with Sam Harris Podcast",
  // },
  // {
  //   value: "Male Boxers (According to Wikipedia)",
  //   label: "Male Boxers (According to Wikipedia)",
  // },
  // {
  //   value: "Male Mixed Martial Artists (According to Wikipedia)",
  //   label: "Male Mixed Martial Artists (According to Wikipedia)",
  // },
  // {
  //   value: "Male Professional Bodybuilders (According to Wikipedia)",
  //   label: "Male Professional Bodybuilders (According to Wikipedia)",
  // },
  // {
  //   value: "Marxists (According to Wikipedia)",
  //   label: "Marxists (According to Wikipedia)",
  // },
  // {
  //   value: "Match Group",
  //   label: "Match Group",
  // },
  // {
  //   value: "Members of Weather Underground (According to Wikipedia)",
  //   label: "Members of Weather Underground (According to Wikipedia)",
  // },
  // {
  //   value: "Mens UFC Champions (According to Wikipedia)",
  //   label: "Mens UFC Champions (According to Wikipedia)",
  // },
  // {
  //   value: "MLB Team Owners",
  //   label: "MLB Team Owners",
  // },
  // {
  //   value: "NBA Team Owners",
  //   label: "NBA Team Owners",
  // },
  {
    value: "Neoconservatives (According to Wikipedia)",
    label: "Neoconservatives (According to Wikipedia)",
  },
  {
    value: "Armchair Expert (Dax Shepard's Podcast)",
    label: "Armchair Expert (Dax Shepard's Podcast)",
  },
  // {
  //   value: "NFL Team Owners",
  //   label: "NFL Team Owners",
  // },
  // {
  //   value: "NHL Team Owners",
  //   label: "NHL Team Owners",
  // },
  // {
  //   value: "Nobel Laureates (1943 - Present)",
  //   label: "Nobel Laureates (1943 - Present)",
  // },
  // {
  //   value: "Nobel Laureates (All)",
  //   label: "Nobel Laureates (All)",
  // },
  // {
  //   value: "Nobel Laureates (Chemistry)",
  //   label: "Nobel Laureates (Chemistry)",
  // },
  // {
  //   value: "Nobel Laureates (Economics)",
  //   label: "Nobel Laureates (Economics)",
  // },
  // {
  //   value: "Nobel Laureates (Literature)",
  //   label: "Nobel Laureates (Literature)",
  // },
  // {
  //   value: "Nobel Laureates (Peace)",
  //   label: "Nobel Laureates (Peace)",
  // },
  // {
  //   value: "Nobel Laureates (Physics)",
  //   label: "Nobel Laureates (Physics)",
  // },
  // {
  //   value: "Nobel Laureates (Physiology or Medicine)",
  //   label: "Nobel Laureates (Physiology or Medicine)",
  // },
  {
    value: "Notable Non-Black Freedom Riders (According To Wikipedia)",
    label: "Notable Non-Black Freedom Riders (According To Wikipedia)",
  },
  // {
  //   value: "NPR Personnel (According to Wikipedia)",
  //   label: "NPR Personnel (According to Wikipedia)",
  // },
  {
    value: "The PBD Podcast (Patrick Bet David's Podcast)",
    label: "The PBD Podcast (Patrick Bet David's Podcast)",
  },
  // {
  //   value: "Polish Billionaires",
  //   label: "Polish Billionaires",
  // },
  // {
  //   value: "Political Scientists (According to Wikipedia)",
  //   label: "Political Scientists (According to Wikipedia)",
  // },
  // {
  //   value: "Pornographic Performers (According to Wikipedia)",
  //   label: "Pornographic Performers (According to Wikipedia)",
  // },
  {
    value: "Prominent YouTubers (According to Wikipedia)",
    label: "Prominent YouTubers (According to Wikipedia)",
  },
  // {
  //   value: "Psychoanalytical Theorists (According to Wikipedia)",
  //   label: "Psychoanalytical Theorists (According to Wikipedia)",
  // },
  // {
  //   value: "QI Panellists (British TV Show)",
  //   label: "QI Panellists (British TV Show)",
  // },
  // {
  //   value: "Real Time with Bill Maher",
  //   label: "Real Time with Bill Maher",
  // },
  // {
  //   value: "Richest Person in Every US State",
  //   label: "Richest Person in Every US State",
  // },
  // {
  //   value: "Simpsons Guest Stars",
  //   label: "Simpsons Guest Stars",
  // },
  // {
  //   value: "Social Democrats (According to Wikipedia)",
  //   label: "Social Democrats (According to Wikipedia)",
  // },
  // {
  //   value: "Social Psychologists (According to Wikipedia)",
  //   label: "Social Psychologists (According to Wikipedia)",
  // },
  // {
  //   value: "Social Theorists (According to Wikipedia)",
  //   label: "Social Theorists (According to Wikipedia)",
  // },
  // {
  //   value: "Spanish Billionaires",
  //   label: "Spanish Billionaires",
  // },
  {
    value: "Strongmen (According to Wikipedia)",
    label: "Strongmen (According to Wikipedia)",
  },
  {
    value: "Canada's Walk of Fame Inductees (Groups Excluded)",
    label: "Canada's Walk of Fame Inductees (Groups Excluded)",
  },
  // {
  //   value: "Swiss Billionaires",
  //   label: "Swiss Billionaires",
  // },
  // {
  //   value: "The Charlie Kirk Show",
  //   label: "The Charlie Kirk Show",
  // },
  // {
  //   value: "The Daily Show with Jon Stewart Guests",
  //   label: "The Daily Show with Jon Stewart Guests",
  // },
  // {
  //   value: "The Daily Show with Jon Stewart Political Guests",
  //   label: "The Daily Show with Jon Stewart Political Guests",
  // },
  // {
  //   value: "The Late Show with Stephen Colbert",
  //   label: "The Late Show with Stephen Colbert",
  // },
  // {
  //   value: "The Lex Fridman Podcast",
  //   label: "The Lex Fridman Podcast",
  // },
  // {
  //   value: "The Majority Report Guests (Sam Seder's Show)",
  //   label: "The Majority Report Guests (Sam Seder's Show)",
  // },
  {
    value: "The Portal (Eric Weinstein's former podcast)",
    label: "The Portal (Eric Weinstein's former podcast)",
  },
  // {
  //   value:
  //     "The Rubin Report (Dave Rubin's Podcast. The Sit Down' & 'Roundtable' guests)",
  //   label:
  //     "The Rubin Report (Dave Rubin's Podcast. The Sit Down' & 'Roundtable' guests)",
  // },
  // {
  //   value: "The Times UK Wealthiest List (Rich List) Top 100",
  //   label: "The Times UK Wealthiest List (Rich List) Top 100",
  // },
  // {
  //   value: "The Times UK Wealthiest List (Rich List) Top 20",
  //   label: "The Times UK Wealthiest List (Rich List) Top 20",
  // },
  // {
  //   value: "The Times UK Wealthiest List (Rich List) Top 40",
  //   label: "The Times UK Wealthiest List (Rich List) Top 40",
  // },
  // {
  //   value: "The Tim Ferriss Show",
  //   label: "The Tim Ferriss Show",
  // },
  // {
  //   value: "The Tonight Show with Jimmy Fallon",
  //   label: "The Tonight Show with Jimmy Fallon",
  // },
  // {
  //   value: "Timcast IRL Guests (Tim Pool's Podcast)",
  //   label: "Timcast IRL Guests (Tim Pool's Podcast)",
  // },
  // {
  //   value: "UK Stand-up Comedians (According to Wikipedia)",
  //   label: "UK Stand-up Comedians (According to Wikipedia)",
  // },
  // {
  //   value: "UK Television Presenters (According to Wikipedia)",
  //   label: "UK Television Presenters (According to Wikipedia)",
  // },
  // {
  //   value: "United States News Anchors (According to Wikipedia)",
  //   label: "United States News Anchors (According to Wikipedia)",
  // },
  // {
  //   value: "United States Stand-up Comedians (According to Wikipedia)",
  //   label: "United States Stand-up Comedians (According to Wikipedia)",
  // },
  // {
  //   value: "US House of Representatives Members (Current)",
  //   label: "US House of Representatives Members (Current)",
  // },
  // {
  //   value: "US Senators (Current)",
  //   label: "US Senators (Current)",
  // },
  // {
  //   value: "US Senators (Historical, from 1950)",
  //   label: "US Senators (Historical, from 1950)",
  // },
  // {
  //   value: "US Supreme Court Justices (Historical, from 1950)",
  //   label: "US Supreme Court Justices (Historical, from 1950)",
  // },
  // {
  //   value: "US Television Presenters (According to Wikipedia)",
  //   label: "US Television Presenters (According to Wikipedia)",
  // },
  // {
  //   value: "Wealthiest People in Canada",
  //   label: "Wealthiest People in Canada",
  // },
  // {
  //   value: "Wealthiest People in Russia",
  //   label: "Wealthiest People in Russia",
  // },
  // {
  //   value: "YOUR WELCOME (Michael Malice's Podcast)",
  //   label: "YOUR WELCOME (Michael Malice's Podcast)",
  // },
  // {
  //   value: "Survivor Contestants (American TV Series)",
  //   label: "Survivor Contestants",
  // },
];

export const almaMaterOptions = [
  {
    label: "A.T. Still University",
    value: "A.T. Still University",
  },
  {
    label: "Aalborg Universitet",
    value: "Aalborg Universitet",
  },
  {
    label: "Aalto-yliopisto",
    value: "Aalto-yliopisto",
  },
  {
    label: "Aarhus Universitet",
    value: "Aarhus Universitet",
  },
  {
    label: "Aba Teachers University",
    value: "Aba Teachers University",
  },
  {
    label: "Abasyn University",
    value: "Abasyn University",
  },
  {
    label: "Abbottabad University of Science and Technology",
    value: "Abbottabad University of Science and Technology",
  },
  {
    label: "Abdul Wali Khan University Mardan",
    value: "Abdul Wali Khan University Mardan",
  },
  {
    label: "Abdullah Gül Üniversitesi",
    value: "Abdullah Gül Üniversitesi",
  },
  {
    label: "Abdulrahman Al-Sumait University",
    value: "Abdulrahman Al-Sumait University",
  },
  {
    label: "Abertay University",
    value: "Abertay University",
  },
  {
    label: "Aberystwyth University",
    value: "Aberystwyth University",
  },
  {
    label: "Abhilashi University",
    value: "Abhilashi University",
  },
  {
    label: "Abia State University",
    value: "Abia State University",
  },
  {
    label: "Abilene Christian University",
    value: "Abilene Christian University",
  },
  {
    label: "ABM University College",
    value: "ABM University College",
  },
  {
    label: "Åbo Akademi",
    value: "Åbo Akademi",
  },
  {
    label: "Abourihan Higher Education Institute",
    value: "Abourihan Higher Education Institute",
  },
  {
    label: "Abra State Institute of Science and Technology",
    value: "Abra State Institute of Science and Technology",
  },
  {
    label: "Abraham Baldwin Agricultural College",
    value: "Abraham Baldwin Agricultural College",
  },
  {
    label: "Abu Ali ibn Sino nomidagi Buxoro Davlat Tibbiyot Instituti",
    value: "Abu Ali ibn Sino nomidagi Buxoro Davlat Tibbiyot Instituti",
  },
  {
    label: "Abu Dhabi Polytechnic",
    value: "Abu Dhabi Polytechnic",
  },
  {
    label: "Abu Dhabi School of Management",
    value: "Abu Dhabi School of Management",
  },
  {
    label: "Abu Dhabi University",
    value: "Abu Dhabi University",
  },
  {
    label: "Abubakar Tafawa Balewa University",
    value: "Abubakar Tafawa Balewa University",
  },
  {
    label: "Abylkas Saginov Karaganda Technical University",
    value: "Abylkas Saginov Karaganda Technical University",
  },
  {
    label: "Academia de Muzica, Teatru si Arte Plastice",
    value: "Academia de Muzica, Teatru si Arte Plastice",
  },
  {
    label: "Academia de Studii Economice din Bucuresti",
    value: "Academia de Studii Economice din Bucuresti",
  },
  {
    label: "Academia de Studii Economice din Moldova",
    value: "Academia de Studii Economice din Moldova",
  },
  {
    label: "Academia Nacional Superior de Orquestra",
    value: "Academia Nacional Superior de Orquestra",
  },
  {
    label: "Academia Nationala de Muzica Gheorghe Dima",
    value: "Academia Nationala de Muzica Gheorghe Dima",
  },
  {
    label: "Academic City University College",
    value: "Academic City University College",
  },
  {
    label: "Académie des Beaux-Arts de Tournai",
    value: "Académie des Beaux-Arts de Tournai",
  },
  {
    label: "Académie Franco-Américaine de Management",
    value: "Académie Franco-Américaine de Management",
  },
  {
    label: "Academie voor Hoger Kunst- en Cultuuronderwijs",
    value: "Academie voor Hoger Kunst- en Cultuuronderwijs",
  },
  {
    label: "Academy of Art University",
    value: "Academy of Art University",
  },
  {
    label: "Academy of Business and Social Development",
    value: "Academy of Business and Social Development",
  },
  {
    label: "Academy of Education of Kyrgyzstan",
    value: "Academy of Education of Kyrgyzstan",
  },
  {
    label: "Academy of Labor and Social Relations",
    value: "Academy of Labor and Social Relations",
  },
  {
    label: "Academy of Music, Dance and Fine Arts",
    value: "Academy of Music, Dance and Fine Arts",
  },
  {
    label:
      "Academy of Public Administration under the aegis of the President of the Republic of Belarus",
    value:
      "Academy of Public Administration under the aegis of the President of the Republic of Belarus",
  },
  {
    label: "Academy of Public Administration under the President of Kazakhstan",
    value: "Academy of Public Administration under the President of Kazakhstan",
  },
  {
    label:
      "Academy of Public Administration under the President of the Kyrgyz Republic",
    value:
      "Academy of Public Administration under the President of the Kyrgyz Republic",
  },
  {
    label:
      "Academy of Public Administration under the President of the Republic of Tajikistan",
    value:
      "Academy of Public Administration under the President of the Republic of Tajikistan",
  },
  {
    label: "Academy of the Ministry of Internal Affairs",
    value: "Academy of the Ministry of Internal Affairs",
  },
  {
    label: "Academy of Tourism",
    value: "Academy of Tourism",
  },
  {
    label: "Acadia University",
    value: "Acadia University",
  },
  {
    label: "Accra Institute of Technology",
    value: "Accra Institute of Technology",
  },
  {
    label: "Accra Technical University",
    value: "Accra Technical University",
  },
  {
    label: "Ach Medical University",
    value: "Ach Medical University",
  },
  {
    label: "Acharya N.G. Ranga Agricultural University",
    value: "Acharya N.G. Ranga Agricultural University",
  },
  {
    label: "Acharya Nagarjuna University",
    value: "Acharya Nagarjuna University",
  },
  {
    label: "Acharya Narendra Deva University of Agriculture & Technology",
    value: "Acharya Narendra Deva University of Agriculture & Technology",
  },
  {
    label: "Achievers University, Owo",
    value: "Achievers University, Owo",
  },
  {
    label: "Achva Academic College",
    value: "Achva Academic College",
  },
  {
    label: "Acibadem Üniversitesi",
    value: "Acibadem Üniversitesi",
  },
  {
    label: "Ada Kent Üniversitesi",
    value: "Ada Kent Üniversitesi",
  },
  {
    label: "ADA Universiteti",
    value: "ADA Universiteti",
  },
  {
    label: "ADAM University",
    value: "ADAM University",
  },
  {
    label: "Adama Science and Technology University",
    value: "Adama Science and Technology University",
  },
  {
    label: "Adamas University",
    value: "Adamas University",
  },
  {
    label: "Adamawa State University",
    value: "Adamawa State University",
  },
  {
    label: "Adams State University",
    value: "Adams State University",
  },
  {
    label: "Adamson University",
    value: "Adamson University",
  },
  {
    label: "Adana Alparslan Türkes Bilim ve Teknoloji Üniversitesi",
    value: "Adana Alparslan Türkes Bilim ve Teknoloji Üniversitesi",
  },
  {
    label: "Addis Ababa Science and Technology University",
    value: "Addis Ababa Science and Technology University",
  },
  {
    label: "Addis Ababa University",
    value: "Addis Ababa University",
  },
  {
    label: "Adekunle Ajasin University",
    value: "Adekunle Ajasin University",
  },
  {
    label: "Adeleke University",
    value: "Adeleke University",
  },
  {
    label: "Adelphi University",
    value: "Adelphi University",
  },
  {
    label: "Adesh University",
    value: "Adesh University",
  },
  {
    label: "Adigrat University",
    value: "Adigrat University",
  },
  {
    label: "Adikavi Nannaya University",
    value: "Adikavi Nannaya University",
  },
  {
    label: "Adi-Keih College of Arts and Social Sciences",
    value: "Adi-Keih College of Arts and Social Sciences",
  },
  {
    label: "Adiyaman Üniversitesi",
    value: "Adiyaman Üniversitesi",
  },
  {
    label: "Adler Graduate School",
    value: "Adler Graduate School",
  },
  {
    label: "Adler University",
    value: "Adler University",
  },
  {
    label: "Admiral Makarov National University of Shipbuilding",
    value: "Admiral Makarov National University of Shipbuilding",
  },
  {
    label: "Admiral Makarov State University of Maritime and Inland Shipping",
    value: "Admiral Makarov State University of Maritime and Inland Shipping",
  },
  {
    label: "Admiralty University of Nigeria",
    value: "Admiralty University of Nigeria",
  },
  {
    label: "Adrian College",
    value: "Adrian College",
  },
  {
    label: "Advanced Business College",
    value: "Advanced Business College",
  },
  {
    label: "Advanced Institute of Industrial Technology",
    value: "Advanced Institute of Industrial Technology",
  },
  {
    label: "AdventHealth University",
    value: "AdventHealth University",
  },
  {
    label: "Adventist International Institute of Advanced Studies",
    value: "Adventist International Institute of Advanced Studies",
  },
  {
    label: "Adventist University of Africa",
    value: "Adventist University of Africa",
  },
  {
    label: "Adventist University of Central Africa",
    value: "Adventist University of Central Africa",
  },
  {
    label: "Adventist University of the Philippines",
    value: "Adventist University of the Philippines",
  },
  {
    label: "Adventista Teológiai Fõiskola",
    value: "Adventista Teológiai Fõiskola",
  },
  {
    label: "Adyghe State University",
    value: "Adyghe State University",
  },
  {
    label: "Aeres Hogeschool",
    value: "Aeres Hogeschool",
  },
  {
    label: "Afe Babalola University",
    value: "Afe Babalola University",
  },
  {
    label: "Afeka Tel Aviv Academic College of Engineering",
    value: "Afeka Tel Aviv Academic College of Engineering",
  },
  {
    label: "Afghan Swiss Medical Institute of Higher Education",
    value: "Afghan Swiss Medical Institute of Higher Education",
  },
  {
    label: "Africa Christian University",
    value: "Africa Christian University",
  },
  {
    label: "Africa International University",
    value: "Africa International University",
  },
  {
    label: "Africa Nazarene University",
    value: "Africa Nazarene University",
  },
  {
    label: "Africa Renewal University",
    value: "Africa Renewal University",
  },
  {
    label: "Africa Research University",
    value: "Africa Research University",
  },
  {
    label: "Africa University",
    value: "Africa University",
  },
  {
    label: "African Bible University",
    value: "African Bible University",
  },
  {
    label: "African Leadership University, Rwanda",
    value: "African Leadership University, Rwanda",
  },
  {
    label: "African Methodist Episcopal University",
    value: "African Methodist Episcopal University",
  },
  {
    label: "African Rural University",
    value: "African Rural University",
  },
  {
    label: "African University College of Communications",
    value: "African University College of Communications",
  },
  {
    label: "African University of Humanities and Applied Sciences",
    value: "African University of Humanities and Applied Sciences",
  },
  {
    label: "African University of Management",
    value: "African University of Management",
  },
  {
    label: "African University of Science and Technology",
    value: "African University of Science and Technology",
  },
  {
    label: "Afyon Kocatepe Üniversitesi",
    value: "Afyon Kocatepe Üniversitesi",
  },
  {
    label: "Aga Khan University",
    value: "Aga Khan University",
  },
  {
    label: "Agnes Scott College",
    value: "Agnes Scott College",
  },
  {
    label: "Agrarian and Economic College",
    value: "Agrarian and Economic College",
  },
  {
    label: "Agri Ibrahim Çeçen Universitesi",
    value: "Agri Ibrahim Çeçen Universitesi",
  },
  {
    label: "Agricultural University of Athens",
    value: "Agricultural University of Athens",
  },
  {
    label: "Agricultural University of Georgia",
    value: "Agricultural University of Georgia",
  },
  {
    label: "Agricultural University of Hebei",
    value: "Agricultural University of Hebei",
  },
  {
    label: "Agricultural University of Iceland",
    value: "Agricultural University of Iceland",
  },
  {
    label: "Agricultural University of Plovdiv",
    value: "Agricultural University of Plovdiv",
  },
  {
    label: "Agriculture and Forestry University",
    value: "Agriculture and Forestry University",
  },
  {
    label: "AgroParisTech",
    value: "AgroParisTech",
  },
  {
    label: "Ahfad University for Women",
    value: "Ahfad University for Women",
  },
  {
    label: "Ahi Evran Üniversitesi",
    value: "Ahi Evran Üniversitesi",
  },
  {
    label: "Ahl al-Bayt University",
    value: "Ahl al-Bayt University",
  },
  {
    label: "Ahlia University",
    value: "Ahlia University",
  },
  {
    label: "Ahlobait Institute of Higher Education",
    value: "Ahlobait Institute of Higher Education",
  },
  {
    label: "Ahlul Bayt International University",
    value: "Ahlul Bayt International University",
  },
  {
    label: "Ahmadu Bello University",
    value: "Ahmadu Bello University",
  },
  {
    label: "Ahmedabad University",
    value: "Ahmedabad University",
  },
  {
    label: "Ahmet Yesevi Üniversitesi",
    value: "Ahmet Yesevi Üniversitesi",
  },
  {
    label: "Ahram Canadian University",
    value: "Ahram Canadian University",
  },
  {
    label: "Ahsanullah University of Science and Technology",
    value: "Ahsanullah University of Science and Technology",
  },
  {
    label: "Ahvaz Jundishapur University of Medical Sciences",
    value: "Ahvaz Jundishapur University of Medical Sciences",
  },
  {
    label: "Aichi Bunkyo University",
    value: "Aichi Bunkyo University",
  },
  {
    label: "Aichi Gakuin University",
    value: "Aichi Gakuin University",
  },
  {
    label: "Aichi Gakusen University",
    value: "Aichi Gakusen University",
  },
  {
    label: "Aichi Institute of Technology",
    value: "Aichi Institute of Technology",
  },
  {
    label: "Aichi Medical University",
    value: "Aichi Medical University",
  },
  {
    label: "Aichi Mizuho College",
    value: "Aichi Mizuho College",
  },
  {
    label: "Aichi Prefectural University",
    value: "Aichi Prefectural University",
  },
  {
    label: "Aichi Sangyo University",
    value: "Aichi Sangyo University",
  },
  {
    label: "Aichi Shukutoku University",
    value: "Aichi Shukutoku University",
  },
  {
    label: "Aichi Toho University",
    value: "Aichi Toho University",
  },
  {
    label: "Aichi University",
    value: "Aichi University",
  },
  {
    label: "Aichi University of Education",
    value: "Aichi University of Education",
  },
  {
    label: "Aichi University of Technology",
    value: "Aichi University of Technology",
  },
  {
    label: "Aichi University of the Arts",
    value: "Aichi University of the Arts",
  },
  {
    label: "Aikoku Gakuen University",
    value: "Aikoku Gakuen University",
  },
  {
    label: "Ain Shams University",
    value: "Ain Shams University",
  },
  {
    label: "Aino University",
    value: "Aino University",
  },
  {
    label: "Air Force Institute of Technology",
    value: "Air Force Institute of Technology",
  },
  {
    label: "Air University",
    value: "Air University",
  },
  {
    label: "Aix-Marseille Université",
    value: "Aix-Marseille Université",
  },
  {
    label: "Ajayi Crowther University",
    value: "Ajayi Crowther University",
  },
  {
    label: "Ajeenkya D.Y. Patil University",
    value: "Ajeenkya D.Y. Patil University",
  },
  {
    label: "Ajloun National Private University",
    value: "Ajloun National Private University",
  },
  {
    label: "Ajman University",
    value: "Ajman University",
  },
  {
    label: "Ajou University",
    value: "Ajou University",
  },
  {
    label: "Akademia e Filmit dhe Multimedias Marubi",
    value: "Akademia e Filmit dhe Multimedias Marubi",
  },
  {
    label: "Akademia e Studimeve Albanologjike",
    value: "Akademia e Studimeve Albanologjike",
  },
  {
    label: "Akademia Finansów i Biznesu Vistula",
    value: "Akademia Finansów i Biznesu Vistula",
  },
  {
    label: "Akademia Górniczo-Hutnicza",
    value: "Akademia Górniczo-Hutnicza",
  },
  {
    label: "Akademia Górnoslaska im. Wojciecha Korfantego w Katowicach",
    value: "Akademia Górnoslaska im. Wojciecha Korfantego w Katowicach",
  },
  {
    label: "Akademia Humanistyczno-Ekonomiczna w Lodzi",
    value: "Akademia Humanistyczno-Ekonomiczna w Lodzi",
  },
  {
    label: "Akademia Ivodent",
    value: "Akademia Ivodent",
  },
  {
    label: "Akademia Leona Kozminskiego",
    value: "Akademia Leona Kozminskiego",
  },
  {
    label: "Akademia Lomzynska",
    value: "Akademia Lomzynska",
  },
  {
    label: "Akademia Muzyczna im. Feliksa Nowowiejskiego w Bydgoszczy",
    value: "Akademia Muzyczna im. Feliksa Nowowiejskiego w Bydgoszczy",
  },
  {
    label: "Akademia Muzyczna im. Grazyny i Kiejstuta Bacewiczów w Lodzi",
    value: "Akademia Muzyczna im. Grazyny i Kiejstuta Bacewiczów w Lodzi",
  },
  {
    label: "Akademia Muzyczna im. Ignacego Jana Paderewskiego w Poznaniu",
    value: "Akademia Muzyczna im. Ignacego Jana Paderewskiego w Poznaniu",
  },
  {
    label: "Akademia Muzyczna im. Karola Lipinskiego we Wroclawiu",
    value: "Akademia Muzyczna im. Karola Lipinskiego we Wroclawiu",
  },
  {
    label: "Akademia Muzyczna im. Karola Szymanowskiego w Katowicach",
    value: "Akademia Muzyczna im. Karola Szymanowskiego w Katowicach",
  },
  {
    label: "Akademia Muzyczna im. Stanislawa Moniuszki w Gdansku",
    value: "Akademia Muzyczna im. Stanislawa Moniuszki w Gdansku",
  },
  {
    label: "Akademia Muzyczna w Krakowie",
    value: "Akademia Muzyczna w Krakowie",
  },
  {
    label: "Akademia Nauk Stosowanych im. Stanislawa Staszica w Pile",
    value: "Akademia Nauk Stosowanych im. Stanislawa Staszica w Pile",
  },
  {
    label: "Akademia Nauk Stosowanych w Walczu",
    value: "Akademia Nauk Stosowanych w Walczu",
  },
  {
    label: "Akademia Pedagogiki Specjalnej im. Marii Grzegorzewskiej",
    value: "Akademia Pedagogiki Specjalnej im. Marii Grzegorzewskiej",
  },
  {
    label: "Akademia Polonijna w Czestochowie",
    value: "Akademia Polonijna w Czestochowie",
  },
  {
    label: "Akademia Sztuk Pieknych im. Eugeniusza Gepperta we Wroclawiu",
    value: "Akademia Sztuk Pieknych im. Eugeniusza Gepperta we Wroclawiu",
  },
  {
    label: "Akademia Sztuk Pieknych im. Jana Matejki w Krakowie",
    value: "Akademia Sztuk Pieknych im. Jana Matejki w Krakowie",
  },
  {
    label: "Akademia Sztuk Pieknych im. Wladyslawa Strzeminskiego w Lodzi",
    value: "Akademia Sztuk Pieknych im. Wladyslawa Strzeminskiego w Lodzi",
  },
  {
    label: "Akademia Sztuk Pieknych w Gdansku",
    value: "Akademia Sztuk Pieknych w Gdansku",
  },
  {
    label: "Akademia Sztuk Pieknych w Katowicach",
    value: "Akademia Sztuk Pieknych w Katowicach",
  },
  {
    label: "Akademia Sztuk Pieknych w Warszawie",
    value: "Akademia Sztuk Pieknych w Warszawie",
  },
  {
    label: "Akademia Sztuk Teatralnych im. Stanislawa Wyspianskiego w Krakowie",
    value: "Akademia Sztuk Teatralnych im. Stanislawa Wyspianskiego w Krakowie",
  },
  {
    label: "Akadémia umení v Banskej Bystrici",
    value: "Akadémia umení v Banskej Bystrici",
  },
  {
    label: "Akademia WSB",
    value: "Akademia WSB",
  },
  {
    label: "Akademia Wychowania Fizycznego i Sportu im. Jedrzeja Sniadeckiego",
    value: "Akademia Wychowania Fizycznego i Sportu im. Jedrzeja Sniadeckiego",
  },
  {
    label: "Akademia Wychowania Fizycznego im. Bronislawa Czecha w Krakowie",
    value: "Akademia Wychowania Fizycznego im. Bronislawa Czecha w Krakowie",
  },
  {
    label:
      "Akademia Wychowania Fizycznego im. Eugeniusza Piaseckiego w Poznaniu",
    value:
      "Akademia Wychowania Fizycznego im. Eugeniusza Piaseckiego w Poznaniu",
  },
  {
    label: "Akademia Wychowania Fizycznego im. Jerzego Kukuczki w Katowicach",
    value: "Akademia Wychowania Fizycznego im. Jerzego Kukuczki w Katowicach",
  },
  {
    label:
      "Akademia Wychowania Fizycznego im. Polskich Olimpijczyków we Wroclawiu",
    value:
      "Akademia Wychowania Fizycznego im. Polskich Olimpijczyków we Wroclawiu",
  },
  {
    label: "Akademia Wychowania Fizycznego Józefa Pilsudskiego w Warszawie",
    value: "Akademia Wychowania Fizycznego Józefa Pilsudskiego w Warszawie",
  },
  {
    label: "Akademie der Bildenden Künste München",
    value: "Akademie der Bildenden Künste München",
  },
  {
    label: "Akademie der Bildenden Künste Nürnberg",
    value: "Akademie der Bildenden Künste Nürnberg",
  },
  {
    label: "Akademie der Bildenden Künste Wien",
    value: "Akademie der Bildenden Künste Wien",
  },
  {
    label: "Akademie HUSPOL",
    value: "Akademie HUSPOL",
  },
  {
    label: "Akademie múzických umení v Praze",
    value: "Akademie múzických umení v Praze",
  },
  {
    label: "Akademie STING",
    value: "Akademie STING",
  },
  {
    label: "Akademie výtvarných umení v Praze",
    value: "Akademie výtvarných umení v Praze",
  },
  {
    label: "Akademii Sztuki w Szczecinie",
    value: "Akademii Sztuki w Szczecinie",
  },
  {
    label: "Akaki Tsereteli State University",
    value: "Akaki Tsereteli State University",
  },
  {
    label: "Akal University",
    value: "Akal University",
  },
  {
    label: "Akdeniz Karpaz Üniversitesi",
    value: "Akdeniz Karpaz Üniversitesi",
  },
  {
    label: "Akdeniz Üniversitesi",
    value: "Akdeniz Üniversitesi",
  },
  {
    label: "Akita International University",
    value: "Akita International University",
  },
  {
    label: "Akita Prefectural University",
    value: "Akita Prefectural University",
  },
  {
    label: "Akita University",
    value: "Akita University",
  },
  {
    label: "Akita University of Art",
    value: "Akita University of Art",
  },
  {
    label: "Akita University of Nursing and Welfare",
    value: "Akita University of Nursing and Welfare",
  },
  {
    label: "Akkon Hochschule für Humanwissenschaften",
    value: "Akkon Hochschule für Humanwissenschaften",
  },
  {
    label: "Aklan State University",
    value: "Aklan State University",
  },
  {
    label: "Akobo Heritage and Memorial University",
    value: "Akobo Heritage and Memorial University",
  },
  {
    label: "AKS University",
    value: "AKS University",
  },
  {
    label: "Aksaray Üniversitesi",
    value: "Aksaray Üniversitesi",
  },
  {
    label: "Aksum University",
    value: "Aksum University",
  },
  {
    label: "Aktobe Regional University named after K. Zhubanov",
    value: "Aktobe Regional University named after K. Zhubanov",
  },
  {
    label: "Akwa Ibom State University",
    value: "Akwa Ibom State University",
  },
  {
    label: "Al Ain University",
    value: "Al Ain University",
  },
  {
    label: "Al Alamein International University",
    value: "Al Alamein International University",
  },
  {
    label: "Al al-Bayt University",
    value: "Al al-Bayt University",
  },
  {
    label: "Al Andalus University for Medical Sciences",
    value: "Al Andalus University for Medical Sciences",
  },
  {
    label: "Al Azhar University-Gaza",
    value: "Al Azhar University-Gaza",
  },
  {
    label: "Al Baha University",
    value: "Al Baha University",
  },
  {
    label: "Al Bayan University",
    value: "Al Bayan University",
  },
  {
    label: "Al Beroni University",
    value: "Al Beroni University",
  },
  {
    label: "Al Dar University College (On Probation)",
    value: "Al Dar University College (On Probation)",
  },
  {
    label: "Al Falah University",
    value: "Al Falah University",
  },
  {
    label: "Al Fashir University",
    value: "Al Fashir University",
  },
  {
    label: "Al Hikma University College",
    value: "Al Hikma University College",
  },
  {
    label: "Al Hussein Technical University",
    value: "Al Hussein Technical University",
  },
  {
    label: "Al Imam Al-Ouzai University",
    value: "Al Imam Al-Ouzai University",
  },
  {
    label: "Al Iraqia University",
    value: "Al Iraqia University",
  },
  {
    label: "Al Istiqlal University",
    value: "Al Istiqlal University",
  },
  {
    label: "Al Janad University for Science and Technology",
    value: "Al Janad University for Science and Technology",
  },
  {
    label: "Al Jazeera University",
    value: "Al Jazeera University",
  },
  {
    label: "Al Jouf University",
    value: "Al Jouf University",
  },
  {
    label: "Al Maarefa University",
    value: "Al Maarefa University",
  },
  {
    label: "Al Mamoun University College",
    value: "Al Mamoun University College",
  },
  {
    label: "Al Mustafa International University",
    value: "Al Mustafa International University",
  },
  {
    label: "Al Nahrain University",
    value: "Al Nahrain University",
  },
  {
    label: "Al Qalam University College",
    value: "Al Qalam University College",
  },
  {
    label: "Al Qasimia University",
    value: "Al Qasimia University",
  },
  {
    label:
      "Al Rasheed International Private University for Science and Technology",
    value:
      "Al Rasheed International Private University for Science and Technology",
  },
  {
    label: "Al Safwa University College",
    value: "Al Safwa University College",
  },
  {
    label: "Al Sharqiyah University",
    value: "Al Sharqiyah University",
  },
  {
    label: "Al Wasl University",
    value: "Al Wasl University",
  },
  {
    label: "Al Yamamah University",
    value: "Al Yamamah University",
  },
  {
    label: "Al Zaiem Al Azhari University",
    value: "Al Zaiem Al Azhari University",
  },
  {
    label: "Alabama A&M University",
    value: "Alabama A&M University",
  },
  {
    label: "Alabama State University",
    value: "Alabama State University",
  },
  {
    label: "Alagappa University",
    value: "Alagappa University",
  },
  {
    label: "Al-Ahgaff University",
    value: "Al-Ahgaff University",
  },
  {
    label: "Al-Ahliyya Amman University",
    value: "Al-Ahliyya Amman University",
  },
  {
    label: "Alakh Prakash Goyal Shimla University",
    value: "Alakh Prakash Goyal Shimla University",
  },
  {
    label: "Al-Amal University College",
    value: "Al-Amal University College",
  },
  {
    label: "Alandalus University for Science and Technology",
    value: "Alandalus University for Science and Technology",
  },
  {
    label: "Alanus Hochschule für Kunst und Gesellschaft",
    value: "Alanus Hochschule für Kunst und Gesellschaft",
  },
  {
    label: "Alanya Alaaddin Keykubat Üniversitesi",
    value: "Alanya Alaaddin Keykubat Üniversitesi",
  },
  {
    label: "Alanya Üniversitesi",
    value: "Alanya Üniversitesi",
  },
  {
    label: "Al-Aqsa University",
    value: "Al-Aqsa University",
  },
  {
    label: "Alaska Bible College",
    value: "Alaska Bible College",
  },
  {
    label: "Alaska Pacific University",
    value: "Alaska Pacific University",
  },
  {
    label: "Alasmarya Islamic University",
    value: "Alasmarya Islamic University",
  },
  {
    label: "Ala-Too Uluslararasi Üniversitesi",
    value: "Ala-Too Uluslararasi Üniversitesi",
  },
  {
    label: "Al-Azhar University",
    value: "Al-Azhar University",
  },
  {
    label: "Al-Baath University",
    value: "Al-Baath University",
  },
  {
    label: "Al-Balqa' Applied University",
    value: "Al-Balqa' Applied University",
  },
  {
    label: "Albany College of Pharmacy and Health Sciences",
    value: "Albany College of Pharmacy and Health Sciences",
  },
  {
    label: "Albany Law School",
    value: "Albany Law School",
  },
  {
    label: "Albany Medical College",
    value: "Albany Medical College",
  },
  {
    label: "Albany State University",
    value: "Albany State University",
  },
  {
    label: "Albaydha University",
    value: "Albaydha University",
  },
  {
    label: "Albert-Ludwigs-Universität Freiburg",
    value: "Albert-Ludwigs-Universität Freiburg",
  },
  {
    label: "Albertus Magnus College",
    value: "Albertus Magnus College",
  },
  {
    label: "Albion College",
    value: "Albion College",
  },
  {
    label: "Alborz Institute of Higher Education",
    value: "Alborz Institute of Higher Education",
  },
  {
    label: "Albright College",
    value: "Albright College",
  },
  {
    label: "Al-Buraimi University College",
    value: "Al-Buraimi University College",
  },
  {
    label: "Alcorn State University",
    value: "Alcorn State University",
  },
  {
    label: "Aldersgate College",
    value: "Aldersgate College",
  },
  {
    label: "Alderson Broaddus University",
    value: "Alderson Broaddus University",
  },
  {
    label: "Al-Eman University",
    value: "Al-Eman University",
  },
  {
    label: "Al-Esraa University College",
    value: "Al-Esraa University College",
  },
  {
    label: "Aletheia University",
    value: "Aletheia University",
  },
  {
    label: "Alex Ekwueme Federal University",
    value: "Alex Ekwueme Federal University",
  },
  {
    label: "Alexander College",
    value: "Alexander College",
  },
  {
    label: "Alexandria University",
    value: "Alexandria University",
  },
  {
    label: "Alfa BK Univerzitet",
    value: "Alfa BK Univerzitet",
  },
  {
    label: "Alfaisal University",
    value: "Alfaisal University",
  },
  {
    label: "Al-Falah University",
    value: "Al-Falah University",
  },
  {
    label: "Al-Farabi Kazakh National University",
    value: "Al-Farabi Kazakh National University",
  },
  {
    label: "Al-Farahidi University",
    value: "Al-Farahidi University",
  },
  {
    label: "Alfred Nobel University",
    value: "Alfred Nobel University",
  },
  {
    label: "Alfred State College",
    value: "Alfred State College",
  },
  {
    label: "Alfred University",
    value: "Alfred University",
  },
  {
    label: "Al-Furat Al-Awsat Technical University",
    value: "Al-Furat Al-Awsat Technical University",
  },
  {
    label: "Al-Furat University",
    value: "Al-Furat University",
  },
  {
    label: "Algoma University",
    value: "Algoma University",
  },
  {
    label: "Al-Hadba University College",
    value: "Al-Hadba University College",
  },
  {
    label: "Al-Hamd Islamic University",
    value: "Al-Hamd Islamic University",
  },
  {
    label: "Al-Hawash Private University",
    value: "Al-Hawash Private University",
  },
  {
    label: "Al-Hikma University",
    value: "Al-Hikma University",
  },
  {
    label: "Al-Hikmah University",
    value: "Al-Hikmah University",
  },
  {
    label: "Al-Hussain University College",
    value: "Al-Hussain University College",
  },
  {
    label: "Al-Hussein Bin Talal University",
    value: "Al-Hussein Bin Talal University",
  },
  {
    label: "Ali Institute of Education",
    value: "Ali Institute of Education",
  },
  {
    label: "Aliah University",
    value: "Aliah University",
  },
  {
    label: "Alice Lloyd College",
    value: "Alice Lloyd College",
  },
  {
    label: "Alice Salomon Hochschule Berlin",
    value: "Alice Salomon Hochschule Berlin",
  },
  {
    label: "Aligarh Muslim University",
    value: "Aligarh Muslim University",
  },
  {
    label: "Al-Imam Muhammad Ibn Saud Islamic University",
    value: "Al-Imam Muhammad Ibn Saud Islamic University",
  },
  {
    label: "Al-Imam University College",
    value: "Al-Imam University College",
  },
  {
    label:
      "Alisher Navoiy nomidagi Toshkent davlat o'zbek tili va adabiyoti universiteti",
    value:
      "Alisher Navoiy nomidagi Toshkent davlat o'zbek tili va adabiyoti universiteti",
  },
  {
    label: "Al-Jafra University",
    value: "Al-Jafra University",
  },
  {
    label: "Aljazeera University",
    value: "Aljazeera University",
  },
  {
    label: "Al-Karkh University of Science",
    value: "Al-Karkh University of Science",
  },
  {
    label: "Al-Kitab University",
    value: "Al-Kitab University",
  },
  {
    label: "Al-Kunooze University College",
    value: "Al-Kunooze University College",
  },
  {
    label: "Al-Kut University College",
    value: "Al-Kut University College",
  },
  {
    label: "All American Institute of Medical Sciences",
    value: "All American Institute of Medical Sciences",
  },
  {
    label: "All India Institute of Medical Sciences Bhopal",
    value: "All India Institute of Medical Sciences Bhopal",
  },
  {
    label: "All India Institute of Medical Sciences Bhubaneswar",
    value: "All India Institute of Medical Sciences Bhubaneswar",
  },
  {
    label: "All India Institute of Medical Sciences Delhi",
    value: "All India Institute of Medical Sciences Delhi",
  },
  {
    label: "All India Institute of Medical Sciences Jodhpur",
    value: "All India Institute of Medical Sciences Jodhpur",
  },
  {
    label: "All India Institute of Medical Sciences Patna",
    value: "All India Institute of Medical Sciences Patna",
  },
  {
    label: "All India Institute of Medical Sciences Raipur",
    value: "All India Institute of Medical Sciences Raipur",
  },
  {
    label: "All India Institute of Medical Sciences Rishikesh",
    value: "All India Institute of Medical Sciences Rishikesh",
  },
  {
    label: "All Nations University",
    value: "All Nations University",
  },
  {
    label: "All Saints University Lango",
    value: "All Saints University Lango",
  },
  {
    label: "Allameh Institute of Higher Education",
    value: "Allameh Institute of Higher Education",
  },
  {
    label: "Allameh Mohaddes Nouri University",
    value: "Allameh Mohaddes Nouri University",
  },
  {
    label: "Allameh Tabataba'i University",
    value: "Allameh Tabataba'i University",
  },
  {
    label: "Allegheny College",
    value: "Allegheny College",
  },
  {
    label: "Allen College",
    value: "Allen College",
  },
  {
    label: "Allen University",
    value: "Allen University",
  },
  {
    label: "Allensbach Hochschule",
    value: "Allensbach Hochschule",
  },
  {
    label: "Alliance University",
    value: "Alliance University",
  },
  {
    label: "Alliance University",
    value: "Alliance University",
  },
  {
    label: "Alliant International University",
    value: "Alliant International University",
  },
  {
    label: "Alma College",
    value: "Alma College",
  },
  {
    label: "Alma Mater Europaea",
    value: "Alma Mater Europaea",
  },
  {
    label: "Alma Mater Studiorum Università di Bologna",
    value: "Alma Mater Studiorum Università di Bologna",
  },
  {
    label: "Al-Maarif University College",
    value: "Al-Maarif University College",
  },
  {
    label: "Al-Madinah International University",
    value: "Al-Madinah International University",
  },
  {
    label: "Al-Mansour University College",
    value: "Al-Mansour University College",
  },
  {
    label: "Almaty Academy of Economics and Statistics",
    value: "Almaty Academy of Economics and Statistics",
  },
  {
    label: "Almaty Management University",
    value: "Almaty Management University",
  },
  {
    label: "Almaty Technological University",
    value: "Almaty Technological University",
  },
  {
    label: "Almaty Transport College of KazATK named after M. Tynyshpayev",
    value: "Almaty Transport College of KazATK named after M. Tynyshpayev",
  },
  {
    label: "Almaty University",
    value: "Almaty University",
  },
  {
    label: "Almaty University of Power Engineering and Telecommunications",
    value: "Almaty University of Power Engineering and Telecommunications",
  },
  {
    label: "AlMughtaribeen University",
    value: "AlMughtaribeen University",
  },
  {
    label: "Al-Mustafa University College",
    value: "Al-Mustafa University College",
  },
  {
    label: "Al-Muthanna University",
    value: "Al-Muthanna University",
  },
  {
    label: "Al-Nasser University",
    value: "Al-Nasser University",
  },
  {
    label: "Al-Nisour University College",
    value: "Al-Nisour University College",
  },
  {
    label: "Al-Noor University College",
    value: "Al-Noor University College",
  },
  {
    label: "Al-Nukhba University College",
    value: "Al-Nukhba University College",
  },
  {
    label: "Alpen-Adria-Universität Klagenfurt",
    value: "Alpen-Adria-Universität Klagenfurt",
  },
  {
    label: "Al-Qalam University, Katsina",
    value: "Al-Qalam University, Katsina",
  },
  {
    label: "Al-Qasim Green University",
    value: "Al-Qasim Green University",
  },
  {
    label: "Al-Quds University",
    value: "Al-Quds University",
  },
  {
    label: "Al-Rafaq National University",
    value: "Al-Rafaq National University",
  },
  {
    label: "Al-Rafidain University College",
    value: "Al-Rafidain University College",
  },
  {
    label: "Al-Rasheed University College",
    value: "Al-Rasheed University College",
  },
  {
    label: "Al-Rayan University",
    value: "Al-Rayan University",
  },
  {
    label: "Al-Razi University",
    value: "Al-Razi University",
  },
  {
    label: "Al-Saeeda University",
    value: "Al-Saeeda University",
  },
  {
    label: "Alsalam University",
    value: "Alsalam University",
  },
  {
    label: "Al-Shahbaa University",
    value: "Al-Shahbaa University",
  },
  {
    label: "Al-Sham Private University",
    value: "Al-Sham Private University",
  },
  {
    label: "Al-Taff University College",
    value: "Al-Taff University College",
  },
  {
    label: "Al-Tahadi National Medical University",
    value: "Al-Tahadi National Medical University",
  },
  {
    label: "Altai State Academy of Education",
    value: "Altai State Academy of Education",
  },
  {
    label: "Altai State Medical University",
    value: "Altai State Medical University",
  },
  {
    label: "Altai State Pedagogical Academy",
    value: "Altai State Pedagogical Academy",
  },
  {
    label: "Altai State University",
    value: "Altai State University",
  },
  {
    label: "Altai State University of Agriculture",
    value: "Altai State University of Agriculture",
  },
  {
    label: "Al-taqwa Institute of Higher Education",
    value: "Al-taqwa Institute of Higher Education",
  },
  {
    label: "Alte University",
    value: "Alte University",
  },
  {
    label: "Altinbas Üniversitesi",
    value: "Altinbas Üniversitesi",
  },
  {
    label: "Altoosi University College",
    value: "Altoosi University College",
  },
  {
    label: "Al-Turath University",
    value: "Al-Turath University",
  },
  {
    label: "Alvernia University",
    value: "Alvernia University",
  },
  {
    label: "Alverno College",
    value: "Alverno College",
  },
  {
    label: "Al-Wataniya Private University",
    value: "Al-Wataniya Private University",
  },
  {
    label: "Alyarmok University College",
    value: "Alyarmok University College",
  },
  {
    label: "Alytaus kolegija",
    value: "Alytaus kolegija",
  },
  {
    label: "Al-Zahra College for Women",
    value: "Al-Zahra College for Women",
  },
  {
    label: "Alzahra University",
    value: "Alzahra University",
  },
  {
    label: "Al-Zahrawi University College",
    value: "Al-Zahrawi University College",
  },
  {
    label: "Al-Zaytoonah University of Jordan",
    value: "Al-Zaytoonah University of Jordan",
  },
  {
    label: "AMA Computer University",
    value: "AMA Computer University",
  },
  {
    label: "Amasya Üniversitesi",
    value: "Amasya Üniversitesi",
  },
  {
    label: "Ambassador International University",
    value: "Ambassador International University",
  },
  {
    label: "Ambedkar University Delhi",
    value: "Ambedkar University Delhi",
  },
  {
    label: "Amberton University",
    value: "Amberton University",
  },
  {
    label: "Ambo University",
    value: "Ambo University",
  },
  {
    label: "Ambrose Alli University",
    value: "Ambrose Alli University",
  },
  {
    label: "Ambrose University",
    value: "Ambrose University",
  },
  {
    label: "AMD Akademie Mode and Design",
    value: "AMD Akademie Mode and Design",
  },
  {
    label: "American Baptist College",
    value: "American Baptist College",
  },
  {
    label: "American College",
    value: "American College",
  },
  {
    label: "American Film Institute Conservatory",
    value: "American Film Institute Conservatory",
  },
  {
    label: "American International College",
    value: "American International College",
  },
  {
    label: "American International School of Medicine",
    value: "American International School of Medicine",
  },
  {
    label: "American International University West Africa",
    value: "American International University West Africa",
  },
  {
    label: "American International University-Bangladesh",
    value: "American International University-Bangladesh",
  },
  {
    label: "American Jewish University",
    value: "American Jewish University",
  },
  {
    label: "American University",
    value: "American University",
  },
  {
    label: "American University in Bulgaria",
    value: "American University in Bulgaria",
  },
  {
    label: "American University in Dubai",
    value: "American University in Dubai",
  },
  {
    label: "American University in North Africa",
    value: "American University in North Africa",
  },
  {
    label: "American University in the Emirates",
    value: "American University in the Emirates",
  },
  {
    label: "American University of Antigua",
    value: "American University of Antigua",
  },
  {
    label: "American University of Armenia",
    value: "American University of Armenia",
  },
  {
    label: "American University of Barbados",
    value: "American University of Barbados",
  },
  {
    label: "American University of Beirut",
    value: "American University of Beirut",
  },
  {
    label: "American University of Central Asia",
    value: "American University of Central Asia",
  },
  {
    label: "American University of Culture and Education",
    value: "American University of Culture and Education",
  },
  {
    label: "American University of Europe",
    value: "American University of Europe",
  },
  {
    label: "American University of Integrative Sciences",
    value: "American University of Integrative Sciences",
  },
  {
    label: "American University of Kuwait",
    value: "American University of Kuwait",
  },
  {
    label: "American University of Madaba",
    value: "American University of Madaba",
  },
  {
    label: "American University of Malta",
    value: "American University of Malta",
  },
  {
    label: "American University of Nigeria",
    value: "American University of Nigeria",
  },
  {
    label: "American University of Phnom Penh",
    value: "American University of Phnom Penh",
  },
  {
    label: "American University of Puerto Rico",
    value: "American University of Puerto Rico",
  },
  {
    label: "American University of Ras Al Khaimah",
    value: "American University of Ras Al Khaimah",
  },
  {
    label: "American University of Science and Technology",
    value: "American University of Science and Technology",
  },
  {
    label: "American University of Sharjah",
    value: "American University of Sharjah",
  },
  {
    label: "American University of Technology",
    value: "American University of Technology",
  },
  {
    label: "American University of the Caribbean",
    value: "American University of the Caribbean",
  },
  {
    label: "American University of the Caribbean - School of Medicine",
    value: "American University of the Caribbean - School of Medicine",
  },
  {
    label: "Amherst College",
    value: "Amherst College",
  },
  {
    label: "Amirkabir University of Technology",
    value: "Amirkabir University of Technology",
  },
  {
    label: "Amity University",
    value: "Amity University",
  },
  {
    label: "Amity University Dubai",
    value: "Amity University Dubai",
  },
  {
    label: "Amman Arab University",
    value: "Amman Arab University",
  },
  {
    label: "Ammon Applied University College",
    value: "Ammon Applied University College",
  },
  {
    label: "Amran University",
    value: "Amran University",
  },
  {
    label: "Amref International University",
    value: "Amref International University",
  },
  {
    label: "Amrita Vishwa Vidyapeetham",
    value: "Amrita Vishwa Vidyapeetham",
  },
  {
    label: "Amsterdamse Hogeschool voor de Kunsten",
    value: "Amsterdamse Hogeschool voor de Kunsten",
  },
  {
    label: "Amur State Medical Academy",
    value: "Amur State Medical Academy",
  },
  {
    label: "Amur State University",
    value: "Amur State University",
  },
  {
    label: "Amur State University of Humanities and Pedagogy",
    value: "Amur State University of Humanities and Pedagogy",
  },
  {
    label: "Anadolu Üniversitesi",
    value: "Anadolu Üniversitesi",
  },
  {
    label: "Anand Agricultural University",
    value: "Anand Agricultural University",
  },
  {
    label: "Anania Shirakatsi University of International Relations",
    value: "Anania Shirakatsi University of International Relations",
  },
  {
    label: "Anant National University",
    value: "Anant National University",
  },
  {
    label: "Anchor University, Lagos",
    value: "Anchor University, Lagos",
  },
  {
    label: "Anderson University",
    value: "Anderson University",
  },
  {
    label: "Anderson University, Indiana",
    value: "Anderson University, Indiana",
  },
  {
    label: "Andhra University",
    value: "Andhra University",
  },
  {
    label: "Andijon Davlat Tibbiyot Instituti",
    value: "Andijon Davlat Tibbiyot Instituti",
  },
  {
    label: "Andijon Davlat Universiteti",
    value: "Andijon Davlat Universiteti",
  },
  {
    label: "Andijon Mashinasozlik Instituti",
    value: "Andijon Mashinasozlik Instituti",
  },
  {
    label: "Andijon Qishloq Xo'jalik Instituti",
    value: "Andijon Qishloq Xo'jalik Instituti",
  },
  {
    label: "Andong National University",
    value: "Andong National University",
  },
  {
    label: "Andrássy Universität Budapest",
    value: "Andrássy Universität Budapest",
  },
  {
    label: "Andrews University",
    value: "Andrews University",
  },
  {
    label: "Angarsk State Technical University",
    value: "Angarsk State Technical University",
  },
  {
    label: "Angel Kanchev University of Ruse",
    value: "Angel Kanchev University of Ruse",
  },
  {
    label: "Angeles University Foundation",
    value: "Angeles University Foundation",
  },
  {
    label: "Angelo State University",
    value: "Angelo State University",
  },
  {
    label: "Angkor Khemara University",
    value: "Angkor Khemara University",
  },
  {
    label: "Angkor University",
    value: "Angkor University",
  },
  {
    label: "Anglia Ruskin University",
    value: "Anglia Ruskin University",
  },
  {
    label: "Anglican University College of Technology",
    value: "Anglican University College of Technology",
  },
  {
    label: "Anglo-americká vysoká škola",
    value: "Anglo-americká vysoká škola",
  },
  {
    label: "Anhui Agricultural University",
    value: "Anhui Agricultural University",
  },
  {
    label: "Anhui Institute of Information Technology",
    value: "Anhui Institute of Information Technology",
  },
  {
    label: "Anhui International Studies University",
    value: "Anhui International Studies University",
  },
  {
    label: "Anhui Jianzhu University",
    value: "Anhui Jianzhu University",
  },
  {
    label: "Anhui Medical University",
    value: "Anhui Medical University",
  },
  {
    label: "Anhui Normal University",
    value: "Anhui Normal University",
  },
  {
    label: "Anhui Polytechnic University",
    value: "Anhui Polytechnic University",
  },
  {
    label: "Anhui Sanlian University",
    value: "Anhui Sanlian University",
  },
  {
    label: "Anhui Science and Technology University",
    value: "Anhui Science and Technology University",
  },
  {
    label: "Anhui University",
    value: "Anhui University",
  },
  {
    label: "Anhui University of Chinese Medicine",
    value: "Anhui University of Chinese Medicine",
  },
  {
    label: "Anhui University of Finance and Economics",
    value: "Anhui University of Finance and Economics",
  },
  {
    label: "Anhui University of Science and Technology",
    value: "Anhui University of Science and Technology",
  },
  {
    label: "Anhui University of Technology",
    value: "Anhui University of Technology",
  },
  {
    label: "Anhui Wonder University of Information Engineering",
    value: "Anhui Wonder University of Information Engineering",
  },
  {
    label: "Anhui Xinhua University",
    value: "Anhui Xinhua University",
  },
  {
    label: "Anka Teknoloji Üniversitesi",
    value: "Anka Teknoloji Üniversitesi",
  },
  {
    label: "Ankang University",
    value: "Ankang University",
  },
  {
    label: "Ankara Sosyal Bilimler Üniversitesi",
    value: "Ankara Sosyal Bilimler Üniversitesi",
  },
  {
    label: "Ankara Üniversitesi",
    value: "Ankara Üniversitesi",
  },
  {
    label: "Ankara Yildirim Beyazit Üniversitesi",
    value: "Ankara Yildirim Beyazit Üniversitesi",
  },
  {
    label: "Ankole Western University",
    value: "Ankole Western University",
  },
  {
    label: "Anna Maria College",
    value: "Anna Maria College",
  },
  {
    label: "Anna University",
    value: "Anna University",
  },
  {
    label: "An-Najah National University",
    value: "An-Najah National University",
  },
  {
    label: "Annamalai University",
    value: "Annamalai University",
  },
  {
    label: "Anqing Normal University",
    value: "Anqing Normal University",
  },
  {
    label: "Anshan Normal University",
    value: "Anshan Normal University",
  },
  {
    label: "Anshun University",
    value: "Anshun University",
  },
  {
    label: "Antalya Belek Üniversitesi",
    value: "Antalya Belek Üniversitesi",
  },
  {
    label: "Antalya Bilim Üniversitesi",
    value: "Antalya Bilim Üniversitesi",
  },
  {
    label: "Antioch University",
    value: "Antioch University",
  },
  {
    label: "Antioch University Los Angeles",
    value: "Antioch University Los Angeles",
  },
  {
    label: "Antioch University New England",
    value: "Antioch University New England",
  },
  {
    label: "Antioch University Santa Barbara",
    value: "Antioch University Santa Barbara",
  },
  {
    label: "Antioch University Seattle",
    value: "Antioch University Seattle",
  },
  {
    label: "Anton Bruckner Privatuniversität",
    value: "Anton Bruckner Privatuniversität",
  },
  {
    label: "Anton de Kom Universiteit van Suriname",
    value: "Anton de Kom Universiteit van Suriname",
  },
  {
    label: "Antwerp Management School",
    value: "Antwerp Management School",
  },
  {
    label: "Anwer Khan Modern University",
    value: "Anwer Khan Modern University",
  },
  {
    label: "Anyang Institute of Technology",
    value: "Anyang Institute of Technology",
  },
  {
    label: "Anyang Normal University",
    value: "Anyang Normal University",
  },
  {
    label: "Anyang University",
    value: "Anyang University",
  },
  {
    label: "Anyang University",
    value: "Anyang University",
  },
  {
    label: "Aomori Chuo Gakuin University",
    value: "Aomori Chuo Gakuin University",
  },
  {
    label: "Aomori Public University",
    value: "Aomori Public University",
  },
  {
    label: "Aomori University",
    value: "Aomori University",
  },
  {
    label: "Aomori University of Health and Welfare",
    value: "Aomori University of Health and Welfare",
  },
  {
    label: "Aoyama Gakuin University",
    value: "Aoyama Gakuin University",
  },
  {
    label: "AP Hogeschool Antwerpen",
    value: "AP Hogeschool Antwerpen",
  },
  {
    label: "Apeejay Stya University",
    value: "Apeejay Stya University",
  },
  {
    label: "Apex Professional University",
    value: "Apex Professional University",
  },
  {
    label: "Apex University",
    value: "Apex University",
  },
  {
    label: "APJ Abdul Kalam Technological University",
    value: "APJ Abdul Kalam Technological University",
  },
  {
    label: "Appalachian Bible College",
    value: "Appalachian Bible College",
  },
  {
    label: "Appalachian College of Pharmacy",
    value: "Appalachian College of Pharmacy",
  },
  {
    label: "Appalachian State University",
    value: "Appalachian State University",
  },
  {
    label: "Applied Science Private University",
    value: "Applied Science Private University",
  },
  {
    label: "Applied Science University",
    value: "Applied Science University",
  },
  {
    label: "Aqaba University of Technology",
    value: "Aqaba University of Technology",
  },
  {
    label: "Aquinas College",
    value: "Aquinas College",
  },
  {
    label: "Aquinas College, Tennessee",
    value: "Aquinas College, Tennessee",
  },
  {
    label: "Aquinas University of Legazpi",
    value: "Aquinas University of Legazpi",
  },
  {
    label: "Arab Academy for Science, Technology and Maritime Transport",
    value: "Arab Academy for Science, Technology and Maritime Transport",
  },
  {
    label: "Arab American University",
    value: "Arab American University",
  },
  {
    label: "Arab College of Applied Sciences",
    value: "Arab College of Applied Sciences",
  },
  {
    label: "Arab International University",
    value: "Arab International University",
  },
  {
    label: "Arab Open University Lebanon",
    value: "Arab Open University Lebanon",
  },
  {
    label: "Arab University for Science and Technology",
    value: "Arab University for Science and Technology",
  },
  {
    label: "Arab University of Science and Technology",
    value: "Arab University of Science and Technology",
  },
  {
    label: "Arabian Gulf University",
    value: "Arabian Gulf University",
  },
  {
    label: "Arak University",
    value: "Arak University",
  },
  {
    label: "Arak University of Medical Sciences",
    value: "Arak University of Medical Sciences",
  },
  {
    label: "Arak University of Technology",
    value: "Arak University of Technology",
  },
  {
    label: "Arba Minch University",
    value: "Arba Minch University",
  },
  {
    label: "Arcadia University",
    value: "Arcadia University",
  },
  {
    label: "Architectural Institute in Prague",
    value: "Architectural Institute in Prague",
  },
  {
    label: "Arctic State Agrotechnological University",
    value: "Arctic State Agrotechnological University",
  },
  {
    label: "Ardabil University of Medical Sciences",
    value: "Ardabil University of Medical Sciences",
  },
  {
    label: "Ardahan Üniversitesi",
    value: "Ardahan Üniversitesi",
  },
  {
    label: "Ardakan University",
    value: "Ardakan University",
  },
  {
    label: "Ardhi University",
    value: "Ardhi University",
  },
  {
    label: "Arellano University",
    value: "Arellano University",
  },
  {
    label: "Aria University",
    value: "Aria University",
  },
  {
    label: "Ariana Institute of Higher Education",
    value: "Ariana Institute of Higher Education",
  },
  {
    label: "Ariel University",
    value: "Ariel University",
  },
  {
    label: "Arish University",
    value: "Arish University",
  },
  {
    label: "Aristotle University of Thessaloniki",
    value: "Aristotle University of Thessaloniki",
  },
  {
    label: "Arizona Christian University",
    value: "Arizona Christian University",
  },
  {
    label: "Arizona State University",
    value: "Arizona State University",
  },
  {
    label: "Arka Jain University",
    value: "Arka Jain University",
  },
  {
    label: "Arkalyk State Pedagogical Institute",
    value: "Arkalyk State Pedagogical Institute",
  },
  {
    label: "Arkansas Baptist College",
    value: "Arkansas Baptist College",
  },
  {
    label: "Arkansas State University",
    value: "Arkansas State University",
  },
  {
    label: "Arkansas Tech University",
    value: "Arkansas Tech University",
  },
  {
    label: "Arkin Yaratici Sanatlar ve Tasarim Üniversitesi",
    value: "Arkin Yaratici Sanatlar ve Tasarim Üniversitesi",
  },
  {
    label: "Arkitektskolen Aarhus",
    value: "Arkitektskolen Aarhus",
  },
  {
    label: "Arkitektur- og designhøgskolen i Oslo",
    value: "Arkitektur- og designhøgskolen i Oslo",
  },
  {
    label: "Arlington Baptist University",
    value: "Arlington Baptist University",
  },
  {
    label: "Armavir State Pedagogical University",
    value: "Armavir State Pedagogical University",
  },
  {
    label: "Armenian Medical Institute",
    value: "Armenian Medical Institute",
  },
  {
    label: "Armenian National Agrarian University",
    value: "Armenian National Agrarian University",
  },
  {
    label: "Armenian State Institute of Physical Culture and Sport",
    value: "Armenian State Institute of Physical Culture and Sport",
  },
  {
    label: "Armenian State Pedagogical University",
    value: "Armenian State Pedagogical University",
  },
  {
    label: "Armenian State University of Economics",
    value: "Armenian State University of Economics",
  },
  {
    label: "Arni University",
    value: "Arni University",
  },
  {
    label: "Arrupe Jesuit University",
    value: "Arrupe Jesuit University",
  },
  {
    label: "Art Academy of Cincinnati",
    value: "Art Academy of Cincinnati",
  },
  {
    label: "Art and Design Institut",
    value: "Art and Design Institut",
  },
  {
    label: "Art University of Isfahan",
    value: "Art University of Isfahan",
  },
  {
    label: "ArtCenter College of Design",
    value: "ArtCenter College of Design",
  },
  {
    label: "Arte A.C.",
    value: "Arte A.C.",
  },
  {
    label: "ARTE Music Academy",
    value: "ARTE Music Academy",
  },
  {
    label: "Arteveldehogeschool",
    value: "Arteveldehogeschool",
  },
  {
    label: "ArtEZ Hogeschool voor de kunsten",
    value: "ArtEZ Hogeschool voor de kunsten",
  },
  {
    label: "ArtHouse - Šola za risanje in slikanje",
    value: "ArtHouse - Šola za risanje in slikanje",
  },
  {
    label: "Arthur Jarvis University",
    value: "Arthur Jarvis University",
  },
  {
    label: "Arts et Métiers ParisTech",
    value: "Arts et Métiers ParisTech",
  },
  {
    label: "Arts University Bournemouth",
    value: "Arts University Bournemouth",
  },
  {
    label: "Arts University Plymouth",
    value: "Arts University Plymouth",
  },
  {
    label: "Arts, Sciences and Technology University in Lebanon",
    value: "Arts, Sciences and Technology University in Lebanon",
  },
  {
    label: "Arts² - École supérieure des Arts",
    value: "Arts² - École supérieure des Arts",
  },
  {
    label: "Artsakh State University",
    value: "Artsakh State University",
  },
  {
    label: "Artvin Çoruh Üniversitesi",
    value: "Artvin Çoruh Üniversitesi",
  },
  {
    label: "Arunachal University of Studies",
    value: "Arunachal University of Studies",
  },
  {
    label: "Arunodaya University",
    value: "Arunodaya University",
  },
  {
    label: "Aryabhatta Knowledge University",
    value: "Aryabhatta Knowledge University",
  },
  {
    label: "ASA University Bangladesh",
    value: "ASA University Bangladesh",
  },
  {
    label: "Asahi University",
    value: "Asahi University",
  },
  {
    label: "Asahikawa Medical University",
    value: "Asahikawa Medical University",
  },
  {
    label: "Asahikawa University",
    value: "Asahikawa University",
  },
  {
    label: "Asbury University",
    value: "Asbury University",
  },
  {
    label: "Ashesi University",
    value: "Ashesi University",
  },
  {
    label: "Ashikaga University",
    value: "Ashikaga University",
  },
  {
    label: "Ashiya University",
    value: "Ashiya University",
  },
  {
    label: "Ashkelon Academic College",
    value: "Ashkelon Academic College",
  },
  {
    label: "Ashland University",
    value: "Ashland University",
  },
  {
    label: "Ashna Institute of Higher Education",
    value: "Ashna Institute of Higher Education",
  },
  {
    label: "Ashoka University",
    value: "Ashoka University",
  },
  {
    label: "Asia e University",
    value: "Asia e University",
  },
  {
    label: "Asia Eastern University of Science and Technology",
    value: "Asia Eastern University of Science and Technology",
  },
  {
    label: "Asia Euro University",
    value: "Asia Euro University",
  },
  {
    label: "Asia Pacific College",
    value: "Asia Pacific College",
  },
  {
    label: "Asia University",
    value: "Asia University",
  },
  {
    label: "Asia University, Taiwan",
    value: "Asia University, Taiwan",
  },
  {
    label: "Asian Institute of Journalism and Communication",
    value: "Asian Institute of Journalism and Communication",
  },
  {
    label: "Asian Institute of Management",
    value: "Asian Institute of Management",
  },
  {
    label: "Asian Institute of Maritime Studies",
    value: "Asian Institute of Maritime Studies",
  },
  {
    label: "Asian Institute of Technology",
    value: "Asian Institute of Technology",
  },
  {
    label: "Asian Medical Institute",
    value: "Asian Medical Institute",
  },
  {
    label: "Asian Social Institute",
    value: "Asian Social Institute",
  },
  {
    label: "Asian University for Women",
    value: "Asian University for Women",
  },
  {
    label: "Asian University of Bangladesh",
    value: "Asian University of Bangladesh",
  },
  {
    label: "Asia-Pacific International University",
    value: "Asia-Pacific International University",
  },
  {
    label: "Asmara College of Health Sciences",
    value: "Asmara College of Health Sciences",
  },
  {
    label: "Assam Agricultural University",
    value: "Assam Agricultural University",
  },
  {
    label: "Assam Don Bosco University",
    value: "Assam Don Bosco University",
  },
  {
    label: "Assam Down Town University",
    value: "Assam Down Town University",
  },
  {
    label: "Assam Rajiv Gandhi University of Cooperative Management",
    value: "Assam Rajiv Gandhi University of Cooperative Management",
  },
  {
    label: "Assam Science and Technology University",
    value: "Assam Science and Technology University",
  },
  {
    label: "Assam University",
    value: "Assam University",
  },
  {
    label: "Assam Women's University",
    value: "Assam Women's University",
  },
  {
    label: "Assiut University",
    value: "Assiut University",
  },
  {
    label: "Assosa University",
    value: "Assosa University",
  },
  {
    label: "Assumption College San Lorenzo",
    value: "Assumption College San Lorenzo",
  },
  {
    label: "Assumption University",
    value: "Assumption University",
  },
  {
    label: "Assumption University",
    value: "Assumption University",
  },
  {
    label: "Astana Medical University",
    value: "Astana Medical University",
  },
  {
    label: "Astana University",
    value: "Astana University",
  },
  {
    label: "Aston University",
    value: "Aston University",
  },
  {
    label: "Astrakhan State Conservatory",
    value: "Astrakhan State Conservatory",
  },
  {
    label: "Astrakhan State Medical Academy",
    value: "Astrakhan State Medical Academy",
  },
  {
    label: "Astrakhan State Technical University",
    value: "Astrakhan State Technical University",
  },
  {
    label: "Astrakhan State University",
    value: "Astrakhan State University",
  },
  {
    label: "Aswan University",
    value: "Aswan University",
  },
  {
    label: "Atal Bihari Vajpayee Hindi Vishwavidyalaya",
    value: "Atal Bihari Vajpayee Hindi Vishwavidyalaya",
  },
  {
    label: "Atal Bihari Vajpayee Vishwavidyalaya",
    value: "Atal Bihari Vajpayee Vishwavidyalaya",
  },
  {
    label: "Atatürk Üniversitesi",
    value: "Atatürk Üniversitesi",
  },
  {
    label: "Ateneo de Davao University",
    value: "Ateneo de Davao University",
  },
  {
    label: "Ateneo de Manila University",
    value: "Ateneo de Manila University",
  },
  {
    label: "Ateneo de Naga University",
    value: "Ateneo de Naga University",
  },
  {
    label: "Ateneo de Zamboanga University",
    value: "Ateneo de Zamboanga University",
  },
  {
    label: "Athens School of Fine Arts",
    value: "Athens School of Fine Arts",
  },
  {
    label: "Athens State University",
    value: "Athens State University",
  },
  {
    label: "Athens University of Economics and Business",
    value: "Athens University of Economics and Business",
  },
  {
    label: "Atiba University",
    value: "Atiba University",
  },
  {
    label: "Atilim Üniversitesi",
    value: "Atilim Üniversitesi",
  },
  {
    label: "Atish Dipankar University of Science and Technology",
    value: "Atish Dipankar University of Science and Technology",
  },
  {
    label: "Atlanta Metropolitan State College",
    value: "Atlanta Metropolitan State College",
  },
  {
    label: "Atlantic Technological University",
    value: "Atlantic Technological University",
  },
  {
    label: "Atlantis College",
    value: "Atlantis College",
  },
  {
    label: "Atmiya University",
    value: "Atmiya University",
  },
  {
    label: "Atomi University",
    value: "Atomi University",
  },
  {
    label: "Atyrau Institute of Engineering and Humanities",
    value: "Atyrau Institute of Engineering and Humanities",
  },
  {
    label: "Atyrau State University",
    value: "Atyrau State University",
  },
  {
    label: "Atyrau University of Oil and Gas",
    value: "Atyrau University of Oil and Gas",
  },
  {
    label: "Auburn University",
    value: "Auburn University",
  },
  {
    label: "Auburn University at Montgomery",
    value: "Auburn University at Montgomery",
  },
  {
    label: "Auckland University of Technology",
    value: "Auckland University of Technology",
  },
  {
    label: "Audencia Business School",
    value: "Audencia Business School",
  },
  {
    label: "Auezov South Kazakhstan State University",
    value: "Auezov South Kazakhstan State University",
  },
  {
    label: "Augsburg University",
    value: "Augsburg University",
  },
  {
    label: "Augusta University",
    value: "Augusta University",
  },
  {
    label: "Augustana College",
    value: "Augustana College",
  },
  {
    label: "Augustana University",
    value: "Augustana University",
  },
  {
    label: "Augustana-Hochschule",
    value: "Augustana-Hochschule",
  },
  {
    label: "Augustine University",
    value: "Augustine University",
  },
  {
    label: "Aureus University School of Medicine",
    value: "Aureus University School of Medicine",
  },
  {
    label: "AURO University",
    value: "AURO University",
  },
  {
    label: "Aurora College",
    value: "Aurora College",
  },
  {
    label: "Aurora State College of Technology",
    value: "Aurora State College of Technology",
  },
  {
    label: "Aurora University",
    value: "Aurora University",
  },
  {
    label: "Austin College",
    value: "Austin College",
  },
  {
    label: "Austin Peay State University",
    value: "Austin Peay State University",
  },
  {
    label: "Australian Catholic University",
    value: "Australian Catholic University",
  },
  {
    label: "Australian National University",
    value: "Australian National University",
  },
  {
    label: "Australian University of Kuwait",
    value: "Australian University of Kuwait",
  },
  {
    label: "Avance International University",
    value: "Avance International University",
  },
  {
    label: "AVANS Hogeschool",
    value: "AVANS Hogeschool",
  },
  {
    label: "Avantika University",
    value: "Avantika University",
  },
  {
    label: "Avarga Institute",
    value: "Avarga Institute",
  },
  {
    label: "Ave Maria University",
    value: "Ave Maria University",
  },
  {
    label: "Averett University",
    value: "Averett University",
  },
  {
    label: "Avicenna University",
    value: "Avicenna University",
  },
  {
    label: "Avignon Université",
    value: "Avignon Université",
  },
  {
    label: "Avila University",
    value: "Avila University",
  },
  {
    label:
      "Avinashilingam Institute for Home Science and Higher Education for Women",
    value:
      "Avinashilingam Institute for Home Science and Higher Education for Women",
  },
  {
    label: "Avrasya Üniversitesi",
    value: "Avrasya Üniversitesi",
  },
  {
    label: "Awadhesh Pratap Singh University",
    value: "Awadhesh Pratap Singh University",
  },
  {
    label: "Ayatollah Borujerdi University",
    value: "Ayatollah Borujerdi University",
  },
  {
    label: "Aydin Adnan Menderes Üniversitesi",
    value: "Aydin Adnan Menderes Üniversitesi",
  },
  {
    label: "Ayush and Health Sciences University of Chhattisgarh",
    value: "Ayush and Health Sciences University of Chhattisgarh",
  },
  {
    label: "Azabu University",
    value: "Azabu University",
  },
  {
    label: "Azal University of Human Development",
    value: "Azal University of Human Development",
  },
  {
    label: "Azal University of Science and Technology",
    value: "Azal University of Science and Technology",
  },
  {
    label: "Azarbaijan Shahid Madani University",
    value: "Azarbaijan Shahid Madani University",
  },
  {
    label: "Azerbaycan Diller Universiteti",
    value: "Azerbaycan Diller Universiteti",
  },
  {
    label: "Azerbaycan Dövlet Aqrar Universiteti",
    value: "Azerbaycan Dövlet Aqrar Universiteti",
  },
  {
    label: "Azerbaycan Dövlet Beden Terbiyesi ve Idman Akademiyasi",
    value: "Azerbaycan Dövlet Beden Terbiyesi ve Idman Akademiyasi",
  },
  {
    label: "Azerbaycan Dövlet Deniz Akademiyasi",
    value: "Azerbaycan Dövlet Deniz Akademiyasi",
  },
  {
    label: "Azerbaycan Dövlet Iqtisad Universiteti",
    value: "Azerbaycan Dövlet Iqtisad Universiteti",
  },
  {
    label: "Azerbaycan Dövlet Medeniyyet ve Incesenet Universiteti",
    value: "Azerbaycan Dövlet Medeniyyet ve Incesenet Universiteti",
  },
  {
    label: "Azerbaycan Dövlet Neft ve Senaye Universiteti",
    value: "Azerbaycan Dövlet Neft ve Senaye Universiteti",
  },
  {
    label: "Azerbaycan Dövlet Pedaqoji Universiteti",
    value: "Azerbaycan Dövlet Pedaqoji Universiteti",
  },
  {
    label: "Azerbaycan Dövlet Ressamliq Akademiyasi",
    value: "Azerbaycan Dövlet Ressamliq Akademiyasi",
  },
  {
    label: "Azerbaycan Emek ve Sosial Münasibetler Akademiyasi",
    value: "Azerbaycan Emek ve Sosial Münasibetler Akademiyasi",
  },
  {
    label: "Azerbaycan Memarliq ve Insaat Universiteti",
    value: "Azerbaycan Memarliq ve Insaat Universiteti",
  },
  {
    label: "Azerbaycan Milli Konservatoriyasi",
    value: "Azerbaycan Milli Konservatoriyasi",
  },
  {
    label: "Azerbaycan Texniki Universiteti",
    value: "Azerbaycan Texniki Universiteti",
  },
  {
    label: "Azerbaycan Texnologiya Universiteti",
    value: "Azerbaycan Texnologiya Universiteti",
  },
  {
    label: "Azerbaycan Tibb Universiteti",
    value: "Azerbaycan Tibb Universiteti",
  },
  {
    label: "Azerbaycan Turizm ve Menecment Universiteti",
    value: "Azerbaycan Turizm ve Menecment Universiteti",
  },
  {
    label: "Azerbaycan Universiteti",
    value: "Azerbaycan Universiteti",
  },
  {
    label: "Azhar Higher Education Institute",
    value: "Azhar Higher Education Institute",
  },
  {
    label: "Azim Premji University",
    value: "Azim Premji University",
  },
  {
    label: "Azrieli College of Engineering Jerusalem",
    value: "Azrieli College of Engineering Jerusalem",
  },
  {
    label: "Azusa Pacific University",
    value: "Azusa Pacific University",
  },
  {
    label: "Azzaytuna University",
    value: "Azzaytuna University",
  },
  {
    label: "B.S. Abdur Rahman Crescent Institute of Science and Technology",
    value: "B.S. Abdur Rahman Crescent Institute of Science and Technology",
  },
  {
    label: "B2 Visoka šola za poslovne vede",
    value: "B2 Visoka šola za poslovne vede",
  },
  {
    label: "BA ISAGO University",
    value: "BA ISAGO University",
  },
  {
    label: "Baba Farid University of Health Sciences",
    value: "Baba Farid University of Health Sciences",
  },
  {
    label: "Baba Ghulam Shah Badhshah University",
    value: "Baba Ghulam Shah Badhshah University",
  },
  {
    label: "Baba Mastnath University",
    value: "Baba Mastnath University",
  },
  {
    label: "Babasaheb Bhimrao Ambedkar Bihar University",
    value: "Babasaheb Bhimrao Ambedkar Bihar University",
  },
  {
    label: "Babasaheb Bhimrao Ambedkar University",
    value: "Babasaheb Bhimrao Ambedkar University",
  },
  {
    label: "Babcock University",
    value: "Babcock University",
  },
  {
    label: "Babol Noshirvani University of Technology",
    value: "Babol Noshirvani University of Technology",
  },
  {
    label: "Babol University of Medical Sciences",
    value: "Babol University of Medical Sciences",
  },
  {
    label: "Babson College",
    value: "Babson College",
  },
  {
    label: "Babu Banarasi Das University",
    value: "Babu Banarasi Das University",
  },
  {
    label: "Bac Lieu University",
    value: "Bac Lieu University",
  },
  {
    label: "Bacha Khan University",
    value: "Bacha Khan University",
  },
  {
    label: "Bacone College",
    value: "Bacone College",
  },
  {
    label: "Badakhshan University",
    value: "Badakhshan University",
  },
  {
    label: "Baddi University of Emerging Sciences and Technologies",
    value: "Baddi University of Emerging Sciences and Technologies",
  },
  {
    label: "Badr University in Cairo",
    value: "Badr University in Cairo",
  },
  {
    label: "Baekseok University",
    value: "Baekseok University",
  },
  {
    label: "Baghdad College of Economic Sciences University",
    value: "Baghdad College of Economic Sciences University",
  },
  {
    label: "Baghdad College of Medical Sciences",
    value: "Baghdad College of Medical Sciences",
  },
  {
    label: "Baghlan University",
    value: "Baghlan University",
  },
  {
    label: "Bago University",
    value: "Bago University",
  },
  {
    label: "Bahauddin Zakariya University",
    value: "Bahauddin Zakariya University",
  },
  {
    label: "Bahçesehir Kibris Üniversitesi",
    value: "Bahçesehir Kibris Üniversitesi",
  },
  {
    label: "Bahçesehir Üniversitesi",
    value: "Bahçesehir Üniversitesi",
  },
  {
    label: "Bahir Dar University",
    value: "Bahir Dar University",
  },
  {
    label: "BAHRA University",
    value: "BAHRA University",
  },
  {
    label: "Bahrain Institute for Banking and Finance",
    value: "Bahrain Institute for Banking and Finance",
  },
  {
    label: "Bahria University",
    value: "Bahria University",
  },
  {
    label: "Baicheng Normal University",
    value: "Baicheng Normal University",
  },
  {
    label: "Baika Women's University",
    value: "Baika Women's University",
  },
  {
    label: "Baikal State University",
    value: "Baikal State University",
  },
  {
    label: "Baiko Gakuin University",
    value: "Baiko Gakuin University",
  },
  {
    label: "Baise University",
    value: "Baise University",
  },
  {
    label: "Baishev University",
    value: "Baishev University",
  },
  {
    label: "Baker College",
    value: "Baker College",
  },
  {
    label: "Baker University",
    value: "Baker University",
  },
  {
    label: "Bakhtar University",
    value: "Bakhtar University",
  },
  {
    label: "Baki Ali Neft Mektebi",
    value: "Baki Ali Neft Mektebi",
  },
  {
    label: "Baki Avrasiya Universiteti",
    value: "Baki Avrasiya Universiteti",
  },
  {
    label: "Baki Biznes Universiteti",
    value: "Baki Biznes Universiteti",
  },
  {
    label: "Baki Dövlet Universiteti",
    value: "Baki Dövlet Universiteti",
  },
  {
    label: "Baki Islam Universiteti",
    value: "Baki Islam Universiteti",
  },
  {
    label: "Baki Muhendislik Universiteti",
    value: "Baki Muhendislik Universiteti",
  },
  {
    label: "Baki Musiqi Akademiyasi",
    value: "Baki Musiqi Akademiyasi",
  },
  {
    label: "Baki Qizlar Universiteti",
    value: "Baki Qizlar Universiteti",
  },
  {
    label: "Baki Slavyan Universiteti",
    value: "Baki Slavyan Universiteti",
  },
  {
    label: "Bakirçay Üniversitesi",
    value: "Bakirçay Üniversitesi",
  },
  {
    label: "Baldwin Wallace University",
    value: "Baldwin Wallace University",
  },
  {
    label: "Balikesir Üniversitesi",
    value: "Balikesir Üniversitesi",
  },
  {
    label: "Baliuag University",
    value: "Baliuag University",
  },
  {
    label: "Balkh University",
    value: "Balkh University",
  },
  {
    label: "Ball State University",
    value: "Ball State University",
  },
  {
    label: "Balochistan University of Engineering and Technology",
    value: "Balochistan University of Engineering and Technology",
  },
  {
    label:
      "Balochistan University of Information Technology, Engineering and Management Sciences",
    value:
      "Balochistan University of Information Technology, Engineering and Management Sciences",
  },
  {
    label: "Baltic State Technical University 'Voenmeh'",
    value: "Baltic State Technical University 'Voenmeh'",
  },
  {
    label: "Baltijas Starptautiska akademija",
    value: "Baltijas Starptautiska akademija",
  },
  {
    label: "Bam University",
    value: "Bam University",
  },
  {
    label: "Bamenda University of Science and Technology",
    value: "Bamenda University of Science and Technology",
  },
  {
    label: "Bamiyan University",
    value: "Bamiyan University",
  },
  {
    label: "Banaras Hindu University",
    value: "Banaras Hindu University",
  },
  {
    label: "Banasthali Vidyapith",
    value: "Banasthali Vidyapith",
  },
  {
    label: "Banda University of Agriculture and Technology",
    value: "Banda University of Agriculture and Technology",
  },
  {
    label: "Bandarban University",
    value: "Bandarban University",
  },
  {
    label: "Bandirma Onyedi Eylül Üniversitesi",
    value: "Bandirma Onyedi Eylül Üniversitesi",
  },
  {
    label: "Bangabandhu Sheikh Mujib Medical University",
    value: "Bangabandhu Sheikh Mujib Medical University",
  },
  {
    label: "Bangabandhu Sheikh Mujibur Rahman Agricultural University",
    value: "Bangabandhu Sheikh Mujibur Rahman Agricultural University",
  },
  {
    label: "Bangabandhu Sheikh Mujibur Rahman Maritime University",
    value: "Bangabandhu Sheikh Mujibur Rahman Maritime University",
  },
  {
    label:
      "Bangabandhu Sheikh Mujibur Rahman Science and Technology University",
    value:
      "Bangabandhu Sheikh Mujibur Rahman Science and Technology University",
  },
  {
    label: "Bangalore University",
    value: "Bangalore University",
  },
  {
    label: "Bangamata Sheikh Fazilatunnesa Mujib Medical University",
    value: "Bangamata Sheikh Fazilatunnesa Mujib Medical University",
  },
  {
    label:
      "Bangamata Sheikh Fojilatunnesa Mujib Science and Technology University",
    value:
      "Bangamata Sheikh Fojilatunnesa Mujib Science and Technology University",
  },
  {
    label: "Bangkok Suvarnabhumi University",
    value: "Bangkok Suvarnabhumi University",
  },
  {
    label: "Bangkok Thonburi University",
    value: "Bangkok Thonburi University",
  },
  {
    label: "Bangkok University",
    value: "Bangkok University",
  },
  {
    label: "Bangladesh Agricultural University",
    value: "Bangladesh Agricultural University",
  },
  {
    label: "Bangladesh Islami University",
    value: "Bangladesh Islami University",
  },
  {
    label: "Bangladesh University",
    value: "Bangladesh University",
  },
  {
    label: "Bangladesh University of Business and Technology",
    value: "Bangladesh University of Business and Technology",
  },
  {
    label: "Bangladesh University of Engineering and Technology",
    value: "Bangladesh University of Engineering and Technology",
  },
  {
    label: "Bangladesh University of Health Sciences ",
    value: "Bangladesh University of Health Sciences ",
  },
  {
    label: "Bangladesh University of Professionals",
    value: "Bangladesh University of Professionals",
  },
  {
    label: "Bangladesh University of Textiles",
    value: "Bangladesh University of Textiles",
  },
  {
    label: "Bangor University",
    value: "Bangor University",
  },
  {
    label: "Bani Waleed University",
    value: "Bani Waleed University",
  },
  {
    label: "Banja Luka College",
    value: "Banja Luka College",
  },
  {
    label: "Bank of Georgia University",
    value: "Bank of Georgia University",
  },
  {
    label: "Bank Street College of Education",
    value: "Bank Street College of Education",
  },
  {
    label: "Bank-moliya Akademiyasi",
    value: "Bank-moliya Akademiyasi",
  },
  {
    label: "Banku augstskola",
    value: "Banku augstskola",
  },
  {
    label: "Bankura University",
    value: "Bankura University",
  },
  {
    label: "Bansomdejchaopraya Rajabhat University",
    value: "Bansomdejchaopraya Rajabhat University",
  },
  {
    label: "Banzarov Buryat State University",
    value: "Banzarov Buryat State University",
  },
  {
    label: "Baoding University",
    value: "Baoding University",
  },
  {
    label: "Baoji University of Arts and Sciences",
    value: "Baoji University of Arts and Sciences",
  },
  {
    label: "Baoshan University",
    value: "Baoshan University",
  },
  {
    label: "Baptist Health Sciences University",
    value: "Baptist Health Sciences University",
  },
  {
    label: "Baptist University of Florida",
    value: "Baptist University of Florida",
  },
  {
    label: "Baptist University of the Americas",
    value: "Baptist University of the Americas",
  },
  {
    label: "Baqai Medical University",
    value: "Baqai Medical University",
  },
  {
    label: "Baqir al-olum University",
    value: "Baqir al-olum University",
  },
  {
    label: "Baqiyatallah Medical Sciences University",
    value: "Baqiyatallah Medical Sciences University",
  },
  {
    label: "Baranovichi State University",
    value: "Baranovichi State University",
  },
  {
    label: "Barclay College",
    value: "Barclay College",
  },
  {
    label: "Bard College",
    value: "Bard College",
  },
  {
    label: "Bard College at Simon's Rock",
    value: "Bard College at Simon's Rock",
  },
  {
    label: "Bard College Berlin",
    value: "Bard College Berlin",
  },
  {
    label: "Bareilly International University",
    value: "Bareilly International University",
  },
  {
    label: "Baria Vungtau University",
    value: "Baria Vungtau University",
  },
  {
    label: "Bar-Ilan University",
    value: "Bar-Ilan University",
  },
  {
    label: "Barkatullah University",
    value: "Barkatullah University",
  },
  {
    label: "Barna Business School",
    value: "Barna Business School",
  },
  {
    label: "Barnard College",
    value: "Barnard College",
  },
  {
    label: "Barry University",
    value: "Barry University",
  },
  {
    label: "Bartin Üniversitesi",
    value: "Bartin Üniversitesi",
  },
  {
    label: "Barton College",
    value: "Barton College",
  },
  {
    label: "Baruch College, CUNY",
    value: "Baruch College, CUNY",
  },
  {
    label: "Bashkir State Agricultural University",
    value: "Bashkir State Agricultural University",
  },
  {
    label: "Bashkir State Medical University",
    value: "Bashkir State Medical University",
  },
  {
    label: "Baskent Üniversitesi",
    value: "Baskent Üniversitesi",
  },
  {
    label: "Basra University College of Science and Technology",
    value: "Basra University College of Science and Technology",
  },
  {
    label: "Basra University of Oil an Gas",
    value: "Basra University of Oil an Gas",
  },
  {
    label: "Bastyr University",
    value: "Bastyr University",
  },
  {
    label: "Bataan Peninsula State University",
    value: "Bataan Peninsula State University",
  },
  {
    label: "Batangas State University",
    value: "Batangas State University",
  },
  {
    label: "Bates College",
    value: "Bates College",
  },
  {
    label: "Bath Spa University",
    value: "Bath Spa University",
  },
  {
    label: "Batken State University",
    value: "Batken State University",
  },
  {
    label: "Batman Üniversitesi",
    value: "Batman Üniversitesi",
  },
  {
    label: "Batumi Art Teaching University",
    value: "Batumi Art Teaching University",
  },
  {
    label: "Batumi Navigation Teaching University",
    value: "Batumi Navigation Teaching University",
  },
  {
    label: "Batumi Shota Rustaveli State University",
    value: "Batumi Shota Rustaveli State University",
  },
  {
    label: "Batumi State Maritime Academy",
    value: "Batumi State Maritime Academy",
  },
  {
    label: "BAU International University, Batumi",
    value: "BAU International University, Batumi",
  },
  {
    label: "Bauchi State University",
    value: "Bauchi State University",
  },
  {
    label: "Bauhaus-Universität Weimar",
    value: "Bauhaus-Universität Weimar",
  },
  {
    label: "Bauman Moscow State Technical University",
    value: "Bauman Moscow State Technical University",
  },
  {
    label: "Bay Path University",
    value: "Bay Path University",
  },
  {
    label: "Bay State College",
    value: "Bay State College",
  },
  {
    label: "Bayan College",
    value: "Bayan College",
  },
  {
    label: "Bayan University",
    value: "Bayan University",
  },
  {
    label: "Bayburt Üniversitesi",
    value: "Bayburt Üniversitesi",
  },
  {
    label: "Bayero University Kano",
    value: "Bayero University Kano",
  },
  {
    label: "Baylor College of Medicine",
    value: "Baylor College of Medicine",
  },
  {
    label: "Baylor University",
    value: "Baylor University",
  },
  {
    label: "Baze University",
    value: "Baze University",
  },
  {
    label: "bbw Hochschule",
    value: "bbw Hochschule",
  },
  {
    label: "Beacon College",
    value: "Beacon College",
  },
  {
    label: "Beaconhouse National University",
    value: "Beaconhouse National University",
  },
  {
    label: "Beaux-Arts de Liège",
    value: "Beaux-Arts de Liège",
  },
  {
    label: "Beckmans Designhögskola",
    value: "Beckmans Designhögskola",
  },
  {
    label: "Begum Gulchemonara Trust University",
    value: "Begum Gulchemonara Trust University",
  },
  {
    label: "Begum Rokeya University, Rangpur",
    value: "Begum Rokeya University, Rangpur",
  },
  {
    label: "Beibu Gulf University",
    value: "Beibu Gulf University",
  },
  {
    label: "Beihai College of Art and Design",
    value: "Beihai College of Art and Design",
  },
  {
    label: "Beihang University",
    value: "Beihang University",
  },
  {
    label: "Beihua University",
    value: "Beihua University",
  },
  {
    label: "Beijing City University",
    value: "Beijing City University",
  },
  {
    label: "Beijing Dance Academy",
    value: "Beijing Dance Academy",
  },
  {
    label: "Beijing Electronic Science and Technology Institute",
    value: "Beijing Electronic Science and Technology Institute",
  },
  {
    label: "Beijing Film Academy",
    value: "Beijing Film Academy",
  },
  {
    label: "Beijing Foreign Studies University",
    value: "Beijing Foreign Studies University",
  },
  {
    label: "Beijing Forestry University",
    value: "Beijing Forestry University",
  },
  {
    label: "Beijing Geely University",
    value: "Beijing Geely University",
  },
  {
    label: "Beijing Information Science and Technology University",
    value: "Beijing Information Science and Technology University",
  },
  {
    label: "Beijing Institute of Fashion Technology",
    value: "Beijing Institute of Fashion Technology",
  },
  {
    label: "Beijing Institute of Graphic Communication",
    value: "Beijing Institute of Graphic Communication",
  },
  {
    label: "Beijing Institute of Petrochemical Technology",
    value: "Beijing Institute of Petrochemical Technology",
  },
  {
    label: "Beijing Institute of Technology",
    value: "Beijing Institute of Technology",
  },
  {
    label: "Beijing International Studies University",
    value: "Beijing International Studies University",
  },
  {
    label: "Beijing Jiaotong University",
    value: "Beijing Jiaotong University",
  },
  {
    label: "Beijing Language and Culture University",
    value: "Beijing Language and Culture University",
  },
  {
    label: "Beijing Normal University",
    value: "Beijing Normal University",
  },
  {
    label: "Beijing Sport University",
    value: "Beijing Sport University",
  },
  {
    label: "Beijing Technology and Business University",
    value: "Beijing Technology and Business University",
  },
  {
    label: "Beijing Union University",
    value: "Beijing Union University",
  },
  {
    label: "Beijing University of Agriculture",
    value: "Beijing University of Agriculture",
  },
  {
    label: "Beijing University of Chemical Technology",
    value: "Beijing University of Chemical Technology",
  },
  {
    label: "Beijing University of Chinese Medicine",
    value: "Beijing University of Chinese Medicine",
  },
  {
    label: "Beijing University of Civil Engineering and Architecture",
    value: "Beijing University of Civil Engineering and Architecture",
  },
  {
    label: "Beijing University of Posts and Telecommunications",
    value: "Beijing University of Posts and Telecommunications",
  },
  {
    label: "Beijing University of Technology",
    value: "Beijing University of Technology",
  },
  {
    label: "Beijing Wuzi University",
    value: "Beijing Wuzi University",
  },
  {
    label: "Beirut Arab University",
    value: "Beirut Arab University",
  },
  {
    label: "Beirut Islamic University",
    value: "Beirut Islamic University",
  },
  {
    label: "Belarusian National Technical University",
    value: "Belarusian National Technical University",
  },
  {
    label: "Belarusian State Academy of Arts",
    value: "Belarusian State Academy of Arts",
  },
  {
    label: "Belarusian State Academy of Aviation",
    value: "Belarusian State Academy of Aviation",
  },
  {
    label: "Belarusian State Academy of Communications",
    value: "Belarusian State Academy of Communications",
  },
  {
    label: "Belarusian State Academy of Music",
    value: "Belarusian State Academy of Music",
  },
  {
    label: "Belarusian State Agrarian Technical University",
    value: "Belarusian State Agrarian Technical University",
  },
  {
    label: "Belarusian State Agricultural Academy",
    value: "Belarusian State Agricultural Academy",
  },
  {
    label: "Belarusian State Economic University",
    value: "Belarusian State Economic University",
  },
  {
    label: "Belarusian State Medical University",
    value: "Belarusian State Medical University",
  },
  {
    label: "Belarusian State Pedagogical University",
    value: "Belarusian State Pedagogical University",
  },
  {
    label: "Belarusian State Technological University",
    value: "Belarusian State Technological University",
  },
  {
    label: "Belarusian State University",
    value: "Belarusian State University",
  },
  {
    label: "Belarusian State University of Culture and Arts",
    value: "Belarusian State University of Culture and Arts",
  },
  {
    label: "Belarusian State University of Food and Chemical Technologies",
    value: "Belarusian State University of Food and Chemical Technologies",
  },
  {
    label: "Belarusian State University of Informatics and Radioelectronics",
    value: "Belarusian State University of Informatics and Radioelectronics",
  },
  {
    label: "Belarusian State University of Physical Culture",
    value: "Belarusian State University of Physical Culture",
  },
  {
    label: "Belarusian State University of Transport",
    value: "Belarusian State University of Transport",
  },
  {
    label: "Belarusian Trade and Economics University of Consumer Cooperatives",
    value: "Belarusian Trade and Economics University of Consumer Cooperatives",
  },
  {
    label: "Belarusian-Russian University",
    value: "Belarusian-Russian University",
  },
  {
    label: "Belgorod State Agricultural University",
    value: "Belgorod State Agricultural University",
  },
  {
    label: "Belgorod State Technological University",
    value: "Belgorod State Technological University",
  },
  {
    label: "Belgorod State University",
    value: "Belgorod State University",
  },
  {
    label: "Belhaven University",
    value: "Belhaven University",
  },
  {
    label: "Bellarmine University",
    value: "Bellarmine University",
  },
  {
    label: "Bellevue College",
    value: "Bellevue College",
  },
  {
    label: "Bellevue University",
    value: "Bellevue University",
  },
  {
    label: "Bellin College",
    value: "Bellin College",
  },
  {
    label: "Bells University of Technology",
    value: "Bells University of Technology",
  },
  {
    label: "Belmont Abbey College",
    value: "Belmont Abbey College",
  },
  {
    label: "Belmont University",
    value: "Belmont University",
  },
  {
    label: "Beloit College",
    value: "Beloit College",
  },
  {
    label: "Beltei International University",
    value: "Beltei International University",
  },
  {
    label: "Bemidji State University",
    value: "Bemidji State University",
  },
  {
    label: "Benawa Institute of Higher Education",
    value: "Benawa Institute of Higher Education",
  },
  {
    label: "Benazir Bhutto Shaheed University Lyari",
    value: "Benazir Bhutto Shaheed University Lyari",
  },
  {
    label:
      "Benazir Bhutto Shaheed University of Technology and Skill Development",
    value:
      "Benazir Bhutto Shaheed University of Technology and Skill Development",
  },
  {
    label: "Benedict College",
    value: "Benedict College",
  },
  {
    label: "Benedictine College",
    value: "Benedictine College",
  },
  {
    label: "Benedictine University",
    value: "Benedictine University",
  },
  {
    label: "Benemerita Universidad Autonoma de Puebla",
    value: "Benemerita Universidad Autonoma de Puebla",
  },
  {
    label: "Bengaluru North University",
    value: "Bengaluru North University",
  },
  {
    label: "Bengbu Medical College",
    value: "Bengbu Medical College",
  },
  {
    label: "Bengbu University",
    value: "Bengbu University",
  },
  {
    label: "Benguet State University",
    value: "Benguet State University",
  },
  {
    label: "Ben-Gurion University of the Negev",
    value: "Ben-Gurion University of the Negev",
  },
  {
    label: "Benha University",
    value: "Benha University",
  },
  {
    label: "Beni-Suef University",
    value: "Beni-Suef University",
  },
  {
    label: "Benjamin Franklin Cummings Institute of Technology",
    value: "Benjamin Franklin Cummings Institute of Technology",
  },
  {
    label: "Bennett College",
    value: "Bennett College",
  },
  {
    label: "Bennett University",
    value: "Bennett University",
  },
  {
    label: "Bennington College",
    value: "Bennington College",
  },
  {
    label: "Benson Idahosa University",
    value: "Benson Idahosa University",
  },
  {
    label: "Bentley University",
    value: "Bentley University",
  },
  {
    label: "Benue State University",
    value: "Benue State University",
  },
  {
    label: "Beppu University",
    value: "Beppu University",
  },
  {
    label: "Berdyansk State Pedagogical University",
    value: "Berdyansk State Pedagogical University",
  },
  {
    label: "Berdyansk University of Management and Business",
    value: "Berdyansk University of Management and Business",
  },
  {
    label: "Berea College",
    value: "Berea College",
  },
  {
    label: "Bergische Universität Wuppertal",
    value: "Bergische Universität Wuppertal",
  },
  {
    label: "Berhampur University",
    value: "Berhampur University",
  },
  {
    label: "Berkeley College",
    value: "Berkeley College",
  },
  {
    label: "Berklee College of Music",
    value: "Berklee College of Music",
  },
  {
    label: "Bermuda College",
    value: "Bermuda College",
  },
  {
    label: "Berner Fachhochschule",
    value: "Berner Fachhochschule",
  },
  {
    label: "Berry College",
    value: "Berry College",
  },
  {
    label: "Bertha von Suttner Privatuniversität",
    value: "Bertha von Suttner Privatuniversität",
  },
  {
    label: "Bethany College",
    value: "Bethany College",
  },
  {
    label: "Bethany College, Kansas",
    value: "Bethany College, Kansas",
  },
  {
    label: "Bethany Lutheran College",
    value: "Bethany Lutheran College",
  },
  {
    label: "Bethel College",
    value: "Bethel College",
  },
  {
    label: "Bethel University",
    value: "Bethel University",
  },
  {
    label: "Bethel University",
    value: "Bethel University",
  },
  {
    label: "Bethel University, Tennessee",
    value: "Bethel University, Tennessee",
  },
  {
    label: "Bethel University, Zambia",
    value: "Bethel University, Zambia",
  },
  {
    label: "Bethesda University",
    value: "Bethesda University",
  },
  {
    label: "Bethlehem University",
    value: "Bethlehem University",
  },
  {
    label: "Bethune-Cookman University",
    value: "Bethune-Cookman University",
  },
  {
    label: "Beulah Heights University",
    value: "Beulah Heights University",
  },
  {
    label: "Beuth Hochschule für Technik Berlin",
    value: "Beuth Hochschule für Technik Berlin",
  },
  {
    label: "Beykent Üniversitesi",
    value: "Beykent Üniversitesi",
  },
  {
    label: "Beykoz Üniversitesi",
    value: "Beykoz Üniversitesi",
  },
  {
    label: "Bezalel Academy of Arts and Design",
    value: "Bezalel Academy of Arts and Design",
  },
  {
    label: "Bezmiâlem Vakif Üniversitesi",
    value: "Bezmiâlem Vakif Üniversitesi",
  },
  {
    label: "BGFI Business School",
    value: "BGFI Business School",
  },
  {
    label: "BGMEA University of Fashion and Technology",
    value: "BGMEA University of Fashion and Technology",
  },
  {
    label: "Bhabha University",
    value: "Bhabha University",
  },
  {
    label: "Bhagat Phool Singh Mahila Vishwavidyalaya",
    value: "Bhagat Phool Singh Mahila Vishwavidyalaya",
  },
  {
    label: "Bhagwant University",
    value: "Bhagwant University",
  },
  {
    label: "Bhakta Kavi Narsinh Mehta University",
    value: "Bhakta Kavi Narsinh Mehta University",
  },
  {
    label: "Bhamo University",
    value: "Bhamo University",
  },
  {
    label: "Bharath Institute of Higher Education and Research",
    value: "Bharath Institute of Higher Education and Research",
  },
  {
    label: "Bharathiar University",
    value: "Bharathiar University",
  },
  {
    label: "Bharathidasan University",
    value: "Bharathidasan University",
  },
  {
    label: "Bharati Vidyapeeth Deemed University",
    value: "Bharati Vidyapeeth Deemed University",
  },
  {
    label: "Bhartiya Skill Development University",
    value: "Bhartiya Skill Development University",
  },
  {
    label: "Bhatkhande Sanskriti Vishwavidyalaya",
    value: "Bhatkhande Sanskriti Vishwavidyalaya",
  },
  {
    label: "Bhiksu University of Sri Lanka",
    value: "Bhiksu University of Sri Lanka",
  },
  {
    label: "Bhupal Nobles University",
    value: "Bhupal Nobles University",
  },
  {
    label: "Bhupendra Narayan Mandal University",
    value: "Bhupendra Narayan Mandal University",
  },
  {
    label: "Bicol University",
    value: "Bicol University",
  },
  {
    label: "Bidhan Chandra Krishi Viswavidyalaya",
    value: "Bidhan Chandra Krishi Viswavidyalaya",
  },
  {
    label: "Bielska Wyzsza Szkola im. Józefa Tyszkiewicza",
    value: "Bielska Wyzsza Szkola im. Józefa Tyszkiewicza",
  },
  {
    label: "Bihar Agricultural University",
    value: "Bihar Agricultural University",
  },
  {
    label: "Biju Patnaik University of Technology",
    value: "Biju Patnaik University of Technology",
  },
  {
    label: "Bila Tserkva National Agrarian University",
    value: "Bila Tserkva National Agrarian University",
  },
  {
    label: "Bilad Al Sham University",
    value: "Bilad Al Sham University",
  },
  {
    label: "Bilad Alrafidain University College",
    value: "Bilad Alrafidain University College",
  },
  {
    label: "Bilecik Seyh Edebali Üniversitesi",
    value: "Bilecik Seyh Edebali Üniversitesi",
  },
  {
    label: "Biliran Province State University",
    value: "Biliran Province State University",
  },
  {
    label: "Bilkent Üniversitesi",
    value: "Bilkent Üniversitesi",
  },
  {
    label: "Binary University of Management and Entrepreneurship",
    value: "Binary University of Management and Entrepreneurship",
  },
  {
    label: "Bindura University of Science Education",
    value: "Bindura University of Science Education",
  },
  {
    label: "Bingham University",
    value: "Bingham University",
  },
  {
    label: "Binghamton University, State University of New York",
    value: "Binghamton University, State University of New York",
  },
  {
    label: "Bingöl Üniversitesi",
    value: "Bingöl Üniversitesi",
  },
  {
    label: "Binod Bihari Mahto Koyalanchal University",
    value: "Binod Bihari Mahto Koyalanchal University",
  },
  {
    label: "Binzhou Medical University",
    value: "Binzhou Medical University",
  },
  {
    label: "Binzhou University",
    value: "Binzhou University",
  },
  {
    label: "Biola University",
    value: "Biola University",
  },
  {
    label: "BIP - Institute of Law",
    value: "BIP - Institute of Law",
  },
  {
    label: "Birjand University of Medical Sciences",
    value: "Birjand University of Medical Sciences",
  },
  {
    label: "Birjand University of Technology",
    value: "Birjand University of Technology",
  },
  {
    label: "Birkbeck, University of London",
    value: "Birkbeck, University of London",
  },
  {
    label: "Birla Institute of Technology",
    value: "Birla Institute of Technology",
  },
  {
    label: "Birla Institute of Technology and Science",
    value: "Birla Institute of Technology and Science",
  },
  {
    label: "Birmingham City University",
    value: "Birmingham City University",
  },
  {
    label: "Birmingham Newman University",
    value: "Birmingham Newman University",
  },
  {
    label: "Birmingham-Southern College",
    value: "Birmingham-Southern College",
  },
  {
    label: "Birsa Agricultural University",
    value: "Birsa Agricultural University",
  },
  {
    label: "Biruni Üniversitesi",
    value: "Biruni Üniversitesi",
  },
  {
    label: "Birzeit University",
    value: "Birzeit University",
  },
  {
    label: "Bishkek State University named after K. Karasaev",
    value: "Bishkek State University named after K. Karasaev",
  },
  {
    label: "Bishop Grosseteste University",
    value: "Bishop Grosseteste University",
  },
  {
    label: "Bishop Stuart University",
    value: "Bishop Stuart University",
  },
  {
    label: "Bishop's University",
    value: "Bishop's University",
  },
  {
    label: "Bismarck State College",
    value: "Bismarck State College",
  },
  {
    label: "Bitlis Eren Üniversitesi",
    value: "Bitlis Eren Üniversitesi",
  },
  {
    label: "Biwako Seikei Sport College",
    value: "Biwako Seikei Sport College",
  },
  {
    label: "Biwako-Gakuin University",
    value: "Biwako-Gakuin University",
  },
  {
    label: "Biznesa augstskola Turiba",
    value: "Biznesa augstskola Turiba",
  },
  {
    label: "Black Hills State University",
    value: "Black Hills State University",
  },
  {
    label: "Black Sea National University",
    value: "Black Sea National University",
  },
  {
    label: "Blackburn College",
    value: "Blackburn College",
  },
  {
    label: "Blagoveshchensk State Pedagogical University",
    value: "Blagoveshchensk State Pedagogical University",
  },
  {
    label: "Blantyre International University",
    value: "Blantyre International University",
  },
  {
    label: "BLDE University",
    value: "BLDE University",
  },
  {
    label: "Blekinge Tekniska Högskola",
    value: "Blekinge Tekniska Högskola",
  },
  {
    label: "Blessing University of Excellence",
    value: "Blessing University of Excellence",
  },
  {
    label: "Blessing-Rieman College of Nursing and Health Sciences",
    value: "Blessing-Rieman College of Nursing and Health Sciences",
  },
  {
    label: "Bloomsburg University of Pennsylvania",
    value: "Bloomsburg University of Pennsylvania",
  },
  {
    label: "Blue Mountain Christian University",
    value: "Blue Mountain Christian University",
  },
  {
    label: "BlueCrest College",
    value: "BlueCrest College",
  },
  {
    label: "Bluefield State University",
    value: "Bluefield State University",
  },
  {
    label: "Bluefield University",
    value: "Bluefield University",
  },
  {
    label: "Bluefields Indian and Caribbean University",
    value: "Bluefields Indian and Caribbean University",
  },
  {
    label: "Bluffton University",
    value: "Bluffton University",
  },
  {
    label: "BML Munjal University",
    value: "BML Munjal University",
  },
  {
    label: "Bob Jones University",
    value: "Bob Jones University",
  },
  {
    label: "Bodoland University",
    value: "Bodoland University",
  },
  {
    label: "Bogaziçi Üniversitesi",
    value: "Bogaziçi Üniversitesi",
  },
  {
    label: "Bohai University",
    value: "Bohai University",
  },
  {
    label: "Bohol Island State University",
    value: "Bohol Island State University",
  },
  {
    label: "Boise Bible College",
    value: "Boise Bible College",
  },
  {
    label: "Boise State University",
    value: "Boise State University",
  },
  {
    label: "Boitekanelo College",
    value: "Boitekanelo College",
  },
  {
    label: "Bolan University of Medical and Health Sciences",
    value: "Bolan University of Medical and Health Sciences",
  },
  {
    label: "Bolashak University",
    value: "Bolashak University",
  },
  {
    label: "Bolashaq Academy",
    value: "Bolashaq Academy",
  },
  {
    label: "Bolgatanga Technical University",
    value: "Bolgatanga Technical University",
  },
  {
    label: "Bolu Abant Izzet Baysal Üniversitesi",
    value: "Bolu Abant Izzet Baysal Üniversitesi",
  },
  {
    label: "Bond University",
    value: "Bond University",
  },
  {
    label: "Bordeaux INP",
    value: "Bordeaux INP",
  },
  {
    label: "Boricua College",
    value: "Boricua College",
  },
  {
    label: "Borno State University",
    value: "Borno State University",
  },
  {
    label: "Borys Grinchenko Kyiv University",
    value: "Borys Grinchenko Kyiv University",
  },
  {
    label: "Bost University",
    value: "Bost University",
  },
  {
    label: "Boston Architectural College",
    value: "Boston Architectural College",
  },
  {
    label: "Boston College",
    value: "Boston College",
  },
  {
    label: "Boston Graduate School of Psychoanalysis",
    value: "Boston Graduate School of Psychoanalysis",
  },
  {
    label: "Boston University",
    value: "Boston University",
  },
  {
    label: "Botho University",
    value: "Botho University",
  },
  {
    label: "Botswana Accountancy College",
    value: "Botswana Accountancy College",
  },
  {
    label: "Botswana International University of Science and Technology",
    value: "Botswana International University of Science and Technology",
  },
  {
    label: "Botswana University of Agriculture and Natural Resources",
    value: "Botswana University of Agriculture and Natural Resources",
  },
  {
    label: "Bournemouth University",
    value: "Bournemouth University",
  },
  {
    label: "Bowdoin College",
    value: "Bowdoin College",
  },
  {
    label: "Bowen University",
    value: "Bowen University",
  },
  {
    label: "Bowie State University",
    value: "Bowie State University",
  },
  {
    label: "Bowling Green State University",
    value: "Bowling Green State University",
  },
  {
    label: "Bozhou University",
    value: "Bozhou University",
  },
  {
    label: "Bozorgmehr University of Qaenat",
    value: "Bozorgmehr University of Qaenat",
  },
  {
    label: "BPP University",
    value: "BPP University",
  },
  {
    label: "BRAC University",
    value: "BRAC University",
  },
  {
    label: "Bradley University",
    value: "Bradley University",
  },
  {
    label: "Brainware University",
    value: "Brainware University",
  },
  {
    label: "Brand University of Applied Sciences",
    value: "Brand University of Applied Sciences",
  },
  {
    label: "Brandeis University",
    value: "Brandeis University",
  },
  {
    label: "Brandenburgische Technische Universität Cottbus-Senftenberg",
    value: "Brandenburgische Technische Universität Cottbus-Senftenberg",
  },
  {
    label: "Brandon University",
    value: "Brandon University",
  },
  {
    label: "Bratislavská medzinárodná škola liberálnych štúdií",
    value: "Bratislavská medzinárodná škola liberálnych štúdií",
  },
  {
    label: "Bratsk State University",
    value: "Bratsk State University",
  },
  {
    label: "Brazosport College",
    value: "Brazosport College",
  },
  {
    label: "Breda University of Applied Sciences",
    value: "Breda University of Applied Sciences",
  },
  {
    label: "Brenau University",
    value: "Brenau University",
  },
  {
    label: "Brescia University",
    value: "Brescia University",
  },
  {
    label: "Brest Business School",
    value: "Brest Business School",
  },
  {
    label: "Brest State Technical University",
    value: "Brest State Technical University",
  },
  {
    label: "Brest State University",
    value: "Brest State University",
  },
  {
    label: "Brevard College",
    value: "Brevard College",
  },
  {
    label: "Brewton-Parker College",
    value: "Brewton-Parker College",
  },
  {
    label: "Briar Cliff University",
    value: "Briar Cliff University",
  },
  {
    label: "Bridgewater College",
    value: "Bridgewater College",
  },
  {
    label: "Bridgewater State University",
    value: "Bridgewater State University",
  },
  {
    label: "Brigham Young University",
    value: "Brigham Young University",
  },
  {
    label: "Brigham Young University-Hawaii",
    value: "Brigham Young University-Hawaii",
  },
  {
    label: "Brigham Young University-Idaho",
    value: "Brigham Young University-Idaho",
  },
  {
    label: "Bright Star University",
    value: "Bright Star University",
  },
  {
    label: "Britannia University",
    value: "Britannia University",
  },
  {
    label: "British Columbia Institute of Technology",
    value: "British Columbia Institute of Technology",
  },
  {
    label: "British University in Yemen",
    value: "British University in Yemen",
  },
  {
    label: "Brock University",
    value: "Brock University",
  },
  {
    label: "Brook Besor University",
    value: "Brook Besor University",
  },
  {
    label: "Brooklyn College",
    value: "Brooklyn College",
  },
  {
    label: "Brooklyn Law School",
    value: "Brooklyn Law School",
  },
  {
    label: "Broward College",
    value: "Broward College",
  },
  {
    label: "Brown University",
    value: "Brown University",
  },
  {
    label: "Brunel University London",
    value: "Brunel University London",
  },
  {
    label: "Brussels School of Governance",
    value: "Brussels School of Governance",
  },
  {
    label: "Bryan College",
    value: "Bryan College",
  },
  {
    label: "Bryan College of Health Sciences",
    value: "Bryan College of Health Sciences",
  },
  {
    label: "Bryansk State Agrarian University",
    value: "Bryansk State Agrarian University",
  },
  {
    label: "Bryansk State Technical University",
    value: "Bryansk State Technical University",
  },
  {
    label: "Bryansk State University",
    value: "Bryansk State University",
  },
  {
    label: "Bryant and Stratton College",
    value: "Bryant and Stratton College",
  },
  {
    label: "Bryant University",
    value: "Bryant University",
  },
  {
    label: "Bryn Athyn College",
    value: "Bryn Athyn College",
  },
  {
    label: "Bryn Mawr College",
    value: "Bryn Mawr College",
  },
  {
    label: "BSP Business School Berlin",
    value: "BSP Business School Berlin",
  },
  {
    label: "Bu-Ali Sina University",
    value: "Bu-Ali Sina University",
  },
  {
    label: "Bucerius Law School",
    value: "Bucerius Law School",
  },
  {
    label: "Buckinghamshire New University",
    value: "Buckinghamshire New University",
  },
  {
    label: "Bucknell University",
    value: "Bucknell University",
  },
  {
    label: "Budapesti Corvinus Egyetem",
    value: "Budapesti Corvinus Egyetem",
  },
  {
    label: "Budapesti Gazdasági Egyetem",
    value: "Budapesti Gazdasági Egyetem",
  },
  {
    label: "Budapesti Metropolitan Egyetem",
    value: "Budapesti Metropolitan Egyetem",
  },
  {
    label: "Budapesti Muszaki és Gazdaságtudományi Egyetem",
    value: "Budapesti Muszaki és Gazdaságtudományi Egyetem",
  },
  {
    label: "Buddhist and Pali University",
    value: "Buddhist and Pali University",
  },
  {
    label: "Buena Vista University",
    value: "Buena Vista University",
  },
  {
    label: "Buffalo State University",
    value: "Buffalo State University",
  },
  {
    label: "Bugema University",
    value: "Bugema University",
  },
  {
    label: "Build Bright University",
    value: "Build Bright University",
  },
  {
    label: "BUILDERS École d'ingénieurs",
    value: "BUILDERS École d'ingénieurs",
  },
  {
    label: "Bujumbura International University",
    value: "Bujumbura International University",
  },
  {
    label: "Bukidnon State University",
    value: "Bukidnon State University",
  },
  {
    label: "Bukkyo University",
    value: "Bukkyo University",
  },
  {
    label: "Bukovinian State Medical University",
    value: "Bukovinian State Medical University",
  },
  {
    label: "Bulacan Agricultural State College",
    value: "Bulacan Agricultural State College",
  },
  {
    label: "Bulacan State University",
    value: "Bulacan State University",
  },
  {
    label: "Bule Hora University",
    value: "Bule Hora University",
  },
  {
    label: "Bundelkhand University",
    value: "Bundelkhand University",
  },
  {
    label: "Bunka Fashion Graduate University",
    value: "Bunka Fashion Graduate University",
  },
  {
    label: "Bunka Gakuen University",
    value: "Bunka Gakuen University",
  },
  {
    label: "Bunkyo Gakuin University",
    value: "Bunkyo Gakuin University",
  },
  {
    label: "Bunkyo University",
    value: "Bunkyo University",
  },
  {
    label: "Bunri University of Hospitality",
    value: "Bunri University of Hospitality",
  },
  {
    label: "Bunsei University of Art",
    value: "Bunsei University of Art",
  },
  {
    label: "Burapha University",
    value: "Burapha University",
  },
  {
    label: "Burdur Mehmet Akif Ersoy Üniversitesi",
    value: "Burdur Mehmet Akif Ersoy Üniversitesi",
  },
  {
    label: "Burg Giebichenstein Kunsthochschule Halle",
    value: "Burg Giebichenstein Kunsthochschule Halle",
  },
  {
    label: "Burgas Free University",
    value: "Burgas Free University",
  },
  {
    label: "Burgundy School of Business",
    value: "Burgundy School of Business",
  },
  {
    label: "Buriram Rajabhat University",
    value: "Buriram Rajabhat University",
  },
  {
    label: "Burman University",
    value: "Burman University",
  },
  {
    label: "Bursa Teknik Üniversitesi",
    value: "Bursa Teknik Üniversitesi",
  },
  {
    label: "Buryat State Academy of Agriculture",
    value: "Buryat State Academy of Agriculture",
  },
  {
    label: "Busan National University of Education",
    value: "Busan National University of Education",
  },
  {
    label: "Busan Presbyterian University",
    value: "Busan Presbyterian University",
  },
  {
    label: "Busan University of Foreign Studies",
    value: "Busan University of Foreign Studies",
  },
  {
    label: "Busan Women's College",
    value: "Busan Women's College",
  },
  {
    label: "Bushehr University of Medical Sciences",
    value: "Bushehr University of Medical Sciences",
  },
  {
    label: "Bushnell University",
    value: "Bushnell University",
  },
  {
    label: "Business and Technology University",
    value: "Business and Technology University",
  },
  {
    label: "Business Breakthrough University",
    value: "Business Breakthrough University",
  },
  {
    label: "Busitema University",
    value: "Busitema University",
  },
  {
    label: "Busoga University",
    value: "Busoga University",
  },
  {
    label: "Butler University",
    value: "Butler University",
  },
  {
    label: "Buxoro Davlat Universiteti",
    value: "Buxoro Davlat Universiteti",
  },
  {
    label: "Buxoro innovatsion tibbiyot instituti",
    value: "Buxoro innovatsion tibbiyot instituti",
  },
  {
    label: "Buxoro muhandislik-texnologiya instituti",
    value: "Buxoro muhandislik-texnologiya instituti",
  },
  {
    label: "Buxoro psixologiya va xorijiy tillar instituti",
    value: "Buxoro psixologiya va xorijiy tillar instituti",
  },
  {
    label: "C.D.A. College",
    value: "C.D.A. College",
  },
  {
    label: "C.K. Tedam University of Technology and Applied Sciences",
    value: "C.K. Tedam University of Technology and Applied Sciences",
  },
  {
    label: "C.U. Shah University",
    value: "C.U. Shah University",
  },
  {
    label: "Cabarrus College of Health Sciences",
    value: "Cabarrus College of Health Sciences",
  },
  {
    label: "Cabrini University",
    value: "Cabrini University",
  },
  {
    label: "Çag Üniversitesi",
    value: "Çag Üniversitesi",
  },
  {
    label: "Cagayan State University",
    value: "Cagayan State University",
  },
  {
    label: "Cairn University",
    value: "Cairn University",
  },
  {
    label: "Cairo University",
    value: "Cairo University",
  },
  {
    label: "Caldwell University",
    value: "Caldwell University",
  },
  {
    label: "Caleb University",
    value: "Caleb University",
  },
  {
    label: "California Baptist University",
    value: "California Baptist University",
  },
  {
    label: "California College of the Arts",
    value: "California College of the Arts",
  },
  {
    label: "California Institute of Integral Studies",
    value: "California Institute of Integral Studies",
  },
  {
    label: "California Institute of Technology",
    value: "California Institute of Technology",
  },
  {
    label: "California Institute of the Arts",
    value: "California Institute of the Arts",
  },
  {
    label: "California Lutheran University",
    value: "California Lutheran University",
  },
  {
    label: "California Polytechnic State University, San Luis Obispo",
    value: "California Polytechnic State University, San Luis Obispo",
  },
  {
    label: "California State Polytechnic University, Pomona",
    value: "California State Polytechnic University, Pomona",
  },
  {
    label: "California State University Channel Islands",
    value: "California State University Channel Islands",
  },
  {
    label: "California State University Maritime Academy",
    value: "California State University Maritime Academy",
  },
  {
    label: "California State University San Marcos",
    value: "California State University San Marcos",
  },
  {
    label: "California State University, Bakersfield",
    value: "California State University, Bakersfield",
  },
  {
    label: "California State University, Chico",
    value: "California State University, Chico",
  },
  {
    label: "California State University, Dominguez Hills",
    value: "California State University, Dominguez Hills",
  },
  {
    label: "California State University, East Bay",
    value: "California State University, East Bay",
  },
  {
    label: "California State University, Fresno",
    value: "California State University, Fresno",
  },
  {
    label: "California State University, Fullerton",
    value: "California State University, Fullerton",
  },
  {
    label: "California State University, Long Beach",
    value: "California State University, Long Beach",
  },
  {
    label: "California State University, Los Angeles",
    value: "California State University, Los Angeles",
  },
  {
    label: "California State University, Monterey Bay",
    value: "California State University, Monterey Bay",
  },
  {
    label: "California State University, Northridge",
    value: "California State University, Northridge",
  },
  {
    label: "California State University, Sacramento",
    value: "California State University, Sacramento",
  },
  {
    label: "California State University, San Bernardino",
    value: "California State University, San Bernardino",
  },
  {
    label: "California State University, Stanislaus",
    value: "California State University, Stanislaus",
  },
  {
    label: "California Western School of Law",
    value: "California Western School of Law",
  },
  {
    label: "Calumet College of St. Joseph",
    value: "Calumet College of St. Joseph",
  },
  {
    label: "Calvary University",
    value: "Calvary University",
  },
  {
    label: "Calvin University",
    value: "Calvin University",
  },
  {
    label: "Calvin University",
    value: "Calvin University",
  },
  {
    label: "Camarines Norte State College",
    value: "Camarines Norte State College",
  },
  {
    label: "Camarines Sur Polytechnic Colleges",
    value: "Camarines Sur Polytechnic Colleges",
  },
  {
    label: "Cambodia University for Specialties",
    value: "Cambodia University for Specialties",
  },
  {
    label: "Cambodian Mekong University",
    value: "Cambodian Mekong University",
  },
  {
    label: "Cambridge College",
    value: "Cambridge College",
  },
  {
    label: "CamEd Business School",
    value: "CamEd Business School",
  },
  {
    label: "Cameron University",
    value: "Cameron University",
  },
  {
    label: "Campbell University",
    value: "Campbell University",
  },
  {
    label: "Campbellsville University",
    value: "Campbellsville University",
  },
  {
    label: "Campion College at the University of Regina",
    value: "Campion College at the University of Regina",
  },
  {
    label: "CAMPUS 02 Fachhochschule der Wirtschaft",
    value: "CAMPUS 02 Fachhochschule der Wirtschaft",
  },
  {
    label: "Campus Adventiste du Salève",
    value: "Campus Adventiste du Salève",
  },
  {
    label: "Can Tho University",
    value: "Can Tho University",
  },
  {
    label: "Canadian Mennonite University",
    value: "Canadian Mennonite University",
  },
  {
    label: "Canadian University of Bangladesh",
    value: "Canadian University of Bangladesh",
  },
  {
    label: "Canadian University of Dubai",
    value: "Canadian University of Dubai",
  },
  {
    label: "Çanakkale Onsekiz Mart Üniversitesi",
    value: "Çanakkale Onsekiz Mart Üniversitesi",
  },
  {
    label: "Cangzhou Normal University",
    value: "Cangzhou Normal University",
  },
  {
    label: "Canisius University",
    value: "Canisius University",
  },
  {
    label: "Çankaya Üniversitesi",
    value: "Çankaya Üniversitesi",
  },
  {
    label: "Çankiri Karatekin Üniversitesi",
    value: "Çankiri Karatekin Üniversitesi",
  },
  {
    label: "Canterbury Christ Church University",
    value: "Canterbury Christ Church University",
  },
  {
    label: "Cape Breton University",
    value: "Cape Breton University",
  },
  {
    label: "Cape Coast Technical University",
    value: "Cape Coast Technical University",
  },
  {
    label: "Cape Peninsula University of Technology",
    value: "Cape Peninsula University of Technology",
  },
  {
    label: "Capilano University",
    value: "Capilano University",
  },
  {
    label: "Capital Medical University",
    value: "Capital Medical University",
  },
  {
    label: "Capital Normal University",
    value: "Capital Normal University",
  },
  {
    label: "Capital University",
    value: "Capital University",
  },
  {
    label: "Capital University of Economics and Business",
    value: "Capital University of Economics and Business",
  },
  {
    label: "Capital University of Physical Education and Sports",
    value: "Capital University of Physical Education and Sports",
  },
  {
    label: "Capital University of Science and Technology",
    value: "Capital University of Science and Technology",
  },
  {
    label: "Capitol Technology University",
    value: "Capitol Technology University",
  },
  {
    label: "Capitol University",
    value: "Capitol University",
  },
  {
    label: "Capiz State University",
    value: "Capiz State University",
  },
  {
    label: "Caraga State University",
    value: "Caraga State University",
  },
  {
    label: "Cardiff Metropolitan University",
    value: "Cardiff Metropolitan University",
  },
  {
    label: "Cardiff University",
    value: "Cardiff University",
  },
  {
    label: "Cardinal Stritch University",
    value: "Cardinal Stritch University",
  },
  {
    label: "Career Point University",
    value: "Career Point University",
  },
  {
    label: "Caribbean Maritime University",
    value: "Caribbean Maritime University",
  },
  {
    label: "Caribbean Nazarene College",
    value: "Caribbean Nazarene College",
  },
  {
    label: "Caribbean University",
    value: "Caribbean University",
  },
  {
    label: "Caritas University",
    value: "Caritas University",
  },
  {
    label: "Carl von Ossietzky Universität Oldenburg",
    value: "Carl von Ossietzky Universität Oldenburg",
  },
  {
    label: "Carleton College",
    value: "Carleton College",
  },
  {
    label: "Carleton University",
    value: "Carleton University",
  },
  {
    label: "Carlow College",
    value: "Carlow College",
  },
  {
    label: "Carlow University",
    value: "Carlow University",
  },
  {
    label: "Carnegie Mellon University",
    value: "Carnegie Mellon University",
  },
  {
    label: "Carnegie Mellon University in Qatar",
    value: "Carnegie Mellon University in Qatar",
  },
  {
    label: "Carolina University",
    value: "Carolina University",
  },
  {
    label: "Carroll College",
    value: "Carroll College",
  },
  {
    label: "Carroll University",
    value: "Carroll University",
  },
  {
    label: "Carson-Newman University",
    value: "Carson-Newman University",
  },
  {
    label: "Carthage College",
    value: "Carthage College",
  },
  {
    label: "Casa College",
    value: "Casa College",
  },
  {
    label: "Case Western Reserve University",
    value: "Case Western Reserve University",
  },
  {
    label: "Caspian State University of Technologies and Engineering",
    value: "Caspian State University of Technologies and Engineering",
  },
  {
    label: "Caspian University",
    value: "Caspian University",
  },
  {
    label: "Catanduanes State University",
    value: "Catanduanes State University",
  },
  {
    label: "Catawba College",
    value: "Catawba College",
  },
  {
    label: "Catholic Institute of Business and Technology",
    value: "Catholic Institute of Business and Technology",
  },
  {
    label: "Catholic Kwandong University",
    value: "Catholic Kwandong University",
  },
  {
    label: "Catholic University College of Ghana",
    value: "Catholic University College of Ghana",
  },
  {
    label: "Catholic University in Erbil",
    value: "Catholic University in Erbil",
  },
  {
    label: "Catholic University of Cameroon",
    value: "Catholic University of Cameroon",
  },
  {
    label: "Catholic University of Daegu",
    value: "Catholic University of Daegu",
  },
  {
    label: "Catholic University of Daejeon",
    value: "Catholic University of Daejeon",
  },
  {
    label: "Catholic University of Health and Allied Sciences",
    value: "Catholic University of Health and Allied Sciences",
  },
  {
    label: "Catholic University of Pusan",
    value: "Catholic University of Pusan",
  },
  {
    label: "Catholic University of Rwanda",
    value: "Catholic University of Rwanda",
  },
  {
    label: "Catholic University of Zimbabwe",
    value: "Catholic University of Zimbabwe",
  },
  {
    label: "Caucasus International University",
    value: "Caucasus International University",
  },
  {
    label: "Caucasus University",
    value: "Caucasus University",
  },
  {
    label: "Cavendish University Uganda",
    value: "Cavendish University Uganda",
  },
  {
    label: "Cavendish University Zambia",
    value: "Cavendish University Zambia",
  },
  {
    label: "Cavite State University",
    value: "Cavite State University",
  },
  {
    label: "Cazenovia College",
    value: "Cazenovia College",
  },
  {
    label: "CBS International Business School",
    value: "CBS International Business School",
  },
  {
    label: "CCN University of Science and Technology",
    value: "CCN University of Science and Technology",
  },
  {
    label: "Cebu Doctors' University",
    value: "Cebu Doctors' University",
  },
  {
    label: "Cebu Institute of Medicine",
    value: "Cebu Institute of Medicine",
  },
  {
    label: "Cebu Institute of Technology",
    value: "Cebu Institute of Technology",
  },
  {
    label: "Cebu Normal University",
    value: "Cebu Normal University",
  },
  {
    label: "Cebu Technological University",
    value: "Cebu Technological University",
  },
  {
    label: "CECOS University",
    value: "CECOS University",
  },
  {
    label: "Cedar Crest College",
    value: "Cedar Crest College",
  },
  {
    label: "Cedarville University",
    value: "Cedarville University",
  },
  {
    label: "Centenary College of Louisiana",
    value: "Centenary College of Louisiana",
  },
  {
    label: "Centenary University",
    value: "Centenary University",
  },
  {
    label: "Central Agricultural University",
    value: "Central Agricultural University",
  },
  {
    label: "Central America Health Sciences University, Belize Medical College",
    value: "Central America Health Sciences University, Belize Medical College",
  },
  {
    label: "Central Baptist College",
    value: "Central Baptist College",
  },
  {
    label: "Central China Normal University",
    value: "Central China Normal University",
  },
  {
    label: "Central Christian College of Kansas",
    value: "Central Christian College of Kansas",
  },
  {
    label: "Central Christian College of the Bible",
    value: "Central Christian College of the Bible",
  },
  {
    label: "Central College",
    value: "Central College",
  },
  {
    label: "Central Colleges of the Philippines",
    value: "Central Colleges of the Philippines",
  },
  {
    label: "Central Connecticut State University",
    value: "Central Connecticut State University",
  },
  {
    label: "Central Conservatory of Music",
    value: "Central Conservatory of Music",
  },
  {
    label: "Central Institute of Fisheries Education",
    value: "Central Institute of Fisheries Education",
  },
  {
    label: "Central Institute of Higher Tibetan Studies",
    value: "Central Institute of Higher Tibetan Studies",
  },
  {
    label: "Central Kazakhstan Academy",
    value: "Central Kazakhstan Academy",
  },
  {
    label: "Central Luzon State University",
    value: "Central Luzon State University",
  },
  {
    label: "Central Methodist University",
    value: "Central Methodist University",
  },
  {
    label: "Central Michigan University",
    value: "Central Michigan University",
  },
  {
    label: "Central Mindanao University",
    value: "Central Mindanao University",
  },
  {
    label: "Central Penn College",
    value: "Central Penn College",
  },
  {
    label: "Central Philippine Adventist College",
    value: "Central Philippine Adventist College",
  },
  {
    label: "Central Philippine University",
    value: "Central Philippine University",
  },
  {
    label: "Central Queensland University",
    value: "Central Queensland University",
  },
  {
    label: "Central South University",
    value: "Central South University",
  },
  {
    label: "Central South University of Forestry and Technology",
    value: "Central South University of Forestry and Technology",
  },
  {
    label: "Central State University",
    value: "Central State University",
  },
  {
    label: "Central Taiwan University of Science and Technology",
    value: "Central Taiwan University of Science and Technology",
  },
  {
    label:
      "Central Ukrainian State University named after Volodymyr Vinnichenko",
    value:
      "Central Ukrainian State University named after Volodymyr Vinnichenko",
  },
  {
    label: "Central University",
    value: "Central University",
  },
  {
    label: "Central University of Andhra Pradesh",
    value: "Central University of Andhra Pradesh",
  },
  {
    label: "Central University of Finance and Economics",
    value: "Central University of Finance and Economics",
  },
  {
    label: "Central University of Gujarat",
    value: "Central University of Gujarat",
  },
  {
    label: "Central University of Haryana",
    value: "Central University of Haryana",
  },
  {
    label: "Central University of Himachal Pradesh",
    value: "Central University of Himachal Pradesh",
  },
  {
    label: "Central University of Jammu",
    value: "Central University of Jammu",
  },
  {
    label: "Central University of Jharkhand",
    value: "Central University of Jharkhand",
  },
  {
    label: "Central University of Karnataka",
    value: "Central University of Karnataka",
  },
  {
    label: "Central University of Kashmir",
    value: "Central University of Kashmir",
  },
  {
    label: "Central University of Kerala",
    value: "Central University of Kerala",
  },
  {
    label: "Central University of Odisha",
    value: "Central University of Odisha",
  },
  {
    label: "Central University of Punjab",
    value: "Central University of Punjab",
  },
  {
    label: "Central University of Rajasthan",
    value: "Central University of Rajasthan",
  },
  {
    label: "Central University of Science and Technology",
    value: "Central University of Science and Technology",
  },
  {
    label: "Central University of South Bihar",
    value: "Central University of South Bihar",
  },
  {
    label: "Central University of Tamil Nadu",
    value: "Central University of Tamil Nadu",
  },
  {
    label: "Central University of Technology",
    value: "Central University of Technology",
  },
  {
    label: "Central Washington University",
    value: "Central Washington University",
  },
  {
    label: "Central Women's University",
    value: "Central Women's University",
  },
  {
    label: "Centrale Lille",
    value: "Centrale Lille",
  },
  {
    label: "Centrale Méditerranée",
    value: "Centrale Méditerranée",
  },
  {
    label: "CentraleSupélec",
    value: "CentraleSupélec",
  },
  {
    label: "Centralia College",
    value: "Centralia College",
  },
  {
    label: "Centre College",
    value: "Centre College",
  },
  {
    label: "Centria ammattikorkeakoulu",
    value: "Centria ammattikorkeakoulu",
  },
  {
    label: "Centro de Diseño, Arquitectura y Construcción",
    value: "Centro de Diseño, Arquitectura y Construcción",
  },
  {
    label: "Centro de Estudios Avanzados de Puerto Rico y El Caribe",
    value: "Centro de Estudios Avanzados de Puerto Rico y El Caribe",
  },
  {
    label: "Centro de Estudios Superiores de Diseño de Monterrey S.C.",
    value: "Centro de Estudios Superiores de Diseño de Monterrey S.C.",
  },
  {
    label: "Centro de Estudios Superiores de San Ángel S.C.",
    value: "Centro de Estudios Superiores de San Ángel S.C.",
  },
  {
    label: "Centro de Estudios Superiores del Noroeste",
    value: "Centro de Estudios Superiores del Noroeste",
  },
  {
    label: "Centro de Estudios Universitarios",
    value: "Centro de Estudios Universitarios",
  },
  {
    label: "Centro de Estudios Universitarios Xochicalco",
    value: "Centro de Estudios Universitarios Xochicalco",
  },
  {
    label: "Centro de Investigación y Docencia Económicas",
    value: "Centro de Investigación y Docencia Económicas",
  },
  {
    label: "Centro Escolar University",
    value: "Centro Escolar University",
  },
  {
    label: "Centro Universitario de Integración Humanística A.C.",
    value: "Centro Universitario de Integración Humanística A.C.",
  },
  {
    label: "Centurion University of Technology and Management",
    value: "Centurion University of Technology and Management",
  },
  {
    label: "CEPS-Centar za poslovne studije",
    value: "CEPS-Centar za poslovne studije",
  },
  {
    label: "CEPT University",
    value: "CEPT University",
  },
  {
    label: "CESI École d'Ingénieurs",
    value: "CESI École d'Ingénieurs",
  },
  {
    label: "Ceská zemedelská univerzita v Praze",
    value: "Ceská zemedelská univerzita v Praze",
  },
  {
    label: "Ceské vysoké ucení technické v Praze",
    value: "Ceské vysoké ucení technické v Praze",
  },
  {
    label: "CETYS Universidad",
    value: "CETYS Universidad",
  },
  {
    label: "CEVRO Institut",
    value: "CEVRO Institut",
  },
  {
    label: "CHA University",
    value: "CHA University",
  },
  {
    label: "Chabahar Maritime University",
    value: "Chabahar Maritime University",
  },
  {
    label: "Chadron State College",
    value: "Chadron State College",
  },
  {
    label: "Chaiyaphum Rajabhat University",
    value: "Chaiyaphum Rajabhat University",
  },
  {
    label: "Chalermkarnchana University",
    value: "Chalermkarnchana University",
  },
  {
    label: "Chalimbana University",
    value: "Chalimbana University",
  },
  {
    label: "Chalmers tekniska högskola",
    value: "Chalmers tekniska högskola",
  },
  {
    label: "Chamberlain University",
    value: "Chamberlain University",
  },
  {
    label: "Chaminade University of Honolulu",
    value: "Chaminade University of Honolulu",
  },
  {
    label: "Champlain College",
    value: "Champlain College",
  },
  {
    label: "Chanakya National Law University",
    value: "Chanakya National Law University",
  },
  {
    label: "Chandigarh University",
    value: "Chandigarh University",
  },
  {
    label: "Chandra Shekhar Azad University of Agriculture and Technology",
    value: "Chandra Shekhar Azad University of Agriculture and Technology",
  },
  {
    label: "Chandrakasem Rajabhat University",
    value: "Chandrakasem Rajabhat University",
  },
  {
    label: "Chang Gung University",
    value: "Chang Gung University",
  },
  {
    label: "Chang Gung University of Science and Technology",
    value: "Chang Gung University of Science and Technology",
  },
  {
    label: "Chang Jung Christian University",
    value: "Chang Jung Christian University",
  },
  {
    label: "Chang'an University",
    value: "Chang'an University",
  },
  {
    label: "Changchun Architecture and Civil Engineering College",
    value: "Changchun Architecture and Civil Engineering College",
  },
  {
    label: "Changchun Guanghua University",
    value: "Changchun Guanghua University",
  },
  {
    label: "Changchun Institute of Technology",
    value: "Changchun Institute of Technology",
  },
  {
    label: "Changchun Normal University",
    value: "Changchun Normal University",
  },
  {
    label: "Changchun University",
    value: "Changchun University",
  },
  {
    label: "Changchun University of Chinese Medicine",
    value: "Changchun University of Chinese Medicine",
  },
  {
    label: "Changchun University of Finance and Economics",
    value: "Changchun University of Finance and Economics",
  },
  {
    label: "Changchun University of Science and Technology",
    value: "Changchun University of Science and Technology",
  },
  {
    label: "Changchun University of Science and Technology",
    value: "Changchun University of Science and Technology",
  },
  {
    label: "Changchun University of Technology",
    value: "Changchun University of Technology",
  },
  {
    label: "Changji University",
    value: "Changji University",
  },
  {
    label: "Changsha Medical University",
    value: "Changsha Medical University",
  },
  {
    label: "Changsha Normal University",
    value: "Changsha Normal University",
  },
  {
    label: "Changsha University",
    value: "Changsha University",
  },
  {
    label: "Changsha University of Science and Technology",
    value: "Changsha University of Science and Technology",
  },
  {
    label: "Changshu Institute of Technology",
    value: "Changshu Institute of Technology",
  },
  {
    label: "Changwon National University",
    value: "Changwon National University",
  },
  {
    label: "Changzhi Medical College",
    value: "Changzhi Medical College",
  },
  {
    label: "Changzhi University",
    value: "Changzhi University",
  },
  {
    label: "Changzhou Institute of Technology",
    value: "Changzhou Institute of Technology",
  },
  {
    label: "Changzhou University",
    value: "Changzhou University",
  },
  {
    label: "Chaohu University",
    value: "Chaohu University",
  },
  {
    label: "Chaopraya University",
    value: "Chaopraya University",
  },
  {
    label: "Chaoyang University of Technology",
    value: "Chaoyang University of Technology",
  },
  {
    label: "Chapman University",
    value: "Chapman University",
  },
  {
    label: "Charité - Universitätsmedizin Berlin",
    value: "Charité - Universitätsmedizin Berlin",
  },
  {
    label: "Charles Darwin University",
    value: "Charles Darwin University",
  },
  {
    label: "Charles R. Drew University of Medicine and Science",
    value: "Charles R. Drew University of Medicine and Science",
  },
  {
    label: "Charles Sturt University",
    value: "Charles Sturt University",
  },
  {
    label: "Charleston Southern University",
    value: "Charleston Southern University",
  },
  {
    label: "Charmo University",
    value: "Charmo University",
  },
  {
    label: "Charotar University of Science and Technology",
    value: "Charotar University of Science and Technology",
  },
  {
    label: "Chatham University",
    value: "Chatham University",
  },
  {
    label: "Chaudhary Bansi Lal University",
    value: "Chaudhary Bansi Lal University",
  },
  {
    label: "Chaudhary Charan Singh Haryana Agricultural University",
    value: "Chaudhary Charan Singh Haryana Agricultural University",
  },
  {
    label: "Chaudhary Charan Singh University",
    value: "Chaudhary Charan Singh University",
  },
  {
    label: "Chaudhary Devi Lal University",
    value: "Chaudhary Devi Lal University",
  },
  {
    label: "Chaudhary Ranbir Singh University",
    value: "Chaudhary Ranbir Singh University",
  },
  {
    label: "Chea Sim University of Kamchaymear",
    value: "Chea Sim University of Kamchaymear",
  },
  {
    label: "Chechen State University",
    value: "Chechen State University",
  },
  {
    label: "Chelyabinsk State Pedagogical University",
    value: "Chelyabinsk State Pedagogical University",
  },
  {
    label: "Chelyabinsk State University",
    value: "Chelyabinsk State University",
  },
  {
    label: "Cheng Shiu University",
    value: "Cheng Shiu University",
  },
  {
    label: "Chengde Medical University",
    value: "Chengde Medical University",
  },
  {
    label: "Chengdu College of Arts and Sciences",
    value: "Chengdu College of Arts and Sciences",
  },
  {
    label: "Chengdu Medical College",
    value: "Chengdu Medical College",
  },
  {
    label: "Chengdu Neusoft University",
    value: "Chengdu Neusoft University",
  },
  {
    label: "Chengdu Normal University",
    value: "Chengdu Normal University",
  },
  {
    label: "Chengdu Sport University",
    value: "Chengdu Sport University",
  },
  {
    label: "Chengdu Technological University",
    value: "Chengdu Technological University",
  },
  {
    label: "Chengdu University",
    value: "Chengdu University",
  },
  {
    label: "Chengdu University of Information Technology",
    value: "Chengdu University of Information Technology",
  },
  {
    label: "Chengdu University of Technology",
    value: "Chengdu University of Technology",
  },
  {
    label: "Chengdu University of Traditional Chinese Medicine",
    value: "Chengdu University of Traditional Chinese Medicine",
  },
  {
    label: "Chenla University",
    value: "Chenla University",
  },
  {
    label: "Chennai Mathematical Institute",
    value: "Chennai Mathematical Institute",
  },
  {
    label: "Cheongju National University of Education",
    value: "Cheongju National University of Education",
  },
  {
    label: "Cheongju University",
    value: "Cheongju University",
  },
  {
    label: "Cheragh Medical Institute",
    value: "Cheragh Medical Institute",
  },
  {
    label: "Cherepovets State University",
    value: "Cherepovets State University",
  },
  {
    label: "Cherkasy State Business College",
    value: "Cherkasy State Business College",
  },
  {
    label: "Cherkasy State Technological University",
    value: "Cherkasy State Technological University",
  },
  {
    label: "Chernihiv Polytechnic National University",
    value: "Chernihiv Polytechnic National University",
  },
  {
    label: "Chestnut Hill College",
    value: "Chestnut Hill College",
  },
  {
    label: "Cheyney University of Pennsylvania",
    value: "Cheyney University of Pennsylvania",
  },
  {
    label: "Chhatrapati Shahu Ji Maharaj University",
    value: "Chhatrapati Shahu Ji Maharaj University",
  },
  {
    label: "Chhattisgarh Kamdhenu Vishwavidyalaya",
    value: "Chhattisgarh Kamdhenu Vishwavidyalaya",
  },
  {
    label: "Chhattisgarh Swami Vivekananda Technical University",
    value: "Chhattisgarh Swami Vivekananda Technical University",
  },
  {
    label: "Chia Nan University of Pharmacy and Science",
    value: "Chia Nan University of Pharmacy and Science",
  },
  {
    label: "Chiang Kai Shek College",
    value: "Chiang Kai Shek College",
  },
  {
    label: "Chiang Mai Rajabhat University",
    value: "Chiang Mai Rajabhat University",
  },
  {
    label: "Chiang Mai University",
    value: "Chiang Mai University",
  },
  {
    label: "Chiang Rai Rajabhat University",
    value: "Chiang Rai Rajabhat University",
  },
  {
    label: "Chiba Institute of Science",
    value: "Chiba Institute of Science",
  },
  {
    label: "Chiba Institute of Technology",
    value: "Chiba Institute of Technology",
  },
  {
    label: "Chiba Keizai University",
    value: "Chiba Keizai University",
  },
  {
    label: "Chiba Prefectural University of Health Sciences",
    value: "Chiba Prefectural University of Health Sciences",
  },
  {
    label: "Chiba University",
    value: "Chiba University",
  },
  {
    label: "Chiba University of Commerce",
    value: "Chiba University of Commerce",
  },
  {
    label: "Chicago State University",
    value: "Chicago State University",
  },
  {
    label: "Chien Hsin University of Science and Technology",
    value: "Chien Hsin University of Science and Technology",
  },
  {
    label: "Chienkuo Technology University",
    value: "Chienkuo Technology University",
  },
  {
    label: "Chifeng University",
    value: "Chifeng University",
  },
  {
    label: "Chihlee University of Technology",
    value: "Chihlee University of Technology",
  },
  {
    label: "Chikushi Jogakuen University",
    value: "Chikushi Jogakuen University",
  },
  {
    label: "Children's University",
    value: "Children's University",
  },
  {
    label: "China Academy of Art",
    value: "China Academy of Art",
  },
  {
    label: "China Agricultural University",
    value: "China Agricultural University",
  },
  {
    label: "China Central Academy of Fine Arts",
    value: "China Central Academy of Fine Arts",
  },
  {
    label: "China Conservatory of Music",
    value: "China Conservatory of Music",
  },
  {
    label: "China Europe International Business School",
    value: "China Europe International Business School",
  },
  {
    label: "China Foreign Affairs University",
    value: "China Foreign Affairs University",
  },
  {
    label: "China Jiliang University",
    value: "China Jiliang University",
  },
  {
    label: "China Medical University",
    value: "China Medical University",
  },
  {
    label: "China Medical University, Taiwan",
    value: "China Medical University, Taiwan",
  },
  {
    label: "China Pharmaceutical University",
    value: "China Pharmaceutical University",
  },
  {
    label: "China Three Gorges University",
    value: "China Three Gorges University",
  },
  {
    label: "China University of Geosciences Beijing",
    value: "China University of Geosciences Beijing",
  },
  {
    label: "China University of Geosciences Wuhan",
    value: "China University of Geosciences Wuhan",
  },
  {
    label: "China University of Labor Relations",
    value: "China University of Labor Relations",
  },
  {
    label: "China University of Mining and Technology",
    value: "China University of Mining and Technology",
  },
  {
    label: "China University of Petroleum",
    value: "China University of Petroleum",
  },
  {
    label: "China University of Petroleum",
    value: "China University of Petroleum",
  },
  {
    label: "China University of Political Science and Law",
    value: "China University of Political Science and Law",
  },
  {
    label: "China University of Science and Technology",
    value: "China University of Science and Technology",
  },
  {
    label: "China University of Technology",
    value: "China University of Technology",
  },
  {
    label: "China West Normal University",
    value: "China West Normal University",
  },
  {
    label: "China Women's University",
    value: "China Women's University",
  },
  {
    label: "China Youth University for Political Sciences",
    value: "China Youth University for Political Sciences",
  },
  {
    label: "Chinese Culture University",
    value: "Chinese Culture University",
  },
  {
    label: "Chinhoyi University of Technology",
    value: "Chinhoyi University of Technology",
  },
  {
    label: "Chinju National University of Education",
    value: "Chinju National University of Education",
  },
  {
    label: "Chinzei Gakuin University",
    value: "Chinzei Gakuin University",
  },
  {
    label: "Chipola College",
    value: "Chipola College",
  },
  {
    label: "Chita State Academy of Medicine",
    value: "Chita State Academy of Medicine",
  },
  {
    label: "Chitkara University, Himachal Pradesh",
    value: "Chitkara University, Himachal Pradesh",
  },
  {
    label: "Chitkara University, Punjab",
    value: "Chitkara University, Punjab",
  },
  {
    label: "Chitose Institute of Science and Technology",
    value: "Chitose Institute of Science and Technology",
  },
  {
    label: "Chittagong Independent University",
    value: "Chittagong Independent University",
  },
  {
    label: "Chittagong Medical University",
    value: "Chittagong Medical University",
  },
  {
    label: "Chittagong University of Engineering and Technology",
    value: "Chittagong University of Engineering and Technology",
  },
  {
    label: "Chittagong Veterinary and Animal Sciences University",
    value: "Chittagong Veterinary and Animal Sciences University",
  },
  {
    label: "Chizhou University",
    value: "Chizhou University",
  },
  {
    label: "Chodang University",
    value: "Chodang University",
  },
  {
    label: "Chongjin Medical University",
    value: "Chongjin Medical University",
  },
  {
    label: "Chongjin Metal Mining University",
    value: "Chongjin Metal Mining University",
  },
  {
    label: "Chongjin University of Light Industry",
    value: "Chongjin University of Light Industry",
  },
  {
    label: "Chongjin University of Pedagogy",
    value: "Chongjin University of Pedagogy",
  },
  {
    label: "Chongqing College of Humanities, Science and Technology",
    value: "Chongqing College of Humanities, Science and Technology",
  },
  {
    label: "Chongqing Institute of Engineering",
    value: "Chongqing Institute of Engineering",
  },
  {
    label: "Chongqing Jiaotong University",
    value: "Chongqing Jiaotong University",
  },
  {
    label: "Chongqing Medical University",
    value: "Chongqing Medical University",
  },
  {
    label: "Chongqing Normal University",
    value: "Chongqing Normal University",
  },
  {
    label: "Chongqing Technology and Business University",
    value: "Chongqing Technology and Business University",
  },
  {
    label: "Chongqing Three Gorges University",
    value: "Chongqing Three Gorges University",
  },
  {
    label: "Chongqing University",
    value: "Chongqing University",
  },
  {
    label: "Chongqing University of Arts and Sciences",
    value: "Chongqing University of Arts and Sciences",
  },
  {
    label: "Chongqing University of Education",
    value: "Chongqing University of Education",
  },
  {
    label: "Chongqing University of Posts and Telecommunications",
    value: "Chongqing University of Posts and Telecommunications",
  },
  {
    label: "Chongqing University of Science and Technology",
    value: "Chongqing University of Science and Technology",
  },
  {
    label: "Chongqing University of Technology",
    value: "Chongqing University of Technology",
  },
  {
    label: "Chongshin University",
    value: "Chongshin University",
  },
  {
    label: "Chonnam National University",
    value: "Chonnam National University",
  },
  {
    label: "Chosun University",
    value: "Chosun University",
  },
  {
    label: "Chowan University",
    value: "Chowan University",
  },
  {
    label: "Chreso University",
    value: "Chreso University",
  },
  {
    label: "Chrisland University",
    value: "Chrisland University",
  },
  {
    label: "Christ Apostolic University College",
    value: "Christ Apostolic University College",
  },
  {
    label: "Christ the King College",
    value: "Christ the King College",
  },
  {
    label: "Christ University",
    value: "Christ University",
  },
  {
    label: "Christelijke Hogeschool Ede",
    value: "Christelijke Hogeschool Ede",
  },
  {
    label: "Christian Brothers University",
    value: "Christian Brothers University",
  },
  {
    label: "Christian Service University College",
    value: "Christian Service University College",
  },
  {
    label: "Christian University of Rwanda",
    value: "Christian University of Rwanda",
  },
  {
    label: "Christian University of Thailand",
    value: "Christian University of Thailand",
  },
  {
    label: "Christian-Albrechts-Universität zu Kiel",
    value: "Christian-Albrechts-Universität zu Kiel",
  },
  {
    label: "Christopher Newport University",
    value: "Christopher Newport University",
  },
  {
    label: "Christopher University",
    value: "Christopher University",
  },
  {
    label: "Chrzescijanska Akademia Teologiczna w Warszawie",
    value: "Chrzescijanska Akademia Teologiczna w Warszawie",
  },
  {
    label: "Chu Hai College of Higher Education",
    value: "Chu Hai College of Higher Education",
  },
  {
    label: "Chubu Gakuin University",
    value: "Chubu Gakuin University",
  },
  {
    label: "Chubu University",
    value: "Chubu University",
  },
  {
    label: "Chugoku Gakuen University",
    value: "Chugoku Gakuen University",
  },
  {
    label: "Chugye University for the Arts",
    value: "Chugye University for the Arts",
  },
  {
    label: "Chuka University",
    value: "Chuka University",
  },
  {
    label: "Chukwuemeka Odumegwu Ojukwu University",
    value: "Chukwuemeka Odumegwu Ojukwu University",
  },
  {
    label: "Chukyo Gakuin University",
    value: "Chukyo Gakuin University",
  },
  {
    label: "Chukyo University",
    value: "Chukyo University",
  },
  {
    label: "Chulabhorn Royal Academy",
    value: "Chulabhorn Royal Academy",
  },
  {
    label: "Chulalongkorn University",
    value: "Chulalongkorn University",
  },
  {
    label: "Chuncheon National University of Education",
    value: "Chuncheon National University of Education",
  },
  {
    label: "Chung Chou University of Science and Technology",
    value: "Chung Chou University of Science and Technology",
  },
  {
    label: "Chung Hua University",
    value: "Chung Hua University",
  },
  {
    label: "Chung Hwa University of Medical Technology",
    value: "Chung Hwa University of Medical Technology",
  },
  {
    label: "Chung Shan Medical University",
    value: "Chung Shan Medical University",
  },
  {
    label: "Chung Yuan Christian University",
    value: "Chung Yuan Christian University",
  },
  {
    label: "Chung-Ang University",
    value: "Chung-Ang University",
  },
  {
    label: "Chungbuk National University",
    value: "Chungbuk National University",
  },
  {
    label: "Chungnam National University",
    value: "Chungnam National University",
  },
  {
    label: "Chungwoon University",
    value: "Chungwoon University",
  },
  {
    label: "Chungyu University of Film and Arts Technology",
    value: "Chungyu University of Film and Arts Technology",
  },
  {
    label: "Chuo Gakuin University",
    value: "Chuo Gakuin University",
  },
  {
    label: "Chuo University",
    value: "Chuo University",
  },
  {
    label: "Chuvash State Agricultural Academy",
    value: "Chuvash State Agricultural Academy",
  },
  {
    label: "Chuvash State Pedagogical University",
    value: "Chuvash State Pedagogical University",
  },
  {
    label: "Chuvash State University",
    value: "Chuvash State University",
  },
  {
    label: "Chuxiong Normal University",
    value: "Chuxiong Normal University",
  },
  {
    label: "Chuzhou University",
    value: "Chuzhou University",
  },
  {
    label: "Cihan University",
    value: "Cihan University",
  },
  {
    label: "CIM-Cyprus Business School",
    value: "CIM-Cyprus Business School",
  },
  {
    label: "Cipriani College of Labour and Cooperative Studies",
    value: "Cipriani College of Labour and Cooperative Studies",
  },
  {
    label: "Citi University",
    value: "Citi University",
  },
  {
    label: "City Unity College Nicosia",
    value: "City Unity College Nicosia",
  },
  {
    label: "City University",
    value: "City University",
  },
  {
    label: "City University",
    value: "City University",
  },
  {
    label: "City University Ajman",
    value: "City University Ajman",
  },
  {
    label: "City University of Hong Kong",
    value: "City University of Hong Kong",
  },
  {
    label: "City University of Malaysia",
    value: "City University of Malaysia",
  },
  {
    label: "City University of Science and Information Technology",
    value: "City University of Science and Information Technology",
  },
  {
    label: "City University of Science and Technology",
    value: "City University of Science and Technology",
  },
  {
    label: "City University of Seattle",
    value: "City University of Seattle",
  },
  {
    label: "City, University of London",
    value: "City, University of London",
  },
  {
    label: "Civil Aviation Flight University of China",
    value: "Civil Aviation Flight University of China",
  },
  {
    label: "Civil Aviation University of China",
    value: "Civil Aviation University of China",
  },
  {
    label: "Claflin University",
    value: "Claflin University",
  },
  {
    label: "Claremont Graduate University",
    value: "Claremont Graduate University",
  },
  {
    label: "Claremont McKenna College",
    value: "Claremont McKenna College",
  },
  {
    label: "Clark Atlanta University",
    value: "Clark Atlanta University",
  },
  {
    label: "Clark University",
    value: "Clark University",
  },
  {
    label: "Clarke International University",
    value: "Clarke International University",
  },
  {
    label: "Clarke University",
    value: "Clarke University",
  },
  {
    label: "Clarks Summit University",
    value: "Clarks Summit University",
  },
  {
    label: "Clarkson College",
    value: "Clarkson College",
  },
  {
    label: "Clarkson University",
    value: "Clarkson University",
  },
  {
    label: "Clayton State University",
    value: "Clayton State University",
  },
  {
    label: "Clear Creek Baptist Bible College",
    value: "Clear Creek Baptist Bible College",
  },
  {
    label: "Cleary University",
    value: "Cleary University",
  },
  {
    label: "Clemson University",
    value: "Clemson University",
  },
  {
    label: "Cleveland Institute of Art",
    value: "Cleveland Institute of Art",
  },
  {
    label: "Cleveland Institute of Music",
    value: "Cleveland Institute of Music",
  },
  {
    label: "Cleveland State University",
    value: "Cleveland State University",
  },
  {
    label: "Cleveland University-Kansas City",
    value: "Cleveland University-Kansas City",
  },
  {
    label: "Clifford University",
    value: "Clifford University",
  },
  {
    label: "Cluster University of Jammu",
    value: "Cluster University of Jammu",
  },
  {
    label: "CMJ University",
    value: "CMJ University",
  },
  {
    label: "CMR University",
    value: "CMR University",
  },
  {
    label: "Coal City University",
    value: "Coal City University",
  },
  {
    label: "Coastal Carolina University",
    value: "Coastal Carolina University",
  },
  {
    label: "Cochin University of Science and Technology",
    value: "Cochin University of Science and Technology",
  },
  {
    label: "Codarts Rotterdam",
    value: "Codarts Rotterdam",
  },
  {
    label: "Coe College",
    value: "Coe College",
  },
  {
    label: "Coker University",
    value: "Coker University",
  },
  {
    label: "Colby College",
    value: "Colby College",
  },
  {
    label: "Colby-Sawyer College",
    value: "Colby-Sawyer College",
  },
  {
    label: "Colegio de Dagupan",
    value: "Colegio de Dagupan",
  },
  {
    label: "Colegio de Estudios Superiores de Administración",
    value: "Colegio de Estudios Superiores de Administración",
  },
  {
    label: "Colegio de San Juan de Letran",
    value: "Colegio de San Juan de Letran",
  },
  {
    label: "Colegio Mayor de Antioquia",
    value: "Colegio Mayor de Antioquia",
  },
  {
    label: "Colegio Universitario de San Juan",
    value: "Colegio Universitario de San Juan",
  },
  {
    label: "Colgate University",
    value: "Colgate University",
  },
  {
    label: "Collège d'Europe",
    value: "Collège d'Europe",
  },
  {
    label: "College for Creative Studies",
    value: "College for Creative Studies",
  },
  {
    label: "College of Agriculture Science and Education",
    value: "College of Agriculture Science and Education",
  },
  {
    label: "College of Banking and Financial Studies",
    value: "College of Banking and Financial Studies",
  },
  {
    label: "College of Biblical Studies",
    value: "College of Biblical Studies",
  },
  {
    label: "College of Central Florida",
    value: "College of Central Florida",
  },
  {
    label: "College of Charleston",
    value: "College of Charleston",
  },
  {
    label: "College of Coastal Georgia",
    value: "College of Coastal Georgia",
  },
  {
    label: "College of Law and Business",
    value: "College of Law and Business",
  },
  {
    label: "College of Mount Saint Vincent",
    value: "College of Mount Saint Vincent",
  },
  {
    label: "College of Our Lady of the Elms",
    value: "College of Our Lady of the Elms",
  },
  {
    label: "College of Saint Benedict/Saint John's University",
    value: "College of Saint Benedict/Saint John's University",
  },
  {
    label: "College of Saint Mary",
    value: "College of Saint Mary",
  },
  {
    label:
      "College of Science, Technology and Applied Arts of Trinidad and Tobago",
    value:
      "College of Science, Technology and Applied Arts of Trinidad and Tobago",
  },
  {
    label: "College of Shari'a Sciences",
    value: "College of Shari'a Sciences",
  },
  {
    label: "College of Southern Nevada",
    value: "College of Southern Nevada",
  },
  {
    label: "College of Staten Island",
    value: "College of Staten Island",
  },
  {
    label: "College of the Atlantic",
    value: "College of the Atlantic",
  },
  {
    label: "College of the Holy Cross",
    value: "College of the Holy Cross",
  },
  {
    label: "College of the Holy Spirit",
    value: "College of the Holy Spirit",
  },
  {
    label: "College of the North Atlantic",
    value: "College of the North Atlantic",
  },
  {
    label: "College of the Ozarks",
    value: "College of the Ozarks",
  },
  {
    label: "College of Tourism and Hotel Management",
    value: "College of Tourism and Hotel Management",
  },
  {
    label: "College of Tourism Blagoevgrad",
    value: "College of Tourism Blagoevgrad",
  },
  {
    label: "College of William & Mary",
    value: "College of William & Mary",
  },
  {
    label: "Collège Universitaire Dominicain",
    value: "Collège Universitaire Dominicain",
  },
  {
    label: "Colorado Christian University",
    value: "Colorado Christian University",
  },
  {
    label: "Colorado College",
    value: "Colorado College",
  },
  {
    label: "Colorado Mesa University",
    value: "Colorado Mesa University",
  },
  {
    label: "Colorado School of Mines",
    value: "Colorado School of Mines",
  },
  {
    label: "Colorado State University",
    value: "Colorado State University",
  },
  {
    label: "Colorado State University-Pueblo",
    value: "Colorado State University-Pueblo",
  },
  {
    label: "Colorado Technical University",
    value: "Colorado Technical University",
  },
  {
    label: "Columbia Basin College",
    value: "Columbia Basin College",
  },
  {
    label: "Columbia Central University",
    value: "Columbia Central University",
  },
  {
    label: "Columbia College",
    value: "Columbia College",
  },
  {
    label: "Columbia College Chicago",
    value: "Columbia College Chicago",
  },
  {
    label: "Columbia College Hollywood",
    value: "Columbia College Hollywood",
  },
  {
    label: "Columbia College, South Carolina",
    value: "Columbia College, South Carolina",
  },
  {
    label: "Columbia International University",
    value: "Columbia International University",
  },
  {
    label: "Columbia University in the City of New York",
    value: "Columbia University in the City of New York",
  },
  {
    label: "Columbus College of Art and Design",
    value: "Columbus College of Art and Design",
  },
  {
    label: "Columbus State University",
    value: "Columbus State University",
  },
  {
    label: "Columbus University",
    value: "Columbus University",
  },
  {
    label: "Comilla University",
    value: "Comilla University",
  },
  {
    label: "Commecs Institute of Business and Emerging Sciences",
    value: "Commecs Institute of Business and Emerging Sciences",
  },
  {
    label: "Communication University of China",
    value: "Communication University of China",
  },
  {
    label: "Communication University of Shanxi",
    value: "Communication University of Shanxi",
  },
  {
    label: "Communication University of Zhejiang",
    value: "Communication University of Zhejiang",
  },
  {
    label: "COMSATS University Islamabad",
    value: "COMSATS University Islamabad",
  },
  {
    label: "Concord University",
    value: "Concord University",
  },
  {
    label: "Concordia College",
    value: "Concordia College",
  },
  {
    label: "Concordia University",
    value: "Concordia University",
  },
  {
    label: "Concordia University Ann Arbor",
    value: "Concordia University Ann Arbor",
  },
  {
    label: "Concordia University Chicago",
    value: "Concordia University Chicago",
  },
  {
    label: "Concordia University Irvine",
    value: "Concordia University Irvine",
  },
  {
    label: "Concordia University of Edmonton",
    value: "Concordia University of Edmonton",
  },
  {
    label: "Concordia University Texas",
    value: "Concordia University Texas",
  },
  {
    label: "Concordia University Wisconsin",
    value: "Concordia University Wisconsin",
  },
  {
    label: "Concordia University, Nebraska",
    value: "Concordia University, Nebraska",
  },
  {
    label: "Concordia University, St. Paul",
    value: "Concordia University, St. Paul",
  },
  {
    label: "Connecticut College",
    value: "Connecticut College",
  },
  {
    label: "Conservatoire Royal de Bruxelles",
    value: "Conservatoire Royal de Bruxelles",
  },
  {
    label: "Conservatoire Royal de Liège",
    value: "Conservatoire Royal de Liège",
  },
  {
    label: "Conservatorio de Música de Puerto Rico",
    value: "Conservatorio de Música de Puerto Rico",
  },
  {
    label: "Conservatorio del Tolima",
    value: "Conservatorio del Tolima",
  },
  {
    label: "Constructor University Bremen",
    value: "Constructor University Bremen",
  },
  {
    label: "Converse College",
    value: "Converse College",
  },
  {
    label: "Conway School of Landscape Design",
    value: "Conway School of Landscape Design",
  },
  {
    label: "Cooch Behar Panchanan Barma University",
    value: "Cooch Behar Panchanan Barma University",
  },
  {
    label: "Copperstone University",
    value: "Copperstone University",
  },
  {
    label: "Coppin State University",
    value: "Coppin State University",
  },
  {
    label: "Cor Jesu College",
    value: "Cor Jesu College",
  },
  {
    label: "Corban University",
    value: "Corban University",
  },
  {
    label: "Cordoba Private University",
    value: "Cordoba Private University",
  },
  {
    label: "Cornell College",
    value: "Cornell College",
  },
  {
    label: "Cornell University",
    value: "Cornell University",
  },
  {
    label: "Cornerstone University",
    value: "Cornerstone University",
  },
  {
    label: "Cornish College of the Arts",
    value: "Cornish College of the Arts",
  },
  {
    label: "Corporacion Colegiatura Colombiana",
    value: "Corporacion Colegiatura Colombiana",
  },
  {
    label: "Corporacion Escuela de Artes y Letras",
    value: "Corporacion Escuela de Artes y Letras",
  },
  {
    label: "Corporacion Escuela Tecnologica del Oriente",
    value: "Corporacion Escuela Tecnologica del Oriente",
  },
  {
    label: "Corporacion Universidad de Investigacion y Desarrollo",
    value: "Corporacion Universidad de Investigacion y Desarrollo",
  },
  {
    label: "Corporación Universitaria Adventista",
    value: "Corporación Universitaria Adventista",
  },
  {
    label: "Corporacion Universitaria Americana",
    value: "Corporacion Universitaria Americana",
  },
  {
    label: "Corporacion Universitaria Antonio Jose de Sucre",
    value: "Corporacion Universitaria Antonio Jose de Sucre",
  },
  {
    label: "Corporacion Universitaria Autonoma de Nariño",
    value: "Corporacion Universitaria Autonoma de Nariño",
  },
  {
    label: "Corporacion Universitaria Autonoma del Cauca",
    value: "Corporacion Universitaria Autonoma del Cauca",
  },
  {
    label: "Corporación Universitaria Autónoma del Norte",
    value: "Corporación Universitaria Autónoma del Norte",
  },
  {
    label: "Corporacion Universitaria Cenda",
    value: "Corporacion Universitaria Cenda",
  },
  {
    label: "Corporacion Universitaria Centro Superior",
    value: "Corporacion Universitaria Centro Superior",
  },
  {
    label: "Corporacion Universitaria Comfacauca",
    value: "Corporacion Universitaria Comfacauca",
  },
  {
    label: "Corporacion Universitaria de Asturias",
    value: "Corporacion Universitaria de Asturias",
  },
  {
    label: "Corporacion Universitaria de Cataluña",
    value: "Corporacion Universitaria de Cataluña",
  },
  {
    label: "Corporacion Universitaria de Ciencia y Desarrollo",
    value: "Corporacion Universitaria de Ciencia y Desarrollo",
  },
  {
    label:
      "Corporacion Universitaria de Ciencias Empresariales, Educacion y Salud",
    value:
      "Corporacion Universitaria de Ciencias Empresariales, Educacion y Salud",
  },
  {
    label: "Corporacion Universitaria de Colombia Ideas",
    value: "Corporacion Universitaria de Colombia Ideas",
  },
  {
    label: "Corporación Universitaria de la Costa",
    value: "Corporación Universitaria de la Costa",
  },
  {
    label: "Corporacion Universitaria de Sabaneta",
    value: "Corporacion Universitaria de Sabaneta",
  },
  {
    label: "Corporacion Universitaria de Santa Rosa de Cabal",
    value: "Corporacion Universitaria de Santa Rosa de Cabal",
  },
  {
    label: "Corporacion Universitaria del Caribe",
    value: "Corporacion Universitaria del Caribe",
  },
  {
    label: "Corporacion Universitaria del Huila",
    value: "Corporacion Universitaria del Huila",
  },
  {
    label: "Corporacion Universitaria del Meta",
    value: "Corporacion Universitaria del Meta",
  },
  {
    label: "Corporacion Universitaria Empresarial Alexander Von Humboldt",
    value: "Corporacion Universitaria Empresarial Alexander Von Humboldt",
  },
  {
    label: "Corporacion Universitaria Empresarial de Salamanca",
    value: "Corporacion Universitaria Empresarial de Salamanca",
  },
  {
    label: "Corporacion Universitaria Iberoamericana",
    value: "Corporacion Universitaria Iberoamericana",
  },
  {
    label: "Corporacion Universitaria Latinoamericana",
    value: "Corporacion Universitaria Latinoamericana",
  },
  {
    label: "Corporación Universitaria Minuto de Dios",
    value: "Corporación Universitaria Minuto de Dios",
  },
  {
    label: "Corporacion Universitaria para el Desarrollo Empresarial y Social",
    value: "Corporacion Universitaria para el Desarrollo Empresarial y Social",
  },
  {
    label: "Corporacion Universitaria Rafael Nuñez",
    value: "Corporacion Universitaria Rafael Nuñez",
  },
  {
    label: "Corporacion Universitaria Reformada",
    value: "Corporacion Universitaria Reformada",
  },
  {
    label: "Corporacion Universitaria Regional del Caribe",
    value: "Corporacion Universitaria Regional del Caribe",
  },
  {
    label: "Corporacion Universitaria Remington",
    value: "Corporacion Universitaria Remington",
  },
  {
    label: "Corporacion Universitaria Republicana",
    value: "Corporacion Universitaria Republicana",
  },
  {
    label: "Corporacion Universitaria Taller Cinco",
    value: "Corporacion Universitaria Taller Cinco",
  },
  {
    label: "Corporacion Universitaria U de Colombia",
    value: "Corporacion Universitaria U de Colombia",
  },
  {
    label: "Corporación Universitaria UNITEC",
    value: "Corporación Universitaria UNITEC",
  },
  {
    label: "Cottey College",
    value: "Cottey College",
  },
  {
    label: "Cotton University",
    value: "Cotton University",
  },
  {
    label: "Covenant College",
    value: "Covenant College",
  },
  {
    label: "Covenant University",
    value: "Covenant University",
  },
  {
    label: "Coventry University",
    value: "Coventry University",
  },
  {
    label: "Cox College",
    value: "Cox College",
  },
  {
    label: "Cox's Bazar International University",
    value: "Cox's Bazar International University",
  },
  {
    label: "Cranbrook Academy of Art",
    value: "Cranbrook Academy of Art",
  },
  {
    label: "Crandall University",
    value: "Crandall University",
  },
  {
    label: "Cranfield University",
    value: "Cranfield University",
  },
  {
    label: "Crawford University",
    value: "Crawford University",
  },
  {
    label: "Creighton University",
    value: "Creighton University",
  },
  {
    label: "Crescent University, Abeokuta",
    value: "Crescent University, Abeokuta",
  },
  {
    label: "Criswell College",
    value: "Criswell College",
  },
  {
    label: "Crowley's Ridge College",
    value: "Crowley's Ridge College",
  },
  {
    label: "Crown College",
    value: "Crown College",
  },
  {
    label: "Crown Hill University",
    value: "Crown Hill University",
  },
  {
    label: "CSK Himachal Pradesh Krishi Vishvavidyalaya",
    value: "CSK Himachal Pradesh Krishi Vishvavidyalaya",
  },
  {
    label: "CTBC Financial Management College",
    value: "CTBC Financial Management College",
  },
  {
    label: "Çukurova Üniversitesi",
    value: "Çukurova Üniversitesi",
  },
  {
    label: "Culver-Stockton College",
    value: "Culver-Stockton College",
  },
  {
    label: "Cumberland University",
    value: "Cumberland University",
  },
  {
    label: "CUNEF Universidad",
    value: "CUNEF Universidad",
  },
  {
    label: "CUNY School of Law",
    value: "CUNY School of Law",
  },
  {
    label: "Curry College",
    value: "Curry College",
  },
  {
    label: "Curtin University",
    value: "Curtin University",
  },
  {
    label: "Curtis Institute of Music",
    value: "Curtis Institute of Music",
  },
  {
    label: "Cuttington University",
    value: "Cuttington University",
  },
  {
    label: "CY Cergy Paris Université",
    value: "CY Cergy Paris Université",
  },
  {
    label: "CY Tech",
    value: "CY Tech",
  },
  {
    label: "Cyber University",
    value: "Cyber University",
  },
  {
    label: "Cyprus College",
    value: "Cyprus College",
  },
  {
    label: "Cyprus International Institute of Management",
    value: "Cyprus International Institute of Management",
  },
  {
    label: "Cyprus University of Technology",
    value: "Cyprus University of Technology",
  },
  {
    label: "D.A. Tsenov Academy of Economics",
    value: "D.A. Tsenov Academy of Economics",
  },
  {
    label: "Dadabhoy Institute of Higher Education",
    value: "Dadabhoy Institute of Higher Education",
  },
  {
    label: "Daegu Arts University",
    value: "Daegu Arts University",
  },
  {
    label: "Daegu Haany University",
    value: "Daegu Haany University",
  },
  {
    label: "Daegu National University of Education",
    value: "Daegu National University of Education",
  },
  {
    label: "Daegu University",
    value: "Daegu University",
  },
  {
    label: "Daejeon University",
    value: "Daejeon University",
  },
  {
    label: "Daejin University",
    value: "Daejin University",
  },
  {
    label: "Daemen University",
    value: "Daemen University",
  },
  {
    label: "Daeshin University",
    value: "Daeshin University",
  },
  {
    label: "Daeyang University",
    value: "Daeyang University",
  },
  {
    label: "Daffodil International University",
    value: "Daffodil International University",
  },
  {
    label: "Dagestan State Agrarian University",
    value: "Dagestan State Agrarian University",
  },
  {
    label: "Dagestan State Medical University",
    value: "Dagestan State Medical University",
  },
  {
    label: "Dagestan State Pedagogical University",
    value: "Dagestan State Pedagogical University",
  },
  {
    label: "Dagestan State Technical University",
    value: "Dagestan State Technical University",
  },
  {
    label: "Dagestan State University",
    value: "Dagestan State University",
  },
  {
    label: "Dagon University",
    value: "Dagon University",
  },
  {
    label: "Dahan Institute of Technology",
    value: "Dahan Institute of Technology",
  },
  {
    label: "Daido University",
    value: "Daido University",
  },
  {
    label: "Daiichi Institute of Technology",
    value: "Daiichi Institute of Technology",
  },
  {
    label: "Daiichi University of Pharmacy",
    value: "Daiichi University of Pharmacy",
  },
  {
    label: "Daito Bunka University",
    value: "Daito Bunka University",
  },
  {
    label: "Dakota State University",
    value: "Dakota State University",
  },
  {
    label: "Dakota Wesleyan University",
    value: "Dakota Wesleyan University",
  },
  {
    label: "Dakshina Bharat Hindi Prachar Sabha",
    value: "Dakshina Bharat Hindi Prachar Sabha",
  },
  {
    label: "Dalanj University",
    value: "Dalanj University",
  },
  {
    label: "Dalat University",
    value: "Dalat University",
  },
  {
    label: "Dalhousie University",
    value: "Dalhousie University",
  },
  {
    label: "Dali University",
    value: "Dali University",
  },
  {
    label: "Dalian Art College",
    value: "Dalian Art College",
  },
  {
    label: "Dalian Jiaotong University",
    value: "Dalian Jiaotong University",
  },
  {
    label: "Dalian Maritime University",
    value: "Dalian Maritime University",
  },
  {
    label: "Dalian Medical University",
    value: "Dalian Medical University",
  },
  {
    label: "Dalian Nationalities University",
    value: "Dalian Nationalities University",
  },
  {
    label: "Dalian Neusoft University of Information",
    value: "Dalian Neusoft University of Information",
  },
  {
    label: "Dalian Ocean University",
    value: "Dalian Ocean University",
  },
  {
    label: "Dalian Polytechnic University",
    value: "Dalian Polytechnic University",
  },
  {
    label: "Dalian University",
    value: "Dalian University",
  },
  {
    label: "Dalian University of Finance and Economics",
    value: "Dalian University of Finance and Economics",
  },
  {
    label: "Dalian University of Foreign Languages",
    value: "Dalian University of Foreign Languages",
  },
  {
    label: "Dalian University of Science and Technology",
    value: "Dalian University of Science and Technology",
  },
  {
    label: "Dalian University of Technology",
    value: "Dalian University of Technology",
  },
  {
    label: "Dallas Baptist University",
    value: "Dallas Baptist University",
  },
  {
    label: "Dallas Christian College",
    value: "Dallas Christian College",
  },
  {
    label: "Dalton State College",
    value: "Dalton State College",
  },
  {
    label: "Damanhour University",
    value: "Damanhour University",
  },
  {
    label: "Damascus University",
    value: "Damascus University",
  },
  {
    label: "Damghan University",
    value: "Damghan University",
  },
  {
    label: "Damietta University",
    value: "Damietta University",
  },
  {
    label: "Damodaram Sanjivayya National Law University",
    value: "Damodaram Sanjivayya National Law University",
  },
  {
    label: "Dangara State University",
    value: "Dangara State University",
  },
  {
    label: "Danish Institute of Higher Education",
    value: "Danish Institute of Higher Education",
  },
  {
    label: "Dankook University",
    value: "Dankook University",
  },
  {
    label: "Danmarks Medie- og journalisthøjskole",
    value: "Danmarks Medie- og journalisthøjskole",
  },
  {
    label: "Danmarks Tekniske Universitet",
    value: "Danmarks Tekniske Universitet",
  },
  {
    label: "Danube Private University",
    value: "Danube Private University",
  },
  {
    label: "Daqing Normal University",
    value: "Daqing Normal University",
  },
  {
    label: "Dar Al Uloom University",
    value: "Dar Al Uloom University",
  },
  {
    label: "Dar Al-Hekma University",
    value: "Dar Al-Hekma University",
  },
  {
    label: "Dar Al-Kalima University",
    value: "Dar Al-Kalima University",
  },
  {
    label: "Dar Al-Salam International University for Science and Technology",
    value: "Dar Al-Salam International University for Science and Technology",
  },
  {
    label: "Darkhan Institute",
    value: "Darkhan Institute",
  },
  {
    label: "Dartmouth College",
    value: "Dartmouth College",
  },
  {
    label: "Data Link Institute of Business and Technology",
    value: "Data Link Institute of Business and Technology",
  },
  {
    label: "Datta Meghe Institute of Higher Education & Research",
    value: "Datta Meghe Institute of Higher Education & Research",
  },
  {
    label: "Daugavpils Universitate",
    value: "Daugavpils Universitate",
  },
  {
    label: "DAV University",
    value: "DAV University",
  },
  {
    label: "Davangere University",
    value: "Davangere University",
  },
  {
    label: "Davao Doctors College",
    value: "Davao Doctors College",
  },
  {
    label: "Davenport University",
    value: "Davenport University",
  },
  {
    label: "David Aghmashenebeli University of Georgia",
    value: "David Aghmashenebeli University of Georgia",
  },
  {
    label: "David Tvildiani Medical University",
    value: "David Tvildiani Medical University",
  },
  {
    label: "Davidson College",
    value: "Davidson College",
  },
  {
    label: "Davis & Elkins College",
    value: "Davis & Elkins College",
  },
  {
    label: "Davis College",
    value: "Davis College",
  },
  {
    label: "Dawat University",
    value: "Dawat University",
  },
  {
    label: "Dawei University",
    value: "Dawei University",
  },
  {
    label: "Dawood University of Engineering and Technology",
    value: "Dawood University of Engineering and Technology",
  },
  {
    label: "Dayalbagh Educational Institute",
    value: "Dayalbagh Educational Institute",
  },
  {
    label: "Dayananda Sagar University",
    value: "Dayananda Sagar University",
  },
  {
    label: "Da-Yeh University",
    value: "Da-Yeh University",
  },
  {
    label: "Daystar University",
    value: "Daystar University",
  },
  {
    label: "Daytona State College",
    value: "Daytona State College",
  },
  {
    label: "De Haagse Hogeschool",
    value: "De Haagse Hogeschool",
  },
  {
    label: "De La Salle Lipa",
    value: "De La Salle Lipa",
  },
  {
    label: "De La Salle Medical and Health Sciences Institute",
    value: "De La Salle Medical and Health Sciences Institute",
  },
  {
    label: "De La Salle University",
    value: "De La Salle University",
  },
  {
    label: "De La Salle-College of Saint Benilde",
    value: "De La Salle-College of Saint Benilde",
  },
  {
    label: "De Montfort University",
    value: "De Montfort University",
  },
  {
    label: "Deakin University",
    value: "Deakin University",
  },
  {
    label: "Dean College",
    value: "Dean College",
  },
  {
    label: "Debre Berhan University",
    value: "Debre Berhan University",
  },
  {
    label: "Debre Markos University",
    value: "Debre Markos University",
  },
  {
    label: "Debre Tabor University",
    value: "Debre Tabor University",
  },
  {
    label: "Debreceni Egyetem",
    value: "Debreceni Egyetem",
  },
  {
    label: "Debreceni Református Hittudományi Egyetem",
    value: "Debreceni Református Hittudományi Egyetem",
  },
  {
    label: "Deccan College Post-Graduate and Research Institute",
    value: "Deccan College Post-Graduate and Research Institute",
  },
  {
    label: "Dedan Kimathi University of Technology",
    value: "Dedan Kimathi University of Technology",
  },
  {
    label: "Deen Dayal Upadhyay Gorakhpur University",
    value: "Deen Dayal Upadhyay Gorakhpur University",
  },
  {
    label: "Deenbandhu Chhotu Ram University of Science and Technology",
    value: "Deenbandhu Chhotu Ram University of Science and Technology",
  },
  {
    label: "Defiance College",
    value: "Defiance College",
  },
  {
    label: "Deh Yu College of Nursing and Health",
    value: "Deh Yu College of Nursing and Health",
  },
  {
    label: "Delaware State University",
    value: "Delaware State University",
  },
  {
    label: "Delaware Valley University",
    value: "Delaware Valley University",
  },
  {
    label: "Delhi Pharmaceutical Sciences and Research University",
    value: "Delhi Pharmaceutical Sciences and Research University",
  },
  {
    label: "Delhi Technological University",
    value: "Delhi Technological University",
  },
  {
    label: "Delta State University",
    value: "Delta State University",
  },
  {
    label: "Delta State University, Abraka",
    value: "Delta State University, Abraka",
  },
  {
    label: "Delta University for Science and Technology",
    value: "Delta University for Science and Technology",
  },
  {
    label: "Demiroglu Bilim Üniversitesi",
    value: "Demiroglu Bilim Üniversitesi",
  },
  {
    label: "Democritus University of Thrace",
    value: "Democritus University of Thrace",
  },
  {
    label: "Den Danske Scenekunstskole",
    value: "Den Danske Scenekunstskole",
  },
  {
    label: "Den-en Chofu University",
    value: "Den-en Chofu University",
  },
  {
    label: "Denison University",
    value: "Denison University",
  },
  {
    label: "Denov tadbirkorlik va pedagogika instituti",
    value: "Denov tadbirkorlik va pedagogika instituti",
  },
  {
    label: "Denver College of Nursing",
    value: "Denver College of Nursing",
  },
  {
    label: "DePaul University",
    value: "DePaul University",
  },
  {
    label: "DePauw University",
    value: "DePauw University",
  },
  {
    label: "Deraya University",
    value: "Deraya University",
  },
  {
    label: "Des Moines University",
    value: "Des Moines University",
  },
  {
    label: "DeSales University",
    value: "DeSales University",
  },
  {
    label: "Desh Bhagat University",
    value: "Desh Bhagat University",
  },
  {
    label: "Design Academy Eindhoven",
    value: "Design Academy Eindhoven",
  },
  {
    label: "Designskolen Kolding",
    value: "Designskolen Kolding",
  },
  {
    label: "Det Jyske Musikkonservatorium",
    value: "Det Jyske Musikkonservatorium",
  },
  {
    label: "Det Kongelige Akademi - Arkitektur, Design, Konservering",
    value: "Det Kongelige Akademi - Arkitektur, Design, Konservering",
  },
  {
    label: "Det Kongelige Danske Kunstakademi, Billedkunstskolerne",
    value: "Det Kongelige Danske Kunstakademi, Billedkunstskolerne",
  },
  {
    label: "Det Kongelige Danske Musikkonservatorium",
    value: "Det Kongelige Danske Musikkonservatorium",
  },
  {
    label: "Deutsche Hochschule für Gesundheit und Sport",
    value: "Deutsche Hochschule für Gesundheit und Sport",
  },
  {
    label: "Deutsche Sporthochschule Köln",
    value: "Deutsche Sporthochschule Köln",
  },
  {
    label: "Deutsche Universität für Verwaltungswissenschaften Speyer",
    value: "Deutsche Universität für Verwaltungswissenschaften Speyer",
  },
  {
    label: "Deutsch-Kasachische Universität",
    value: "Deutsch-Kasachische Universität",
  },
  {
    label: "Dev Sanskriti Vishwavidyalaya",
    value: "Dev Sanskriti Vishwavidyalaya",
  },
  {
    label: "Devi Ahilya Vishwavidyalaya",
    value: "Devi Ahilya Vishwavidyalaya",
  },
  {
    label: "DeVry University",
    value: "DeVry University",
  },
  {
    label: "Dewey International University",
    value: "Dewey International University",
  },
  {
    label: "Dezful University of Medical Sciences and Health Services",
    value: "Dezful University of Medical Sciences and Health Services",
  },
  {
    label: "Dezhou University",
    value: "Dezhou University",
  },
  {
    label: "DHA Suffa University",
    value: "DHA Suffa University",
  },
  {
    label: "Dhaka International University",
    value: "Dhaka International University",
  },
  {
    label: "Dhaka University of Engineering and Technology",
    value: "Dhaka University of Engineering and Technology",
  },
  {
    label: "Dharma Drum Institute of Liberal Arts",
    value: "Dharma Drum Institute of Liberal Arts",
  },
  {
    label: "Dharma Realm Buddhist University",
    value: "Dharma Realm Buddhist University",
  },
  {
    label: "Dharmsinh Desai University",
    value: "Dharmsinh Desai University",
  },
  {
    label:
      "Dhirubhai Ambani Institute of Information and Communication Technology",
    value:
      "Dhirubhai Ambani Institute of Information and Communication Technology",
  },
  {
    label: "Dhofar University",
    value: "Dhofar University",
  },
  {
    label: "Dhonburi Rajabhat University",
    value: "Dhonburi Rajabhat University",
  },
  {
    label: "Dhurakij Pundit University",
    value: "Dhurakij Pundit University",
  },
  {
    label: "Diakonia-ammattikorkeakoulu",
    value: "Diakonia-ammattikorkeakoulu",
  },
  {
    label: "Diamond Harbour Women's University",
    value: "Diamond Harbour Women's University",
  },
  {
    label: "Dibrugarh University",
    value: "Dibrugarh University",
  },
  {
    label: "Dickinson College",
    value: "Dickinson College",
  },
  {
    label: "Dickinson State University",
    value: "Dickinson State University",
  },
  {
    label: "Dicle Üniversitesi",
    value: "Dicle Üniversitesi",
  },
  {
    label: "Digital Hollywood University",
    value: "Digital Hollywood University",
  },
  {
    label: "Dijlah University College",
    value: "Dijlah University College",
  },
  {
    label: "Dili Institute of Technology",
    value: "Dili Institute of Technology",
  },
  {
    label: "Dilla University",
    value: "Dilla University",
  },
  {
    label: "Dillard University",
    value: "Dillard University",
  },
  {
    label:
      "Diplomatic Academy of the Ministry of Foreign Affairs of the Kyrgyz Republic",
    value:
      "Diplomatic Academy of the Ministry of Foreign Affairs of the Kyrgyz Republic",
  },
  {
    label: "Diplomatic Academy of Ukraine",
    value: "Diplomatic Academy of Ukraine",
  },
  {
    label: "Diplomatische Akademie Wien",
    value: "Diplomatische Akademie Wien",
  },
  {
    label: "Dire Dawa University",
    value: "Dire Dawa University",
  },
  {
    label: "DIT University",
    value: "DIT University",
  },
  {
    label: "Divine Word University",
    value: "Divine Word University",
  },
  {
    label: "DMI-St. Eugene University",
    value: "DMI-St. Eugene University",
  },
  {
    label: "Dnepropetrovsk State University of Internal Affairs",
    value: "Dnepropetrovsk State University of Internal Affairs",
  },
  {
    label: "Dnipro Humanitarian University",
    value: "Dnipro Humanitarian University",
  },
  {
    label: "Dnipro State Medical University",
    value: "Dnipro State Medical University",
  },
  {
    label: "Dnipro University of Technology",
    value: "Dnipro University of Technology",
  },
  {
    label: "Dnipropetrovsk State Agrarian and Economic University",
    value: "Dnipropetrovsk State Agrarian and Economic University",
  },
  {
    label: "Dniprovsk State Technical University",
    value: "Dniprovsk State Technical University",
  },
  {
    label: "Doane University",
    value: "Doane University",
  },
  {
    label: "DOBA Fakultet",
    value: "DOBA Fakultet",
  },
  {
    label: "Dogu Akdeniz Üniversitesi",
    value: "Dogu Akdeniz Üniversitesi",
  },
  {
    label: "Dogus Üniversitesi",
    value: "Dogus Üniversitesi",
  },
  {
    label: "Doha Institute for Graduate Studies",
    value: "Doha Institute for Graduate Studies",
  },
  {
    label: "Doho University",
    value: "Doho University",
  },
  {
    label: "Dokkyo Medical University",
    value: "Dokkyo Medical University",
  },
  {
    label: "Dokkyo University",
    value: "Dokkyo University",
  },
  {
    label: "Dokuz Eylül Üniversitesi",
    value: "Dokuz Eylül Üniversitesi",
  },
  {
    label: "Dominican School of Philosophy & Theology",
    value: "Dominican School of Philosophy & Theology",
  },
  {
    label: "Dominican University",
    value: "Dominican University",
  },
  {
    label: "Dominican University New York",
    value: "Dominican University New York",
  },
  {
    label: "Dominican University of California",
    value: "Dominican University of California",
  },
  {
    label: "Dominican University, Ibadan",
    value: "Dominican University, Ibadan",
  },
  {
    label: "Dominion University College",
    value: "Dominion University College",
  },
  {
    label: "Don Bosco Technical College",
    value: "Don Bosco Technical College",
  },
  {
    label: "Don Honorio Ventura Technological State University",
    value: "Don Honorio Ventura Technological State University",
  },
  {
    label: "Don Mariano Marcos Memorial State University",
    value: "Don Mariano Marcos Memorial State University",
  },
  {
    label: "Don State Technical University",
    value: "Don State Technical University",
  },
  {
    label: "Don State University of Agriculture",
    value: "Don State University of Agriculture",
  },
  {
    label: "Donbas National Academy of Civil Engineering and Architecture",
    value: "Donbas National Academy of Civil Engineering and Architecture",
  },
  {
    label: "Donbass State Pedagogical University",
    value: "Donbass State Pedagogical University",
  },
  {
    label: "Donbass State Technical University",
    value: "Donbass State Technical University",
  },
  {
    label: "Donetsk National Medical University",
    value: "Donetsk National Medical University",
  },
  {
    label: "Donetsk National Technical University",
    value: "Donetsk National Technical University",
  },
  {
    label: "Donetsk National University of Economics and Trade",
    value: "Donetsk National University of Economics and Trade",
  },
  {
    label: "Donetsk State University of Internal Affairs",
    value: "Donetsk State University of Internal Affairs",
  },
  {
    label: "Dong Do International University",
    value: "Dong Do International University",
  },
  {
    label: "Dong Nai University of Technology",
    value: "Dong Nai University of Technology",
  },
  {
    label: "Dong-A University",
    value: "Dong-A University",
  },
  {
    label: "Dongbei University of Finance and Economics",
    value: "Dongbei University of Finance and Economics",
  },
  {
    label: "Dongduk Women's University",
    value: "Dongduk Women's University",
  },
  {
    label: "Dong-Eui University",
    value: "Dong-Eui University",
  },
  {
    label: "Dongguan University of Technology",
    value: "Dongguan University of Technology",
  },
  {
    label: "Dongguk University",
    value: "Dongguk University",
  },
  {
    label: "Donghua University",
    value: "Donghua University",
  },
  {
    label: "Dongseo University",
    value: "Dongseo University",
  },
  {
    label: "Dongshin University",
    value: "Dongshin University",
  },
  {
    label: "Dongyang University",
    value: "Dongyang University",
  },
  {
    label: "Donnelly College",
    value: "Donnelly College",
  },
  {
    label: "Doon University",
    value: "Doon University",
  },
  {
    label: "Dordt University",
    value: "Dordt University",
  },
  {
    label: "Dornod University",
    value: "Dornod University",
  },
  {
    label: "Doshisha University",
    value: "Doshisha University",
  },
  {
    label: "Doshisha Women's College of Liberal Arts",
    value: "Doshisha Women's College of Liberal Arts",
  },
  {
    label: "Dostoevsky Omsk State University",
    value: "Dostoevsky Omsk State University",
  },
  {
    label: "Dövlet Idareçilik Akademiyasi",
    value: "Dövlet Idareçilik Akademiyasi",
  },
  {
    label: "Dovletmammet Azadi Turkmen National Institute of World Languages",
    value: "Dovletmammet Azadi Turkmen National Institute of World Languages",
  },
  {
    label: "DOW University of Health Sciences",
    value: "DOW University of Health Sciences",
  },
  {
    label: "DPFA Hochschule Sachsen",
    value: "DPFA Hochschule Sachsen",
  },
  {
    label: "Dr K.N. Modi University",
    value: "Dr K.N. Modi University",
  },
  {
    label: "Dr YSR Architecture and Fine Arts University",
    value: "Dr YSR Architecture and Fine Arts University",
  },
  {
    label: "Dr. A.P.J Abdul Kalam University",
    value: "Dr. A.P.J Abdul Kalam University",
  },
  {
    label: "Dr. A.P.J. Abdul Kalam Technical University",
    value: "Dr. A.P.J. Abdul Kalam Technical University",
  },
  {
    label: "Dr. B R Ambedkar National Institute of Technology Jalandhar",
    value: "Dr. B R Ambedkar National Institute of Technology Jalandhar",
  },
  {
    label: "Dr. B.R. Ambedkar University",
    value: "Dr. B.R. Ambedkar University",
  },
  {
    label: "Dr. B.R. Ambedkar University of Social Sciences",
    value: "Dr. B.R. Ambedkar University of Social Sciences",
  },
  {
    label: "Dr. Babasaheb Ambedkar Marathwada University",
    value: "Dr. Babasaheb Ambedkar Marathwada University",
  },
  {
    label: "Dr. Babasaheb Ambedkar Technological University",
    value: "Dr. Babasaheb Ambedkar Technological University",
  },
  {
    label: "Dr. Balasaheb Sawant Konkan Krishi Vidyapeeth",
    value: "Dr. Balasaheb Sawant Konkan Krishi Vidyapeeth",
  },
  {
    label: "Dr. Bhimrao Ambedkar University",
    value: "Dr. Bhimrao Ambedkar University",
  },
  {
    label: "Dr. C.V. Raman University",
    value: "Dr. C.V. Raman University",
  },
  {
    label: "Dr. D.Y. Patil Vidyapeeth",
    value: "Dr. D.Y. Patil Vidyapeeth",
  },
  {
    label: "Dr. Harisingh Gour Vishwavidyalaya Sagar",
    value: "Dr. Harisingh Gour Vishwavidyalaya Sagar",
  },
  {
    label: "Dr. Hilla Limann Technical University",
    value: "Dr. Hilla Limann Technical University",
  },
  {
    label: "Dr. M.G.R. Educational and Research Institute",
    value: "Dr. M.G.R. Educational and Research Institute",
  },
  {
    label: "Dr. N.T.R. University of Health Sciences",
    value: "Dr. N.T.R. University of Health Sciences",
  },
  {
    label: "Dr. Panjabrao Deshmukh Krishi Vidyapeeth",
    value: "Dr. Panjabrao Deshmukh Krishi Vidyapeeth",
  },
  {
    label: "Dr. Rajendra Prasad Central Agricultural University",
    value: "Dr. Rajendra Prasad Central Agricultural University",
  },
  {
    label: "Dr. Ram Manohar Lohia Avadh University",
    value: "Dr. Ram Manohar Lohia Avadh University",
  },
  {
    label: "Dr. Ram Manohar Lohiya National Law University",
    value: "Dr. Ram Manohar Lohiya National Law University",
  },
  {
    label: "Dr. Sarvepalli Radhakrishnan Rajasthan Ayurved University",
    value: "Dr. Sarvepalli Radhakrishnan Rajasthan Ayurved University",
  },
  {
    label: "Dr. Shakuntala Misra National Rehabilitation University",
    value: "Dr. Shakuntala Misra National Rehabilitation University",
  },
  {
    label: "Dr. Vishwanath Karad MIT World Peace University",
    value: "Dr. Vishwanath Karad MIT World Peace University",
  },
  {
    label: "Dr. Y.S. Parmar University of Horticulture and Forestry",
    value: "Dr. Y.S. Parmar University of Horticulture and Forestry",
  },
  {
    label: "Dr. Y.S.R. Horticultural University",
    value: "Dr. Y.S.R. Horticultural University",
  },
  {
    label: "Drake University",
    value: "Drake University",
  },
  {
    label: "Dravidian University",
    value: "Dravidian University",
  },
  {
    label: "DRB-HICOM University of Automotive Malaysia",
    value: "DRB-HICOM University of Automotive Malaysia",
  },
  {
    label: "Drew University",
    value: "Drew University",
  },
  {
    label: "Drexel University",
    value: "Drexel University",
  },
  {
    label: "Driestar Hogeschool",
    value: "Driestar Hogeschool",
  },
  {
    label: "Drohobych State Pedagogical University",
    value: "Drohobych State Pedagogical University",
  },
  {
    label: "Dronning Mauds Minne Høgskole for barnehagelærerutdanning",
    value: "Dronning Mauds Minne Høgskole for barnehagelærerutdanning",
  },
  {
    label: "Drury University",
    value: "Drury University",
  },
  {
    label: "Državni univerzitet u Novom Pazaru",
    value: "Državni univerzitet u Novom Pazaru",
  },
  {
    label: "Duale Hochschule Gera-Eisenach",
    value: "Duale Hochschule Gera-Eisenach",
  },
  {
    label: "Dubai Institute of Design and Innovation",
    value: "Dubai Institute of Design and Innovation",
  },
  {
    label: "Dubai Medical College",
    value: "Dubai Medical College",
  },
  {
    label: "Dubai Pharmacy College",
    value: "Dubai Pharmacy College",
  },
  {
    label: "Dublin City University",
    value: "Dublin City University",
  },
  {
    label: "Dubna State University",
    value: "Dubna State University",
  },
  {
    label: "Duhok Polytechnic University",
    value: "Duhok Polytechnic University",
  },
  {
    label: "Duke Kunshan University",
    value: "Duke Kunshan University",
  },
  {
    label: "Duke University",
    value: "Duke University",
  },
  {
    label: "Duksung Women's University",
    value: "Duksung Women's University",
  },
  {
    label: "Dún Laoghaire Institute of Art, Design and Technology",
    value: "Dún Laoghaire Institute of Art, Design and Technology",
  },
  {
    label: "Dunaújvárosi Egyetem",
    value: "Dunaújvárosi Egyetem",
  },
  {
    label: "Dundalk Institute of Technology",
    value: "Dundalk Institute of Technology",
  },
  {
    label: "Dunwoody College of Technology",
    value: "Dunwoody College of Technology",
  },
  {
    label: "Dunya University of Afghanistan",
    value: "Dunya University of Afghanistan",
  },
  {
    label: "Duquesne University",
    value: "Duquesne University",
  },
  {
    label: "Durban University of Technology",
    value: "Durban University of Technology",
  },
  {
    label: "Durham University",
    value: "Durham University",
  },
  {
    label: "Duy Tan University",
    value: "Duy Tan University",
  },
  {
    label: "Düzce Üniversitesi",
    value: "Düzce Üniversitesi",
  },
  {
    label: "D'Youville College",
    value: "D'Youville College",
  },
  {
    label: "E.A. Buketov University of Karaganda",
    value: "E.A. Buketov University of Karaganda",
  },
  {
    label: "Earlham College",
    value: "Earlham College",
  },
  {
    label: "East Africa Star University",
    value: "East Africa Star University",
  },
  {
    label: "East African University Rwanda",
    value: "East African University Rwanda",
  },
  {
    label: "East Asia Management University",
    value: "East Asia Management University",
  },
  {
    label: "East Carolina University",
    value: "East Carolina University",
  },
  {
    label: "East Central University",
    value: "East Central University",
  },
  {
    label: "East China Jiaotong University",
    value: "East China Jiaotong University",
  },
  {
    label: "East China Normal University",
    value: "East China Normal University",
  },
  {
    label: "East China University of Political Science and Law",
    value: "East China University of Political Science and Law",
  },
  {
    label: "East China University of Science and Technology",
    value: "East China University of Science and Technology",
  },
  {
    label: "East China University of Technology",
    value: "East China University of Technology",
  },
  {
    label: "East Delta University",
    value: "East Delta University",
  },
  {
    label: "East European University",
    value: "East European University",
  },
  {
    label: "East European University, Georgia",
    value: "East European University, Georgia",
  },
  {
    label: "East Georgia State College",
    value: "East Georgia State College",
  },
  {
    label: "East Siberia State University of Technology and Management",
    value: "East Siberia State University of Technology and Management",
  },
  {
    label: "East Stroudsburg University",
    value: "East Stroudsburg University",
  },
  {
    label: "East Tennessee State University",
    value: "East Tennessee State University",
  },
  {
    label: "East Texas Baptist University",
    value: "East Texas Baptist University",
  },
  {
    label: "East Timor Coffee Institute",
    value: "East Timor Coffee Institute",
  },
  {
    label: "East Timor Institute of Business",
    value: "East Timor Institute of Business",
  },
  {
    label: "East Ukrainian National University",
    value: "East Ukrainian National University",
  },
  {
    label: "East West University",
    value: "East West University",
  },
  {
    label: "East Yangon University",
    value: "East Yangon University",
  },
  {
    label: "Eastern Asia University",
    value: "Eastern Asia University",
  },
  {
    label: "Eastern Connecticut State University",
    value: "Eastern Connecticut State University",
  },
  {
    label: "Eastern Illinois University",
    value: "Eastern Illinois University",
  },
  {
    label: "Eastern Kentucky University",
    value: "Eastern Kentucky University",
  },
  {
    label: "Eastern Liaoning University",
    value: "Eastern Liaoning University",
  },
  {
    label: "Eastern Mennonite University",
    value: "Eastern Mennonite University",
  },
  {
    label: "Eastern Michigan University",
    value: "Eastern Michigan University",
  },
  {
    label: "Eastern Nazarene College",
    value: "Eastern Nazarene College",
  },
  {
    label: "Eastern New Mexico University",
    value: "Eastern New Mexico University",
  },
  {
    label: "Eastern Oregon University",
    value: "Eastern Oregon University",
  },
  {
    label: "Eastern Samar State University",
    value: "Eastern Samar State University",
  },
  {
    label: "Eastern Technical University of Sierra Leone",
    value: "Eastern Technical University of Sierra Leone",
  },
  {
    label: "Eastern University",
    value: "Eastern University",
  },
  {
    label: "Eastern University of Technology",
    value: "Eastern University of Technology",
  },
  {
    label: "Eastern University, Bangladesh",
    value: "Eastern University, Bangladesh",
  },
  {
    label: "Eastern University, Sri Lanka",
    value: "Eastern University, Sri Lanka",
  },
  {
    label: "Eastern Virginia Medical School",
    value: "Eastern Virginia Medical School",
  },
  {
    label: "Eastern Visayas State University",
    value: "Eastern Visayas State University",
  },
  {
    label: "Eastern Washington University",
    value: "Eastern Washington University",
  },
  {
    label: "East-Kazakhstan State Technical University",
    value: "East-Kazakhstan State Technical University",
  },
  {
    label: "East-Kazakhstan State University",
    value: "East-Kazakhstan State University",
  },
  {
    label: "East-West University",
    value: "East-West University",
  },
  {
    label: "Eberhard Karls Universität Tübingen",
    value: "Eberhard Karls Universität Tübingen",
  },
  {
    label: "Ebla Private University",
    value: "Ebla Private University",
  },
  {
    label: "Ebonyi State University",
    value: "Ebonyi State University",
  },
  {
    label: "EBS Rahvusvaheline ülikool",
    value: "EBS Rahvusvaheline ülikool",
  },
  {
    label: "EBS Universität für Wirtschaft und Recht",
    value: "EBS Universität für Wirtschaft und Recht",
  },
  {
    label: "EBZ Business School",
    value: "EBZ Business School",
  },
  {
    label: "ECAM Lyon",
    value: "ECAM Lyon",
  },
  {
    label: "ECAM Rennes Louis de Broglie",
    value: "ECAM Rennes Louis de Broglie",
  },
  {
    label: "ECAM Strasbourg-Europe",
    value: "ECAM Strasbourg-Europe",
  },
  {
    label: "ECAM-EPMI",
    value: "ECAM-EPMI",
  },
  {
    label: "Ecclesia College",
    value: "Ecclesia College",
  },
  {
    label: "ECE Paris",
    value: "ECE Paris",
  },
  {
    label: "Eckerd College",
    value: "Eckerd College",
  },
  {
    label: "Eckernforde Tanga University",
    value: "Eckernforde Tanga University",
  },
  {
    label: "École Centrale Casablanca",
    value: "École Centrale Casablanca",
  },
  {
    label: "École Centrale de Lyon",
    value: "École Centrale de Lyon",
  },
  {
    label: "École Centrale de Nantes",
    value: "École Centrale de Nantes",
  },
  {
    label: "École Centrale des Logiciels Libres et des Télécommunications",
    value: "École Centrale des Logiciels Libres et des Télécommunications",
  },
  {
    label: "École Centrale Supérieure Privée de Technologie",
    value: "École Centrale Supérieure Privée de Technologie",
  },
  {
    label: "École de Biologie Industrielle",
    value: "École de Biologie Industrielle",
  },
  {
    label: "École de Commerce de Valence",
    value: "École de Commerce de Valence",
  },
  {
    label: "École de Gestion et de Commerce d'Occitanie",
    value: "École de Gestion et de Commerce d'Occitanie",
  },
  {
    label: "École de Management de Normandie",
    value: "École de Management de Normandie",
  },
  {
    label: "École de Management du Gabon",
    value: "École de Management du Gabon",
  },
  {
    label: "École de Management Léonard de Vinci",
    value: "École de Management Léonard de Vinci",
  },
  {
    label: "École de Recherche Graphique",
    value: "École de Recherche Graphique",
  },
  {
    label: "École de Technologie Supérieure",
    value: "École de Technologie Supérieure",
  },
  {
    label: "École des Dirigeants et Créateurs d'entreprise",
    value: "École des Dirigeants et Créateurs d'entreprise",
  },
  {
    label: "École des Hautes Etudes Commerciales",
    value: "École des Hautes Etudes Commerciales",
  },
  {
    label: "École des Hautes Études Commerciales de Paris",
    value: "École des Hautes Études Commerciales de Paris",
  },
  {
    label: "École des Hautes Études Commerciales du Nord",
    value: "École des Hautes Études Commerciales du Nord",
  },
  {
    label: "École des Hautes Études en Santé Publique",
    value: "École des Hautes Études en Santé Publique",
  },
  {
    label: "École des Hautes Études en Sciences Sociales",
    value: "École des Hautes Études en Sciences Sociales",
  },
  {
    label: "École des Ingénieurs de la Ville de Paris",
    value: "École des Ingénieurs de la Ville de Paris",
  },
  {
    label: "École des Mines et de la Métallurgie de Moanda",
    value: "École des Mines et de la Métallurgie de Moanda",
  },
  {
    label: "École des Ponts ParisTech",
    value: "École des Ponts ParisTech",
  },
  {
    label:
      "École d'ingénieur généraliste en informatique et technologies du numérique",
    value:
      "École d'ingénieur généraliste en informatique et technologies du numérique",
  },
  {
    label: "École d'Ingénieurs de Purpan",
    value: "École d'Ingénieurs de Purpan",
  },
  {
    label: "École d'Ingénieurs Généralistes La Rochelle",
    value: "École d'Ingénieurs Généralistes La Rochelle",
  },
  {
    label: "École d'ingénieurs SIGMA Clermont",
    value: "École d'ingénieurs SIGMA Clermont",
  },
  {
    label: "École Européenne de Management",
    value: "École Européenne de Management",
  },
  {
    label: "École Internationale Supérieure Privée de Droit et des Affaires",
    value: "École Internationale Supérieure Privée de Droit et des Affaires",
  },
  {
    label: "École Nationale d'Administration de Côte d'Ivoire",
    value: "École Nationale d'Administration de Côte d'Ivoire",
  },
  {
    label: "École Nationale d'Administration Moulay Ahmed Medeghri",
    value: "École Nationale d'Administration Moulay Ahmed Medeghri",
  },
  {
    label: "École Nationale d'Administration Publique",
    value: "École Nationale d'Administration Publique",
  },
  {
    label: "École Nationale d'Administration, Burundi",
    value: "École Nationale d'Administration, Burundi",
  },
  {
    label:
      "École Nationale d'Administration, de Journalisme et de Magistrature",
    value:
      "École Nationale d'Administration, de Journalisme et de Magistrature",
  },
  {
    label: "École Nationale d'Administration, Tchad",
    value: "École Nationale d'Administration, Tchad",
  },
  {
    label: "École Nationale d'Agriculture de Meknes",
    value: "École Nationale d'Agriculture de Meknes",
  },
  {
    label: "École Nationale d'Architecture",
    value: "École Nationale d'Architecture",
  },
  {
    label: "École Nationale de la Météorologie",
    value: "École Nationale de la Météorologie",
  },
  {
    label: "École Nationale de la Statistique et de l'Analyse de l'information",
    value: "École Nationale de la Statistique et de l'Analyse de l'information",
  },
  {
    label: "École Nationale de l'Aviation Civile",
    value: "École Nationale de l'Aviation Civile",
  },
  {
    label: "École Nationale des Eaux et Forêts",
    value: "École Nationale des Eaux et Forêts",
  },
  {
    label: "École Nationale des Sciences Géographiques",
    value: "École Nationale des Sciences Géographiques",
  },
  {
    label: "École Nationale des Travaux Publics de l'État",
    value: "École Nationale des Travaux Publics de l'État",
  },
  {
    label: "École Nationale d'Ingénieurs Abderhame Baba Touré",
    value: "École Nationale d'Ingénieurs Abderhame Baba Touré",
  },
  {
    label: "École Nationale d'Ingénieurs de Brest",
    value: "École Nationale d'Ingénieurs de Brest",
  },
  {
    label: "École Nationale d'Ingénieurs de Saint-Étienne",
    value: "École Nationale d'Ingénieurs de Saint-Étienne",
  },
  {
    label: "École Nationale d'Ingénieurs de Tarbes",
    value: "École Nationale d'Ingénieurs de Tarbes",
  },
  {
    label: "École Nationale Polytechnique",
    value: "École Nationale Polytechnique",
  },
  {
    label: "École Nationale Polytechnique de Constantine",
    value: "École Nationale Polytechnique de Constantine",
  },
  {
    label: "École Nationale Polytechnique d'Oran",
    value: "École Nationale Polytechnique d'Oran",
  },
  {
    label: "École Nationale Supérieure Agronomique",
    value: "École Nationale Supérieure Agronomique",
  },
  {
    label: "École Nationale Supérieure Agronomique de Toulouse",
    value: "École Nationale Supérieure Agronomique de Toulouse",
  },
  {
    label: "École Nationale Supérieure d'Architecture de Nancy",
    value: "École Nationale Supérieure d'Architecture de Nancy",
  },
  {
    label: "École Nationale Supérieure de Biotechnologie",
    value: "École Nationale Supérieure de Biotechnologie",
  },
  {
    label: "École Nationale Supérieure de Chimie de Lille",
    value: "École Nationale Supérieure de Chimie de Lille",
  },
  {
    label: "École Nationale Supérieure de Chimie de Montpellier",
    value: "École Nationale Supérieure de Chimie de Montpellier",
  },
  {
    label: "École Nationale Supérieure de Chimie de Paris",
    value: "École Nationale Supérieure de Chimie de Paris",
  },
  {
    label: "École Nationale Supérieure de Chimie de Rennes",
    value: "École Nationale Supérieure de Chimie de Rennes",
  },
  {
    label:
      "École Nationale Supérieure de Journalisme et des Sciences de l'Information",
    value:
      "École Nationale Supérieure de Journalisme et des Sciences de l'Information",
  },
  {
    label: "École Nationale Supérieure de l'Administration",
    value: "École Nationale Supérieure de l'Administration",
  },
  {
    label:
      "École Nationale Supérieure de l'Électronique et de ses Applications",
    value:
      "École Nationale Supérieure de l'Électronique et de ses Applications",
  },
  {
    label: "École Nationale Supérieure de Management",
    value: "École Nationale Supérieure de Management",
  },
  {
    label: "École Nationale Supérieure de Mécanique et d'Aérotechnique",
    value: "École Nationale Supérieure de Mécanique et d'Aérotechnique",
  },
  {
    label: "École Nationale Supérieure de Mécanique et des Microtechniques",
    value: "École Nationale Supérieure de Mécanique et des Microtechniques",
  },
  {
    label: "École Nationale Supérieure de Sciences Politiques",
    value: "École Nationale Supérieure de Sciences Politiques",
  },
  {
    label: "École Nationale Supérieure de Statistique et d'Economie Appliquée",
    value: "École Nationale Supérieure de Statistique et d'Economie Appliquée",
  },
  {
    label: "École Nationale Supérieure de Techniques Avancées Bretagne",
    value: "École Nationale Supérieure de Techniques Avancées Bretagne",
  },
  {
    label: "École Nationale Supérieure de Technologie",
    value: "École Nationale Supérieure de Technologie",
  },
  {
    label: "École Nationale Supérieure de Technologie et d’Ingénierie",
    value: "École Nationale Supérieure de Technologie et d’Ingénierie",
  },
  {
    label: "École Nationale Supérieure des Arts et Industries Textiles",
    value: "École Nationale Supérieure des Arts et Industries Textiles",
  },
  {
    label: "École Nationale Supérieure des Arts Visuels de La Cambre",
    value: "École Nationale Supérieure des Arts Visuels de La Cambre",
  },
  {
    label: "Ecole Nationale Supérieure des Forêts",
    value: "Ecole Nationale Supérieure des Forêts",
  },
  {
    label: "École Nationale Supérieure des Mines de St-Etienne",
    value: "École Nationale Supérieure des Mines de St-Etienne",
  },
  {
    label: "École Nationale Supérieure des Mines et de la Métallurgie",
    value: "École Nationale Supérieure des Mines et de la Métallurgie",
  },
  {
    label:
      "École nationale supérieure des sciences agronomiques de Bordeaux Aquitaine",
    value:
      "École nationale supérieure des sciences agronomiques de Bordeaux Aquitaine",
  },
  {
    label:
      "École Nationale Supérieure des Sciences de la Mer et de l'Aménagement du Littoral",
    value:
      "École Nationale Supérieure des Sciences de la Mer et de l'Aménagement du Littoral",
  },
  {
    label:
      "École Nationale Supérieure des Sciences de l'Information et des Bibliothèques",
    value:
      "École Nationale Supérieure des Sciences de l'Information et des Bibliothèques",
  },
  {
    label: "École Nationale Supérieure des Travaux Publics",
    value: "École Nationale Supérieure des Travaux Publics",
  },
  {
    label: "École Nationale Supérieure d'Hydraulique",
    value: "École Nationale Supérieure d'Hydraulique",
  },
  {
    label: "École Nationale Supérieure d'Informatique",
    value: "École Nationale Supérieure d'Informatique",
  },
  {
    label:
      "École Nationale Supérieure d'Informatique pour l'Industrie et l'Entreprise",
    value:
      "École Nationale Supérieure d'Informatique pour l'Industrie et l'Entreprise",
  },
  {
    label: "École Nationale Supérieure d'Ingénieurs de Caen",
    value: "École Nationale Supérieure d'Ingénieurs de Caen",
  },
  {
    label: "École Nationale Supérieure en Statistique et en Economie Appliquée",
    value: "École Nationale Supérieure en Statistique et en Economie Appliquée",
  },
  {
    label: "École Nationale Supérieure Vétérinaire d'Alger",
    value: "École Nationale Supérieure Vétérinaire d'Alger",
  },
  {
    label: "École Nationale Vétérinaire d'Alfort",
    value: "École Nationale Vétérinaire d'Alfort",
  },
  {
    label: "École Nationale Vétérinaire de Toulouse",
    value: "École Nationale Vétérinaire de Toulouse",
  },
  {
    label:
      "École Nationale Vétérinaire, Agroalimentaire et de l'alimentation de Nantes-Atlantique",
    value:
      "École Nationale Vétérinaire, Agroalimentaire et de l'alimentation de Nantes-Atlantique",
  },
  {
    label: "École Normale d'Enseignement Technique et Professionnel",
    value: "École Normale d'Enseignement Technique et Professionnel",
  },
  {
    label: "École Normale Supérieure",
    value: "École Normale Supérieure",
  },
  {
    label: "École Normale Supérieure d’Oran Ammour Ahmed",
    value: "École Normale Supérieure d’Oran Ammour Ahmed",
  },
  {
    label: "École Normale Supérieure d'Abidjan",
    value: "École Normale Supérieure d'Abidjan",
  },
  {
    label: "École Normale Supérieure de Bamako",
    value: "École Normale Supérieure de Bamako",
  },
  {
    label: "École Normale Supérieure de Béchar",
    value: "École Normale Supérieure de Béchar",
  },
  {
    label: "École Normale Supérieure de Bou Saâda",
    value: "École Normale Supérieure de Bou Saâda",
  },
  {
    label: "École Normale Supérieure de Bouzaréah",
    value: "École Normale Supérieure de Bouzaréah",
  },
  {
    label: "École Normale Supérieure de Bujumbura",
    value: "École Normale Supérieure de Bujumbura",
  },
  {
    label: "École Normale Supérieure de Constantine",
    value: "École Normale Supérieure de Constantine",
  },
  {
    label: "École Normale Supérieure de Kouba",
    value: "École Normale Supérieure de Kouba",
  },
  {
    label: "École Normale Supérieure de Laghouat",
    value: "École Normale Supérieure de Laghouat",
  },
  {
    label: "École Normale Supérieure de l'Enseignement Technique",
    value: "École Normale Supérieure de l'Enseignement Technique",
  },
  {
    label: "École Normale Supérieure de Libreville",
    value: "École Normale Supérieure de Libreville",
  },
  {
    label: "École Normale Supérieure de Lyon",
    value: "École Normale Supérieure de Lyon",
  },
  {
    label: "École Normale Supérieure de Ouargla",
    value: "École Normale Supérieure de Ouargla",
  },
  {
    label: "École Normale Supérieure de Rennes",
    value: "École Normale Supérieure de Rennes",
  },
  {
    label: "École Normale Supérieure de Sétif",
    value: "École Normale Supérieure de Sétif",
  },
  {
    label: "École Normale Supérieure d'Enseignement Technologique de Skikda",
    value: "École Normale Supérieure d'Enseignement Technologique de Skikda",
  },
  {
    label: "École Normale Supérieure Paris-Saclay",
    value: "École Normale Supérieure Paris-Saclay",
  },
  {
    label: "École Polytechnique",
    value: "École Polytechnique",
  },
  {
    label: "École Polytechnique d'Architecture et d'Urbanisme",
    value: "École Polytechnique d'Architecture et d'Urbanisme",
  },
  {
    label: "École Polytechnique de Montréal",
    value: "École Polytechnique de Montréal",
  },
  {
    label: "École polytechnique de Thiès",
    value: "École polytechnique de Thiès",
  },
  {
    label: "École Polytechnique Fédérale de Lausanne",
    value: "École Polytechnique Fédérale de Lausanne",
  },
  {
    label: "École Polytechnique Internationale Privée de Tunis",
    value: "École Polytechnique Internationale Privée de Tunis",
  },
  {
    label: "École pour l'Informatique et les Techniques Avancées",
    value: "École pour l'Informatique et les Techniques Avancées",
  },
  {
    label: "École Royale d'Administration",
    value: "École Royale d'Administration",
  },
  {
    label: "École Spéciale des Travaux Publics, du Bâtiment et de l'Industrie",
    value: "École Spéciale des Travaux Publics, du Bâtiment et de l'Industrie",
  },
  {
    label: "École Supérieur en Génie Electrique et Energétique d'Oran",
    value: "École Supérieur en Génie Electrique et Energétique d'Oran",
  },
  {
    label:
      "École Supérieure Africaine des Technologies de l'Information et de la Communication",
    value:
      "École Supérieure Africaine des Technologies de l'Information et de la Communication",
  },
  {
    label:
      "École Supérieure d'Administration, d'Economie, de Journalisme et des Métiers de l'Audiovisuel",
    value:
      "École Supérieure d'Administration, d'Economie, de Journalisme et des Métiers de l'Audiovisuel",
  },
  {
    label: "École Supérieure d'Agriculture d'Angers",
    value: "École Supérieure d'Agriculture d'Angers",
  },
  {
    label: "École Supérieure d'Agro-développement International",
    value: "École Supérieure d'Agro-développement International",
  },
  {
    label: "École Supérieure d'Architecture de Casablanca",
    value: "École Supérieure d'Architecture de Casablanca",
  },
  {
    label: "École Supérieure de Chimie Organique et Minérale",
    value: "École Supérieure de Chimie Organique et Minérale",
  },
  {
    label: "École Supérieure de Chimie Physique Électronique de Lyon",
    value: "École Supérieure de Chimie Physique Électronique de Lyon",
  },
  {
    label: "École Supérieure de Commerce",
    value: "École Supérieure de Commerce",
  },
  {
    label: "École Supérieure de Commerce d'Amiens",
    value: "École Supérieure de Commerce d'Amiens",
  },
  {
    label: "École Supérieure de Commerce de Dakar",
    value: "École Supérieure de Commerce de Dakar",
  },
  {
    label: "École Superieure de Commerce de Marrakech",
    value: "École Superieure de Commerce de Marrakech",
  },
  {
    label: "École Supérieure de Commerce et de Développement 3A",
    value: "École Supérieure de Commerce et de Développement 3A",
  },
  {
    label: "École Supérieure de Comptabilité et de Finances de Constantine",
    value: "École Supérieure de Comptabilité et de Finances de Constantine",
  },
  {
    label: "École Supérieure de Fonderie et de Forge",
    value: "École Supérieure de Fonderie et de Forge",
  },
  {
    label: "École Supérieure de Génie Civil Verechaguine AK",
    value: "École Supérieure de Génie Civil Verechaguine AK",
  },
  {
    label: "École Supérieure de Génies",
    value: "École Supérieure de Génies",
  },
  {
    label: "École Supérieure de Gestion et d'Expertise Comptable",
    value: "École Supérieure de Gestion et d'Expertise Comptable",
  },
  {
    label: "École Supérieure de Gestion, d'Informatique et des Sciences",
    value: "École Supérieure de Gestion, d'Informatique et des Sciences",
  },
  {
    label: "École Supérieure de la Magistrature",
    value: "École Supérieure de la Magistrature",
  },
  {
    label: "École Supérieure de la Mer",
    value: "École Supérieure de la Mer",
  },
  {
    label: "École Supérieure de Management Benin",
    value: "École Supérieure de Management Benin",
  },
  {
    label: "École Supérieure de Management de Tlemcen",
    value: "École Supérieure de Management de Tlemcen",
  },
  {
    label:
      "École supérieure de physique et de chimie industrielles de la Ville de Paris",
    value:
      "École supérieure de physique et de chimie industrielles de la Ville de Paris",
  },
  {
    label:
      "École Supérieure de Télécommunication d'Informatique et de Management",
    value:
      "École Supérieure de Télécommunication d'Informatique et de Management",
  },
  {
    label: "École Supérieure d'Economie d'Oran",
    value: "École Supérieure d'Economie d'Oran",
  },
  {
    label: "École Supérieure d'Electricité, du Bâtiment et des Travaux Publics",
    value: "École Supérieure d'Electricité, du Bâtiment et des Travaux Publics",
  },
  {
    label: "École Supérieure d'Électronique de l'Ouest",
    value: "École Supérieure d'Électronique de l'Ouest",
  },
  {
    label: "École Supérieure des Affaires",
    value: "École Supérieure des Affaires",
  },
  {
    label: "École Supérieure des Arts Saint-Luc de Liège",
    value: "École Supérieure des Arts Saint-Luc de Liège",
  },
  {
    label: "École Supérieure des Métiers des Énergies Renouvelables",
    value: "École Supérieure des Métiers des Énergies Renouvelables",
  },
  {
    label: "École Supérieure des Sciences Appliquées d'Alger",
    value: "École Supérieure des Sciences Appliquées d'Alger",
  },
  {
    label: "École Supérieure des Sciences de Gestion de Annaba",
    value: "École Supérieure des Sciences de Gestion de Annaba",
  },
  {
    label:
      "École Supérieure des Sciences de l'Aliment et Industries Agroalimentaires",
    value:
      "École Supérieure des Sciences de l'Aliment et Industries Agroalimentaires",
  },
  {
    label: "École Supérieure des Sciences Économiques et Commerciales",
    value: "École Supérieure des Sciences Économiques et Commerciales",
  },
  {
    label:
      "École Supérieure des Techniques Aéronautiques et de Construction Automobile",
    value:
      "École Supérieure des Techniques Aéronautiques et de Construction Automobile",
  },
  {
    label: "École supérieure des technologies et des affaires de Belfort",
    value: "École supérieure des technologies et des affaires de Belfort",
  },
  {
    label: "École Supérieure des Technologies Industrielles Avancées",
    value: "École Supérieure des Technologies Industrielles Avancées",
  },
  {
    label: "École Supérieure d'Informatique, Électronique, Automatique",
    value: "École Supérieure d'Informatique, Électronique, Automatique",
  },
  {
    label:
      "École Supérieure d'Ingénieurs des Travaux de la Construction de Metz",
    value:
      "École Supérieure d'Ingénieurs des Travaux de la Construction de Metz",
  },
  {
    label:
      "École Supérieure d'Ingénieurs des Travaux de la Construction de Paris",
    value:
      "École Supérieure d'Ingénieurs des Travaux de la Construction de Paris",
  },
  {
    label: "École Supérieure d'Ingénieurs en Génie Électrique",
    value: "École Supérieure d'Ingénieurs en Génie Électrique",
  },
  {
    label: "École Supérieure d'Ingénieurs Léonard de Vinci",
    value: "École Supérieure d'Ingénieurs Léonard de Vinci",
  },
  {
    label: "École Superieure d'Ingénieurs Privée de Gafsa",
    value: "École Superieure d'Ingénieurs Privée de Gafsa",
  },
  {
    label: "École Supérieure du Bâtiment",
    value: "École Supérieure du Bâtiment",
  },
  {
    label: "École Supérieure du Bois",
    value: "École Supérieure du Bois",
  },
  {
    label: "École Supérieure du Commerce Extérieur",
    value: "École Supérieure du Commerce Extérieur",
  },
  {
    label: "École Supérieure en Informatique",
    value: "École Supérieure en Informatique",
  },
  {
    label:
      "École Supérieure en Ingénierie de l'Information, Télécoms, Management et Génie Civil",
    value:
      "École Supérieure en Ingénierie de l'Information, Télécoms, Management et Génie Civil",
  },
  {
    label: "École Supérieure en Sciences Appliquées de Tlemcen",
    value: "École Supérieure en Sciences Appliquées de Tlemcen",
  },
  {
    label: "École Supérieure en Sciences Biologiques d'Oran",
    value: "École Supérieure en Sciences Biologiques d'Oran",
  },
  {
    label: "École Supérieure Polytechnique Internationale Privée de Sfax",
    value: "École Supérieure Polytechnique Internationale Privée de Sfax",
  },
  {
    label: "École Supérieure Polytechnique Privée de Monastir",
    value: "École Supérieure Polytechnique Privée de Monastir",
  },
  {
    label: "École Supérieure Polytechnique Privée de Sousse",
    value: "École Supérieure Polytechnique Privée de Sousse",
  },
  {
    label:
      "École Supérieure Privée d'Administration des Affaires et de Droit Avicenne",
    value:
      "École Supérieure Privée d'Administration des Affaires et de Droit Avicenne",
  },
  {
    label: "École Supérieure Privée d'Architecture, d'Audiovisuel et de Design",
    value: "École Supérieure Privée d'Architecture, d'Audiovisuel et de Design",
  },
  {
    label: "École Supérieure Privée d'Assurance et de Finance",
    value: "École Supérieure Privée d'Assurance et de Finance",
  },
  {
    label: "École Supérieure Privée de l'Aéronautique et des Technologies",
    value: "École Supérieure Privée de l'Aéronautique et des Technologies",
  },
  {
    label: "École Supérieure Privée de Technologie et de Management",
    value: "École Supérieure Privée de Technologie et de Management",
  },
  {
    label: "École Supérieure Privée des Etudes Administratives et Commerciales",
    value: "École Supérieure Privée des Etudes Administratives et Commerciales",
  },
  {
    label:
      "École Supérieure Privée des Technologies de l'Information et de Management de Nabeul",
    value:
      "École Supérieure Privée des Technologies de l'Information et de Management de Nabeul",
  },
  {
    label:
      "École Supérieure Privée des Technologies d'Informatique et de Management",
    value:
      "École Supérieure Privée des Technologies d'Informatique et de Management",
  },
  {
    label: "École Supérieure Privée des Technologies et Ingénierie",
    value: "École Supérieure Privée des Technologies et Ingénierie",
  },
  {
    label:
      "École Supérieure Privée d'Informatique et d'Administration des Affaires",
    value:
      "École Supérieure Privée d'Informatique et d'Administration des Affaires",
  },
  {
    label: "École Supérieure Privée d'Ingénierie et de Technologie",
    value: "École Supérieure Privée d'Ingénierie et de Technologie",
  },
  {
    label: "École Supérieure Privée d'Ingénierie et de Technologie Appliquée",
    value: "École Supérieure Privée d'Ingénierie et de Technologie Appliquée",
  },
  {
    label: "École Supérieure Privée d'Ingénieurs de Monastir",
    value: "École Supérieure Privée d'Ingénieurs de Monastir",
  },
  {
    label: "École Supérieure Sainte Félicité",
    value: "École Supérieure Sainte Félicité",
  },
  {
    label: "Economics and Finance Institute",
    value: "Economics and Finance Institute",
  },
  {
    label: "ECPI University",
    value: "ECPI University",
  },
  {
    label: "Eden University",
    value: "Eden University",
  },
  {
    label: "Edge Hill University",
    value: "Edge Hill University",
  },
  {
    label: "Edgewood College",
    value: "Edgewood College",
  },
  {
    label: "Edinburgh Napier University",
    value: "Edinburgh Napier University",
  },
  {
    label: "Edith Cowan University",
    value: "Edith Cowan University",
  },
  {
    label: "Edo State University Uzairue",
    value: "Edo State University Uzairue",
  },
  {
    label: "Edogawa University",
    value: "Edogawa University",
  },
  {
    label: "EDP University",
    value: "EDP University",
  },
  {
    label: "Edrak Institute of Higher Education",
    value: "Edrak Institute of Higher Education",
  },
  {
    label: "Edutus Egyetem",
    value: "Edutus Egyetem",
  },
  {
    label: "Edward Waters University",
    value: "Edward Waters University",
  },
  {
    label: "Edwin Clark University",
    value: "Edwin Clark University",
  },
  {
    label: "EELK Usuteaduse Instituut",
    value: "EELK Usuteaduse Instituut",
  },
  {
    label: "Eesti Ettevõtluskõrgkool Mainor",
    value: "Eesti Ettevõtluskõrgkool Mainor",
  },
  {
    label: "Eesti Kunstiakadeemia",
    value: "Eesti Kunstiakadeemia",
  },
  {
    label: "Eesti Lennuakadeemia",
    value: "Eesti Lennuakadeemia",
  },
  {
    label: "Eesti Maaülikool",
    value: "Eesti Maaülikool",
  },
  {
    label: "Eesti Muusika- ja Teatriakadeemia",
    value: "Eesti Muusika- ja Teatriakadeemia",
  },
  {
    label: "Effat University",
    value: "Effat University",
  },
  {
    label: "Egas Moniz - Cooperativa de Ensino Superior",
    value: "Egas Moniz - Cooperativa de Ensino Superior",
  },
  {
    label: "Ege Üniversitesi",
    value: "Ege Üniversitesi",
  },
  {
    label: "Egerton University",
    value: "Egerton University",
  },
  {
    label: "Egyptian Chinese University",
    value: "Egyptian Chinese University",
  },
  {
    label: "Egyptian Russian University",
    value: "Egyptian Russian University",
  },
  {
    label: "Egypt-Japan University of Science and Technology",
    value: "Egypt-Japan University of Science and Technology",
  },
  {
    label: "Ehime Prefectural University of Health Sciences",
    value: "Ehime Prefectural University of Health Sciences",
  },
  {
    label: "Ehime University",
    value: "Ehime University",
  },
  {
    label: "Eidgenössische Technische Hochschule Zürich",
    value: "Eidgenössische Technische Hochschule Zürich",
  },
  {
    label: "EIILM University",
    value: "EIILM University",
  },
  {
    label: "Eikei University of Hiroshima",
    value: "Eikei University of Hiroshima",
  },
  {
    label: "Eiropas Kristiga akademija",
    value: "Eiropas Kristiga akademija",
  },
  {
    label: "Ekiti State University, Ado Ekiti",
    value: "Ekiti State University, Ado Ekiti",
  },
  {
    label: "Eklore-ed School of Management",
    value: "Eklore-ed School of Management",
  },
  {
    label: "Eko University of Medical and Health Sciences",
    value: "Eko University of Medical and Health Sciences",
  },
  {
    label: "Ekonomická univerzita v Bratislave",
    value: "Ekonomická univerzita v Bratislave",
  },
  {
    label: "Ekonomikas un kulturas augstskola",
    value: "Ekonomikas un kulturas augstskola",
  },
  {
    label: "El Colegio de Chihuahua",
    value: "El Colegio de Chihuahua",
  },
  {
    label: "El Colegio de México",
    value: "El Colegio de México",
  },
  {
    label: "El Colegio de Sonora",
    value: "El Colegio de Sonora",
  },
  {
    label: "El Colegio Mexiquense A.C.",
    value: "El Colegio Mexiquense A.C.",
  },
  {
    label: "Eldaein University",
    value: "Eldaein University",
  },
  {
    label: "Elisabeth University of Music",
    value: "Elisabeth University of Music",
  },
  {
    label: "Elizabeth City State University",
    value: "Elizabeth City State University",
  },
  {
    label: "Elizabethtown College",
    value: "Elizabethtown College",
  },
  {
    label: "Elizade University",
    value: "Elizade University",
  },
  {
    label: "Elmergib University",
    value: "Elmergib University",
  },
  {
    label: "Elmhurst University",
    value: "Elmhurst University",
  },
  {
    label: "Elmira College",
    value: "Elmira College",
  },
  {
    label: "Elon University",
    value: "Elon University",
  },
  {
    label: "Elrazi University",
    value: "Elrazi University",
  },
  {
    label: "Elsheikh Abdallah Elbadri University",
    value: "Elsheikh Abdallah Elbadri University",
  },
  {
    label: "Embry-Riddle Aeronautical University",
    value: "Embry-Riddle Aeronautical University",
  },
  {
    label: "Emerson College",
    value: "Emerson College",
  },
  {
    label: "Emilio Aguinaldo College",
    value: "Emilio Aguinaldo College",
  },
  {
    label: "Emily Carr University of Art and Design",
    value: "Emily Carr University of Art and Design",
  },
  {
    label: "Emirates Aviation University",
    value: "Emirates Aviation University",
  },
  {
    label: "Emirates College for Advanced Education",
    value: "Emirates College for Advanced Education",
  },
  {
    label: "Emirates Institute of Finance",
    value: "Emirates Institute of Finance",
  },
  {
    label: "Emirates International University",
    value: "Emirates International University",
  },
  {
    label: "EMLYON Business School",
    value: "EMLYON Business School",
  },
  {
    label: "Emmanuel College",
    value: "Emmanuel College",
  },
  {
    label: "Emmanuel University",
    value: "Emmanuel University",
  },
  {
    label: "Emmaus Bible College",
    value: "Emmaus Bible College",
  },
  {
    label: "Emory & Henry College",
    value: "Emory & Henry College",
  },
  {
    label: "Emory University",
    value: "Emory University",
  },
  {
    label: "Empire State University",
    value: "Empire State University",
  },
  {
    label: "Emporia State University",
    value: "Emporia State University",
  },
  {
    label: "Endicott College",
    value: "Endicott College",
  },
  {
    label: "Enerel Medical Institute",
    value: "Enerel Medical Institute",
  },
  {
    label: "Engineering Higher Education Complex of Esfarayen",
    value: "Engineering Higher Education Complex of Esfarayen",
  },
  {
    label: "ENSAE Paris",
    value: "ENSAE Paris",
  },
  {
    label: "ENSTA Paris",
    value: "ENSTA Paris",
  },
  {
    label: "Ensup Afrique",
    value: "Ensup Afrique",
  },
  {
    label: "Enugu State University of Science and Technology",
    value: "Enugu State University of Science and Technology",
  },
  {
    label: "Eötvös József Foiskola",
    value: "Eötvös József Foiskola",
  },
  {
    label: "Eötvös Loránd Tudományegyetem",
    value: "Eötvös Loránd Tudományegyetem",
  },
  {
    label: "EPF École d'Ingénieurs",
    value: "EPF École d'Ingénieurs",
  },
  {
    label: "EPI Sousse",
    value: "EPI Sousse",
  },
  {
    label: "Era University",
    value: "Era University",
  },
  {
    label: "Erasmus Universiteit Rotterdam",
    value: "Erasmus Universiteit Rotterdam",
  },
  {
    label: "Erasmushogeschool Brussel",
    value: "Erasmushogeschool Brussel",
  },
  {
    label: "Erbil Polytechnic University",
    value: "Erbil Polytechnic University",
  },
  {
    label: "Erciyes Üniversitesi",
    value: "Erciyes Üniversitesi",
  },
  {
    label: "Erhvervsakademi Aarhus",
    value: "Erhvervsakademi Aarhus",
  },
  {
    label: "Erhvervsakademi Dania",
    value: "Erhvervsakademi Dania",
  },
  {
    label: "Erhvervsakademi Midtvest",
    value: "Erhvervsakademi Midtvest",
  },
  {
    label: "Erhvervsakademi Sjælland",
    value: "Erhvervsakademi Sjælland",
  },
  {
    label: "Erhvervsakademi SydVest",
    value: "Erhvervsakademi SydVest",
  },
  {
    label: "Erhvervsakademiet Copenhagen Business",
    value: "Erhvervsakademiet Copenhagen Business",
  },
  {
    label: "Eritrea Institute of Technology",
    value: "Eritrea Institute of Technology",
  },
  {
    label: "Ernest Bai Koroma University of Science and Technology",
    value: "Ernest Bai Koroma University of Science and Technology",
  },
  {
    label: "Ernst-Abbe-Hochschule Jena",
    value: "Ernst-Abbe-Hochschule Jena",
  },
  {
    label: "Ernst-Moritz-Arndt-Universität Greifswald",
    value: "Ernst-Moritz-Arndt-Universität Greifswald",
  },
  {
    label: "Erskine College",
    value: "Erskine College",
  },
  {
    label: "Erzincan Binali Yildirim Üniversitesi",
    value: "Erzincan Binali Yildirim Üniversitesi",
  },
  {
    label: "Erzurum Teknik Üniversitesi",
    value: "Erzurum Teknik Üniversitesi",
  },
  {
    label: "ESAIP École d'Ingénieurs",
    value: "ESAIP École d'Ingénieurs",
  },
  {
    label: "ESCA École de Management",
    value: "ESCA École de Management",
  },
  {
    label: "Escola Superior Artística do Porto",
    value: "Escola Superior Artística do Porto",
  },
  {
    label: "Escola Superior de Artes e Design",
    value: "Escola Superior de Artes e Design",
  },
  {
    label: "Escola Superior de Atividades Imobiliárias",
    value: "Escola Superior de Atividades Imobiliárias",
  },
  {
    label: "Escola Superior de Educação de João de Deus",
    value: "Escola Superior de Educação de João de Deus",
  },
  {
    label: "Escola Superior de Educação de Paula Frassinetti",
    value: "Escola Superior de Educação de Paula Frassinetti",
  },
  {
    label: "Escola Superior de Educadores de Infância Maria Ulrich",
    value: "Escola Superior de Educadores de Infância Maria Ulrich",
  },
  {
    label: "Escola Superior de Enfermagem Cruz Vermelha Portuguesa",
    value: "Escola Superior de Enfermagem Cruz Vermelha Portuguesa",
  },
  {
    label: "Escola Superior de Enfermagem de Coimbra",
    value: "Escola Superior de Enfermagem de Coimbra",
  },
  {
    label: "Escola Superior de Enfermagem de Lisboa",
    value: "Escola Superior de Enfermagem de Lisboa",
  },
  {
    label: "Escola Superior de Enfermagem de São José de Cluny",
    value: "Escola Superior de Enfermagem de São José de Cluny",
  },
  {
    label: "Escola Superior de Enfermagem do Porto",
    value: "Escola Superior de Enfermagem do Porto",
  },
  {
    label: "Escola Superior de Enfermagem São Francisco das Misericórdias",
    value: "Escola Superior de Enfermagem São Francisco das Misericórdias",
  },
  {
    label: "Escola Superior de Hotelaria e Turismo do Estoril",
    value: "Escola Superior de Hotelaria e Turismo do Estoril",
  },
  {
    label: "Escola Superior de Negócios Atlântico",
    value: "Escola Superior de Negócios Atlântico",
  },
  {
    label: "Escola Superior de Saúde da Cruz Vermelha Portuguesa",
    value: "Escola Superior de Saúde da Cruz Vermelha Portuguesa",
  },
  {
    label: "Escola Superior de Saúde de Santa Maria",
    value: "Escola Superior de Saúde de Santa Maria",
  },
  {
    label: "Escola Superior de Saúde do Alcoitão",
    value: "Escola Superior de Saúde do Alcoitão",
  },
  {
    label: "Escola Superior de Saúde Norte da Cruz Vermelha Portuguesa",
    value: "Escola Superior de Saúde Norte da Cruz Vermelha Portuguesa",
  },
  {
    label: "Escola Superior Náutica Infante D. Henrique",
    value: "Escola Superior Náutica Infante D. Henrique",
  },
  {
    label: "Escola Universitária Vasco da Gama",
    value: "Escola Universitária Vasco da Gama",
  },
  {
    label: "ESCP Business School",
    value: "ESCP Business School",
  },
  {
    label: "Escuela Agrícola Panamericana, Zamorano",
    value: "Escuela Agrícola Panamericana, Zamorano",
  },
  {
    label: "Escuela Bancaria y Comercial",
    value: "Escuela Bancaria y Comercial",
  },
  {
    label: "Escuela Colombiana de Ingenieria Julio Garavito",
    value: "Escuela Colombiana de Ingenieria Julio Garavito",
  },
  {
    label: "Escuela de Artes Plasticas y Diseno de Puerto Rico",
    value: "Escuela de Artes Plasticas y Diseno de Puerto Rico",
  },
  {
    label: "Escuela de Comunicación Mónica Herrera",
    value: "Escuela de Comunicación Mónica Herrera",
  },
  {
    label: "Escuela de Medicina San Juan Bautista",
    value: "Escuela de Medicina San Juan Bautista",
  },
  {
    label: "Escuela Especializada en Ingeniería ITCA-FEPADE",
    value: "Escuela Especializada en Ingeniería ITCA-FEPADE",
  },
  {
    label: "Escuela Latinoamericana de Medicina",
    value: "Escuela Latinoamericana de Medicina",
  },
  {
    label: "Escuela Militar de Ingeniería",
    value: "Escuela Militar de Ingeniería",
  },
  {
    label: "Escuela Nacional de la Judicatura",
    value: "Escuela Nacional de la Judicatura",
  },
  {
    label: "Escuela Nacional del Deporte",
    value: "Escuela Nacional del Deporte",
  },
  {
    label: "Escuela Politécnica Nacional",
    value: "Escuela Politécnica Nacional",
  },
  {
    label: "Escuela Superior de Administración Pública",
    value: "Escuela Superior de Administración Pública",
  },
  {
    label: "Escuela Superior de Economía y Negocios",
    value: "Escuela Superior de Economía y Negocios",
  },
  {
    label: "Escuela Superior de Empresa, Ingeniería y Tecnología",
    value: "Escuela Superior de Empresa, Ingeniería y Tecnología",
  },
  {
    label: "Escuela Superior Franciscana Especializada AGAPE",
    value: "Escuela Superior Franciscana Especializada AGAPE",
  },
  {
    label: "Escuela Superior Politecnica Agropecuaria de Manabi",
    value: "Escuela Superior Politecnica Agropecuaria de Manabi",
  },
  {
    label: "Escuela Superior Politecnica de Chimborazo",
    value: "Escuela Superior Politecnica de Chimborazo",
  },
  {
    label: "Escuela Superior Politécnica del Litoral",
    value: "Escuela Superior Politécnica del Litoral",
  },
  {
    label: "Escuela Tecnologica Instituto Tecnico Central",
    value: "Escuela Tecnologica Instituto Tecnico Central",
  },
  {
    label: "Esep Le Berger",
    value: "Esep Le Berger",
  },
  {
    label: "ESF College of Women's Society in Ramallah",
    value: "ESF College of Women's Society in Ramallah",
  },
  {
    label: "Eshrag Institute of Higher Education",
    value: "Eshrag Institute of Higher Education",
  },
  {
    label: "ESIEE Paris",
    value: "ESIEE Paris",
  },
  {
    label: "Esil University",
    value: "Esil University",
  },
  {
    label: "Eskisehir Osmangazi Üniversitesi",
    value: "Eskisehir Osmangazi Üniversitesi",
  },
  {
    label: "ESME Sudria",
    value: "ESME Sudria",
  },
  {
    label: "ESMT Berlin",
    value: "ESMT Berlin",
  },
  {
    label: "ESSCA School of Management",
    value: "ESSCA School of Management",
  },
  {
    label: "Esteghlal Institute of Higher Education",
    value: "Esteghlal Institute of Higher Education",
  },
  {
    label: "Esteqamat Higher Education Institute",
    value: "Esteqamat Higher Education Institute",
  },
  {
    label: "Eswatini College of Technology",
    value: "Eswatini College of Technology",
  },
  {
    label: "Eswatini Medical Christian University",
    value: "Eswatini Medical Christian University",
  },
  {
    label: "Esztergomi Hittudományi Fõiskola",
    value: "Esztergomi Hittudományi Fõiskola",
  },
  {
    label: "Eszterházy Károly Egyetem",
    value: "Eszterházy Károly Egyetem",
  },
  {
    label: "Eternal University",
    value: "Eternal University",
  },
  {
    label: "Ethiopian Civil Service University",
    value: "Ethiopian Civil Service University",
  },
  {
    label: "Etugen University",
    value: "Etugen University",
  },
  {
    label: "Eulji University",
    value: "Eulji University",
  },
  {
    label: "Eulogio 'Amang' Rodriguez Institute of Science and Technology",
    value: "Eulogio 'Amang' Rodriguez Institute of Science and Technology",
  },
  {
    label: "Eurasia International University",
    value: "Eurasia International University",
  },
  {
    label: "Eurasian Academy of Law after D.A. Kunaev",
    value: "Eurasian Academy of Law after D.A. Kunaev",
  },
  {
    label: "Eurasian Institute for the Humanities",
    value: "Eurasian Institute for the Humanities",
  },
  {
    label: "Eurasian Technological University",
    value: "Eurasian Technological University",
  },
  {
    label: "Eurecom",
    value: "Eurecom",
  },
  {
    label: "Eureka College",
    value: "Eureka College",
  },
  {
    label: "Europäische Fachhochschule",
    value: "Europäische Fachhochschule",
  },
  {
    label: "Europa-Universität Flensburg",
    value: "Europa-Universität Flensburg",
  },
  {
    label: "Europa-Universität Viadrina Frankfurt (Oder)",
    value: "Europa-Universität Viadrina Frankfurt (Oder)",
  },
  {
    label: "European Graduate School of Economics and Management",
    value: "European Graduate School of Economics and Management",
  },
  {
    label: "European Polytechnical University",
    value: "European Polytechnical University",
  },
  {
    label: "European School of Economics",
    value: "European School of Economics",
  },
  {
    label: "European University",
    value: "European University",
  },
  {
    label: "European University",
    value: "European University",
  },
  {
    label: "European University",
    value: "European University",
  },
  {
    label: "European University",
    value: "European University",
  },
  {
    label: "European University at St. Petersburg",
    value: "European University at St. Petersburg",
  },
  {
    label: "European University College",
    value: "European University College",
  },
  {
    label: "European University Cyprus",
    value: "European University Cyprus",
  },
  {
    label: "European University of Bangladesh",
    value: "European University of Bangladesh",
  },
  {
    label: "Europos Humanitarinis Universitetas",
    value: "Europos Humanitarinis Universitetas",
  },
  {
    label: "Europska poslovna škola Zagreb",
    value: "Europska poslovna škola Zagreb",
  },
  {
    label: "Evangel University",
    value: "Evangel University",
  },
  {
    label: "Evangel University, Akaeze",
    value: "Evangel University, Akaeze",
  },
  {
    label: "Evangelical Presbyterian University College",
    value: "Evangelical Presbyterian University College",
  },
  {
    label: "Evangelical University",
    value: "Evangelical University",
  },
  {
    label: "Evangelische Hochschule Berlin",
    value: "Evangelische Hochschule Berlin",
  },
  {
    label: "Evangelische Hochschule Darmstadt",
    value: "Evangelische Hochschule Darmstadt",
  },
  {
    label: "Evangelische Hochschule Dresden",
    value: "Evangelische Hochschule Dresden",
  },
  {
    label: "Evangelische Hochschule Freiburg",
    value: "Evangelische Hochschule Freiburg",
  },
  {
    label: "Evangelische Hochschule für Kirchenmusik",
    value: "Evangelische Hochschule für Kirchenmusik",
  },
  {
    label: "Evangelische Hochschule für Soziale Arbeit und Diakonie",
    value: "Evangelische Hochschule für Soziale Arbeit und Diakonie",
  },
  {
    label: "Evangelische Hochschule Ludwigsburg",
    value: "Evangelische Hochschule Ludwigsburg",
  },
  {
    label: "Evangelische Hochschule Nürnberg",
    value: "Evangelische Hochschule Nürnberg",
  },
  {
    label: "Evangelische Hochschule Rheinland-Westfalen-Lippe",
    value: "Evangelische Hochschule Rheinland-Westfalen-Lippe",
  },
  {
    label: "Evangelische Theologische Faculteit",
    value: "Evangelische Theologische Faculteit",
  },
  {
    label: "Everglades University",
    value: "Everglades University",
  },
  {
    label: "Evropski Univerzitet",
    value: "Evropski Univerzitet",
  },
  {
    label: "Evropski univerzitet Brcko distrikt",
    value: "Evropski univerzitet Brcko distrikt",
  },
  {
    label: "Evropski univerzitet Kallos Tuzla",
    value: "Evropski univerzitet Kallos Tuzla",
  },
  {
    label: "Ewha Womans University",
    value: "Ewha Womans University",
  },
  {
    label: "Excelia",
    value: "Excelia",
  },
  {
    label: "Exim Bank Agricultural University of Bangladesh",
    value: "Exim Bank Agricultural University of Bangladesh",
  },
  {
    label: "Exploits University",
    value: "Exploits University",
  },
  {
    label: "Fachhochschule Aachen",
    value: "Fachhochschule Aachen",
  },
  {
    label: "Fachhochschule Burgenland",
    value: "Fachhochschule Burgenland",
  },
  {
    label: "Fachhochschule Campus Wien",
    value: "Fachhochschule Campus Wien",
  },
  {
    label: "Fachhochschule der Diakonie",
    value: "Fachhochschule der Diakonie",
  },
  {
    label: "Fachhochschule der Wirtschaft",
    value: "Fachhochschule der Wirtschaft",
  },
  {
    label: "Fachhochschule des bfi Wien",
    value: "Fachhochschule des bfi Wien",
  },
  {
    label: "Fachhochschule des Mittelstands",
    value: "Fachhochschule des Mittelstands",
  },
  {
    label: "Fachhochschule Dortmund",
    value: "Fachhochschule Dortmund",
  },
  {
    label: "Fachhochschule Dresden",
    value: "Fachhochschule Dresden",
  },
  {
    label: "Fachhochschule Erfurt",
    value: "Fachhochschule Erfurt",
  },
  {
    label: "Fachhochschule für die Wirtschaft Hannover",
    value: "Fachhochschule für die Wirtschaft Hannover",
  },
  {
    label: "Fachhochschule für Finanzen NRW",
    value: "Fachhochschule für Finanzen NRW",
  },
  {
    label: "Fachhochschule für Rechtspflege Nordrhein-Westfalen",
    value: "Fachhochschule für Rechtspflege Nordrhein-Westfalen",
  },
  {
    label: "Fachhochschule für Sport und Management Potsdam",
    value: "Fachhochschule für Sport und Management Potsdam",
  },
  {
    label: "Fachhochschule Kärnten",
    value: "Fachhochschule Kärnten",
  },
  {
    label: "Fachhochschule Kiel",
    value: "Fachhochschule Kiel",
  },
  {
    label: "Fachhochschule Kufstein Tirol",
    value: "Fachhochschule Kufstein Tirol",
  },
  {
    label: "Fachhochschule Münster",
    value: "Fachhochschule Münster",
  },
  {
    label: "Fachhochschule Nordwestschweiz",
    value: "Fachhochschule Nordwestschweiz",
  },
  {
    label: "Fachhochschule Ostschweiz",
    value: "Fachhochschule Ostschweiz",
  },
  {
    label: "Fachhochschule Potsdam",
    value: "Fachhochschule Potsdam",
  },
  {
    label: "Fachhochschule Salzburg",
    value: "Fachhochschule Salzburg",
  },
  {
    label: "Fachhochschule St. Pölten",
    value: "Fachhochschule St. Pölten",
  },
  {
    label: "Fachhochschule Südwestfalen",
    value: "Fachhochschule Südwestfalen",
  },
  {
    label: "Fachhochschule Technikum Wien",
    value: "Fachhochschule Technikum Wien",
  },
  {
    label: "Fachhochschule Vorarlberg",
    value: "Fachhochschule Vorarlberg",
  },
  {
    label: "Fachhochschule Wedel",
    value: "Fachhochschule Wedel",
  },
  {
    label: "Fachhochschule Westküste",
    value: "Fachhochschule Westküste",
  },
  {
    label: "Fachhochschule Wiener Neustadt",
    value: "Fachhochschule Wiener Neustadt",
  },
  {
    label: "Facultad de Teología del Uruguay Mons. Mariano Soler",
    value: "Facultad de Teología del Uruguay Mons. Mariano Soler",
  },
  {
    label: "Facultad Latinoamericana de Ciencias Sociales",
    value: "Facultad Latinoamericana de Ciencias Sociales",
  },
  {
    label: "Facultad Latinoamericana de Ciencias Sociales, Ecuador",
    value: "Facultad Latinoamericana de Ciencias Sociales, Ecuador",
  },
  {
    label: "Faculté des Sciences de la Santé",
    value: "Faculté des Sciences de la Santé",
  },
  {
    label:
      "Faculté Privée de Management et des Sciences de l'Administration de Sousse",
    value:
      "Faculté Privée de Management et des Sciences de l'Administration de Sousse",
  },
  {
    label: "Fahad Bin Sultan University",
    value: "Fahad Bin Sultan University",
  },
  {
    label: "Fairfield University",
    value: "Fairfield University",
  },
  {
    label: "Fairleigh Dickinson University",
    value: "Fairleigh Dickinson University",
  },
  {
    label: "Fairmont State University",
    value: "Fairmont State University",
  },
  {
    label: "Faith Baptist Bible College and Theological Seminary",
    value: "Faith Baptist Bible College and Theological Seminary",
  },
  {
    label: "Fakir Mohan University",
    value: "Fakir Mohan University",
  },
  {
    label: "Fakulteta za komercialne in poslovne vede",
    value: "Fakulteta za komercialne in poslovne vede",
  },
  {
    label: "Fakulteta za pravo in ekonomijo",
    value: "Fakulteta za pravo in ekonomijo",
  },
  {
    label:
      "Fakulteta za psihoterapevtsko znanost Univerze Sigmunda Freuda v Ljubljani",
    value:
      "Fakulteta za psihoterapevtsko znanost Univerze Sigmunda Freuda v Ljubljani",
  },
  {
    label: "Fakulteta za tehnologijo polimerov",
    value: "Fakulteta za tehnologijo polimerov",
  },
  {
    label: "Fakulteta za uporabne družbene študije v Novi Gorici",
    value: "Fakulteta za uporabne družbene študije v Novi Gorici",
  },
  {
    label: "Fakulteta za varstvo okolja",
    value: "Fakulteta za varstvo okolja",
  },
  {
    label: "Fakulteta za zdravstvo Angele Boškin",
    value: "Fakulteta za zdravstvo Angele Boškin",
  },
  {
    label: "Falmouth University",
    value: "Falmouth University",
  },
  {
    label: "Fanoos Institute of Higher Education",
    value: "Fanoos Institute of Higher Education",
  },
  {
    label: "Far East State Agrarian University",
    value: "Far East State Agrarian University",
  },
  {
    label: "Far East University",
    value: "Far East University",
  },
  {
    label: "Far East University, Korea",
    value: "Far East University, Korea",
  },
  {
    label: "Far Eastern Federal University",
    value: "Far Eastern Federal University",
  },
  {
    label: "Far Eastern State Medical University",
    value: "Far Eastern State Medical University",
  },
  {
    label: "Far Eastern State Technical Fisheries University",
    value: "Far Eastern State Technical Fisheries University",
  },
  {
    label: "Far Eastern State Transport University",
    value: "Far Eastern State Transport University",
  },
  {
    label: "Far Eastern University",
    value: "Far Eastern University",
  },
  {
    label: "Far Western University",
    value: "Far Western University",
  },
  {
    label: "Fareast International University",
    value: "Fareast International University",
  },
  {
    label: "Farg'ona Davlat Universiteti",
    value: "Farg'ona Davlat Universiteti",
  },
  {
    label: "Farg'ona jamoat salomatligi tibbiyot instituti",
    value: "Farg'ona jamoat salomatligi tibbiyot instituti",
  },
  {
    label: "Farg'ona Politexnika Instituti",
    value: "Farg'ona Politexnika Instituti",
  },
  {
    label: "Farmingdale State College",
    value: "Farmingdale State College",
  },
  {
    label: "Faryab University",
    value: "Faryab University",
  },
  {
    label: "Fasa University",
    value: "Fasa University",
  },
  {
    label: "Fasa University of Medical Sciences",
    value: "Fasa University of Medical Sciences",
  },
  {
    label: "Fashion Institute of Technology",
    value: "Fashion Institute of Technology",
  },
  {
    label: "FATA University",
    value: "FATA University",
  },
  {
    label: "Father Saturnino Urios University",
    value: "Father Saturnino Urios University",
  },
  {
    label: "Fatih Sultan Mehmet Vakif Üniversitesi",
    value: "Fatih Sultan Mehmet Vakif Üniversitesi",
  },
  {
    label: "Fatima College of Health Sciences",
    value: "Fatima College of Health Sciences",
  },
  {
    label: "Fatima Jinnah Medical University",
    value: "Fatima Jinnah Medical University",
  },
  {
    label: "Fatima Jinnah Women University",
    value: "Fatima Jinnah Women University",
  },
  {
    label: "Fatoni University",
    value: "Fatoni University",
  },
  {
    label: "Faulkner University",
    value: "Faulkner University",
  },
  {
    label: "Fayetteville State University",
    value: "Fayetteville State University",
  },
  {
    label: "Fayoum University",
    value: "Fayoum University",
  },
  {
    label: "FEATI University",
    value: "FEATI University",
  },
  {
    label: "Federal University of Agriculture, Abeokuta",
    value: "Federal University of Agriculture, Abeokuta",
  },
  {
    label: "Federal University of Petroleum Resources",
    value: "Federal University of Petroleum Resources",
  },
  {
    label: "Federal University of Technology, Akure",
    value: "Federal University of Technology, Akure",
  },
  {
    label: "Federal University of Technology, Minna",
    value: "Federal University of Technology, Minna",
  },
  {
    label: "Federal University of Technology, Owerri",
    value: "Federal University of Technology, Owerri",
  },
  {
    label: "Federal University, Birnin Kebbi",
    value: "Federal University, Birnin Kebbi",
  },
  {
    label: "Federal University, Dutse",
    value: "Federal University, Dutse",
  },
  {
    label: "Federal University, Dutsin-Ma",
    value: "Federal University, Dutsin-Ma",
  },
  {
    label: "Federal University, Gashua",
    value: "Federal University, Gashua",
  },
  {
    label: "Federal University, Gusau",
    value: "Federal University, Gusau",
  },
  {
    label: "Federal University, Kashere",
    value: "Federal University, Kashere",
  },
  {
    label: "Federal University, Lafia",
    value: "Federal University, Lafia",
  },
  {
    label: "Federal University, Lokoja",
    value: "Federal University, Lokoja",
  },
  {
    label: "Federal University, Otuoke",
    value: "Federal University, Otuoke",
  },
  {
    label: "Federal University, Oye-Ekiti",
    value: "Federal University, Oye-Ekiti",
  },
  {
    label: "Federal University, Wukari",
    value: "Federal University, Wukari",
  },
  {
    label: "Federal Urdu University of Arts, Sciences and Technology",
    value: "Federal Urdu University of Arts, Sciences and Technology",
  },
  {
    label: "Federation University Australia",
    value: "Federation University Australia",
  },
  {
    label: "Felician University",
    value: "Felician University",
  },
  {
    label: "Fenerbahçe Üniversitesi",
    value: "Fenerbahçe Üniversitesi",
  },
  {
    label: "Feng Chia University",
    value: "Feng Chia University",
  },
  {
    label: "Feni University",
    value: "Feni University",
  },
  {
    label: "Ferdinand Porsche FernFH",
    value: "Ferdinand Porsche FernFH",
  },
  {
    label: "Ferdowsi University of Mashhad",
    value: "Ferdowsi University of Mashhad",
  },
  {
    label: "FernUniversität in Hagen",
    value: "FernUniversität in Hagen",
  },
  {
    label: "Ferris State University",
    value: "Ferris State University",
  },
  {
    label: "Ferris University",
    value: "Ferris University",
  },
  {
    label: "Ferrum College",
    value: "Ferrum College",
  },
  {
    label: "FEU Institute of Technology",
    value: "FEU Institute of Technology",
  },
  {
    label: "Fezzan University",
    value: "Fezzan University",
  },
  {
    label: "fh gesundheit",
    value: "fh gesundheit",
  },
  {
    label: "FH Gesundheitsberufe OÖ",
    value: "FH Gesundheitsberufe OÖ",
  },
  {
    label: "FH Joanneum",
    value: "FH Joanneum",
  },
  {
    label: "FH Oberösterreich",
    value: "FH Oberösterreich",
  },
  {
    label: "FHWien der WKW",
    value: "FHWien der WKW",
  },
  {
    label: "Fielding Graduate University",
    value: "Fielding Graduate University",
  },
  {
    label: "Fiji National University",
    value: "Fiji National University",
  },
  {
    label: "Filamer Christian University",
    value: "Filamer Christian University",
  },
  {
    label: "Filmová akademie Miroslava Ondrícka v Písku",
    value: "Filmová akademie Miroslava Ondrícka v Písku",
  },
  {
    label: "Filmuniversität Babelsberg Konrad Wolf",
    value: "Filmuniversität Babelsberg Konrad Wolf",
  },
  {
    label: "Finance Academy under the Government of the Russian Federation",
    value: "Finance Academy under the Government of the Russian Federation",
  },
  {
    label: "Financial Academy",
    value: "Financial Academy",
  },
  {
    label: "Finlandia University",
    value: "Finlandia University",
  },
  {
    label: "Firat Üniversitesi",
    value: "Firat Üniversitesi",
  },
  {
    label: "First Capital University of Bangladesh",
    value: "First Capital University of Bangladesh",
  },
  {
    label: "First Nations University of Canada",
    value: "First Nations University of Canada",
  },
  {
    label: "Fisher College",
    value: "Fisher College",
  },
  {
    label: "Fisk University",
    value: "Fisk University",
  },
  {
    label: "Fitchburg State University",
    value: "Fitchburg State University",
  },
  {
    label: "Five Towns College",
    value: "Five Towns College",
  },
  {
    label: "Flagler College",
    value: "Flagler College",
  },
  {
    label: "Flame University",
    value: "Flame University",
  },
  {
    label: "Fliedner Fachhochschule Düsseldorf",
    value: "Fliedner Fachhochschule Düsseldorf",
  },
  {
    label: "Flinders University",
    value: "Flinders University",
  },
  {
    label: "Florida Agricultural and Mechanical University",
    value: "Florida Agricultural and Mechanical University",
  },
  {
    label: "Florida Atlantic University",
    value: "Florida Atlantic University",
  },
  {
    label: "Florida College",
    value: "Florida College",
  },
  {
    label: "Florida Gateway College",
    value: "Florida Gateway College",
  },
  {
    label: "Florida Gulf Coast University",
    value: "Florida Gulf Coast University",
  },
  {
    label: "Florida Institute of Technology",
    value: "Florida Institute of Technology",
  },
  {
    label: "Florida International University",
    value: "Florida International University",
  },
  {
    label: "Florida Memorial University",
    value: "Florida Memorial University",
  },
  {
    label: "Florida National University",
    value: "Florida National University",
  },
  {
    label: "Florida Southern College",
    value: "Florida Southern College",
  },
  {
    label: "Florida SouthWestern State College",
    value: "Florida SouthWestern State College",
  },
  {
    label: "Florida State College at Jacksonville",
    value: "Florida State College at Jacksonville",
  },
  {
    label: "Florida State University",
    value: "Florida State University",
  },
  {
    label: "Florida State University Republic of Panama Campus",
    value: "Florida State University Republic of Panama Campus",
  },
  {
    label: "Fo Guang University",
    value: "Fo Guang University",
  },
  {
    label: "Folkwang Universität der Künste",
    value: "Folkwang Universität der Künste",
  },
  {
    label: "FOM Hochschule für Oekonomie und Management",
    value: "FOM Hochschule für Oekonomie und Management",
  },
  {
    label: "Fontbonne University",
    value: "Fontbonne University",
  },
  {
    label: "Fontys Hogescholen",
    value: "Fontys Hogescholen",
  },
  {
    label: "Fooyin University",
    value: "Fooyin University",
  },
  {
    label: "Fordham University",
    value: "Fordham University",
  },
  {
    label: "Foreign Trade University",
    value: "Foreign Trade University",
  },
  {
    label: "Forest Research Institute",
    value: "Forest Research Institute",
  },
  {
    label: "Forman Christian College",
    value: "Forman Christian College",
  },
  {
    label: "Fort Hays State University",
    value: "Fort Hays State University",
  },
  {
    label: "Fort Lewis College",
    value: "Fort Lewis College",
  },
  {
    label: "Fort Valley State University",
    value: "Fort Valley State University",
  },
  {
    label: "Fortune Institute of Technology",
    value: "Fortune Institute of Technology",
  },
  {
    label: "Foshan University",
    value: "Foshan University",
  },
  {
    label: "Foundation University Islamabad",
    value: "Foundation University Islamabad",
  },
  {
    label: "Fountain University, Osogbo",
    value: "Fountain University, Osogbo",
  },
  {
    label: "FPT University",
    value: "FPT University",
  },
  {
    label: "Framingham State University",
    value: "Framingham State University",
  },
  {
    label: "Francis Marion University",
    value: "Francis Marion University",
  },
  {
    label: "Franciscan Missionaries of Our Lady University",
    value: "Franciscan Missionaries of Our Lady University",
  },
  {
    label: "Franciscan University of Steubenville",
    value: "Franciscan University of Steubenville",
  },
  {
    label: "Francisk Skorina Gomel State University",
    value: "Francisk Skorina Gomel State University",
  },
  {
    label: "Frankfurt School of Finance and Management",
    value: "Frankfurt School of Finance and Management",
  },
  {
    label: "Frankfurt University of Applied Sciences",
    value: "Frankfurt University of Applied Sciences",
  },
  {
    label: "Franklin and Marshall College",
    value: "Franklin and Marshall College",
  },
  {
    label: "Franklin College",
    value: "Franklin College",
  },
  {
    label: "Franklin Pierce University",
    value: "Franklin Pierce University",
  },
  {
    label: "Franklin University",
    value: "Franklin University",
  },
  {
    label: "Franklin W. Olin College of Engineering",
    value: "Franklin W. Olin College of Engineering",
  },
  {
    label: "Frederick University",
    value: "Frederick University",
  },
  {
    label: "Free University of Tbilisi",
    value: "Free University of Tbilisi",
  },
  {
    label: "Freed-Hardeman University",
    value: "Freed-Hardeman University",
  },
  {
    label: "Freetown Polytechnic",
    value: "Freetown Polytechnic",
  },
  {
    label: "Freie Theologische Hochschule Giessen",
    value: "Freie Theologische Hochschule Giessen",
  },
  {
    label: "Freie Universität Berlin",
    value: "Freie Universität Berlin",
  },
  {
    label: "Fresno Pacific University",
    value: "Fresno Pacific University",
  },
  {
    label: "Friedrich-Alexander-Universität Erlangen-Nürnberg",
    value: "Friedrich-Alexander-Universität Erlangen-Nürnberg",
  },
  {
    label: "Friedrich-Schiller-Universität Jena",
    value: "Friedrich-Schiller-Universität Jena",
  },
  {
    label: "Friends University",
    value: "Friends University",
  },
  {
    label: "Frostburg State University",
    value: "Frostburg State University",
  },
  {
    label: "Fu Jen Catholic University",
    value: "Fu Jen Catholic University",
  },
  {
    label: "Fudan University",
    value: "Fudan University",
  },
  {
    label: "Fuji University",
    value: "Fuji University",
  },
  {
    label: "Fuji Women's University",
    value: "Fuji Women's University",
  },
  {
    label: "Fujian Agriculture and Forestry University",
    value: "Fujian Agriculture and Forestry University",
  },
  {
    label: "Fujian Business University",
    value: "Fujian Business University",
  },
  {
    label: "Fujian Jiangxia University",
    value: "Fujian Jiangxia University",
  },
  {
    label: "Fujian Medical University",
    value: "Fujian Medical University",
  },
  {
    label: "Fujian Normal University",
    value: "Fujian Normal University",
  },
  {
    label: "Fujian University of Technology",
    value: "Fujian University of Technology",
  },
  {
    label: "Fujian University of Traditional Chinese Medicine",
    value: "Fujian University of Traditional Chinese Medicine",
  },
  {
    label: "Fujita Health University",
    value: "Fujita Health University",
  },
  {
    label: "Fukui Health Science University",
    value: "Fukui Health Science University",
  },
  {
    label: "Fukui Prefectural University",
    value: "Fukui Prefectural University",
  },
  {
    label: "Fukui University of Technology",
    value: "Fukui University of Technology",
  },
  {
    label: "Fukuoka Dental College",
    value: "Fukuoka Dental College",
  },
  {
    label: "Fukuoka Institute of Technology",
    value: "Fukuoka Institute of Technology",
  },
  {
    label: "Fukuoka International University",
    value: "Fukuoka International University",
  },
  {
    label: "Fukuoka International University of Health and Welfare",
    value: "Fukuoka International University of Health and Welfare",
  },
  {
    label: "Fukuoka Jo Gakuin Nursing University",
    value: "Fukuoka Jo Gakuin Nursing University",
  },
  {
    label: "Fukuoka Jo Gakuin University",
    value: "Fukuoka Jo Gakuin University",
  },
  {
    label: "Fukuoka Nursing College",
    value: "Fukuoka Nursing College",
  },
  {
    label: "Fukuoka Prefectural University",
    value: "Fukuoka Prefectural University",
  },
  {
    label: "Fukuoka University",
    value: "Fukuoka University",
  },
  {
    label: "Fukuoka Women's University",
    value: "Fukuoka Women's University",
  },
  {
    label: "Fukushima College",
    value: "Fukushima College",
  },
  {
    label: "Fukushima Medical University",
    value: "Fukushima Medical University",
  },
  {
    label: "Fukushima University",
    value: "Fukushima University",
  },
  {
    label: "Fukuyama City University",
    value: "Fukuyama City University",
  },
  {
    label: "Fukuyama Heisei University",
    value: "Fukuyama Heisei University",
  },
  {
    label: "Fukuyama University",
    value: "Fukuyama University",
  },
  {
    label: "Fundacion Centro Universitario de Bienestar Rural",
    value: "Fundacion Centro Universitario de Bienestar Rural",
  },
  {
    label: "Fundacion de Estudios Superiores Monseñor Abraham Escudero Montoya",
    value: "Fundacion de Estudios Superiores Monseñor Abraham Escudero Montoya",
  },
  {
    label:
      "Fundacion de Estudios Superiores Universitarios de Uraba Antonio Roldan Betancur",
    value:
      "Fundacion de Estudios Superiores Universitarios de Uraba Antonio Roldan Betancur",
  },
  {
    label: "Fundacion Escuela Colombiana de Mercadotecnia",
    value: "Fundacion Escuela Colombiana de Mercadotecnia",
  },
  {
    label: "Fundacion Escuela Colombiana de Rehabilitacion",
    value: "Fundacion Escuela Colombiana de Rehabilitacion",
  },
  {
    label: "Fundacion Escuela Tecnologica de Neiva Jesus Oviedo Perez",
    value: "Fundacion Escuela Tecnologica de Neiva Jesus Oviedo Perez",
  },
  {
    label: "Fundacion Universitaria Agraria de Colombia",
    value: "Fundacion Universitaria Agraria de Colombia",
  },
  {
    label: "Fundación Universitaria Antonio de Arévalo",
    value: "Fundación Universitaria Antonio de Arévalo",
  },
  {
    label: "Fundacion Universitaria Autonoma de Las Americas",
    value: "Fundacion Universitaria Autonoma de Las Americas",
  },
  {
    label: "Fundacion Universitaria Bellas Artes",
    value: "Fundacion Universitaria Bellas Artes",
  },
  {
    label: "Fundacion Universitaria Cafam",
    value: "Fundacion Universitaria Cafam",
  },
  {
    label: "Fundación Universitaria Católica del Caribe",
    value: "Fundación Universitaria Católica del Caribe",
  },
  {
    label: "Fundacion Universitaria Catolica del Norte",
    value: "Fundacion Universitaria Catolica del Norte",
  },
  {
    label: "Fundacion Universitaria Catolica del Sur",
    value: "Fundacion Universitaria Catolica del Sur",
  },
  {
    label: "Fundacion Universitaria Catolica Lumen Gentium",
    value: "Fundacion Universitaria Catolica Lumen Gentium",
  },
  {
    label: "Fundacion Universitaria CEIPA",
    value: "Fundacion Universitaria CEIPA",
  },
  {
    label: "Fundación Universitaria Cervantes San Agustín",
    value: "Fundación Universitaria Cervantes San Agustín",
  },
  {
    label: "Fundacion Universitaria Cieo",
    value: "Fundacion Universitaria Cieo",
  },
  {
    label: "Fundacion Universitaria Claretiana",
    value: "Fundacion Universitaria Claretiana",
  },
  {
    label: "Fundacion Universitaria Colombo Germana",
    value: "Fundacion Universitaria Colombo Germana",
  },
  {
    label: "Fundacion Universitaria Colombo Internacional",
    value: "Fundacion Universitaria Colombo Internacional",
  },
  {
    label: "Fundacion Universitaria Comfamiliar Risaralda",
    value: "Fundacion Universitaria Comfamiliar Risaralda",
  },
  {
    label: "Fundacion Universitaria Comfenalco Santander",
    value: "Fundacion Universitaria Comfenalco Santander",
  },
  {
    label: "Fundación Universitaria Compensar",
    value: "Fundación Universitaria Compensar",
  },
  {
    label: "Fundacion Universitaria de Ciencias de La Salud",
    value: "Fundacion Universitaria de Ciencias de La Salud",
  },
  {
    label: "Fundacion Universitaria de Popayan",
    value: "Fundacion Universitaria de Popayan",
  },
  {
    label: "Fundacion Universitaria de San Gil",
    value: "Fundacion Universitaria de San Gil",
  },
  {
    label: "Fundación Universitaria del Area Andina",
    value: "Fundación Universitaria del Area Andina",
  },
  {
    label:
      "Fundacion Universitaria Empresarial de La Camara de Comercio de Bogota",
    value:
      "Fundacion Universitaria Empresarial de La Camara de Comercio de Bogota",
  },
  {
    label: "Fundacion Universitaria FCV",
    value: "Fundacion Universitaria FCV",
  },
  {
    label: "Fundacion Universitaria Horizonte",
    value: "Fundacion Universitaria Horizonte",
  },
  {
    label: "Fundacion Universitaria Internacional de Colombia",
    value: "Fundacion Universitaria Internacional de Colombia",
  },
  {
    label: "Fundacion Universitaria Internacional de la Rioja",
    value: "Fundacion Universitaria Internacional de la Rioja",
  },
  {
    label: "Fundacion Universitaria Internacional del Tropico Americano",
    value: "Fundacion Universitaria Internacional del Tropico Americano",
  },
  {
    label: "Fundacion Universitaria Juan de Castellanos",
    value: "Fundacion Universitaria Juan de Castellanos",
  },
  {
    label: "Fundación Universitaria Juan N. Corpas",
    value: "Fundación Universitaria Juan N. Corpas",
  },
  {
    label: "Fundacion Universitaria Konrad Lorenz",
    value: "Fundacion Universitaria Konrad Lorenz",
  },
  {
    label: "Fundacion Universitaria Los Libertadores",
    value: "Fundacion Universitaria Los Libertadores",
  },
  {
    label: "Fundacion Universitaria Luis G. Paez",
    value: "Fundacion Universitaria Luis G. Paez",
  },
  {
    label: "Fundacion Universitaria Maria Cano",
    value: "Fundacion Universitaria Maria Cano",
  },
  {
    label: "Fundacion Universitaria Monserrate",
    value: "Fundacion Universitaria Monserrate",
  },
  {
    label: "Fundacion Universitaria Navarra",
    value: "Fundacion Universitaria Navarra",
  },
  {
    label: "Fundacion Universitaria Para el Desarrollo Humano",
    value: "Fundacion Universitaria Para el Desarrollo Humano",
  },
  {
    label: "Fundación Universitaria Patricio Symes",
    value: "Fundación Universitaria Patricio Symes",
  },
  {
    label: "Fundacion Universitaria Salesiana",
    value: "Fundacion Universitaria Salesiana",
  },
  {
    label: "Fundación Universitaria San Alfonso",
    value: "Fundación Universitaria San Alfonso",
  },
  {
    label: "Fundación Universitaria San Martín",
    value: "Fundación Universitaria San Martín",
  },
  {
    label: "Fundacion Universitaria San Mateo",
    value: "Fundacion Universitaria San Mateo",
  },
  {
    label: "Fundación Universitaria San Pablo",
    value: "Fundación Universitaria San Pablo",
  },
  {
    label: "Fundacion Universitaria Sanitas",
    value: "Fundacion Universitaria Sanitas",
  },
  {
    label: "Fundacion Universitaria Tecnologico Comfenalco - Cartagena",
    value: "Fundacion Universitaria Tecnologico Comfenalco - Cartagena",
  },
  {
    label: "Furman University",
    value: "Furman University",
  },
  {
    label: "Future University",
    value: "Future University",
  },
  {
    label: "Future University Hakodate",
    value: "Future University Hakodate",
  },
  {
    label: "Future University in Egypt",
    value: "Future University in Egypt",
  },
  {
    label: "Fuyang Normal University",
    value: "Fuyang Normal University",
  },
  {
    label: "Fuzhou Institute of Technology",
    value: "Fuzhou Institute of Technology",
  },
  {
    label: "Fuzhou University",
    value: "Fuzhou University",
  },
  {
    label: "G.H. Raisoni University",
    value: "G.H. Raisoni University",
  },
  {
    label: "G.L.S. University",
    value: "G.L.S. University",
  },
  {
    label: "Gábor Dénes Egyetem",
    value: "Gábor Dénes Egyetem",
  },
  {
    label: "Gaborone University College of Law and Professional Studies",
    value: "Gaborone University College of Law and Professional Studies",
  },
  {
    label: "Gachon University",
    value: "Gachon University",
  },
  {
    label: "Gaidar Institute for Economic Policy",
    value: "Gaidar Institute for Economic Policy",
  },
  {
    label: "Gakushuin University",
    value: "Gakushuin University",
  },
  {
    label: "Gakushuin Women's College",
    value: "Gakushuin Women's College",
  },
  {
    label: "Galala University",
    value: "Galala University",
  },
  {
    label: "Galatasaray Üniversitesi",
    value: "Galatasaray Üniversitesi",
  },
  {
    label: "Galen University",
    value: "Galen University",
  },
  {
    label: "Galgotias University",
    value: "Galgotias University",
  },
  {
    label: "GALIK University",
    value: "GALIK University",
  },
  {
    label: "Gallaudet University",
    value: "Gallaudet University",
  },
  {
    label: "Gambat Institute of Medical Sciences",
    value: "Gambat Institute of Medical Sciences",
  },
  {
    label: "Gampaha Wickramarachchi University of Indigenous Medicine",
    value: "Gampaha Wickramarachchi University of Indigenous Medicine",
  },
  {
    label: "Gandhara University",
    value: "Gandhara University",
  },
  {
    label: "Gandhi Institute of Technology and Management",
    value: "Gandhi Institute of Technology and Management",
  },
  {
    label: "Gandhigram Rural University",
    value: "Gandhigram Rural University",
  },
  {
    label: "Gangadhar Meher University",
    value: "Gangadhar Meher University",
  },
  {
    label: "Gangneung-Wonju National University",
    value: "Gangneung-Wonju National University",
  },
  {
    label: "Gangseo University",
    value: "Gangseo University",
  },
  {
    label: "Gannan Medical University",
    value: "Gannan Medical University",
  },
  {
    label: "Gannan Normal University",
    value: "Gannan Normal University",
  },
  {
    label: "Gannon University",
    value: "Gannon University",
  },
  {
    label: "Ganpat University",
    value: "Ganpat University",
  },
  {
    label: "Gansu Agricultural University",
    value: "Gansu Agricultural University",
  },
  {
    label: "Gansu Medical College",
    value: "Gansu Medical College",
  },
  {
    label: "Gansu Normal University for Nationalities",
    value: "Gansu Normal University for Nationalities",
  },
  {
    label: "Gansu University of Chinese Medicine",
    value: "Gansu University of Chinese Medicine",
  },
  {
    label: "Gansu University of Political Science and Law",
    value: "Gansu University of Political Science and Law",
  },
  {
    label: "Garden City University",
    value: "Garden City University",
  },
  {
    label: "Garden City University College",
    value: "Garden City University College",
  },
  {
    label: "Gardner-Webb University",
    value: "Gardner-Webb University",
  },
  {
    label: "Garissa University",
    value: "Garissa University",
  },
  {
    label: "Gauhati University",
    value: "Gauhati University",
  },
  {
    label: "Gautam Buddha University",
    value: "Gautam Buddha University",
  },
  {
    label: "Gavar State University",
    value: "Gavar State University",
  },
  {
    label: "Gawharshad Institute of Higher Education",
    value: "Gawharshad Institute of Higher Education",
  },
  {
    label: "Gaza University",
    value: "Gaza University",
  },
  {
    label: "Gazarchin University of Mongolia",
    value: "Gazarchin University of Mongolia",
  },
  {
    label: "Gazi Üniversitesi",
    value: "Gazi Üniversitesi",
  },
  {
    label: "Gaziantep Üniversitesi",
    value: "Gaziantep Üniversitesi",
  },
  {
    label: "GD Goenka University",
    value: "GD Goenka University",
  },
  {
    label: "Gdanski Uniwersytet Medyczny",
    value: "Gdanski Uniwersytet Medyczny",
  },
  {
    label: "GEA College",
    value: "GEA College",
  },
  {
    label: "Gebze Teknik Üniversitesi",
    value: "Gebze Teknik Üniversitesi",
  },
  {
    label: "Geetanjali University",
    value: "Geetanjali University",
  },
  {
    label: "Geisinger Commonwealth School of Medicine",
    value: "Geisinger Commonwealth School of Medicine",
  },
  {
    label: "Gence Dövlet Universiteti",
    value: "Gence Dövlet Universiteti",
  },
  {
    label: "Generolo Jono Žemaicio Lietuvos karo akademija",
    value: "Generolo Jono Žemaicio Lietuvos karo akademija",
  },
  {
    label: "Geneva College",
    value: "Geneva College",
  },
  {
    label: "Georg-August-Universität Göttingen",
    value: "Georg-August-Universität Göttingen",
  },
  {
    label: "George Fox University",
    value: "George Fox University",
  },
  {
    label: "George Mason University",
    value: "George Mason University",
  },
  {
    label: "George Washington University",
    value: "George Washington University",
  },
  {
    label: "Georgetown American University",
    value: "Georgetown American University",
  },
  {
    label: "Georgetown College",
    value: "Georgetown College",
  },
  {
    label: "Georgetown University",
    value: "Georgetown University",
  },
  {
    label: "Georgetown University in Qatar",
    value: "Georgetown University in Qatar",
  },
  {
    label: "Georgia College and State University",
    value: "Georgia College and State University",
  },
  {
    label: "Georgia Gwinnett College",
    value: "Georgia Gwinnett College",
  },
  {
    label: "Georgia Institute of Technology",
    value: "Georgia Institute of Technology",
  },
  {
    label: "Georgia Southern University",
    value: "Georgia Southern University",
  },
  {
    label: "Georgia Southwestern State University",
    value: "Georgia Southwestern State University",
  },
  {
    label: "Georgia State University",
    value: "Georgia State University",
  },
  {
    label: "Georgian American University",
    value: "Georgian American University",
  },
  {
    label: "Georgian Aviation University",
    value: "Georgian Aviation University",
  },
  {
    label: "Georgian Court University",
    value: "Georgian Court University",
  },
  {
    label: "Georgian Institute of Public Affairs",
    value: "Georgian Institute of Public Affairs",
  },
  {
    label: "Georgian National Universty SEU",
    value: "Georgian National Universty SEU",
  },
  {
    label: "Georgian State Teaching University of Physical Education and Sport",
    value: "Georgian State Teaching University of Physical Education and Sport",
  },
  {
    label: "Georgian Technical University",
    value: "Georgian Technical University",
  },
  {
    label: "German Graduate School of Management and Law",
    value: "German Graduate School of Management and Law",
  },
  {
    label: "German Jordanian University",
    value: "German Jordanian University",
  },
  {
    label: "German University Bangladesh",
    value: "German University Bangladesh",
  },
  {
    label: "German University of Technology in Oman",
    value: "German University of Technology in Oman",
  },
  {
    label: "Gerrit Rietveld Academie",
    value: "Gerrit Rietveld Academie",
  },
  {
    label: "Gettysburg College",
    value: "Gettysburg College",
  },
  {
    label: "Geumgang University",
    value: "Geumgang University",
  },
  {
    label: "Ghalib University",
    value: "Ghalib University",
  },
  {
    label: "Ghana Baptist University College",
    value: "Ghana Baptist University College",
  },
  {
    label: "Ghana Christian University College",
    value: "Ghana Christian University College",
  },
  {
    label: "Ghana Communication Technology University",
    value: "Ghana Communication Technology University",
  },
  {
    label: "Ghana Institute of Journalism",
    value: "Ghana Institute of Journalism",
  },
  {
    label: "Ghana Institute of Languages",
    value: "Ghana Institute of Languages",
  },
  {
    label: "Ghana Institute of Management and Public Administration",
    value: "Ghana Institute of Management and Public Administration",
  },
  {
    label: "Gharjistan University",
    value: "Gharjistan University",
  },
  {
    label: "Ghazi Amanullah Khan Institute of Higher Education",
    value: "Ghazi Amanullah Khan Institute of Higher Education",
  },
  {
    label: "Ghazi University",
    value: "Ghazi University",
  },
  {
    label: "Ghazni University",
    value: "Ghazni University",
  },
  {
    label: "Ghulam Ishaq Khan Institute of Engineering Sciences and Technology",
    value: "Ghulam Ishaq Khan Institute of Engineering Sciences and Technology",
  },
  {
    label: "Gideon Robert University",
    value: "Gideon Robert University",
  },
  {
    label: "GIET University",
    value: "GIET University",
  },
  {
    label: "GIFT University",
    value: "GIFT University",
  },
  {
    label: "Gifu College of Nursing",
    value: "Gifu College of Nursing",
  },
  {
    label: "Gifu Kyoritsu University",
    value: "Gifu Kyoritsu University",
  },
  {
    label: "Gifu Pharmaceutical University",
    value: "Gifu Pharmaceutical University",
  },
  {
    label: "Gifu Shotoku Gakuen University",
    value: "Gifu Shotoku Gakuen University",
  },
  {
    label: "Gifu University",
    value: "Gifu University",
  },
  {
    label: "Gifu University of Health Sciences",
    value: "Gifu University of Health Sciences",
  },
  {
    label: "Gifu University of Medical Science",
    value: "Gifu University of Medical Science",
  },
  {
    label: "Gifu Women's University",
    value: "Gifu Women's University",
  },
  {
    label: "Gilan University of Medical Sciences",
    value: "Gilan University of Medical Sciences",
  },
  {
    label: "Gilgamesh Ahliya University",
    value: "Gilgamesh Ahliya University",
  },
  {
    label: "Gimcheon University",
    value: "Gimcheon University",
  },
  {
    label: "Giresun Üniversitesi",
    value: "Giresun Üniversitesi",
  },
  {
    label: "Girne Amerikan Üniversitesi",
    value: "Girne Amerikan Üniversitesi",
  },
  {
    label: "Girne Üniversitesi",
    value: "Girne Üniversitesi",
  },
  {
    label: "GLA University",
    value: "GLA University",
  },
  {
    label: "Glasgow Caledonian University",
    value: "Glasgow Caledonian University",
  },
  {
    label: "Glenville State University",
    value: "Glenville State University",
  },
  {
    label: "Glion Institute of Higher Education",
    value: "Glion Institute of Higher Education",
  },
  {
    label: "Global College",
    value: "Global College",
  },
  {
    label: "Global College of Engineering and Technology",
    value: "Global College of Engineering and Technology",
  },
  {
    label: "Global Leadership University",
    value: "Global Leadership University",
  },
  {
    label: "Global University",
    value: "Global University",
  },
  {
    label: "Global University Bangladesh",
    value: "Global University Bangladesh",
  },
  {
    label: "Glocal University",
    value: "Glocal University",
  },
  {
    label: "Glorious Vision University",
    value: "Glorious Vision University",
  },
  {
    label: "GNA University",
    value: "GNA University",
  },
  {
    label: "Goa University",
    value: "Goa University",
  },
  {
    label: "Goce Delcev University of Štip",
    value: "Goce Delcev University of Štip",
  },
  {
    label: "Goddard College",
    value: "Goddard College",
  },
  {
    label: "Godfrey Okoye University",
    value: "Godfrey Okoye University",
  },
  {
    label: "God's Bible School and College",
    value: "God's Bible School and College",
  },
  {
    label: "Goethe-Universität Frankfurt am Main",
    value: "Goethe-Universität Frankfurt am Main",
  },
  {
    label: "Gokhale Institute of Politics and Economics",
    value: "Gokhale Institute of Politics and Economics",
  },
  {
    label: "Golbahar University of Science and New Technology",
    value: "Golbahar University of Science and New Technology",
  },
  {
    label: "Golden Gate University",
    value: "Golden Gate University",
  },
  {
    label: "Goldey-Beacom College",
    value: "Goldey-Beacom College",
  },
  {
    label: "Goldfarb School of Nursing at Barnes-Jewish College",
    value: "Goldfarb School of Nursing at Barnes-Jewish College",
  },
  {
    label: "Goldsmiths, University of London",
    value: "Goldsmiths, University of London",
  },
  {
    label: "Golestan University",
    value: "Golestan University",
  },
  {
    label: "Golestan University of Medical Sciences",
    value: "Golestan University of Medical Sciences",
  },
  {
    label: "Gomal University",
    value: "Gomal University",
  },
  {
    label: "Gombe State University",
    value: "Gombe State University",
  },
  {
    label: "Gombe State University of Science and Technology",
    value: "Gombe State University of Science and Technology",
  },
  {
    label: "Gomel State Medical University",
    value: "Gomel State Medical University",
  },
  {
    label: "Gonabad University of Medical Sciences",
    value: "Gonabad University of Medical Sciences",
  },
  {
    label: "Gonbad Kavous University",
    value: "Gonbad Kavous University",
  },
  {
    label: "Gondwana University",
    value: "Gondwana University",
  },
  {
    label: "Gongju National University of Education",
    value: "Gongju National University of Education",
  },
  {
    label: "Gono Bishwabidyalay",
    value: "Gono Bishwabidyalay",
  },
  {
    label: "Gonzaga University",
    value: "Gonzaga University",
  },
  {
    label: "Good Samaritan College of Nursing and Health Science",
    value: "Good Samaritan College of Nursing and Health Science",
  },
  {
    label: "Goodwin University",
    value: "Goodwin University",
  },
  {
    label: "Gordon College",
    value: "Gordon College",
  },
  {
    label: "Gordon State College",
    value: "Gordon State College",
  },
  {
    label: "Gorgan University of Agricultural Sciences and Natural Resources",
    value: "Gorgan University of Agricultural Sciences and Natural Resources",
  },
  {
    label: "Gori State Teaching University",
    value: "Gori State Teaching University",
  },
  {
    label: "Goris State University",
    value: "Goris State University",
  },
  {
    label: "Gorno-Altaisk State University",
    value: "Gorno-Altaisk State University",
  },
  {
    label: "Gorsky State Agrarian University",
    value: "Gorsky State Agrarian University",
  },
  {
    label: "Goshen College",
    value: "Goshen College",
  },
  {
    label: "Göteborgs universitet",
    value: "Göteborgs universitet",
  },
  {
    label: "Goucher College",
    value: "Goucher College",
  },
  {
    label: "Government College University, Faisalabad",
    value: "Government College University, Faisalabad",
  },
  {
    label: "Government College University, Lahore",
    value: "Government College University, Lahore",
  },
  {
    label: "Government College Women University, Faisalabad",
    value: "Government College Women University, Faisalabad",
  },
  {
    label: "Government College Women University, Sialkot",
    value: "Government College Women University, Sialkot",
  },
  {
    label: "Governors State University",
    value: "Governors State University",
  },
  {
    label: "Govind Ballabh Pant University of Agriculture and Technology",
    value: "Govind Ballabh Pant University of Agriculture and Technology",
  },
  {
    label: "Govind Guru Tribal University",
    value: "Govind Guru Tribal University",
  },
  {
    label: "Grace Christian University",
    value: "Grace Christian University",
  },
  {
    label: "Grace College",
    value: "Grace College",
  },
  {
    label: "Graceland University",
    value: "Graceland University",
  },
  {
    label: "Graduate Institute for Entrepreneurial Studies",
    value: "Graduate Institute for Entrepreneurial Studies",
  },
  {
    label: "Graduate School of Management, Globis University",
    value: "Graduate School of Management, Globis University",
  },
  {
    label: "Graduate University of Advanced Technology",
    value: "Graduate University of Advanced Technology",
  },
  {
    label: "Graiciuno aukštoji vadybos mokykla",
    value: "Graiciuno aukštoji vadybos mokykla",
  },
  {
    label: "Grambling State University",
    value: "Grambling State University",
  },
  {
    label: "Grand Canyon University",
    value: "Grand Canyon University",
  },
  {
    label: "Grand Valley State University",
    value: "Grand Valley State University",
  },
  {
    label: "Grand View University",
    value: "Grand View University",
  },
  {
    label: "Graphic Era Hill University",
    value: "Graphic Era Hill University",
  },
  {
    label: "Graphic Era University",
    value: "Graphic Era University",
  },
  {
    label: "Gratz College",
    value: "Gratz College",
  },
  {
    label: "Great Basin College",
    value: "Great Basin College",
  },
  {
    label: "Great Lakes Christian College",
    value: "Great Lakes Christian College",
  },
  {
    label: "Great Lakes University of Kisumu",
    value: "Great Lakes University of Kisumu",
  },
  {
    label: "Great Mongol Institute",
    value: "Great Mongol Institute",
  },
  {
    label: "Great Zimbabwe University",
    value: "Great Zimbabwe University",
  },
  {
    label: "Green University of Bangladesh",
    value: "Green University of Bangladesh",
  },
  {
    label: "GreenHeart Medical University",
    value: "GreenHeart Medical University",
  },
  {
    label: "Greensboro College",
    value: "Greensboro College",
  },
  {
    label: "Greenville University",
    value: "Greenville University",
  },
  {
    label: "Greenwich University",
    value: "Greenwich University",
  },
  {
    label: "Gregory University, Uturu",
    value: "Gregory University, Uturu",
  },
  {
    label: "Grenoble École de Management",
    value: "Grenoble École de Management",
  },
  {
    label: "Grenoble INP",
    value: "Grenoble INP",
  },
  {
    label: "Gretsa University",
    value: "Gretsa University",
  },
  {
    label: "Griffith University",
    value: "Griffith University",
  },
  {
    label: "Grigol Robakidze University",
    value: "Grigol Robakidze University",
  },
  {
    label: "Grinnell College",
    value: "Grinnell College",
  },
  {
    label: "Grodno State Agrarian University",
    value: "Grodno State Agrarian University",
  },
  {
    label: "Grodno State Medical University",
    value: "Grodno State Medical University",
  },
  {
    label: "Grove City College",
    value: "Grove City College",
  },
  {
    label: "GSFC University",
    value: "GSFC University",
  },
  {
    label: "Guagua National Colleges",
    value: "Guagua National Colleges",
  },
  {
    label: "Guangdong Baiyun University",
    value: "Guangdong Baiyun University",
  },
  {
    label: "Guangdong Medical University",
    value: "Guangdong Medical University",
  },
  {
    label: "Guangdong Ocean University",
    value: "Guangdong Ocean University",
  },
  {
    label: "Guangdong Peizheng College",
    value: "Guangdong Peizheng College",
  },
  {
    label: "Guangdong Pharmaceutical University",
    value: "Guangdong Pharmaceutical University",
  },
  {
    label: "Guangdong Polytechnic College",
    value: "Guangdong Polytechnic College",
  },
  {
    label: "Guangdong Polytechnic Normal University",
    value: "Guangdong Polytechnic Normal University",
  },
  {
    label: "Guangdong Technion Israel Institute of Technology",
    value: "Guangdong Technion Israel Institute of Technology",
  },
  {
    label: "Guangdong University of Education",
    value: "Guangdong University of Education",
  },
  {
    label: "Guangdong University of Finance",
    value: "Guangdong University of Finance",
  },
  {
    label: "Guangdong University of Finance and Economics",
    value: "Guangdong University of Finance and Economics",
  },
  {
    label: "Guangdong University of Foreign Studies",
    value: "Guangdong University of Foreign Studies",
  },
  {
    label: "Guangdong University of Petrochemical Technology",
    value: "Guangdong University of Petrochemical Technology",
  },
  {
    label: "Guangdong University of Science and Technology",
    value: "Guangdong University of Science and Technology",
  },
  {
    label: "Guangdong University of Technology",
    value: "Guangdong University of Technology",
  },
  {
    label: "Guangxi Arts University",
    value: "Guangxi Arts University",
  },
  {
    label: "Guangxi Medical University",
    value: "Guangxi Medical University",
  },
  {
    label: "Guangxi Normal University",
    value: "Guangxi Normal University",
  },
  {
    label: "Guangxi Normal University for Nationalities",
    value: "Guangxi Normal University for Nationalities",
  },
  {
    label: "Guangxi Science and Technology Normal University",
    value: "Guangxi Science and Technology Normal University",
  },
  {
    label: "Guangxi University",
    value: "Guangxi University",
  },
  {
    label: "Guangxi University for Nationalities",
    value: "Guangxi University for Nationalities",
  },
  {
    label: "Guangxi University of Chinese Medicine",
    value: "Guangxi University of Chinese Medicine",
  },
  {
    label: "Guangxi University of Finance and Economics",
    value: "Guangxi University of Finance and Economics",
  },
  {
    label: "Guangxi University of Foreign Languages",
    value: "Guangxi University of Foreign Languages",
  },
  {
    label: "Guangxi University of Science and Technology",
    value: "Guangxi University of Science and Technology",
  },
  {
    label: "Guangzhou Academy of Fine Arts",
    value: "Guangzhou Academy of Fine Arts",
  },
  {
    label: "Guangzhou College of Commerce",
    value: "Guangzhou College of Commerce",
  },
  {
    label: "Guangzhou Maritime University",
    value: "Guangzhou Maritime University",
  },
  {
    label: "Guangzhou Medical University",
    value: "Guangzhou Medical University",
  },
  {
    label: "Guangzhou Sport University",
    value: "Guangzhou Sport University",
  },
  {
    label: "Guangzhou University",
    value: "Guangzhou University",
  },
  {
    label: "Guangzhou University of Chinese Medicine",
    value: "Guangzhou University of Chinese Medicine",
  },
  {
    label: "Guildhall School of Music and Drama",
    value: "Guildhall School of Music and Drama",
  },
  {
    label: "Guilford College",
    value: "Guilford College",
  },
  {
    label: "Guilin Medical University",
    value: "Guilin Medical University",
  },
  {
    label: "Guilin Tourism University",
    value: "Guilin Tourism University",
  },
  {
    label: "Guilin University of Aerospace Technology",
    value: "Guilin University of Aerospace Technology",
  },
  {
    label: "Guilin University of Electronic Technology",
    value: "Guilin University of Electronic Technology",
  },
  {
    label: "Guilin University of Technology",
    value: "Guilin University of Technology",
  },
  {
    label: "Guimaras State University",
    value: "Guimaras State University",
  },
  {
    label: "Guiyang University",
    value: "Guiyang University",
  },
  {
    label: "Guiyang University Traditional Chinese Medicine",
    value: "Guiyang University Traditional Chinese Medicine",
  },
  {
    label: "Guizhou Education University",
    value: "Guizhou Education University",
  },
  {
    label: "Guizhou Institute of Technology",
    value: "Guizhou Institute of Technology",
  },
  {
    label: "Guizhou Medical University",
    value: "Guizhou Medical University",
  },
  {
    label: "Guizhou Minzu University",
    value: "Guizhou Minzu University",
  },
  {
    label: "Guizhou Normal University",
    value: "Guizhou Normal University",
  },
  {
    label: "Guizhou University",
    value: "Guizhou University",
  },
  {
    label: "Guizhou University of Commerce",
    value: "Guizhou University of Commerce",
  },
  {
    label: "Guizhou University of Engineering Science",
    value: "Guizhou University of Engineering Science",
  },
  {
    label: "Guizhou University of Finance and Economics",
    value: "Guizhou University of Finance and Economics",
  },
  {
    label: "Gujarat Ayurved University",
    value: "Gujarat Ayurved University",
  },
  {
    label: "Gujarat National Law University",
    value: "Gujarat National Law University",
  },
  {
    label: "Gujarat Technological University",
    value: "Gujarat Technological University",
  },
  {
    label: "Gujarat University",
    value: "Gujarat University",
  },
  {
    label: "Gujarat University of Transplantation Sciences",
    value: "Gujarat University of Transplantation Sciences",
  },
  {
    label: "Gujarat Vidyapith",
    value: "Gujarat Vidyapith",
  },
  {
    label: "Gulbarga University",
    value: "Gulbarga University",
  },
  {
    label: "Gulf Coast State College",
    value: "Gulf Coast State College",
  },
  {
    label: "Gulf College",
    value: "Gulf College",
  },
  {
    label: "Gulf Medical University",
    value: "Gulf Medical University",
  },
  {
    label: "Gulf University",
    value: "Gulf University",
  },
  {
    label: "Gulf University for Science and Technology",
    value: "Gulf University for Science and Technology",
  },
  {
    label: "Guliston Davlat Universiteti",
    value: "Guliston Davlat Universiteti",
  },
  {
    label: "Gulu University",
    value: "Gulu University",
  },
  {
    label: "Gümüshane Üniversitesi",
    value: "Gümüshane Üniversitesi",
  },
  {
    label: "Gunma Paz University",
    value: "Gunma Paz University",
  },
  {
    label: "Gunma Prefectural College of Health Sciences",
    value: "Gunma Prefectural College of Health Sciences",
  },
  {
    label: "Gunma Prefectural Women's University",
    value: "Gunma Prefectural Women's University",
  },
  {
    label: "Gunma University",
    value: "Gunma University",
  },
  {
    label: "Gunma University of Health and Welfare",
    value: "Gunma University of Health and Welfare",
  },
  {
    label: "Guram Tavartkiladze Teaching University",
    value: "Guram Tavartkiladze Teaching University",
  },
  {
    label: "Guru Angad Dev Veterinary and Animal Sciences University",
    value: "Guru Angad Dev Veterinary and Animal Sciences University",
  },
  {
    label: "Guru Ghasidas Vishwavidyalaya",
    value: "Guru Ghasidas Vishwavidyalaya",
  },
  {
    label: "Guru Gobind Singh Indraprastha University",
    value: "Guru Gobind Singh Indraprastha University",
  },
  {
    label: "Guru Jambheshwar University of Science and Technology",
    value: "Guru Jambheshwar University of Science and Technology",
  },
  {
    label: "Guru Kashi University",
    value: "Guru Kashi University",
  },
  {
    label: "Guru Nanak Dev University",
    value: "Guru Nanak Dev University",
  },
  {
    label: "Guru Ravidas Ayurved University",
    value: "Guru Ravidas Ayurved University",
  },
  {
    label: "Gurukul Kangri Vishwavidyalaya",
    value: "Gurukul Kangri Vishwavidyalaya",
  },
  {
    label: "Gurvan Erdene Institute of Pedagogy",
    value: "Gurvan Erdene Institute of Pedagogy",
  },
  {
    label: "Gurvan Tamir College",
    value: "Gurvan Tamir College",
  },
  {
    label: "Gustav Mahler Privatuniversität für Musik",
    value: "Gustav Mahler Privatuniversität für Musik",
  },
  {
    label: "Gustavus Adolphus College",
    value: "Gustavus Adolphus College",
  },
  {
    label: "Gwanda State University",
    value: "Gwanda State University",
  },
  {
    label: "Gwangju Catholic University",
    value: "Gwangju Catholic University",
  },
  {
    label: "Gwangju National University of Education",
    value: "Gwangju National University of Education",
  },
  {
    label: "Gwangju University",
    value: "Gwangju University",
  },
  {
    label: "Gwynedd Mercy University",
    value: "Gwynedd Mercy University",
  },
  {
    label: "Gyeongin National University of Education",
    value: "Gyeongin National University of Education",
  },
  {
    label: "Gyeongsang National University",
    value: "Gyeongsang National University",
  },
  {
    label: "Gymnastik- och idrottshögskolan",
    value: "Gymnastik- och idrottshögskolan",
  },
  {
    label: "H.S. Skovoroda Kharkiv National Pedagogical University",
    value: "H.S. Skovoroda Kharkiv National Pedagogical University",
  },
  {
    label: "HAAGA-HELIA ammattikorkeakoulu",
    value: "HAAGA-HELIA ammattikorkeakoulu",
  },
  {
    label: "Habib University",
    value: "Habib University",
  },
  {
    label: "Hacettepe Üniversitesi",
    value: "Hacettepe Üniversitesi",
  },
  {
    label: "Hachinohe Gakuin University",
    value: "Hachinohe Gakuin University",
  },
  {
    label: "Hachinohe Institute of Technology",
    value: "Hachinohe Institute of Technology",
  },
  {
    label: "Hadassah Academic College",
    value: "Hadassah Academic College",
  },
  {
    label: "Hadhramout University",
    value: "Hadhramout University",
  },
  {
    label: "HafenCity Universität Hamburg",
    value: "HafenCity Universität Hamburg",
  },
  {
    label: "Hagoromo University of International Studies",
    value: "Hagoromo University of International Studies",
  },
  {
    label: "Hai Phong Medical University",
    value: "Hai Phong Medical University",
  },
  {
    label: "Haigazian University",
    value: "Haigazian University",
  },
  {
    label: "Haikou College of Economics",
    value: "Haikou College of Economics",
  },
  {
    label: "Hainan Medical University",
    value: "Hainan Medical University",
  },
  {
    label: "Hainan Normal University",
    value: "Hainan Normal University",
  },
  {
    label: "Hainan Tropical Ocean University",
    value: "Hainan Tropical Ocean University",
  },
  {
    label: "Hainan University",
    value: "Hainan University",
  },
  {
    label: "Hajee Mohammad Danesh Science and Technology University",
    value: "Hajee Mohammad Danesh Science and Technology University",
  },
  {
    label: "Hajjah University",
    value: "Hajjah University",
  },
  {
    label: "Hajvery University",
    value: "Hajvery University",
  },
  {
    label: "Hakim Sabzevari University",
    value: "Hakim Sabzevari University",
  },
  {
    label: "Hakim Sanayee University",
    value: "Hakim Sanayee University",
  },
  {
    label: "Hakkari Üniversitesi",
    value: "Hakkari Üniversitesi",
  },
  {
    label: "Hakodate University",
    value: "Hakodate University",
  },
  {
    label: "Hakuoh University",
    value: "Hakuoh University",
  },
  {
    label: "Halhale College of Business and Economics",
    value: "Halhale College of Business and Economics",
  },
  {
    label: "Haliç Üniversitesi",
    value: "Haliç Üniversitesi",
  },
  {
    label: "Halla University",
    value: "Halla University",
  },
  {
    label: "Hallmark University, Ijebu-Itele",
    value: "Hallmark University, Ijebu-Itele",
  },
  {
    label: "Hallym University",
    value: "Hallym University",
  },
  {
    label: "Hamad Bin Khalifa University",
    value: "Hamad Bin Khalifa University",
  },
  {
    label: "Hamadan University of Medical Sciences",
    value: "Hamadan University of Medical Sciences",
  },
  {
    label: "Hamadan University of Technology",
    value: "Hamadan University of Technology",
  },
  {
    label: "Hamamatsu Gakuin University",
    value: "Hamamatsu Gakuin University",
  },
  {
    label: "Hamamatsu University School of Medicine",
    value: "Hamamatsu University School of Medicine",
  },
  {
    label: "Hamburg School of Business Administration",
    value: "Hamburg School of Business Administration",
  },
  {
    label: "Hamdard University",
    value: "Hamdard University",
  },
  {
    label: "Hamdard University of Bangladesh",
    value: "Hamdard University of Bangladesh",
  },
  {
    label: "Hämeen ammattikorkeakoulu",
    value: "Hämeen ammattikorkeakoulu",
  },
  {
    label: "Hamelmalo College of Agriculture",
    value: "Hamelmalo College of Agriculture",
  },
  {
    label: "Hamhung University of Chemical Industry",
    value: "Hamhung University of Chemical Industry",
  },
  {
    label: "Hamhung University of Education",
    value: "Hamhung University of Education",
  },
  {
    label: "Hamhung University of Mathematical and Physical Sciences",
    value: "Hamhung University of Mathematical and Physical Sciences",
  },
  {
    label: "Hamilton College",
    value: "Hamilton College",
  },
  {
    label: "Hamline University",
    value: "Hamline University",
  },
  {
    label: "Hampden-Sydney College",
    value: "Hampden-Sydney College",
  },
  {
    label: "Hampshire College",
    value: "Hampshire College",
  },
  {
    label: "Hampton University",
    value: "Hampton University",
  },
  {
    label: "Hanazono University",
    value: "Hanazono University",
  },
  {
    label: "Hanbat National University",
    value: "Hanbat National University",
  },
  {
    label: "Handan College",
    value: "Handan College",
  },
  {
    label: "Handelshögskolan i Stockholm",
    value: "Handelshögskolan i Stockholm",
  },
  {
    label: "Handelshøjskolen i København",
    value: "Handelshøjskolen i København",
  },
  {
    label: "Handelshøyskolen BI",
    value: "Handelshøyskolen BI",
  },
  {
    label: "Handong Global University",
    value: "Handong Global University",
  },
  {
    label: "Hangzhou Dianzi University",
    value: "Hangzhou Dianzi University",
  },
  {
    label: "Hangzhou Medical College",
    value: "Hangzhou Medical College",
  },
  {
    label: "Hangzhou Normal University",
    value: "Hangzhou Normal University",
  },
  {
    label: "Hanjiang Normal University",
    value: "Hanjiang Normal University",
  },
  {
    label: "Hanken Svenska handelshögskolan",
    value: "Hanken Svenska handelshögskolan",
  },
  {
    label: "Hankou University",
    value: "Hankou University",
  },
  {
    label: "Hankuk University of Foreign Studies",
    value: "Hankuk University of Foreign Studies",
  },
  {
    label: "Hankyong National University",
    value: "Hankyong National University",
  },
  {
    label: "Hannam University",
    value: "Hannam University",
  },
  {
    label: "Hannan University",
    value: "Hannan University",
  },
  {
    label: "Hannibal-LaGrange University",
    value: "Hannibal-LaGrange University",
  },
  {
    label: "Hanoi Architectural University",
    value: "Hanoi Architectural University",
  },
  {
    label: "Hanoi Industrial Textile Garment University",
    value: "Hanoi Industrial Textile Garment University",
  },
  {
    label: "Hanoi Law University",
    value: "Hanoi Law University",
  },
  {
    label: "Hanoi Medical University",
    value: "Hanoi Medical University",
  },
  {
    label: "Hanoi National University of Education",
    value: "Hanoi National University of Education",
  },
  {
    label: "Hanoi University",
    value: "Hanoi University",
  },
  {
    label: "Hanoi University of Business and Technology",
    value: "Hanoi University of Business and Technology",
  },
  {
    label: "Hanoi University of Civil Engineering",
    value: "Hanoi University of Civil Engineering",
  },
  {
    label: "Hanoi University of Culture",
    value: "Hanoi University of Culture",
  },
  {
    label: "Hanoi University of Industrial Fine Arts",
    value: "Hanoi University of Industrial Fine Arts",
  },
  {
    label: "Hanoi University of Industry",
    value: "Hanoi University of Industry",
  },
  {
    label: "Hanoi University of Mining and Geology",
    value: "Hanoi University of Mining and Geology",
  },
  {
    label: "Hanoi University of Pharmacy",
    value: "Hanoi University of Pharmacy",
  },
  {
    label: "Hanoi University of Science and Technology",
    value: "Hanoi University of Science and Technology",
  },
  {
    label: "Hanover College",
    value: "Hanover College",
  },
  {
    label: "Hansei University",
    value: "Hansei University",
  },
  {
    label: "Hanseo University",
    value: "Hanseo University",
  },
  {
    label: "Hanshan Normal University",
    value: "Hanshan Normal University",
  },
  {
    label: "Hanshin University",
    value: "Hanshin University",
  },
  {
    label: "Hansung University",
    value: "Hansung University",
  },
  {
    label: "Hanyang University",
    value: "Hanyang University",
  },
  {
    label: "Hanzehogeschool Groningen",
    value: "Hanzehogeschool Groningen",
  },
  {
    label: "Haramaya University",
    value: "Haramaya University",
  },
  {
    label: "Harare Institute of Technology",
    value: "Harare Institute of Technology",
  },
  {
    label: "Harbel College",
    value: "Harbel College",
  },
  {
    label: "Harbin Cambridge University",
    value: "Harbin Cambridge University",
  },
  {
    label: "Harbin Conservatory of Music",
    value: "Harbin Conservatory of Music",
  },
  {
    label: "Harbin Engineering University",
    value: "Harbin Engineering University",
  },
  {
    label: "Harbin Far East Institute of Technology",
    value: "Harbin Far East Institute of Technology",
  },
  {
    label: "Harbin Finance University",
    value: "Harbin Finance University",
  },
  {
    label: "Harbin Guangxia University",
    value: "Harbin Guangxia University",
  },
  {
    label: "Harbin Huade University",
    value: "Harbin Huade University",
  },
  {
    label: "Harbin Institute of Information Technology",
    value: "Harbin Institute of Information Technology",
  },
  {
    label: "Harbin Institute of Petroleum",
    value: "Harbin Institute of Petroleum",
  },
  {
    label: "Harbin Institute of Physical Education",
    value: "Harbin Institute of Physical Education",
  },
  {
    label: "Harbin Institute of Technology",
    value: "Harbin Institute of Technology",
  },
  {
    label: "Harbin Medical University",
    value: "Harbin Medical University",
  },
  {
    label: "Harbin Normal University",
    value: "Harbin Normal University",
  },
  {
    label: "Harbin University",
    value: "Harbin University",
  },
  {
    label: "Harbin University of Commerce",
    value: "Harbin University of Commerce",
  },
  {
    label: "Harbin University of Science and Technology",
    value: "Harbin University of Science and Technology",
  },
  {
    label: "Harcourt Butler Technical University",
    value: "Harcourt Butler Technical University",
  },
  {
    label: "Harding University",
    value: "Harding University",
  },
  {
    label: "Hardin-Simmons University",
    value: "Hardin-Simmons University",
  },
  {
    label: "Haridev Joshi University of Journalism and Mass Communication",
    value: "Haridev Joshi University of Journalism and Mass Communication",
  },
  {
    label: "Haridwar University",
    value: "Haridwar University",
  },
  {
    label: "Harokopio University",
    value: "Harokopio University",
  },
  {
    label: "Harper Adams University",
    value: "Harper Adams University",
  },
  {
    label: "Harran Üniversitesi",
    value: "Harran Üniversitesi",
  },
  {
    label: "Harrisburg University of Science and Technology",
    value: "Harrisburg University of Science and Technology",
  },
  {
    label: "Harris-Stowe State University",
    value: "Harris-Stowe State University",
  },
  {
    label: "Hartpury University and Hartpury College",
    value: "Hartpury University and Hartpury College",
  },
  {
    label: "Hartwick College",
    value: "Hartwick College",
  },
  {
    label: "Harvard University",
    value: "Harvard University",
  },
  {
    label: "Harvest University",
    value: "Harvest University",
  },
  {
    label: "Harvey Mudd College",
    value: "Harvey Mudd College",
  },
  {
    label: "HAS Hogeschool",
    value: "HAS Hogeschool",
  },
  {
    label: "Hasan Kalyoncu Üniversitesi",
    value: "Hasan Kalyoncu Üniversitesi",
  },
  {
    label: "Háskóli Íslands",
    value: "Háskóli Íslands",
  },
  {
    label: "Háskólinn á Akureyri",
    value: "Háskólinn á Akureyri",
  },
  {
    label: "Háskólinn á Bifröst",
    value: "Háskólinn á Bifröst",
  },
  {
    label: "Háskólinn á Hólum",
    value: "Háskólinn á Hólum",
  },
  {
    label: "Háskólinn í Reykjavík",
    value: "Háskólinn í Reykjavík",
  },
  {
    label: "Hastings College",
    value: "Hastings College",
  },
  {
    label: "Hatay Mustafa Kemal Üniversitesi",
    value: "Hatay Mustafa Kemal Üniversitesi",
  },
  {
    label: "Hatyai University",
    value: "Hatyai University",
  },
  {
    label: "Haute École Albert Jacquard",
    value: "Haute École Albert Jacquard",
  },
  {
    label: "Haute École Bruxelles-Brabant",
    value: "Haute École Bruxelles-Brabant",
  },
  {
    label: "Haute École Charlemagne",
    value: "Haute École Charlemagne",
  },
  {
    label: "Haute École de Commerce et de Management",
    value: "Haute École de Commerce et de Management",
  },
  {
    label: "Haute École de la Province de Liège",
    value: "Haute École de la Province de Liège",
  },
  {
    label: "Haute École de la Province de Namur",
    value: "Haute École de la Province de Namur",
  },
  {
    label: "Haute École de la Ville de Liège",
    value: "Haute École de la Ville de Liège",
  },
  {
    label: "Haute École de Namur-Liège-Luxembourg",
    value: "Haute École de Namur-Liège-Luxembourg",
  },
  {
    label: "Haute École en Hainaut",
    value: "Haute École en Hainaut",
  },
  {
    label: "Haute École EPHEC",
    value: "Haute École EPHEC",
  },
  {
    label: "Haute École Francisco Ferrer",
    value: "Haute École Francisco Ferrer",
  },
  {
    label: "Haute École Galilée",
    value: "Haute École Galilée",
  },
  {
    label: "Haute École Léonard de Vinci",
    value: "Haute École Léonard de Vinci",
  },
  {
    label: "Haute École Libre de Bruxelles Ilya Prigogine",
    value: "Haute École Libre de Bruxelles Ilya Prigogine",
  },
  {
    label: "Haute École Libre Mosane",
    value: "Haute École Libre Mosane",
  },
  {
    label: "Haute École Louvain en Hainaut",
    value: "Haute École Louvain en Hainaut",
  },
  {
    label: "Haute École Lucia de Brouckère",
    value: "Haute École Lucia de Brouckère",
  },
  {
    label: "Haute École Provinciale de Hainaut - Condorcet",
    value: "Haute École Provinciale de Hainaut - Condorcet",
  },
  {
    label: "Haute École Robert Schuman",
    value: "Haute École Robert Schuman",
  },
  {
    label: "Haute École Spécialisée de Suisse Occidentale",
    value: "Haute École Spécialisée de Suisse Occidentale",
  },
  {
    label: "Haverford College",
    value: "Haverford College",
  },
  {
    label: "Hawaii Pacific University",
    value: "Hawaii Pacific University",
  },
  {
    label: "Hawassa University",
    value: "Hawassa University",
  },
  {
    label: "HAWK Hochschule Hildesheim/Holzminden/Göttingen",
    value: "HAWK Hochschule Hildesheim/Holzminden/Göttingen",
  },
  {
    label: "Hawler Medical University",
    value: "Hawler Medical University",
  },
  {
    label: "Hazara University",
    value: "Hazara University",
  },
  {
    label: "Hazrat-e Masoumeh University",
    value: "Hazrat-e Masoumeh University",
  },
  {
    label: "Hazrat-e Narjes University of Rafsanjan",
    value: "Hazrat-e Narjes University of Rafsanjan",
  },
  {
    label: "He University",
    value: "He University",
  },
  {
    label: "Health Science University",
    value: "Health Science University",
  },
  {
    label: "Health Sciences University of Hokkaido",
    value: "Health Sciences University of Hokkaido",
  },
  {
    label: "Hebei Academy of Fine Arts",
    value: "Hebei Academy of Fine Arts",
  },
  {
    label: "Hebei College of Science and Technology",
    value: "Hebei College of Science and Technology",
  },
  {
    label: "Hebei Finance University",
    value: "Hebei Finance University",
  },
  {
    label: "Hebei Foreign Studies University",
    value: "Hebei Foreign Studies University",
  },
  {
    label: "Hebei GEO University",
    value: "Hebei GEO University",
  },
  {
    label: "Hebei Institute of Communication",
    value: "Hebei Institute of Communication",
  },
  {
    label: "Hebei Institute of Physical Education",
    value: "Hebei Institute of Physical Education",
  },
  {
    label: "Hebei Medical University",
    value: "Hebei Medical University",
  },
  {
    label: "Hebei Normal University",
    value: "Hebei Normal University",
  },
  {
    label: "Hebei Normal University for Nationalities",
    value: "Hebei Normal University for Nationalities",
  },
  {
    label: "Hebei Normal University of Science and Technology",
    value: "Hebei Normal University of Science and Technology",
  },
  {
    label: "Hebei North University",
    value: "Hebei North University",
  },
  {
    label: "Hebei Oriental University",
    value: "Hebei Oriental University",
  },
  {
    label: "Hebei Polytechnic Institute",
    value: "Hebei Polytechnic Institute",
  },
  {
    label: "Hebei University",
    value: "Hebei University",
  },
  {
    label: "Hebei University of Architecture",
    value: "Hebei University of Architecture",
  },
  {
    label: "Hebei University of Chinese Medicine",
    value: "Hebei University of Chinese Medicine",
  },
  {
    label: "Hebei University of Economics and Business",
    value: "Hebei University of Economics and Business",
  },
  {
    label: "Hebei University of Engineering",
    value: "Hebei University of Engineering",
  },
  {
    label: "Hebei University of Environmental Engineering",
    value: "Hebei University of Environmental Engineering",
  },
  {
    label: "Hebei University of Science and Technology",
    value: "Hebei University of Science and Technology",
  },
  {
    label: "Hebei University of Technology",
    value: "Hebei University of Technology",
  },
  {
    label: "Hebrew College",
    value: "Hebrew College",
  },
  {
    label: "Hebrew University of Jerusalem",
    value: "Hebrew University of Jerusalem",
  },
  {
    label: "Hebron University",
    value: "Hebron University",
  },
  {
    label: "HEC Maroc",
    value: "HEC Maroc",
  },
  {
    label: "HEC Montréal",
    value: "HEC Montréal",
  },
  {
    label: "HEC Paris in Qatar",
    value: "HEC Paris in Qatar",
  },
  {
    label: "Hechi University",
    value: "Hechi University",
  },
  {
    label: "Hefei Normal University",
    value: "Hefei Normal University",
  },
  {
    label: "Hefei University",
    value: "Hefei University",
  },
  {
    label: "Hefei University of Technology",
    value: "Hefei University of Technology",
  },
  {
    label: "Heian Jogakuin University",
    value: "Heian Jogakuin University",
  },
  {
    label: "Heidelberg University",
    value: "Heidelberg University",
  },
  {
    label: "Heihe University",
    value: "Heihe University",
  },
  {
    label: "Heilongjiang Bayi Agricultural University",
    value: "Heilongjiang Bayi Agricultural University",
  },
  {
    label: "Heilongjiang College of Business and Technology",
    value: "Heilongjiang College of Business and Technology",
  },
  {
    label: "Heilongjiang Institute of Technology",
    value: "Heilongjiang Institute of Technology",
  },
  {
    label: "Heilongjiang International University",
    value: "Heilongjiang International University",
  },
  {
    label: "Heilongjiang University",
    value: "Heilongjiang University",
  },
  {
    label: "Heilongjiang University of Chinese Medicine",
    value: "Heilongjiang University of Chinese Medicine",
  },
  {
    label: "Heilongjiang University of Finance and Economics",
    value: "Heilongjiang University of Finance and Economics",
  },
  {
    label: "Heilongjiang University of Science and Technology",
    value: "Heilongjiang University of Science and Technology",
  },
  {
    label: "Heilongjiang University of Technology",
    value: "Heilongjiang University of Technology",
  },
  {
    label: "Heinrich-Heine-Universität Düsseldorf",
    value: "Heinrich-Heine-Universität Düsseldorf",
  },
  {
    label: "Heisei College of Music",
    value: "Heisei College of Music",
  },
  {
    label: "Heisei International University",
    value: "Heisei International University",
  },
  {
    label: "Helene Fuld College of Nursing",
    value: "Helene Fuld College of Nursing",
  },
  {
    label: "Heliopolis University",
    value: "Heliopolis University",
  },
  {
    label: "Hellenic Mediterranean University",
    value: "Hellenic Mediterranean University",
  },
  {
    label: "Hellenic Naval Academy",
    value: "Hellenic Naval Academy",
  },
  {
    label: "Helmand University",
    value: "Helmand University",
  },
  {
    label: "Helmut-Schmidt-Universität",
    value: "Helmut-Schmidt-Universität",
  },
  {
    label: "HELP University",
    value: "HELP University",
  },
  {
    label: "Helsingin yliopisto",
    value: "Helsingin yliopisto",
  },
  {
    label: "Helwan University",
    value: "Helwan University",
  },
  {
    label: "HEM Institut des Hautes Etudes de Management",
    value: "HEM Institut des Hautes Etudes de Management",
  },
  {
    label: "Hemchandracharya North Gujarat University",
    value: "Hemchandracharya North Gujarat University",
  },
  {
    label: "Hemwati Nandan Bahuguna Garhwal University",
    value: "Hemwati Nandan Bahuguna Garhwal University",
  },
  {
    label: "Hemwati Nandan Bahuguna Uttarakhand Medical Education University",
    value: "Hemwati Nandan Bahuguna Uttarakhand Medical Education University",
  },
  {
    label: "Henan Agricultural University",
    value: "Henan Agricultural University",
  },
  {
    label: "Henan Finance University",
    value: "Henan Finance University",
  },
  {
    label: "Henan Institute of Science and Technology",
    value: "Henan Institute of Science and Technology",
  },
  {
    label: "Henan Institute of Technology",
    value: "Henan Institute of Technology",
  },
  {
    label: "Henan Institute of Technology",
    value: "Henan Institute of Technology",
  },
  {
    label: "Henan Normal University",
    value: "Henan Normal University",
  },
  {
    label: "Henan Polytechnic University",
    value: "Henan Polytechnic University",
  },
  {
    label: "Henan University",
    value: "Henan University",
  },
  {
    label: "Henan University of Animal Husbandry and Economy",
    value: "Henan University of Animal Husbandry and Economy",
  },
  {
    label: "Henan University of Economics and Law",
    value: "Henan University of Economics and Law",
  },
  {
    label: "Henan University of Science and Technology",
    value: "Henan University of Science and Technology",
  },
  {
    label: "Henan University of Technology",
    value: "Henan University of Technology",
  },
  {
    label: "Henan University of Traditional Chinese Medicine",
    value: "Henan University of Traditional Chinese Medicine",
  },
  {
    label: "Henan University of Urban Construction",
    value: "Henan University of Urban Construction",
  },
  {
    label: "Henderson State University",
    value: "Henderson State University",
  },
  {
    label: "Hendrix College",
    value: "Hendrix College",
  },
  {
    label: "Hengshui University",
    value: "Hengshui University",
  },
  {
    label: "Hengyang Normal University",
    value: "Hengyang Normal University",
  },
  {
    label: "Herat University",
    value: "Herat University",
  },
  {
    label: "Heriot-Watt University",
    value: "Heriot-Watt University",
  },
  {
    label: "Heritage Christian University",
    value: "Heritage Christian University",
  },
  {
    label: "Heritage University",
    value: "Heritage University",
  },
  {
    label: "Hertie School of Governance",
    value: "Hertie School of Governance",
  },
  {
    label: "Herzen State Pedagogical University of Russia",
    value: "Herzen State Pedagogical University of Russia",
  },
  {
    label: "Herzing University",
    value: "Herzing University",
  },
  {
    label: "Hetao College",
    value: "Hetao College",
  },
  {
    label: "Hexi University",
    value: "Hexi University",
  },
  {
    label: "Heze University",
    value: "Heze University",
  },
  {
    label: "Hezekiah University",
    value: "Hezekiah University",
  },
  {
    label: "Hezhou University",
    value: "Hezhou University",
  },
  {
    label: "HFH Hamburger Fern-Hochschule",
    value: "HFH Hamburger Fern-Hochschule",
  },
  {
    label: "HHL Leipzig Graduate School of Management",
    value: "HHL Leipzig Graduate School of Management",
  },
  {
    label: "Hidayatullah National Law University",
    value: "Hidayatullah National Law University",
  },
  {
    label: "Higashi Nippon International University",
    value: "Higashi Nippon International University",
  },
  {
    label: "Higashiosaka College",
    value: "Higashiosaka College",
  },
  {
    label: "High Point University",
    value: "High Point University",
  },
  {
    label: "Higher Colleges of Technology",
    value: "Higher Colleges of Technology",
  },
  {
    label: "Higher Education Complex of Larestan",
    value: "Higher Education Complex of Larestan",
  },
  {
    label: "Higher Education Complex of Saravan",
    value: "Higher Education Complex of Saravan",
  },
  {
    label: "Higher Education Complex of Torbat-e-Jam",
    value: "Higher Education Complex of Torbat-e-Jam",
  },
  {
    label: "Higher Education Complex of Zarand",
    value: "Higher Education Complex of Zarand",
  },
  {
    label: "Higher Institute of Business Administration",
    value: "Higher Institute of Business Administration",
  },
  {
    label: "Higher School of Insurance and Finance",
    value: "Higher School of Insurance and Finance",
  },
  {
    label: "HIGH-TECH",
    value: "HIGH-TECH",
  },
  {
    label: "Hijiyama University",
    value: "Hijiyama University",
  },
  {
    label: "Hilbert College",
    value: "Hilbert College",
  },
  {
    label: "Hilla University College",
    value: "Hilla University College",
  },
  {
    label: "Hillsdale College",
    value: "Hillsdale College",
  },
  {
    label: "Himachal Pradesh Technical University",
    value: "Himachal Pradesh Technical University",
  },
  {
    label: "Himachal Pradesh University",
    value: "Himachal Pradesh University",
  },
  {
    label: "Himalayan University",
    value: "Himalayan University",
  },
  {
    label: "Himeji Dokkyo University",
    value: "Himeji Dokkyo University",
  },
  {
    label: "Himeji University",
    value: "Himeji University",
  },
  {
    label: "Himgiri ZEE University",
    value: "Himgiri ZEE University",
  },
  {
    label: "Himilo University",
    value: "Himilo University",
  },
  {
    label: "Hindustan Institute of Technology and Science",
    value: "Hindustan Institute of Technology and Science",
  },
  {
    label: "Hinthada University",
    value: "Hinthada University",
  },
  {
    label: "Hiram College",
    value: "Hiram College",
  },
  {
    label: "Hirosaki Gakuin University",
    value: "Hirosaki Gakuin University",
  },
  {
    label: "Hirosaki University",
    value: "Hirosaki University",
  },
  {
    label: "Hirosaki University of Health and Welfare",
    value: "Hirosaki University of Health and Welfare",
  },
  {
    label: "Hiroshima Bunka Gakuen University",
    value: "Hiroshima Bunka Gakuen University",
  },
  {
    label: "Hiroshima Bunkyo University",
    value: "Hiroshima Bunkyo University",
  },
  {
    label: "Hiroshima Bunkyo Women's University",
    value: "Hiroshima Bunkyo Women's University",
  },
  {
    label: "Hiroshima City University",
    value: "Hiroshima City University",
  },
  {
    label: "Hiroshima Institute of Technology",
    value: "Hiroshima Institute of Technology",
  },
  {
    label: "Hiroshima International University",
    value: "Hiroshima International University",
  },
  {
    label: "Hiroshima Jogakuin University",
    value: "Hiroshima Jogakuin University",
  },
  {
    label: "Hiroshima Kokusai Gakuin University",
    value: "Hiroshima Kokusai Gakuin University",
  },
  {
    label: "Hiroshima Shudo University",
    value: "Hiroshima Shudo University",
  },
  {
    label: "Hiroshima University",
    value: "Hiroshima University",
  },
  {
    label: "Hiroshima University of Economics",
    value: "Hiroshima University of Economics",
  },
  {
    label: "HITEC University",
    value: "HITEC University",
  },
  {
    label: "Hitit Üniversitesi",
    value: "Hitit Üniversitesi",
  },
  {
    label: "Hitotsubashi University",
    value: "Hitotsubashi University",
  },
  {
    label: "Hlukhiv National Pedagogical University",
    value: "Hlukhiv National Pedagogical University",
  },
  {
    label: "HMKW Hochschule für Medien, Kommunikation und Wirtschaft",
    value: "HMKW Hochschule für Medien, Kommunikation und Wirtschaft",
  },
  {
    label: "Ho Chi Minh City International University",
    value: "Ho Chi Minh City International University",
  },
  {
    label: "Ho Chi Minh City University of Agriculture and Forestry",
    value: "Ho Chi Minh City University of Agriculture and Forestry",
  },
  {
    label: "Ho Chi Minh City University of Architecture",
    value: "Ho Chi Minh City University of Architecture",
  },
  {
    label: "Ho Chi Minh City University of Education",
    value: "Ho Chi Minh City University of Education",
  },
  {
    label: "Ho Chi Minh City University of Food Industry",
    value: "Ho Chi Minh City University of Food Industry",
  },
  {
    label:
      "Ho Chi Minh City University of Foreign Languages and Information Technology",
    value:
      "Ho Chi Minh City University of Foreign Languages and Information Technology",
  },
  {
    label: "Ho Chi Minh City University of Information Technology",
    value: "Ho Chi Minh City University of Information Technology",
  },
  {
    label: "Ho Chi Minh City University of Law",
    value: "Ho Chi Minh City University of Law",
  },
  {
    label: "Ho Chi Minh City University of Social Sciences and Humanities",
    value: "Ho Chi Minh City University of Social Sciences and Humanities",
  },
  {
    label: "Ho Chi Minh City University of Technology",
    value: "Ho Chi Minh City University of Technology",
  },
  {
    label: "Ho Chi Minh City University of Technology and Education",
    value: "Ho Chi Minh City University of Technology and Education",
  },
  {
    label: "Ho Chi Minh City University of Transport",
    value: "Ho Chi Minh City University of Transport",
  },
  {
    label: "Ho Technical University",
    value: "Ho Technical University",
  },
  {
    label: "Hoa Sen University",
    value: "Hoa Sen University",
  },
  {
    label: "Hobart and William Smith Colleges",
    value: "Hobart and William Smith Colleges",
  },
  {
    label: "hochschule 21",
    value: "hochschule 21",
  },
  {
    label: "Hochschule Aalen",
    value: "Hochschule Aalen",
  },
  {
    label: "Hochschule Albstadt-Sigmaringen",
    value: "Hochschule Albstadt-Sigmaringen",
  },
  {
    label: "Hochschule Anhalt",
    value: "Hochschule Anhalt",
  },
  {
    label: "Hochschule Ansbach",
    value: "Hochschule Ansbach",
  },
  {
    label: "Hochschule Aschaffenburg",
    value: "Hochschule Aschaffenburg",
  },
  {
    label: "Hochschule Biberach",
    value: "Hochschule Biberach",
  },
  {
    label: "Hochschule Bielefeld",
    value: "Hochschule Bielefeld",
  },
  {
    label: "Hochschule Bochum",
    value: "Hochschule Bochum",
  },
  {
    label: "Hochschule Bonn-Rhein-Sieg",
    value: "Hochschule Bonn-Rhein-Sieg",
  },
  {
    label: "Hochschule Bremen",
    value: "Hochschule Bremen",
  },
  {
    label: "Hochschule Bremerhaven",
    value: "Hochschule Bremerhaven",
  },
  {
    label: "Hochschule Coburg",
    value: "Hochschule Coburg",
  },
  {
    label: "Hochschule Darmstadt",
    value: "Hochschule Darmstadt",
  },
  {
    label: "Hochschule der Bildenden Künste Saar",
    value: "Hochschule der Bildenden Künste Saar",
  },
  {
    label: "Hochschule der Bundesagentur für Arbeit",
    value: "Hochschule der Bundesagentur für Arbeit",
  },
  {
    label: "Hochschule der Deutschen Bundesbank",
    value: "Hochschule der Deutschen Bundesbank",
  },
  {
    label: "Hochschule der Medien",
    value: "Hochschule der Medien",
  },
  {
    label: "Hochschule der Wirtschaft für Management",
    value: "Hochschule der Wirtschaft für Management",
  },
  {
    label: "Hochschule des Bundes für öffentliche Verwaltung",
    value: "Hochschule des Bundes für öffentliche Verwaltung",
  },
  {
    label: "Hochschule Düsseldorf",
    value: "Hochschule Düsseldorf",
  },
  {
    label: "Hochschule Emden/Leer",
    value: "Hochschule Emden/Leer",
  },
  {
    label: "Hochschule Esslingen",
    value: "Hochschule Esslingen",
  },
  {
    label: "Hochschule Flensburg",
    value: "Hochschule Flensburg",
  },
  {
    label: "Hochschule Fresenius",
    value: "Hochschule Fresenius",
  },
  {
    label: "Hochschule Fulda",
    value: "Hochschule Fulda",
  },
  {
    label: "Hochschule für Agrar- und Umweltpädagogik Wien",
    value: "Hochschule für Agrar- und Umweltpädagogik Wien",
  },
  {
    label: "Hochschule für Angewandte Wissenschaften Hamburg",
    value: "Hochschule für Angewandte Wissenschaften Hamburg",
  },
  {
    label: "Hochschule für angewandte Wissenschaften München",
    value: "Hochschule für angewandte Wissenschaften München",
  },
  {
    label: "Hochschule für angewandtes Management",
    value: "Hochschule für angewandtes Management",
  },
  {
    label: "Hochschule für Bildende Künste Braunschweig",
    value: "Hochschule für Bildende Künste Braunschweig",
  },
  {
    label: "Hochschule für Bildende Künste Dresden",
    value: "Hochschule für Bildende Künste Dresden",
  },
  {
    label: "Hochschule für Bildende Künste Hamburg",
    value: "Hochschule für Bildende Künste Hamburg",
  },
  {
    label: "Hochschule für Bildende Künste-Städelschule",
    value: "Hochschule für Bildende Künste-Städelschule",
  },
  {
    label: "Hochschule für Evangelische Kirchenmusik Bayreuth",
    value: "Hochschule für Evangelische Kirchenmusik Bayreuth",
  },
  {
    label: "Hochschule für Fernsehen und Film München",
    value: "Hochschule für Fernsehen und Film München",
  },
  {
    label: "Hochschule für Finanzen und Landesfinanzschule",
    value: "Hochschule für Finanzen und Landesfinanzschule",
  },
  {
    label: "Hochschule für Finanzwirtschaft & Management",
    value: "Hochschule für Finanzwirtschaft & Management",
  },
  {
    label: "Hochschule für Forstwirtschaft Rottenburg",
    value: "Hochschule für Forstwirtschaft Rottenburg",
  },
  {
    label: "Hochschule für Gestaltung Offenbach am Main",
    value: "Hochschule für Gestaltung Offenbach am Main",
  },
  {
    label: "Hochschule für Gestaltung Schwäbisch Gmünd",
    value: "Hochschule für Gestaltung Schwäbisch Gmünd",
  },
  {
    label: "Hochschule für Gesundheit",
    value: "Hochschule für Gesundheit",
  },
  {
    label: "Hochschule für Grafik und Buchkunst Leipzig",
    value: "Hochschule für Grafik und Buchkunst Leipzig",
  },
  {
    label: "Hochschule für Jüdische Studien Heidelberg",
    value: "Hochschule für Jüdische Studien Heidelberg",
  },
  {
    label: "Hochschule für Katholische Kirchenmusik und Musikpädagogik",
    value: "Hochschule für Katholische Kirchenmusik und Musikpädagogik",
  },
  {
    label: "Hochschule für Kirchenmusik Herford-Witten",
    value: "Hochschule für Kirchenmusik Herford-Witten",
  },
  {
    label: "Hochschule für Künste Bremen",
    value: "Hochschule für Künste Bremen",
  },
  {
    label: "Hochschule für Künste im Sozialen, Ottersberg",
    value: "Hochschule für Künste im Sozialen, Ottersberg",
  },
  {
    label: "Hochschule für Musik Carl Maria von Weber Dresden",
    value: "Hochschule für Musik Carl Maria von Weber Dresden",
  },
  {
    label: "Hochschule für Musik Detmold",
    value: "Hochschule für Musik Detmold",
  },
  {
    label: "Hochschule für Musik Franz Liszt Weimar",
    value: "Hochschule für Musik Franz Liszt Weimar",
  },
  {
    label: "Hochschule für Musik Freiburg",
    value: "Hochschule für Musik Freiburg",
  },
  {
    label: "Hochschule für Musik Hanns Eisler",
    value: "Hochschule für Musik Hanns Eisler",
  },
  {
    label: "Hochschule für Musik Karlsruhe",
    value: "Hochschule für Musik Karlsruhe",
  },
  {
    label: "Hochschule für Musik Nürnberg",
    value: "Hochschule für Musik Nürnberg",
  },
  {
    label: "Hochschule für Musik Saar",
    value: "Hochschule für Musik Saar",
  },
  {
    label: "Hochschule für Musik und Darstellende Kunst Frankfurt am Main",
    value: "Hochschule für Musik und Darstellende Kunst Frankfurt am Main",
  },
  {
    label: "Hochschule für Musik und Tanz Köln",
    value: "Hochschule für Musik und Tanz Köln",
  },
  {
    label: "Hochschule für Musik und Theater Hamburg",
    value: "Hochschule für Musik und Theater Hamburg",
  },
  {
    label: "Hochschule für Musik und Theater Leipzig",
    value: "Hochschule für Musik und Theater Leipzig",
  },
  {
    label: "Hochschule für Musik und Theater München",
    value: "Hochschule für Musik und Theater München",
  },
  {
    label: "Hochschule für Musik und Theater Rostock",
    value: "Hochschule für Musik und Theater Rostock",
  },
  {
    label: "Hochschule für Musik Würzburg",
    value: "Hochschule für Musik Würzburg",
  },
  {
    label: "Hochschule für Musik, Theater und Medien Hannover",
    value: "Hochschule für Musik, Theater und Medien Hannover",
  },
  {
    label: "Hochschule für Nachhaltige Entwicklung Eberswalde",
    value: "Hochschule für Nachhaltige Entwicklung Eberswalde",
  },
  {
    label: "Hochschule für Öffentliche Verwaltung Bremen",
    value: "Hochschule für Öffentliche Verwaltung Bremen",
  },
  {
    label: "Hochschule für öffentliche Verwaltung Kehl",
    value: "Hochschule für öffentliche Verwaltung Kehl",
  },
  {
    label: "Hochschule für öffentliche Verwaltung Rheinland-Pfalz",
    value: "Hochschule für öffentliche Verwaltung Rheinland-Pfalz",
  },
  {
    label: "Hochschule für öffentliche Verwaltung und Finanzen Ludwigsburg",
    value: "Hochschule für öffentliche Verwaltung und Finanzen Ludwigsburg",
  },
  {
    label: "Hochschule für Philosophie München",
    value: "Hochschule für Philosophie München",
  },
  {
    label:
      "Hochschule für Polizei und öffentliche Verwaltung Nordrhein-Westfalen",
    value:
      "Hochschule für Polizei und öffentliche Verwaltung Nordrhein-Westfalen",
  },
  {
    label: "Hochschule für Rechtspflege Schwetzingen",
    value: "Hochschule für Rechtspflege Schwetzingen",
  },
  {
    label: "Hochschule für Schauspielkunst Ernst Busch",
    value: "Hochschule für Schauspielkunst Ernst Busch",
  },
  {
    label: "Hochschule für Technik Stuttgart",
    value: "Hochschule für Technik Stuttgart",
  },
  {
    label: "Hochschule für Technik und Wirtschaft Berlin",
    value: "Hochschule für Technik und Wirtschaft Berlin",
  },
  {
    label: "Hochschule für Technik und Wirtschaft des Saarlandes",
    value: "Hochschule für Technik und Wirtschaft des Saarlandes",
  },
  {
    label: "Hochschule für Technik und Wirtschaft Dresden",
    value: "Hochschule für Technik und Wirtschaft Dresden",
  },
  {
    label: "Hochschule für Technik, Wirtschaft und Kultur Leipzig",
    value: "Hochschule für Technik, Wirtschaft und Kultur Leipzig",
  },
  {
    label: "Hochschule für Wirtschaft und Gesellschaft Ludwigshafen",
    value: "Hochschule für Wirtschaft und Gesellschaft Ludwigshafen",
  },
  {
    label: "Hochschule für Wirtschaft und Recht Berlin",
    value: "Hochschule für Wirtschaft und Recht Berlin",
  },
  {
    label: "Hochschule für Wirtschaft und Umwelt Nürtingen-Geislingen",
    value: "Hochschule für Wirtschaft und Umwelt Nürtingen-Geislingen",
  },
  {
    label: "Hochschule Geisenheim",
    value: "Hochschule Geisenheim",
  },
  {
    label: "Hochschule Hamm-Lippstadt",
    value: "Hochschule Hamm-Lippstadt",
  },
  {
    label: "Hochschule Hannover",
    value: "Hochschule Hannover",
  },
  {
    label: "Hochschule Harz",
    value: "Hochschule Harz",
  },
  {
    label: "Hochschule Heilbronn",
    value: "Hochschule Heilbronn",
  },
  {
    label: "Hochschule Hof",
    value: "Hochschule Hof",
  },
  {
    label: "Hochschule Kaiserslautern",
    value: "Hochschule Kaiserslautern",
  },
  {
    label: "Hochschule Karlsruhe",
    value: "Hochschule Karlsruhe",
  },
  {
    label: "Hochschule Kempten",
    value: "Hochschule Kempten",
  },
  {
    label: "Hochschule Koblenz",
    value: "Hochschule Koblenz",
  },
  {
    label: "Hochschule Konstanz",
    value: "Hochschule Konstanz",
  },
  {
    label: "Hochschule Landshut",
    value: "Hochschule Landshut",
  },
  {
    label: "Hochschule Luzern",
    value: "Hochschule Luzern",
  },
  {
    label: "Hochschule Macromedia",
    value: "Hochschule Macromedia",
  },
  {
    label: "Hochschule Magdeburg-Stendal",
    value: "Hochschule Magdeburg-Stendal",
  },
  {
    label: "Hochschule Mainz",
    value: "Hochschule Mainz",
  },
  {
    label: "Hochschule Mannheim",
    value: "Hochschule Mannheim",
  },
  {
    label: "Hochschule Merseburg",
    value: "Hochschule Merseburg",
  },
  {
    label: "Hochschule Mittweida",
    value: "Hochschule Mittweida",
  },
  {
    label: "Hochschule Neubrandenburg",
    value: "Hochschule Neubrandenburg",
  },
  {
    label: "Hochschule Neu-Ulm",
    value: "Hochschule Neu-Ulm",
  },
  {
    label: "Hochschule Niederrhein",
    value: "Hochschule Niederrhein",
  },
  {
    label: "Hochschule Nordhausen",
    value: "Hochschule Nordhausen",
  },
  {
    label: "Hochschule Offenburg",
    value: "Hochschule Offenburg",
  },
  {
    label: "Hochschule Osnabrück",
    value: "Hochschule Osnabrück",
  },
  {
    label: "Hochschule Pforzheim",
    value: "Hochschule Pforzheim",
  },
  {
    label: "Hochschule Ravensburg-Weingarten",
    value: "Hochschule Ravensburg-Weingarten",
  },
  {
    label: "Hochschule Reutlingen",
    value: "Hochschule Reutlingen",
  },
  {
    label: "Hochschule RheinMain",
    value: "Hochschule RheinMain",
  },
  {
    label: "Hochschule Rhein-Waal",
    value: "Hochschule Rhein-Waal",
  },
  {
    label: "Hochschule Rosenheim",
    value: "Hochschule Rosenheim",
  },
  {
    label: "Hochschule Ruhr West",
    value: "Hochschule Ruhr West",
  },
  {
    label: "Hochschule Schmalkalden",
    value: "Hochschule Schmalkalden",
  },
  {
    label: "Hochschule Stralsund",
    value: "Hochschule Stralsund",
  },
  {
    label: "Hochschule Trier",
    value: "Hochschule Trier",
  },
  {
    label: "Hochschule Weihenstephan-Triesdorf",
    value: "Hochschule Weihenstephan-Triesdorf",
  },
  {
    label: "Hochschule Weserbergland",
    value: "Hochschule Weserbergland",
  },
  {
    label: "Hochschule Wismar",
    value: "Hochschule Wismar",
  },
  {
    label: "Hochschule Worms",
    value: "Hochschule Worms",
  },
  {
    label: "Hochschule Zittau/Görlitz",
    value: "Hochschule Zittau/Görlitz",
  },
  {
    label: "Hochuschule Furtwangen",
    value: "Hochuschule Furtwangen",
  },
  {
    label: "Hodeidah University",
    value: "Hodeidah University",
  },
  {
    label: "Hodges University",
    value: "Hodges University",
  },
  {
    label: "Hofstra University",
    value: "Hofstra University",
  },
  {
    label: "Hogere Zeevaartschool Antwerpen",
    value: "Hogere Zeevaartschool Antwerpen",
  },
  {
    label: "Hogeschool de Kempel",
    value: "Hogeschool de Kempel",
  },
  {
    label: "Hogeschool Gent",
    value: "Hogeschool Gent",
  },
  {
    label: "Hogeschool INHolland",
    value: "Hogeschool INHolland",
  },
  {
    label: "Hogeschool iPABO",
    value: "Hogeschool iPABO",
  },
  {
    label: "Hogeschool KPZ",
    value: "Hogeschool KPZ",
  },
  {
    label: "Hogeschool Leiden",
    value: "Hogeschool Leiden",
  },
  {
    label: "Hogeschool PXL",
    value: "Hogeschool PXL",
  },
  {
    label: "Hogeschool Rotterdam",
    value: "Hogeschool Rotterdam",
  },
  {
    label: "Hogeschool Saxion",
    value: "Hogeschool Saxion",
  },
  {
    label: "Hogeschool Utrecht",
    value: "Hogeschool Utrecht",
  },
  {
    label: "Hogeschool van Amsterdam",
    value: "Hogeschool van Amsterdam",
  },
  {
    label: "Hogeschool van Arnhem en Nijmegen",
    value: "Hogeschool van Arnhem en Nijmegen",
  },
  {
    label: "Hogeschool Viaa",
    value: "Hogeschool Viaa",
  },
  {
    label: "Hogeschool voor de Kunsten Utrecht",
    value: "Hogeschool voor de Kunsten Utrecht",
  },
  {
    label: "Hogeschool West-Vlaanderen",
    value: "Hogeschool West-Vlaanderen",
  },
  {
    label: "Hogeschool Windesheim",
    value: "Hogeschool Windesheim",
  },
  {
    label: "Hogeschool Zeeland",
    value: "Hogeschool Zeeland",
  },
  {
    label: "Högskolan Dalarna",
    value: "Högskolan Dalarna",
  },
  {
    label: "Högskolan i Borås",
    value: "Högskolan i Borås",
  },
  {
    label: "Högskolan i Gävle",
    value: "Högskolan i Gävle",
  },
  {
    label: "Högskolan i Halmstad",
    value: "Högskolan i Halmstad",
  },
  {
    label: "Högskolan i Skövde",
    value: "Högskolan i Skövde",
  },
  {
    label: "Högskolan Kristianstad",
    value: "Högskolan Kristianstad",
  },
  {
    label: "Högskolan på Åland",
    value: "Högskolan på Åland",
  },
  {
    label: "Högskolan Väst",
    value: "Högskolan Väst",
  },
  {
    label: "Høgskolen i Innlandet",
    value: "Høgskolen i Innlandet",
  },
  {
    label: "Høgskolen i Molde",
    value: "Høgskolen i Molde",
  },
  {
    label: "Høgskolen i Østfold",
    value: "Høgskolen i Østfold",
  },
  {
    label: "Høgskulen i Volda",
    value: "Høgskulen i Volda",
  },
  {
    label: "Høgskulen på Vestlandet",
    value: "Høgskulen på Vestlandet",
  },
  {
    label: "Hohai University",
    value: "Hohai University",
  },
  {
    label: "Hokkai School of Commerce",
    value: "Hokkai School of Commerce",
  },
  {
    label: "Hokkaido Bunkyo University",
    value: "Hokkaido Bunkyo University",
  },
  {
    label: "Hokkaido Chitose College of Rehabilitation",
    value: "Hokkaido Chitose College of Rehabilitation",
  },
  {
    label: "Hokkaido Information University",
    value: "Hokkaido Information University",
  },
  {
    label: "Hokkaido University",
    value: "Hokkaido University",
  },
  {
    label: "Hokkaido University of Education",
    value: "Hokkaido University of Education",
  },
  {
    label: "Hokkaido University of Science",
    value: "Hokkaido University of Science",
  },
  {
    label: "Hokkai-Gakuen University",
    value: "Hokkai-Gakuen University",
  },
  {
    label: "Hokuriku Gakuin University",
    value: "Hokuriku Gakuin University",
  },
  {
    label: "Hokuriku University",
    value: "Hokuriku University",
  },
  {
    label: "Hokusei Gakuen University",
    value: "Hokusei Gakuen University",
  },
  {
    label: "Hokusho University",
    value: "Hokusho University",
  },
  {
    label: "Hokuyo University",
    value: "Hokuyo University",
  },
  {
    label: "Hollins University",
    value: "Hollins University",
  },
  {
    label: "Holon Institute of Technology",
    value: "Holon Institute of Technology",
  },
  {
    label: "Holy Angel University",
    value: "Holy Angel University",
  },
  {
    label: "Holy Apostles College and Seminary",
    value: "Holy Apostles College and Seminary",
  },
  {
    label: "Holy Cross College",
    value: "Holy Cross College",
  },
  {
    label: "Holy Cross of Davao College",
    value: "Holy Cross of Davao College",
  },
  {
    label: "Holy Family University",
    value: "Holy Family University",
  },
  {
    label: "Holy Name University",
    value: "Holy Name University",
  },
  {
    label: "Holy Names University",
    value: "Holy Names University",
  },
  {
    label: "Holy Trinity University",
    value: "Holy Trinity University",
  },
  {
    label: "Homi Bhabha National Institute",
    value: "Homi Bhabha National Institute",
  },
  {
    label: "Honam University",
    value: "Honam University",
  },
  {
    label: "Hong Bang International University",
    value: "Hong Bang International University",
  },
  {
    label: "Hong Duc University",
    value: "Hong Duc University",
  },
  {
    label: "Hong Kong Baptist University",
    value: "Hong Kong Baptist University",
  },
  {
    label: "Hong Kong Metropolitan University",
    value: "Hong Kong Metropolitan University",
  },
  {
    label: "Hong Kong Shue Yan University",
    value: "Hong Kong Shue Yan University",
  },
  {
    label: "Honghe University",
    value: "Honghe University",
  },
  {
    label: "Hongik University",
    value: "Hongik University",
  },
  {
    label: "Hood College",
    value: "Hood College",
  },
  {
    label: "Hope College",
    value: "Hope College",
  },
  {
    label: "Hope International University",
    value: "Hope International University",
  },
  {
    label: "Hormozgan University",
    value: "Hormozgan University",
  },
  {
    label: "Hormozgan University of Medical Sciences",
    value: "Hormozgan University of Medical Sciences",
  },
  {
    label: "Hosei University",
    value: "Hosei University",
  },
  {
    label: "Hosen College of Childhood Education",
    value: "Hosen College of Childhood Education",
  },
  {
    label: "Hoseo University",
    value: "Hoseo University",
  },
  {
    label: "Hoshi University",
    value: "Hoshi University",
  },
  {
    label: "Hotelschool The Hague",
    value: "Hotelschool The Hague",
  },
  {
    label: "Houghton University",
    value: "Houghton University",
  },
  {
    label: "Houston Baptist University",
    value: "Houston Baptist University",
  },
  {
    label: "Howard Payne University",
    value: "Howard Payne University",
  },
  {
    label: "Howard University",
    value: "Howard University",
  },
  {
    label: "Howon University",
    value: "Howon University",
  },
  {
    label: "Høyskolen Kristiania",
    value: "Høyskolen Kristiania",
  },
  {
    label: "Hpaan University",
    value: "Hpaan University",
  },
  {
    label: "Hrvatsko katolicko sveucilište",
    value: "Hrvatsko katolicko sveucilište",
  },
  {
    label: "Hryhorii Skovoroda University in Pereiaslav",
    value: "Hryhorii Skovoroda University in Pereiaslav",
  },
  {
    label: "Hsing Wu University",
    value: "Hsing Wu University",
  },
  {
    label: "Hsiuping University of Science and Technology",
    value: "Hsiuping University of Science and Technology",
  },
  {
    label: "Hsuan Chuang University",
    value: "Hsuan Chuang University",
  },
  {
    label: "Huachiew Chalermprakiet University",
    value: "Huachiew Chalermprakiet University",
  },
  {
    label: "Huafan University",
    value: "Huafan University",
  },
  {
    label: "Huaibei Normal University",
    value: "Huaibei Normal University",
  },
  {
    label: "Huaihua University",
    value: "Huaihua University",
  },
  {
    label: "Huainan Normal University",
    value: "Huainan Normal University",
  },
  {
    label: "Huaiyin Institute of Technology",
    value: "Huaiyin Institute of Technology",
  },
  {
    label: "Huaiyin Normal University",
    value: "Huaiyin Normal University",
  },
  {
    label: "Huanggang Normal University",
    value: "Huanggang Normal University",
  },
  {
    label: "Huanghe Jiaotong University",
    value: "Huanghe Jiaotong University",
  },
  {
    label: "Huanghe Science and Technology College",
    value: "Huanghe Science and Technology College",
  },
  {
    label: "Huanghuai University",
    value: "Huanghuai University",
  },
  {
    label: "Huangshan University",
    value: "Huangshan University",
  },
  {
    label: "Huaqiao University",
    value: "Huaqiao University",
  },
  {
    label: "Huazhong Agricultural University",
    value: "Huazhong Agricultural University",
  },
  {
    label: "Huazhong University of Science and Technology",
    value: "Huazhong University of Science and Technology",
  },
  {
    label: "Hubei Business College",
    value: "Hubei Business College",
  },
  {
    label: "Hubei Engineering University",
    value: "Hubei Engineering University",
  },
  {
    label: "Hubei Institute of Fine Arts",
    value: "Hubei Institute of Fine Arts",
  },
  {
    label: "Hubei Normal University",
    value: "Hubei Normal University",
  },
  {
    label: "Hubei Polytechnic University",
    value: "Hubei Polytechnic University",
  },
  {
    label: "Hubei University",
    value: "Hubei University",
  },
  {
    label: "Hubei University for Nationalities",
    value: "Hubei University for Nationalities",
  },
  {
    label: "Hubei University of Arts and Science",
    value: "Hubei University of Arts and Science",
  },
  {
    label: "Hubei University of Automotive Technology",
    value: "Hubei University of Automotive Technology",
  },
  {
    label: "Hubei University of Chinese Medicine",
    value: "Hubei University of Chinese Medicine",
  },
  {
    label: "Hubei University of Economics",
    value: "Hubei University of Economics",
  },
  {
    label: "Hubei University of Education",
    value: "Hubei University of Education",
  },
  {
    label: "Hubei University of Medicine",
    value: "Hubei University of Medicine",
  },
  {
    label: "Hubei University of Science and Technology",
    value: "Hubei University of Science and Technology",
  },
  {
    label: "Hubei University of Technology",
    value: "Hubei University of Technology",
  },
  {
    label: "Hubert Kairuki Memorial University",
    value: "Hubert Kairuki Memorial University",
  },
  {
    label: "Hudobná a umelecká akadémia Jána Albrechta",
    value: "Hudobná a umelecká akadémia Jána Albrechta",
  },
  {
    label: "Hue University",
    value: "Hue University",
  },
  {
    label: "Huichon University of Telecommunications",
    value: "Huichon University of Telecommunications",
  },
  {
    label: "Huizhou University",
    value: "Huizhou University",
  },
  {
    label: "Hult International Business School",
    value: "Hult International Business School",
  },
  {
    label: "Hulunbeier University",
    value: "Hulunbeier University",
  },
  {
    label: "Human Resources University",
    value: "Human Resources University",
  },
  {
    label: "Humanistinen ammattikorkeakoulu",
    value: "Humanistinen ammattikorkeakoulu",
  },
  {
    label: "Humanitarian Institute of Hrazdan",
    value: "Humanitarian Institute of Hrazdan",
  },
  {
    label: "Humanitarian-Technical Academy",
    value: "Humanitarian-Technical Academy",
  },
  {
    label: "Humboldt State University",
    value: "Humboldt State University",
  },
  {
    label: "Humboldt-Universität zu Berlin",
    value: "Humboldt-Universität zu Berlin",
  },
  {
    label: "Humphreys University",
    value: "Humphreys University",
  },
  {
    label: "Hunan Agricultural University",
    value: "Hunan Agricultural University",
  },
  {
    label: "Hunan Applied Technology University",
    value: "Hunan Applied Technology University",
  },
  {
    label: "Hunan City University",
    value: "Hunan City University",
  },
  {
    label: "Hunan First Normal University",
    value: "Hunan First Normal University",
  },
  {
    label: "Hunan Institute of Engineering",
    value: "Hunan Institute of Engineering",
  },
  {
    label: "Hunan Institute of Information Technology",
    value: "Hunan Institute of Information Technology",
  },
  {
    label: "Hunan Institute of Science and Technology",
    value: "Hunan Institute of Science and Technology",
  },
  {
    label: "Hunan Institute of Technology",
    value: "Hunan Institute of Technology",
  },
  {
    label: "Hunan Institute of Traffic Engineering",
    value: "Hunan Institute of Traffic Engineering",
  },
  {
    label: "Hunan International Economics University",
    value: "Hunan International Economics University",
  },
  {
    label: "Hunan Normal University",
    value: "Hunan Normal University",
  },
  {
    label: "Hunan University",
    value: "Hunan University",
  },
  {
    label: "Hunan University of Arts and Science",
    value: "Hunan University of Arts and Science",
  },
  {
    label: "Hunan University of Chinese Medicine",
    value: "Hunan University of Chinese Medicine",
  },
  {
    label: "Hunan University of Commerce",
    value: "Hunan University of Commerce",
  },
  {
    label: "Hunan University of Finance and Economics",
    value: "Hunan University of Finance and Economics",
  },
  {
    label: "Hunan University of Humanities, Science and Technology",
    value: "Hunan University of Humanities, Science and Technology",
  },
  {
    label: "Hunan University of Medicine",
    value: "Hunan University of Medicine",
  },
  {
    label: "Hunan University of Science and Engineering",
    value: "Hunan University of Science and Engineering",
  },
  {
    label: "Hunan University of Science and Technology",
    value: "Hunan University of Science and Technology",
  },
  {
    label: "Hunan University of Technology",
    value: "Hunan University of Technology",
  },
  {
    label: "Hunan Women's University",
    value: "Hunan Women's University",
  },
  {
    label: "Hung Vuong University",
    value: "Hung Vuong University",
  },
  {
    label: "Hungkuang University",
    value: "Hungkuang University",
  },
  {
    label: "HungKuo Delin University of Technology",
    value: "HungKuo Delin University of Technology",
  },
  {
    label: "Hunter College, CUNY",
    value: "Hunter College, CUNY",
  },
  {
    label: "Huntingdon College",
    value: "Huntingdon College",
  },
  {
    label: "Huntington University",
    value: "Huntington University",
  },
  {
    label: "Huree University",
    value: "Huree University",
  },
  {
    label: "Husson University",
    value: "Husson University",
  },
  {
    label: "Huston-Tillotson University",
    value: "Huston-Tillotson University",
  },
  {
    label: "HUTECH University",
    value: "HUTECH University",
  },
  {
    label: "Huzhou University",
    value: "Huzhou University",
  },
  {
    label: "Hwa Hsia University of Technology",
    value: "Hwa Hsia University of Technology",
  },
  {
    label: "Hwasung Medi Science University",
    value: "Hwasung Medi Science University",
  },
  {
    label: "Hyogo Medical University",
    value: "Hyogo Medical University",
  },
  {
    label: "Hyogo University",
    value: "Hyogo University",
  },
  {
    label: "Hyogo University of Teacher Education",
    value: "Hyogo University of Teacher Education",
  },
  {
    label: "Hyupsung University",
    value: "Hyupsung University",
  },
  {
    label: "I. Horbachevsky Ternopil National Medical University",
    value: "I. Horbachevsky Ternopil National Medical University",
  },
  {
    label: "I.M. Seçenov adina Birinci Moskva Dövlet Tibb Universitetinin Baki",
    value: "I.M. Seçenov adina Birinci Moskva Dövlet Tibb Universitetinin Baki",
  },
  {
    label: "Iakob Gogebashvili Telavi State University",
    value: "Iakob Gogebashvili Telavi State University",
  },
  {
    label: "IBA Erhvervsakademi Kolding",
    value: "IBA Erhvervsakademi Kolding",
  },
  {
    label: "IBAIS University",
    value: "IBAIS University",
  },
  {
    label: "Ibanda University",
    value: "Ibanda University",
  },
  {
    label: "Ibaraki Christian University",
    value: "Ibaraki Christian University",
  },
  {
    label: "Ibaraki Prefectural University of Health Sciences",
    value: "Ibaraki Prefectural University of Health Sciences",
  },
  {
    label: "Ibaraki University",
    value: "Ibaraki University",
  },
  {
    label: "Ibb University",
    value: "Ibb University",
  },
  {
    label: "IB-Hochschule Berlin",
    value: "IB-Hochschule Berlin",
  },
  {
    label: "Ibn Haldun Üniversitesi",
    value: "Ibn Haldun Üniversitesi",
  },
  {
    label: "Ibn Khaldoun University",
    value: "Ibn Khaldoun University",
  },
  {
    label: "Ibn Sina College for Health Sciences",
    value: "Ibn Sina College for Health Sciences",
  },
  {
    label: "Ibn Sina University",
    value: "Ibn Sina University",
  },
  {
    label: "Ibn Sina University of Medical and Pharmaceutical Sciences",
    value: "Ibn Sina University of Medical and Pharmaceutical Sciences",
  },
  {
    label: "Ibrahim Badamasi Babangida University",
    value: "Ibrahim Badamasi Babangida University",
  },
  {
    label: "IBS Mednarodna poslovna šola Ljubljana",
    value: "IBS Mednarodna poslovna šola Ljubljana",
  },
  {
    label: "Icahn School of Medicine at Mount Sinai",
    value: "Icahn School of Medicine at Mount Sinai",
  },
  {
    label: "ICAM - Institut Catholiques d'Arts et Métiers",
    value: "ICAM - Institut Catholiques d'Arts et Métiers",
  },
  {
    label: "ICFAI University, Dehradun",
    value: "ICFAI University, Dehradun",
  },
  {
    label: "ICFAI University, Himachal Pradesh",
    value: "ICFAI University, Himachal Pradesh",
  },
  {
    label: "ICFAI University, Jaipur",
    value: "ICFAI University, Jaipur",
  },
  {
    label: "ICFAI University, Jharkhand",
    value: "ICFAI University, Jharkhand",
  },
  {
    label: "ICFAI University, Meghalaya",
    value: "ICFAI University, Meghalaya",
  },
  {
    label: "ICFAI University, Mizoram",
    value: "ICFAI University, Mizoram",
  },
  {
    label: "ICFAI University, Nagaland",
    value: "ICFAI University, Nagaland",
  },
  {
    label: "ICFAI University, Raipur",
    value: "ICFAI University, Raipur",
  },
  {
    label: "ICFAI University, Sikkim",
    value: "ICFAI University, Sikkim",
  },
  {
    label: "ICFAI University, Tripura",
    value: "ICFAI University, Tripura",
  },
  {
    label: "Ichinomiya Kenshin College",
    value: "Ichinomiya Kenshin College",
  },
  {
    label: "ICN Business School",
    value: "ICN Business School",
  },
  {
    label: "Idaho State University",
    value: "Idaho State University",
  },
  {
    label: "Ider University",
    value: "Ider University",
  },
  {
    label: "IE University",
    value: "IE University",
  },
  {
    label: "IEC University",
    value: "IEC University",
  },
  {
    label: "IEDC-Bled School of Management",
    value: "IEDC-Bled School of Management",
  },
  {
    label: "IÉSEG School of Management",
    value: "IÉSEG School of Management",
  },
  {
    label: "IFHE Hyderabad",
    value: "IFHE Hyderabad",
  },
  {
    label: "IFP School",
    value: "IFP School",
  },
  {
    label: "IFTM University",
    value: "IFTM University",
  },
  {
    label: "Igbinedion University Okada",
    value: "Igbinedion University Okada",
  },
  {
    label: "Igdir Üniversitesi",
    value: "Igdir Üniversitesi",
  },
  {
    label: "Ignatius Ajuru University of Education",
    value: "Ignatius Ajuru University of Education",
  },
  {
    label: "IHE Delft Institute for Water Education",
    value: "IHE Delft Institute for Water Education",
  },
  {
    label: "IIC University of Technology",
    value: "IIC University of Technology",
  },
  {
    label: "IIHMR University",
    value: "IIHMR University",
  },
  {
    label: "IIMT University",
    value: "IIMT University",
  },
  {
    label: "Ikuei University",
    value: "Ikuei University",
  },
  {
    label: "Ikueikan University",
    value: "Ikueikan University",
  },
  {
    label: "Ilam University",
    value: "Ilam University",
  },
  {
    label: "Ilia State University",
    value: "Ilia State University",
  },
  {
    label: "Ilisimatusarfik",
    value: "Ilisimatusarfik",
  },
  {
    label: "Illinois College",
    value: "Illinois College",
  },
  {
    label: "Illinois College of Optometry",
    value: "Illinois College of Optometry",
  },
  {
    label: "Illinois Institute of Technology",
    value: "Illinois Institute of Technology",
  },
  {
    label: "Illinois State University",
    value: "Illinois State University",
  },
  {
    label: "Illinois Wesleyan University",
    value: "Illinois Wesleyan University",
  },
  {
    label: "Ilma University",
    value: "Ilma University",
  },
  {
    label: "Ilocos Sur Polytechnic State College",
    value: "Ilocos Sur Polytechnic State College",
  },
  {
    label: "Iloilo Science and Technology University",
    value: "Iloilo Science and Technology University",
  },
  {
    label: "Imam Abdulrahman Bin Faisal University",
    value: "Imam Abdulrahman Bin Faisal University",
  },
  {
    label: "Imam Al-Azam University College",
    value: "Imam Al-Azam University College",
  },
  {
    label: "Imam Al-Kadhim University College of Islamic Sciences",
    value: "Imam Al-Kadhim University College of Islamic Sciences",
  },
  {
    label: "Imam Hossein University",
    value: "Imam Hossein University",
  },
  {
    label: "Imam Ja'afar Al-sadiq University",
    value: "Imam Ja'afar Al-sadiq University",
  },
  {
    label: "Imam Khomeini Education and Research Institute",
    value: "Imam Khomeini Education and Research Institute",
  },
  {
    label: "Imam Khomeini International University",
    value: "Imam Khomeini International University",
  },
  {
    label: "Imam Malik College for Islamic Sharia and Law",
    value: "Imam Malik College for Islamic Sharia and Law",
  },
  {
    label: "Imam Reza University",
    value: "Imam Reza University",
  },
  {
    label: "Imam Sadiq University",
    value: "Imam Sadiq University",
  },
  {
    label: "Imam Shafei College of Islamic Sciences",
    value: "Imam Shafei College of Islamic Sciences",
  },
  {
    label: "IMC Fachhochschule Krems",
    value: "IMC Fachhochschule Krems",
  },
  {
    label: "Immaculata University",
    value: "Immaculata University",
  },
  {
    label: "Immanuel Kant Baltic Federal University",
    value: "Immanuel Kant Baltic Federal University",
  },
  {
    label: "Imo State University",
    value: "Imo State University",
  },
  {
    label: "Imperial College London",
    value: "Imperial College London",
  },
  {
    label: "Imperial College of Business Studies",
    value: "Imperial College of Business Studies",
  },
  {
    label: "Imperial School of Business and Science",
    value: "Imperial School of Business and Science",
  },
  {
    label: "IMS Unison University",
    value: "IMS Unison University",
  },
  {
    label: "IMT Atlantique",
    value: "IMT Atlantique",
  },
  {
    label: "IMT Mines Albi",
    value: "IMT Mines Albi",
  },
  {
    label: "IMT Mines Alès",
    value: "IMT Mines Alès",
  },
  {
    label: "IMT Nord Europe",
    value: "IMT Nord Europe",
  },
  {
    label: "INCAE Business School, Costa Rica",
    value: "INCAE Business School, Costa Rica",
  },
  {
    label: "INCAE Business School, Nicaragua",
    value: "INCAE Business School, Nicaragua",
  },
  {
    label: "Incheon Catholic University",
    value: "Incheon Catholic University",
  },
  {
    label: "Independent University, Bangladesh",
    value: "Independent University, Bangladesh",
  },
  {
    label: "Indian Agricultural Research Institute",
    value: "Indian Agricultural Research Institute",
  },
  {
    label: "Indian Institute of Engineering Science and Technology, Shibpur",
    value: "Indian Institute of Engineering Science and Technology, Shibpur",
  },
  {
    label: "Indian Institute of Foreign Trade",
    value: "Indian Institute of Foreign Trade",
  },
  {
    label: "Indian Institute of Information Technology Allahabad",
    value: "Indian Institute of Information Technology Allahabad",
  },
  {
    label: "Indian Institute of Information Technology and Management Gwalior",
    value: "Indian Institute of Information Technology and Management Gwalior",
  },
  {
    label:
      "Indian Institute of Information Technology, Design and Manufacturing",
    value:
      "Indian Institute of Information Technology, Design and Manufacturing",
  },
  {
    label: "Indian Institute of Information Technology, Guwahati",
    value: "Indian Institute of Information Technology, Guwahati",
  },
  {
    label: "Indian Institute of Information Technology, Kalyani",
    value: "Indian Institute of Information Technology, Kalyani",
  },
  {
    label: "Indian Institute of Information Technology, Kottayam",
    value: "Indian Institute of Information Technology, Kottayam",
  },
  {
    label: "Indian Institute of Information Technology, Lucknow",
    value: "Indian Institute of Information Technology, Lucknow",
  },
  {
    label: "Indian Institute of Information Technology, Manipur",
    value: "Indian Institute of Information Technology, Manipur",
  },
  {
    label: "Indian Institute of Information Technology, Pune",
    value: "Indian Institute of Information Technology, Pune",
  },
  {
    label: "Indian Institute of Information Technology, Sri City",
    value: "Indian Institute of Information Technology, Sri City",
  },
  {
    label: "Indian Institute of Information Technology, Una",
    value: "Indian Institute of Information Technology, Una",
  },
  {
    label: "Indian Institute of Information Technology, Vadodara",
    value: "Indian Institute of Information Technology, Vadodara",
  },
  {
    label: "Indian Institute of Public Health",
    value: "Indian Institute of Public Health",
  },
  {
    label: "Indian Institute of Science",
    value: "Indian Institute of Science",
  },
  {
    label: "Indian Institute of Science Education and Research, Bhopal",
    value: "Indian Institute of Science Education and Research, Bhopal",
  },
  {
    label: "Indian Institute of Science Education and Research, Kolkata",
    value: "Indian Institute of Science Education and Research, Kolkata",
  },
  {
    label: "Indian Institute of Science Education and Research, Mohali",
    value: "Indian Institute of Science Education and Research, Mohali",
  },
  {
    label: "Indian Institute of Science Education and Research, Pune",
    value: "Indian Institute of Science Education and Research, Pune",
  },
  {
    label:
      "Indian Institute of Science Education and Research, Thiruvananthapuram",
    value:
      "Indian Institute of Science Education and Research, Thiruvananthapuram",
  },
  {
    label: "Indian Institute of Space Science and Technology",
    value: "Indian Institute of Space Science and Technology",
  },
  {
    label: "Indian Institute of Teacher Education",
    value: "Indian Institute of Teacher Education",
  },
  {
    label: "Indian Institute of Technology Bhubaneswar",
    value: "Indian Institute of Technology Bhubaneswar",
  },
  {
    label: "Indian Institute of Technology Bombay",
    value: "Indian Institute of Technology Bombay",
  },
  {
    label: "Indian Institute of Technology Delhi",
    value: "Indian Institute of Technology Delhi",
  },
  {
    label: "Indian Institute of Technology Gandhinagar",
    value: "Indian Institute of Technology Gandhinagar",
  },
  {
    label: "Indian Institute of Technology Guwahati",
    value: "Indian Institute of Technology Guwahati",
  },
  {
    label: "Indian Institute of Technology Hyderabad",
    value: "Indian Institute of Technology Hyderabad",
  },
  {
    label: "Indian Institute of Technology Indore",
    value: "Indian Institute of Technology Indore",
  },
  {
    label: "Indian Institute of Technology Jodhpur",
    value: "Indian Institute of Technology Jodhpur",
  },
  {
    label: "Indian Institute of Technology Kanpur",
    value: "Indian Institute of Technology Kanpur",
  },
  {
    label: "Indian Institute of Technology Kharagpur",
    value: "Indian Institute of Technology Kharagpur",
  },
  {
    label: "Indian Institute of Technology Madras",
    value: "Indian Institute of Technology Madras",
  },
  {
    label: "Indian Institute of Technology Mandi",
    value: "Indian Institute of Technology Mandi",
  },
  {
    label: "Indian Institute of Technology Patna",
    value: "Indian Institute of Technology Patna",
  },
  {
    label: "Indian Institute of Technology Roorkee",
    value: "Indian Institute of Technology Roorkee",
  },
  {
    label: "Indian Institute of Technology Ropar",
    value: "Indian Institute of Technology Ropar",
  },
  {
    label: "Indian Institute of Technology, BHU",
    value: "Indian Institute of Technology, BHU",
  },
  {
    label: "Indian Maritime University",
    value: "Indian Maritime University",
  },
  {
    label: "Indian River State College",
    value: "Indian River State College",
  },
  {
    label: "Indian School of Mines",
    value: "Indian School of Mines",
  },
  {
    label: "Indian Statistical Institute",
    value: "Indian Statistical Institute",
  },
  {
    label: "Indian Veterinary Research Institute",
    value: "Indian Veterinary Research Institute",
  },
  {
    label: "Indiana Institute of Technology",
    value: "Indiana Institute of Technology",
  },
  {
    label: "Indiana State University",
    value: "Indiana State University",
  },
  {
    label: "Indiana University Bloomington",
    value: "Indiana University Bloomington",
  },
  {
    label: "Indiana University East",
    value: "Indiana University East",
  },
  {
    label: "Indiana University Fort Wayne",
    value: "Indiana University Fort Wayne",
  },
  {
    label: "Indiana University Kokomo",
    value: "Indiana University Kokomo",
  },
  {
    label: "Indiana University Northwest",
    value: "Indiana University Northwest",
  },
  {
    label: "Indiana University of Pennsylvania",
    value: "Indiana University of Pennsylvania",
  },
  {
    label: "Indiana University South Bend",
    value: "Indiana University South Bend",
  },
  {
    label: "Indiana University Southeast",
    value: "Indiana University Southeast",
  },
  {
    label: "Indiana University-Purdue University Indianapolis",
    value: "Indiana University-Purdue University Indianapolis",
  },
  {
    label: "Indiana Wesleyan University",
    value: "Indiana Wesleyan University",
  },
  {
    label: "Indira Gandhi Delhi Technical University for Women",
    value: "Indira Gandhi Delhi Technical University for Women",
  },
  {
    label: "Indira Gandhi Institute of Development Research",
    value: "Indira Gandhi Institute of Development Research",
  },
  {
    label: "Indira Gandhi Institute of Medical Sciences",
    value: "Indira Gandhi Institute of Medical Sciences",
  },
  {
    label: "Indira Gandhi Krishi Vishwavidyalaya",
    value: "Indira Gandhi Krishi Vishwavidyalaya",
  },
  {
    label: "Indira Gandhi National Tribal University",
    value: "Indira Gandhi National Tribal University",
  },
  {
    label: "Indira Gandhi Technological and Medical Sciences University",
    value: "Indira Gandhi Technological and Medical Sciences University",
  },
  {
    label: "Indira Gandhi University, Meerpur",
    value: "Indira Gandhi University, Meerpur",
  },
  {
    label: "Indira Kala Sangeet Vishwavidyalaya",
    value: "Indira Kala Sangeet Vishwavidyalaya",
  },
  {
    label: "Indraprastha Institute of Information Technology",
    value: "Indraprastha Institute of Information Technology",
  },
  {
    label: "Indrashil University",
    value: "Indrashil University",
  },
  {
    label: "Indus International University",
    value: "Indus International University",
  },
  {
    label: "Indus University",
    value: "Indus University",
  },
  {
    label: "Indus University, Pakistan",
    value: "Indus University, Pakistan",
  },
  {
    label: "Indus Valley School of Art and Architecture",
    value: "Indus Valley School of Art and Architecture",
  },
  {
    label: "Industrial University of Tyumen",
    value: "Industrial University of Tyumen",
  },
  {
    label: "Informacijas sistemu menedžmenta augstskola",
    value: "Informacijas sistemu menedžmenta augstskola",
  },
  {
    label: "Information and Communication University",
    value: "Information and Communication University",
  },
  {
    label: "Information Technology University",
    value: "Information Technology University",
  },
  {
    label: "Ingush State University",
    value: "Ingush State University",
  },
  {
    label: "Inha University",
    value: "Inha University",
  },
  {
    label: "Inje University",
    value: "Inje University",
  },
  {
    label: "Inner Mongolia Agricultural University",
    value: "Inner Mongolia Agricultural University",
  },
  {
    label: "Inner Mongolia Arts University",
    value: "Inner Mongolia Arts University",
  },
  {
    label: "Inner Mongolia Medical University",
    value: "Inner Mongolia Medical University",
  },
  {
    label: "Inner Mongolia Nationality College",
    value: "Inner Mongolia Nationality College",
  },
  {
    label: "Inner Mongolia Normal University",
    value: "Inner Mongolia Normal University",
  },
  {
    label: "Inner Mongolia University",
    value: "Inner Mongolia University",
  },
  {
    label: "Inner Mongolia University for the Nationalities",
    value: "Inner Mongolia University for the Nationalities",
  },
  {
    label: "Inner Mongolia University of Finance and Economics",
    value: "Inner Mongolia University of Finance and Economics",
  },
  {
    label: "Inner Mongolia University of Science and Technology",
    value: "Inner Mongolia University of Science and Technology",
  },
  {
    label: "Inner Mongolia University of Technology",
    value: "Inner Mongolia University of Technology",
  },
  {
    label: "Innovative University of Eurasia",
    value: "Innovative University of Eurasia",
  },
  {
    label: "Inönü Üniversitesi",
    value: "Inönü Üniversitesi",
  },
  {
    label: "INSEEC Alpes-Savoie",
    value: "INSEEC Alpes-Savoie",
  },
  {
    label: "Institución Universitaria Antonio José Camacho",
    value: "Institución Universitaria Antonio José Camacho",
  },
  {
    label: "Institución Universitaria Bellas Artes y Ciencias de Bolívar",
    value: "Institución Universitaria Bellas Artes y Ciencias de Bolívar",
  },
  {
    label: "Institución Universitaria Colegio Mayor del Cauca",
    value: "Institución Universitaria Colegio Mayor del Cauca",
  },
  {
    label: "Institucion Universitaria Colegios de Colombia",
    value: "Institucion Universitaria Colegios de Colombia",
  },
  {
    label: "Institucion Universitaria Colombo Americana",
    value: "Institucion Universitaria Colombo Americana",
  },
  {
    label:
      "Institucion Universitaria Conocimiento e Innovacion para la Justicia",
    value:
      "Institucion Universitaria Conocimiento e Innovacion para la Justicia",
  },
  {
    label: "Institución Universitaria de Barranquilla",
    value: "Institución Universitaria de Barranquilla",
  },
  {
    label: "Institucion Universitaria de Colombia - Universitaria de Colombia",
    value: "Institucion Universitaria de Colombia - Universitaria de Colombia",
  },
  {
    label: "Institución Universitaria de Envigado",
    value: "Institución Universitaria de Envigado",
  },
  {
    label: "Institucion Universitaria EAM",
    value: "Institucion Universitaria EAM",
  },
  {
    label: "Institución Universitaria Esumer",
    value: "Institución Universitaria Esumer",
  },
  {
    label: "Institucion Universitaria Latina",
    value: "Institucion Universitaria Latina",
  },
  {
    label: "Institucion Universitaria Marco Fidel Suarez",
    value: "Institucion Universitaria Marco Fidel Suarez",
  },
  {
    label: "Institución Universitaria Mayor de Cartagena",
    value: "Institución Universitaria Mayor de Cartagena",
  },
  {
    label: "Institucion Universitaria Salazar y Herrera",
    value: "Institucion Universitaria Salazar y Herrera",
  },
  {
    label: "Institut Africain de Commerce et de Marketing",
    value: "Institut Africain de Commerce et de Marketing",
  },
  {
    label: "Institut Agro Dijon",
    value: "Institut Agro Dijon",
  },
  {
    label: "Institut Agro Rennes-Angers",
    value: "Institut Agro Rennes-Angers",
  },
  {
    label: "Institut Catholique de Kabgayi",
    value: "Institut Catholique de Kabgayi",
  },
  {
    label: "Institut Catholique de Paris",
    value: "Institut Catholique de Paris",
  },
  {
    label: "Institut Catholique de Toulouse",
    value: "Institut Catholique de Toulouse",
  },
  {
    label: "Institut Catholique de Yaoundé",
    value: "Institut Catholique de Yaoundé",
  },
  {
    label: "Institut Catholique des Hautes Études Commerciales",
    value: "Institut Catholique des Hautes Études Commerciales",
  },
  {
    label: "Institut de hautes études internationales et du développement",
    value: "Institut de hautes études internationales et du développement",
  },
  {
    label: "Institut de Technologies d’Owendo",
    value: "Institut de Technologies d’Owendo",
  },
  {
    label: "Institut d'Enséignement Supérieur de Ruhengeri",
    value: "Institut d'Enséignement Supérieur de Ruhengeri",
  },
  {
    label: "Institut des Arts de Diffusion",
    value: "Institut des Arts de Diffusion",
  },
  {
    label: "Institut des Sciences et Techniques de la Communication",
    value: "Institut des Sciences et Techniques de la Communication",
  },
  {
    label: "Institut des Techniques Avancées",
    value: "Institut des Techniques Avancées",
  },
  {
    label: "Institut d'Études Politiques de Paris",
    value: "Institut d'Études Politiques de Paris",
  },
  {
    label: "Institut d'Optique Graduate School",
    value: "Institut d'Optique Graduate School",
  },
  {
    label: "Inštitut in akademija za multimedije",
    value: "Inštitut in akademija za multimedije",
  },
  {
    label: "Institut International de Management",
    value: "Institut International de Management",
  },
  {
    label: "Institut International de Technologie",
    value: "Institut International de Technologie",
  },
  {
    label: "Institut International du Commerce et du Développement",
    value: "Institut International du Commerce et du Développement",
  },
  {
    label: "Institut International du Numérique et de l'Audiovisuel",
    value: "Institut International du Numérique et de l'Audiovisuel",
  },
  {
    label: "Institut Jean-Paul II",
    value: "Institut Jean-Paul II",
  },
  {
    label: "Institut National d'Administration",
    value: "Institut National d'Administration",
  },
  {
    label: "Institut National de la Jeunesse et des Sports",
    value: "Institut National de la Jeunesse et des Sports",
  },
  {
    label:
      "Institut National de la Poste des Technologies de l'Information et de la Communication",
    value:
      "Institut National de la Poste des Technologies de l'Information et de la Communication",
  },
  {
    label: "Institut National de Santé Publique",
    value: "Institut National de Santé Publique",
  },
  {
    label: "Institut National des Langues et Civilisations Orientales",
    value: "Institut National des Langues et Civilisations Orientales",
  },
  {
    label: "Institut National des Sciences Appliquées Centre Val de Loire",
    value: "Institut National des Sciences Appliquées Centre Val de Loire",
  },
  {
    label: "Institut National des Sciences Appliquées de Lyon",
    value: "Institut National des Sciences Appliquées de Lyon",
  },
  {
    label: "Institut National des Sciences Appliquées de Rennes",
    value: "Institut National des Sciences Appliquées de Rennes",
  },
  {
    label: "Institut National des Sciences Appliquées de Rouen",
    value: "Institut National des Sciences Appliquées de Rouen",
  },
  {
    label: "Institut National des Sciences Appliquées de Strasbourg",
    value: "Institut National des Sciences Appliquées de Strasbourg",
  },
  {
    label: "Institut National des Sciences Appliquées de Toulouse",
    value: "Institut National des Sciences Appliquées de Toulouse",
  },
  {
    label: "Institut National des Sciences de Gestion",
    value: "Institut National des Sciences de Gestion",
  },
  {
    label: "Institut national du service public",
    value: "Institut national du service public",
  },
  {
    label: "Institut National Polytechnique de Toulouse",
    value: "Institut National Polytechnique de Toulouse",
  },
  {
    label: "Institut National Polytechnique Félix Houphouët-Boigny",
    value: "Institut National Polytechnique Félix Houphouët-Boigny",
  },
  {
    label:
      "Institut national supérieur des Arts du Spectacle et des Techniques de Diffusion",
    value:
      "Institut national supérieur des Arts du Spectacle et des Techniques de Diffusion",
  },
  {
    label: "Institut National Supérieur des Arts et de l'Action Culturelle",
    value: "Institut National Supérieur des Arts et de l'Action Culturelle",
  },
  {
    label: "Institut National Universitaire Champollion",
    value: "Institut National Universitaire Champollion",
  },
  {
    label: "Institut Pertanian Bogor",
    value: "Institut Pertanian Bogor",
  },
  {
    label: "Institut Polytechnique Africain",
    value: "Institut Polytechnique Africain",
  },
  {
    label: "Institut Polytechnique de Dakar",
    value: "Institut Polytechnique de Dakar",
  },
  {
    label: "Institut Polytechnique des Sciences Avancées",
    value: "Institut Polytechnique des Sciences Avancées",
  },
  {
    label: "Institut Polytechnique privé des Sciences Avancées de Sfax",
    value: "Institut Polytechnique privé des Sciences Avancées de Sfax",
  },
  {
    label:
      "Institut Polytechnique Rural de Formation et de Recherches Appliquées de Katibougou",
    value:
      "Institut Polytechnique Rural de Formation et de Recherches Appliquées de Katibougou",
  },
  {
    label: "Institut Privé de Formation et de Recherches Médicales de Dakar",
    value: "Institut Privé de Formation et de Recherches Médicales de Dakar",
  },
  {
    label: "Institut privé des hautes Etudes Cheick Modibo Diarra",
    value: "Institut privé des hautes Etudes Cheick Modibo Diarra",
  },
  {
    label: "Institut Privée des Hautes Etudes à Sousse",
    value: "Institut Privée des Hautes Etudes à Sousse",
  },
  {
    label: "Institut Privée des Hautes Etudes à Tunis",
    value: "Institut Privée des Hautes Etudes à Tunis",
  },
  {
    label: "Institut Saint-Luc Tournai",
    value: "Institut Saint-Luc Tournai",
  },
  {
    label: "Institut Sciences Campus",
    value: "Institut Sciences Campus",
  },
  {
    label: "Institut Seni Indonesia Denpasar",
    value: "Institut Seni Indonesia Denpasar",
  },
  {
    label: "Institut Seni Indonesia Padang Panjang",
    value: "Institut Seni Indonesia Padang Panjang",
  },
  {
    label: "Institut Seni Indonesia Surakarta",
    value: "Institut Seni Indonesia Surakarta",
  },
  {
    label: "Institut Seni Indonesia Yogyakarta",
    value: "Institut Seni Indonesia Yogyakarta",
  },
  {
    label: "Institut Supérieur d'Agriculture et d'Agroalimentaire Rhône-Alpes",
    value: "Institut Supérieur d'Agriculture et d'Agroalimentaire Rhône-Alpes",
  },
  {
    label: "Institut Superieur de Communication et de Gestion",
    value: "Institut Superieur de Communication et de Gestion",
  },
  {
    label: "Institut Supérieur de Formation Sociale et de Communication",
    value: "Institut Supérieur de Formation Sociale et de Communication",
  },
  {
    label: "Institut Supérieur de Gestion",
    value: "Institut Supérieur de Gestion",
  },
  {
    label: "Institut Supérieur de Gestion des Entreprises",
    value: "Institut Supérieur de Gestion des Entreprises",
  },
  {
    label: "Institut Supérieur de l'Aéronautique et de l'Espace",
    value: "Institut Supérieur de l'Aéronautique et de l'Espace",
  },
  {
    label: "Institut Supérieur de l'Électronique et du Numérique",
    value: "Institut Supérieur de l'Électronique et du Numérique",
  },
  {
    label: "Institut Supérieur de Management Adonaï",
    value: "Institut Supérieur de Management Adonaï",
  },
  {
    label: "Institut Supérieur de Musique et de Pédagogie",
    value: "Institut Supérieur de Musique et de Pédagogie",
  },
  {
    label: "Institut Supérieur de Technologie",
    value: "Institut Supérieur de Technologie",
  },
  {
    label: "Institut Supérieur d'Électronique de Paris",
    value: "Institut Supérieur d'Électronique de Paris",
  },
  {
    label: "Institut Supérieur des Biotechnologies de Paris",
    value: "Institut Supérieur des Biotechnologies de Paris",
  },
  {
    label:
      "Institut Supérieur des Etudes Paramédicales et Sciences Infirmières",
    value:
      "Institut Supérieur des Etudes Paramédicales et Sciences Infirmières",
  },
  {
    label: "Institut Supérieur des Matériaux et Mécaniques Avancés du Mans",
    value: "Institut Supérieur des Matériaux et Mécaniques Avancés du Mans",
  },
  {
    label: "Institut Supérieur des Métiers de l'Audiovisuel",
    value: "Institut Supérieur des Métiers de l'Audiovisuel",
  },
  {
    label:
      "Institut Supérieur des Nouvelles Technologies de Commerce de Bâtiment et de Santé",
    value:
      "Institut Supérieur des Nouvelles Technologies de Commerce de Bâtiment et de Santé",
  },
  {
    label: "Institut Supérieur d'Etudes et de Recherche Islamiques",
    value: "Institut Supérieur d'Etudes et de Recherche Islamiques",
  },
  {
    label: "Institut Supérieur du Bâtiment et des Travaux Publics",
    value: "Institut Supérieur du Bâtiment et des Travaux Publics",
  },
  {
    label: "Institut Supérieur du Génie Appliqué",
    value: "Institut Supérieur du Génie Appliqué",
  },
  {
    label: "Institut Supérieur Privé d'Administrationdes Entreprises",
    value: "Institut Supérieur Privé d'Administrationdes Entreprises",
  },
  {
    label: "Institut Supérieur Privé des Sciences Infirmières de Kairouan",
    value: "Institut Supérieur Privé des Sciences Infirmières de Kairouan",
  },
  {
    label: "Institut Supérieur Privé des Sciences Infirmières de Sousse",
    value: "Institut Supérieur Privé des Sciences Infirmières de Sousse",
  },
  {
    label: "Institut Supérieur Privé des Sciences Infirmières El Amed",
    value: "Institut Supérieur Privé des Sciences Infirmières El Amed",
  },
  {
    label:
      "Institut Supérieur Privé des Sciences, de la Technologie et des Affaires du Centre",
    value:
      "Institut Supérieur Privé des Sciences, de la Technologie et des Affaires du Centre",
  },
  {
    label: "Institut Teknologi Bandung",
    value: "Institut Teknologi Bandung",
  },
  {
    label: "Institut Teknologi Nasional",
    value: "Institut Teknologi Nasional",
  },
  {
    label: "Institut Teknologi Nasional Malang",
    value: "Institut Teknologi Nasional Malang",
  },
  {
    label: "Institut Teknologi Sepuluh Nopember",
    value: "Institut Teknologi Sepuluh Nopember",
  },
  {
    label: "Institut Universitaire de l'Entreprise et du Développement",
    value: "Institut Universitaire de l'Entreprise et du Développement",
  },
  {
    label: "Institut Universitaire des Sciences de l'Organisation",
    value: "Institut Universitaire des Sciences de l'Organisation",
  },
  {
    label: "Institut Universitaire Panafricain",
    value: "Institut Universitaire Panafricain",
  },
  {
    label: "Institute for Advanced Studies in Basic Sciences",
    value: "Institute for Advanced Studies in Basic Sciences",
  },
  {
    label: "Institute for Research in Fundamental Sciences",
    value: "Institute for Research in Fundamental Sciences",
  },
  {
    label: "Institute for Training of Advanced Teachers",
    value: "Institute for Training of Advanced Teachers",
  },
  {
    label: "Institute of Advanced Media Arts and Sciences",
    value: "Institute of Advanced Media Arts and Sciences",
  },
  {
    label: "Institute of Advanced Research",
    value: "Institute of Advanced Research",
  },
  {
    label: "Institute of Advanced Studies in Education",
    value: "Institute of Advanced Studies in Education",
  },
  {
    label: "Institute of Business Administration",
    value: "Institute of Business Administration",
  },
  {
    label: "Institute of Business Management",
    value: "Institute of Business Management",
  },
  {
    label: "Institute of Chemical Technology",
    value: "Institute of Chemical Technology",
  },
  {
    label: "Institute of Economics and Finance",
    value: "Institute of Economics and Finance",
  },
  {
    label: "Institute of Education, Culture and Law",
    value: "Institute of Education, Culture and Law",
  },
  {
    label: "Institute of Energy of Tajikistan",
    value: "Institute of Energy of Tajikistan",
  },
  {
    label: "Institute of Engineering and Technology",
    value: "Institute of Engineering and Technology",
  },
  {
    label: "Institute of Information Security",
    value: "Institute of Information Security",
  },
  {
    label: "Institute of Infrastructure, Technology, Research and Management",
    value: "Institute of Infrastructure, Technology, Research and Management",
  },
  {
    label: "Institute of Intercultural Management and Communication",
    value: "Institute of Intercultural Management and Communication",
  },
  {
    label: "Institute of International Business Education",
    value: "Institute of International Business Education",
  },
  {
    label: "Institute of International Relations",
    value: "Institute of International Relations",
  },
  {
    label: "Institute of Legal Practice and Development",
    value: "Institute of Legal Practice and Development",
  },
  {
    label: "Institute of Management and Entrepreneurship",
    value: "Institute of Management and Entrepreneurship",
  },
  {
    label: "Institute of Management Sciences",
    value: "Institute of Management Sciences",
  },
  {
    label: "Institute of Management Technology Dubai",
    value: "Institute of Management Technology Dubai",
  },
  {
    label: "Institute of Modern Information Technologies in Education",
    value: "Institute of Modern Information Technologies in Education",
  },
  {
    label: "Institute of Modern Knowledge",
    value: "Institute of Modern Knowledge",
  },
  {
    label: "Institute of Natural Science",
    value: "Institute of Natural Science",
  },
  {
    label: "Institute of Parliamentarism and Private Enterprise",
    value: "Institute of Parliamentarism and Private Enterprise",
  },
  {
    label: "Institute of Public Administration",
    value: "Institute of Public Administration",
  },
  {
    label: "Institute of Public Administration, Saudi Arabia",
    value: "Institute of Public Administration, Saudi Arabia",
  },
  {
    label: "Institute of Railways",
    value: "Institute of Railways",
  },
  {
    label: "Institute of Science and Technology Austria",
    value: "Institute of Science and Technology Austria",
  },
  {
    label: "Institute of Social Science",
    value: "Institute of Social Science",
  },
  {
    label: "Institute of Southern Punjab",
    value: "Institute of Southern Punjab",
  },
  {
    label: "Institute of Space Technology",
    value: "Institute of Space Technology",
  },
  {
    label: "Institute of Technologists",
    value: "Institute of Technologists",
  },
  {
    label: "Institute of Technology of Cambodia",
    value: "Institute of Technology of Cambodia",
  },
  {
    label: "Institute of Technology Sligo",
    value: "Institute of Technology Sligo",
  },
  {
    label: "Institute of Tourism Studies Malta",
    value: "Institute of Tourism Studies Malta",
  },
  {
    label: "Institute Superior Cristal",
    value: "Institute Superior Cristal",
  },
  {
    label: "Instituto Caro y Cuervo",
    value: "Instituto Caro y Cuervo",
  },
  {
    label: "Instituto de Altos Estudios Nacionales",
    value: "Instituto de Altos Estudios Nacionales",
  },
  {
    label: "Instituto de Ciencia Animal",
    value: "Instituto de Ciencia Animal",
  },
  {
    label:
      "Instituto de Educación Superior en Formación Diplomática y Consular",
    value:
      "Instituto de Educación Superior en Formación Diplomática y Consular",
  },
  {
    label: "Instituto de Especialización para Ejecutivos",
    value: "Instituto de Especialización para Ejecutivos",
  },
  {
    label: "Instituto de Estudios Superiores de Tamaulipas A.C.",
    value: "Instituto de Estudios Superiores de Tamaulipas A.C.",
  },
  {
    label: "Instituto de Estudios Superiores del Bajío",
    value: "Instituto de Estudios Superiores del Bajío",
  },
  {
    label: "Instituto de Estudios Universitarios A.C.",
    value: "Instituto de Estudios Universitarios A.C.",
  },
  {
    label: "Instituto de Estudos Superiores de Fafe",
    value: "Instituto de Estudos Superiores de Fafe",
  },
  {
    label: "Instituto de Formação Turística de Macau",
    value: "Instituto de Formação Turística de Macau",
  },
  {
    label: "Instituto Departamental de Bellas Artes",
    value: "Instituto Departamental de Bellas Artes",
  },
  {
    label: "Instituto Dominicano de Tecnología",
    value: "Instituto Dominicano de Tecnología",
  },
  {
    label:
      "Instituto Especializado de Educación Superior de Profesionales de la Salud de El Salvador",
    value:
      "Instituto Especializado de Educación Superior de Profesionales de la Salud de El Salvador",
  },
  {
    label: "Instituto Especializado de Educación Superior El Espíritu Santo",
    value: "Instituto Especializado de Educación Superior El Espíritu Santo",
  },
  {
    label:
      "Instituto Especializado de Estudios Superiores de Derecho Empresarial",
    value:
      "Instituto Especializado de Estudios Superiores de Derecho Empresarial",
  },
  {
    label:
      "Instituto Especializado de Investigación y Formación en Ciencias Jurídicas",
    value:
      "Instituto Especializado de Investigación y Formación en Ciencias Jurídicas",
  },
  {
    label: "Instituto Global de Altos Estudios en Ciencias Sociales",
    value: "Instituto Global de Altos Estudios en Ciencias Sociales",
  },
  {
    label: "Instituto Metodista Universitario Crandon",
    value: "Instituto Metodista Universitario Crandon",
  },
  {
    label: "Instituto Nacional de Ciencias Agrícolas",
    value: "Instituto Nacional de Ciencias Agrícolas",
  },
  {
    label: "Instituto Nacional de Estudios Fiscales",
    value: "Instituto Nacional de Estudios Fiscales",
  },
  {
    label: "Instituto para el Desarrollo Empresarial de la Argentina",
    value: "Instituto para el Desarrollo Empresarial de la Argentina",
  },
  {
    label: "Instituto Pedagogico Arubano",
    value: "Instituto Pedagogico Arubano",
  },
  {
    label: "Instituto Piaget",
    value: "Instituto Piaget",
  },
  {
    label: "Instituto Politécnico da Guarda",
    value: "Instituto Politécnico da Guarda",
  },
  {
    label: "Instituto Politécnico da Lusofonia",
    value: "Instituto Politécnico da Lusofonia",
  },
  {
    label: "Instituto Politécnico da Maia",
    value: "Instituto Politécnico da Maia",
  },
  {
    label: "Instituto Politécnico de Beja",
    value: "Instituto Politécnico de Beja",
  },
  {
    label: "Instituto Politécnico de Bragança",
    value: "Instituto Politécnico de Bragança",
  },
  {
    label: "Instituto Politécnico de Castelo Branco",
    value: "Instituto Politécnico de Castelo Branco",
  },
  {
    label: "Instituto Politécnico de Coimbra",
    value: "Instituto Politécnico de Coimbra",
  },
  {
    label: "Instituto Politécnico de Gestão e Tecnologia",
    value: "Instituto Politécnico de Gestão e Tecnologia",
  },
  {
    label: "Instituto Politécnico de Leiria",
    value: "Instituto Politécnico de Leiria",
  },
  {
    label: "Instituto Politécnico de Lisboa",
    value: "Instituto Politécnico de Lisboa",
  },
  {
    label: "Instituto Politécnico de Portalegre",
    value: "Instituto Politécnico de Portalegre",
  },
  {
    label: "Instituto Politécnico de Santarém",
    value: "Instituto Politécnico de Santarém",
  },
  {
    label: "Instituto Politécnico de Setúbal",
    value: "Instituto Politécnico de Setúbal",
  },
  {
    label: "Instituto Politécnico de Tomar",
    value: "Instituto Politécnico de Tomar",
  },
  {
    label: "Instituto Politécnico de Viana do Castelo",
    value: "Instituto Politécnico de Viana do Castelo",
  },
  {
    label: "Instituto Politécnico de Viseu",
    value: "Instituto Politécnico de Viseu",
  },
  {
    label: "Instituto Politécnico do Cávado e do Ave",
    value: "Instituto Politécnico do Cávado e do Ave",
  },
  {
    label: "Instituto Politécnico do Porto",
    value: "Instituto Politécnico do Porto",
  },
  {
    label: "Instituto Politécnico Loyola",
    value: "Instituto Politécnico Loyola",
  },
  {
    label: "Instituto Politécnico Nacional",
    value: "Instituto Politécnico Nacional",
  },
  {
    label: "Instituto Português de Administração de Marketing",
    value: "Instituto Português de Administração de Marketing",
  },
  {
    label: "Instituto Superior D. Dinis",
    value: "Instituto Superior D. Dinis",
  },
  {
    label: "Instituto Superior de Administração e Gestão",
    value: "Instituto Superior de Administração e Gestão",
  },
  {
    label: "Instituto Superior de Administração e Línguas",
    value: "Instituto Superior de Administração e Línguas",
  },
  {
    label: "Instituto Superior de Ciências da Informação e da Administração",
    value: "Instituto Superior de Ciências da Informação e da Administração",
  },
  {
    label: "Instituto Superior de Ciências Económicas e Empresariais",
    value: "Instituto Superior de Ciências Económicas e Empresariais",
  },
  {
    label: "Instituto Superior de Ciências Educativas",
    value: "Instituto Superior de Ciências Educativas",
  },
  {
    label: "Instituto Superior de Ciências Educativas do Douro",
    value: "Instituto Superior de Ciências Educativas do Douro",
  },
  {
    label: "Instituto Superior de Ciências Empresariais e do Turismo",
    value: "Instituto Superior de Ciências Empresariais e do Turismo",
  },
  {
    label: "Instituto Superior de Ciências Jurídicas e Sociais",
    value: "Instituto Superior de Ciências Jurídicas e Sociais",
  },
  {
    label: "Instituto Superior de Diseño Industrial",
    value: "Instituto Superior de Diseño Industrial",
  },
  {
    label: "Instituto Superior de Economia y Administración de Empresas",
    value: "Instituto Superior de Economia y Administración de Empresas",
  },
  {
    label: "Instituto Superior de Educação e Ciências",
    value: "Instituto Superior de Educação e Ciências",
  },
  {
    label: "Instituto Superior de Entre Douro e Vouga",
    value: "Instituto Superior de Entre Douro e Vouga",
  },
  {
    label: "Instituto Superior de Formación Docente Salomé Ureña",
    value: "Instituto Superior de Formación Docente Salomé Ureña",
  },
  {
    label: "Instituto Superior de Gestão",
    value: "Instituto Superior de Gestão",
  },
  {
    label: "Instituto Superior de Novas Profissões",
    value: "Instituto Superior de Novas Profissões",
  },
  {
    label: "Instituto Superior de Relaciones Internacionales Raúl Roa García",
    value: "Instituto Superior de Relaciones Internacionales Raúl Roa García",
  },
  {
    label: "Instituto Superior de Saúde do Alto Ave",
    value: "Instituto Superior de Saúde do Alto Ave",
  },
  {
    label: "Instituto Superior de Serviço Social do Porto",
    value: "Instituto Superior de Serviço Social do Porto",
  },
  {
    label: "Instituto Superior de Tecnologias Avançadas de Lisboa",
    value: "Instituto Superior de Tecnologias Avançadas de Lisboa",
  },
  {
    label: "Instituto Superior de Tecnologías y Ciencias Aplicadas",
    value: "Instituto Superior de Tecnologías y Ciencias Aplicadas",
  },
  {
    label: "Instituto Superior Manuel Teixeira Gomes",
    value: "Instituto Superior Manuel Teixeira Gomes",
  },
  {
    label: "Instituto Superior Miguel Torga",
    value: "Instituto Superior Miguel Torga",
  },
  {
    label: "Instituto Superior Pedro Francisco Bonó",
    value: "Instituto Superior Pedro Francisco Bonó",
  },
  {
    label: "Instituto Superior Politécnico Gaya",
    value: "Instituto Superior Politécnico Gaya",
  },
  {
    label: "Instituto Técnico Superior Comunitario",
    value: "Instituto Técnico Superior Comunitario",
  },
  {
    label: "Instituto Técnico Superior Mercy Jácquez",
    value: "Instituto Técnico Superior Mercy Jácquez",
  },
  {
    label: "Instituto Tecnológico Autonómo de México",
    value: "Instituto Tecnológico Autonómo de México",
  },
  {
    label: "Instituto Tecnológico de Acapulco",
    value: "Instituto Tecnológico de Acapulco",
  },
  {
    label: "Instituto Tecnológico de Agua Prieta",
    value: "Instituto Tecnológico de Agua Prieta",
  },
  {
    label: "Instituto Tecnológico de Aguascalientes",
    value: "Instituto Tecnológico de Aguascalientes",
  },
  {
    label: "Instituto Tecnológico de Altamira",
    value: "Instituto Tecnológico de Altamira",
  },
  {
    label: "Instituto Tecnológico de Álvaro Obregón",
    value: "Instituto Tecnológico de Álvaro Obregón",
  },
  {
    label: "Instituto Tecnológico de Apizaco",
    value: "Instituto Tecnológico de Apizaco",
  },
  {
    label: "Instituto Tecnológico de Atitalaquia",
    value: "Instituto Tecnológico de Atitalaquia",
  },
  {
    label: "Instituto Tecnológico de Bahía de Banderas",
    value: "Instituto Tecnológico de Bahía de Banderas",
  },
  {
    label: "Instituto Tecnológico de Boca del Río",
    value: "Instituto Tecnológico de Boca del Río",
  },
  {
    label: "Instituto Tecnológico de Buenos Aires",
    value: "Instituto Tecnológico de Buenos Aires",
  },
  {
    label: "Instituto Tecnológico de Campeche",
    value: "Instituto Tecnológico de Campeche",
  },
  {
    label: "Instituto Tecnológico de Cancún",
    value: "Instituto Tecnológico de Cancún",
  },
  {
    label: "Instituto Tecnológico de Celaya",
    value: "Instituto Tecnológico de Celaya",
  },
  {
    label: "Instituto Tecnológico de Cerro Azul",
    value: "Instituto Tecnológico de Cerro Azul",
  },
  {
    label: "Instituto Tecnológico de Chetumal",
    value: "Instituto Tecnológico de Chetumal",
  },
  {
    label: "Instituto Tecnológico de Chihuahua",
    value: "Instituto Tecnológico de Chihuahua",
  },
  {
    label: "Instituto Tecnológico de Chihuahua II",
    value: "Instituto Tecnológico de Chihuahua II",
  },
  {
    label: "Instituto Tecnológico de Chilpancingo",
    value: "Instituto Tecnológico de Chilpancingo",
  },
  {
    label: "Instituto Tecnológico de Chiná",
    value: "Instituto Tecnológico de Chiná",
  },
  {
    label: "Instituto Tecnológico de Ciudad Altamirano",
    value: "Instituto Tecnológico de Ciudad Altamirano",
  },
  {
    label: "Instituto Tecnológico de Ciudad Cuauhtémoc",
    value: "Instituto Tecnológico de Ciudad Cuauhtémoc",
  },
  {
    label: "Instituto Tecnológico de Ciudad Guzmán",
    value: "Instituto Tecnológico de Ciudad Guzmán",
  },
  {
    label: "Instituto Tecnológico de Ciudad Jiménez",
    value: "Instituto Tecnológico de Ciudad Jiménez",
  },
  {
    label: "Instituto Tecnológico de Ciudad Juárez",
    value: "Instituto Tecnológico de Ciudad Juárez",
  },
  {
    label: "Instituto Tecnológico de Ciudad Madero",
    value: "Instituto Tecnológico de Ciudad Madero",
  },
  {
    label: "Instituto Tecnológico de Ciudad Valles",
    value: "Instituto Tecnológico de Ciudad Valles",
  },
  {
    label: "Instituto Tecnológico de Ciudad Victoria",
    value: "Instituto Tecnológico de Ciudad Victoria",
  },
  {
    label: "Instituto Tecnológico de Colima",
    value: "Instituto Tecnológico de Colima",
  },
  {
    label: "Instituto Tecnológico de Comitancillo",
    value: "Instituto Tecnológico de Comitancillo",
  },
  {
    label: "Instituto Tecnológico de Conkal",
    value: "Instituto Tecnológico de Conkal",
  },
  {
    label: "Instituto Tecnológico de Costa Rica",
    value: "Instituto Tecnológico de Costa Rica",
  },
  {
    label: "Instituto Tecnológico de Cuautla",
    value: "Instituto Tecnológico de Cuautla",
  },
  {
    label: "Instituto Tecnológico de Culiacán",
    value: "Instituto Tecnológico de Culiacán",
  },
  {
    label: "Instituto Tecnológico de Delicias",
    value: "Instituto Tecnológico de Delicias",
  },
  {
    label: "Instituto Tecnológico de Durango",
    value: "Instituto Tecnológico de Durango",
  },
  {
    label: "Instituto Tecnológico de El Llano Aguascalientes",
    value: "Instituto Tecnológico de El Llano Aguascalientes",
  },
  {
    label: "Instituto Tecnológico de El Salto",
    value: "Instituto Tecnológico de El Salto",
  },
  {
    label: "Instituto Tecnológico de Ensenada",
    value: "Instituto Tecnológico de Ensenada",
  },
  {
    label: "Instituto Tecnológico de Frontera Comalapa",
    value: "Instituto Tecnológico de Frontera Comalapa",
  },
  {
    label: "Instituto Tecnológico de Guaymas",
    value: "Instituto Tecnológico de Guaymas",
  },
  {
    label: "Instituto Tecnológico de Gustavo A. Madero",
    value: "Instituto Tecnológico de Gustavo A. Madero",
  },
  {
    label: "Instituto Tecnológico de Gustavo A. Madero II",
    value: "Instituto Tecnológico de Gustavo A. Madero II",
  },
  {
    label: "Instituto Tecnológico de Hermosillo",
    value: "Instituto Tecnológico de Hermosillo",
  },
  {
    label: "Instituto Tecnológico de Huatabampo",
    value: "Instituto Tecnológico de Huatabampo",
  },
  {
    label: "Instituto Tecnológico de Huejutla",
    value: "Instituto Tecnológico de Huejutla",
  },
  {
    label: "Instituto Tecnológico de Huimanguillo",
    value: "Instituto Tecnológico de Huimanguillo",
  },
  {
    label: "Instituto Tecnológico de Iguala",
    value: "Instituto Tecnológico de Iguala",
  },
  {
    label: "Instituto Tecnológico de Iztapalapa",
    value: "Instituto Tecnológico de Iztapalapa",
  },
  {
    label: "Instituto Tecnológico de Iztapalapa II",
    value: "Instituto Tecnológico de Iztapalapa II",
  },
  {
    label: "Instituto Tecnológico de Iztapalapa III",
    value: "Instituto Tecnológico de Iztapalapa III",
  },
  {
    label: "Instituto Tecnológico de Jiquilpan",
    value: "Instituto Tecnológico de Jiquilpan",
  },
  {
    label: "Instituto Tecnológico de la Chontalpa",
    value: "Instituto Tecnológico de la Chontalpa",
  },
  {
    label: "Instituto Tecnológico de la Costa Grande",
    value: "Instituto Tecnológico de la Costa Grande",
  },
  {
    label: "Instituto Tecnológico de La Cuenca del Papaloapan",
    value: "Instituto Tecnológico de La Cuenca del Papaloapan",
  },
  {
    label: "Instituto Tecnológico de La Laguna",
    value: "Instituto Tecnológico de La Laguna",
  },
  {
    label: "Instituto Tecnológico de La Paz",
    value: "Instituto Tecnológico de La Paz",
  },
  {
    label: "Instituto Tecnológico de La Piedad",
    value: "Instituto Tecnológico de La Piedad",
  },
  {
    label: "Instituto Tecnológico de La Zona Maya",
    value: "Instituto Tecnológico de La Zona Maya",
  },
  {
    label: "Instituto Tecnológico de La Zona Olmeca",
    value: "Instituto Tecnológico de La Zona Olmeca",
  },
  {
    label: "Instituto Tecnológico de Las Américas",
    value: "Instituto Tecnológico de Las Américas",
  },
  {
    label: "Instituto Tecnológico de Lázaro Cárdenas",
    value: "Instituto Tecnológico de Lázaro Cárdenas",
  },
  {
    label: "Instituto Tecnológico de León",
    value: "Instituto Tecnológico de León",
  },
  {
    label: "Instituto Tecnológico de Lerma",
    value: "Instituto Tecnológico de Lerma",
  },
  {
    label: "Instituto Tecnológico de Linares",
    value: "Instituto Tecnológico de Linares",
  },
  {
    label: "Instituto Tecnológico de Los Mochis",
    value: "Instituto Tecnológico de Los Mochis",
  },
  {
    label: "Instituto Tecnológico de Matamoros",
    value: "Instituto Tecnológico de Matamoros",
  },
  {
    label: "Instituto Tecnológico de Matehuala",
    value: "Instituto Tecnológico de Matehuala",
  },
  {
    label: "Instituto Tecnológico de Mazatlán",
    value: "Instituto Tecnológico de Mazatlán",
  },
  {
    label: "Instituto Tecnológico de Mérida",
    value: "Instituto Tecnológico de Mérida",
  },
  {
    label: "Instituto Tecnológico de Mexicali",
    value: "Instituto Tecnológico de Mexicali",
  },
  {
    label: "Instituto Tecnológico de Milpa Alta",
    value: "Instituto Tecnológico de Milpa Alta",
  },
  {
    label: "Instituto Tecnológico de Milpa Alta II",
    value: "Instituto Tecnológico de Milpa Alta II",
  },
  {
    label: "Instituto Tecnológico de Minatitlán",
    value: "Instituto Tecnológico de Minatitlán",
  },
  {
    label: "Instituto Tecnológico de Morelia",
    value: "Instituto Tecnológico de Morelia",
  },
  {
    label: "Instituto Tecnológico de Nogales",
    value: "Instituto Tecnológico de Nogales",
  },
  {
    label: "Instituto Tecnológico de Nuevo Laredo",
    value: "Instituto Tecnológico de Nuevo Laredo",
  },
  {
    label: "Instituto Tecnológico de Nuevo León",
    value: "Instituto Tecnológico de Nuevo León",
  },
  {
    label: "Instituto Tecnológico de Ocotlán",
    value: "Instituto Tecnológico de Ocotlán",
  },
  {
    label: "Instituto Tecnológico de Orizaba",
    value: "Instituto Tecnológico de Orizaba",
  },
  {
    label: "Instituto Tecnológico de Pabellón de Arteaga",
    value: "Instituto Tecnológico de Pabellón de Arteaga",
  },
  {
    label: "Instituto Tecnológico de Pachuca",
    value: "Instituto Tecnológico de Pachuca",
  },
  {
    label: "Instituto Tecnológico de Parral",
    value: "Instituto Tecnológico de Parral",
  },
  {
    label: "Instituto Tecnológico de Piedras Negras",
    value: "Instituto Tecnológico de Piedras Negras",
  },
  {
    label: "Instituto Tecnológico de Pinotepa",
    value: "Instituto Tecnológico de Pinotepa",
  },
  {
    label: "Instituto Tecnológico de Pochutla",
    value: "Instituto Tecnológico de Pochutla",
  },
  {
    label: "Instituto Tecnológico de Puebla",
    value: "Instituto Tecnológico de Puebla",
  },
  {
    label: "Instituto Tecnológico de Querétaro",
    value: "Instituto Tecnológico de Querétaro",
  },
  {
    label: "Instituto Tecnológico de Reynosa",
    value: "Instituto Tecnológico de Reynosa",
  },
  {
    label: "Instituto Tecnológico de Roque",
    value: "Instituto Tecnológico de Roque",
  },
  {
    label: "Instituto Tecnológico de Salina Cruz",
    value: "Instituto Tecnológico de Salina Cruz",
  },
  {
    label: "Instituto Tecnológico de Saltillo",
    value: "Instituto Tecnológico de Saltillo",
  },
  {
    label: "Instituto Tecnológico de San Juan del Río",
    value: "Instituto Tecnológico de San Juan del Río",
  },
  {
    label: "Instituto Tecnológico de San Luís Potosí",
    value: "Instituto Tecnológico de San Luís Potosí",
  },
  {
    label: "Instituto Tecnológico de San Marcos",
    value: "Instituto Tecnológico de San Marcos",
  },
  {
    label: "Instituto Tecnológico de Santo Domingo",
    value: "Instituto Tecnológico de Santo Domingo",
  },
  {
    label: "Instituto Tecnológico de Sinaloa de Leyva",
    value: "Instituto Tecnológico de Sinaloa de Leyva",
  },
  {
    label: "Instituto Tecnológico de Sonora",
    value: "Instituto Tecnológico de Sonora",
  },
  {
    label: "Instituto Tecnológico de Tapachula",
    value: "Instituto Tecnológico de Tapachula",
  },
  {
    label: "Instituto Tecnológico de Tecomatlán",
    value: "Instituto Tecnológico de Tecomatlán",
  },
  {
    label: "Instituto Tecnológico de Tehuacán",
    value: "Instituto Tecnológico de Tehuacán",
  },
  {
    label: "Instituto Tecnológico de Tepic",
    value: "Instituto Tecnológico de Tepic",
  },
  {
    label: "Instituto Tecnológico de Tijuana",
    value: "Instituto Tecnológico de Tijuana",
  },
  {
    label: "Instituto Tecnológico de Tizimín",
    value: "Instituto Tecnológico de Tizimín",
  },
  {
    label: "Instituto Tecnológico de Tláhuac",
    value: "Instituto Tecnológico de Tláhuac",
  },
  {
    label: "Instituto Tecnológico de Tláhuac II",
    value: "Instituto Tecnológico de Tláhuac II",
  },
  {
    label: "Instituto Tecnológico de Tláhuac III",
    value: "Instituto Tecnológico de Tláhuac III",
  },
  {
    label: "Instituto Tecnológico de Tlajomulco",
    value: "Instituto Tecnológico de Tlajomulco",
  },
  {
    label: "Instituto Tecnológico de Tlalnepantla",
    value: "Instituto Tecnológico de Tlalnepantla",
  },
  {
    label: "Instituto Tecnológico de Tlalpan",
    value: "Instituto Tecnológico de Tlalpan",
  },
  {
    label: "Instituto Tecnológico de Tlaxiaco",
    value: "Instituto Tecnológico de Tlaxiaco",
  },
  {
    label: "Instituto Tecnológico de Toluca",
    value: "Instituto Tecnológico de Toluca",
  },
  {
    label: "Instituto Tecnológico de Torreón",
    value: "Instituto Tecnológico de Torreón",
  },
  {
    label: "Instituto Tecnológico de Tuxtepec",
    value: "Instituto Tecnológico de Tuxtepec",
  },
  {
    label: "Instituto Tecnológico de Tuxtla Gutiérrez",
    value: "Instituto Tecnológico de Tuxtla Gutiérrez",
  },
  {
    label: "Instituto Tecnológico de Úrsulo Galván",
    value: "Instituto Tecnológico de Úrsulo Galván",
  },
  {
    label: "Instituto Tecnológico de Veracruz",
    value: "Instituto Tecnológico de Veracruz",
  },
  {
    label: "Instituto Tecnológico de Villahermosa",
    value: "Instituto Tecnológico de Villahermosa",
  },
  {
    label: "Instituto Tecnológico de Zacatecas",
    value: "Instituto Tecnológico de Zacatecas",
  },
  {
    label: "Instituto Tecnológico de Zacatepec",
    value: "Instituto Tecnológico de Zacatepec",
  },
  {
    label: "Instituto Tecnológico del Istmo",
    value: "Instituto Tecnológico del Istmo",
  },
  {
    label: "Instituto Tecnológico del Norte de Nayarit",
    value: "Instituto Tecnológico del Norte de Nayarit",
  },
  {
    label: "Instituto Tecnológico del Sur de Nayarit",
    value: "Instituto Tecnológico del Sur de Nayarit",
  },
  {
    label: "Instituto Tecnológico del Valle de Etla",
    value: "Instituto Tecnológico del Valle de Etla",
  },
  {
    label: "Instituto Tecnológico del Valle de Morelia",
    value: "Instituto Tecnológico del Valle de Morelia",
  },
  {
    label: "Instituto Tecnológico del Valle de Oaxaca",
    value: "Instituto Tecnológico del Valle de Oaxaca",
  },
  {
    label: "Instituto Tecnológico del Valle del Guadiana",
    value: "Instituto Tecnológico del Valle del Guadiana",
  },
  {
    label: "Instituto Tecnológico del Valle del Yaqui",
    value: "Instituto Tecnológico del Valle del Yaqui",
  },
  {
    label: "Instituto Tecnológico José Mario Molina Pasquel y Henríquez",
    value: "Instituto Tecnológico José Mario Molina Pasquel y Henríquez",
  },
  {
    label: "Instituto Tecnológico Latinoamericano",
    value: "Instituto Tecnológico Latinoamericano",
  },
  {
    label: "Instituto Tecnológico Metropolitano",
    value: "Instituto Tecnológico Metropolitano",
  },
  {
    label: "Instituto Tecnológico Pascual Bravo",
    value: "Instituto Tecnológico Pascual Bravo",
  },
  {
    label: "Instituto Tecnológico y de Estudios Superiores de Occidente A.C.",
    value: "Instituto Tecnológico y de Estudios Superiores de Occidente A.C.",
  },
  {
    label: "Instituto Universitario Aeronáutico",
    value: "Instituto Universitario Aeronáutico",
  },
  {
    label: "Instituto Universitario Asociación Cristiana de Jóvenes",
    value: "Instituto Universitario Asociación Cristiana de Jóvenes",
  },
  {
    label: "Instituto Universitario Bios",
    value: "Instituto Universitario Bios",
  },
  {
    label: "Instituto Universitario CEMIC",
    value: "Instituto Universitario CEMIC",
  },
  {
    label:
      "Instituto Universitario Centro de Docencia, Investigación e Información en Aprendizaje",
    value:
      "Instituto Universitario Centro de Docencia, Investigación e Información en Aprendizaje",
  },
  {
    label:
      "Instituto Universitario Centro de Estudio y Diagnóstico de las Disgnacias del Uruguay",
    value:
      "Instituto Universitario Centro de Estudio y Diagnóstico de las Disgnacias del Uruguay",
  },
  {
    label: "Instituto Universitario Centro Latinoamericano de Economía Humana",
    value: "Instituto Universitario Centro Latinoamericano de Economía Humana",
  },
  {
    label: "Instituto Universitario de Ciencias Biomédicas de Córdoba",
    value: "Instituto Universitario de Ciencias Biomédicas de Córdoba",
  },
  {
    label: "Instituto Universitário de Ciências da Saúde",
    value: "Instituto Universitário de Ciências da Saúde",
  },
  {
    label: "Instituto Universitario de Ciencias de la Salud",
    value: "Instituto Universitario de Ciencias de la Salud",
  },
  {
    label: "Instituto Universitario de La Paz",
    value: "Instituto Universitario de La Paz",
  },
  {
    label: "Instituto Universitário de Lisboa",
    value: "Instituto Universitário de Lisboa",
  },
  {
    label: "Instituto Universitario de Postgrado en Psicoanálisis",
    value: "Instituto Universitario de Postgrado en Psicoanálisis",
  },
  {
    label: "Instituto Universitario de Salud Mental",
    value: "Instituto Universitario de Salud Mental",
  },
  {
    label: "Instituto Universitario de Seguridad Marítima",
    value: "Instituto Universitario de Seguridad Marítima",
  },
  {
    label: "Instituto Universitario del Hospital Italiano",
    value: "Instituto Universitario del Hospital Italiano",
  },
  {
    label: "Instituto Universitario Escuela Argentina de Negocios",
    value: "Instituto Universitario Escuela Argentina de Negocios",
  },
  {
    label: "Instituto Universitario ESEADE",
    value: "Instituto Universitario ESEADE",
  },
  {
    label: "Instituto Universitario Francisco de Asís",
    value: "Instituto Universitario Francisco de Asís",
  },
  {
    label: "Instituto Universitario Italiano de Rosario",
    value: "Instituto Universitario Italiano de Rosario",
  },
  {
    label: "Instituto Universitario Patagónico de las Artes",
    value: "Instituto Universitario Patagónico de las Artes",
  },
  {
    label: "Instituto Universitario River Plate",
    value: "Instituto Universitario River Plate",
  },
  {
    label: "Instituts Saint-Luc Bruxelles",
    value: "Instituts Saint-Luc Bruxelles",
  },
  {
    label: "Instituts Supérieurs des Etudes Technologiques",
    value: "Instituts Supérieurs des Etudes Technologiques",
  },
  {
    label: "Institutul de Administrare a Afacerilor din Bucuresti",
    value: "Institutul de Administrare a Afacerilor din Bucuresti",
  },
  {
    label: "Instituut voor Tropische Geneeskunde",
    value: "Instituut voor Tropische Geneeskunde",
  },
  {
    label: "Integral University",
    value: "Integral University",
  },
  {
    label: "Intercollege",
    value: "Intercollege",
  },
  {
    label: "Internacionalna poslovno-informaciona akademija",
    value: "Internacionalna poslovno-informaciona akademija",
  },
  {
    label: "Internacionalni univerzitet Travnik",
    value: "Internacionalni univerzitet Travnik",
  },
  {
    label: "Internacionalni Univerzitet u Novom Pazaru",
    value: "Internacionalni Univerzitet u Novom Pazaru",
  },
  {
    label: "Internacionalni univerzitet u Sarajevu",
    value: "Internacionalni univerzitet u Sarajevu",
  },
  {
    label: "Internacionalnog univerziteta u Goraždu",
    value: "Internacionalnog univerziteta u Goraždu",
  },
  {
    label: "InterNapa College",
    value: "InterNapa College",
  },
  {
    label: "International Academy of Management, Law, Finance and Business",
    value: "International Academy of Management, Law, Finance and Business",
  },
  {
    label: "International Balkan University",
    value: "International Balkan University",
  },
  {
    label: "International Banking Institute",
    value: "International Banking Institute",
  },
  {
    label: "International Black Sea University",
    value: "International Black Sea University",
  },
  {
    label: "International Budo University",
    value: "International Budo University",
  },
  {
    label: "International BURCH University",
    value: "International BURCH University",
  },
  {
    label: "International Business School",
    value: "International Business School",
  },
  {
    label: "International Business School, Botevgrad",
    value: "International Business School, Botevgrad",
  },
  {
    label: "International Business, Science and Technology University",
    value: "International Business, Science and Technology University",
  },
  {
    label: "International Christian University",
    value: "International Christian University",
  },
  {
    label: "International College for Postgraduate Buddhist Studies",
    value: "International College for Postgraduate Buddhist Studies",
  },
  {
    label: "International College of the Cayman Islands",
    value: "International College of the Cayman Islands",
  },
  {
    label: "International Hellenic University",
    value: "International Hellenic University",
  },
  {
    label: "International Higher School of Medicine",
    value: "International Higher School of Medicine",
  },
  {
    label: "International Humanitarian Technical University",
    value: "International Humanitarian Technical University",
  },
  {
    label: "International Humanitarian University",
    value: "International Humanitarian University",
  },
  {
    label: "International Humanities and Economics Institute",
    value: "International Humanities and Economics Institute",
  },
  {
    label: "International Institute for Higher Education in Morocco",
    value: "International Institute for Higher Education in Morocco",
  },
  {
    label: "International Institute for Population Sciences",
    value: "International Institute for Population Sciences",
  },
  {
    label: "International Institute of Information Technology Bangalore",
    value: "International Institute of Information Technology Bangalore",
  },
  {
    label: "International Institute of Information Technology, Bhubaneswar",
    value: "International Institute of Information Technology, Bhubaneswar",
  },
  {
    label: "International Institute of Information Technology, Hyderabad",
    value: "International Institute of Information Technology, Hyderabad",
  },
  {
    label: "International Institute of Information Technology, Naya Raipur",
    value: "International Institute of Information Technology, Naya Raipur",
  },
  {
    label: "International Islamic University, Chittagong",
    value: "International Islamic University, Chittagong",
  },
  {
    label: "International Islamic University, Islamabad",
    value: "International Islamic University, Islamabad",
  },
  {
    label: "International IT University",
    value: "International IT University",
  },
  {
    label: "International Leadership University, Burundi",
    value: "International Leadership University, Burundi",
  },
  {
    label: "International Leadership University, Kenya",
    value: "International Leadership University, Kenya",
  },
  {
    label: "International Maritime College Oman",
    value: "International Maritime College Oman",
  },
  {
    label: "International Medical and Technological University",
    value: "International Medical and Technological University",
  },
  {
    label: "International Medical University",
    value: "International Medical University",
  },
  {
    label: "International Oil and Gas University",
    value: "International Oil and Gas University",
  },
  {
    label: "International Pacific University",
    value: "International Pacific University",
  },
  {
    label: "International Psychoanalytic University",
    value: "International Psychoanalytic University",
  },
  {
    label: "International School of Business",
    value: "International School of Business",
  },
  {
    label: "International School of Management",
    value: "International School of Management",
  },
  {
    label: "International Science and Technology University",
    value: "International Science and Technology University",
  },
  {
    label: "International Slavic University G. R. Derzhavin",
    value: "International Slavic University G. R. Derzhavin",
  },
  {
    label: "International Standard University",
    value: "International Standard University",
  },
  {
    label: "International Technological University Mykolaiv Polytechnic",
    value: "International Technological University Mykolaiv Polytechnic",
  },
  {
    label: "International Transport and Humanitarian University",
    value: "International Transport and Humanitarian University",
  },
  {
    label: "International University",
    value: "International University",
  },
  {
    label: "International University for Graduate Studies",
    value: "International University for Graduate Studies",
  },
  {
    label: "International University MITSO",
    value: "International University MITSO",
  },
  {
    label: "International University of Africa",
    value: "International University of Africa",
  },
  {
    label: "International University of Business Agriculture and Technology",
    value: "International University of Business Agriculture and Technology",
  },
  {
    label: "International University of Central Asia",
    value: "International University of Central Asia",
  },
  {
    label: "International University of Chabahar",
    value: "International University of Chabahar",
  },
  {
    label: "International University of East Africa",
    value: "International University of East Africa",
  },
  {
    label: "International University of Economics and Business",
    value: "International University of Economics and Business",
  },
  {
    label: "International University of Equator",
    value: "International University of Equator",
  },
  {
    label: "International University of Erbil",
    value: "International University of Erbil",
  },
  {
    label: "International University of Fundamental Studies, St. Petersburg",
    value: "International University of Fundamental Studies, St. Petersburg",
  },
  {
    label: "International University of Health and Welfare",
    value: "International University of Health and Welfare",
  },
  {
    label: "International University of Humanities and Development",
    value: "International University of Humanities and Development",
  },
  {
    label: "International University of Innovative Technologies",
    value: "International University of Innovative Technologies",
  },
  {
    label: "International University of Japan",
    value: "International University of Japan",
  },
  {
    label: "International University of Korea",
    value: "International University of Korea",
  },
  {
    label: "International University of Kyrgyzstan",
    value: "International University of Kyrgyzstan",
  },
  {
    label: "International University of Malaya-Wales",
    value: "International University of Malaya-Wales",
  },
  {
    label: "International University of Monaco",
    value: "International University of Monaco",
  },
  {
    label: "International University of Science and Technology",
    value: "International University of Science and Technology",
  },
  {
    label: "International University of Technology Twintech",
    value: "International University of Technology Twintech",
  },
  {
    label:
      "International University of Tourism and Entrepreneurship of Tajikistan",
    value:
      "International University of Tourism and Entrepreneurship of Tajikistan",
  },
  {
    label: "International University of Ulaanbaatar",
    value: "International University of Ulaanbaatar",
  },
  {
    label: "International University, Bamenda",
    value: "International University, Bamenda",
  },
  {
    label: "Internationale Akademie für Philosophie",
    value: "Internationale Akademie für Philosophie",
  },
  {
    label: "Interregional Academy of Personnel Management",
    value: "Interregional Academy of Personnel Management",
  },
  {
    label: "INTI International University",
    value: "INTI International University",
  },
  {
    label: "Invertis University",
    value: "Invertis University",
  },
  {
    label: "Iona University",
    value: "Iona University",
  },
  {
    label: "Ionian University",
    value: "Ionian University",
  },
  {
    label: "Iowa State University",
    value: "Iowa State University",
  },
  {
    label: "IPAG Business School",
    value: "IPAG Business School",
  },
  {
    label: "Iqra National University",
    value: "Iqra National University",
  },
  {
    label: "Iqra University",
    value: "Iqra University",
  },
  {
    label: "Iqra'a University for Science and Technology",
    value: "Iqra'a University for Science and Technology",
  },
  {
    label: "Iran Informatic Institute",
    value: "Iran Informatic Institute",
  },
  {
    label: "Iran Polymer and Petrochemical Institute",
    value: "Iran Polymer and Petrochemical Institute",
  },
  {
    label: "Iran University of Industries and Mines",
    value: "Iran University of Industries and Mines",
  },
  {
    label: "Iran University of Science and Technology",
    value: "Iran University of Science and Technology",
  },
  {
    label: "Iraq University College",
    value: "Iraq University College",
  },
  {
    label: "Irbid National University",
    value: "Irbid National University",
  },
  {
    label: "Irell and Manella Graduate School of Biological Sciences",
    value: "Irell and Manella Graduate School of Biological Sciences",
  },
  {
    label: "Irkutsk National Research Technical University",
    value: "Irkutsk National Research Technical University",
  },
  {
    label: "Irkutsk State Medical University",
    value: "Irkutsk State Medical University",
  },
  {
    label: "Irkutsk State University",
    value: "Irkutsk State University",
  },
  {
    label: "Iryo Sosei University",
    value: "Iryo Sosei University",
  },
  {
    label: "ISA, Universidad de las Artes",
    value: "ISA, Universidad de las Artes",
  },
  {
    label: "Isabela State University",
    value: "Isabela State University",
  },
  {
    label: "ISAE Universidad",
    value: "ISAE Universidad",
  },
  {
    label: "ISBM University",
    value: "ISBM University",
  },
  {
    label: "ISC Paris Business School",
    value: "ISC Paris Business School",
  },
  {
    label: "Iselinge Hogeschool",
    value: "Iselinge Hogeschool",
  },
  {
    label: "Isfahan Institute of Higher Education",
    value: "Isfahan Institute of Higher Education",
  },
  {
    label: "Isfahan University of Medical Sciences",
    value: "Isfahan University of Medical Sciences",
  },
  {
    label: "Isfahan University of Technology",
    value: "Isfahan University of Technology",
  },
  {
    label: "Ishakha International University, Bangladesh",
    value: "Ishakha International University, Bangladesh",
  },
  {
    label: "Ishikawa Prefectural Nursing University",
    value: "Ishikawa Prefectural Nursing University",
  },
  {
    label: "Ishikawa Prefectural University",
    value: "Ishikawa Prefectural University",
  },
  {
    label: "Ishinomaki Senshu University",
    value: "Ishinomaki Senshu University",
  },
  {
    label: "I-Shou University",
    value: "I-Shou University",
  },
  {
    label: "Isik Üniversitesi",
    value: "Isik Üniversitesi",
  },
  {
    label: "Iskenderun Teknik Üniversitesi",
    value: "Iskenderun Teknik Üniversitesi",
  },
  {
    label: "Islamia College Peshawar",
    value: "Islamia College Peshawar",
  },
  {
    label: "Islamic Arabic University",
    value: "Islamic Arabic University",
  },
  {
    label: "Islamic Azad University Afghanistan",
    value: "Islamic Azad University Afghanistan",
  },
  {
    label: "Islamic Azad University Central Tehran Branch",
    value: "Islamic Azad University Central Tehran Branch",
  },
  {
    label: "Islamic Azad University Isfahan, Khorasgan Branch",
    value: "Islamic Azad University Isfahan, Khorasgan Branch",
  },
  {
    label: "Islamic Azad university Kashmar Branch",
    value: "Islamic Azad university Kashmar Branch",
  },
  {
    label: "Islamic Azad University of Abadeh",
    value: "Islamic Azad University of Abadeh",
  },
  {
    label: "Islamic Azad University of Arak",
    value: "Islamic Azad University of Arak",
  },
  {
    label: "Islamic Azad University of Bojnourd",
    value: "Islamic Azad University of Bojnourd",
  },
  {
    label: "Islamic Azad University of Fasa",
    value: "Islamic Azad University of Fasa",
  },
  {
    label: "Islamic Azad University of Golpayegan",
    value: "Islamic Azad University of Golpayegan",
  },
  {
    label: "Islamic Azad University of Ilam",
    value: "Islamic Azad University of Ilam",
  },
  {
    label: "Islamic Azad University of Jahrom",
    value: "Islamic Azad University of Jahrom",
  },
  {
    label: "Islamic Azad University of Lahijan",
    value: "Islamic Azad University of Lahijan",
  },
  {
    label: "Islamic Azad University of Mashhad",
    value: "Islamic Azad University of Mashhad",
  },
  {
    label: "Islamic Azad University of Medical Sciences, Qeshm",
    value: "Islamic Azad University of Medical Sciences, Qeshm",
  },
  {
    label: "Islamic Azad University of Roudehen",
    value: "Islamic Azad University of Roudehen",
  },
  {
    label: "Islamic Azad University of Urmia",
    value: "Islamic Azad University of Urmia",
  },
  {
    label: "Islamic Azad University U.A.E. Branch",
    value: "Islamic Azad University U.A.E. Branch",
  },
  {
    label: "Islamic Azad University, Abadan",
    value: "Islamic Azad University, Abadan",
  },
  {
    label: "Islamic Azad University, Abarkouh",
    value: "Islamic Azad University, Abarkouh",
  },
  {
    label: "Islamic Azad University, Abhar",
    value: "Islamic Azad University, Abhar",
  },
  {
    label: "Islamic Azad University, Ahar",
    value: "Islamic Azad University, Ahar",
  },
  {
    label: "Islamic Azad University, Ahvaz",
    value: "Islamic Azad University, Ahvaz",
  },
  {
    label: "Islamic Azad University, Ajabshir",
    value: "Islamic Azad University, Ajabshir",
  },
  {
    label: "Islamic Azad University, Aligudarz",
    value: "Islamic Azad University, Aligudarz",
  },
  {
    label: "Islamic Azad University, Anar",
    value: "Islamic Azad University, Anar",
  },
  {
    label: "Islamic Azad University, Andimeshk",
    value: "Islamic Azad University, Andimeshk",
  },
  {
    label: "Islamic Azad University, Ardabil",
    value: "Islamic Azad University, Ardabil",
  },
  {
    label: "Islamic Azad University, Ardakan",
    value: "Islamic Azad University, Ardakan",
  },
  {
    label: "Islamic Azad University, Ardestan",
    value: "Islamic Azad University, Ardestan",
  },
  {
    label: "Islamic Azad University, Arsanjan",
    value: "Islamic Azad University, Arsanjan",
  },
  {
    label: "Islamic Azad University, Ashkezar",
    value: "Islamic Azad University, Ashkezar",
  },
  {
    label: "Islamic Azad University, Ashtian",
    value: "Islamic Azad University, Ashtian",
  },
  {
    label: "Islamic Azad University, Astara",
    value: "Islamic Azad University, Astara",
  },
  {
    label: "Islamic Azad University, Ayatollah Amoli",
    value: "Islamic Azad University, Ayatollah Amoli",
  },
  {
    label: "Islamic Azad University, Azadshahr",
    value: "Islamic Azad University, Azadshahr",
  },
  {
    label: "Islamic Azad University, Babol",
    value: "Islamic Azad University, Babol",
  },
  {
    label: "Islamic Azad University, Baft",
    value: "Islamic Azad University, Baft",
  },
  {
    label: "Islamic Azad University, Bandar Abbas",
    value: "Islamic Azad University, Bandar Abbas",
  },
  {
    label: "Islamic Azad University, Bandar Gaz",
    value: "Islamic Azad University, Bandar Gaz",
  },
  {
    label: "Islamic Azad University, Bandar-e Anzali",
    value: "Islamic Azad University, Bandar-e Anzali",
  },
  {
    label: "Islamic Azad University, Behbahan",
    value: "Islamic Azad University, Behbahan",
  },
  {
    label: "Islamic Azad University, Behshahr",
    value: "Islamic Azad University, Behshahr",
  },
  {
    label: "Islamic Azad University, Birjand",
    value: "Islamic Azad University, Birjand",
  },
  {
    label: "Islamic Azad University, Bonab",
    value: "Islamic Azad University, Bonab",
  },
  {
    label: "Islamic Azad University, Borujerd",
    value: "Islamic Azad University, Borujerd",
  },
  {
    label: "Islamic Azad University, Buin-Zahra",
    value: "Islamic Azad University, Buin-Zahra",
  },
  {
    label: "Islamic Azad University, Bushehr",
    value: "Islamic Azad University, Bushehr",
  },
  {
    label: "Islamic Azad University, Damavand",
    value: "Islamic Azad University, Damavand",
  },
  {
    label: "Islamic Azad University, Damghan",
    value: "Islamic Azad University, Damghan",
  },
  {
    label: "Islamic Azad University, Darab",
    value: "Islamic Azad University, Darab",
  },
  {
    label: "Islamic Azad University, Dehaghan",
    value: "Islamic Azad University, Dehaghan",
  },
  {
    label: "Islamic Azad University, Dehloran",
    value: "Islamic Azad University, Dehloran",
  },
  {
    label: "Islamic Azad University, Dezful",
    value: "Islamic Azad University, Dezful",
  },
  {
    label: "Islamic Azad University, East Tehran",
    value: "Islamic Azad University, East Tehran",
  },
  {
    label: "Islamic Azad University, Eghlid",
    value: "Islamic Azad University, Eghlid",
  },
  {
    label: "Islamic Azad University, Esfarayen",
    value: "Islamic Azad University, Esfarayen",
  },
  {
    label: "Islamic Azad University, Eslamshahr",
    value: "Islamic Azad University, Eslamshahr",
  },
  {
    label: "Islamic Azad University, Estahban",
    value: "Islamic Azad University, Estahban",
  },
  {
    label: "Islamic Azad University, Ferdows",
    value: "Islamic Azad University, Ferdows",
  },
  {
    label: "Islamic Azad University, Firoozkooh",
    value: "Islamic Azad University, Firoozkooh",
  },
  {
    label: "Islamic Azad University, Firuzabad",
    value: "Islamic Azad University, Firuzabad",
  },
  {
    label: "Islamic Azad University, Gachsaran",
    value: "Islamic Azad University, Gachsaran",
  },
  {
    label: "Islamic Azad University, Garmsar",
    value: "Islamic Azad University, Garmsar",
  },
  {
    label: "Islamic Azad University, Gonabad",
    value: "Islamic Azad University, Gonabad",
  },
  {
    label: "Islamic Azad University, Gorgan",
    value: "Islamic Azad University, Gorgan",
  },
  {
    label: "Islamic Azad University, Hamedan",
    value: "Islamic Azad University, Hamedan",
  },
  {
    label: "Islamic Azad University, Hashtrood",
    value: "Islamic Azad University, Hashtrood",
  },
  {
    label: "Islamic Azad University, Hidaj",
    value: "Islamic Azad University, Hidaj",
  },
  {
    label: "Islamic Azad University, Izeh",
    value: "Islamic Azad University, Izeh",
  },
  {
    label: "Islamic Azad University, Karaj Branch",
    value: "Islamic Azad University, Karaj Branch",
  },
  {
    label: "Islamic Azad University, Kashan",
    value: "Islamic Azad University, Kashan",
  },
  {
    label: "Islamic Azad University, Kazeroon",
    value: "Islamic Azad University, Kazeroon",
  },
  {
    label: "Islamic Azad University, Kerman",
    value: "Islamic Azad University, Kerman",
  },
  {
    label: "Islamic Azad University, Kermanshah",
    value: "Islamic Azad University, Kermanshah",
  },
  {
    label: "Islamic Azad University, Khomain",
    value: "Islamic Azad University, Khomain",
  },
  {
    label: "Islamic Azad University, Khomeinishahr",
    value: "Islamic Azad University, Khomeinishahr",
  },
  {
    label: "Islamic Azad University, Khorramsbad",
    value: "Islamic Azad University, Khorramsbad",
  },
  {
    label: "Islamic Azad University, Khoy",
    value: "Islamic Azad University, Khoy",
  },
  {
    label: "Islamic Azad University, Komijan",
    value: "Islamic Azad University, Komijan",
  },
  {
    label: "Islamic Azad University, Larestan",
    value: "Islamic Azad University, Larestan",
  },
  {
    label: "Islamic Azad University, Mahabad",
    value: "Islamic Azad University, Mahabad",
  },
  {
    label: "Islamic Azad University, Mahdishahr",
    value: "Islamic Azad University, Mahdishahr",
  },
  {
    label: "Islamic Azad University, Mahshahr",
    value: "Islamic Azad University, Mahshahr",
  },
  {
    label: "Islamic Azad University, Majlesi",
    value: "Islamic Azad University, Majlesi",
  },
  {
    label: "Islamic Azad University, Maragheh",
    value: "Islamic Azad University, Maragheh",
  },
  {
    label: "Islamic Azad University, Marvdasht",
    value: "Islamic Azad University, Marvdasht",
  },
  {
    label: "Islamic Azad University, Masjed Soleyman",
    value: "Islamic Azad University, Masjed Soleyman",
  },
  {
    label: "Islamic Azad University, Maybod",
    value: "Islamic Azad University, Maybod",
  },
  {
    label: "Islamic Azad University, Miyaneh",
    value: "Islamic Azad University, Miyaneh",
  },
  {
    label: "Islamic Azad University, Mobarakeh",
    value: "Islamic Azad University, Mobarakeh",
  },
  {
    label: "Islamic Azad University, Naein",
    value: "Islamic Azad University, Naein",
  },
  {
    label: "Islamic Azad University, Naragh",
    value: "Islamic Azad University, Naragh",
  },
  {
    label: "Islamic Azad University, Neyshabur",
    value: "Islamic Azad University, Neyshabur",
  },
  {
    label: "Islamic Azad University, North Tehran",
    value: "Islamic Azad University, North Tehran",
  },
  {
    label: "Islamic Azad University, Nur",
    value: "Islamic Azad University, Nur",
  },
  {
    label: "Islamic Azad University, Omidiyeh",
    value: "Islamic Azad University, Omidiyeh",
  },
  {
    label: "Islamic Azad University, Osku",
    value: "Islamic Azad University, Osku",
  },
  {
    label: "Islamic Azad University, Parand",
    value: "Islamic Azad University, Parand",
  },
  {
    label: "Islamic Azad University, Parsabad Moghan",
    value: "Islamic Azad University, Parsabad Moghan",
  },
  {
    label: "Islamic Azad University, Qaemshahr",
    value: "Islamic Azad University, Qaemshahr",
  },
  {
    label: "Islamic Azad University, Qazvin",
    value: "Islamic Azad University, Qazvin",
  },
  {
    label: "Islamic Azad University, Qom",
    value: "Islamic Azad University, Qom",
  },
  {
    label: "Islamic Azad University, Quchan",
    value: "Islamic Azad University, Quchan",
  },
  {
    label: "Islamic Azad University, Ramhormoz",
    value: "Islamic Azad University, Ramhormoz",
  },
  {
    label: "Islamic Azad University, Rasht",
    value: "Islamic Azad University, Rasht",
  },
  {
    label: "Islamic Azad University, Sabzevar",
    value: "Islamic Azad University, Sabzevar",
  },
  {
    label: "Islamic Azad University, Sanandaj Branch",
    value: "Islamic Azad University, Sanandaj Branch",
  },
  {
    label: "Islamic Azad University, Sari",
    value: "Islamic Azad University, Sari",
  },
  {
    label: "Islamic Azad University, Saveh",
    value: "Islamic Azad University, Saveh",
  },
  {
    label: "Islamic Azad University, Science and Research of Fars",
    value: "Islamic Azad University, Science and Research of Fars",
  },
  {
    label: "Islamic Azad University, Semnan",
    value: "Islamic Azad University, Semnan",
  },
  {
    label: "Islamic Azad University, Sepidan",
    value: "Islamic Azad University, Sepidan",
  },
  {
    label: "Islamic Azad University, Shabestar",
    value: "Islamic Azad University, Shabestar",
  },
  {
    label: "Islamic Azad University, Shahr Rey",
    value: "Islamic Azad University, Shahr Rey",
  },
  {
    label: "Islamic Azad University, Shahr-e-Qods",
    value: "Islamic Azad University, Shahr-e-Qods",
  },
  {
    label: "Islamic Azad University, Shahreza",
    value: "Islamic Azad University, Shahreza",
  },
  {
    label: "Islamic Azad University, Shahrood",
    value: "Islamic Azad University, Shahrood",
  },
  {
    label: "Islamic Azad University, Shiraz",
    value: "Islamic Azad University, Shiraz",
  },
  {
    label: "Islamic Azad University, Shirvan",
    value: "Islamic Azad University, Shirvan",
  },
  {
    label: "Islamic Azad University, Shoushtar",
    value: "Islamic Azad University, Shoushtar",
  },
  {
    label: "Islamic Azad University, Sirjan",
    value: "Islamic Azad University, Sirjan",
  },
  {
    label: "Islamic Azad University, South Tehran",
    value: "Islamic Azad University, South Tehran",
  },
  {
    label: "Islamic Azad University, Tabriz",
    value: "Islamic Azad University, Tabriz",
  },
  {
    label: "Islamic Azad University, Tafresh",
    value: "Islamic Azad University, Tafresh",
  },
  {
    label: "Islamic Azad University, Takestan",
    value: "Islamic Azad University, Takestan",
  },
  {
    label: "Islamic Azad University, Tehran Medical",
    value: "Islamic Azad University, Tehran Medical",
  },
  {
    label: "Islamic Azad University, Tonekabon",
    value: "Islamic Azad University, Tonekabon",
  },
  {
    label: "Islamic Azad University, Varamin",
    value: "Islamic Azad University, Varamin",
  },
  {
    label: "Islamic Azad University, West Tehran",
    value: "Islamic Azad University, West Tehran",
  },
  {
    label: "Islamic Azad University, Yasuj",
    value: "Islamic Azad University, Yasuj",
  },
  {
    label: "Islamic Azad University, Yazd",
    value: "Islamic Azad University, Yazd",
  },
  {
    label: "Islamic Azad University, Zahedan",
    value: "Islamic Azad University, Zahedan",
  },
  {
    label: "Islamic Azad University, Zanjan",
    value: "Islamic Azad University, Zanjan",
  },
  {
    label: "Islamic Azad University, Zarand",
    value: "Islamic Azad University, Zarand",
  },
  {
    label: "Islamic Azad University-Sarab Branch",
    value: "Islamic Azad University-Sarab Branch",
  },
  {
    label: "Islamic Institute of Tajikistan",
    value: "Islamic Institute of Tajikistan",
  },
  {
    label: "Islamic University",
    value: "Islamic University",
  },
  {
    label: "Islamic University College, Ghana",
    value: "Islamic University College, Ghana",
  },
  {
    label: "Islamic University in Uganda",
    value: "Islamic University in Uganda",
  },
  {
    label: "Islamic University of Applied Sciences Rotterdam",
    value: "Islamic University of Applied Sciences Rotterdam",
  },
  {
    label: "Islamic University of Gaza",
    value: "Islamic University of Gaza",
  },
  {
    label: "Islamic University of Kenya",
    value: "Islamic University of Kenya",
  },
  {
    label: "Islamic University of Kyrgyzstan",
    value: "Islamic University of Kyrgyzstan",
  },
  {
    label: "Islamic University of Lebanon",
    value: "Islamic University of Lebanon",
  },
  {
    label: "Islamic University of Madinah",
    value: "Islamic University of Madinah",
  },
  {
    label: "Islamic University of Mohamed Bin Ali Al Sanussi",
    value: "Islamic University of Mohamed Bin Ali Al Sanussi",
  },
  {
    label: "Islamic University of Najaf",
    value: "Islamic University of Najaf",
  },
  {
    label: "Islamic University of Science and Technology",
    value: "Islamic University of Science and Technology",
  },
  {
    label: "Islamic University of Technology",
    value: "Islamic University of Technology",
  },
  {
    label: "ISM Vadybos ir ekonomikos universitetas",
    value: "ISM Vadybos ir ekonomikos universitetas",
  },
  {
    label:
      "ISPA - Instituto Universitário de Ciências Psicológicas, Sociais e da Vida",
    value:
      "ISPA - Instituto Universitário de Ciências Psicológicas, Sociais e da Vida",
  },
  {
    label: "Isra University",
    value: "Isra University",
  },
  {
    label: "Isra University",
    value: "Isra University",
  },
  {
    label: "Israa University",
    value: "Israa University",
  },
  {
    label: "Israel Academic College",
    value: "Israel Academic College",
  },
  {
    label: "ISS International Business School of Service Management",
    value: "ISS International Business School of Service Management",
  },
  {
    label: "ISSIC University",
    value: "ISSIC University",
  },
  {
    label: "Issyk-Kul State University",
    value: "Issyk-Kul State University",
  },
  {
    label: "Istanbul 29 Mayis Üniversitesi",
    value: "Istanbul 29 Mayis Üniversitesi",
  },
  {
    label: "Istanbul Arel Üniversitesi",
    value: "Istanbul Arel Üniversitesi",
  },
  {
    label: "Istanbul Aydin Üniversitesi",
    value: "Istanbul Aydin Üniversitesi",
  },
  {
    label: "Istanbul Bilgi Üniversitesi",
    value: "Istanbul Bilgi Üniversitesi",
  },
  {
    label: "Istanbul Esenyurt Üniversitesi",
    value: "Istanbul Esenyurt Üniversitesi",
  },
  {
    label: "Istanbul Gedik Üniversitesi",
    value: "Istanbul Gedik Üniversitesi",
  },
  {
    label: "Istanbul Gelisim Üniversitesi",
    value: "Istanbul Gelisim Üniversitesi",
  },
  {
    label: "Istanbul Kent Üniversitesi",
    value: "Istanbul Kent Üniversitesi",
  },
  {
    label: "Istanbul Kültür Üniversitesi",
    value: "Istanbul Kültür Üniversitesi",
  },
  {
    label: "Istanbul Medeniyet Üniversitesi",
    value: "Istanbul Medeniyet Üniversitesi",
  },
  {
    label: "Istanbul Medipol Üniversitesi",
    value: "Istanbul Medipol Üniversitesi",
  },
  {
    label: "Istanbul Rumeli Üniversitesi",
    value: "Istanbul Rumeli Üniversitesi",
  },
  {
    label: "Istanbul Sabahattin Zaim Üniversitesi",
    value: "Istanbul Sabahattin Zaim Üniversitesi",
  },
  {
    label: "Istanbul Teknik Üniversitesi",
    value: "Istanbul Teknik Üniversitesi",
  },
  {
    label: "Istanbul Ticaret Üniversitesi",
    value: "Istanbul Ticaret Üniversitesi",
  },
  {
    label: "Istanbul Topkapi Üniversitesi",
    value: "Istanbul Topkapi Üniversitesi",
  },
  {
    label: "Istanbul Üniversitesi",
    value: "Istanbul Üniversitesi",
  },
  {
    label: "Istanbul Yeni Yüzyil Üniversitesi",
    value: "Istanbul Yeni Yüzyil Üniversitesi",
  },
  {
    label: "Istarsko veleucilište",
    value: "Istarsko veleucilište",
  },
  {
    label: "IST-Hochschule für Management",
    value: "IST-Hochschule für Management",
  },
  {
    label: "Istinye Üniversitesi",
    value: "Istinye Üniversitesi",
  },
  {
    label: "Istituto Universitario di Studi Superiori",
    value: "Istituto Universitario di Studi Superiori",
  },
  {
    label: "Itä-Suomen yliopisto",
    value: "Itä-Suomen yliopisto",
  },
  {
    label: "ITECH Institut Textile et Chimique de Lyon",
    value: "ITECH Institut Textile et Chimique de Lyon",
  },
  {
    label: "Ithaca College",
    value: "Ithaca College",
  },
  {
    label: "ITM University Gwalior",
    value: "ITM University Gwalior",
  },
  {
    label: "ITM University Raipur",
    value: "ITM University Raipur",
  },
  {
    label: "ITM Vocational University",
    value: "ITM Vocational University",
  },
  {
    label: "ITMO University",
    value: "ITMO University",
  },
  {
    label: "Ittihad Private University",
    value: "Ittihad Private University",
  },
  {
    label: "IT-Universitetet i København",
    value: "IT-Universitetet i København",
  },
  {
    label: "IU International University of Applied Sciences",
    value: "IU International University of Applied Sciences",
  },
  {
    label: "IU Internationale Hochschule",
    value: "IU Internationale Hochschule",
  },
  {
    label: "Ivan Franko National University of Lviv",
    value: "Ivan Franko National University of Lviv",
  },
  {
    label: "Ivane Javakhishvili Tbilisi State University",
    value: "Ivane Javakhishvili Tbilisi State University",
  },
  {
    label: "Ivano-Frankivsk National Medical University",
    value: "Ivano-Frankivsk National Medical University",
  },
  {
    label: "Ivano-Frankivsk National Technical University of Oil and Gas",
    value: "Ivano-Frankivsk National Technical University of Oil and Gas",
  },
  {
    label: "Ivanovo State Academy of Agriculture",
    value: "Ivanovo State Academy of Agriculture",
  },
  {
    label: "Ivanovo State Medical Academy",
    value: "Ivanovo State Medical Academy",
  },
  {
    label: "Ivanovo State Polytechnic University",
    value: "Ivanovo State Polytechnic University",
  },
  {
    label: "Ivanovo State Power University",
    value: "Ivanovo State Power University",
  },
  {
    label: "Ivanovo State University",
    value: "Ivanovo State University",
  },
  {
    label: "Ivanovo State University of Chemistry and Technology",
    value: "Ivanovo State University of Chemistry and Technology",
  },
  {
    label: "Iwate Medical University",
    value: "Iwate Medical University",
  },
  {
    label: "Iwate Prefectural University",
    value: "Iwate Prefectural University",
  },
  {
    label: "Iwate University",
    value: "Iwate University",
  },
  {
    label: "Iwate University of Health and Medical Sciences",
    value: "Iwate University of Health and Medical Sciences",
  },
  {
    label: "Izhevsk State Medical Academy",
    value: "Izhevsk State Medical Academy",
  },
  {
    label: "Izmail State University of Humanities",
    value: "Izmail State University of Humanities",
  },
  {
    label: "Izmir Demokrasi Üniversitesi",
    value: "Izmir Demokrasi Üniversitesi",
  },
  {
    label: "Izmir Ekonomi Üniversitesi",
    value: "Izmir Ekonomi Üniversitesi",
  },
  {
    label: "Izmir Kâtip Çelebi Üniversitesi",
    value: "Izmir Kâtip Çelebi Üniversitesi",
  },
  {
    label: "Izmir Yüksek Teknoloji Enstitüsü",
    value: "Izmir Yüksek Teknoloji Enstitüsü",
  },
  {
    label: "J. F. Oberlin University",
    value: "J. F. Oberlin University",
  },
  {
    label: "J.C. Bose University of Science and Technology",
    value: "J.C. Bose University of Science and Technology",
  },
  {
    label: "Jaamacada Badweynta Hindiya",
    value: "Jaamacada Badweynta Hindiya",
  },
  {
    label: "Jaamacada Bariga Afrika",
    value: "Jaamacada Bariga Afrika",
  },
  {
    label: "Jaamacada Burco",
    value: "Jaamacada Burco",
  },
  {
    label: "Jaamacada Eelo",
    value: "Jaamacada Eelo",
  },
  {
    label: "Jaamacada Gedo",
    value: "Jaamacada Gedo",
  },
  {
    label: "Jaamacada Golis",
    value: "Jaamacada Golis",
  },
  {
    label: "Jaamacada Hargeysa",
    value: "Jaamacada Hargeysa",
  },
  {
    label: "Jaamacada Hiiraan",
    value: "Jaamacada Hiiraan",
  },
  {
    label: "Jaamacada Jamhuuriya ee Culuumta iyo Tiknooloojiyada",
    value: "Jaamacada Jamhuuriya ee Culuumta iyo Tiknooloojiyada",
  },
  {
    label: "Jaamacada Jazeera",
    value: "Jaamacada Jazeera",
  },
  {
    label: "Jaamacada Kismaayo",
    value: "Jaamacada Kismaayo",
  },
  {
    label: "Jaamacada Koonfur Galbeed Soomaaliya",
    value: "Jaamacada Koonfur Galbeed Soomaaliya",
  },
  {
    label: "Jaamacada Nugaal",
    value: "Jaamacada Nugaal",
  },
  {
    label: "Jaamacada Plasma",
    value: "Jaamacada Plasma",
  },
  {
    label: "Jaamacada Ummada Soomaaliyeed",
    value: "Jaamacada Ummada Soomaaliyeed",
  },
  {
    label: "Jaamacadda Abraar",
    value: "Jaamacadda Abraar",
  },
  {
    label: "Jaamacadda Banaadir",
    value: "Jaamacadda Banaadir",
  },
  {
    label: "Jaamacadda barawa International University",
    value: "Jaamacadda barawa International University",
  },
  {
    label: "Jaamacadda Caalamiga ah ee Horseed",
    value: "Jaamacadda Caalamiga ah ee Horseed",
  },
  {
    label: "Jaamacadda Camuud",
    value: "Jaamacadda Camuud",
  },
  {
    label: "Jaamacadda City",
    value: "Jaamacadda City",
  },
  {
    label: "Jaamacadda Culuumta Cafimadka",
    value: "Jaamacadda Culuumta Cafimadka",
  },
  {
    label: "Jaamacadda Hormuud",
    value: "Jaamacadda Hormuud",
  },
  {
    label: "Jaamacadda Jobkey",
    value: "Jaamacadda Jobkey",
  },
  {
    label: "Jaamacadda Juba ee Cilmiga iyo Tiknolojiyada",
    value: "Jaamacadda Juba ee Cilmiga iyo Tiknolojiyada",
  },
  {
    label: "Jaamacadda Muqdisho",
    value: "Jaamacadda Muqdisho",
  },
  {
    label: "Jaamacadda Puntland State University",
    value: "Jaamacadda Puntland State University",
  },
  {
    label: "Jaamacadda Salaam",
    value: "Jaamacadda Salaam",
  },
  {
    label: "Jaamacadda Sayniska iyo Teknolojiyada Sanaag",
    value: "Jaamacadda Sayniska iyo Teknolojiyada Sanaag",
  },
  {
    label: "Jaamacadda SIMAD",
    value: "Jaamacadda SIMAD",
  },
  {
    label: "Jaamacadda Soomaaliya",
    value: "Jaamacadda Soomaaliya",
  },
  {
    label: "Jaamacadda Teknoolajiyadda Somaliland",
    value: "Jaamacadda Teknoolajiyadda Somaliland",
  },
  {
    label: "Jaamacadda Zamzam ee Culuumta iyo Tiknolojiyadda",
    value: "Jaamacadda Zamzam ee Culuumta iyo Tiknolojiyadda",
  },
  {
    label: "Jabir Ibn Hayyan Medical University",
    value: "Jabir Ibn Hayyan Medical University",
  },
  {
    label: "Jackson State University",
    value: "Jackson State University",
  },
  {
    label: "Jacksonville State University",
    value: "Jacksonville State University",
  },
  {
    label: "Jacksonville University",
    value: "Jacksonville University",
  },
  {
    label: "Jadara University",
    value: "Jadara University",
  },
  {
    label: "Jadavpur University",
    value: "Jadavpur University",
  },
  {
    label: "Jade Hochschule",
    value: "Jade Hochschule",
  },
  {
    label: "Jagadguru Ramanandacharya Rajasthan Sanskrit University",
    value: "Jagadguru Ramanandacharya Rajasthan Sanskrit University",
  },
  {
    label: "Jagadguru Rambhadracharya Handicapped University",
    value: "Jagadguru Rambhadracharya Handicapped University",
  },
  {
    label: "Jagan Nath University",
    value: "Jagan Nath University",
  },
  {
    label: "Jagannath University",
    value: "Jagannath University",
  },
  {
    label: "Jagannath University",
    value: "Jagannath University",
  },
  {
    label: "Jagora University",
    value: "Jagora University",
  },
  {
    label: "Jagran Lakecity University",
    value: "Jagran Lakecity University",
  },
  {
    label: "Jahan E Noor Institute of Higher Education",
    value: "Jahan E Noor Institute of Higher Education",
  },
  {
    label: "Jahan University",
    value: "Jahan University",
  },
  {
    label: "Jahangirnagar University",
    value: "Jahangirnagar University",
  },
  {
    label: "Jahon Iqtisodiyoti va Diplomatiya Universiteti",
    value: "Jahon Iqtisodiyoti va Diplomatiya Universiteti",
  },
  {
    label: "Jahrom university",
    value: "Jahrom university",
  },
  {
    label: "Jahrom University of Medical Sciences",
    value: "Jahrom University of Medical Sciences",
  },
  {
    label: "Jai Narain Vyas University",
    value: "Jai Narain Vyas University",
  },
  {
    label: "Jai Prakash Vishwavidyalaya",
    value: "Jai Prakash Vishwavidyalaya",
  },
  {
    label: "Jain University",
    value: "Jain University",
  },
  {
    label: "Jain Vishva Bharati Institute",
    value: "Jain Vishva Bharati Institute",
  },
  {
    label: "Jaipur National University",
    value: "Jaipur National University",
  },
  {
    label: "Jalalabad State University",
    value: "Jalalabad State University",
  },
  {
    label: "Jam Music Lab Private University",
    value: "Jam Music Lab Private University",
  },
  {
    label: "James Cook University",
    value: "James Cook University",
  },
  {
    label: "James Madison University",
    value: "James Madison University",
  },
  {
    label: "Jamestown Business College",
    value: "Jamestown Business College",
  },
  {
    label: "Jami Institute of Technology",
    value: "Jami Institute of Technology",
  },
  {
    label: "Jamia Hamdard",
    value: "Jamia Hamdard",
  },
  {
    label: "Jamia Millia Islamia",
    value: "Jamia Millia Islamia",
  },
  {
    label: "Janáckova akademie múzických umení",
    value: "Janáckova akademie múzických umení",
  },
  {
    label: "Jananayak Chandrashekhar University",
    value: "Jananayak Chandrashekhar University",
  },
  {
    label: "Janardan Rai Nagar Rajasthan Vidhyapeeth University",
    value: "Janardan Rai Nagar Rajasthan Vidhyapeeth University",
  },
  {
    label: "Japan Advanced Institute of Science and Technology",
    value: "Japan Advanced Institute of Science and Technology",
  },
  {
    label: "Japan College of Social Work",
    value: "Japan College of Social Work",
  },
  {
    label: "Japan Health Care College",
    value: "Japan Health Care College",
  },
  {
    label: "Japan Institute of the Moving Image",
    value: "Japan Institute of the Moving Image",
  },
  {
    label: "Japan Lutheran College",
    value: "Japan Lutheran College",
  },
  {
    label: "Japan University of Economics",
    value: "Japan University of Economics",
  },
  {
    label: "Japan University of Health Sciences",
    value: "Japan University of Health Sciences",
  },
  {
    label: "Japan Women's College of Physical Education",
    value: "Japan Women's College of Physical Education",
  },
  {
    label: "Japan Women's University",
    value: "Japan Women's University",
  },
  {
    label: "Japanese Red Cross Akita College of Nursing",
    value: "Japanese Red Cross Akita College of Nursing",
  },
  {
    label: "Japanese Red Cross College of Nursing",
    value: "Japanese Red Cross College of Nursing",
  },
  {
    label: "Japanese Red Cross Hiroshima College of Nursing",
    value: "Japanese Red Cross Hiroshima College of Nursing",
  },
  {
    label: "Japanese Red Cross Hokkaido College of Nursing",
    value: "Japanese Red Cross Hokkaido College of Nursing",
  },
  {
    label: "Japanese Red Cross Toyota College of Nursing",
    value: "Japanese Red Cross Toyota College of Nursing",
  },
  {
    label: "Jaramogi Oginga Odinga University of Science and Technology",
    value: "Jaramogi Oginga Odinga University of Science and Technology",
  },
  {
    label: "Jarvis Christian University",
    value: "Jarvis Christian University",
  },
  {
    label: "Jashore University of Science and Technology",
    value: "Jashore University of Science and Technology",
  },
  {
    label: "Jatiya Kabi Kazi Nazrul Islam University",
    value: "Jatiya Kabi Kazi Nazrul Islam University",
  },
  {
    label: "Jawaharlal Institute of Postgraduate Medical Education & Research",
    value: "Jawaharlal Institute of Postgraduate Medical Education & Research",
  },
  {
    label: "Jawaharlal Nehru Architecture and Fine Arts University",
    value: "Jawaharlal Nehru Architecture and Fine Arts University",
  },
  {
    label: "Jawaharlal Nehru Centre for Advanced Scientific Research",
    value: "Jawaharlal Nehru Centre for Advanced Scientific Research",
  },
  {
    label: "Jawaharlal Nehru Krishi Vishwavidyalaya",
    value: "Jawaharlal Nehru Krishi Vishwavidyalaya",
  },
  {
    label: "Jawaharlal Nehru Technological University",
    value: "Jawaharlal Nehru Technological University",
  },
  {
    label: "Jawaharlal Nehru Technological University, Anantapur",
    value: "Jawaharlal Nehru Technological University, Anantapur",
  },
  {
    label: "Jawaharlal Nehru Technological University, Kakinada",
    value: "Jawaharlal Nehru Technological University, Kakinada",
  },
  {
    label: "Jawaharlal Nehru University",
    value: "Jawaharlal Nehru University",
  },
  {
    label: "Jawzjan University",
    value: "Jawzjan University",
  },
  {
    label: "Jayee University College",
    value: "Jayee University College",
  },
  {
    label: "Jayoti Vidyapeeth Women's University",
    value: "Jayoti Vidyapeeth Women's University",
  },
  {
    label: "Jaypee Institute of Information Technology",
    value: "Jaypee Institute of Information Technology",
  },
  {
    label: "Jaypee University Anoopshahr",
    value: "Jaypee University Anoopshahr",
  },
  {
    label: "Jaypee University of Engineering and Technology",
    value: "Jaypee University of Engineering and Technology",
  },
  {
    label: "Jaypee University of Information Technology",
    value: "Jaypee University of Information Technology",
  },
  {
    label: "Jazan University",
    value: "Jazan University",
  },
  {
    label: "Jazepa Vitola Latvijas muzikas akademija",
    value: "Jazepa Vitola Latvijas muzikas akademija",
  },
  {
    label: "JECRC University",
    value: "JECRC University",
  },
  {
    label: "Jeju International University",
    value: "Jeju International University",
  },
  {
    label: "Jeju National University",
    value: "Jeju National University",
  },
  {
    label: "Jeonbuk National University",
    value: "Jeonbuk National University",
  },
  {
    label: "Jeonju National University of Education",
    value: "Jeonju National University of Education",
  },
  {
    label: "Jeonju University",
    value: "Jeonju University",
  },
  {
    label: "Jerash Private University",
    value: "Jerash Private University",
  },
  {
    label: "Jerusalem College of Technology",
    value: "Jerusalem College of Technology",
  },
  {
    label: "Jessup University",
    value: "Jessup University",
  },
  {
    label: "Jesus University",
    value: "Jesus University",
  },
  {
    label: "Jharkhand Rai University",
    value: "Jharkhand Rai University",
  },
  {
    label: "Jharkhand Raksha Shakti University",
    value: "Jharkhand Raksha Shakti University",
  },
  {
    label: "Jiamusi University",
    value: "Jiamusi University",
  },
  {
    label: "Jianghan University",
    value: "Jianghan University",
  },
  {
    label: "Jiangnan University",
    value: "Jiangnan University",
  },
  {
    label: "Jiangsu Normal University",
    value: "Jiangsu Normal University",
  },
  {
    label: "Jiangsu Ocean University",
    value: "Jiangsu Ocean University",
  },
  {
    label: "Jiangsu Second Normal University",
    value: "Jiangsu Second Normal University",
  },
  {
    label: "Jiangsu Teachers University of Technology",
    value: "Jiangsu Teachers University of Technology",
  },
  {
    label: "Jiangsu University",
    value: "Jiangsu University",
  },
  {
    label: "Jiangsu University of Science and Technology",
    value: "Jiangsu University of Science and Technology",
  },
  {
    label: "Jiangsu University of Technology",
    value: "Jiangsu University of Technology",
  },
  {
    label: "Jiangxi Agricultural University",
    value: "Jiangxi Agricultural University",
  },
  {
    label: "Jiangxi Institute of Fashion Technology",
    value: "Jiangxi Institute of Fashion Technology",
  },
  {
    label: "Jiangxi Normal University",
    value: "Jiangxi Normal University",
  },
  {
    label: "Jiangxi Science and Technology Normal University",
    value: "Jiangxi Science and Technology Normal University",
  },
  {
    label: "Jiangxi University of Finance and Economics",
    value: "Jiangxi University of Finance and Economics",
  },
  {
    label: "Jiangxi University of Science and Technology",
    value: "Jiangxi University of Science and Technology",
  },
  {
    label: "Jiangxi University of Technology",
    value: "Jiangxi University of Technology",
  },
  {
    label: "Jiangxi University of Traditional Chinese Medicine",
    value: "Jiangxi University of Traditional Chinese Medicine",
  },
  {
    label: "Jiaxing University",
    value: "Jiaxing University",
  },
  {
    label: "Jiaying University",
    value: "Jiaying University",
  },
  {
    label: "Jichi Medical University",
    value: "Jichi Medical University",
  },
  {
    label: "Jigjiga University",
    value: "Jigjiga University",
  },
  {
    label: "Jihoceská univerzita v Ceských Budejovicích",
    value: "Jihoceská univerzita v Ceských Budejovicích",
  },
  {
    label: "Jikei University of Health Care Sciences",
    value: "Jikei University of Health Care Sciences",
  },
  {
    label: "Jilin Agricultural Science and Technology College",
    value: "Jilin Agricultural Science and Technology College",
  },
  {
    label: "Jilin Agricultural University",
    value: "Jilin Agricultural University",
  },
  {
    label: "Jilin Animation Institute",
    value: "Jilin Animation Institute",
  },
  {
    label: "Jilin Business and Technology College",
    value: "Jilin Business and Technology College",
  },
  {
    label: "Jilin College of the Arts",
    value: "Jilin College of the Arts",
  },
  {
    label: "Jilin Engineering Normal University",
    value: "Jilin Engineering Normal University",
  },
  {
    label: "Jilin Institute of Chemical Technology",
    value: "Jilin Institute of Chemical Technology",
  },
  {
    label: "Jilin International Studies University",
    value: "Jilin International Studies University",
  },
  {
    label: "Jilin Jianzhu University",
    value: "Jilin Jianzhu University",
  },
  {
    label: "Jilin Medical University",
    value: "Jilin Medical University",
  },
  {
    label: "Jilin Normal University",
    value: "Jilin Normal University",
  },
  {
    label: "Jilin University",
    value: "Jilin University",
  },
  {
    label: "Jilin University of Finance and Economics",
    value: "Jilin University of Finance and Economics",
  },
  {
    label: "Jimei University",
    value: "Jimei University",
  },
  {
    label: "Jimma University",
    value: "Jimma University",
  },
  {
    label: "Jin-ai University",
    value: "Jin-ai University",
  },
  {
    label: "Jinan University",
    value: "Jinan University",
  },
  {
    label: "Jinan University of Lebanon",
    value: "Jinan University of Lebanon",
  },
  {
    label: "Jingchu University of Technology",
    value: "Jingchu University of Technology",
  },
  {
    label: "Jingdezhen Ceramic Institute",
    value: "Jingdezhen Ceramic Institute",
  },
  {
    label: "Jingdezhen University",
    value: "Jingdezhen University",
  },
  {
    label: "Jinggangshan University",
    value: "Jinggangshan University",
  },
  {
    label: "Jining Medical University",
    value: "Jining Medical University",
  },
  {
    label: "Jining Normal University",
    value: "Jining Normal University",
  },
  {
    label: "Jining University",
    value: "Jining University",
  },
  {
    label: "Jinling Institute of Technology",
    value: "Jinling Institute of Technology",
  },
  {
    label: "Jinnah Sindh Medical University",
    value: "Jinnah Sindh Medical University",
  },
  {
    label: "Jinnah University for Women",
    value: "Jinnah University for Women",
  },
  {
    label: "Jinwen University of Science and Technology",
    value: "Jinwen University of Science and Technology",
  },
  {
    label: "Jinzhong University",
    value: "Jinzhong University",
  },
  {
    label: "Jinzhou Medical University",
    value: "Jinzhou Medical University",
  },
  {
    label: "JIS University",
    value: "JIS University",
  },
  {
    label: "Jishou University",
    value: "Jishou University",
  },
  {
    label: "Jissen Women's University",
    value: "Jissen Women's University",
  },
  {
    label: "Jiujiang University",
    value: "Jiujiang University",
  },
  {
    label: "Jiwaji University",
    value: "Jiwaji University",
  },
  {
    label: "Jizzax Davlat Pedagogika Universiteti",
    value: "Jizzax Davlat Pedagogika Universiteti",
  },
  {
    label: "Jizzax Politexnika Instituti",
    value: "Jizzax Politexnika Instituti",
  },
  {
    label: "JK Lakshmipat University",
    value: "JK Lakshmipat University",
  },
  {
    label: "Jobu University",
    value: "Jobu University",
  },
  {
    label: "Jodhpur National University",
    value: "Jodhpur National University",
  },
  {
    label: "Joetsu University of Education",
    value: "Joetsu University of Education",
  },
  {
    label: "Johannes Gutenberg-Universität Mainz",
    value: "Johannes Gutenberg-Universität Mainz",
  },
  {
    label: "Johannes Kepler Universität Linz",
    value: "Johannes Kepler Universität Linz",
  },
  {
    label: "John B. Lacson Foundation Maritime University",
    value: "John B. Lacson Foundation Maritime University",
  },
  {
    label: "John Brown University",
    value: "John Brown University",
  },
  {
    label: "John Carroll University",
    value: "John Carroll University",
  },
  {
    label: "John Garang Memorial University of Science and Technology",
    value: "John Garang Memorial University of Science and Technology",
  },
  {
    label: "John Jay College of Criminal Justice",
    value: "John Jay College of Criminal Justice",
  },
  {
    label: "John Paul the Great Catholic University",
    value: "John Paul the Great Catholic University",
  },
  {
    label: "Johns Hopkins University",
    value: "Johns Hopkins University",
  },
  {
    label: "Johnson and Wales University",
    value: "Johnson and Wales University",
  },
  {
    label: "Johnson C. Smith University",
    value: "Johnson C. Smith University",
  },
  {
    label: "Johnson University",
    value: "Johnson University",
  },
  {
    label: "Jomo Kenyatta University of Agriculture and Technology",
    value: "Jomo Kenyatta University of Agriculture and Technology",
  },
  {
    label:
      "Jomo Kenyatta University of Agriculture and Technology, Kigali Campus",
    value:
      "Jomo Kenyatta University of Agriculture and Technology, Kigali Campus",
  },
  {
    label: "Jönköping University",
    value: "Jönköping University",
  },
  {
    label: "Joongang Sangha University",
    value: "Joongang Sangha University",
  },
  {
    label: "Joongbu University",
    value: "Joongbu University",
  },
  {
    label: "Jordan Academy of Music",
    value: "Jordan Academy of Music",
  },
  {
    label: "Jordan University of Science and Technology",
    value: "Jordan University of Science and Technology",
  },
  {
    label: "Josai International University",
    value: "Josai International University",
  },
  {
    label: "Josai University",
    value: "Josai University",
  },
  {
    label: "José Rizal University",
    value: "José Rizal University",
  },
  {
    label: "Joseph Ayo Babalola University",
    value: "Joseph Ayo Babalola University",
  },
  {
    label: "Joseph Sarwuan Tarkaa University",
    value: "Joseph Sarwuan Tarkaa University",
  },
  {
    label: "Joshibi University of Art and Design",
    value: "Joshibi University of Art and Design",
  },
  {
    label: "JS University",
    value: "JS University",
  },
  {
    label: "JSS Academy of Higher Education and Research",
    value: "JSS Academy of Higher Education and Research",
  },
  {
    label: "JSS Science and Technology University",
    value: "JSS Science and Technology University",
  },
  {
    label: "Judson University",
    value: "Judson University",
  },
  {
    label: "Julius-Maximilians-Universität Würzburg",
    value: "Julius-Maximilians-Universität Würzburg",
  },
  {
    label: "Jumeira University",
    value: "Jumeira University",
  },
  {
    label: "Jumonji University",
    value: "Jumonji University",
  },
  {
    label: "Junagadh Agricultural University",
    value: "Junagadh Agricultural University",
  },
  {
    label: "Jundi-Shapur University of Technology",
    value: "Jundi-Shapur University of Technology",
  },
  {
    label: "Jungwon University",
    value: "Jungwon University",
  },
  {
    label: "Junia",
    value: "Junia",
  },
  {
    label: "Juniata College",
    value: "Juniata College",
  },
  {
    label: "Junshin Gakuen University",
    value: "Junshin Gakuen University",
  },
  {
    label: "Juntendo University",
    value: "Juntendo University",
  },
  {
    label: "Justo Mwale University",
    value: "Justo Mwale University",
  },
  {
    label: "Justus-Liebig-Universität Giessen",
    value: "Justus-Liebig-Universität Giessen",
  },
  {
    label: "Jyväskylän ammattikorkeakoulu",
    value: "Jyväskylän ammattikorkeakoulu",
  },
  {
    label: "Jyväskylän yliopisto",
    value: "Jyväskylän yliopisto",
  },
  {
    label: "K L University",
    value: "K L University",
  },
  {
    label: "K. Sh. Toktomamatova International University",
    value: "K. Sh. Toktomamatova International University",
  },
  {
    label: "K.K. University",
    value: "K.K. University",
  },
  {
    label: "K.R. Mangalam University",
    value: "K.R. Mangalam University",
  },
  {
    label: "KAAF University College",
    value: "KAAF University College",
  },
  {
    label: "Kaakkois-Suomen ammattikorkeakoulu",
    value: "Kaakkois-Suomen ammattikorkeakoulu",
  },
  {
    label: "Kabale University",
    value: "Kabale University",
  },
  {
    label: "Kabarak University",
    value: "Kabarak University",
  },
  {
    label: "Kabardino-Balkarian State Agricultural University",
    value: "Kabardino-Balkarian State Agricultural University",
  },
  {
    label: "Kabardino-Balkarian State University",
    value: "Kabardino-Balkarian State University",
  },
  {
    label: "Kaboora Institute of Higher Education",
    value: "Kaboora Institute of Higher Education",
  },
  {
    label: "Kabul Polytechnic University",
    value: "Kabul Polytechnic University",
  },
  {
    label: "Kabul University",
    value: "Kabul University",
  },
  {
    label: "Kabul University of Medical Sciences",
    value: "Kabul University of Medical Sciences",
  },
  {
    label: "Kadi Sarva Vishwavidyalaya",
    value: "Kadi Sarva Vishwavidyalaya",
  },
  {
    label: "Kadir Has Üniversitesi",
    value: "Kadir Has Üniversitesi",
  },
  {
    label: "Kaduna State University",
    value: "Kaduna State University",
  },
  {
    label: "Kaetsu University",
    value: "Kaetsu University",
  },
  {
    label: "Kafkas Üniversitesi",
    value: "Kafkas Üniversitesi",
  },
  {
    label: "Kafrelsheikh University",
    value: "Kafrelsheikh University",
  },
  {
    label: "KAG East University",
    value: "KAG East University",
  },
  {
    label: "Kagawa Nutrition University",
    value: "Kagawa Nutrition University",
  },
  {
    label: "Kagawa Prefectural University of Health Sciences",
    value: "Kagawa Prefectural University of Health Sciences",
  },
  {
    label: "Kagawa University",
    value: "Kagawa University",
  },
  {
    label: "Kagoshima Immaculate Heart University",
    value: "Kagoshima Immaculate Heart University",
  },
  {
    label: "Kagoshima University",
    value: "Kagoshima University",
  },
  {
    label: "Kahkashan-e-Sharq Higher Education Institute",
    value: "Kahkashan-e-Sharq Higher Education Institute",
  },
  {
    label: "Kahramanmaras Sütçü Imam Üniversitesi",
    value: "Kahramanmaras Sütçü Imam Üniversitesi",
  },
  {
    label: "Kaichi International University",
    value: "Kaichi International University",
  },
  {
    label: "Kaili University",
    value: "Kaili University",
  },
  {
    label: "Kainan University",
    value: "Kainan University",
  },
  {
    label: "Kainar University",
    value: "Kainar University",
  },
  {
    label: "KAIST",
    value: "KAIST",
  },
  {
    label: "Kajaanin ammattikorkeakoulu",
    value: "Kajaanin ammattikorkeakoulu",
  },
  {
    label: "Kakatiya University",
    value: "Kakatiya University",
  },
  {
    label: "Kalaidos Fachhochschule",
    value: "Kalaidos Fachhochschule",
  },
  {
    label: "Kalamazoo College",
    value: "Kalamazoo College",
  },
  {
    label: "Kalasalingam Academy of Research and Education",
    value: "Kalasalingam Academy of Research and Education",
  },
  {
    label: "Kalashnikov Izhevsk State Technical University",
    value: "Kalashnikov Izhevsk State Technical University",
  },
  {
    label: "Kalasin University",
    value: "Kalasin University",
  },
  {
    label: "Kalay University",
    value: "Kalay University",
  },
  {
    label: "Kalinga University",
    value: "Kalinga University",
  },
  {
    label: "Kaliningrad State Technical University",
    value: "Kaliningrad State Technical University",
  },
  {
    label: "Kalmyk State University",
    value: "Kalmyk State University",
  },
  {
    label: "Kaluga State University",
    value: "Kaluga State University",
  },
  {
    label: "Kamakura Women's University",
    value: "Kamakura Women's University",
  },
  {
    label: "Kamchatka State Technical University",
    value: "Kamchatka State Technical University",
  },
  {
    label: "Kamchatka State University named after Vitus Bering",
    value: "Kamchatka State University named after Vitus Bering",
  },
  {
    label: "Kamdhenu University",
    value: "Kamdhenu University",
  },
  {
    label: "Kameda University of Health Sciences",
    value: "Kameda University of Health Sciences",
  },
  {
    label: "Kameshwar Singh Darbhanga Sanskrit University",
    value: "Kameshwar Singh Darbhanga Sanskrit University",
  },
  {
    label: "Kamoliddin Behzod Nomidagi Milliy Rassomlik Va Dizayn Instituti",
    value: "Kamoliddin Behzod Nomidagi Milliy Rassomlik Va Dizayn Instituti",
  },
  {
    label: "Kampala International University",
    value: "Kampala International University",
  },
  {
    label: "Kampala University",
    value: "Kampala University",
  },
  {
    label: "Kamphaeng Phet Rajabhat University",
    value: "Kamphaeng Phet Rajabhat University",
  },
  {
    label: "Kampong Cham National School of Agriculture",
    value: "Kampong Cham National School of Agriculture",
  },
  {
    label: "Kamyanets-Podilsky Ivan Ohienko National University",
    value: "Kamyanets-Podilsky Ivan Ohienko National University",
  },
  {
    label: "Kanagawa Dental University",
    value: "Kanagawa Dental University",
  },
  {
    label: "Kanagawa Institute of Technology",
    value: "Kanagawa Institute of Technology",
  },
  {
    label: "Kanagawa University",
    value: "Kanagawa University",
  },
  {
    label: "Kanagawa University of Human Services",
    value: "Kanagawa University of Human Services",
  },
  {
    label: "Kanazawa College of Art",
    value: "Kanazawa College of Art",
  },
  {
    label: "Kanazawa Gakuin University",
    value: "Kanazawa Gakuin University",
  },
  {
    label: "Kanazawa Institute of Technology",
    value: "Kanazawa Institute of Technology",
  },
  {
    label: "Kanazawa Medical University",
    value: "Kanazawa Medical University",
  },
  {
    label: "Kanazawa Seiryo University",
    value: "Kanazawa Seiryo University",
  },
  {
    label: "Kanazawa University",
    value: "Kanazawa University",
  },
  {
    label: "Kanchanaburi Rajabhat University",
    value: "Kanchanaburi Rajabhat University",
  },
  {
    label: "Kanda University of International Studies",
    value: "Kanda University of International Studies",
  },
  {
    label: "Kandahar University",
    value: "Kandahar University",
  },
  {
    label: "Kangnam University",
    value: "Kangnam University",
  },
  {
    label: "Kangwon National University",
    value: "Kangwon National University",
  },
  {
    label: "Kannada University",
    value: "Kannada University",
  },
  {
    label: "Kannur University",
    value: "Kannur University",
  },
  {
    label: "Kano University of Science and Technology",
    value: "Kano University of Science and Technology",
  },
  {
    label: "Kansai Gaidai University",
    value: "Kansai Gaidai University",
  },
  {
    label: "Kansai Medical University",
    value: "Kansai Medical University",
  },
  {
    label: "Kansai University",
    value: "Kansai University",
  },
  {
    label: "Kansai University of Health Sciences",
    value: "Kansai University of Health Sciences",
  },
  {
    label: "Kansai University of International Studies",
    value: "Kansai University of International Studies",
  },
  {
    label: "Kansai University of Nursing and Health Sciences",
    value: "Kansai University of Nursing and Health Sciences",
  },
  {
    label: "Kansai University of Social Welfare",
    value: "Kansai University of Social Welfare",
  },
  {
    label: "Kansai University of Welfare Sciences",
    value: "Kansai University of Welfare Sciences",
  },
  {
    label: "Kansas City Art Institute",
    value: "Kansas City Art Institute",
  },
  {
    label: "Kansas City University",
    value: "Kansas City University",
  },
  {
    label: "Kansas State University",
    value: "Kansas State University",
  },
  {
    label: "Kansas Wesleyan University",
    value: "Kansas Wesleyan University",
  },
  {
    label: "Kanto Gakuen University",
    value: "Kanto Gakuen University",
  },
  {
    label: "Kanto Gakuin University",
    value: "Kanto Gakuin University",
  },
  {
    label: "Kao Yuan University",
    value: "Kao Yuan University",
  },
  {
    label: "Kaohsiung Medical University",
    value: "Kaohsiung Medical University",
  },
  {
    label: "Kapasa Makasa University",
    value: "Kapasa Makasa University",
  },
  {
    label: "Karabük Üniversitesi",
    value: "Karabük Üniversitesi",
  },
  {
    label: "Karachi Institute of Economics and Technology",
    value: "Karachi Institute of Economics and Technology",
  },
  {
    label: "Karachi School for Business and Leadership",
    value: "Karachi School for Business and Leadership",
  },
  {
    label: "Karadeniz Teknik Üniversitesi",
    value: "Karadeniz Teknik Üniversitesi",
  },
  {
    label: "Karaganda Medical University",
    value: "Karaganda Medical University",
  },
  {
    label: "Karaganda State Industrial University",
    value: "Karaganda State Industrial University",
  },
  {
    label: "Karaganda University of Economics",
    value: "Karaganda University of Economics",
  },
  {
    label: "Karakurum International University",
    value: "Karakurum International University",
  },
  {
    label: "Karamanoglu Mehmetbey Üniversitesi",
    value: "Karamanoglu Mehmetbey Üniversitesi",
  },
  {
    label: "Karary University",
    value: "Karary University",
  },
  {
    label: "Karatina University",
    value: "Karatina University",
  },
  {
    label: "Kardan University",
    value: "Kardan University",
  },
  {
    label: "Karel de Grote-Hogeschool",
    value: "Karel de Grote-Hogeschool",
  },
  {
    label: "Karelia-ammattikorkeakoulu",
    value: "Karelia-ammattikorkeakoulu",
  },
  {
    label: "Karl Landsteiner Privatuniversität für Gesundheitswissenschaften",
    value: "Karl Landsteiner Privatuniversität für Gesundheitswissenschaften",
  },
  {
    label: "Karlshochschule International University",
    value: "Karlshochschule International University",
  },
  {
    label: "Karlsruher Institut für Technologie",
    value: "Karlsruher Institut für Technologie",
  },
  {
    label: "Karlstads universitet",
    value: "Karlstads universitet",
  },
  {
    label: "Karnatak University",
    value: "Karnatak University",
  },
  {
    label: "Karnataka Janapada Vishwavidyalaya",
    value: "Karnataka Janapada Vishwavidyalaya",
  },
  {
    label: "Karnataka Samskrit University",
    value: "Karnataka Samskrit University",
  },
  {
    label: "Karnataka State Akkamahadevi Women's University",
    value: "Karnataka State Akkamahadevi Women's University",
  },
  {
    label: "Karnataka State Law University",
    value: "Karnataka State Law University",
  },
  {
    label: "Karnataka State Rural Development and Panchayat Raj University",
    value: "Karnataka State Rural Development and Panchayat Raj University",
  },
  {
    label: "Karnataka Veterinary, Animal and Fisheries Sciences University",
    value: "Karnataka Veterinary, Animal and Fisheries Sciences University",
  },
  {
    label: "Karnavati University",
    value: "Karnavati University",
  },
  {
    label: "Károli Gáspár Református Egyetem",
    value: "Károli Gáspár Református Egyetem",
  },
  {
    label: "Karolinska Institutet",
    value: "Karolinska Institutet",
  },
  {
    label: "Karpagam Academy of Higher Education",
    value: "Karpagam Academy of Higher Education",
  },
  {
    label: "Karunya Institute of Technology and Sciences",
    value: "Karunya Institute of Technology and Sciences",
  },
  {
    label: "Karwan University",
    value: "Karwan University",
  },
  {
    label: "KASB Institute of Technology",
    value: "KASB Institute of Technology",
  },
  {
    label: "Kasem Bundit University",
    value: "Kasem Bundit University",
  },
  {
    label: "Kasetsart University",
    value: "Kasetsart University",
  },
  {
    label: "Kashan University of Medical Sciences",
    value: "Kashan University of Medical Sciences",
  },
  {
    label: "Kashi University",
    value: "Kashi University",
  },
  {
    label: "Kastamonu Üniversitesi",
    value: "Kastamonu Üniversitesi",
  },
  {
    label: "Katavi University of Agriculture",
    value: "Katavi University of Agriculture",
  },
  {
    label: "Kateb University",
    value: "Kateb University",
  },
  {
    label: "Kathmandu University",
    value: "Kathmandu University",
  },
  {
    label: "Katholieke Universiteit Leuven",
    value: "Katholieke Universiteit Leuven",
  },
  {
    label: "Katholische Hochschule Freiburg",
    value: "Katholische Hochschule Freiburg",
  },
  {
    label: "Katholische Hochschule für Sozialwesen Berlin",
    value: "Katholische Hochschule für Sozialwesen Berlin",
  },
  {
    label: "Katholische Hochschule Mainz",
    value: "Katholische Hochschule Mainz",
  },
  {
    label: "Katholische Hochschule Nordrhein-Westfalen",
    value: "Katholische Hochschule Nordrhein-Westfalen",
  },
  {
    label: "Katholische Privat-Universität Linz",
    value: "Katholische Privat-Universität Linz",
  },
  {
    label: "Katholische Stiftungsfachhochschule München",
    value: "Katholische Stiftungsfachhochschule München",
  },
  {
    label: "Katholische Universität Eichstätt-Ingolstadt",
    value: "Katholische Universität Eichstätt-Ingolstadt",
  },
  {
    label: "Katolická Univerzita v Ružomberku",
    value: "Katolická Univerzita v Ružomberku",
  },
  {
    label: "Katolicki Uniwersytet Lubelski Jana Pawla II",
    value: "Katolicki Uniwersytet Lubelski Jana Pawla II",
  },
  {
    label: "Kauno Kolegija",
    value: "Kauno Kolegija",
  },
  {
    label: "Kauno mišku ir aplinkos inžinerijos kolegija",
    value: "Kauno mišku ir aplinkos inžinerijos kolegija",
  },
  {
    label: "Kauno technikos kolegija",
    value: "Kauno technikos kolegija",
  },
  {
    label: "Kauno technologijos universitetas",
    value: "Kauno technologijos universitetas",
  },
  {
    label: "Kavayitri Bahinabai Chaudhari North Maharashtra University",
    value: "Kavayitri Bahinabai Chaudhari North Maharashtra University",
  },
  {
    label: "Kavi Kulguru Kalidas Sanskrit Vishwavidyalaya",
    value: "Kavi Kulguru Kalidas Sanskrit Vishwavidyalaya",
  },
  {
    label: "Kawamura Gakuen Woman's University",
    value: "Kawamura Gakuen Woman's University",
  },
  {
    label: "Kawasaki Medical School",
    value: "Kawasaki Medical School",
  },
  {
    label: "Kawasaki University of Medical Welfare",
    value: "Kawasaki University of Medical Welfare",
  },
  {
    label: "Kawun Institute of Higher Education",
    value: "Kawun Institute of Higher Education",
  },
  {
    label: "Kaya University",
    value: "Kaya University",
  },
  {
    label: "Kayiwa International University",
    value: "Kayiwa International University",
  },
  {
    label:
      "Kazakh Ablai Khan University of International Relations and World Languages",
    value:
      "Kazakh Ablai Khan University of International Relations and World Languages",
  },
  {
    label: "Kazakh Academy of Sport and Tourism",
    value: "Kazakh Academy of Sport and Tourism",
  },
  {
    label: "Kazakh Humanitarian Law Innovative University",
    value: "Kazakh Humanitarian Law Innovative University",
  },
  {
    label: "Kazakh Leading Academy of Architecture and Civil Engineering",
    value: "Kazakh Leading Academy of Architecture and Civil Engineering",
  },
  {
    label: "Kazakh National Academy of Arts",
    value: "Kazakh National Academy of Arts",
  },
  {
    label: "Kazakh National Agricultural University",
    value: "Kazakh National Agricultural University",
  },
  {
    label: "Kazakh National Conservatory",
    value: "Kazakh National Conservatory",
  },
  {
    label: "Kazakh National Medical University",
    value: "Kazakh National Medical University",
  },
  {
    label: "Kazakh National Pedagogical University",
    value: "Kazakh National Pedagogical University",
  },
  {
    label: "Kazakh National University of Arts",
    value: "Kazakh National University of Arts",
  },
  {
    label: "Kazakh National Women's Teacher Training University",
    value: "Kazakh National Women's Teacher Training University",
  },
  {
    label: "Kazakh University of Technology and Business",
    value: "Kazakh University of Technology and Business",
  },
  {
    label: "Kazakh-American Free University",
    value: "Kazakh-American Free University",
  },
  {
    label: "Kazakh-American University",
    value: "Kazakh-American University",
  },
  {
    label: "Kazakh-British Technical University",
    value: "Kazakh-British Technical University",
  },
  {
    label: "Kazakh-Russian International University",
    value: "Kazakh-Russian International University",
  },
  {
    label:
      "Kazakhstan Engineering and Pedagogical University of Friendship of Peoples",
    value:
      "Kazakhstan Engineering and Pedagogical University of Friendship of Peoples",
  },
  {
    label: "Kazakhstan Engineering-Technological University",
    value: "Kazakhstan Engineering-Technological University",
  },
  {
    label: "Kazakhstan School of Public Health",
    value: "Kazakhstan School of Public Health",
  },
  {
    label: "Kazakhstan-Russian Medical University",
    value: "Kazakhstan-Russian Medical University",
  },
  {
    label: "Kazan Federal University",
    value: "Kazan Federal University",
  },
  {
    label:
      "Kazan National Research Technical University named after A.N. Tupolev - KAI",
    value:
      "Kazan National Research Technical University named after A.N. Tupolev - KAI",
  },
  {
    label: "Kazan State Agricultural University",
    value: "Kazan State Agricultural University",
  },
  {
    label: "Kazan State Conservatory",
    value: "Kazan State Conservatory",
  },
  {
    label: "Kazan State Medical University",
    value: "Kazan State Medical University",
  },
  {
    label: "Kazan State Power Engineering University",
    value: "Kazan State Power Engineering University",
  },
  {
    label: "Kazan State Technological University",
    value: "Kazan State Technological University",
  },
  {
    label: "Kazan State University of Architecture and Engineering",
    value: "Kazan State University of Architecture and Engineering",
  },
  {
    label: "Kazan State University of Culture and Arts",
    value: "Kazan State University of Culture and Arts",
  },
  {
    label: "KazAtiso Academy",
    value: "KazAtiso Academy",
  },
  {
    label: "KAZGUU University",
    value: "KAZGUU University",
  },
  {
    label: "Kazi Nazrul University",
    value: "Kazi Nazrul University",
  },
  {
    label: "Kazimiero Simonaviciaus universitetas",
    value: "Kazimiero Simonaviciaus universitetas",
  },
  {
    label: "Kaziranga University",
    value: "Kaziranga University",
  },
  {
    label: "KCA University",
    value: "KCA University",
  },
  {
    label: "Kean University",
    value: "Kean University",
  },
  {
    label: "Kebbi State University of Science and Technology",
    value: "Kebbi State University of Science and Technology",
  },
  {
    label: "Keck Graduate Institute",
    value: "Keck Graduate Institute",
  },
  {
    label: "KEDGE Business School",
    value: "KEDGE Business School",
  },
  {
    label: "Keele University",
    value: "Keele University",
  },
  {
    label: "Keene State College",
    value: "Keene State College",
  },
  {
    label: "Keiai University",
    value: "Keiai University",
  },
  {
    label: "KEIIN International Institute",
    value: "KEIIN International Institute",
  },
  {
    label: "Keimyung University",
    value: "Keimyung University",
  },
  {
    label: "Keio University",
    value: "Keio University",
  },
  {
    label: "Keisen University",
    value: "Keisen University",
  },
  {
    label: "Keiser University",
    value: "Keiser University",
  },
  {
    label: "Keiser University Latin American Campus",
    value: "Keiser University Latin American Campus",
  },
  {
    label: "Keiwa College",
    value: "Keiwa College",
  },
  {
    label: "Kemerovo State Institute of Culture",
    value: "Kemerovo State Institute of Culture",
  },
  {
    label: "Kemerovo State Medical University",
    value: "Kemerovo State Medical University",
  },
  {
    label: "Kemerovo State University",
    value: "Kemerovo State University",
  },
  {
    label: "Kennesaw State University",
    value: "Kennesaw State University",
  },
  {
    label: "Kenneth Kaunda Metropolitan University",
    value: "Kenneth Kaunda Metropolitan University",
  },
  {
    label: "Kent State University",
    value: "Kent State University",
  },
  {
    label: "Kentucky Christian University",
    value: "Kentucky Christian University",
  },
  {
    label: "Kentucky State University",
    value: "Kentucky State University",
  },
  {
    label: "Kentucky Wesleyan College",
    value: "Kentucky Wesleyan College",
  },
  {
    label: "Kenya Highlands University",
    value: "Kenya Highlands University",
  },
  {
    label: "Kenya Methodist University",
    value: "Kenya Methodist University",
  },
  {
    label: "Kenyatta University",
    value: "Kenyatta University",
  },
  {
    label: "Kenyon College",
    value: "Kenyon College",
  },
  {
    label: "Kerala Agricultural University",
    value: "Kerala Agricultural University",
  },
  {
    label: "Kerala Kalamandalam",
    value: "Kerala Kalamandalam",
  },
  {
    label: "Kerala University of Fisheries and Ocean Studies",
    value: "Kerala University of Fisheries and Ocean Studies",
  },
  {
    label: "Kerala University of Health Sciences",
    value: "Kerala University of Health Sciences",
  },
  {
    label: "Kerala Veterinary and Animal Sciences University",
    value: "Kerala Veterinary and Animal Sciences University",
  },
  {
    label: "Kerch State Marine Technology University",
    value: "Kerch State Marine Technology University",
  },
  {
    label: "Kerman Medical University",
    value: "Kerman Medical University",
  },
  {
    label: "Kermanshah University of Medical Sciences",
    value: "Kermanshah University of Medical Sciences",
  },
  {
    label: "Kermanshah University of Technology",
    value: "Kermanshah University of Technology",
  },
  {
    label: "KES College",
    value: "KES College",
  },
  {
    label: "Kessben College",
    value: "Kessben College",
  },
  {
    label: "Kettering College",
    value: "Kettering College",
  },
  {
    label: "Kettering University",
    value: "Kettering University",
  },
  {
    label: "Keuka College",
    value: "Keuka College",
  },
  {
    label: "Keystone College",
    value: "Keystone College",
  },
  {
    label: "Khabarovsk State University of Economics and Law",
    value: "Khabarovsk State University of Economics and Law",
  },
  {
    label: "Khaje Nasir Toosi University of Technology",
    value: "Khaje Nasir Toosi University of Technology",
  },
  {
    label: "Khakas State University",
    value: "Khakas State University",
  },
  {
    label: "Khalifa University",
    value: "Khalifa University",
  },
  {
    label: "Khana-e-Noor University",
    value: "Khana-e-Noor University",
  },
  {
    label: "Khangai University",
    value: "Khangai University",
  },
  {
    label: "Kharazmi University",
    value: "Kharazmi University",
  },
  {
    label: "Kharkiv Humanitarian University",
    value: "Kharkiv Humanitarian University",
  },
  {
    label: "Kharkiv I. P. Kotlyarevsky National University of Arts",
    value: "Kharkiv I. P. Kotlyarevsky National University of Arts",
  },
  {
    label: "Kharkiv International Medical University",
    value: "Kharkiv International Medical University",
  },
  {
    label: "Kharkiv Medical Academy of Postgraduate Education",
    value: "Kharkiv Medical Academy of Postgraduate Education",
  },
  {
    label: "Kharkiv National Automobile and Highway University",
    value: "Kharkiv National Automobile and Highway University",
  },
  {
    label: "Kharkiv National Medical University",
    value: "Kharkiv National Medical University",
  },
  {
    label: "Kharkiv National University of Internal Affairs",
    value: "Kharkiv National University of Internal Affairs",
  },
  {
    label: "Kharkiv National University of Radioelectronics",
    value: "Kharkiv National University of Radioelectronics",
  },
  {
    label: "Kharkiv State Academy of Culture",
    value: "Kharkiv State Academy of Culture",
  },
  {
    label: "Kharkiv State Academy of Design and Arts",
    value: "Kharkiv State Academy of Design and Arts",
  },
  {
    label: "Kharkiv State Academy of Physical Culture",
    value: "Kharkiv State Academy of Physical Culture",
  },
  {
    label: "Khatam Al Anbia Behbahan University of Technology",
    value: "Khatam Al Anbia Behbahan University of Technology",
  },
  {
    label: "Khatam Al Nabieen University",
    value: "Khatam Al Nabieen University",
  },
  {
    label: "Khavaran Institute of Higher Education",
    value: "Khavaran Institute of Higher Education",
  },
  {
    label: "Khemarak University",
    value: "Khemarak University",
  },
  {
    label: "Kherson National Technical University",
    value: "Kherson National Technical University",
  },
  {
    label: "Kherson State Agrarian and Economic University",
    value: "Kherson State Agrarian and Economic University",
  },
  {
    label: "Kherson State Maritime Academy",
    value: "Kherson State Maritime Academy",
  },
  {
    label: "Kherson State University",
    value: "Kherson State University",
  },
  {
    label: "Khesar Gyalpo University of Medical Sciences of Bhutan",
    value: "Khesar Gyalpo University of Medical Sciences of Bhutan",
  },
  {
    label: "Khmelnytskyi National University",
    value: "Khmelnytskyi National University",
  },
  {
    label: "Khon Kaen University",
    value: "Khon Kaen University",
  },
  {
    label: "Khorog State University",
    value: "Khorog State University",
  },
  {
    label: "Khorramshahr Marine Science and Technology University",
    value: "Khorramshahr Marine Science and Technology University",
  },
  {
    label: "Khovd University",
    value: "Khovd University",
  },
  {
    label: "Khujand State University",
    value: "Khujand State University",
  },
  {
    label: "Khulna Agricultural University",
    value: "Khulna Agricultural University",
  },
  {
    label: "Khulna University",
    value: "Khulna University",
  },
  {
    label: "Khulna University of Engineering and Technology",
    value: "Khulna University of Engineering and Technology",
  },
  {
    label: "Khurasan University",
    value: "Khurasan University",
  },
  {
    label: "Khurshid Institute of Higher Education",
    value: "Khurshid Institute of Higher Education",
  },
  {
    label: "Khushal Khan Khattak University",
    value: "Khushal Khan Khattak University",
  },
  {
    label: "Khuzestan Agricultural Sciences and Natural Resources University",
    value: "Khuzestan Agricultural Sciences and Natural Resources University",
  },
  {
    label: "Khwaja Fareed University of Engineering & Information Technology",
    value: "Khwaja Fareed University of Engineering & Information Technology",
  },
  {
    label: "Khwaja Moinuddin Chishti Language University",
    value: "Khwaja Moinuddin Chishti Language University",
  },
  {
    label: "Khwaja Yunus Ali University",
    value: "Khwaja Yunus Ali University",
  },
  {
    label: "Khyber Medical University",
    value: "Khyber Medical University",
  },
  {
    label: "Kiang Wu Nursing College of Macau",
    value: "Kiang Wu Nursing College of Macau",
  },
  {
    label: "Kibabii University",
    value: "Kibabii University",
  },
  {
    label: "Kibi International University",
    value: "Kibi International University",
  },
  {
    label: "Kibogora Polytechnic",
    value: "Kibogora Polytechnic",
  },
  {
    label: "Kibris Amerikan Üniversitesi",
    value: "Kibris Amerikan Üniversitesi",
  },
  {
    label: "Kibris Bati Üniversitesi",
    value: "Kibris Bati Üniversitesi",
  },
  {
    label: "Kibris Ilim Üniversitesi",
    value: "Kibris Ilim Üniversitesi",
  },
  {
    label: "Kibris Saglik ve Toplum Bilimleri Üniversitesi",
    value: "Kibris Saglik ve Toplum Bilimleri Üniversitesi",
  },
  {
    label: "Kiev College of Civil Engineering, Architecture and Design",
    value: "Kiev College of Civil Engineering, Architecture and Design",
  },
  {
    label: "KIIT University",
    value: "KIIT University",
  },
  {
    label: "Kilis 7 Aralik Üniversitesi",
    value: "Kilis 7 Aralik Üniversitesi",
  },
  {
    label: "Kim Chaek University of Technology",
    value: "Kim Chaek University of Technology",
  },
  {
    label: "Kim Chol Ju University of Education",
    value: "Kim Chol Ju University of Education",
  },
  {
    label: "Kim Hyong Jik University of Education",
    value: "Kim Hyong Jik University of Education",
  },
  {
    label: "Kim Il Sung University",
    value: "Kim Il Sung University",
  },
  {
    label: "Kim Won Gyun Pyongyang Conservatory",
    value: "Kim Won Gyun Pyongyang Conservatory",
  },
  {
    label: "KIMEP University",
    value: "KIMEP University",
  },
  {
    label: "Kindai University",
    value: "Kindai University",
  },
  {
    label: "King AbdulAziz University",
    value: "King AbdulAziz University",
  },
  {
    label: "King Abdullah University of Science and Technology",
    value: "King Abdullah University of Science and Technology",
  },
  {
    label: "King Ceasor University",
    value: "King Ceasor University",
  },
  {
    label: "King Danylo University",
    value: "King Danylo University",
  },
  {
    label: "King Edward Medical University",
    value: "King Edward Medical University",
  },
  {
    label: "King Fahd University of Petroleum and Minerals",
    value: "King Fahd University of Petroleum and Minerals",
  },
  {
    label: "King Faisal University",
    value: "King Faisal University",
  },
  {
    label: "King George's Medical University",
    value: "King George's Medical University",
  },
  {
    label: "King Khalid University",
    value: "King Khalid University",
  },
  {
    label: "King Mongkut's Institute of Technology Ladkrabang",
    value: "King Mongkut's Institute of Technology Ladkrabang",
  },
  {
    label: "King Mongkut's University of Technology North Bangkok",
    value: "King Mongkut's University of Technology North Bangkok",
  },
  {
    label: "King Mongkut's University of Technology Thonburi",
    value: "King Mongkut's University of Technology Thonburi",
  },
  {
    label: "King Salman International University",
    value: "King Salman International University",
  },
  {
    label: "King Saud bin Abdulaziz University for Health Sciences",
    value: "King Saud bin Abdulaziz University for Health Sciences",
  },
  {
    label: "King Saud University",
    value: "King Saud University",
  },
  {
    label: "King University",
    value: "King University",
  },
  {
    label: "Kingdom University",
    value: "Kingdom University",
  },
  {
    label: "King's College",
    value: "King's College",
  },
  {
    label: "King's College London",
    value: "King's College London",
  },
  {
    label: "Kings University",
    value: "Kings University",
  },
  {
    label: "Kings University College",
    value: "Kings University College",
  },
  {
    label: "Kingsley Ozumba Mbadiwe University",
    value: "Kingsley Ozumba Mbadiwe University",
  },
  {
    label: "Kingston University",
    value: "Kingston University",
  },
  {
    label: "Kingswood University",
    value: "Kingswood University",
  },
  {
    label: "Kinjo Gakuin University",
    value: "Kinjo Gakuin University",
  },
  {
    label: "Kinjo University",
    value: "Kinjo University",
  },
  {
    label: "Kinnaird College for Women",
    value: "Kinnaird College for Women",
  },
  {
    label: "Kinneret Academic College",
    value: "Kinneret Academic College",
  },
  {
    label: "Kio University",
    value: "Kio University",
  },
  {
    label: "Kirchliche Hochschule Wuppertal",
    value: "Kirchliche Hochschule Wuppertal",
  },
  {
    label: "Kirchliche Pädagogische Hochschule Edith Stein",
    value: "Kirchliche Pädagogische Hochschule Edith Stein",
  },
  {
    label: "Kirchliche Pädagogische Hochschule Wien/Krems",
    value: "Kirchliche Pädagogische Hochschule Wien/Krems",
  },
  {
    label: "Kirgizistan-Türkiye Manas Üniversitesi",
    value: "Kirgizistan-Türkiye Manas Üniversitesi",
  },
  {
    label: "Kirikkale Üniversitesi",
    value: "Kirikkale Üniversitesi",
  },
  {
    label: "Kirinyaga University",
    value: "Kirinyaga University",
  },
  {
    label: "Kiriri Women's University of Science and Technology",
    value: "Kiriri Women's University of Science and Technology",
  },
  {
    label: "Kirklareli Üniversitesi",
    value: "Kirklareli Üniversitesi",
  },
  {
    label: "Kirov State Medical University",
    value: "Kirov State Medical University",
  },
  {
    label: "Kirovohrad National Technical University",
    value: "Kirovohrad National Technical University",
  },
  {
    label: "Kiryu University",
    value: "Kiryu University",
  },
  {
    label: "Kisii University",
    value: "Kisii University",
  },
  {
    label: "Kitami Institute of Technology",
    value: "Kitami Institute of Technology",
  },
  {
    label: "Kitasato University",
    value: "Kitasato University",
  },
  {
    label: "Kkottongnae University",
    value: "Kkottongnae University",
  },
  {
    label: "Klaipedos Universitetas",
    value: "Klaipedos Universitetas",
  },
  {
    label: "Klaipedos valstybine kolegija",
    value: "Klaipedos valstybine kolegija",
  },
  {
    label: "KLE Technological University",
    value: "KLE Technological University",
  },
  {
    label: "KLE University",
    value: "KLE University",
  },
  {
    label: "Knowledge and Modern Science University",
    value: "Knowledge and Modern Science University",
  },
  {
    label: "Knowledge University",
    value: "Knowledge University",
  },
  {
    label: "Knox College",
    value: "Knox College",
  },
  {
    label: "Knutsford University College",
    value: "Knutsford University College",
  },
  {
    label: "Kobe City College of Nursing",
    value: "Kobe City College of Nursing",
  },
  {
    label: "Kobe City University of Foreign Studies",
    value: "Kobe City University of Foreign Studies",
  },
  {
    label: "Kobe College",
    value: "Kobe College",
  },
  {
    label: "Kobe Design University",
    value: "Kobe Design University",
  },
  {
    label: "Kobe Gakuin University",
    value: "Kobe Gakuin University",
  },
  {
    label: "Kobe Institute of Computing",
    value: "Kobe Institute of Computing",
  },
  {
    label: "Kobe International University",
    value: "Kobe International University",
  },
  {
    label: "Kobe Kaisei College",
    value: "Kobe Kaisei College",
  },
  {
    label: "Kobe Pharmaceutical University",
    value: "Kobe Pharmaceutical University",
  },
  {
    label: "Kobe Shinwa Women's University",
    value: "Kobe Shinwa Women's University",
  },
  {
    label: "Kobe Shoin Women's University",
    value: "Kobe Shoin Women's University",
  },
  {
    label: "Kobe Tokiwa University",
    value: "Kobe Tokiwa University",
  },
  {
    label: "Kobe University",
    value: "Kobe University",
  },
  {
    label: "Kobe University of Future Health Sciences",
    value: "Kobe University of Future Health Sciences",
  },
  {
    label: "Kobe Women's University",
    value: "Kobe Women's University",
  },
  {
    label: "Københavns Erhvervsakademi",
    value: "Københavns Erhvervsakademi",
  },
  {
    label: "Københavns Universitet",
    value: "Københavns Universitet",
  },
  {
    label: "Koç Üniversitesi",
    value: "Koç Üniversitesi",
  },
  {
    label: "Kocaeli Üniversitesi",
    value: "Kocaeli Üniversitesi",
  },
  {
    label: "Kochi Gakuen University",
    value: "Kochi Gakuen University",
  },
  {
    label: "Kochi University",
    value: "Kochi University",
  },
  {
    label: "Kochi University of Technology",
    value: "Kochi University of Technology",
  },
  {
    label: "Kodolányi János Egyetem",
    value: "Kodolányi János Egyetem",
  },
  {
    label: "Koforidua Technical University",
    value: "Koforidua Technical University",
  },
  {
    label: "Kogakkan University",
    value: "Kogakkan University",
  },
  {
    label: "Kogakuin University",
    value: "Kogakuin University",
  },
  {
    label: "Kogi State University",
    value: "Kogi State University",
  },
  {
    label: "Kohat University of Science and Technology",
    value: "Kohat University of Science and Technology",
  },
  {
    label: "Kokshetau State University",
    value: "Kokshetau State University",
  },
  {
    label: "Kokshetau University named after A. Myrzakhmetov",
    value: "Kokshetau University named after A. Myrzakhmetov",
  },
  {
    label: "Kokugakuin University",
    value: "Kokugakuin University",
  },
  {
    label: "Kokushikan University",
    value: "Kokushikan University",
  },
  {
    label: "Kola Daisi University",
    value: "Kola Daisi University",
  },
  {
    label: "Kolegji Universitar Bedër",
    value: "Kolegji Universitar Bedër",
  },
  {
    label: "Kolegji Universitar i Biznesit",
    value: "Kolegji Universitar i Biznesit",
  },
  {
    label: "Kolegji Universitar Instituti Kanadez i Teknologjisë",
    value: "Kolegji Universitar Instituti Kanadez i Teknologjisë",
  },
  {
    label: "Kolegji Universitar Logos",
    value: "Kolegji Universitar Logos",
  },
  {
    label: "Kolegji Universitar Pavarësia Vlorë",
    value: "Kolegji Universitar Pavarësia Vlorë",
  },
  {
    label: "Kolegji Universitar Qiriazi",
    value: "Kolegji Universitar Qiriazi",
  },
  {
    label: "Kolegji Universitar Reald",
    value: "Kolegji Universitar Reald",
  },
  {
    label: "Kolegji Universitar Wisdom",
    value: "Kolegji Universitar Wisdom",
  },
  {
    label: "Kolhan University",
    value: "Kolhan University",
  },
  {
    label: "Kölner Hochschule für Katholische Theologie",
    value: "Kölner Hochschule für Katholische Theologie",
  },
  {
    label: "Kolpingo kolegija",
    value: "Kolpingo kolegija",
  },
  {
    label: "Komar University of Science and Technology",
    value: "Komar University of Science and Technology",
  },
  {
    label: "Komatsu University",
    value: "Komatsu University",
  },
  {
    label: "Komazawa University",
    value: "Komazawa University",
  },
  {
    label: "Komazawa Women's University",
    value: "Komazawa Women's University",
  },
  {
    label: "Komsomolsk-on-Amur State Technical University",
    value: "Komsomolsk-on-Amur State Technical University",
  },
  {
    label: "Komunikološki koledž u Banjaluci Kapa Fi",
    value: "Komunikološki koledž u Banjaluci Kapa Fi",
  },
  {
    label: "Konan University",
    value: "Konan University",
  },
  {
    label: "Konan Women's University",
    value: "Konan Women's University",
  },
  {
    label: "Kongju National University",
    value: "Kongju National University",
  },
  {
    label: "Koninklijke Academie van Beeldende Kunsten",
    value: "Koninklijke Academie van Beeldende Kunsten",
  },
  {
    label: "Konkuk University",
    value: "Konkuk University",
  },
  {
    label: "Konstantin Preslavsky University of Shumen",
    value: "Konstantin Preslavsky University of Shumen",
  },
  {
    label: "Konstfack",
    value: "Konstfack",
  },
  {
    label: "Konya Gida ve Tarim Üniversitesi",
    value: "Konya Gida ve Tarim Üniversitesi",
  },
  {
    label: "Konyang University",
    value: "Konyang University",
  },
  {
    label: "Kookmin University",
    value: "Kookmin University",
  },
  {
    label: "Korea Aerospace University",
    value: "Korea Aerospace University",
  },
  {
    label: "Korea Baptist Theological University",
    value: "Korea Baptist Theological University",
  },
  {
    label: "Korea Maritime and Ocean University",
    value: "Korea Maritime and Ocean University",
  },
  {
    label: "Korea National Sport University",
    value: "Korea National Sport University",
  },
  {
    label: "Korea National University of Education",
    value: "Korea National University of Education",
  },
  {
    label: "Korea National University of Transportation",
    value: "Korea National University of Transportation",
  },
  {
    label: "Korea Nazarene University",
    value: "Korea Nazarene University",
  },
  {
    label: "Korea University",
    value: "Korea University",
  },
  {
    label: "Korea University of Technology and Education",
    value: "Korea University of Technology and Education",
  },
  {
    label: "Korea University, Japan",
    value: "Korea University, Japan",
  },
  {
    label: "Korean Bible University",
    value: "Korean Bible University",
  },
  {
    label: "Korean Institute of Central Asia",
    value: "Korean Institute of Central Asia",
  },
  {
    label: "Korean National University of Arts",
    value: "Korean National University of Arts",
  },
  {
    label: "Kõrgem Kunstikool Pallas",
    value: "Kõrgem Kunstikool Pallas",
  },
  {
    label: "Koriyama Women's University",
    value: "Koriyama Women's University",
  },
  {
    label: "Koryo Songgyungwan University",
    value: "Koryo Songgyungwan University",
  },
  {
    label: "Kosar University of Bojnord",
    value: "Kosar University of Bojnord",
  },
  {
    label: "Koshien University",
    value: "Koshien University",
  },
  {
    label: "Kosin University",
    value: "Kosin University",
  },
  {
    label: "Kostanay Engineering-Pedagogical University",
    value: "Kostanay Engineering-Pedagogical University",
  },
  {
    label: "Kostanay Social-Technical University",
    value: "Kostanay Social-Technical University",
  },
  {
    label: "Kostanay State University",
    value: "Kostanay State University",
  },
  {
    label: "Kostroma State University",
    value: "Kostroma State University",
  },
  {
    label: "Koya University",
    value: "Koya University",
  },
  {
    label: "Koyasan University",
    value: "Koyasan University",
  },
  {
    label: "Közép-Európai Egyetem",
    value: "Közép-Európai Egyetem",
  },
  {
    label: "Krantiguru Shyamji Krishna Verma Kachchh University",
    value: "Krantiguru Shyamji Krishna Verma Kachchh University",
  },
  {
    label: "Krasnoyarsk State Agricultural University",
    value: "Krasnoyarsk State Agricultural University",
  },
  {
    label: "Krasnoyarsk State Medical University",
    value: "Krasnoyarsk State Medical University",
  },
  {
    label: "Krasnoyarsk State Pedagogical University",
    value: "Krasnoyarsk State Pedagogical University",
  },
  {
    label: "Krastyo Sarafov National Academy for Theatre and Film Arts",
    value: "Krastyo Sarafov National Academy for Theatre and Film Arts",
  },
  {
    label: "Kremenchuk Mykhailo Ostrohradskyi National University",
    value: "Kremenchuk Mykhailo Ostrohradskyi National University",
  },
  {
    label: "Krirk University",
    value: "Krirk University",
  },
  {
    label: "Krishna University",
    value: "Krishna University",
  },
  {
    label: "Krishna Vishwa Vidyapeeth",
    value: "Krishna Vishwa Vidyapeeth",
  },
  {
    label: "KROK University",
    value: "KROK University",
  },
  {
    label: "Kryvyi Rih National University",
    value: "Kryvyi Rih National University",
  },
  {
    label: "Kryvyi Rih State Pedagogical University",
    value: "Kryvyi Rih State Pedagogical University",
  },
  {
    label: "KSGH Music and Performing Arts University",
    value: "KSGH Music and Performing Arts University",
  },
  {
    label: "KTO Karatay Üniversitesi",
    value: "KTO Karatay Üniversitesi",
  },
  {
    label: "Kuban State Agricultural University",
    value: "Kuban State Agricultural University",
  },
  {
    label: "Kuban State Medical University",
    value: "Kuban State Medical University",
  },
  {
    label: "Kuban State University",
    value: "Kuban State University",
  },
  {
    label: "Kuban State University of Physical Culture, Sport and Tourism",
    value: "Kuban State University of Physical Culture, Sport and Tourism",
  },
  {
    label: "Kuban State University of Technology",
    value: "Kuban State University of Technology",
  },
  {
    label: "Kühne Logistics University",
    value: "Kühne Logistics University",
  },
  {
    label: "Kulob State University",
    value: "Kulob State University",
  },
  {
    label: "Kumamoto Gakuen University",
    value: "Kumamoto Gakuen University",
  },
  {
    label: "Kumamoto Health Science University",
    value: "Kumamoto Health Science University",
  },
  {
    label: "Kumamoto University",
    value: "Kumamoto University",
  },
  {
    label: "Kumar Bhaskar Varma Sanskrit and Ancient Studies University",
    value: "Kumar Bhaskar Varma Sanskrit and Ancient Studies University",
  },
  {
    label: "Kumasi Technical University",
    value: "Kumasi Technical University",
  },
  {
    label: "Kumaun University",
    value: "Kumaun University",
  },
  {
    label: "Kumi University",
    value: "Kumi University",
  },
  {
    label: "Kumoh National University of Technology",
    value: "Kumoh National University of Technology",
  },
  {
    label: "Kun Shan University",
    value: "Kun Shan University",
  },
  {
    label: "Kunduz University",
    value: "Kunduz University",
  },
  {
    label: "Kungliga Konsthögskolan",
    value: "Kungliga Konsthögskolan",
  },
  {
    label: "Kungliga Musikhögskolan i Stockholm",
    value: "Kungliga Musikhögskolan i Stockholm",
  },
  {
    label: "Kungliga Tekniska högskolan",
    value: "Kungliga Tekniska högskolan",
  },
  {
    label: "Kunitachi College of Music",
    value: "Kunitachi College of Music",
  },
  {
    label: "Kunming Medical University",
    value: "Kunming Medical University",
  },
  {
    label: "Kunming University",
    value: "Kunming University",
  },
  {
    label: "Kunming University of Science and Technology",
    value: "Kunming University of Science and Technology",
  },
  {
    label: "Kunsan National University",
    value: "Kunsan National University",
  },
  {
    label: "Kunstakademie Düsseldorf",
    value: "Kunstakademie Düsseldorf",
  },
  {
    label: "Kunstakademie Münster",
    value: "Kunstakademie Münster",
  },
  {
    label: "Kunsthochschule für Medien Köln",
    value: "Kunsthochschule für Medien Köln",
  },
  {
    label: "Kunsthøgskolen i Oslo",
    value: "Kunsthøgskolen i Oslo",
  },
  {
    label: "Kurashiki Sakuyo University",
    value: "Kurashiki Sakuyo University",
  },
  {
    label: "Kurashiki University of Science and the Arts",
    value: "Kurashiki University of Science and the Arts",
  },
  {
    label:
      "Kurdistan Institution for Strategic Studies and Scientific Research",
    value:
      "Kurdistan Institution for Strategic Studies and Scientific Research",
  },
  {
    label: "Kurdistan University of Medical Sciences",
    value: "Kurdistan University of Medical Sciences",
  },
  {
    label: "Kurgan State University",
    value: "Kurgan State University",
  },
  {
    label: "Kursk State Medical University",
    value: "Kursk State Medical University",
  },
  {
    label: "Kursk State University",
    value: "Kursk State University",
  },
  {
    label: "Kurukshetra University",
    value: "Kurukshetra University",
  },
  {
    label: "Kurume Institute of Technology",
    value: "Kurume Institute of Technology",
  },
  {
    label: "Kurume University",
    value: "Kurume University",
  },
  {
    label: "Kushabhau Thakre Patrakarita Avam Jansanchar University",
    value: "Kushabhau Thakre Patrakarita Avam Jansanchar University",
  },
  {
    label: "Kushiro Public University of Economics",
    value: "Kushiro Public University of Economics",
  },
  {
    label: "Kutafin Moscow State Law University",
    value: "Kutafin Moscow State Law University",
  },
  {
    label: "Kütahya Dumlupinar Üniversitesi",
    value: "Kütahya Dumlupinar Üniversitesi",
  },
  {
    label: "Kutaisi University",
    value: "Kutaisi University",
  },
  {
    label: "Kutztown University of Pennsylvania",
    value: "Kutztown University of Pennsylvania",
  },
  {
    label: "Kuvempu University",
    value: "Kuvempu University",
  },
  {
    label: "Kuwait International University",
    value: "Kuwait International University",
  },
  {
    label: "Kuwait University",
    value: "Kuwait University",
  },
  {
    label: "Kuyper College",
    value: "Kuyper College",
  },
  {
    label: "Kuzbass State Technical University",
    value: "Kuzbass State Technical University",
  },
  {
    label: "Kwame Nkrumah University",
    value: "Kwame Nkrumah University",
  },
  {
    label: "Kwame Nkrumah University of Science and Technology",
    value: "Kwame Nkrumah University of Science and Technology",
  },
  {
    label: "Kwangju Women's University",
    value: "Kwangju Women's University",
  },
  {
    label: "Kwangshin University",
    value: "Kwangshin University",
  },
  {
    label: "Kwangwoon University",
    value: "Kwangwoon University",
  },
  {
    label: "Kwansei Gakuin University",
    value: "Kwansei Gakuin University",
  },
  {
    label: "Kwantlen Polytechnic University",
    value: "Kwantlen Polytechnic University",
  },
  {
    label: "Kwara State University",
    value: "Kwara State University",
  },
  {
    label: "Kwararafa University, Wukari",
    value: "Kwararafa University, Wukari",
  },
  {
    label: "Kwassui Women's University",
    value: "Kwassui Women's University",
  },
  {
    label: "Kyaing Tong University",
    value: "Kyaing Tong University",
  },
  {
    label: "Kyambogo University",
    value: "Kyambogo University",
  },
  {
    label: "Kyaukse Technological University",
    value: "Kyaukse Technological University",
  },
  {
    label: "Kyaukse University",
    value: "Kyaukse University",
  },
  {
    label: "Kyiv Medical University",
    value: "Kyiv Medical University",
  },
  {
    label: "Kyiv National Economic University",
    value: "Kyiv National Economic University",
  },
  {
    label: "Kyiv National Linguistic University",
    value: "Kyiv National Linguistic University",
  },
  {
    label: "Kyiv National University of Construction and Architecture",
    value: "Kyiv National University of Construction and Architecture",
  },
  {
    label: "Kyiv National University of Culture and Arts",
    value: "Kyiv National University of Culture and Arts",
  },
  {
    label: "Kyiv National University of Technologies and Design",
    value: "Kyiv National University of Technologies and Design",
  },
  {
    label: "Kyiv National University of Theatre, Cinema and Television",
    value: "Kyiv National University of Theatre, Cinema and Television",
  },
  {
    label: "Kyiv National University of Trade and Economics",
    value: "Kyiv National University of Trade and Economics",
  },
  {
    label:
      "Kyiv University of Law of the National Academy of Sciences of Ukraine",
    value:
      "Kyiv University of Law of the National Academy of Sciences of Ukraine",
  },
  {
    label: "Kyoai Gakuen University",
    value: "Kyoai Gakuen University",
  },
  {
    label: "Kyoei University",
    value: "Kyoei University",
  },
  {
    label: "Kyonggi University",
    value: "Kyonggi University",
  },
  {
    label: "Kyorin University",
    value: "Kyorin University",
  },
  {
    label: "Kyoritsu Women's University",
    value: "Kyoritsu Women's University",
  },
  {
    label: "Kyoto Arts and Crafts University",
    value: "Kyoto Arts and Crafts University",
  },
  {
    label: "Kyoto Bunkyo University",
    value: "Kyoto Bunkyo University",
  },
  {
    label: "Kyoto City University of Arts",
    value: "Kyoto City University of Arts",
  },
  {
    label: "Kyoto College of Graduate Studies for Informatics",
    value: "Kyoto College of Graduate Studies for Informatics",
  },
  {
    label: "Kyoto College of Medical Science",
    value: "Kyoto College of Medical Science",
  },
  {
    label: "Kyoto College of Nursing",
    value: "Kyoto College of Nursing",
  },
  {
    label: "Kyoto Institute of Technology",
    value: "Kyoto Institute of Technology",
  },
  {
    label: "Kyoto Kacho University",
    value: "Kyoto Kacho University",
  },
  {
    label: "Kyoto Koka Women's University",
    value: "Kyoto Koka Women's University",
  },
  {
    label: "Kyoto Notre Dame University",
    value: "Kyoto Notre Dame University",
  },
  {
    label: "Kyoto Pharmaceutical University",
    value: "Kyoto Pharmaceutical University",
  },
  {
    label: "Kyoto Prefectural University",
    value: "Kyoto Prefectural University",
  },
  {
    label: "Kyoto Prefectural University of Medicine",
    value: "Kyoto Prefectural University of Medicine",
  },
  {
    label: "Kyoto Saga University of Arts",
    value: "Kyoto Saga University of Arts",
  },
  {
    label: "Kyoto Sangyo University",
    value: "Kyoto Sangyo University",
  },
  {
    label: "Kyoto Seika University",
    value: "Kyoto Seika University",
  },
  {
    label: "Kyoto Tachibana University",
    value: "Kyoto Tachibana University",
  },
  {
    label: "Kyoto University",
    value: "Kyoto University",
  },
  {
    label: "Kyoto University of Advanced Science",
    value: "Kyoto University of Advanced Science",
  },
  {
    label: "Kyoto University of Education",
    value: "Kyoto University of Education",
  },
  {
    label: "Kyoto University of Foreign Studies",
    value: "Kyoto University of Foreign Studies",
  },
  {
    label: "Kyoto University of the Arts",
    value: "Kyoto University of the Arts",
  },
  {
    label: "Kyoto Women's University",
    value: "Kyoto Women's University",
  },
  {
    label: "Kyrgyz Aviation Institute",
    value: "Kyrgyz Aviation Institute",
  },
  {
    label: "Kyrgyz Economic University",
    value: "Kyrgyz Economic University",
  },
  {
    label: "Kyrgyz Institute of Languages ??and Culture",
    value: "Kyrgyz Institute of Languages ??and Culture",
  },
  {
    label: "Kyrgyz International University NRZ",
    value: "Kyrgyz International University NRZ",
  },
  {
    label: "Kyrgyz Medical and Dental Institute",
    value: "Kyrgyz Medical and Dental Institute",
  },
  {
    label: "Kyrgyz National Agrarian University",
    value: "Kyrgyz National Agrarian University",
  },
  {
    label: "Kyrgyz National Conservatory",
    value: "Kyrgyz National Conservatory",
  },
  {
    label: "Kyrgyz National University named after J. Balasagyn",
    value: "Kyrgyz National University named after J. Balasagyn",
  },
  {
    label: "Kyrgyz Russian Slavic University",
    value: "Kyrgyz Russian Slavic University",
  },
  {
    label: "Kyrgyz State Academy of Physical Culture and Sports",
    value: "Kyrgyz State Academy of Physical Culture and Sports",
  },
  {
    label: "Kyrgyz State Law University",
    value: "Kyrgyz State Law University",
  },
  {
    label: "Kyrgyz State Medical Academy",
    value: "Kyrgyz State Medical Academy",
  },
  {
    label: "Kyrgyz State Technical University named after I. Razzakov",
    value: "Kyrgyz State Technical University named after I. Razzakov",
  },
  {
    label: "Kyrgyz State University named after I. Arabayev",
    value: "Kyrgyz State University named after I. Arabayev",
  },
  {
    label:
      "Kyrgyz State University of Construction, Transportation and Architecture",
    value:
      "Kyrgyz State University of Construction, Transportation and Architecture",
  },
  {
    label: "Kyrgyz State University of Culture and Arts",
    value: "Kyrgyz State University of Culture and Arts",
  },
  {
    label: "Kyrgyz-German Institute for Applied Informatics",
    value: "Kyrgyz-German Institute for Applied Informatics",
  },
  {
    label: "Kyrgyz-Kazakh University",
    value: "Kyrgyz-Kazakh University",
  },
  {
    label: "Kyrgyz-Russian Academy of Education",
    value: "Kyrgyz-Russian Academy of Education",
  },
  {
    label: "Kyrgyz-Uzbek International University",
    value: "Kyrgyz-Uzbek International University",
  },
  {
    label: "Kyung Hee University",
    value: "Kyung Hee University",
  },
  {
    label: "Kyungdong University",
    value: "Kyungdong University",
  },
  {
    label: "Kyungil University",
    value: "Kyungil University",
  },
  {
    label: "Kyungnam University",
    value: "Kyungnam University",
  },
  {
    label: "Kyungpook National University",
    value: "Kyungpook National University",
  },
  {
    label: "Kyungsung University",
    value: "Kyungsung University",
  },
  {
    label: "Kyungwoon University",
    value: "Kyungwoon University",
  },
  {
    label: "Kyushu Dental University",
    value: "Kyushu Dental University",
  },
  {
    label: "Kyushu Institute of Information Sciences",
    value: "Kyushu Institute of Information Sciences",
  },
  {
    label: "Kyushu Institute of Technology",
    value: "Kyushu Institute of Technology",
  },
  {
    label: "Kyushu International University",
    value: "Kyushu International University",
  },
  {
    label: "Kyushu Kyoritsu University",
    value: "Kyushu Kyoritsu University",
  },
  {
    label: "Kyushu Lutheran College",
    value: "Kyushu Lutheran College",
  },
  {
    label: "Kyushu Nutrition Welfare University",
    value: "Kyushu Nutrition Welfare University",
  },
  {
    label: "Kyushu Sangyo University",
    value: "Kyushu Sangyo University",
  },
  {
    label: "Kyushu University",
    value: "Kyushu University",
  },
  {
    label: "Kyushu University of Health and Welfare",
    value: "Kyushu University of Health and Welfare",
  },
  {
    label: "Kyushu University of Nursing and Social Welfare",
    value: "Kyushu University of Nursing and Social Welfare",
  },
  {
    label: "Kyushu Women's University",
    value: "Kyushu Women's University",
  },
  {
    label: "Kyzylorda State University",
    value: "Kyzylorda State University",
  },
  {
    label: "L.B. Goncharov Kazakh Road Academy",
    value: "L.B. Goncharov Kazakh Road Academy",
  },
  {
    label: "L.N. Gumilyov Eurasian National University",
    value: "L.N. Gumilyov Eurasian National University",
  },
  {
    label: "La American University",
    value: "La American University",
  },
  {
    label: "La Consolacion College",
    value: "La Consolacion College",
  },
  {
    label: "La Consolacion College Manila",
    value: "La Consolacion College Manila",
  },
  {
    label: "La Consolacion University Philippines",
    value: "La Consolacion University Philippines",
  },
  {
    label: "La Roche University",
    value: "La Roche University",
  },
  {
    label: "La Rochelle Université",
    value: "La Rochelle Université",
  },
  {
    label: "La Salle University",
    value: "La Salle University",
  },
  {
    label: "La Salle University, Ozamiz City",
    value: "La Salle University, Ozamiz City",
  },
  {
    label: "La Sierra University",
    value: "La Sierra University",
  },
  {
    label: "La Trobe University",
    value: "La Trobe University",
  },
  {
    label: "LAB University of Applied Sciences",
    value: "LAB University of Applied Sciences",
  },
  {
    label: "Labouré College",
    value: "Labouré College",
  },
  {
    label: "Lac Hong University",
    value: "Lac Hong University",
  },
  {
    label: "Ladoke Akintola University of Technology",
    value: "Ladoke Akintola University of Technology",
  },
  {
    label: "Lafayette College",
    value: "Lafayette College",
  },
  {
    label: "Laghman University",
    value: "Laghman University",
  },
  {
    label: "Lagos State University",
    value: "Lagos State University",
  },
  {
    label: "LaGrange College",
    value: "LaGrange College",
  },
  {
    label: "Laguna College of Art and Design",
    value: "Laguna College of Art and Design",
  },
  {
    label: "Laguna State Polytechnic University",
    value: "Laguna State Polytechnic University",
  },
  {
    label: "Lahore College for Women University",
    value: "Lahore College for Women University",
  },
  {
    label: "Lahore Garrison University",
    value: "Lahore Garrison University",
  },
  {
    label: "Lahore Leads University",
    value: "Lahore Leads University",
  },
  {
    label: "Lahore School of Economics",
    value: "Lahore School of Economics",
  },
  {
    label: "Lahore University of Management Sciences",
    value: "Lahore University of Management Sciences",
  },
  {
    label: "Laikipia University",
    value: "Laikipia University",
  },
  {
    label: "Lake Erie College",
    value: "Lake Erie College",
  },
  {
    label: "Lake Forest College",
    value: "Lake Forest College",
  },
  {
    label: "Lake Forest Graduate School of Management",
    value: "Lake Forest Graduate School of Management",
  },
  {
    label: "Lake Malawi Anglican University",
    value: "Lake Malawi Anglican University",
  },
  {
    label: "Lake Superior State University",
    value: "Lake Superior State University",
  },
  {
    label: "Lake Washington Institute of Technology",
    value: "Lake Washington Institute of Technology",
  },
  {
    label: "Lakehead University",
    value: "Lakehead University",
  },
  {
    label: "Lakeland University",
    value: "Lakeland University",
  },
  {
    label: "Lakeview College of Nursing",
    value: "Lakeview College of Nursing",
  },
  {
    label: "Lakshmibai National Institute of Physical Education",
    value: "Lakshmibai National Institute of Physical Education",
  },
  {
    label: "Lakulish Yoga University",
    value: "Lakulish Yoga University",
  },
  {
    label: "Lala Lajpat Rai University of Veterinary and Animal Sciences",
    value: "Lala Lajpat Rai University of Veterinary and Animal Sciences",
  },
  {
    label: "Lalit Narayan Mithila University",
    value: "Lalit Narayan Mithila University",
  },
  {
    label: "Lamar University",
    value: "Lamar University",
  },
  {
    label: "Lampang Rajabhat University",
    value: "Lampang Rajabhat University",
  },
  {
    label: "Lan Yang Institute of Technology",
    value: "Lan Yang Institute of Technology",
  },
  {
    label: "Lancaster Bible College",
    value: "Lancaster Bible College",
  },
  {
    label: "Lancaster University",
    value: "Lancaster University",
  },
  {
    label: "Lancaster University, Ghana",
    value: "Lancaster University, Ghana",
  },
  {
    label: "Lander University",
    value: "Lander University",
  },
  {
    label: "Landmark College",
    value: "Landmark College",
  },
  {
    label: "Landmark University",
    value: "Landmark University",
  },
  {
    label: "Lane College",
    value: "Lane College",
  },
  {
    label: "Langfang Teachers University",
    value: "Langfang Teachers University",
  },
  {
    label: "Langston University",
    value: "Langston University",
  },
  {
    label: "Language and Civilisation Institute",
    value: "Language and Civilisation Institute",
  },
  {
    label: "Lanzhou City University",
    value: "Lanzhou City University",
  },
  {
    label: "Lanzhou Institute of Technology",
    value: "Lanzhou Institute of Technology",
  },
  {
    label: "Lanzhou Jiaotong University",
    value: "Lanzhou Jiaotong University",
  },
  {
    label: "Lanzhou University",
    value: "Lanzhou University",
  },
  {
    label: "Lanzhou University of Arts and Science",
    value: "Lanzhou University of Arts and Science",
  },
  {
    label: "Lanzhou University of Finance and Economics",
    value: "Lanzhou University of Finance and Economics",
  },
  {
    label: "Lanzhou University of Technology",
    value: "Lanzhou University of Technology",
  },
  {
    label: "Lapin Ammattikorkeakoulu",
    value: "Lapin Ammattikorkeakoulu",
  },
  {
    label: "Lapin yliopisto",
    value: "Lapin yliopisto",
  },
  {
    label: "Lappeenrannan teknillinen yliopisto",
    value: "Lappeenrannan teknillinen yliopisto",
  },
  {
    label: "Larnaca College",
    value: "Larnaca College",
  },
  {
    label: "LASALLE College of the Arts",
    value: "LASALLE College of the Arts",
  },
  {
    label: "Lasbela University of Agriculture, Water and Marine Sciences",
    value: "Lasbela University of Agriculture, Water and Marine Sciences",
  },
  {
    label: "Lasell University",
    value: "Lasell University",
  },
  {
    label: "Lashio University",
    value: "Lashio University",
  },
  {
    label: "Latvijas Biozinatnu un tehnologiju universitate",
    value: "Latvijas Biozinatnu un tehnologiju universitate",
  },
  {
    label: "Latvijas Kulturas akademija",
    value: "Latvijas Kulturas akademija",
  },
  {
    label: "Latvijas Makslas akademija",
    value: "Latvijas Makslas akademija",
  },
  {
    label: "Latvijas Sporta pedagogijas akademija",
    value: "Latvijas Sporta pedagogijas akademija",
  },
  {
    label: "Latvijas Universitate",
    value: "Latvijas Universitate",
  },
  {
    label: "Lauder Business School",
    value: "Lauder Business School",
  },
  {
    label: "Laurea-ammattikorkeakoulu",
    value: "Laurea-ammattikorkeakoulu",
  },
  {
    label: "Laurentian University",
    value: "Laurentian University",
  },
  {
    label: "Lawrence Technological University",
    value: "Lawrence Technological University",
  },
  {
    label: "Lawrence University",
    value: "Lawrence University",
  },
  {
    label: "LCC tarptautinis universitetas",
    value: "LCC tarptautinis universitetas",
  },
  {
    label: "Le Iunivesite Aoao o Samoa",
    value: "Le Iunivesite Aoao o Samoa",
  },
  {
    label: "Le Mans Université",
    value: "Le Mans Université",
  },
  {
    label: "Le Moyne College",
    value: "Le Moyne College",
  },
  {
    label: "Lead City University",
    value: "Lead City University",
  },
  {
    label: "LEAD University",
    value: "LEAD University",
  },
  {
    label: "Leaders University",
    value: "Leaders University",
  },
  {
    label: "Leading University",
    value: "Leading University",
  },
  {
    label: "Lebanese American University",
    value: "Lebanese American University",
  },
  {
    label: "Lebanese French University",
    value: "Lebanese French University",
  },
  {
    label: "Lebanese German University",
    value: "Lebanese German University",
  },
  {
    label: "Lebanese International University",
    value: "Lebanese International University",
  },
  {
    label: "Lebanese International University Yemen",
    value: "Lebanese International University Yemen",
  },
  {
    label: "Lebanon Valley College",
    value: "Lebanon Valley College",
  },
  {
    label: "LEC Accounting Graduate School",
    value: "LEC Accounting Graduate School",
  },
  {
    label: "L'École de design Nantes Atlantique",
    value: "L'École de design Nantes Atlantique",
  },
  {
    label: "Ledra College",
    value: "Ledra College",
  },
  {
    label: "Lee University",
    value: "Lee University",
  },
  {
    label: "Leeds Arts University",
    value: "Leeds Arts University",
  },
  {
    label: "Leeds Beckett University",
    value: "Leeds Beckett University",
  },
  {
    label: "Leeds Conservatoire",
    value: "Leeds Conservatoire",
  },
  {
    label: "Leeds Trinity University",
    value: "Leeds Trinity University",
  },
  {
    label: "Lee-Ming Institute of Technology",
    value: "Lee-Ming Institute of Technology",
  },
  {
    label: "Lees-McRae College",
    value: "Lees-McRae College",
  },
  {
    label: "Lefke Avrupa Üniversitesi",
    value: "Lefke Avrupa Üniversitesi",
  },
  {
    label: "Legacy University, Okija",
    value: "Legacy University, Okija",
  },
  {
    label: "Lehigh University",
    value: "Lehigh University",
  },
  {
    label: "Lehman College, CUNY",
    value: "Lehman College, CUNY",
  },
  {
    label: "Leibniz Universität Hannover",
    value: "Leibniz Universität Hannover",
  },
  {
    label: "Leibniz-Fachhochschule",
    value: "Leibniz-Fachhochschule",
  },
  {
    label: "LeMoyne-Owen College",
    value: "LeMoyne-Owen College",
  },
  {
    label: "Leningrad State University",
    value: "Leningrad State University",
  },
  {
    label: "Lenkeran Dövlet Universiteti",
    value: "Lenkeran Dövlet Universiteti",
  },
  {
    label: "Lenoir-Rhyne University",
    value: "Lenoir-Rhyne University",
  },
  {
    label: "Les Cours Sonou",
    value: "Les Cours Sonou",
  },
  {
    label:
      "Lesgaft National State University of Physical Education, Sport and Health",
    value:
      "Lesgaft National State University of Physical Education, Sport and Health",
  },
  {
    label: "Leshan Normal University",
    value: "Leshan Normal University",
  },
  {
    label: "Lesley University",
    value: "Lesley University",
  },
  {
    label: "Lesotho College of Education",
    value: "Lesotho College of Education",
  },
  {
    label: "Lesya Ukrainka Volyn National University",
    value: "Lesya Ukrainka Volyn National University",
  },
  {
    label: "LeTourneau University",
    value: "LeTourneau University",
  },
  {
    label: "Letterkenny Institute of Technology",
    value: "Letterkenny Institute of Technology",
  },
  {
    label: "Leuphana Universität Lüneburg",
    value: "Leuphana Universität Lüneburg",
  },
  {
    label: "Lewis & Clark College",
    value: "Lewis & Clark College",
  },
  {
    label: "Lewis University",
    value: "Lewis University",
  },
  {
    label: "Lewis-Clark State College",
    value: "Lewis-Clark State College",
  },
  {
    label: "Leyte Normal University",
    value: "Leyte Normal University",
  },
  {
    label: "Liaocheng University",
    value: "Liaocheng University",
  },
  {
    label: "Liaoning Communication University",
    value: "Liaoning Communication University",
  },
  {
    label: "Liaoning Institute of Science and Engineering",
    value: "Liaoning Institute of Science and Engineering",
  },
  {
    label: "Liaoning Institute of Science and Technology",
    value: "Liaoning Institute of Science and Technology",
  },
  {
    label: "Liaoning Normal University",
    value: "Liaoning Normal University",
  },
  {
    label: "Liaoning Shihua University",
    value: "Liaoning Shihua University",
  },
  {
    label: "Liaoning Technical University",
    value: "Liaoning Technical University",
  },
  {
    label: "Liaoning University",
    value: "Liaoning University",
  },
  {
    label: "Liaoning University of Finance and Trade",
    value: "Liaoning University of Finance and Trade",
  },
  {
    label: "Liaoning University of International Business and Economics",
    value: "Liaoning University of International Business and Economics",
  },
  {
    label: "Liaoning University of Technology",
    value: "Liaoning University of Technology",
  },
  {
    label: "Liaoning University of Traditional Chinese Medicine",
    value: "Liaoning University of Traditional Chinese Medicine",
  },
  {
    label: "Liaquat University of Medical and Health Sciences",
    value: "Liaquat University of Medical and Health Sciences",
  },
  {
    label: "Libera Università di Bolzano",
    value: "Libera Università di Bolzano",
  },
  {
    label: "Libera Università di Lingue e Comunicazione IULM",
    value: "Libera Università di Lingue e Comunicazione IULM",
  },
  {
    label: "Libera Università Internazionale degli Studi Sociali Guido Carli",
    value: "Libera Università Internazionale degli Studi Sociali Guido Carli",
  },
  {
    label: "Libera Università Maria SS. Assunta",
    value: "Libera Università Maria SS. Assunta",
  },
  {
    label: "Libertas Medunarodno Sveucilište",
    value: "Libertas Medunarodno Sveucilište",
  },
  {
    label: "Liberty University",
    value: "Liberty University",
  },
  {
    label: "Libreville International Business School",
    value: "Libreville International Business School",
  },
  {
    label: "Libyan Academy for Postgraduate Studies",
    value: "Libyan Academy for Postgraduate Studies",
  },
  {
    label: "Libyan International Medical University",
    value: "Libyan International Medical University",
  },
  {
    label: "Libyan University of Humanities and Applied Sciences",
    value: "Libyan University of Humanities and Applied Sciences",
  },
  {
    label: "Liceo de Cagayan University",
    value: "Liceo de Cagayan University",
  },
  {
    label: "Liepajas Universitate",
    value: "Liepajas Universitate",
  },
  {
    label: "Lietuvos aukštoji jureivystes mokykla",
    value: "Lietuvos aukštoji jureivystes mokykla",
  },
  {
    label: "Lietuvos muzikos ir teatro akademija",
    value: "Lietuvos muzikos ir teatro akademija",
  },
  {
    label: "Lietuvos sporto universitetas",
    value: "Lietuvos sporto universitetas",
  },
  {
    label: "Lietuvos sveikatos mokslu universitetas",
    value: "Lietuvos sveikatos mokslu universitetas",
  },
  {
    label: "Lietuvos verslo kolegija",
    value: "Lietuvos verslo kolegija",
  },
  {
    label: "Life Pacific University",
    value: "Life Pacific University",
  },
  {
    label: "Life University",
    value: "Life University",
  },
  {
    label: "Life University, Cambodia",
    value: "Life University, Cambodia",
  },
  {
    label: "Lilongwe University of Agriculture and Natural Resources",
    value: "Lilongwe University of Agriculture and Natural Resources",
  },
  {
    label: "LIM College",
    value: "LIM College",
  },
  {
    label: "Limestone University",
    value: "Limestone University",
  },
  {
    label: "Limkokwing University of Creative Technology Swaziland",
    value: "Limkokwing University of Creative Technology Swaziland",
  },
  {
    label: "Limkokwing University of Creative Technology, Botswana",
    value: "Limkokwing University of Creative Technology, Botswana",
  },
  {
    label: "Limkokwing University of Creative Technology, Cambodia",
    value: "Limkokwing University of Creative Technology, Cambodia",
  },
  {
    label: "Lincoln American University",
    value: "Lincoln American University",
  },
  {
    label: "Lincoln Christian University",
    value: "Lincoln Christian University",
  },
  {
    label: "Lincoln College",
    value: "Lincoln College",
  },
  {
    label: "Lincoln Memorial University",
    value: "Lincoln Memorial University",
  },
  {
    label: "Lincoln University",
    value: "Lincoln University",
  },
  {
    label: "Lincoln University, Missouri",
    value: "Lincoln University, Missouri",
  },
  {
    label: "Lincoln University, New Zealand",
    value: "Lincoln University, New Zealand",
  },
  {
    label: "Lindenwood University",
    value: "Lindenwood University",
  },
  {
    label: "Lindsey Wilson College",
    value: "Lindsey Wilson College",
  },
  {
    label: "Linfield University",
    value: "Linfield University",
  },
  {
    label: "Ling Tung University",
    value: "Ling Tung University",
  },
  {
    label: "Lingaya's University",
    value: "Lingaya's University",
  },
  {
    label: "Lingnan Normal University",
    value: "Lingnan Normal University",
  },
  {
    label: "Lingnan University",
    value: "Lingnan University",
  },
  {
    label: "Linguistic University of Nizhny Novgorod",
    value: "Linguistic University of Nizhny Novgorod",
  },
  {
    label: "Link Campus University",
    value: "Link Campus University",
  },
  {
    label: "Linköpings Universitet",
    value: "Linköpings Universitet",
  },
  {
    label: "Linnéuniversitetet",
    value: "Linnéuniversitetet",
  },
  {
    label: "Linyi University",
    value: "Linyi University",
  },
  {
    label: "Lipa City Colleges",
    value: "Lipa City Colleges",
  },
  {
    label: "Lipetsk State Pedagogical University",
    value: "Lipetsk State Pedagogical University",
  },
  {
    label: "Lipetsk State Technical University",
    value: "Lipetsk State Technical University",
  },
  {
    label: "Lipscomb University",
    value: "Lipscomb University",
  },
  {
    label: "Lira University",
    value: "Lira University",
  },
  {
    label: "Lishui University",
    value: "Lishui University",
  },
  {
    label: "Listaháskóli Íslands",
    value: "Listaháskóli Íslands",
  },
  {
    label: "Liszt Ferenc Zenemuvészeti Egyetem",
    value: "Liszt Ferenc Zenemuvészeti Egyetem",
  },
  {
    label: "LIUC Università Cattaneo",
    value: "LIUC Università Cattaneo",
  },
  {
    label: "Liupanshui Normal University",
    value: "Liupanshui Normal University",
  },
  {
    label: "Liverpool Hope University",
    value: "Liverpool Hope University",
  },
  {
    label: "Liverpool John Moores University",
    value: "Liverpool John Moores University",
  },
  {
    label: "Liverpool School of Tropical Medicine",
    value: "Liverpool School of Tropical Medicine",
  },
  {
    label: "Livingstone College",
    value: "Livingstone College",
  },
  {
    label: "LivingStone International University",
    value: "LivingStone International University",
  },
  {
    label:
      "Livingstone International University of Tourism Excellence and Business Management",
    value:
      "Livingstone International University of Tourism Excellence and Business Management",
  },
  {
    label: "Liwa College",
    value: "Liwa College",
  },
  {
    label: "LNCT University",
    value: "LNCT University",
  },
  {
    label: "Lobachevsky State University of Nizhny Novgorod",
    value: "Lobachevsky State University of Nizhny Novgorod",
  },
  {
    label: "Lock Haven University",
    value: "Lock Haven University",
  },
  {
    label: "Loei Rajabhat University",
    value: "Loei Rajabhat University",
  },
  {
    label: "Logan Business College",
    value: "Logan Business College",
  },
  {
    label: "Logan University",
    value: "Logan University",
  },
  {
    label: "Loikaw University",
    value: "Loikaw University",
  },
  {
    label: "Loma Linda University",
    value: "Loma Linda University",
  },
  {
    label: "London Business School",
    value: "London Business School",
  },
  {
    label: "London College of International Business Studies, Botswana",
    value: "London College of International Business Studies, Botswana",
  },
  {
    label: "London Metropolitan University",
    value: "London Metropolitan University",
  },
  {
    label:
      "London School of Hygiene and Tropical Medicine, University of London",
    value:
      "London School of Hygiene and Tropical Medicine, University of London",
  },
  {
    label: "London South Bank University",
    value: "London South Bank University",
  },
  {
    label: "Long Island University",
    value: "Long Island University",
  },
  {
    label: "Longdong University",
    value: "Longdong University",
  },
  {
    label: "Longwood University",
    value: "Longwood University",
  },
  {
    label: "Longyan University",
    value: "Longyan University",
  },
  {
    label: "Loras College",
    value: "Loras College",
  },
  {
    label: "Lorestan University",
    value: "Lorestan University",
  },
  {
    label: "Lorestan University of Medical Sciences",
    value: "Lorestan University of Medical Sciences",
  },
  {
    label: "Lorma Colleges",
    value: "Lorma Colleges",
  },
  {
    label: "Loughborough University",
    value: "Loughborough University",
  },
  {
    label: "Louisiana Christian University",
    value: "Louisiana Christian University",
  },
  {
    label: "Louisiana State University",
    value: "Louisiana State University",
  },
  {
    label: "Louisiana State University Health Sciences Center",
    value: "Louisiana State University Health Sciences Center",
  },
  {
    label: "Louisiana State University Health Sciences Center-Shreveport",
    value: "Louisiana State University Health Sciences Center-Shreveport",
  },
  {
    label: "Louisiana State University in Shreveport",
    value: "Louisiana State University in Shreveport",
  },
  {
    label: "Louisiana State University of Alexandria",
    value: "Louisiana State University of Alexandria",
  },
  {
    label: "Louisiana Tech University",
    value: "Louisiana Tech University",
  },
  {
    label: "Lourdes College",
    value: "Lourdes College",
  },
  {
    label: "Lourdes University",
    value: "Lourdes University",
  },
  {
    label: "Lovely Professional University",
    value: "Lovely Professional University",
  },
  {
    label: "Lovisenberg diakonale høgskole",
    value: "Lovisenberg diakonale høgskole",
  },
  {
    label: "Loyola Marymount University",
    value: "Loyola Marymount University",
  },
  {
    label: "Loyola University Chicago",
    value: "Loyola University Chicago",
  },
  {
    label: "Loyola University Maryland",
    value: "Loyola University Maryland",
  },
  {
    label: "Loyola University New Orleans",
    value: "Loyola University New Orleans",
  },
  {
    label: "Lubbock Christian University",
    value: "Lubbock Christian University",
  },
  {
    label: "LUCA School of Arts",
    value: "LUCA School of Arts",
  },
  {
    label: "Ludong University",
    value: "Ludong University",
  },
  {
    label: "Ludwig-Maximilians-Universität München",
    value: "Ludwig-Maximilians-Universität München",
  },
  {
    label: "Lugansk State Medical University",
    value: "Lugansk State Medical University",
  },
  {
    label: "Lugansk State University of Internal Affairs",
    value: "Lugansk State University of Internal Affairs",
  },
  {
    label: "Luhansk State Academy of Culture and Arts",
    value: "Luhansk State Academy of Culture and Arts",
  },
  {
    label: "Luhansk Taras Shevchenko National University",
    value: "Luhansk Taras Shevchenko National University",
  },
  {
    label: "Lukenya University",
    value: "Lukenya University",
  },
  {
    label: "Luleå tekniska Universitet",
    value: "Luleå tekniska Universitet",
  },
  {
    label: "Luliang University",
    value: "Luliang University",
  },
  {
    label: "Lumbini Buddhist University",
    value: "Lumbini Buddhist University",
  },
  {
    label: "Lunds Universitet",
    value: "Lunds Universitet",
  },
  {
    label: "Lunghwa University of Science and Technology",
    value: "Lunghwa University of Science and Technology",
  },
  {
    label: "L-Università ta' Malta",
    value: "L-Università ta' Malta",
  },
  {
    label: "Luoyang Institute of Science and Technology",
    value: "Luoyang Institute of Science and Technology",
  },
  {
    label: "Luoyang Normal University",
    value: "Luoyang Normal University",
  },
  {
    label: "Lupane State University",
    value: "Lupane State University",
  },
  {
    label: "Lusaka Apex Medical University",
    value: "Lusaka Apex Medical University",
  },
  {
    label: "Luther College",
    value: "Luther College",
  },
  {
    label: "Luther College at the University of Regina",
    value: "Luther College at the University of Regina",
  },
  {
    label: "Luther University",
    value: "Luther University",
  },
  {
    label: "Lutherische Theologische Hochschule",
    value: "Lutherische Theologische Hochschule",
  },
  {
    label: "Lutsk National Technical University",
    value: "Lutsk National Technical University",
  },
  {
    label: "Luxor University",
    value: "Luxor University",
  },
  {
    label: "LuXun Academy of Fine Arts",
    value: "LuXun Academy of Fine Arts",
  },
  {
    label: "Lviv National Academy of Arts",
    value: "Lviv National Academy of Arts",
  },
  {
    label: "Lviv National Environmental University",
    value: "Lviv National Environmental University",
  },
  {
    label: "Lviv National Medical University",
    value: "Lviv National Medical University",
  },
  {
    label: "Lviv National Music Academy",
    value: "Lviv National Music Academy",
  },
  {
    label:
      "Lviv National University of Veterinary Medicine and Biotechnologies",
    value:
      "Lviv National University of Veterinary Medicine and Biotechnologies",
  },
  {
    label: "Lviv Polytechnic National University",
    value: "Lviv Polytechnic National University",
  },
  {
    label: "Lviv State University of Internal Affairs",
    value: "Lviv State University of Internal Affairs",
  },
  {
    label: "Lviv State University of Life Safety",
    value: "Lviv State University of Life Safety",
  },
  {
    label: "Lviv State University of Physical Culture",
    value: "Lviv State University of Physical Culture",
  },
  {
    label: "Lviv University of Trade and Economics",
    value: "Lviv University of Trade and Economics",
  },
  {
    label: "Lyceum of the Philippines University",
    value: "Lyceum of the Philippines University",
  },
  {
    label: "Lyceum-Northwestern University",
    value: "Lyceum-Northwestern University",
  },
  {
    label: "Lycoming College",
    value: "Lycoming College",
  },
  {
    label: "Lynn University",
    value: "Lynn University",
  },
  {
    label: "Lyon College",
    value: "Lyon College",
  },
  {
    label: "Lyuben Karavelov University of Applied Sciences",
    value: "Lyuben Karavelov University of Applied Sciences",
  },
  {
    label: "M. Akmullah Bashkir State Pedagogical University",
    value: "M. Akmullah Bashkir State Pedagogical University",
  },
  {
    label: "M. Kh. Dulati Taraz State University",
    value: "M. Kh. Dulati Taraz State University",
  },
  {
    label: "M.J.P. Rohilkhand University",
    value: "M.J.P. Rohilkhand University",
  },
  {
    label: "M.V. Lomonosov adina Moskva Dövlet Universitetinin Baki",
    value: "M.V. Lomonosov adina Moskva Dövlet Universitetinin Baki",
  },
  {
    label: "M_EIA Instituto Universitário de Arte, Tecnologia e Cultura",
    value: "M_EIA Instituto Universitário de Arte, Tecnologia e Cultura",
  },
  {
    label: "Maasai Mara University",
    value: "Maasai Mara University",
  },
  {
    label: "Maastricht School of Management Kuwait",
    value: "Maastricht School of Management Kuwait",
  },
  {
    label: "Macalester College",
    value: "Macalester College",
  },
  {
    label: "Macau Institute of Management",
    value: "Macau Institute of Management",
  },
  {
    label: "Macau Millennium College",
    value: "Macau Millennium College",
  },
  {
    label: "Macau University of Science and Technology",
    value: "Macau University of Science and Technology",
  },
  {
    label: "MacEwan University",
    value: "MacEwan University",
  },
  {
    label: "Machakos University",
    value: "Machakos University",
  },
  {
    label: "Macquarie University",
    value: "Macquarie University",
  },
  {
    label: "Madan Mohan Malaviya University of Technology",
    value: "Madan Mohan Malaviya University of Technology",
  },
  {
    label: "Madda Walabu University",
    value: "Madda Walabu University",
  },
  {
    label: "Madenat Alelem University College",
    value: "Madenat Alelem University College",
  },
  {
    label: "Madhav University",
    value: "Madhav University",
  },
  {
    label: "Madhyanchal Professional University",
    value: "Madhyanchal Professional University",
  },
  {
    label: "Madonna University",
    value: "Madonna University",
  },
  {
    label: "Madonna University, Nigeria",
    value: "Madonna University, Nigeria",
  },
  {
    label: "Madurai Kamaraj University",
    value: "Madurai Kamaraj University",
  },
  {
    label: "Mae Fah Luang University",
    value: "Mae Fah Luang University",
  },
  {
    label: "Maebashi Institute of Technology",
    value: "Maebashi Institute of Technology",
  },
  {
    label: "Maejo University",
    value: "Maejo University",
  },
  {
    label: "Magadh University",
    value: "Magadh University",
  },
  {
    label: "Magdalen College of the Liberal Arts",
    value: "Magdalen College of the Liberal Arts",
  },
  {
    label: "Magnitogorsk State Conservatory",
    value: "Magnitogorsk State Conservatory",
  },
  {
    label: "Magnitogorsk State Technical University",
    value: "Magnitogorsk State Technical University",
  },
  {
    label: "Magtymguly adyndaky Türkmen döwlet uniwersiteti",
    value: "Magtymguly adyndaky Türkmen döwlet uniwersiteti",
  },
  {
    label: "Magway University",
    value: "Magway University",
  },
  {
    label: "Magyar Agrár- és Élettudományi Egyetem",
    value: "Magyar Agrár- és Élettudományi Egyetem",
  },
  {
    label: "Magyar Képzomuvészeti Egyetem",
    value: "Magyar Képzomuvészeti Egyetem",
  },
  {
    label: "Magyar Táncmuvészeti Egyetem",
    value: "Magyar Táncmuvészeti Egyetem",
  },
  {
    label: "Mahachulalongkornrajavidyalaya University",
    value: "Mahachulalongkornrajavidyalaya University",
  },
  {
    label: "Mahamakut Buddhist University",
    value: "Mahamakut Buddhist University",
  },
  {
    label: "Mahanakorn University of Technology",
    value: "Mahanakorn University of Technology",
  },
  {
    label: "Mahapurusha Srimanta Sankaradeva Viswavidyalaya",
    value: "Mahapurusha Srimanta Sankaradeva Viswavidyalaya",
  },
  {
    label: "Maharaja Agrasen Himalayan Garhwal University",
    value: "Maharaja Agrasen Himalayan Garhwal University",
  },
  {
    label: "Maharaja Agrasen University",
    value: "Maharaja Agrasen University",
  },
  {
    label: "Maharaja Bir Bikram University",
    value: "Maharaja Bir Bikram University",
  },
  {
    label: "Maharaja Chhatrasal Bundelkhand University",
    value: "Maharaja Chhatrasal Bundelkhand University",
  },
  {
    label: "Maharaja Ganga Singh University",
    value: "Maharaja Ganga Singh University",
  },
  {
    label: "Maharaja Krishnakumarsinhji Bhavnagar University",
    value: "Maharaja Krishnakumarsinhji Bhavnagar University",
  },
  {
    label: "Maharaja Ranjit Singh Punjab Technical University",
    value: "Maharaja Ranjit Singh Punjab Technical University",
  },
  {
    label: "Maharaja Surajmal Brij University",
    value: "Maharaja Surajmal Brij University",
  },
  {
    label: "Maharana Pratap University of Agriculture and Technology",
    value: "Maharana Pratap University of Agriculture and Technology",
  },
  {
    label: "Maharashtra Animal and Fishery Sciences University",
    value: "Maharashtra Animal and Fishery Sciences University",
  },
  {
    label: "Maharashtra National Law University Mumbai",
    value: "Maharashtra National Law University Mumbai",
  },
  {
    label: "Maharashtra National Law University, Aurangabad",
    value: "Maharashtra National Law University, Aurangabad",
  },
  {
    label: "Maharashtra National Law University, Nagpur",
    value: "Maharashtra National Law University, Nagpur",
  },
  {
    label: "Maharashtra University of Health Sciences",
    value: "Maharashtra University of Health Sciences",
  },
  {
    label: "Maharishi Arvind University, Jaipur",
    value: "Maharishi Arvind University, Jaipur",
  },
  {
    label: "Maharishi Dayanand University",
    value: "Maharishi Dayanand University",
  },
  {
    label: "Maharishi International University",
    value: "Maharishi International University",
  },
  {
    label: "Maharishi Mahesh Yogi Vedic Vishwavidyalaya",
    value: "Maharishi Mahesh Yogi Vedic Vishwavidyalaya",
  },
  {
    label: "Maharishi Markandeshwar University, Mullana",
    value: "Maharishi Markandeshwar University, Mullana",
  },
  {
    label: "Maharishi Markandeshwar University, Sadopur",
    value: "Maharishi Markandeshwar University, Sadopur",
  },
  {
    label: "Maharishi Markandeshwar University, Solan",
    value: "Maharishi Markandeshwar University, Solan",
  },
  {
    label: "Maharishi University",
    value: "Maharishi University",
  },
  {
    label: "Maharishi University of Management and Technology",
    value: "Maharishi University of Management and Technology",
  },
  {
    label: "Maharshi Dayanand Saraswati University",
    value: "Maharshi Dayanand Saraswati University",
  },
  {
    label: "Maharshi Panini Sanskrit Vishwavidyalaya",
    value: "Maharshi Panini Sanskrit Vishwavidyalaya",
  },
  {
    label: "Mahasarakham University",
    value: "Mahasarakham University",
  },
  {
    label: "Mahatma Gandhi Antarrashtriya Hindi Vishwavidyalaya",
    value: "Mahatma Gandhi Antarrashtriya Hindi Vishwavidyalaya",
  },
  {
    label: "Mahatma Gandhi Central University, Motihari",
    value: "Mahatma Gandhi Central University, Motihari",
  },
  {
    label: "Mahatma Gandhi Chitrakoot Gramoday Vishwavidyalaya",
    value: "Mahatma Gandhi Chitrakoot Gramoday Vishwavidyalaya",
  },
  {
    label: "Mahatma Gandhi Institute",
    value: "Mahatma Gandhi Institute",
  },
  {
    label: "Mahatma Gandhi Kashi Vidyapeeth",
    value: "Mahatma Gandhi Kashi Vidyapeeth",
  },
  {
    label: "Mahatma Gandhi University",
    value: "Mahatma Gandhi University",
  },
  {
    label: "Mahatma Gandhi University of Medical Sciences and Technology",
    value: "Mahatma Gandhi University of Medical Sciences and Technology",
  },
  {
    label: "Mahatma Gandhi University, Meghalaya",
    value: "Mahatma Gandhi University, Meghalaya",
  },
  {
    label: "Mahatma Gandhi University, Nalgonda",
    value: "Mahatma Gandhi University, Nalgonda",
  },
  {
    label: "Mahatma Jyoti Rao Phoole University",
    value: "Mahatma Jyoti Rao Phoole University",
  },
  {
    label: "Mahatma Phule Krishi Vidyapeeth",
    value: "Mahatma Phule Krishi Vidyapeeth",
  },
  {
    label: "Mahidol University",
    value: "Mahidol University",
  },
  {
    label: "Maihan Institute of Higher Education",
    value: "Maihan Institute of Higher Education",
  },
  {
    label: "Maikop State Technological University",
    value: "Maikop State Technological University",
  },
  {
    label: "Maine College of Art",
    value: "Maine College of Art",
  },
  {
    label: "Maine Maritime Academy",
    value: "Maine Maritime Academy",
  },
  {
    label: "Maiwand institute of Higher Education",
    value: "Maiwand institute of Higher Education",
  },
  {
    label: "Majan University College",
    value: "Majan University College",
  },
  {
    label: "Majmaah University",
    value: "Majmaah University",
  },
  {
    label: "Makassed University of Beirut",
    value: "Makassed University of Beirut",
  },
  {
    label: "Makerere University",
    value: "Makerere University",
  },
  {
    label: "Makhanlal Chaturvedi Rashtriya Patrakarita Vishwavidyalaya",
    value: "Makhanlal Chaturvedi Rashtriya Patrakarita Vishwavidyalaya",
  },
  {
    label: "Mälardalens universitet",
    value: "Mälardalens universitet",
  },
  {
    label: "Malaviya National Institute of Technology, Jaipur",
    value: "Malaviya National Institute of Technology, Jaipur",
  },
  {
    label: "Malawi Adventist University",
    value: "Malawi Adventist University",
  },
  {
    label: "Malawi Assemblies of God University",
    value: "Malawi Assemblies of God University",
  },
  {
    label: "Malawi College of Accountancy",
    value: "Malawi College of Accountancy",
  },
  {
    label: "Malawi University of Science and Technology",
    value: "Malawi University of Science and Technology",
  },
  {
    label: "Malayer University",
    value: "Malayer University",
  },
  {
    label: "Malaysia University of Science and Technology",
    value: "Malaysia University of Science and Technology",
  },
  {
    label: "Malek-Ashtar University of Technology",
    value: "Malek-Ashtar University of Technology",
  },
  {
    label: "Malmö Universitet",
    value: "Malmö Universitet",
  },
  {
    label: "Malone University",
    value: "Malone University",
  },
  {
    label: "Malta College of Arts, Science and Technology",
    value: "Malta College of Arts, Science and Technology",
  },
  {
    label: "Maltepe Üniversitesi",
    value: "Maltepe Üniversitesi",
  },
  {
    label: "Malwanchal University",
    value: "Malwanchal University",
  },
  {
    label: "Ma'mun nomidagi jahon tillari universiteti",
    value: "Ma'mun nomidagi jahon tillari universiteti",
  },
  {
    label: "Management and Science University",
    value: "Management and Science University",
  },
  {
    label: "Management University of Africa",
    value: "Management University of Africa",
  },
  {
    label: "Managil University of Science and Technology",
    value: "Managil University of Science and Technology",
  },
  {
    label: "Manara University",
    value: "Manara University",
  },
  {
    label: "Manarat International University",
    value: "Manarat International University",
  },
  {
    label: "Manash Kozybayev North Kazakhstan University",
    value: "Manash Kozybayev North Kazakhstan University",
  },
  {
    label: "Manav Bharti University",
    value: "Manav Bharti University",
  },
  {
    label: "Manav Rachna International Institute of Research and Studies",
    value: "Manav Rachna International Institute of Research and Studies",
  },
  {
    label: "Manav Rachna University",
    value: "Manav Rachna University",
  },
  {
    label: "Manchester Metropolitan University",
    value: "Manchester Metropolitan University",
  },
  {
    label: "Manchester University",
    value: "Manchester University",
  },
  {
    label: "Mandakh University",
    value: "Mandakh University",
  },
  {
    label: "Mandalay Technological University",
    value: "Mandalay Technological University",
  },
  {
    label: "Mandalay University",
    value: "Mandalay University",
  },
  {
    label: "Mandalay University of Foreign Languages",
    value: "Mandalay University of Foreign Languages",
  },
  {
    label: "Mandsaur University",
    value: "Mandsaur University",
  },
  {
    label: "Mangalayatan University",
    value: "Mangalayatan University",
  },
  {
    label: "Mangalore University",
    value: "Mangalore University",
  },
  {
    label: "Mangosuthu University of Technology",
    value: "Mangosuthu University of Technology",
  },
  {
    label: "Manhattan Christian College",
    value: "Manhattan Christian College",
  },
  {
    label: "Manhattan College",
    value: "Manhattan College",
  },
  {
    label: "Manhattan School of Music",
    value: "Manhattan School of Music",
  },
  {
    label: "Manhattanville College",
    value: "Manhattanville College",
  },
  {
    label: "Manicaland State University of Applied Sciences",
    value: "Manicaland State University of Applied Sciences",
  },
  {
    label: "Manila Central University",
    value: "Manila Central University",
  },
  {
    label: "Manipal Academy of Higher Education",
    value: "Manipal Academy of Higher Education",
  },
  {
    label: "Manipal International University",
    value: "Manipal International University",
  },
  {
    label: "Manipal University, Dubai",
    value: "Manipal University, Dubai",
  },
  {
    label: "Manipur International University",
    value: "Manipur International University",
  },
  {
    label: "Manipur Technical University",
    value: "Manipur Technical University",
  },
  {
    label: "Manipur University",
    value: "Manipur University",
  },
  {
    label: "Manipur University of Culture",
    value: "Manipur University of Culture",
  },
  {
    label: "Manisa Celal Bayar Üniversitesi",
    value: "Manisa Celal Bayar Üniversitesi",
  },
  {
    label: "Manonmaniam Sundaranar University",
    value: "Manonmaniam Sundaranar University",
  },
  {
    label: "Mansfield University",
    value: "Mansfield University",
  },
  {
    label: "Mansfield University of Pennsylvania",
    value: "Mansfield University of Pennsylvania",
  },
  {
    label: "Mansoura University",
    value: "Mansoura University",
  },
  {
    label: "Manuel L. Quezon University",
    value: "Manuel L. Quezon University",
  },
  {
    label: "Manuel S. Enverga University Foundation",
    value: "Manuel S. Enverga University Foundation",
  },
  {
    label: "Mapúa University",
    value: "Mapúa University",
  },
  {
    label: "Maranatha Baptist University",
    value: "Maranatha Baptist University",
  },
  {
    label: "Maranatha University College",
    value: "Maranatha University College",
  },
  {
    label: "Mardin Artuklu Üniversitesi",
    value: "Mardin Artuklu Üniversitesi",
  },
  {
    label: "Mari State University",
    value: "Mari State University",
  },
  {
    label: "Maria College",
    value: "Maria College",
  },
  {
    label: "Marian University",
    value: "Marian University",
  },
  {
    label: "Marian University, Wisconsin",
    value: "Marian University, Wisconsin",
  },
  {
    label: "Mariano Marcos State University",
    value: "Mariano Marcos State University",
  },
  {
    label: "Marie Cederschiöld högskola",
    value: "Marie Cederschiöld högskola",
  },
  {
    label: "Marietta College",
    value: "Marietta College",
  },
  {
    label: "Marijampoles kolegija",
    value: "Marijampoles kolegija",
  },
  {
    label: "Marinduque State College",
    value: "Marinduque State College",
  },
  {
    label: "Marino Institute of Education",
    value: "Marino Institute of Education",
  },
  {
    label: "Marist College",
    value: "Marist College",
  },
  {
    label: "Maritime State University",
    value: "Maritime State University",
  },
  {
    label: "Mariupol State University",
    value: "Mariupol State University",
  },
  {
    label: "Marmara Üniversitesi",
    value: "Marmara Üniversitesi",
  },
  {
    label: "Marnix Academie",
    value: "Marnix Academie",
  },
  {
    label: "Marondera University of Agricultural Sciences and Technology",
    value: "Marondera University of Agricultural Sciences and Technology",
  },
  {
    label: "Marquette University",
    value: "Marquette University",
  },
  {
    label: "Mars Hill University",
    value: "Mars Hill University",
  },
  {
    label: "Marshall B. Ketchum University",
    value: "Marshall B. Ketchum University",
  },
  {
    label: "Marshall University",
    value: "Marshall University",
  },
  {
    label: "Marshalls University College",
    value: "Marshalls University College",
  },
  {
    label: "Martin Luther Christian University",
    value: "Martin Luther Christian University",
  },
  {
    label: "Martin Luther College",
    value: "Martin Luther College",
  },
  {
    label: "Martin University",
    value: "Martin University",
  },
  {
    label: "Martin-Luther-Universität Halle-Wittenberg",
    value: "Martin-Luther-Universität Halle-Wittenberg",
  },
  {
    label: "Marwadi University",
    value: "Marwadi University",
  },
  {
    label: "Mary Baldwin University",
    value: "Mary Baldwin University",
  },
  {
    label: "Maryam University",
    value: "Maryam University",
  },
  {
    label: "Maryland Institute College of Art",
    value: "Maryland Institute College of Art",
  },
  {
    label: "Maryland University of Integrative Health",
    value: "Maryland University of Integrative Health",
  },
  {
    label: "Marymount Manhattan College",
    value: "Marymount Manhattan College",
  },
  {
    label: "Marymount University",
    value: "Marymount University",
  },
  {
    label: "Maryville College",
    value: "Maryville College",
  },
  {
    label: "Maryville University",
    value: "Maryville University",
  },
  {
    label: "Marywood University",
    value: "Marywood University",
  },
  {
    label: "Masarykova univerzita",
    value: "Masarykova univerzita",
  },
  {
    label: "Maseno University",
    value: "Maseno University",
  },
  {
    label: "Mashal University",
    value: "Mashal University",
  },
  {
    label: "Mashhad University of Medical Sciences",
    value: "Mashhad University of Medical Sciences",
  },
  {
    label: "Mashreq University",
    value: "Mashreq University",
  },
  {
    label: "Masinde Muliro University of Science and Technology",
    value: "Masinde Muliro University of Science and Technology",
  },
  {
    label: "Massachusetts College of Art and Design",
    value: "Massachusetts College of Art and Design",
  },
  {
    label: "Massachusetts College of Liberal Arts",
    value: "Massachusetts College of Liberal Arts",
  },
  {
    label: "Massachusetts Institute of Technology",
    value: "Massachusetts Institute of Technology",
  },
  {
    label: "Massachusetts Maritime Academy",
    value: "Massachusetts Maritime Academy",
  },
  {
    label: "Massachusetts School of Law",
    value: "Massachusetts School of Law",
  },
  {
    label: "Massawa College of Marine Science and Technology",
    value: "Massawa College of Marine Science and Technology",
  },
  {
    label: "Massey University",
    value: "Massey University",
  },
  {
    label: "Matn University College of Technology",
    value: "Matn University College of Technology",
  },
  {
    label: "Matrouh University",
    value: "Matrouh University",
  },
  {
    label: "MATS University",
    value: "MATS University",
  },
  {
    label: "Matsumoto College of Nursing",
    value: "Matsumoto College of Nursing",
  },
  {
    label: "Matsumoto Dental University",
    value: "Matsumoto Dental University",
  },
  {
    label: "Matsumoto University",
    value: "Matsumoto University",
  },
  {
    label: "Matsuyama Shinonome College",
    value: "Matsuyama Shinonome College",
  },
  {
    label: "Matsuyama University",
    value: "Matsuyama University",
  },
  {
    label: "Mattu University",
    value: "Mattu University",
  },
  {
    label: "Maubin University",
    value: "Maubin University",
  },
  {
    label: "Maulana Abul Kalam Azad University of Technology, West Bengal",
    value: "Maulana Abul Kalam Azad University of Technology, West Bengal",
  },
  {
    label: "Maulana Azad National Institute of Technology",
    value: "Maulana Azad National Institute of Technology",
  },
  {
    label: "Maulana Azad National Urdu University",
    value: "Maulana Azad National Urdu University",
  },
  {
    label: "Maulana Azad University, Jodhpur",
    value: "Maulana Azad University, Jodhpur",
  },
  {
    label: "Maulana Mazharul Haque Arabic and Persian University",
    value: "Maulana Mazharul Haque Arabic and Persian University",
  },
  {
    label: "Mauritius Institute of Education",
    value: "Mauritius Institute of Education",
  },
  {
    label: "Mawlamyine University",
    value: "Mawlamyine University",
  },
  {
    label: "Mawlana Bhashani Science and Technology University",
    value: "Mawlana Bhashani Science and Technology University",
  },
  {
    label: "Mawlana University",
    value: "Mawlana University",
  },
  {
    label: "Max Stern Academic College of Emek Yezreel",
    value: "Max Stern Academic College of Emek Yezreel",
  },
  {
    label: "May 22 College of Applied Medical Sciences",
    value: "May 22 College of Applied Medical Sciences",
  },
  {
    label: "Maynooth University",
    value: "Maynooth University",
  },
  {
    label: "Mayo Clinic College of Medicine and Science",
    value: "Mayo Clinic College of Medicine and Science",
  },
  {
    label: "Mayville State University",
    value: "Mayville State University",
  },
  {
    label: "Mazandaran University of Medical Sciences",
    value: "Mazandaran University of Medical Sciences",
  },
  {
    label: "Mazandaran University of Science and Technology",
    value: "Mazandaran University of Science and Technology",
  },
  {
    label: "Mazaya Private University",
    value: "Mazaya Private University",
  },
  {
    label: "Mazoon College",
    value: "Mazoon College",
  },
  {
    label: "Mbarara University of Science and Technology",
    value: "Mbarara University of Science and Technology",
  },
  {
    label: "Mbeya University of Science and Technology",
    value: "Mbeya University of Science and Technology",
  },
  {
    label: "McDaniel College",
    value: "McDaniel College",
  },
  {
    label: "McGill University",
    value: "McGill University",
  },
  {
    label: "MCI Management Center Innsbruck",
    value: "MCI Management Center Innsbruck",
  },
  {
    label: "McKendree University",
    value: "McKendree University",
  },
  {
    label: "McMaster University",
    value: "McMaster University",
  },
  {
    label: "McMurry University",
    value: "McMurry University",
  },
  {
    label: "McNeese State University",
    value: "McNeese State University",
  },
  {
    label: "McPherson College",
    value: "McPherson College",
  },
  {
    label: "Mcpherson University",
    value: "Mcpherson University",
  },
  {
    label: "MCPHS University",
    value: "MCPHS University",
  },
  {
    label: "mdw - Universität für Musik und darstellende Kunst Wien",
    value: "mdw - Universität für Musik und darstellende Kunst Wien",
  },
  {
    label: "Medgar Evers College",
    value: "Medgar Evers College",
  },
  {
    label: "Mediadesign Hochschule",
    value: "Mediadesign Hochschule",
  },
  {
    label: "Medical and Social Research Institute",
    value: "Medical and Social Research Institute",
  },
  {
    label: "Medical College of Wisconsin",
    value: "Medical College of Wisconsin",
  },
  {
    label: "Medical School Hamburg",
    value: "Medical School Hamburg",
  },
  {
    label: "Medical University - Pleven",
    value: "Medical University - Pleven",
  },
  {
    label: "Medical University - Sofia",
    value: "Medical University - Sofia",
  },
  {
    label: "Medical University of Ilam",
    value: "Medical University of Ilam",
  },
  {
    label: "Medical University of Plovdiv",
    value: "Medical University of Plovdiv",
  },
  {
    label: "Medical University of South Carolina",
    value: "Medical University of South Carolina",
  },
  {
    label: "Medical University-Varna",
    value: "Medical University-Varna",
  },
  {
    label: "Medi-Caps University",
    value: "Medi-Caps University",
  },
  {
    label: "Medimursko veleucilište u Cakovcu",
    value: "Medimursko veleucilište u Cakovcu",
  },
  {
    label: "Mediterranean Institute of Management",
    value: "Mediterranean Institute of Management",
  },
  {
    label: "Medizinische Hochschule Brandenburg Theodor Fontane",
    value: "Medizinische Hochschule Brandenburg Theodor Fontane",
  },
  {
    label: "Medizinische Hochschule Hannover",
    value: "Medizinische Hochschule Hannover",
  },
  {
    label: "Medizinische Universität Graz",
    value: "Medizinische Universität Graz",
  },
  {
    label: "Medizinische Universität Innsbruck",
    value: "Medizinische Universität Innsbruck",
  },
  {
    label: "Medizinische Universität Wien",
    value: "Medizinische Universität Wien",
  },
  {
    label: "Mednarodna fakulteta za družbene in poslovne študije",
    value: "Mednarodna fakulteta za družbene in poslovne študije",
  },
  {
    label: "Mednarodna podiplomska šola Jožefa Stefana",
    value: "Mednarodna podiplomska šola Jožefa Stefana",
  },
  {
    label: "Meenakshi Academy of Higher Education and Research",
    value: "Meenakshi Academy of Higher Education and Research",
  },
  {
    label: "Mef Üniversitesi",
    value: "Mef Üniversitesi",
  },
  {
    label: "Mega Size College",
    value: "Mega Size College",
  },
  {
    label: "Meharry Medical College",
    value: "Meharry Medical College",
  },
  {
    label: "Mehran University of Engineering and Technology",
    value: "Mehran University of Engineering and Technology",
  },
  {
    label: "Meiho University",
    value: "Meiho University",
  },
  {
    label: "Meiji Gakuin University",
    value: "Meiji Gakuin University",
  },
  {
    label: "Meiji Pharmaceutical University",
    value: "Meiji Pharmaceutical University",
  },
  {
    label: "Meiji University",
    value: "Meiji University",
  },
  {
    label: "Meiji University of Integrative Medicine",
    value: "Meiji University of Integrative Medicine",
  },
  {
    label: "Meijo University",
    value: "Meijo University",
  },
  {
    label: "Meikai University",
    value: "Meikai University",
  },
  {
    label: "Meiktila University",
    value: "Meiktila University",
  },
  {
    label: "Meiktila University of Economics",
    value: "Meiktila University of Economics",
  },
  {
    label: "Meio University",
    value: "Meio University",
  },
  {
    label: "Meisei University",
    value: "Meisei University",
  },
  {
    label: "Mejiro University",
    value: "Mejiro University",
  },
  {
    label: "Mekelle University",
    value: "Mekelle University",
  },
  {
    label: "Melitopol State Pedagogical University",
    value: "Melitopol State Pedagogical University",
  },
  {
    label: "Memorial University of Newfoundland",
    value: "Memorial University of Newfoundland",
  },
  {
    label: "Mendeleev University of Chemical Technology of Russia",
    value: "Mendeleev University of Chemical Technology of Russia",
  },
  {
    label: "Mendelova univerzita v Brne",
    value: "Mendelova univerzita v Brne",
  },
  {
    label: "Menlo College",
    value: "Menlo College",
  },
  {
    label: "Menoufia University",
    value: "Menoufia University",
  },
  {
    label: "Mercer University",
    value: "Mercer University",
  },
  {
    label: "Mercy College of Health Sciences",
    value: "Mercy College of Health Sciences",
  },
  {
    label: "Mercy College of Ohio",
    value: "Mercy College of Ohio",
  },
  {
    label: "Mercy University",
    value: "Mercy University",
  },
  {
    label: "Mercyhurst University",
    value: "Mercyhurst University",
  },
  {
    label: "Meredith College",
    value: "Meredith College",
  },
  {
    label: "Merowe University of Technology",
    value: "Merowe University of Technology",
  },
  {
    label: "Merrimack College",
    value: "Merrimack College",
  },
  {
    label: "Mersin Üniversitesi",
    value: "Mersin Üniversitesi",
  },
  {
    label: "Meru University of Science and Technology",
    value: "Meru University of Science and Technology",
  },
  {
    label: "Merz Akademie",
    value: "Merz Akademie",
  },
  {
    label: "Mesoyios College",
    value: "Mesoyios College",
  },
  {
    label: "Messiah University",
    value: "Messiah University",
  },
  {
    label: "Metharath University",
    value: "Metharath University",
  },
  {
    label: "Methodist College",
    value: "Methodist College",
  },
  {
    label: "Methodist University",
    value: "Methodist University",
  },
  {
    label: "Methodist University",
    value: "Methodist University",
  },
  {
    label: "Metropolia Ammattikorkeakoulu",
    value: "Metropolia Ammattikorkeakoulu",
  },
  {
    label: "Metropolitan College of New York",
    value: "Metropolitan College of New York",
  },
  {
    label: "Metropolitan International University",
    value: "Metropolitan International University",
  },
  {
    label: "Metropolitan State University",
    value: "Metropolitan State University",
  },
  {
    label: "Metropolitan State University of Denver",
    value: "Metropolitan State University of Denver",
  },
  {
    label: "Metropolitan University",
    value: "Metropolitan University",
  },
  {
    label: "Metropolitní univerzita v Praze",
    value: "Metropolitní univerzita v Praze",
  },
  {
    label: "Mewar University",
    value: "Mewar University",
  },
  {
    label: "Meybod University",
    value: "Meybod University",
  },
  {
    label: "Meycauayan College",
    value: "Meycauayan College",
  },
  {
    label: "MF vitenskapelig høyskole",
    value: "MF vitenskapelig høyskole",
  },
  {
    label: "MGH Institute of Health Professions",
    value: "MGH Institute of Health Professions",
  },
  {
    label: "MGM Institute of Health Sciences",
    value: "MGM Institute of Health Sciences",
  },
  {
    label: "Miami Dade College",
    value: "Miami Dade College",
  },
  {
    label: "Miami University",
    value: "Miami University",
  },
  {
    label: "Mianyang Normal University",
    value: "Mianyang Normal University",
  },
  {
    label: "Michael and Cecilia Ibru University",
    value: "Michael and Cecilia Ibru University",
  },
  {
    label: "Michael Okpara University of Agriculture",
    value: "Michael Okpara University of Agriculture",
  },
  {
    label: "Michigan School of Psychology",
    value: "Michigan School of Psychology",
  },
  {
    label: "Michigan State University",
    value: "Michigan State University",
  },
  {
    label: "Michigan Technological University",
    value: "Michigan Technological University",
  },
  {
    label: "Michurinsk State Agrarian University",
    value: "Michurinsk State Agrarian University",
  },
  {
    label: "Mico University College",
    value: "Mico University College",
  },
  {
    label: "Mid Western University",
    value: "Mid Western University",
  },
  {
    label: "Mid-America Christian University",
    value: "Mid-America Christian University",
  },
  {
    label: "MidAmerica Nazarene University",
    value: "MidAmerica Nazarene University",
  },
  {
    label: "Mid-Atlantic Christian University",
    value: "Mid-Atlantic Christian University",
  },
  {
    label: "Middle East College",
    value: "Middle East College",
  },
  {
    label: "Middle East University",
    value: "Middle East University",
  },
  {
    label: "Middle East University, Jordan",
    value: "Middle East University, Jordan",
  },
  {
    label: "Middle Georgia State University",
    value: "Middle Georgia State University",
  },
  {
    label: "Middle Technical University",
    value: "Middle Technical University",
  },
  {
    label: "Middle Tennessee School of Anesthesia",
    value: "Middle Tennessee School of Anesthesia",
  },
  {
    label: "Middle Tennessee State University",
    value: "Middle Tennessee State University",
  },
  {
    label: "Middlebury College",
    value: "Middlebury College",
  },
  {
    label: "Middlesex University",
    value: "Middlesex University",
  },
  {
    label: "Middlesex University Dubai",
    value: "Middlesex University Dubai",
  },
  {
    label: "Middlesex University Malta",
    value: "Middlesex University Malta",
  },
  {
    label: "Midland College",
    value: "Midland College",
  },
  {
    label: "Midland University",
    value: "Midland University",
  },
  {
    label: "Midlands State University",
    value: "Midlands State University",
  },
  {
    label: "Midway University",
    value: "Midway University",
  },
  {
    label: "Midwestern State University",
    value: "Midwestern State University",
  },
  {
    label: "Midwestern University",
    value: "Midwestern University",
  },
  {
    label: "Mie Prefectural College of Nursing",
    value: "Mie Prefectural College of Nursing",
  },
  {
    label: "Mie University",
    value: "Mie University",
  },
  {
    label: "Miedzynarodowa Wyzsza Szkola Logistyki i Transportu we Wroclawiu",
    value: "Miedzynarodowa Wyzsza Szkola Logistyki i Transportu we Wroclawiu",
  },
  {
    label: "Mientrung University of Civil Engineering",
    value: "Mientrung University of Civil Engineering",
  },
  {
    label: "Miles College",
    value: "Miles College",
  },
  {
    label: "Mili Institute of Higher Education",
    value: "Mili Institute of Higher Education",
  },
  {
    label: "Millennium University",
    value: "Millennium University",
  },
  {
    label: "Millersville University of Pennsylvania",
    value: "Millersville University of Pennsylvania",
  },
  {
    label: "Milli Aviasiya Akademiyasi",
    value: "Milli Aviasiya Akademiyasi",
  },
  {
    label: "Milligan University",
    value: "Milligan University",
  },
  {
    label: "Millikin University",
    value: "Millikin University",
  },
  {
    label: "Millsaps College",
    value: "Millsaps College",
  },
  {
    label: "Milton Friedman Egyetem",
    value: "Milton Friedman Egyetem",
  },
  {
    label: "Milton Margai College of Education and Technology",
    value: "Milton Margai College of Education and Technology",
  },
  {
    label: "Milwaukee Institute of Art & Design",
    value: "Milwaukee Institute of Art & Design",
  },
  {
    label: "Milwaukee School of Engineering",
    value: "Milwaukee School of Engineering",
  },
  {
    label: "Mimar Sinan Güzel Sanatlar Üniversitesi",
    value: "Mimar Sinan Güzel Sanatlar Üniversitesi",
  },
  {
    label: "Mimasaka University",
    value: "Mimasaka University",
  },
  {
    label: "Minami Kyushu University",
    value: "Minami Kyushu University",
  },
  {
    label: "Mindanao State University",
    value: "Mindanao State University",
  },
  {
    label: "Mindanao State University - Iligan Institute of Technology",
    value: "Mindanao State University - Iligan Institute of Technology",
  },
  {
    label: "Mines Paris",
    value: "Mines Paris",
  },
  {
    label: "Ming Chi University of Technology",
    value: "Ming Chi University of Technology",
  },
  {
    label: "Ming Chuan University",
    value: "Ming Chuan University",
  },
  {
    label: "MingDao University",
    value: "MingDao University",
  },
  {
    label: "Mingeçevir Dövlet Universiteti",
    value: "Mingeçevir Dövlet Universiteti",
  },
  {
    label: "Minghsin University of Science and Technology",
    value: "Minghsin University of Science and Technology",
  },
  {
    label: "Minhaj University",
    value: "Minhaj University",
  },
  {
    label: "Minia University",
    value: "Minia University",
  },
  {
    label: "Mining-metallurgy Institute of Tajikistan",
    value: "Mining-metallurgy Institute of Tajikistan",
  },
  {
    label: "Minjiang University",
    value: "Minjiang University",
  },
  {
    label: "Minnan Normal University",
    value: "Minnan Normal University",
  },
  {
    label: "Minnan University of Science and Technology",
    value: "Minnan University of Science and Technology",
  },
  {
    label: "Minneapolis College of Art and Design",
    value: "Minneapolis College of Art and Design",
  },
  {
    label: "Minnesota State University Moorhead",
    value: "Minnesota State University Moorhead",
  },
  {
    label: "Minnesota State University, Mankato",
    value: "Minnesota State University, Mankato",
  },
  {
    label: "Minobusan University",
    value: "Minobusan University",
  },
  {
    label: "Minot State University",
    value: "Minot State University",
  },
  {
    label: "Minsk Innovation University",
    value: "Minsk Innovation University",
  },
  {
    label: "Minsk State Linguistic University",
    value: "Minsk State Linguistic University",
  },
  {
    label: "Minth University of Science and Technology",
    value: "Minth University of Science and Technology",
  },
  {
    label: "Minzu University of China",
    value: "Minzu University of China",
  },
  {
    label: "Miriam College",
    value: "Miriam College",
  },
  {
    label: "Mirpur University of Science and Technology",
    value: "Mirpur University of Science and Technology",
  },
  {
    label: "Misamis Oriental State College of Agriculture and Technology",
    value: "Misamis Oriental State College of Agriculture and Technology",
  },
  {
    label: "Misamis University",
    value: "Misamis University",
  },
  {
    label: "Misericordia University",
    value: "Misericordia University",
  },
  {
    label: "Miskolci Egyetem",
    value: "Miskolci Egyetem",
  },
  {
    label: "Misr International University",
    value: "Misr International University",
  },
  {
    label: "Misr University for Science and Technology",
    value: "Misr University for Science and Technology",
  },
  {
    label: "Mission University",
    value: "Mission University",
  },
  {
    label: "Mississippi College",
    value: "Mississippi College",
  },
  {
    label: "Mississippi State University",
    value: "Mississippi State University",
  },
  {
    label: "Mississippi University for Women",
    value: "Mississippi University for Women",
  },
  {
    label: "Mississippi Valley State University",
    value: "Mississippi Valley State University",
  },
  {
    label: "Missouri Baptist University",
    value: "Missouri Baptist University",
  },
  {
    label: "Missouri Southern State University",
    value: "Missouri Southern State University",
  },
  {
    label: "Missouri State University",
    value: "Missouri State University",
  },
  {
    label: "Missouri University of Science and Technology",
    value: "Missouri University of Science and Technology",
  },
  {
    label: "Missouri Valley College",
    value: "Missouri Valley College",
  },
  {
    label: "Missouri Western State University",
    value: "Missouri Western State University",
  },
  {
    label: "Misurata University",
    value: "Misurata University",
  },
  {
    label: "MIT Art Design and Technology University",
    value: "MIT Art Design and Technology University",
  },
  {
    label: "MIT University",
    value: "MIT University",
  },
  {
    label: "MIT University Dakar",
    value: "MIT University Dakar",
  },
  {
    label: "MIT Univerzitet",
    value: "MIT Univerzitet",
  },
  {
    label: "Mitchell College",
    value: "Mitchell College",
  },
  {
    label: "Mitchell Hamline School of Law",
    value: "Mitchell Hamline School of Law",
  },
  {
    label: "Mittuniversitetet",
    value: "Mittuniversitetet",
  },
  {
    label: "Miyagi Gakuin Women's University",
    value: "Miyagi Gakuin Women's University",
  },
  {
    label: "Miyagi University",
    value: "Miyagi University",
  },
  {
    label: "Miyagi University of Education",
    value: "Miyagi University of Education",
  },
  {
    label: "Miyazaki International University",
    value: "Miyazaki International University",
  },
  {
    label: "Miyazaki Municipal University",
    value: "Miyazaki Municipal University",
  },
  {
    label: "Miyazaki Prefectural Nursing University",
    value: "Miyazaki Prefectural Nursing University",
  },
  {
    label: "Miyazaki Sangyo-keiei University",
    value: "Miyazaki Sangyo-keiei University",
  },
  {
    label: "Mizan Tepi University",
    value: "Mizan Tepi University",
  },
  {
    label: "Mizoram University",
    value: "Mizoram University",
  },
  {
    label: "Mkitar Gosh Armenian-Russian International University",
    value: "Mkitar Gosh Armenian-Russian International University",
  },
  {
    label: "MKU International University of Technology",
    value: "MKU International University of Technology",
  },
  {
    label: "MLC Fakulteta za management in pravo Ljubljana",
    value: "MLC Fakulteta za management in pravo Ljubljana",
  },
  {
    label: "Modern College of Business and Science",
    value: "Modern College of Business and Science",
  },
  {
    label: "Modern International University",
    value: "Modern International University",
  },
  {
    label: "Modern Sciences and Arts University",
    value: "Modern Sciences and Arts University",
  },
  {
    label: "Modern University College",
    value: "Modern University College",
  },
  {
    label: "Modern University for Business and Science",
    value: "Modern University for Business and Science",
  },
  {
    label: "Modern University for Technology and Information",
    value: "Modern University for Technology and Information",
  },
  {
    label: "Modern University for the Humanities",
    value: "Modern University for the Humanities",
  },
  {
    label: "Modibbo Adama University, Yola",
    value: "Modibbo Adama University, Yola",
  },
  {
    label: "MODUL University Vienna",
    value: "MODUL University Vienna",
  },
  {
    label: "Mody University of Science and Technology",
    value: "Mody University of Science and Technology",
  },
  {
    label: "Mofid University",
    value: "Mofid University",
  },
  {
    label: "Mogilev State A. Kuleshov University",
    value: "Mogilev State A. Kuleshov University",
  },
  {
    label: "Mohamed Bin Zayed University for Humanities",
    value: "Mohamed Bin Zayed University for Humanities",
  },
  {
    label: "Mohamed bin Zayed University of Artificial Intelligence",
    value: "Mohamed bin Zayed University of Artificial Intelligence",
  },
  {
    label: "Mohammad Ali Jauhar University",
    value: "Mohammad Ali Jauhar University",
  },
  {
    label: "Mohammad Ali Jinnah University",
    value: "Mohammad Ali Jinnah University",
  },
  {
    label: "Mohammed Bin Rashid School of Government",
    value: "Mohammed Bin Rashid School of Government",
  },
  {
    label: "Mohammed Bin Rashid University of Medicine and Health Sciences",
    value: "Mohammed Bin Rashid University of Medicine and Health Sciences",
  },
  {
    label: "Mohanlal Sukhadia University",
    value: "Mohanlal Sukhadia University",
  },
  {
    label: "Mohi-ud-Din Islamic University",
    value: "Mohi-ud-Din Islamic University",
  },
  {
    label: "Moholy-Nagy Muvészeti Egyetem",
    value: "Moholy-Nagy Muvészeti Egyetem",
  },
  {
    label: "Moi University",
    value: "Moi University",
  },
  {
    label: "Mokpo Catholic University",
    value: "Mokpo Catholic University",
  },
  {
    label: "Mokpo National Maritime University",
    value: "Mokpo National Maritime University",
  },
  {
    label: "Mokpo National University",
    value: "Mokpo National University",
  },
  {
    label: "Mokwon University",
    value: "Mokwon University",
  },
  {
    label: "Molloy University",
    value: "Molloy University",
  },
  {
    label: "Momoyama Gakuin University",
    value: "Momoyama Gakuin University",
  },
  {
    label: "Momoyama Gakuin University",
    value: "Momoyama Gakuin University",
  },
  {
    label: "Monad University",
    value: "Monad University",
  },
  {
    label: "Mon-Altius Institute",
    value: "Mon-Altius Institute",
  },
  {
    label: "Monash University",
    value: "Monash University",
  },
  {
    label: "Mongol Institute",
    value: "Mongol Institute",
  },
  {
    label: "Mongolia International University",
    value: "Mongolia International University",
  },
  {
    label: "Mongolian Labour and Social Relations Institute",
    value: "Mongolian Labour and Social Relations Institute",
  },
  {
    label: "Mongolian National Institute of Physical Education",
    value: "Mongolian National Institute of Physical Education",
  },
  {
    label: "Mongolian National University",
    value: "Mongolian National University",
  },
  {
    label: "Mongolian National University of Arts and Culture",
    value: "Mongolian National University of Arts and Culture",
  },
  {
    label: "Mongolian National University of Medical Sciences",
    value: "Mongolian National University of Medical Sciences",
  },
  {
    label: "Mongolian State Conservatory",
    value: "Mongolian State Conservatory",
  },
  {
    label: "Mongolian State University of Education",
    value: "Mongolian State University of Education",
  },
  {
    label: "Mongolian University of Life Sciences",
    value: "Mongolian University of Life Sciences",
  },
  {
    label: "Mongolian University of Science and Technology",
    value: "Mongolian University of Science and Technology",
  },
  {
    label: "Monmouth College",
    value: "Monmouth College",
  },
  {
    label: "Monmouth University",
    value: "Monmouth University",
  },
  {
    label: "Monroe College",
    value: "Monroe College",
  },
  {
    label: "Montana State University",
    value: "Montana State University",
  },
  {
    label: "Montana State University Billings",
    value: "Montana State University Billings",
  },
  {
    label: "Montana State University-Northern",
    value: "Montana State University-Northern",
  },
  {
    label: "Montana Tech",
    value: "Montana Tech",
  },
  {
    label: "Montanuniversität Leoben",
    value: "Montanuniversität Leoben",
  },
  {
    label: "Montclair State University",
    value: "Montclair State University",
  },
  {
    label: "Montpellier Business School",
    value: "Montpellier Business School",
  },
  {
    label: "Montpellier SupAgro",
    value: "Montpellier SupAgro",
  },
  {
    label: "Montreat College",
    value: "Montreat College",
  },
  {
    label: "Montserrat College of Art",
    value: "Montserrat College of Art",
  },
  {
    label: "Monywa University",
    value: "Monywa University",
  },
  {
    label: "Monywa University of Economics",
    value: "Monywa University of Economics",
  },
  {
    label: "Moody Bible Institute",
    value: "Moody Bible Institute",
  },
  {
    label: "Moore College of Art and Design",
    value: "Moore College of Art and Design",
  },
  {
    label: "Moraa Female University",
    value: "Moraa Female University",
  },
  {
    label: "Moravian University",
    value: "Moravian University",
  },
  {
    label: "Moravská vysoká škola Olomouc",
    value: "Moravská vysoká škola Olomouc",
  },
  {
    label: "Morehead State University",
    value: "Morehead State University",
  },
  {
    label: "Morehouse College",
    value: "Morehouse College",
  },
  {
    label: "Morehouse School of Medicine",
    value: "Morehouse School of Medicine",
  },
  {
    label: "Morgan State University",
    value: "Morgan State University",
  },
  {
    label: "Morinomiya University of Medical Sciences",
    value: "Morinomiya University of Medical Sciences",
  },
  {
    label: "Morioka University",
    value: "Morioka University",
  },
  {
    label: "Morningside University",
    value: "Morningside University",
  },
  {
    label: "Morris College",
    value: "Morris College",
  },
  {
    label: "Morrisville State College",
    value: "Morrisville State College",
  },
  {
    label: "Mosa University",
    value: "Mosa University",
  },
  {
    label: "Moscow Automobile and Road Construction State Technical University",
    value: "Moscow Automobile and Road Construction State Technical University",
  },
  {
    label: "Moscow Aviation Institute",
    value: "Moscow Aviation Institute",
  },
  {
    label: "Moscow City Teachers' Training University",
    value: "Moscow City Teachers' Training University",
  },
  {
    label: "Moscow Financial and Law University",
    value: "Moscow Financial and Law University",
  },
  {
    label:
      "Moscow Information Technology University - Moscow Institute of Architecture and Civil Engineering",
    value:
      "Moscow Information Technology University - Moscow Institute of Architecture and Civil Engineering",
  },
  {
    label: "Moscow Institute of Physics and Technology",
    value: "Moscow Institute of Physics and Technology",
  },
  {
    label: "Moscow Institute of Public Administration and Law",
    value: "Moscow Institute of Public Administration and Law",
  },
  {
    label: "Moscow International Higher Business School",
    value: "Moscow International Higher Business School",
  },
  {
    label: "Moscow International University",
    value: "Moscow International University",
  },
  {
    label: "Moscow Medical Academy",
    value: "Moscow Medical Academy",
  },
  {
    label: "Moscow Metropolitan Governance University",
    value: "Moscow Metropolitan Governance University",
  },
  {
    label: "Moscow Polytech",
    value: "Moscow Polytech",
  },
  {
    label: "Moscow State Academy of Physical Culture",
    value: "Moscow State Academy of Physical Culture",
  },
  {
    label: "Moscow State Industrial Art University",
    value: "Moscow State Industrial Art University",
  },
  {
    label: "Moscow State Institute of Culture",
    value: "Moscow State Institute of Culture",
  },
  {
    label: "Moscow State Institute of International Relations",
    value: "Moscow State Institute of International Relations",
  },
  {
    label: "Moscow State Linguistic University",
    value: "Moscow State Linguistic University",
  },
  {
    label: "Moscow State Pedagogical University",
    value: "Moscow State Pedagogical University",
  },
  {
    label: "Moscow State Technical University of Civil Aviation",
    value: "Moscow State Technical University of Civil Aviation",
  },
  {
    label: "Moscow State Technological University 'Stankin'",
    value: "Moscow State Technological University 'Stankin'",
  },
  {
    label: "Moscow State University",
    value: "Moscow State University",
  },
  {
    label: "Moscow State University Lomonosov in Dushanbe",
    value: "Moscow State University Lomonosov in Dushanbe",
  },
  {
    label: "Moscow State University of Civil Engineering",
    value: "Moscow State University of Civil Engineering",
  },
  {
    label: "Moscow State University of Environmental Engineering",
    value: "Moscow State University of Environmental Engineering",
  },
  {
    label: "Moscow State University of Food Production",
    value: "Moscow State University of Food Production",
  },
  {
    label: "Moscow State University of Geodesy and Cartography",
    value: "Moscow State University of Geodesy and Cartography",
  },
  {
    label: "Moscow State University of Psychology and Education",
    value: "Moscow State University of Psychology and Education",
  },
  {
    label: "Moscow State University of Technology and Management",
    value: "Moscow State University of Technology and Management",
  },
  {
    label: "Moscow Tchaikovsky Conservatory",
    value: "Moscow Tchaikovsky Conservatory",
  },
  {
    label: "Moscow Technical University - MIREA",
    value: "Moscow Technical University - MIREA",
  },
  {
    label: "Moscow Technical University of Communications and Informatics",
    value: "Moscow Technical University of Communications and Informatics",
  },
  {
    label: "Moscow University for the Humanities",
    value: "Moscow University for the Humanities",
  },
  {
    label: "Moscow University Touro",
    value: "Moscow University Touro",
  },
  {
    label: "Moshi Co-operative University",
    value: "Moshi Co-operative University",
  },
  {
    label: "Moshood Abiola Polytechnic, Abeokuta",
    value: "Moshood Abiola Polytechnic, Abeokuta",
  },
  {
    label: "Mother Teresa Women's University",
    value: "Mother Teresa Women's University",
  },
  {
    label: "Motherhood University",
    value: "Motherhood University",
  },
  {
    label: "Motilal Nehru National Institute of Technology Allahabad",
    value: "Motilal Nehru National Institute of Technology Allahabad",
  },
  {
    label: "Mount Allison University",
    value: "Mount Allison University",
  },
  {
    label: "Mount Aloysius College",
    value: "Mount Aloysius College",
  },
  {
    label: "Mount Carmel College of Nursing",
    value: "Mount Carmel College of Nursing",
  },
  {
    label: "Mount Holyoke College",
    value: "Mount Holyoke College",
  },
  {
    label: "Mount Kenya University",
    value: "Mount Kenya University",
  },
  {
    label: "Mount Marty University",
    value: "Mount Marty University",
  },
  {
    label: "Mount Mary University",
    value: "Mount Mary University",
  },
  {
    label: "Mount Mercy University",
    value: "Mount Mercy University",
  },
  {
    label: "Mount Meru University",
    value: "Mount Meru University",
  },
  {
    label: "Mount Royal University",
    value: "Mount Royal University",
  },
  {
    label: "Mount Saint Mary College",
    value: "Mount Saint Mary College",
  },
  {
    label: "Mount Saint Mary's University",
    value: "Mount Saint Mary's University",
  },
  {
    label: "Mount Saint Vincent University",
    value: "Mount Saint Vincent University",
  },
  {
    label: "Mount St. Joseph University",
    value: "Mount St. Joseph University",
  },
  {
    label: "Mount St. Mary's University",
    value: "Mount St. Mary's University",
  },
  {
    label: "Mount Vernon Nazarene University",
    value: "Mount Vernon Nazarene University",
  },
  {
    label: "Mountain Top University",
    value: "Mountain Top University",
  },
  {
    label: "Mountain View College",
    value: "Mountain View College",
  },
  {
    label: "Mountains of the Moon University",
    value: "Mountains of the Moon University",
  },
  {
    label: "Mountcrest University College",
    value: "Mountcrest University College",
  },
  {
    label: "Moutai Institute",
    value: "Moutai Institute",
  },
  {
    label: "Mozyr State Pedagogical University",
    value: "Mozyr State Pedagogical University",
  },
  {
    label: "MSB Medical School Berlin",
    value: "MSB Medical School Berlin",
  },
  {
    label: "MT&M College",
    value: "MT&M College",
  },
  {
    label: "Muban Chombueng Rajabhat University",
    value: "Muban Chombueng Rajabhat University",
  },
  {
    label: "Mudanjiang Medical University",
    value: "Mudanjiang Medical University",
  },
  {
    label: "Mudanjiang Normal University",
    value: "Mudanjiang Normal University",
  },
  {
    label: "Mugla Sitki Koçman Üniversitesi",
    value: "Mugla Sitki Koçman Üniversitesi",
  },
  {
    label:
      "Muhammad al-Xorazmiy nomidagi Toshkent Axborot Texnologiyalari Universiteti",
    value:
      "Muhammad al-Xorazmiy nomidagi Toshkent Axborot Texnologiyalari Universiteti",
  },
  {
    label: "Muhammad Nawaz Shareef University of Agriculture, Multan",
    value: "Muhammad Nawaz Shareef University of Agriculture, Multan",
  },
  {
    label: "Muhammad Nawaz Sharif University of Engineering and Technology",
    value: "Muhammad Nawaz Sharif University of Engineering and Technology",
  },
  {
    label: "Muhimbili University of Health and Allied Sciences",
    value: "Muhimbili University of Health and Allied Sciences",
  },
  {
    label: "Muhlenberg College",
    value: "Muhlenberg College",
  },
  {
    label: "Mukachevo State University",
    value: "Mukachevo State University",
  },
  {
    label: "Mukogawa Women's University",
    value: "Mukogawa Women's University",
  },
  {
    label: "Mukuba University",
    value: "Mukuba University",
  },
  {
    label: "Multimedia University",
    value: "Multimedia University",
  },
  {
    label: "Multimedia University of Kenya",
    value: "Multimedia University of Kenya",
  },
  {
    label: "Multnomah University",
    value: "Multnomah University",
  },
  {
    label: "Mulungushi University",
    value: "Mulungushi University",
  },
  {
    label: "Muni University",
    value: "Muni University",
  },
  {
    label: "Munich Business School",
    value: "Munich Business School",
  },
  {
    label: "Munster Technological University",
    value: "Munster Technological University",
  },
  {
    label: "Munzur Üniversitesi",
    value: "Munzur Üniversitesi",
  },
  {
    label: "Murang'a University of Technology",
    value: "Murang'a University of Technology",
  },
  {
    label: "Murdoch University",
    value: "Murdoch University",
  },
  {
    label: "Murdoch University Dubai",
    value: "Murdoch University Dubai",
  },
  {
    label: "Murmansk Arctic State University",
    value: "Murmansk Arctic State University",
  },
  {
    label: "Murmansk State Technical University",
    value: "Murmansk State Technical University",
  },
  {
    label: "Muroran Institute of Technology",
    value: "Muroran Institute of Technology",
  },
  {
    label: "Murray State University",
    value: "Murray State University",
  },
  {
    label: "Murshidabad University",
    value: "Murshidabad University",
  },
  {
    label: "Mus Alparslan Üniversitesi",
    value: "Mus Alparslan Üniversitesi",
  },
  {
    label: "Musashi University",
    value: "Musashi University",
  },
  {
    label: "Musashino Academia Musicae",
    value: "Musashino Academia Musicae",
  },
  {
    label: "Musashino Art University",
    value: "Musashino Art University",
  },
  {
    label: "Musashino Gakuin University",
    value: "Musashino Gakuin University",
  },
  {
    label: "Musashino University",
    value: "Musashino University",
  },
  {
    label: "Muscat College",
    value: "Muscat College",
  },
  {
    label: "Muscat University",
    value: "Muscat University",
  },
  {
    label: "Musik und Kunst Privatuniversität der Stadt Wien",
    value: "Musik und Kunst Privatuniversität der Stadt Wien",
  },
  {
    label: "Musikhochschule Lübeck",
    value: "Musikhochschule Lübeck",
  },
  {
    label: "Muskingum University",
    value: "Muskingum University",
  },
  {
    label: "Muslim University of Morogoro",
    value: "Muslim University of Morogoro",
  },
  {
    label: "Muslim Youth University",
    value: "Muslim Youth University",
  },
  {
    label: "Mutah university",
    value: "Mutah university",
  },
  {
    label: "Muteesa I Royal University",
    value: "Muteesa I Royal University",
  },
  {
    label: "Muthesius Kunsthochschule",
    value: "Muthesius Kunsthochschule",
  },
  {
    label: "MVN University",
    value: "MVN University",
  },
  {
    label: "Mwalimu Julius K. Nyerere University of Agriculture and Technology",
    value: "Mwalimu Julius K. Nyerere University of Agriculture and Technology",
  },
  {
    label: "Mwenge Catholic University",
    value: "Mwenge Catholic University",
  },
  {
    label: "Myanmar Aerospace Engineering University",
    value: "Myanmar Aerospace Engineering University",
  },
  {
    label: "Myanmar Maritime University",
    value: "Myanmar Maritime University",
  },
  {
    label: "Myeik University",
    value: "Myeik University",
  },
  {
    label: "Mykolayiv National Agrarian University",
    value: "Mykolayiv National Agrarian University",
  },
  {
    label: "Mykolayiv National University",
    value: "Mykolayiv National University",
  },
  {
    label: "Mykolo Romerio Universitetas",
    value: "Mykolo Romerio Universitetas",
  },
  {
    label: "Myongji University",
    value: "Myongji University",
  },
  {
    label: "Mzumbe University",
    value: "Mzumbe University",
  },
  {
    label: "Mzuzu University",
    value: "Mzuzu University",
  },
  {
    label: "N.P.I. University of Bangladesh",
    value: "N.P.I. University of Bangladesh",
  },
  {
    label: "N.R.U. Moscow Power Engineering Institute in Dushanbe",
    value: "N.R.U. Moscow Power Engineering Institute in Dushanbe",
  },
  {
    label: "Nadbuzanska Szkola Wyzsza im. Marka J. Karpia w Siemiatyczach",
    value: "Nadbuzanska Szkola Wyzsza im. Marka J. Karpia w Siemiatyczach",
  },
  {
    label: "Nagahama Institute of Bio-Science and Technology",
    value: "Nagahama Institute of Bio-Science and Technology",
  },
  {
    label: "Nagaland University",
    value: "Nagaland University",
  },
  {
    label: "Nagano College of Nursing",
    value: "Nagano College of Nursing",
  },
  {
    label: "Nagano University",
    value: "Nagano University",
  },
  {
    label: "Nagano University of Health and Medicine",
    value: "Nagano University of Health and Medicine",
  },
  {
    label: "Nagaoka Institute of Design",
    value: "Nagaoka Institute of Design",
  },
  {
    label: "Nagaoka Sutoku University",
    value: "Nagaoka Sutoku University",
  },
  {
    label: "Nagaoka University",
    value: "Nagaoka University",
  },
  {
    label: "Nagaoka University of Technology",
    value: "Nagaoka University of Technology",
  },
  {
    label: "Nagasaki Institute of Applied Science",
    value: "Nagasaki Institute of Applied Science",
  },
  {
    label: "Nagasaki International University",
    value: "Nagasaki International University",
  },
  {
    label: "Nagasaki Junshin Catholic University",
    value: "Nagasaki Junshin Catholic University",
  },
  {
    label: "Nagasaki University",
    value: "Nagasaki University",
  },
  {
    label: "Nagasaki University of Foreign Studies",
    value: "Nagasaki University of Foreign Studies",
  },
  {
    label: "Nagoya Bunri University",
    value: "Nagoya Bunri University",
  },
  {
    label: "Nagoya City University",
    value: "Nagoya City University",
  },
  {
    label: "Nagoya College of Music",
    value: "Nagoya College of Music",
  },
  {
    label: "Nagoya Gakuin University",
    value: "Nagoya Gakuin University",
  },
  {
    label: "Nagoya Institute of Technology",
    value: "Nagoya Institute of Technology",
  },
  {
    label: "Nagoya Ryujo Women's University",
    value: "Nagoya Ryujo Women's University",
  },
  {
    label: "Nagoya Sangyo University",
    value: "Nagoya Sangyo University",
  },
  {
    label: "Nagoya University",
    value: "Nagoya University",
  },
  {
    label: "Nagoya University of Arts and Sciences",
    value: "Nagoya University of Arts and Sciences",
  },
  {
    label: "Nagoya University of Commerce and Business",
    value: "Nagoya University of Commerce and Business",
  },
  {
    label: "Nagoya University of Economics",
    value: "Nagoya University of Economics",
  },
  {
    label: "Nagoya University of Foreign Studies",
    value: "Nagoya University of Foreign Studies",
  },
  {
    label: "Nagoya University of the Arts",
    value: "Nagoya University of the Arts",
  },
  {
    label: "Nagoya Women's University",
    value: "Nagoya Women's University",
  },
  {
    label: "Nagoya Zokei University of Art & Design",
    value: "Nagoya Zokei University of Art & Design",
  },
  {
    label: "Nahavand University",
    value: "Nahavand University",
  },
  {
    label: "Nahda University",
    value: "Nahda University",
  },
  {
    label: "Najran University",
    value: "Najran University",
  },
  {
    label: "Nakamura Gakuen University",
    value: "Nakamura Gakuen University",
  },
  {
    label: "Nakhon Pathom Rajabhat University",
    value: "Nakhon Pathom Rajabhat University",
  },
  {
    label: "Nakhon Phanom University",
    value: "Nakhon Phanom University",
  },
  {
    label: "Nakhon Ratchasima Rajabhat University",
    value: "Nakhon Ratchasima Rajabhat University",
  },
  {
    label: "Nakhon Sawan Rajabhat University",
    value: "Nakhon Sawan Rajabhat University",
  },
  {
    label: "Nakhon Si Thammarat Rajabhat University",
    value: "Nakhon Si Thammarat Rajabhat University",
  },
  {
    label: "Nalanda University",
    value: "Nalanda University",
  },
  {
    label: "NALSAR University of Law",
    value: "NALSAR University of Law",
  },
  {
    label: "Nalut University",
    value: "Nalut University",
  },
  {
    label: "Namangan davlat pedagogika instituti",
    value: "Namangan davlat pedagogika instituti",
  },
  {
    label: "Namangan muhandislik qurilish instituti",
    value: "Namangan muhandislik qurilish instituti",
  },
  {
    label: "Namangan Muhandislik-Texnologiya Instituti",
    value: "Namangan Muhandislik-Texnologiya Instituti",
  },
  {
    label: "Nambu University",
    value: "Nambu University",
  },
  {
    label: "Namibia University of Science and Technology",
    value: "Namibia University of Science and Technology",
  },
  {
    label: "Namseoul University",
    value: "Namseoul University",
  },
  {
    label: "Nan Jeon University of Science and Technology",
    value: "Nan Jeon University of Science and Technology",
  },
  {
    label: "Nan Kai University of Technology",
    value: "Nan Kai University of Technology",
  },
  {
    label: "Nanaji Deshmukh Veterinary Science University",
    value: "Nanaji Deshmukh Veterinary Science University",
  },
  {
    label: "Nanchang HangKong University",
    value: "Nanchang HangKong University",
  },
  {
    label: "Nanchang Institute of Science and Technology",
    value: "Nanchang Institute of Science and Technology",
  },
  {
    label: "Nanchang Institute of Technology",
    value: "Nanchang Institute of Technology",
  },
  {
    label: "Nanchang Institute of Technology",
    value: "Nanchang Institute of Technology",
  },
  {
    label: "Nanchang Normal University",
    value: "Nanchang Normal University",
  },
  {
    label: "Nanchang University",
    value: "Nanchang University",
  },
  {
    label: "Nangarhar University",
    value: "Nangarhar University",
  },
  {
    label: "Nanhua University",
    value: "Nanhua University",
  },
  {
    label: "Nanjing Agricultural University",
    value: "Nanjing Agricultural University",
  },
  {
    label: "Nanjing Audit University",
    value: "Nanjing Audit University",
  },
  {
    label: "Nanjing Forestry University",
    value: "Nanjing Forestry University",
  },
  {
    label: "Nanjing Institute of Technology",
    value: "Nanjing Institute of Technology",
  },
  {
    label: "Nanjing Medical University",
    value: "Nanjing Medical University",
  },
  {
    label: "Nanjing Normal University",
    value: "Nanjing Normal University",
  },
  {
    label: "Nanjing Sport Institute",
    value: "Nanjing Sport Institute",
  },
  {
    label: "Nanjing Tech University",
    value: "Nanjing Tech University",
  },
  {
    label: "Nanjing University",
    value: "Nanjing University",
  },
  {
    label: "Nanjing University of Aeronautics and Astronautics",
    value: "Nanjing University of Aeronautics and Astronautics",
  },
  {
    label: "Nanjing University of Chinese Medicine",
    value: "Nanjing University of Chinese Medicine",
  },
  {
    label: "Nanjing University of Finance and Economics",
    value: "Nanjing University of Finance and Economics",
  },
  {
    label: "Nanjing University of Information Science and Technology",
    value: "Nanjing University of Information Science and Technology",
  },
  {
    label: "Nanjing University of Posts and Telecommunications",
    value: "Nanjing University of Posts and Telecommunications",
  },
  {
    label: "Nanjing University of Science and Technology",
    value: "Nanjing University of Science and Technology",
  },
  {
    label: "Nanjing University of the Arts",
    value: "Nanjing University of the Arts",
  },
  {
    label: "Nanjing Xiaozhuang University",
    value: "Nanjing Xiaozhuang University",
  },
  {
    label: "Nankai University",
    value: "Nankai University",
  },
  {
    label: "Nanning Normal University",
    value: "Nanning Normal University",
  },
  {
    label: "Nanning University",
    value: "Nanning University",
  },
  {
    label: "Nantes Université",
    value: "Nantes Université",
  },
  {
    label: "NanTong Institute of Technology",
    value: "NanTong Institute of Technology",
  },
  {
    label: "Nantong University",
    value: "Nantong University",
  },
  {
    label: "Nanya Institute of Technology",
    value: "Nanya Institute of Technology",
  },
  {
    label: "Nanyang Academy of Fine Arts",
    value: "Nanyang Academy of Fine Arts",
  },
  {
    label: "Nanyang Institute of Technology",
    value: "Nanyang Institute of Technology",
  },
  {
    label: "Nanyang Normal University",
    value: "Nanyang Normal University",
  },
  {
    label: "Nanyang Technological University",
    value: "Nanyang Technological University",
  },
  {
    label: "Nanzan University",
    value: "Nanzan University",
  },
  {
    label: "Nara Institute of Science and Technology",
    value: "Nara Institute of Science and Technology",
  },
  {
    label: "Nara Medical University",
    value: "Nara Medical University",
  },
  {
    label: "Nara Prefectural University",
    value: "Nara Prefectural University",
  },
  {
    label: "Nara University",
    value: "Nara University",
  },
  {
    label: "Nara University of Education",
    value: "Nara University of Education",
  },
  {
    label: "Nara Women's University",
    value: "Nara Women's University",
  },
  {
    label: "Naragakuen University",
    value: "Naragakuen University",
  },
  {
    label: "Naresuan University",
    value: "Naresuan University",
  },
  {
    label: "Naropa University",
    value: "Naropa University",
  },
  {
    label: "Narsee Monjee Institute of Management and Higher Studies",
    value: "Narsee Monjee Institute of Management and Higher Studies",
  },
  {
    label: "Naruto University of Education",
    value: "Naruto University of Education",
  },
  {
    label: "Narxoz University",
    value: "Narxoz University",
  },
  {
    label: "Naryn State University",
    value: "Naryn State University",
  },
  {
    label: "Nasarawa State University",
    value: "Nasarawa State University",
  },
  {
    label: "Nation University",
    value: "Nation University",
  },
  {
    label: "National Academy of Arts",
    value: "National Academy of Arts",
  },
  {
    label: "National Academy of Arts of the Kyrgyz Republic",
    value: "National Academy of Arts of the Kyrgyz Republic",
  },
  {
    label: "National Academy of Management of Culture and Arts",
    value: "National Academy of Management of Culture and Arts",
  },
  {
    label: "National Academy of Music 'Pancho Vladigerov'",
    value: "National Academy of Music 'Pancho Vladigerov'",
  },
  {
    label: "National Academy of Visual Arts and Architecture",
    value: "National Academy of Visual Arts and Architecture",
  },
  {
    label: "National Aerospace University",
    value: "National Aerospace University",
  },
  {
    label: "National American University",
    value: "National American University",
  },
  {
    label: "National and Kapodistrian University of Athens",
    value: "National and Kapodistrian University of Athens",
  },
  {
    label: "National Aviation University",
    value: "National Aviation University",
  },
  {
    label: "National Central University",
    value: "National Central University",
  },
  {
    label: "National Changhua University of Education",
    value: "National Changhua University of Education",
  },
  {
    label: "National Cheng Kung University",
    value: "National Cheng Kung University",
  },
  {
    label: "National Chengchi University",
    value: "National Chengchi University",
  },
  {
    label: "National Chi Nan University",
    value: "National Chi Nan University",
  },
  {
    label: "National Chiayi University",
    value: "National Chiayi University",
  },
  {
    label: "National Chin-Yi University of Technology",
    value: "National Chin-Yi University of Technology",
  },
  {
    label: "National Chung Cheng University",
    value: "National Chung Cheng University",
  },
  {
    label: "National Chung Hsing University",
    value: "National Chung Hsing University",
  },
  {
    label: "National College of Art and Design",
    value: "National College of Art and Design",
  },
  {
    label: "National College of Arts",
    value: "National College of Arts",
  },
  {
    label: "National College of Business Administration and Economics",
    value: "National College of Business Administration and Economics",
  },
  {
    label: "National College of Business and Arts",
    value: "National College of Business and Arts",
  },
  {
    label: "National College of Ireland",
    value: "National College of Ireland",
  },
  {
    label: "National College of Nursing, Japan",
    value: "National College of Nursing, Japan",
  },
  {
    label: "National Dairy Research Institute",
    value: "National Dairy Research Institute",
  },
  {
    label: "National Defence University",
    value: "National Defence University",
  },
  {
    label: "National Defense College of the Philippines",
    value: "National Defense College of the Philippines",
  },
  {
    label: "National Defense University",
    value: "National Defense University",
  },
  {
    label: "National Dong Hwa University",
    value: "National Dong Hwa University",
  },
  {
    label: "National Economics University",
    value: "National Economics University",
  },
  {
    label: "National Fisheries University",
    value: "National Fisheries University",
  },
  {
    label: "National Forensic Sciences University",
    value: "National Forensic Sciences University",
  },
  {
    label: "National Forestry University of Ukraine",
    value: "National Forestry University of Ukraine",
  },
  {
    label: "National Formosa University",
    value: "National Formosa University",
  },
  {
    label: "National Graduate Institute for Policy Studies",
    value: "National Graduate Institute for Policy Studies",
  },
  {
    label: "National Ilan University",
    value: "National Ilan University",
  },
  {
    label: "National Institute of Business",
    value: "National Institute of Business",
  },
  {
    label: "National Institute of Design",
    value: "National Institute of Design",
  },
  {
    label: "National Institute of Development Administration",
    value: "National Institute of Development Administration",
  },
  {
    label: "National Institute of Education",
    value: "National Institute of Education",
  },
  {
    label: "National Institute of Educational Planning and Administration",
    value: "National Institute of Educational Planning and Administration",
  },
  {
    label: "National Institute of Fashion Technology",
    value: "National Institute of Fashion Technology",
  },
  {
    label: "National Institute of Fitness and Sports in Kanoya",
    value: "National Institute of Fitness and Sports in Kanoya",
  },
  {
    label:
      "National Institute of Food Technology Entrepreneurship and Management",
    value:
      "National Institute of Food Technology Entrepreneurship and Management",
  },
  {
    label: "National Institute of Mental Health and Neuro Sciences",
    value: "National Institute of Mental Health and Neuro Sciences",
  },
  {
    label:
      "National Institute of Pharmaceutical Education and Research, Ahmedabad",
    value:
      "National Institute of Pharmaceutical Education and Research, Ahmedabad",
  },
  {
    label:
      "National Institute of Pharmaceutical Education and Research, Guwahati",
    value:
      "National Institute of Pharmaceutical Education and Research, Guwahati",
  },
  {
    label:
      "National Institute of Pharmaceutical Education and Research, Hajipur",
    value:
      "National Institute of Pharmaceutical Education and Research, Hajipur",
  },
  {
    label:
      "National Institute of Pharmaceutical Education and Research, Hyderabad",
    value:
      "National Institute of Pharmaceutical Education and Research, Hyderabad",
  },
  {
    label:
      "National Institute of Pharmaceutical Education and Research, Kolkata",
    value:
      "National Institute of Pharmaceutical Education and Research, Kolkata",
  },
  {
    label:
      "National Institute of Pharmaceutical Education and Research, Raebareli",
    value:
      "National Institute of Pharmaceutical Education and Research, Raebareli",
  },
  {
    label:
      "National Institute of Pharmaceutical Education and Research, S.A.S. Nagar",
    value:
      "National Institute of Pharmaceutical Education and Research, S.A.S. Nagar",
  },
  {
    label: "National Institute of Sports and Tourism of Turkmenistan",
    value: "National Institute of Sports and Tourism of Turkmenistan",
  },
  {
    label: "National Institute of Technology Delhi",
    value: "National Institute of Technology Delhi",
  },
  {
    label: "National Institute of Technology Mizoram",
    value: "National Institute of Technology Mizoram",
  },
  {
    label: "National Institute of Technology Sikkim",
    value: "National Institute of Technology Sikkim",
  },
  {
    label: "National Institute of Technology, Agartala",
    value: "National Institute of Technology, Agartala",
  },
  {
    label: "National Institute of Technology, Arunachal Pradesh",
    value: "National Institute of Technology, Arunachal Pradesh",
  },
  {
    label: "National Institute of Technology, Calicut",
    value: "National Institute of Technology, Calicut",
  },
  {
    label: "National Institute of Technology, Durgapur",
    value: "National Institute of Technology, Durgapur",
  },
  {
    label: "National Institute of Technology, Goa",
    value: "National Institute of Technology, Goa",
  },
  {
    label: "National Institute of Technology, Hamirpur",
    value: "National Institute of Technology, Hamirpur",
  },
  {
    label: "National Institute of Technology, Jamshedpur",
    value: "National Institute of Technology, Jamshedpur",
  },
  {
    label: "National Institute of Technology, Karnataka",
    value: "National Institute of Technology, Karnataka",
  },
  {
    label: "National Institute of Technology, Kurukshetra",
    value: "National Institute of Technology, Kurukshetra",
  },
  {
    label: "National Institute of Technology, Manipur",
    value: "National Institute of Technology, Manipur",
  },
  {
    label: "National Institute of Technology, Meghalaya",
    value: "National Institute of Technology, Meghalaya",
  },
  {
    label: "National Institute of Technology, Nagaland",
    value: "National Institute of Technology, Nagaland",
  },
  {
    label: "National Institute of Technology, Patna",
    value: "National Institute of Technology, Patna",
  },
  {
    label: "National Institute of Technology, Puducherry",
    value: "National Institute of Technology, Puducherry",
  },
  {
    label: "National Institute of Technology, Raipur",
    value: "National Institute of Technology, Raipur",
  },
  {
    label: "National Institute of Technology, Rourkela",
    value: "National Institute of Technology, Rourkela",
  },
  {
    label: "National Institute of Technology, Silchar",
    value: "National Institute of Technology, Silchar",
  },
  {
    label: "National Institute of Technology, Srinagar",
    value: "National Institute of Technology, Srinagar",
  },
  {
    label: "National Institute of Technology, Tiruchirappalli",
    value: "National Institute of Technology, Tiruchirappalli",
  },
  {
    label: "National Institute of Technology, Uttarakhand",
    value: "National Institute of Technology, Uttarakhand",
  },
  {
    label: "National Institute of Technology, Warangal",
    value: "National Institute of Technology, Warangal",
  },
  {
    label: "National Kaohsiung Normal University",
    value: "National Kaohsiung Normal University",
  },
  {
    label: "National Kaohsiung University of Hospitality and Tourism",
    value: "National Kaohsiung University of Hospitality and Tourism",
  },
  {
    label: "National Kaohsiung University of Science and Technology",
    value: "National Kaohsiung University of Science and Technology",
  },
  {
    label: "National Law Institute University",
    value: "National Law Institute University",
  },
  {
    label: "National Law School of India University",
    value: "National Law School of India University",
  },
  {
    label: "National Law University and Judicial Academy",
    value: "National Law University and Judicial Academy",
  },
  {
    label: "National Law University Odisha",
    value: "National Law University Odisha",
  },
  {
    label: "National Law University, Delhi",
    value: "National Law University, Delhi",
  },
  {
    label: "National Law University, Jodhpur",
    value: "National Law University, Jodhpur",
  },
  {
    label: "National Louis University",
    value: "National Louis University",
  },
  {
    label: "National Meanchey University",
    value: "National Meanchey University",
  },
  {
    label: "National Military University 'Vasil Levski'",
    value: "National Military University 'Vasil Levski'",
  },
  {
    label: "National Penghu University of Science and Technology",
    value: "National Penghu University of Science and Technology",
  },
  {
    label: "National Pingtung University",
    value: "National Pingtung University",
  },
  {
    label: "National Pingtung University of Science and Technology",
    value: "National Pingtung University of Science and Technology",
  },
  {
    label: "National Polytechnic Institute of Cambodia",
    value: "National Polytechnic Institute of Cambodia",
  },
  {
    label: "National Polytechnic University of Armenia",
    value: "National Polytechnic University of Armenia",
  },
  {
    label: "National Quemoy University",
    value: "National Quemoy University",
  },
  {
    label: "National Research Nuclear University MEPI",
    value: "National Research Nuclear University MEPI",
  },
  {
    label: "National Research Technological University 'MISA' in Dushanbe",
    value: "National Research Technological University 'MISA' in Dushanbe",
  },
  {
    label: "National Research University 'Moscow Power Engineering Institute'",
    value: "National Research University 'Moscow Power Engineering Institute'",
  },
  {
    label: "National Research University Higher School of Economics",
    value: "National Research University Higher School of Economics",
  },
  {
    label: "National Research University of Electronic Technology",
    value: "National Research University of Electronic Technology",
  },
  {
    label: "National Ribat University",
    value: "National Ribat University",
  },
  {
    label: "National Sanskrit University",
    value: "National Sanskrit University",
  },
  {
    label: "National Sports Academy Vasil Levski",
    value: "National Sports Academy Vasil Levski",
  },
  {
    label: "National Sports University",
    value: "National Sports University",
  },
  {
    label: "National Sun Yat-Sen University",
    value: "National Sun Yat-Sen University",
  },
  {
    label: "National Taichung University of Education",
    value: "National Taichung University of Education",
  },
  {
    label: "National Taichung University of Science and Technology",
    value: "National Taichung University of Science and Technology",
  },
  {
    label: "National Taipei University",
    value: "National Taipei University",
  },
  {
    label: "National Taipei University of Business",
    value: "National Taipei University of Business",
  },
  {
    label: "National Taipei University of Education",
    value: "National Taipei University of Education",
  },
  {
    label: "National Taipei University of Nursing and Health Sciences",
    value: "National Taipei University of Nursing and Health Sciences",
  },
  {
    label: "National Taipei University of Technology",
    value: "National Taipei University of Technology",
  },
  {
    label: "National Taitung University",
    value: "National Taitung University",
  },
  {
    label: "National Taiwan College of Performing Arts",
    value: "National Taiwan College of Performing Arts",
  },
  {
    label: "National Taiwan Normal University",
    value: "National Taiwan Normal University",
  },
  {
    label: "National Taiwan Ocean University",
    value: "National Taiwan Ocean University",
  },
  {
    label: "National Taiwan Sport University",
    value: "National Taiwan Sport University",
  },
  {
    label: "National Taiwan University",
    value: "National Taiwan University",
  },
  {
    label: "National Taiwan University of Arts",
    value: "National Taiwan University of Arts",
  },
  {
    label: "National Taiwan University of Science and Technology",
    value: "National Taiwan University of Science and Technology",
  },
  {
    label: "National Taiwan University of Sport",
    value: "National Taiwan University of Sport",
  },
  {
    label: "National Teachers College",
    value: "National Teachers College",
  },
  {
    label: "National Technical University",
    value: "National Technical University",
  },
  {
    label: "National Technical University Kharkiv Polytechnic Institute",
    value: "National Technical University Kharkiv Polytechnic Institute",
  },
  {
    label: "National Technical University of Athens",
    value: "National Technical University of Athens",
  },
  {
    label:
      "National Technical University of Ukraine Kyiv Polytechnic Institute",
    value:
      "National Technical University of Ukraine Kyiv Polytechnic Institute",
  },
  {
    label: "National Textile University",
    value: "National Textile University",
  },
  {
    label: "National Transport University",
    value: "National Transport University",
  },
  {
    label: "National Tsing Hua University",
    value: "National Tsing Hua University",
  },
  {
    label: "National United University",
    value: "National United University",
  },
  {
    label: "National University",
    value: "National University",
  },
  {
    label: "National University 'Zaporizhzhia Polytechnic'",
    value: "National University 'Zaporizhzhia Polytechnic'",
  },
  {
    label: "National University Odesa Law Academy",
    value: "National University Odesa Law Academy",
  },
  {
    label: "National University Odessa Maritime Academy",
    value: "National University Odessa Maritime Academy",
  },
  {
    label: "National University of Architecture and Construction of Armenia",
    value: "National University of Architecture and Construction of Armenia",
  },
  {
    label: "National University of Arts and Culture, Mandalay",
    value: "National University of Arts and Culture, Mandalay",
  },
  {
    label: "National University of Arts and Culture, Yangon",
    value: "National University of Arts and Culture, Yangon",
  },
  {
    label: "National University of Battambang",
    value: "National University of Battambang",
  },
  {
    label: "National University of Cherkasy",
    value: "National University of Cherkasy",
  },
  {
    label: "National University of Computer and Emerging Sciences",
    value: "National University of Computer and Emerging Sciences",
  },
  {
    label: "National University of Defense Technology",
    value: "National University of Defense Technology",
  },
  {
    label: "National University of Economics",
    value: "National University of Economics",
  },
  {
    label: "National University of Food Technologies",
    value: "National University of Food Technologies",
  },
  {
    label: "National University of Health Sciences",
    value: "National University of Health Sciences",
  },
  {
    label: "National University of Ireland, System",
    value: "National University of Ireland, System",
  },
  {
    label: "National University of Kaohsiung",
    value: "National University of Kaohsiung",
  },
  {
    label: "National University of Kyiv-Mohyla Academy",
    value: "National University of Kyiv-Mohyla Academy",
  },
  {
    label: "National University of Laos",
    value: "National University of Laos",
  },
  {
    label: "National University of Lesotho",
    value: "National University of Lesotho",
  },
  {
    label: "National University of Life and Environmental Sciences of Ukraine",
    value: "National University of Life and Environmental Sciences of Ukraine",
  },
  {
    label: "National University of Management",
    value: "National University of Management",
  },
  {
    label: "National University of Medical Sciences",
    value: "National University of Medical Sciences",
  },
  {
    label: "National University of Modern Languages",
    value: "National University of Modern Languages",
  },
  {
    label: "National University of Mongolia",
    value: "National University of Mongolia",
  },
  {
    label: "National University of Ostroh Academy",
    value: "National University of Ostroh Academy",
  },
  {
    label: "National University of Pharmacy",
    value: "National University of Pharmacy",
  },
  {
    label: "National University of Physical Education and Sports of Ukraine",
    value: "National University of Physical Education and Sports of Ukraine",
  },
  {
    label: "National University of Science and Technology",
    value: "National University of Science and Technology",
  },
  {
    label: "National University of Science and Technology",
    value: "National University of Science and Technology",
  },
  {
    label: "National University of Science and Technology",
    value: "National University of Science and Technology",
  },
  {
    label: "National University of Science and Technology 'MISIS'",
    value: "National University of Science and Technology 'MISIS'",
  },
  {
    label: "National University of Sciences and Technology",
    value: "National University of Sciences and Technology",
  },
  {
    label: "National University of Singapore",
    value: "National University of Singapore",
  },
  {
    label: "National University of Study and Research in Law",
    value: "National University of Study and Research in Law",
  },
  {
    label: "National University of Tainan",
    value: "National University of Tainan",
  },
  {
    label: "National University of Technology",
    value: "National University of Technology",
  },
  {
    label: "National University of Water and Environmental Engineering",
    value: "National University of Water and Environmental Engineering",
  },
  {
    label: "National University Yuri Kondratyuk Poltava Polytechnic",
    value: "National University Yuri Kondratyuk Poltava Polytechnic",
  },
  {
    label: "National University, Bangladesh",
    value: "National University, Bangladesh",
  },
  {
    label: "National University, Philippines",
    value: "National University, Philippines",
  },
  {
    label: "National University, Yemen",
    value: "National University, Yemen",
  },
  {
    label: "National University-Sudan",
    value: "National University-Sudan",
  },
  {
    label: "National Yang Ming Chiao Tung University",
    value: "National Yang Ming Chiao Tung University",
  },
  {
    label: "National Yunlin University of Science and Technology",
    value: "National Yunlin University of Science and Technology",
  },
  {
    label: "Naturwissenschaftlich-Technische Akademie Isny",
    value: "Naturwissenschaftlich-Technische Akademie Isny",
  },
  {
    label: "Nava Nalanda Mahavihara",
    value: "Nava Nalanda Mahavihara",
  },
  {
    label: "Naval Postgraduate School",
    value: "Naval Postgraduate School",
  },
  {
    label: "Navamindradhiraj University",
    value: "Navamindradhiraj University",
  },
  {
    label: "Navoiy Davlat Konchilik Instituti",
    value: "Navoiy Davlat Konchilik Instituti",
  },
  {
    label: "Navoiy Davlat Pedagogika Instituti",
    value: "Navoiy Davlat Pedagogika Instituti",
  },
  {
    label: "Navrachana University",
    value: "Navrachana University",
  },
  {
    label: "Navsari Agricultural University",
    value: "Navsari Agricultural University",
  },
  {
    label: "Nawroz University",
    value: "Nawroz University",
  },
  {
    label: "Naxcivan Dövlet Universiteti",
    value: "Naxcivan Dövlet Universiteti",
  },
  {
    label: "Naxçivan Müellimler Institutu",
    value: "Naxçivan Müellimler Institutu",
  },
  {
    label: "Naxcivan Universiteti",
    value: "Naxcivan Universiteti",
  },
  {
    label: "Nayanova University",
    value: "Nayanova University",
  },
  {
    label: "Nayestan Institute of Higher Education",
    value: "Nayestan Institute of Higher Education",
  },
  {
    label: "Nayoro City University",
    value: "Nayoro City University",
  },
  {
    label: "Nazarbayev University",
    value: "Nazarbayev University",
  },
  {
    label: "Nazarene Bible College",
    value: "Nazarene Bible College",
  },
  {
    label: "Nazareth University",
    value: "Nazareth University",
  },
  {
    label: "Nazeer Hussain University",
    value: "Nazeer Hussain University",
  },
  {
    label: "Ndejje University",
    value: "Ndejje University",
  },
  {
    label: "Neapolis University Pafos",
    value: "Neapolis University Pafos",
  },
  {
    label: "Nebraska Methodist College",
    value: "Nebraska Methodist College",
  },
  {
    label: "Nebraska Wesleyan University",
    value: "Nebraska Wesleyan University",
  },
  {
    label: "Necmettin Erbakan Üniversitesi",
    value: "Necmettin Erbakan Üniversitesi",
  },
  {
    label: "NED University of Engineering and Technology",
    value: "NED University of Engineering and Technology",
  },
  {
    label: "Neelain University",
    value: "Neelain University",
  },
  {
    label: "Negros Oriental State University",
    value: "Negros Oriental State University",
  },
  {
    label: "Nehru Gram Bharati Vishwavidyalaya",
    value: "Nehru Gram Bharati Vishwavidyalaya",
  },
  {
    label: "Neijiang Normal University",
    value: "Neijiang Normal University",
  },
  {
    label: "Nelson Mandela African Institution of Science and Technology",
    value: "Nelson Mandela African Institution of Science and Technology",
  },
  {
    label: "Nelson Mandela University",
    value: "Nelson Mandela University",
  },
  {
    label: "Nemzeti Közszolgálati Egyetem",
    value: "Nemzeti Közszolgálati Egyetem",
  },
  {
    label: "NEOMA Business School",
    value: "NEOMA Business School",
  },
  {
    label: "Nepal Sanskrit University",
    value: "Nepal Sanskrit University",
  },
  {
    label: "Netanya Academic College",
    value: "Netanya Academic College",
  },
  {
    label: "Neumann János Egyetem",
    value: "Neumann János Egyetem",
  },
  {
    label: "Neumann University",
    value: "Neumann University",
  },
  {
    label: "Neusoft Institute, Guangdong",
    value: "Neusoft Institute, Guangdong",
  },
  {
    label: "Nevada State University",
    value: "Nevada State University",
  },
  {
    label: "Nevsehir Haci Bektas Veli Üniversitesi",
    value: "Nevsehir Haci Bektas Veli Üniversitesi",
  },
  {
    label: "Nevsky Institute of Language and Culture",
    value: "Nevsky Institute of Language and Culture",
  },
  {
    label: "New Bulgarian University",
    value: "New Bulgarian University",
  },
  {
    label: "New Civilization Polytechnic College",
    value: "New Civilization Polytechnic College",
  },
  {
    label: "New College of Florida",
    value: "New College of Florida",
  },
  {
    label: "New Design University Privatuniversität",
    value: "New Design University Privatuniversität",
  },
  {
    label: "New Economic School",
    value: "New Economic School",
  },
  {
    label: "New England College",
    value: "New England College",
  },
  {
    label: "New England College of Optometry",
    value: "New England College of Optometry",
  },
  {
    label: "New England Conservatory",
    value: "New England Conservatory",
  },
  {
    label: "New England Institute of Technology",
    value: "New England Institute of Technology",
  },
  {
    label: "New England Law - Boston",
    value: "New England Law - Boston",
  },
  {
    label: "New Era College",
    value: "New Era College",
  },
  {
    label: "New Era University",
    value: "New Era University",
  },
  {
    label: "New Giza University",
    value: "New Giza University",
  },
  {
    label: "New Hope Christian College",
    value: "New Hope Christian College",
  },
  {
    label: "New Jersey City University",
    value: "New Jersey City University",
  },
  {
    label: "New Jersey Institute of Technology",
    value: "New Jersey Institute of Technology",
  },
  {
    label: "New Medicine Institute",
    value: "New Medicine Institute",
  },
  {
    label: "New Mexico Highlands University",
    value: "New Mexico Highlands University",
  },
  {
    label: "New Mexico Institute of Mining and Technology",
    value: "New Mexico Institute of Mining and Technology",
  },
  {
    label: "New Mexico State University",
    value: "New Mexico State University",
  },
  {
    label: "New Valley University",
    value: "New Valley University",
  },
  {
    label: "New Vision University",
    value: "New Vision University",
  },
  {
    label: "New York Academy of Art",
    value: "New York Academy of Art",
  },
  {
    label: "New York City College of Technology, CUNY",
    value: "New York City College of Technology, CUNY",
  },
  {
    label: "New York College of Podiatric Medicine",
    value: "New York College of Podiatric Medicine",
  },
  {
    label: "New York Institute of Technology",
    value: "New York Institute of Technology",
  },
  {
    label: "New York Law School",
    value: "New York Law School",
  },
  {
    label: "New York Medical College",
    value: "New York Medical College",
  },
  {
    label: "New York School of Interior Design",
    value: "New York School of Interior Design",
  },
  {
    label: "New York University",
    value: "New York University",
  },
  {
    label: "New York University Abu Dhabi",
    value: "New York University Abu Dhabi",
  },
  {
    label: "Newberry College",
    value: "Newberry College",
  },
  {
    label: "Newcastle University",
    value: "Newcastle University",
  },
  {
    label: "Newman University",
    value: "Newman University",
  },
  {
    label: "Newmaninstitutet",
    value: "Newmaninstitutet",
  },
  {
    label: "Newports Institute of Communications and Economics",
    value: "Newports Institute of Communications and Economics",
  },
  {
    label: "NewSchool of Architecture and Design",
    value: "NewSchool of Architecture and Design",
  },
  {
    label: "Newton University",
    value: "Newton University",
  },
  {
    label: "Nezavisni univerzitet Banja Luka",
    value: "Nezavisni univerzitet Banja Luka",
  },
  {
    label: "NFC Institute of Engineering and Technology",
    value: "NFC Institute of Engineering and Technology",
  },
  {
    label: "Nguyen Tat Thanh University",
    value: "Nguyen Tat Thanh University",
  },
  {
    label: "Ngwane Teacher's College",
    value: "Ngwane Teacher's College",
  },
  {
    label: "Nha Trang University",
    value: "Nha Trang University",
  },
  {
    label: "NHL Stenden Hogeschool",
    value: "NHL Stenden Hogeschool",
  },
  {
    label: "Niagara University",
    value: "Niagara University",
  },
  {
    label: "Nicholls State University",
    value: "Nicholls State University",
  },
  {
    label: "Nichols College",
    value: "Nichols College",
  },
  {
    label: "Nicola Valley Institute of Technology",
    value: "Nicola Valley Institute of Technology",
  },
  {
    label: "Nigde Ömer Halisdemir Üniversitesi",
    value: "Nigde Ömer Halisdemir Üniversitesi",
  },
  {
    label: "Niger Delta University",
    value: "Niger Delta University",
  },
  {
    label: "Nigerian Maritime University, Okerenkoko",
    value: "Nigerian Maritime University, Okerenkoko",
  },
  {
    label: "Nihon Bunka University",
    value: "Nihon Bunka University",
  },
  {
    label: "Nihon Fukushi University",
    value: "Nihon Fukushi University",
  },
  {
    label: "Nihon Institute of Medical Science",
    value: "Nihon Institute of Medical Science",
  },
  {
    label: "Nihon Pharmaceutical University",
    value: "Nihon Pharmaceutical University",
  },
  {
    label: "Nihon University",
    value: "Nihon University",
  },
  {
    label: "Nihon Wellness Sports University",
    value: "Nihon Wellness Sports University",
  },
  {
    label: "Niigata Agro-Food University",
    value: "Niigata Agro-Food University",
  },
  {
    label: "Niigata College of Nursing",
    value: "Niigata College of Nursing",
  },
  {
    label: "Niigata Institute of Technology",
    value: "Niigata Institute of Technology",
  },
  {
    label: "Niigata Sangyo University",
    value: "Niigata Sangyo University",
  },
  {
    label: "Niigata Seiryo University",
    value: "Niigata Seiryo University",
  },
  {
    label: "Niigata University",
    value: "Niigata University",
  },
  {
    label: "Niigata University of Health and Welfare",
    value: "Niigata University of Health and Welfare",
  },
  {
    label: "Niigata University of International and Information Studies",
    value: "Niigata University of International and Information Studies",
  },
  {
    label: "Niigata University of Management",
    value: "Niigata University of Management",
  },
  {
    label: "Niigata University of Pharmacy and Applied Life Sciences",
    value: "Niigata University of Pharmacy and Applied Life Sciences",
  },
  {
    label: "Niigata University of Rehabilitation",
    value: "Niigata University of Rehabilitation",
  },
  {
    label: "NIILM University",
    value: "NIILM University",
  },
  {
    label: "Niimi University",
    value: "Niimi University",
  },
  {
    label: "NIIT University",
    value: "NIIT University",
  },
  {
    label: "Nikola Vaptsarov Naval Academy",
    value: "Nikola Vaptsarov Naval Academy",
  },
  {
    label: "Nilamber-Pitamber University",
    value: "Nilamber-Pitamber University",
  },
  {
    label: "Nile Source Polytechnic of Applied Arts",
    value: "Nile Source Polytechnic of Applied Arts",
  },
  {
    label: "Nile University",
    value: "Nile University",
  },
  {
    label: "Nile University of Nigeria",
    value: "Nile University of Nigeria",
  },
  {
    label: "Nile Valley University",
    value: "Nile Valley University",
  },
  {
    label: "Nimba University",
    value: "Nimba University",
  },
  {
    label: "NIMS University",
    value: "NIMS University",
  },
  {
    label: "Ninevah University",
    value: "Ninevah University",
  },
  {
    label: "Ningbo University",
    value: "Ningbo University",
  },
  {
    label: "Ningbo University of Finance and Economics",
    value: "Ningbo University of Finance and Economics",
  },
  {
    label: "Ningbo University of Technology",
    value: "Ningbo University of Technology",
  },
  {
    label: "Ningde Normal University",
    value: "Ningde Normal University",
  },
  {
    label: "Ningxia Institute of Science and Technology",
    value: "Ningxia Institute of Science and Technology",
  },
  {
    label: "Ningxia Medical University",
    value: "Ningxia Medical University",
  },
  {
    label: "Ningxia Normal University",
    value: "Ningxia Normal University",
  },
  {
    label: "Ningxia University",
    value: "Ningxia University",
  },
  {
    label: "Nipissing University",
    value: "Nipissing University",
  },
  {
    label: "Nippon Bunri University",
    value: "Nippon Bunri University",
  },
  {
    label: "Nippon Institute of Technology",
    value: "Nippon Institute of Technology",
  },
  {
    label: "Nippon Medical School",
    value: "Nippon Medical School",
  },
  {
    label: "Nippon Sport Science University",
    value: "Nippon Sport Science University",
  },
  {
    label: "Nippon Veterinary and Life Science University",
    value: "Nippon Veterinary and Life Science University",
  },
  {
    label: "Nirma University",
    value: "Nirma University",
  },
  {
    label: "Nisantasi Üniversitesi",
    value: "Nisantasi Üniversitesi",
  },
  {
    label: "Nishikyushu University",
    value: "Nishikyushu University",
  },
  {
    label: "Nishinippon Institute of Technology",
    value: "Nishinippon Institute of Technology",
  },
  {
    label: "Nishogakusha University",
    value: "Nishogakusha University",
  },
  {
    label: "NITTE University",
    value: "NITTE University",
  },
  {
    label: "Nizam's Institute of Medical Sciences",
    value: "Nizam's Institute of Medical Sciences",
  },
  {
    label: "Nizhnevartovsk State University",
    value: "Nizhnevartovsk State University",
  },
  {
    label: "Nizhny Novgorod State Agricultural Academy",
    value: "Nizhny Novgorod State Agricultural Academy",
  },
  {
    label: "Nizhny Novgorod State Pedagogical University",
    value: "Nizhny Novgorod State Pedagogical University",
  },
  {
    label: "Nizhny Novgorod State Technical University",
    value: "Nizhny Novgorod State Technical University",
  },
  {
    label:
      "Nizhny Novgorod State University of Architecture and Civil Engineering",
    value:
      "Nizhny Novgorod State University of Architecture and Civil Engineering",
  },
  {
    label: "Nizhyn Gogol State University",
    value: "Nizhyn Gogol State University",
  },
  {
    label: "Njala University",
    value: "Njala University",
  },
  {
    label: "Nkhoma University",
    value: "Nkhoma University",
  },
  {
    label: "Nkumba University",
    value: "Nkumba University",
  },
  {
    label: "NLA Høgskolen",
    value: "NLA Høgskolen",
  },
  {
    label: "Nnamdi Azikiwe University",
    value: "Nnamdi Azikiwe University",
  },
  {
    label: "Noakhali Science and Technology University",
    value: "Noakhali Science and Technology University",
  },
  {
    label: "Noida International University",
    value: "Noida International University",
  },
  {
    label: "Noman Sadat Institute of Higher Education",
    value: "Noman Sadat Institute of Higher Education",
  },
  {
    label: "Nomera Institute",
    value: "Nomera Institute",
  },
  {
    label: "Noorin Institute of Higher Education",
    value: "Noorin Institute of Higher Education",
  },
  {
    label: "Nordakademie Hochschule der Wirtschaft",
    value: "Nordakademie Hochschule der Wirtschaft",
  },
  {
    label: "Norfolk State University",
    value: "Norfolk State University",
  },
  {
    label: "Norges Handelshøyskole",
    value: "Norges Handelshøyskole",
  },
  {
    label: "Norges idrettshøgskole",
    value: "Norges idrettshøgskole",
  },
  {
    label: "Norges miljø- og biovitenskapelige universitet",
    value: "Norges miljø- og biovitenskapelige universitet",
  },
  {
    label: "Norges musikkhøgskole",
    value: "Norges musikkhøgskole",
  },
  {
    label: "Norges teknisk-naturvitenskaplige universitet",
    value: "Norges teknisk-naturvitenskaplige universitet",
  },
  {
    label: "North Asia University",
    value: "North Asia University",
  },
  {
    label: "North Bangkok University",
    value: "North Bangkok University",
  },
  {
    label: "North Bengal International University",
    value: "North Bengal International University",
  },
  {
    label: "North Carolina Agricultural and Technical State University",
    value: "North Carolina Agricultural and Technical State University",
  },
  {
    label: "North Carolina Central University",
    value: "North Carolina Central University",
  },
  {
    label: "North Carolina State University",
    value: "North Carolina State University",
  },
  {
    label: "North Carolina Wesleyan University",
    value: "North Carolina Wesleyan University",
  },
  {
    label: "North Caucasian Institute of Mining and Metallurgy",
    value: "North Caucasian Institute of Mining and Metallurgy",
  },
  {
    label: "North Caucasus Federal University",
    value: "North Caucasus Federal University",
  },
  {
    label: "North Central College",
    value: "North Central College",
  },
  {
    label: "North Central University",
    value: "North Central University",
  },
  {
    label: "North Chiang Mai University",
    value: "North Chiang Mai University",
  },
  {
    label: "North China Electric Power University",
    value: "North China Electric Power University",
  },
  {
    label: "North China Institute of Aerospace Engineering",
    value: "North China Institute of Aerospace Engineering",
  },
  {
    label: "North China Institute of Science and Technology",
    value: "North China Institute of Science and Technology",
  },
  {
    label: "North China University of Science and Technology",
    value: "North China University of Science and Technology",
  },
  {
    label: "North China University of Technology",
    value: "North China University of Technology",
  },
  {
    label: "North China University of Water Resources and Electric Power",
    value: "North China University of Water Resources and Electric Power",
  },
  {
    label: "North Dakota State University",
    value: "North Dakota State University",
  },
  {
    label: "North East Frontier Technical University",
    value: "North East Frontier Technical University",
  },
  {
    label: "North East University Bangladesh",
    value: "North East University Bangladesh",
  },
  {
    label: "North Eastern Hill University",
    value: "North Eastern Hill University",
  },
  {
    label: "North Eastern Mindanao State University",
    value: "North Eastern Mindanao State University",
  },
  {
    label: "North Eastern Regional Institute of Science and Technology",
    value: "North Eastern Regional Institute of Science and Technology",
  },
  {
    label: "North Eastern University",
    value: "North Eastern University",
  },
  {
    label: "North Greenville University",
    value: "North Greenville University",
  },
  {
    label: "North Khorasan University of Medical Sciences",
    value: "North Khorasan University of Medical Sciences",
  },
  {
    label: "North Minzu University",
    value: "North Minzu University",
  },
  {
    label: "North Orissa University",
    value: "North Orissa University",
  },
  {
    label: "North Ossetian State University",
    value: "North Ossetian State University",
  },
  {
    label: "North Park University",
    value: "North Park University",
  },
  {
    label: "North Sichuan Medical College",
    value: "North Sichuan Medical College",
  },
  {
    label: "North South University",
    value: "North South University",
  },
  {
    label: "North State Medical University",
    value: "North State Medical University",
  },
  {
    label: "North University of China",
    value: "North University of China",
  },
  {
    label: "North Western University",
    value: "North Western University",
  },
  {
    label: "Northeast Agricultural University",
    value: "Northeast Agricultural University",
  },
  {
    label: "Northeast Electric Power University",
    value: "Northeast Electric Power University",
  },
  {
    label: "Northeast Forestry University",
    value: "Northeast Forestry University",
  },
  {
    label: "Northeast Normal University",
    value: "Northeast Normal University",
  },
  {
    label: "Northeast Ohio Medical University",
    value: "Northeast Ohio Medical University",
  },
  {
    label: "Northeast Petroleum University",
    value: "Northeast Petroleum University",
  },
  {
    label: "North-Eastern Federal University",
    value: "North-Eastern Federal University",
  },
  {
    label: "Northeastern Illinois University",
    value: "Northeastern Illinois University",
  },
  {
    label: "Northeastern State University",
    value: "Northeastern State University",
  },
  {
    label: "North-Eastern State University",
    value: "North-Eastern State University",
  },
  {
    label: "Northeastern University",
    value: "Northeastern University",
  },
  {
    label: "Northeastern University, China",
    value: "Northeastern University, China",
  },
  {
    label: "Northern Alberta Institute of Technology",
    value: "Northern Alberta Institute of Technology",
  },
  {
    label: "Northern Arctic Federal University",
    value: "Northern Arctic Federal University",
  },
  {
    label: "Northern Arizona University",
    value: "Northern Arizona University",
  },
  {
    label: "Northern Borders University",
    value: "Northern Borders University",
  },
  {
    label: "Northern Caribbean University",
    value: "Northern Caribbean University",
  },
  {
    label: "Northern Illinois University",
    value: "Northern Illinois University",
  },
  {
    label: "Northern Kentucky University",
    value: "Northern Kentucky University",
  },
  {
    label: "Northern Luzon Adventist College",
    value: "Northern Luzon Adventist College",
  },
  {
    label: "Northern Michigan University",
    value: "Northern Michigan University",
  },
  {
    label: "Northern New Mexico College",
    value: "Northern New Mexico College",
  },
  {
    label: "Northern Ossetian State Academy of Medicine",
    value: "Northern Ossetian State Academy of Medicine",
  },
  {
    label: "Northern School of Contemporary Dance",
    value: "Northern School of Contemporary Dance",
  },
  {
    label: "Northern State University",
    value: "Northern State University",
  },
  {
    label: "Northern Technical University",
    value: "Northern Technical University",
  },
  {
    label: "Northern University",
    value: "Northern University",
  },
  {
    label: "Northern University of Bangladesh",
    value: "Northern University of Bangladesh",
  },
  {
    label: "Northern University of Business and Technology, Khulna",
    value: "Northern University of Business and Technology, Khulna",
  },
  {
    label: "Northland College",
    value: "Northland College",
  },
  {
    label: "Northpoint Bible College",
    value: "Northpoint Bible College",
  },
  {
    label: "Northrise University",
    value: "Northrise University",
  },
  {
    label: "Northumbria University",
    value: "Northumbria University",
  },
  {
    label: "Northwest A&F University",
    value: "Northwest A&F University",
  },
  {
    label: "Northwest Florida State College",
    value: "Northwest Florida State College",
  },
  {
    label: "Northwest Missouri State University",
    value: "Northwest Missouri State University",
  },
  {
    label: "Northwest Nazarene University",
    value: "Northwest Nazarene University",
  },
  {
    label: "Northwest Normal University",
    value: "Northwest Normal University",
  },
  {
    label: "Northwest Samar State University",
    value: "Northwest Samar State University",
  },
  {
    label: "Northwest University",
    value: "Northwest University",
  },
  {
    label: "North-West University",
    value: "North-West University",
  },
  {
    label: "Northwest University for Nationalities",
    value: "Northwest University for Nationalities",
  },
  {
    label: "Northwest University of Politics and Law",
    value: "Northwest University of Politics and Law",
  },
  {
    label: "Northwest University, China",
    value: "Northwest University, China",
  },
  {
    label: "Northwestern College",
    value: "Northwestern College",
  },
  {
    label: "Northwestern Health Sciences University",
    value: "Northwestern Health Sciences University",
  },
  {
    label: "Northwestern Oklahoma State University",
    value: "Northwestern Oklahoma State University",
  },
  {
    label: "Northwestern Polytechnical University",
    value: "Northwestern Polytechnical University",
  },
  {
    label: "North-Western State Medical University",
    value: "North-Western State Medical University",
  },
  {
    label: "Northwestern State University of Louisiana",
    value: "Northwestern State University of Louisiana",
  },
  {
    label: "Northwestern University",
    value: "Northwestern University",
  },
  {
    label: "Northwestern University in Qatar",
    value: "Northwestern University in Qatar",
  },
  {
    label: "Northwestern University, Philippines",
    value: "Northwestern University, Philippines",
  },
  {
    label: "Northwood University",
    value: "Northwood University",
  },
  {
    label: "Norton University",
    value: "Norton University",
  },
  {
    label: "Norwich University",
    value: "Norwich University",
  },
  {
    label: "Norwich University of the Arts",
    value: "Norwich University of the Arts",
  },
  {
    label: "Notre Dame College",
    value: "Notre Dame College",
  },
  {
    label: "Notre Dame de Namur University",
    value: "Notre Dame de Namur University",
  },
  {
    label: "Notre Dame of Dadiangas University",
    value: "Notre Dame of Dadiangas University",
  },
  {
    label: "Notre Dame of Kidapawan College",
    value: "Notre Dame of Kidapawan College",
  },
  {
    label: "Notre Dame of Marbel University",
    value: "Notre Dame of Marbel University",
  },
  {
    label: "Notre Dame of Maryland University",
    value: "Notre Dame of Maryland University",
  },
  {
    label: "Notre Dame Seishin University",
    value: "Notre Dame Seishin University",
  },
  {
    label: "Notre Dame University",
    value: "Notre Dame University",
  },
  {
    label: "Notre Dame University",
    value: "Notre Dame University",
  },
  {
    label: "Notre Dame University Bangladesh",
    value: "Notre Dame University Bangladesh",
  },
  {
    label: "Nottingham Trent University",
    value: "Nottingham Trent University",
  },
  {
    label: "Nova Southeastern University",
    value: "Nova Southeastern University",
  },
  {
    label: "Nova univerza",
    value: "Nova univerza",
  },
  {
    label: "Novena University",
    value: "Novena University",
  },
  {
    label: "Novgorod State University",
    value: "Novgorod State University",
  },
  {
    label: "Novosibirsk State Agricultural University",
    value: "Novosibirsk State Agricultural University",
  },
  {
    label: "Novosibirsk State Architectural University",
    value: "Novosibirsk State Architectural University",
  },
  {
    label: "Novosibirsk State Medical University",
    value: "Novosibirsk State Medical University",
  },
  {
    label: "Novosibirsk State Pedagogical University",
    value: "Novosibirsk State Pedagogical University",
  },
  {
    label: "Novosibirsk State Technical University",
    value: "Novosibirsk State Technical University",
  },
  {
    label: "Novosibirsk State University",
    value: "Novosibirsk State University",
  },
  {
    label: "Novosibirsk State University of Economics and Management",
    value: "Novosibirsk State University of Economics and Management",
  },
  {
    label: "Nsaka University",
    value: "Nsaka University",
  },
  {
    label: "NSCAD University",
    value: "NSCAD University",
  },
  {
    label: "NUC University",
    value: "NUC University",
  },
  {
    label: "Nueva Ecija University of Science and Technology",
    value: "Nueva Ecija University of Science and Technology",
  },
  {
    label: "Nueva Vizcaya State University",
    value: "Nueva Vizcaya State University",
  },
  {
    label: "Nuh Naci Yazgan Üniversitesi",
    value: "Nuh Naci Yazgan Üniversitesi",
  },
  {
    label: "Nukus Davlat Pedagogika Instituti",
    value: "Nukus Davlat Pedagogika Instituti",
  },
  {
    label: "Nur International University",
    value: "Nur International University",
  },
  {
    label: "Nyenrode Business Universiteit",
    value: "Nyenrode Business Universiteit",
  },
  {
    label: "Nyíregyházi Egyetem",
    value: "Nyíregyházi Egyetem",
  },
  {
    label: "O.M. Beketov National University of Urban Economy in Kharkiv",
    value: "O.M. Beketov National University of Urban Economy in Kharkiv",
  },
  {
    label: "O.O. Bogomolets National Medical University",
    value: "O.O. Bogomolets National Medical University",
  },
  {
    label: "O.P. Jindal Global University",
    value: "O.P. Jindal Global University",
  },
  {
    label: "O.P. Jindal University",
    value: "O.P. Jindal University",
  },
  {
    label: "Oak Hills Christian College",
    value: "Oak Hills Christian College",
  },
  {
    label: "Oak Point University",
    value: "Oak Point University",
  },
  {
    label: "OAK University",
    value: "OAK University",
  },
  {
    label: "Oakland City University",
    value: "Oakland City University",
  },
  {
    label: "Oakland University",
    value: "Oakland University",
  },
  {
    label: "Oakwood University",
    value: "Oakwood University",
  },
  {
    label: "Obafemi Awolowo University",
    value: "Obafemi Awolowo University",
  },
  {
    label: "Oberlin College",
    value: "Oberlin College",
  },
  {
    label: "Obihiro University of Agriculture and Veterinary Medicine",
    value: "Obihiro University of Agriculture and Veterinary Medicine",
  },
  {
    label: "Obong University",
    value: "Obong University",
  },
  {
    label: "Óbudai Egyetem",
    value: "Óbudai Egyetem",
  },
  {
    label: "OCAD University",
    value: "OCAD University",
  },
  {
    label: "Occidental College",
    value: "Occidental College",
  },
  {
    label: "Ocean University of China",
    value: "Ocean University of China",
  },
  {
    label: "Ocean University of Sri Lanka",
    value: "Ocean University of Sri Lanka",
  },
  {
    label: "Ochanomizu University",
    value: "Ochanomizu University",
  },
  {
    label: "October 6 University",
    value: "October 6 University",
  },
  {
    label: "Odesa State University of Internal Affairs",
    value: "Odesa State University of Internal Affairs",
  },
  {
    label: "Odessa National Academy of Music",
    value: "Odessa National Academy of Music",
  },
  {
    label: "Odessa National Economics University",
    value: "Odessa National Economics University",
  },
  {
    label: "Odessa National Maritime University",
    value: "Odessa National Maritime University",
  },
  {
    label: "Odessa National Medical University",
    value: "Odessa National Medical University",
  },
  {
    label: "Odessa National Polytechnic University",
    value: "Odessa National Polytechnic University",
  },
  {
    label: "Odessa National Technological University",
    value: "Odessa National Technological University",
  },
  {
    label: "Odessa National University",
    value: "Odessa National University",
  },
  {
    label: "Odessa State Academy of Civil Engineering and Architecture",
    value: "Odessa State Academy of Civil Engineering and Architecture",
  },
  {
    label: "Odessa State Agrarian University",
    value: "Odessa State Agrarian University",
  },
  {
    label: "Odessa State Environmental University",
    value: "Odessa State Environmental University",
  },
  {
    label: "Odisee",
    value: "Odisee",
  },
  {
    label: "Odisha University of Agriculture and Technology",
    value: "Odisha University of Agriculture and Technology",
  },
  {
    label: "Odlar Yurdu Universiteti",
    value: "Odlar Yurdu Universiteti",
  },
  {
    label: "Oduduwa University",
    value: "Oduduwa University",
  },
  {
    label: "Ogarev Mordovia State University",
    value: "Ogarev Mordovia State University",
  },
  {
    label: "Oglethorpe University",
    value: "Oglethorpe University",
  },
  {
    label: "Oguz Han Engineering and Technology University of Turkmenistan",
    value: "Oguz Han Engineering and Technology University of Turkmenistan",
  },
  {
    label: "Ohio Christian University",
    value: "Ohio Christian University",
  },
  {
    label: "Ohio Dominican University",
    value: "Ohio Dominican University",
  },
  {
    label: "Ohio Northern University",
    value: "Ohio Northern University",
  },
  {
    label: "Ohio University",
    value: "Ohio University",
  },
  {
    label: "Ohio University Southern",
    value: "Ohio University Southern",
  },
  {
    label: "Ohio University-Chillicothe",
    value: "Ohio University-Chillicothe",
  },
  {
    label: "Ohio Wesleyan University",
    value: "Ohio Wesleyan University",
  },
  {
    label: "Ohkagakuen University",
    value: "Ohkagakuen University",
  },
  {
    label: "Ohu University",
    value: "Ohu University",
  },
  {
    label: "Oita University",
    value: "Oita University",
  },
  {
    label: "Oita University of Nursing and Health Sciences",
    value: "Oita University of Nursing and Health Sciences",
  },
  {
    label: "Okan Üniversitesi",
    value: "Okan Üniversitesi",
  },
  {
    label: "Okayama Gakuin University",
    value: "Okayama Gakuin University",
  },
  {
    label: "Okayama Prefectural University",
    value: "Okayama Prefectural University",
  },
  {
    label: "Okayama Shoka University",
    value: "Okayama Shoka University",
  },
  {
    label: "Okayama University",
    value: "Okayama University",
  },
  {
    label: "Okayama University of Science",
    value: "Okayama University of Science",
  },
  {
    label: "Okazaki Women’s University",
    value: "Okazaki Women’s University",
  },
  {
    label: "Okinawa Christian University",
    value: "Okinawa Christian University",
  },
  {
    label: "Okinawa Institute of Science and Technology Graduate University",
    value: "Okinawa Institute of Science and Technology Graduate University",
  },
  {
    label: "Okinawa International University",
    value: "Okinawa International University",
  },
  {
    label: "Okinawa Prefectural College of Nursing",
    value: "Okinawa Prefectural College of Nursing",
  },
  {
    label: "Okinawa Prefectural University of Arts",
    value: "Okinawa Prefectural University of Arts",
  },
  {
    label: "Okinawa University",
    value: "Okinawa University",
  },
  {
    label: "Oklahoma Baptist University",
    value: "Oklahoma Baptist University",
  },
  {
    label: "Oklahoma Christian University",
    value: "Oklahoma Christian University",
  },
  {
    label: "Oklahoma City University",
    value: "Oklahoma City University",
  },
  {
    label: "Oklahoma Panhandle State University",
    value: "Oklahoma Panhandle State University",
  },
  {
    label: "Oklahoma State University",
    value: "Oklahoma State University",
  },
  {
    label: "Oklahoma Wesleyan University",
    value: "Oklahoma Wesleyan University",
  },
  {
    label: "Olabisi Onabanjo University",
    value: "Olabisi Onabanjo University",
  },
  {
    label: "Old Dominion University",
    value: "Old Dominion University",
  },
  {
    label: "Oles Honchar Dnipro National University",
    value: "Oles Honchar Dnipro National University",
  },
  {
    label: "Olivarez College",
    value: "Olivarez College",
  },
  {
    label: "Olivet Nazarene University",
    value: "Olivet Nazarene University",
  },
  {
    label: "Oman College of Management and Technology",
    value: "Oman College of Management and Technology",
  },
  {
    label: "Oman Dental College",
    value: "Oman Dental College",
  },
  {
    label: "Oman Tourism College",
    value: "Oman Tourism College",
  },
  {
    label: "Omar Al-Mukhtar University",
    value: "Omar Al-Mukhtar University",
  },
  {
    label: "Omdurman Ahlia University",
    value: "Omdurman Ahlia University",
  },
  {
    label: "Omdurman Islamic University",
    value: "Omdurman Islamic University",
  },
  {
    label: "Omsk State Agrarian University named after P. A. Stolypin",
    value: "Omsk State Agrarian University named after P. A. Stolypin",
  },
  {
    label: "Omsk State Medical Academy",
    value: "Omsk State Medical Academy",
  },
  {
    label: "Omsk State Pedagogical University",
    value: "Omsk State Pedagogical University",
  },
  {
    label: "Omsk State Technical University",
    value: "Omsk State Technical University",
  },
  {
    label: "Omsk State Transport University",
    value: "Omsk State Transport University",
  },
  {
    label: "Onbes Kasim Kibris Üniversitesi",
    value: "Onbes Kasim Kibris Üniversitesi",
  },
  {
    label: "Ondo State University of Science and Technology",
    value: "Ondo State University of Science and Technology",
  },
  {
    label: "Ondokuz Mayis Üniversitesi",
    value: "Ondokuz Mayis Üniversitesi",
  },
  {
    label: "Ono Academic College",
    value: "Ono Academic College",
  },
  {
    label: "Onomichi City University",
    value: "Onomichi City University",
  },
  {
    label: "Ontario Tech University",
    value: "Ontario Tech University",
  },
  {
    label: "Open International University of Human Development 'Ukraine'",
    value: "Open International University of Human Development 'Ukraine'",
  },
  {
    label: "OPJS University",
    value: "OPJS University",
  },
  {
    label: "Oral Roberts University",
    value: "Oral Roberts University",
  },
  {
    label: "Ordos Institute of Technology",
    value: "Ordos Institute of Technology",
  },
  {
    label: "Ordu Üniversitesi",
    value: "Ordu Üniversitesi",
  },
  {
    label: "Örebro Universitet",
    value: "Örebro Universitet",
  },
  {
    label: "Oregon Health & Science University",
    value: "Oregon Health & Science University",
  },
  {
    label: "Oregon Institute of Technology",
    value: "Oregon Institute of Technology",
  },
  {
    label: "Oregon State University",
    value: "Oregon State University",
  },
  {
    label: "Orel State Agrarian University",
    value: "Orel State Agrarian University",
  },
  {
    label: "Orel State University",
    value: "Orel State University",
  },
  {
    label: "Orenburg State Agrarian University",
    value: "Orenburg State Agrarian University",
  },
  {
    label: "Orenburg State Medical University",
    value: "Orenburg State Medical University",
  },
  {
    label: "Orenburg State Pedagogical University",
    value: "Orenburg State Pedagogical University",
  },
  {
    label: "Orenburg State University",
    value: "Orenburg State University",
  },
  {
    label: "Oriental University",
    value: "Oriental University",
  },
  {
    label: "Orkhon University",
    value: "Orkhon University",
  },
  {
    label: "Oromia State University",
    value: "Oromia State University",
  },
  {
    label: "Orota School of Medicine and Dental Medicine",
    value: "Orota School of Medicine and Dental Medicine",
  },
  {
    label: "ORT Braude College",
    value: "ORT Braude College",
  },
  {
    label: "Orta Dogu Teknik Üniversitesi",
    value: "Orta Dogu Teknik Üniversitesi",
  },
  {
    label: "Orta Dogu Teknik Universitesi Kuzey Kibris Kampusu",
    value: "Orta Dogu Teknik Universitesi Kuzey Kibris Kampusu",
  },
  {
    label: "Oruj Institute of Higher Education",
    value: "Oruj Institute of Higher Education",
  },
  {
    label: "Osaka Aoyama University",
    value: "Osaka Aoyama University",
  },
  {
    label: "Osaka Butsuryo University",
    value: "Osaka Butsuryo University",
  },
  {
    label: "Osaka College of Music",
    value: "Osaka College of Music",
  },
  {
    label: "Osaka Dental University",
    value: "Osaka Dental University",
  },
  {
    label: "Osaka Electro-Communication University",
    value: "Osaka Electro-Communication University",
  },
  {
    label: "Osaka Gakuin University",
    value: "Osaka Gakuin University",
  },
  {
    label: "Osaka Health Science University",
    value: "Osaka Health Science University",
  },
  {
    label: "Osaka Institute of Technology",
    value: "Osaka Institute of Technology",
  },
  {
    label: "Osaka International University",
    value: "Osaka International University",
  },
  {
    label: "Osaka Jogakuin University",
    value: "Osaka Jogakuin University",
  },
  {
    label: "Osaka Kawasaki Rehabilitation University",
    value: "Osaka Kawasaki Rehabilitation University",
  },
  {
    label: "Osaka Kyoiku University",
    value: "Osaka Kyoiku University",
  },
  {
    label: "Osaka Medical and Pharmaceutical University",
    value: "Osaka Medical and Pharmaceutical University",
  },
  {
    label: "Osaka Metropolitan University",
    value: "Osaka Metropolitan University",
  },
  {
    label: "Osaka Ohtani University",
    value: "Osaka Ohtani University",
  },
  {
    label: "Osaka Sangyo University",
    value: "Osaka Sangyo University",
  },
  {
    label: "Osaka Seikei University",
    value: "Osaka Seikei University",
  },
  {
    label: "Osaka Shoin Women's University",
    value: "Osaka Shoin Women's University",
  },
  {
    label: "Osaka University",
    value: "Osaka University",
  },
  {
    label: "Osaka University of Arts",
    value: "Osaka University of Arts",
  },
  {
    label: "Osaka University of Commerce",
    value: "Osaka University of Commerce",
  },
  {
    label: "Osaka University of Comprehensive Children Education",
    value: "Osaka University of Comprehensive Children Education",
  },
  {
    label: "Osaka University of Economics",
    value: "Osaka University of Economics",
  },
  {
    label: "Osaka University of Economics and Law",
    value: "Osaka University of Economics and Law",
  },
  {
    label: "Osaka University of Health and Sport Sciences",
    value: "Osaka University of Health and Sport Sciences",
  },
  {
    label: "Osaka University of Human Sciences",
    value: "Osaka University of Human Sciences",
  },
  {
    label: "Osaka University of Tourism",
    value: "Osaka University of Tourism",
  },
  {
    label: "OSCE Academy",
    value: "OSCE Academy",
  },
  {
    label: "Osh Humanitarian and Pedagogical Institute",
    value: "Osh Humanitarian and Pedagogical Institute",
  },
  {
    label: "Osh State Law Institute",
    value: "Osh State Law Institute",
  },
  {
    label: "Osh State University",
    value: "Osh State University",
  },
  {
    label: "Osh Technological University",
    value: "Osh Technological University",
  },
  {
    label: "OsloMet",
    value: "OsloMet",
  },
  {
    label: "Osmania University",
    value: "Osmania University",
  },
  {
    label: "Osmaniye Korkut Ata Üniversitesi",
    value: "Osmaniye Korkut Ata Üniversitesi",
  },
  {
    label: "Osol Al-Deen University College",
    value: "Osol Al-Deen University College",
  },
  {
    label: "Ostbayerische Technische Hochschule Amberg-Weiden",
    value: "Ostbayerische Technische Hochschule Amberg-Weiden",
  },
  {
    label: "Ostbayerische Technische Hochschule Regensburg",
    value: "Ostbayerische Technische Hochschule Regensburg",
  },
  {
    label: "Ostfalia Hochschule für angewandte Wissenschaften",
    value: "Ostfalia Hochschule für angewandte Wissenschaften",
  },
  {
    label: "Ostravská univerzita",
    value: "Ostravská univerzita",
  },
  {
    label: "Osun State University",
    value: "Osun State University",
  },
  {
    label: "Otani University",
    value: "Otani University",
  },
  {
    label: "Otaru University of Commerce",
    value: "Otaru University of Commerce",
  },
  {
    label: "Otemae University",
    value: "Otemae University",
  },
  {
    label: "Otemon Gakuin University",
    value: "Otemon Gakuin University",
  },
  {
    label: "Otgontenger University",
    value: "Otgontenger University",
  },
  {
    label: "Otis College of Art and Design",
    value: "Otis College of Art and Design",
  },
  {
    label: "Otoch Manramba University",
    value: "Otoch Manramba University",
  },
  {
    label: "Otsuma Women's University",
    value: "Otsuma Women's University",
  },
  {
    label: "Ottawa University",
    value: "Ottawa University",
  },
  {
    label: "Otterbein University",
    value: "Otterbein University",
  },
  {
    label: "Otto-Friedrich-Universität Bamberg",
    value: "Otto-Friedrich-Universität Bamberg",
  },
  {
    label: "Otto-von-Guericke-Universität Magdeburg",
    value: "Otto-von-Guericke-Universität Magdeburg",
  },
  {
    label: "Ouachita Baptist University",
    value: "Ouachita Baptist University",
  },
  {
    label: "Oulun Seudun ammattikorkeakoulu",
    value: "Oulun Seudun ammattikorkeakoulu",
  },
  {
    label: "Oulun yliopisto",
    value: "Oulun yliopisto",
  },
  {
    label: "Our Lady of Fatima University",
    value: "Our Lady of Fatima University",
  },
  {
    label: "Our Lady of the Lake University",
    value: "Our Lady of the Lake University",
  },
  {
    label: "Overseas Chinese University",
    value: "Overseas Chinese University",
  },
  {
    label: "Oxford Brookes University",
    value: "Oxford Brookes University",
  },
  {
    label: "Ozark Christian College",
    value: "Ozark Christian College",
  },
  {
    label: "O'zbekiston Davlat Jahon Tillari Universiteti",
    value: "O'zbekiston Davlat Jahon Tillari Universiteti",
  },
  {
    label: "O'zbekiston davlat jismoniy tarbiya va sport universiteti",
    value: "O'zbekiston davlat jismoniy tarbiya va sport universiteti",
  },
  {
    label: "O'zbekiston Davlat Konservatoriyasi",
    value: "O'zbekiston Davlat Konservatoriyasi",
  },
  {
    label: "O'zbekiston Davlat San'at va Madaniyat Instituti",
    value: "O'zbekiston Davlat San'at va Madaniyat Instituti",
  },
  {
    label: "O'zbekiston davlat xoreografiya akademiyasi",
    value: "O'zbekiston davlat xoreografiya akademiyasi",
  },
  {
    label: "O'zbekiston Milliy Universiteti",
    value: "O'zbekiston Milliy Universiteti",
  },
  {
    label:
      "O'zbekiston Respublikasi Davlat soliq qo'mitasi huzuridagi Fiskal institut",
    value:
      "O'zbekiston Respublikasi Davlat soliq qo'mitasi huzuridagi Fiskal institut",
  },
  {
    label: "O'zbekiston xalqaro islom akademiyasi",
    value: "O'zbekiston xalqaro islom akademiyasi",
  },
  {
    label: "O'zbekistondagi Sharda Universiteti",
    value: "O'zbekistondagi Sharda Universiteti",
  },
  {
    label: "O'zbekiston-Koreya Xalqaro Universiteti",
    value: "O'zbekiston-Koreya Xalqaro Universiteti",
  },
  {
    label: "Özyegin Üniversitesi",
    value: "Özyegin Üniversitesi",
  },
  {
    label: "P P Savani University",
    value: "P P Savani University",
  },
  {
    label: "P.A. College",
    value: "P.A. College",
  },
  {
    label: "P.K. University",
    value: "P.K. University",
  },
  {
    label: "Pabna Science and Technology University",
    value: "Pabna Science and Technology University",
  },
  {
    label: "Pace University",
    value: "Pace University",
  },
  {
    label: "Pacific Adventist University",
    value: "Pacific Adventist University",
  },
  {
    label: "Pacific Lutheran University",
    value: "Pacific Lutheran University",
  },
  {
    label: "Pacific Medical University",
    value: "Pacific Medical University",
  },
  {
    label: "Pacific National University",
    value: "Pacific National University",
  },
  {
    label: "Pacific Oaks College",
    value: "Pacific Oaks College",
  },
  {
    label: "Pacific State Medical University",
    value: "Pacific State Medical University",
  },
  {
    label: "Pacific Union College",
    value: "Pacific Union College",
  },
  {
    label: "Pacific University",
    value: "Pacific University",
  },
  {
    label: "Pacific University, India",
    value: "Pacific University, India",
  },
  {
    label: "Pacifica Graduate Institute",
    value: "Pacifica Graduate Institute",
  },
  {
    label: "Pädagogische Hochschule Freiburg",
    value: "Pädagogische Hochschule Freiburg",
  },
  {
    label: "Pädagogische Hochschule Heidelberg",
    value: "Pädagogische Hochschule Heidelberg",
  },
  {
    label: "Pädagogische Hochschule Karlsruhe",
    value: "Pädagogische Hochschule Karlsruhe",
  },
  {
    label: "Pädagogische Hochschule Kärnten",
    value: "Pädagogische Hochschule Kärnten",
  },
  {
    label: "Pädagogische Hochschule Ludwigsburg",
    value: "Pädagogische Hochschule Ludwigsburg",
  },
  {
    label: "Pädagogische Hochschule Niederösterreich",
    value: "Pädagogische Hochschule Niederösterreich",
  },
  {
    label: "Pädagogische Hochschule Oberösterreich",
    value: "Pädagogische Hochschule Oberösterreich",
  },
  {
    label: "Pädagogische Hochschule Salzburg Stefan Zweig",
    value: "Pädagogische Hochschule Salzburg Stefan Zweig",
  },
  {
    label: "Pädagogische Hochschule Schwäbisch Gmünd",
    value: "Pädagogische Hochschule Schwäbisch Gmünd",
  },
  {
    label: "Pädagogische Hochschule Steiermark",
    value: "Pädagogische Hochschule Steiermark",
  },
  {
    label: "Pädagogische Hochschule Tirol",
    value: "Pädagogische Hochschule Tirol",
  },
  {
    label: "Pädagogische Hochschule Vorarlberg",
    value: "Pädagogische Hochschule Vorarlberg",
  },
  {
    label: "Pädagogische Hochschule Weingarten",
    value: "Pädagogische Hochschule Weingarten",
  },
  {
    label: "Pädagogische Hochschule Wien",
    value: "Pädagogische Hochschule Wien",
  },
  {
    label: "Padmashree Dr. D.Y. Patil Vidyapith",
    value: "Padmashree Dr. D.Y. Patil Vidyapith",
  },
  {
    label: "Paglory University",
    value: "Paglory University",
  },
  {
    label: "Pai Chai University",
    value: "Pai Chai University",
  },
  {
    label: "Paine College",
    value: "Paine College",
  },
  {
    label: "Pakistan Institute of Development Economics",
    value: "Pakistan Institute of Development Economics",
  },
  {
    label: "Pakistan Institute of Engineering and Applied Sciences",
    value: "Pakistan Institute of Engineering and Applied Sciences",
  },
  {
    label: "Pakistan Institute of Fashion and Design",
    value: "Pakistan Institute of Fashion and Design",
  },
  {
    label: "Pakokku University",
    value: "Pakokku University",
  },
  {
    label: "Paktia University",
    value: "Paktia University",
  },
  {
    label: "Palamuru University",
    value: "Palamuru University",
  },
  {
    label: "Palawan State University",
    value: "Palawan State University",
  },
  {
    label: "Palestine Ahliya University",
    value: "Palestine Ahliya University",
  },
  {
    label: "Palestine College of Nursing",
    value: "Palestine College of Nursing",
  },
  {
    label: "Palestine Polytechnic University",
    value: "Palestine Polytechnic University",
  },
  {
    label: "Palestine Technical College",
    value: "Palestine Technical College",
  },
  {
    label: "Palestine Technical College Arroub",
    value: "Palestine Technical College Arroub",
  },
  {
    label: "Palestine Technical University Kadoorie",
    value: "Palestine Technical University Kadoorie",
  },
  {
    label: "Palm Beach Atlantic University",
    value: "Palm Beach Atlantic University",
  },
  {
    label: "Palm Beach State College",
    value: "Palm Beach State College",
  },
  {
    label: "Palo Alto University",
    value: "Palo Alto University",
  },
  {
    label: "Palucca Hochschule für Tanz Dresden",
    value: "Palucca Hochschule für Tanz Dresden",
  },
  {
    label: "Pamantasan ng Lungsod ng Maynila",
    value: "Pamantasan ng Lungsod ng Maynila",
  },
  {
    label: "Pamir Institute of Higher Education",
    value: "Pamir Institute of Higher Education",
  },
  {
    label: "PAMO University of Medical Sciences",
    value: "PAMO University of Medical Sciences",
  },
  {
    label: "Pamukkale Üniversitesi",
    value: "Pamukkale Üniversitesi",
  },
  {
    label: "Pan Africa Christian University",
    value: "Pan Africa Christian University",
  },
  {
    label: "Pan-Atlantic University",
    value: "Pan-Atlantic University",
  },
  {
    label: "Pandit Deendayal Petroleum University",
    value: "Pandit Deendayal Petroleum University",
  },
  {
    label: "Pandit Deendayal Upadhyaya Shekhawati University",
    value: "Pandit Deendayal Upadhyaya Shekhawati University",
  },
  {
    label: "Pandit Ravishankar Shukla University",
    value: "Pandit Ravishankar Shukla University",
  },
  {
    label: "Paneurópska vysoká škola",
    value: "Paneurópska vysoká škola",
  },
  {
    label: "Panevežio kolegija",
    value: "Panevežio kolegija",
  },
  {
    label: "Panevropská univerzita",
    value: "Panevropská univerzita",
  },
  {
    label: "Panevropski univerzitet Apeiron",
    value: "Panevropski univerzitet Apeiron",
  },
  {
    label: "Pangasinan State University",
    value: "Pangasinan State University",
  },
  {
    label: "Panglong University",
    value: "Panglong University",
  },
  {
    label: "Panha Chiet University",
    value: "Panha Chiet University",
  },
  {
    label: "Panjab University",
    value: "Panjab University",
  },
  {
    label: "Paññasastra University of Cambodia",
    value: "Paññasastra University of Cambodia",
  },
  {
    label: "Pannon Egyetem",
    value: "Pannon Egyetem",
  },
  {
    label:
      "Panstwowa Akademia Nauk Stosowanych im. Ignacego Moscickiego w Ciechanowie",
    value:
      "Panstwowa Akademia Nauk Stosowanych im. Ignacego Moscickiego w Ciechanowie",
  },
  {
    label: "Panstwowa Akademia Nauk Stosowanych w Chelmie",
    value: "Panstwowa Akademia Nauk Stosowanych w Chelmie",
  },
  {
    label: "Panteion University",
    value: "Panteion University",
  },
  {
    label: "Panzhihua University",
    value: "Panzhihua University",
  },
  {
    label: "Papua New Guinea University of Technology",
    value: "Papua New Guinea University of Technology",
  },
  {
    label: "Paracelsus Medizinische Privatuniversität",
    value: "Paracelsus Medizinische Privatuniversität",
  },
  {
    label: "Paragon International University",
    value: "Paragon International University",
  },
  {
    label: "Pardee RAND Graduate School",
    value: "Pardee RAND Graduate School",
  },
  {
    label: "Paris Lodron Universität Salzburg",
    value: "Paris Lodron Universität Salzburg",
  },
  {
    label: "Park University",
    value: "Park University",
  },
  {
    label: "Parker University",
    value: "Parker University",
  },
  {
    label: "Partido State University",
    value: "Partido State University",
  },
  {
    label: "Parul University",
    value: "Parul University",
  },
  {
    label: "Parwan University",
    value: "Parwan University",
  },
  {
    label: "Pasig Catholic College",
    value: "Pasig Catholic College",
  },
  {
    label: "Pathein University",
    value: "Pathein University",
  },
  {
    label: "Pathumthani University",
    value: "Pathumthani University",
  },
  {
    label: "Pathumwan Institute of Technology",
    value: "Pathumwan Institute of Technology",
  },
  {
    label: "Patna University",
    value: "Patna University",
  },
  {
    label: "PATTS College of Aeronautics",
    value: "PATTS College of Aeronautics",
  },
  {
    label: "Patuakhali Science and Technology University",
    value: "Patuakhali Science and Technology University",
  },
  {
    label: "Paul Quinn College",
    value: "Paul Quinn College",
  },
  {
    label: "Paul Smith's College",
    value: "Paul Smith's College",
  },
  {
    label: "Paul University",
    value: "Paul University",
  },
  {
    label: "Pavlodar State Pedagogical University",
    value: "Pavlodar State Pedagogical University",
  },
  {
    label: "Pavlov First Saint Petersburg State Medical University",
    value: "Pavlov First Saint Petersburg State Medical University",
  },
  {
    label: "Payam Institute of Higher Education",
    value: "Payam Institute of Higher Education",
  },
  {
    label: "Payap University",
    value: "Payap University",
  },
  {
    label: "Pázmány Péter Katolikus Egyetem",
    value: "Pázmány Péter Katolikus Egyetem",
  },
  {
    label: "PDM University",
    value: "PDM University",
  },
  {
    label:
      "PDPM Indian Institute of Information Technology, Design and Manufacturing",
    value:
      "PDPM Indian Institute of Information Technology, Design and Manufacturing",
  },
  {
    label: "PEC University of Technology",
    value: "PEC University of Technology",
  },
  {
    label: "Pécsi Tudományegyetem",
    value: "Pécsi Tudományegyetem",
  },
  {
    label: "Pedagogical Institute of Panjakent",
    value: "Pedagogical Institute of Panjakent",
  },
  {
    label: "Peirce College",
    value: "Peirce College",
  },
  {
    label: "Peking Union Medical College",
    value: "Peking Union Medical College",
  },
  {
    label: "Peking University",
    value: "Peking University",
  },
  {
    label: "Penn State College of Medicine",
    value: "Penn State College of Medicine",
  },
  {
    label: "Penn State University",
    value: "Penn State University",
  },
  {
    label: "Pennsylvania Academy of the Fine Arts",
    value: "Pennsylvania Academy of the Fine Arts",
  },
  {
    label: "Pennsylvania College of Art and Design",
    value: "Pennsylvania College of Art and Design",
  },
  {
    label: "Pennsylvania College of Technology",
    value: "Pennsylvania College of Technology",
  },
  {
    label: "PennWest California",
    value: "PennWest California",
  },
  {
    label: "PennWest Clarion",
    value: "PennWest Clarion",
  },
  {
    label: "PennWest Edinboro",
    value: "PennWest Edinboro",
  },
  {
    label: "Pensacola State College",
    value: "Pensacola State College",
  },
  {
    label: "Pentecost University",
    value: "Pentecost University",
  },
  {
    label: "Pentecostal Life University",
    value: "Pentecostal Life University",
  },
  {
    label: "Penza State Agricultural Academy",
    value: "Penza State Agricultural Academy",
  },
  {
    label: "Penza State Technological University",
    value: "Penza State Technological University",
  },
  {
    label: "Penza State University",
    value: "Penza State University",
  },
  {
    label: "Penza State University of Architecture and Construction",
    value: "Penza State University of Architecture and Construction",
  },
  {
    label: "People's Public Security University of China",
    value: "People's Public Security University of China",
  },
  {
    label: "People's University",
    value: "People's University",
  },
  {
    label: "Peoples University of Medical and Health Sciences for Women",
    value: "Peoples University of Medical and Health Sciences for Women",
  },
  {
    label: "Pepperdine University",
    value: "Pepperdine University",
  },
  {
    label: "Perdana University",
    value: "Perdana University",
  },
  {
    label: "Peres Academic Center",
    value: "Peres Academic Center",
  },
  {
    label: "Perez University College",
    value: "Perez University College",
  },
  {
    label: "Periyar Maniammai Institute of Science and Technology",
    value: "Periyar Maniammai Institute of Science and Technology",
  },
  {
    label: "Periyar University",
    value: "Periyar University",
  },
  {
    label: "Perm State Academy of Medicine",
    value: "Perm State Academy of Medicine",
  },
  {
    label: "Perm State Pedagogical University",
    value: "Perm State Pedagogical University",
  },
  {
    label: "Perm State Technical University",
    value: "Perm State Technical University",
  },
  {
    label: "Perm State University",
    value: "Perm State University",
  },
  {
    label: "Persian Gulf University",
    value: "Persian Gulf University",
  },
  {
    label: "Peru State College",
    value: "Peru State College",
  },
  {
    label: "PES University",
    value: "PES University",
  },
  {
    label: "Peshgam Institute of Higher Education",
    value: "Peshgam Institute of Higher Education",
  },
  {
    label: "Peter the Great St.Petersburg Polytechnic University",
    value: "Peter the Great St.Petersburg Polytechnic University",
  },
  {
    label: "Petre Shotadze Tbilisi Medical Academy",
    value: "Petre Shotadze Tbilisi Medical Academy",
  },
  {
    label: "Petro Tchaikovsky National Music Academy of Ukraine",
    value: "Petro Tchaikovsky National Music Academy of Ukraine",
  },
  {
    label: "Petroleum University of Technology",
    value: "Petroleum University of Technology",
  },
  {
    label: "Petrozavodsk State Conservatory",
    value: "Petrozavodsk State Conservatory",
  },
  {
    label: "Petrozavodsk State University",
    value: "Petrozavodsk State University",
  },
  {
    label: "Pfeiffer University",
    value: "Pfeiffer University",
  },
  {
    label: "Pharos University in Alexandria",
    value: "Pharos University in Alexandria",
  },
  {
    label: "Phetchabun Rajabhat University",
    value: "Phetchabun Rajabhat University",
  },
  {
    label: "Phetchaburi Rajabhat University",
    value: "Phetchaburi Rajabhat University",
  },
  {
    label: "Philadelphia University",
    value: "Philadelphia University",
  },
  {
    label: "Philander Smith University",
    value: "Philander Smith University",
  },
  {
    label: "Philippine Christian University",
    value: "Philippine Christian University",
  },
  {
    label: "Philippine Normal University",
    value: "Philippine Normal University",
  },
  {
    label: "Philippine School of Business Administration",
    value: "Philippine School of Business Administration",
  },
  {
    label: "Philipps-Universität Marburg",
    value: "Philipps-Universität Marburg",
  },
  {
    label: "Philosophisch-Theologische Hochschule Münster",
    value: "Philosophisch-Theologische Hochschule Münster",
  },
  {
    label: "Philosophisch-Theologische Hochschule Sankt Georgen",
    value: "Philosophisch-Theologische Hochschule Sankt Georgen",
  },
  {
    label: "Phitsanulok University",
    value: "Phitsanulok University",
  },
  {
    label: "Phnom Penh International University",
    value: "Phnom Penh International University",
  },
  {
    label: "Phranakhon Rajabhat University",
    value: "Phranakhon Rajabhat University",
  },
  {
    label: "Phranakhon Si Ayutthaya Rajabhat University",
    value: "Phranakhon Si Ayutthaya Rajabhat University",
  },
  {
    label: "Phuket Rajabhat University",
    value: "Phuket Rajabhat University",
  },
  {
    label: "Phuong Dong University",
    value: "Phuong Dong University",
  },
  {
    label: "Pibulsongkram Rajabhat University",
    value: "Pibulsongkram Rajabhat University",
  },
  {
    label: "Piedmont College",
    value: "Piedmont College",
  },
  {
    label: "PIGIER Benin",
    value: "PIGIER Benin",
  },
  {
    label: "Pillar College",
    value: "Pillar College",
  },
  {
    label: "Pingdingshan University",
    value: "Pingdingshan University",
  },
  {
    label: "Pingxiang University",
    value: "Pingxiang University",
  },
  {
    label: "Pioneer International University",
    value: "Pioneer International University",
  },
  {
    label: "Pir Mehr Ali Shah Arid Agriculture University",
    value: "Pir Mehr Ali Shah Arid Agriculture University",
  },
  {
    label: "Piri Reis Üniversitesi",
    value: "Piri Reis Üniversitesi",
  },
  {
    label: "Pittsburg State University",
    value: "Pittsburg State University",
  },
  {
    label: "Pitzer College",
    value: "Pitzer College",
  },
  {
    label: "Plastindia International University",
    value: "Plastindia International University",
  },
  {
    label: "Plateau State University",
    value: "Plateau State University",
  },
  {
    label: "Plaza College",
    value: "Plaza College",
  },
  {
    label: "Plekhanov Russian University of Economics",
    value: "Plekhanov Russian University of Economics",
  },
  {
    label: "Plymouth Marjon University",
    value: "Plymouth Marjon University",
  },
  {
    label: "Plymouth State University",
    value: "Plymouth State University",
  },
  {
    label: "PNG University of Natural Resources and Environment",
    value: "PNG University of Natural Resources and Environment",
  },
  {
    label: "Podillia State University",
    value: "Podillia State University",
  },
  {
    label: "Pohang University of Science and Technology",
    value: "Pohang University of Science and Technology",
  },
  {
    label: "Point Loma Nazarene University",
    value: "Point Loma Nazarene University",
  },
  {
    label: "Point Park University",
    value: "Point Park University",
  },
  {
    label: "Point University",
    value: "Point University",
  },
  {
    label: "Pokhara University",
    value: "Pokhara University",
  },
  {
    label: "Polessky State University",
    value: "Polessky State University",
  },
  {
    label: "Polissia National University",
    value: "Polissia National University",
  },
  {
    label: "Politechnika Bialostocka",
    value: "Politechnika Bialostocka",
  },
  {
    label: "Politechnika Bydgoska im. Jana i Jedrzeja Sniadeckich",
    value: "Politechnika Bydgoska im. Jana i Jedrzeja Sniadeckich",
  },
  {
    label: "Politechnika Czestochowska",
    value: "Politechnika Czestochowska",
  },
  {
    label: "Politechnika Gdanska",
    value: "Politechnika Gdanska",
  },
  {
    label: "Politechnika Koszalinska",
    value: "Politechnika Koszalinska",
  },
  {
    label: "Politechnika Krakowska im. Tadeusza Kosciuszki",
    value: "Politechnika Krakowska im. Tadeusza Kosciuszki",
  },
  {
    label: "Politechnika Lódzka",
    value: "Politechnika Lódzka",
  },
  {
    label: "Politechnika Lubelska",
    value: "Politechnika Lubelska",
  },
  {
    label: "Politechnika Morska w Szczecinie",
    value: "Politechnika Morska w Szczecinie",
  },
  {
    label: "Politechnika Opolska",
    value: "Politechnika Opolska",
  },
  {
    label: "Politechnika Poznanska",
    value: "Politechnika Poznanska",
  },
  {
    label: "Politechnika Rzeszowska im. Ignacego Lukasiewicza",
    value: "Politechnika Rzeszowska im. Ignacego Lukasiewicza",
  },
  {
    label: "Politechnika Slaska",
    value: "Politechnika Slaska",
  },
  {
    label: "Politechnika Swietokrzyska w Kielcach",
    value: "Politechnika Swietokrzyska w Kielcach",
  },
  {
    label: "Politechnika Warszawska",
    value: "Politechnika Warszawska",
  },
  {
    label: "Politechnika Wroclawska",
    value: "Politechnika Wroclawska",
  },
  {
    label: "Politécnico Colombiano Jaime Isaza Cadavid",
    value: "Politécnico Colombiano Jaime Isaza Cadavid",
  },
  {
    label: "Politécnico de Punta del Este",
    value: "Politécnico de Punta del Este",
  },
  {
    label: "Politecnico di Bari",
    value: "Politecnico di Bari",
  },
  {
    label: "Politecnico di Milano",
    value: "Politecnico di Milano",
  },
  {
    label: "Politecnico di Torino",
    value: "Politecnico di Torino",
  },
  {
    label: "Politécnico Grancolombiano",
    value: "Politécnico Grancolombiano",
  },
  {
    label: "Politeknik Brunei",
    value: "Politeknik Brunei",
  },
  {
    label: "Polk State College",
    value: "Polk State College",
  },
  {
    label: "Polotsk State University",
    value: "Polotsk State University",
  },
  {
    label: "Polsko-Japonska Akademia Technik Komputerowych",
    value: "Polsko-Japonska Akademia Technik Komputerowych",
  },
  {
    label: "Poltava State Agrarian University",
    value: "Poltava State Agrarian University",
  },
  {
    label: "Poltava State Medical University",
    value: "Poltava State Medical University",
  },
  {
    label: "Poltava University of Economics and Trade",
    value: "Poltava University of Economics and Trade",
  },
  {
    label: "Poltava V. G. Korolenko National Pedagogical University",
    value: "Poltava V. G. Korolenko National Pedagogical University",
  },
  {
    label: "Polytechnic College Suriname",
    value: "Polytechnic College Suriname",
  },
  {
    label: "Polytechnic University",
    value: "Polytechnic University",
  },
  {
    label: "Polytechnic University of the Philippines",
    value: "Polytechnic University of the Philippines",
  },
  {
    label: "Polzunov Altai State Technical University",
    value: "Polzunov Altai State Technical University",
  },
  {
    label: "Pomona College",
    value: "Pomona College",
  },
  {
    label: "Pomorski Uniwersytet Medyczny w Szczecinie",
    value: "Pomorski Uniwersytet Medyczny w Szczecinie",
  },
  {
    label: "Ponce Health Sciences University",
    value: "Ponce Health Sciences University",
  },
  {
    label: "Pondicherry University",
    value: "Pondicherry University",
  },
  {
    label: "Ponnaiyan Ramajayam Institute of Science and Technology",
    value: "Ponnaiyan Ramajayam Institute of Science and Technology",
  },
  {
    label: "Pontifical Faculty of the Immaculate Conception",
    value: "Pontifical Faculty of the Immaculate Conception",
  },
  {
    label: "Pontificia Facoltà di Scienze dell'Educazione Auxilium",
    value: "Pontificia Facoltà di Scienze dell'Educazione Auxilium",
  },
  {
    label: "Pontificia Universidad Católica Argentina",
    value: "Pontificia Universidad Católica Argentina",
  },
  {
    label: "Pontificia Universidad Católica de Chile",
    value: "Pontificia Universidad Católica de Chile",
  },
  {
    label: "Pontificia Universidad Católica de Puerto Rico",
    value: "Pontificia Universidad Católica de Puerto Rico",
  },
  {
    label: "Pontificia Universidad Católica de Valparaíso",
    value: "Pontificia Universidad Católica de Valparaíso",
  },
  {
    label: "Pontificia Universidad Católica del Ecuador",
    value: "Pontificia Universidad Católica del Ecuador",
  },
  {
    label: "Pontificia Universidad Católica del Perú",
    value: "Pontificia Universidad Católica del Perú",
  },
  {
    label: "Pontificia Universidad Católica Madre y Maestra",
    value: "Pontificia Universidad Católica Madre y Maestra",
  },
  {
    label: "Pontificia Universidad Javeriana",
    value: "Pontificia Universidad Javeriana",
  },
  {
    label: "Pontifícia Universidade Católica de Campinas",
    value: "Pontifícia Universidade Católica de Campinas",
  },
  {
    label: "Pontifícia Universidade Católica de Goiás",
    value: "Pontifícia Universidade Católica de Goiás",
  },
  {
    label: "Pontifícia Universidade Católica de Minas Gerais",
    value: "Pontifícia Universidade Católica de Minas Gerais",
  },
  {
    label: "Pontifícia Universidade Católica de São Paulo",
    value: "Pontifícia Universidade Católica de São Paulo",
  },
  {
    label: "Pontifícia Universidade Católica do Paraná",
    value: "Pontifícia Universidade Católica do Paraná",
  },
  {
    label: "Pontifícia Universidade Católica do Rio de Janeiro",
    value: "Pontifícia Universidade Católica do Rio de Janeiro",
  },
  {
    label: "Pontifícia Universidade Católica do Rio Grande do Sul",
    value: "Pontifícia Universidade Católica do Rio Grande do Sul",
  },
  {
    label: "Pontificia Università Antonianum",
    value: "Pontificia Università Antonianum",
  },
  {
    label: "Pontificia Università della Santa Croce",
    value: "Pontificia Università della Santa Croce",
  },
  {
    label: "Pontificia Università Gregoriana",
    value: "Pontificia Università Gregoriana",
  },
  {
    label: "Pontificia Università Lateranense",
    value: "Pontificia Università Lateranense",
  },
  {
    label: "Pontificia Università San Tommaso d'Aquino",
    value: "Pontificia Università San Tommaso d'Aquino",
  },
  {
    label: "Pontificia Università Urbaniana",
    value: "Pontificia Università Urbaniana",
  },
  {
    label: "Pontificio Istituto di Archeologia Cristiana",
    value: "Pontificio Istituto di Archeologia Cristiana",
  },
  {
    label: "Poornima University",
    value: "Poornima University",
  },
  {
    label: "Port City International University",
    value: "Port City International University",
  },
  {
    label: "Port Said University",
    value: "Port Said University",
  },
  {
    label: "Portland State University",
    value: "Portland State University",
  },
  {
    label: "Poslovno veleucilište Zagreb",
    value: "Poslovno veleucilište Zagreb",
  },
  {
    label: "Post Graduate Institute of Medical Education and Research",
    value: "Post Graduate Institute of Medical Education and Research",
  },
  {
    label: "Post University",
    value: "Post University",
  },
  {
    label: "Potti Sreeramulu Telugu University",
    value: "Potti Sreeramulu Telugu University",
  },
  {
    label: "Prague City University",
    value: "Prague City University",
  },
  {
    label: "Pragyan International University",
    value: "Pragyan International University",
  },
  {
    label: "Prairie View A&M University",
    value: "Prairie View A&M University",
  },
  {
    label: "Pratap University",
    value: "Pratap University",
  },
  {
    label: "Pratt Institute",
    value: "Pratt Institute",
  },
  {
    label: "Pravara Institute of Medical Sciences",
    value: "Pravara Institute of Medical Sciences",
  },
  {
    label: "Pražská vysoká škola psychosociálních studií",
    value: "Pražská vysoká škola psychosociálních studií",
  },
  {
    label: "Preah Sihanouk Raja Buddhist University",
    value: "Preah Sihanouk Raja Buddhist University",
  },
  {
    label: "Precarpathian National University",
    value: "Precarpathian National University",
  },
  {
    label: "Precious Cornerstone University",
    value: "Precious Cornerstone University",
  },
  {
    label: "Prefectural University of Hiroshima",
    value: "Prefectural University of Hiroshima",
  },
  {
    label: "Prefectural University of Kumamoto",
    value: "Prefectural University of Kumamoto",
  },
  {
    label: "Prek Leap National Institute of Agriculture",
    value: "Prek Leap National Institute of Agriculture",
  },
  {
    label: "Premier University",
    value: "Premier University",
  },
  {
    label: "Presbyterian College",
    value: "Presbyterian College",
  },
  {
    label: "Presbyterian University and Theological Seminary",
    value: "Presbyterian University and Theological Seminary",
  },
  {
    label: "Presbyterian University, Ghana",
    value: "Presbyterian University, Ghana",
  },
  {
    label: "Prescott College",
    value: "Prescott College",
  },
  {
    label: "Presidency University",
    value: "Presidency University",
  },
  {
    label: "Presidency University",
    value: "Presidency University",
  },
  {
    label: "Presidency University, Bangladesh",
    value: "Presidency University, Bangladesh",
  },
  {
    label: "President Ramon Magsaysay State University",
    value: "President Ramon Magsaysay State University",
  },
  {
    label: "Prešovská univerzita v Prešove",
    value: "Prešovská univerzita v Prešove",
  },
  {
    label: "Preston University",
    value: "Preston University",
  },
  {
    label: "Prime University",
    value: "Prime University",
  },
  {
    label: "Primeasia University",
    value: "Primeasia University",
  },
  {
    label: "Prince Mohammad Bin Fahd University",
    value: "Prince Mohammad Bin Fahd University",
  },
  {
    label: "Prince of Songkla University",
    value: "Prince of Songkla University",
  },
  {
    label: "Prince Sattam Bin Abdulaziz University",
    value: "Prince Sattam Bin Abdulaziz University",
  },
  {
    label: "Prince Sultan University",
    value: "Prince Sultan University",
  },
  {
    label: "Princess Galyani Vadhana Institute of Music",
    value: "Princess Galyani Vadhana Institute of Music",
  },
  {
    label: "Princess Nora bint Abdulrahman University",
    value: "Princess Nora bint Abdulrahman University",
  },
  {
    label: "Princess of Naradhiwas University",
    value: "Princess of Naradhiwas University",
  },
  {
    label: "Princess Sumaya University for Technology",
    value: "Princess Sumaya University for Technology",
  },
  {
    label: "Princeton University",
    value: "Princeton University",
  },
  {
    label: "Principia College",
    value: "Principia College",
  },
  {
    label: "Private Hochschule für Wirtschaft und Technik",
    value: "Private Hochschule für Wirtschaft und Technik",
  },
  {
    label: "Private Hochschule Göttingen",
    value: "Private Hochschule Göttingen",
  },
  {
    label: "Private Pädagogische Hochschule Augustinum",
    value: "Private Pädagogische Hochschule Augustinum",
  },
  {
    label: "Private Pädagogische Hochschule Burgenland",
    value: "Private Pädagogische Hochschule Burgenland",
  },
  {
    label: "Private Pädagogische Hochschule der Diözese Linz",
    value: "Private Pädagogische Hochschule der Diözese Linz",
  },
  {
    label:
      "Private Universität für Gesundheitswissenschaften, Medizinische Informatik und Technik",
    value:
      "Private Universität für Gesundheitswissenschaften, Medizinische Informatik und Technik",
  },
  {
    label: "Private Universität im fürstentum Liechtenstein",
    value: "Private Universität im fürstentum Liechtenstein",
  },
  {
    label: "Privatuniversität Schloss Seeburg",
    value: "Privatuniversität Schloss Seeburg",
  },
  {
    label: "Privolzhsky Research Medical University",
    value: "Privolzhsky Research Medical University",
  },
  {
    label: "Prof. Rajendra Singh (Rajju Bhaiya) University",
    value: "Prof. Rajendra Singh (Rajju Bhaiya) University",
  },
  {
    label: "Professor Jayashankar Telangana State Agricultural University",
    value: "Professor Jayashankar Telangana State Agricultural University",
  },
  {
    label: "Progress University of Gyumri",
    value: "Progress University of Gyumri",
  },
  {
    label: "Protestant Institute of Arts and Social Sciences",
    value: "Protestant Institute of Arts and Social Sciences",
  },
  {
    label: "Provadis Hochschule",
    value: "Provadis Hochschule",
  },
  {
    label: "Providence Christian College",
    value: "Providence Christian College",
  },
  {
    label: "Providence College",
    value: "Providence College",
  },
  {
    label: "Providence University",
    value: "Providence University",
  },
  {
    label: "Pryazovskyi State Technical University",
    value: "Pryazovskyi State Technical University",
  },
  {
    label: "Prydniprovska State Academy of Civil Engineering and Architecture",
    value: "Prydniprovska State Academy of Civil Engineering and Architecture",
  },
  {
    label: "Pskov State Pedagogical University",
    value: "Pskov State Pedagogical University",
  },
  {
    label: "Psychologische Hochschule Berlin",
    value: "Psychologische Hochschule Berlin",
  },
  {
    label: "Pt. Bhagwat Dayal Sharma University of Health Sciences",
    value: "Pt. Bhagwat Dayal Sharma University of Health Sciences",
  },
  {
    label: "Puer University",
    value: "Puer University",
  },
  {
    label: "Pukyong National University",
    value: "Pukyong National University",
  },
  {
    label: "Pundra University of Science and Technology",
    value: "Pundra University of Science and Technology",
  },
  {
    label: "Punjab Agricultural University",
    value: "Punjab Agricultural University",
  },
  {
    label: "Punjab Technical University",
    value: "Punjab Technical University",
  },
  {
    label: "Punjabi University Patiala",
    value: "Punjabi University Patiala",
  },
  {
    label: "Punyashlok Ahilyadevi Holkar Solapur University",
    value: "Punyashlok Ahilyadevi Holkar Solapur University",
  },
  {
    label: "Purbanchal University",
    value: "Purbanchal University",
  },
  {
    label: "Purchase College, State University of New York",
    value: "Purchase College, State University of New York",
  },
  {
    label: "Purdue University",
    value: "Purdue University",
  },
  {
    label: "Purdue University Fort Wayne",
    value: "Purdue University Fort Wayne",
  },
  {
    label: "Purdue University Northwest",
    value: "Purdue University Northwest",
  },
  {
    label: "Pusan National University",
    value: "Pusan National University",
  },
  {
    label: "Pushchino State Institute of Natural Science",
    value: "Pushchino State Institute of Natural Science",
  },
  {
    label: "Pushkin State Russian Language Institute",
    value: "Pushkin State Russian Language Institute",
  },
  {
    label: "Putian University",
    value: "Putian University",
  },
  {
    label: "Pwani University",
    value: "Pwani University",
  },
  {
    label: "Pyatigorsk State Pharmaceutical Academy",
    value: "Pyatigorsk State Pharmaceutical Academy",
  },
  {
    label: "Pyatigorsk State University",
    value: "Pyatigorsk State University",
  },
  {
    label: "Pyay Technological University",
    value: "Pyay Technological University",
  },
  {
    label: "Pyeongtaek University",
    value: "Pyeongtaek University",
  },
  {
    label: "Pylyp Orlyk International Classical University",
    value: "Pylyp Orlyk International Classical University",
  },
  {
    label: "Pyongyang Medical University",
    value: "Pyongyang Medical University",
  },
  {
    label: "Pyongyang University of Agriculture",
    value: "Pyongyang University of Agriculture",
  },
  {
    label: "Pyongyang University of Architecture and Building Materials",
    value: "Pyongyang University of Architecture and Building Materials",
  },
  {
    label: "Pyongyang University of Foreign Studies",
    value: "Pyongyang University of Foreign Studies",
  },
  {
    label: "Pyongyang University of Music and Dance",
    value: "Pyongyang University of Music and Dance",
  },
  {
    label: "Pyongyang University of Printing Engineering",
    value: "Pyongyang University of Printing Engineering",
  },
  {
    label: "Pyongyang University of Railways",
    value: "Pyongyang University of Railways",
  },
  {
    label: "Pyongyang University of Science and Technology",
    value: "Pyongyang University of Science and Technology",
  },
  {
    label: "Qalam Institute of Higher Education",
    value: "Qalam Institute of Higher Education",
  },
  {
    label: "Qarshi Davlat Universiteti",
    value: "Qarshi Davlat Universiteti",
  },
  {
    label: "Qarshi Muhandislik Iqtisodiyot Instituti",
    value: "Qarshi Muhandislik Iqtisodiyot Instituti",
  },
  {
    label: "Qarshi University",
    value: "Qarshi University",
  },
  {
    label: "Qassim University",
    value: "Qassim University",
  },
  {
    label: "Qasyuon University for Science and Technology",
    value: "Qasyuon University for Science and Technology",
  },
  {
    label: "Qatar University",
    value: "Qatar University",
  },
  {
    label: "Qazvin University of Medical Sciences",
    value: "Qazvin University of Medical Sciences",
  },
  {
    label: "Qerbi Kaspi Universiteti",
    value: "Qerbi Kaspi Universiteti",
  },
  {
    label: "Qiannan Normal College for Nationalities",
    value: "Qiannan Normal College for Nationalities",
  },
  {
    label: "Qilu Institute of Technology",
    value: "Qilu Institute of Technology",
  },
  {
    label: "Qilu Medical University",
    value: "Qilu Medical University",
  },
  {
    label: "Qilu Normal University",
    value: "Qilu Normal University",
  },
  {
    label: "Qilu University of Technology",
    value: "Qilu University of Technology",
  },
  {
    label: "Qingdao Agricultural University",
    value: "Qingdao Agricultural University",
  },
  {
    label: "Qingdao Binhai University",
    value: "Qingdao Binhai University",
  },
  {
    label: "Qingdao Hengxing University of Science and Technology",
    value: "Qingdao Hengxing University of Science and Technology",
  },
  {
    label: "Qingdao Huanghai University",
    value: "Qingdao Huanghai University",
  },
  {
    label: "Qingdao Institute of Technology",
    value: "Qingdao Institute of Technology",
  },
  {
    label: "Qingdao University",
    value: "Qingdao University",
  },
  {
    label: "Qingdao University of Science and Technology",
    value: "Qingdao University of Science and Technology",
  },
  {
    label: "Qingdao University of Technology",
    value: "Qingdao University of Technology",
  },
  {
    label: "Qinghai Normal University",
    value: "Qinghai Normal University",
  },
  {
    label: "Qinghai University",
    value: "Qinghai University",
  },
  {
    label: "Qinghai University for Nationalities",
    value: "Qinghai University for Nationalities",
  },
  {
    label: "Qiongtai Normal University",
    value: "Qiongtai Normal University",
  },
  {
    label: "Qiqihar Institute of Engineering",
    value: "Qiqihar Institute of Engineering",
  },
  {
    label: "Qiqihar Medical University",
    value: "Qiqihar Medical University",
  },
  {
    label: "Qiqihar University",
    value: "Qiqihar University",
  },
  {
    label: "Qom University of Medical Sciences",
    value: "Qom University of Medical Sciences",
  },
  {
    label: "Qom University of Technology",
    value: "Qom University of Technology",
  },
  {
    label: "Qo'qon Davlat Pedagogika Instituti",
    value: "Qo'qon Davlat Pedagogika Instituti",
  },
  {
    label: "Qo'qon Universiteti",
    value: "Qo'qon Universiteti",
  },
  {
    label: "Qoraqalpoq Davlat Universiteti",
    value: "Qoraqalpoq Davlat Universiteti",
  },
  {
    label: "Quadriga Hochschule Berlin",
    value: "Quadriga Hochschule Berlin",
  },
  {
    label: "Quaid-e-Awam University of Engineering, Science and Technology",
    value: "Quaid-e-Awam University of Engineering, Science and Technology",
  },
  {
    label: "Quaid-i-Azam University",
    value: "Quaid-i-Azam University",
  },
  {
    label: "Quality Leadership University",
    value: "Quality Leadership University",
  },
  {
    label: "Quantum University",
    value: "Quantum University",
  },
  {
    label: "Quanzhou Institute of Information Engineering",
    value: "Quanzhou Institute of Information Engineering",
  },
  {
    label: "Quanzhou Normal University",
    value: "Quanzhou Normal University",
  },
  {
    label: "Quchan University of Advanced Technology",
    value: "Quchan University of Advanced Technology",
  },
  {
    label: "Quds Higher Education Institute",
    value: "Quds Higher Education Institute",
  },
  {
    label: "Queen Arwa University",
    value: "Queen Arwa University",
  },
  {
    label: "Queen Margaret University",
    value: "Queen Margaret University",
  },
  {
    label: "Queen Mary University of London",
    value: "Queen Mary University of London",
  },
  {
    label: "Queens College, City University of New York",
    value: "Queens College, City University of New York",
  },
  {
    label: "Queens University",
    value: "Queens University",
  },
  {
    label: "Queen's University",
    value: "Queen's University",
  },
  {
    label: "Queen's University Belfast",
    value: "Queen's University Belfast",
  },
  {
    label: "Queens University of Charlotte",
    value: "Queens University of Charlotte",
  },
  {
    label: "Queensland University",
    value: "Queensland University",
  },
  {
    label: "Queensland University of Technology",
    value: "Queensland University of Technology",
  },
  {
    label: "Quest International University",
    value: "Quest International University",
  },
  {
    label: "Quest University Canada",
    value: "Quest University Canada",
  },
  {
    label: "Qufu Normal University",
    value: "Qufu Normal University",
  },
  {
    label: "Quincy University",
    value: "Quincy University",
  },
  {
    label: "Quinnipiac University",
    value: "Quinnipiac University",
  },
  {
    label: "Quirino State University",
    value: "Quirino State University",
  },
  {
    label: "Qujing Normal University",
    value: "Qujing Normal University",
  },
  {
    label: "Qurtaba University",
    value: "Qurtaba University",
  },
  {
    label: "Quy Nhon University",
    value: "Quy Nhon University",
  },
  {
    label: "Quzhou University",
    value: "Quzhou University",
  },
  {
    label: "Rabia Balkhi University",
    value: "Rabia Balkhi University",
  },
  {
    label: "Rabindra Bharati University",
    value: "Rabindra Bharati University",
  },
  {
    label: "Rabindra Maitree University",
    value: "Rabindra Maitree University",
  },
  {
    label: "Rabindra University, Bangladesh",
    value: "Rabindra University, Bangladesh",
  },
  {
    label: "Rabindranath Tagore University",
    value: "Rabindranath Tagore University",
  },
  {
    label: "Radboud Universiteit",
    value: "Radboud Universiteit",
  },
  {
    label: "Radford University",
    value: "Radford University",
  },
  {
    label: "Radford University College",
    value: "Radford University College",
  },
  {
    label: "Raffles University",
    value: "Raffles University",
  },
  {
    label: "Rafik Hariri University",
    value: "Rafik Hariri University",
  },
  {
    label: "Rafsanjan University of Medical Sciences",
    value: "Rafsanjan University of Medical Sciences",
  },
  {
    label: "Rah-e-Saadat University",
    value: "Rah-e-Saadat University",
  },
  {
    label: "Rahnaward Institute of Higher Education",
    value: "Rahnaward Institute of Higher Education",
  },
  {
    label: "Rai Technology University",
    value: "Rai Technology University",
  },
  {
    label: "Rai University",
    value: "Rai University",
  },
  {
    label: "Raiganj University",
    value: "Raiganj University",
  },
  {
    label: "Raj Rishi Bharthari Matsya University",
    value: "Raj Rishi Bharthari Matsya University",
  },
  {
    label: "Raja Mansingh Tomar Music and Arts University",
    value: "Raja Mansingh Tomar Music and Arts University",
  },
  {
    label: "Rajabhat Maha Sarakham University",
    value: "Rajabhat Maha Sarakham University",
  },
  {
    label: "Rajamangala University of Technology Isarn",
    value: "Rajamangala University of Technology Isarn",
  },
  {
    label: "Rajamangala University of Technology Krungthep",
    value: "Rajamangala University of Technology Krungthep",
  },
  {
    label: "Rajamangala University of Technology Lanna",
    value: "Rajamangala University of Technology Lanna",
  },
  {
    label: "Rajamangala University of Technology Phra Nakhon",
    value: "Rajamangala University of Technology Phra Nakhon",
  },
  {
    label: "Rajamangala University of Technology Rattanakosin",
    value: "Rajamangala University of Technology Rattanakosin",
  },
  {
    label: "Rajamangala University of Technology Srivijaya",
    value: "Rajamangala University of Technology Srivijaya",
  },
  {
    label: "Rajamangala University of Technology Suvarnabhumi",
    value: "Rajamangala University of Technology Suvarnabhumi",
  },
  {
    label: "Rajamangala University of Technology Tawan-ok",
    value: "Rajamangala University of Technology Tawan-ok",
  },
  {
    label: "Rajamangala University of Technology Thanyaburi",
    value: "Rajamangala University of Technology Thanyaburi",
  },
  {
    label: "Rajanagarindra Rajabhat University",
    value: "Rajanagarindra Rajabhat University",
  },
  {
    label: "Rajapruk University",
    value: "Rajapruk University",
  },
  {
    label: "Rajarata University of Sri Lanka",
    value: "Rajarata University of Sri Lanka",
  },
  {
    label: "Rajasthan Technical University Kota",
    value: "Rajasthan Technical University Kota",
  },
  {
    label: "Rajasthan University of Health Sciences",
    value: "Rajasthan University of Health Sciences",
  },
  {
    label: "Rajasthan University of Veterinary and Animal Sciences",
    value: "Rajasthan University of Veterinary and Animal Sciences",
  },
  {
    label: "Rajin University of Marine Transport",
    value: "Rajin University of Marine Transport",
  },
  {
    label: "Rajiv Gandhi Institute of Petroleum Technology",
    value: "Rajiv Gandhi Institute of Petroleum Technology",
  },
  {
    label: "Rajiv Gandhi National Aviation University",
    value: "Rajiv Gandhi National Aviation University",
  },
  {
    label: "Rajiv Gandhi National Institute of Youth Development",
    value: "Rajiv Gandhi National Institute of Youth Development",
  },
  {
    label: "Rajiv Gandhi National University of Law",
    value: "Rajiv Gandhi National University of Law",
  },
  {
    label: "Rajiv Gandhi Proudyogiki Vishwavidyalaya",
    value: "Rajiv Gandhi Proudyogiki Vishwavidyalaya",
  },
  {
    label: "Rajiv Gandhi University",
    value: "Rajiv Gandhi University",
  },
  {
    label: "Rajiv Gandhi University of Health Sciences",
    value: "Rajiv Gandhi University of Health Sciences",
  },
  {
    label: "Rajiv Gandhi University of Knowledge Technologies",
    value: "Rajiv Gandhi University of Knowledge Technologies",
  },
  {
    label: "Rajiv Gandhi University of Science and Technology",
    value: "Rajiv Gandhi University of Science and Technology",
  },
  {
    label: "Rajmata Vijayaraje Scindia Krishi Vishwavidyalaya",
    value: "Rajmata Vijayaraje Scindia Krishi Vishwavidyalaya",
  },
  {
    label: "Rajshahi Medical University",
    value: "Rajshahi Medical University",
  },
  {
    label: "Rajshahi Science and Technology University",
    value: "Rajshahi Science and Technology University",
  },
  {
    label: "Rajshahi University",
    value: "Rajshahi University",
  },
  {
    label: "Rajshahi University of Engineering and Technology",
    value: "Rajshahi University of Engineering and Technology",
  },
  {
    label: "Rakuno Gakuen University",
    value: "Rakuno Gakuen University",
  },
  {
    label: "Rama Devi Women's University",
    value: "Rama Devi Women's University",
  },
  {
    label: "Rama University",
    value: "Rama University",
  },
  {
    label: "Ramaiah University of Applied Sciences",
    value: "Ramaiah University of Applied Sciences",
  },
  {
    label: "Ramakrishna Mission Vivekananda Educational and Research Institute",
    value: "Ramakrishna Mission Vivekananda Educational and Research Institute",
  },
  {
    label: "Ramapo College of New Jersey",
    value: "Ramapo College of New Jersey",
  },
  {
    label: "Rambhai Barni Rajabhat University",
    value: "Rambhai Barni Rajabhat University",
  },
  {
    label: "Ramkhamhaeng University",
    value: "Ramkhamhaeng University",
  },
  {
    label: "Rana University",
    value: "Rana University",
  },
  {
    label: "Ranada Prasad Shaha University",
    value: "Ranada Prasad Shaha University",
  },
  {
    label: "Ranchi University",
    value: "Ranchi University",
  },
  {
    label: "Randolph College",
    value: "Randolph College",
  },
  {
    label: "Randolph-Macon College",
    value: "Randolph-Macon College",
  },
  {
    label: "Rangamati Science and Technology University",
    value: "Rangamati Science and Technology University",
  },
  {
    label: "Rangsit University",
    value: "Rangsit University",
  },
  {
    label: "Rani Channamma University, Belagavi",
    value: "Rani Channamma University, Belagavi",
  },
  {
    label: "Rani Durgavati Vishwavidyalaya",
    value: "Rani Durgavati Vishwavidyalaya",
  },
  {
    label: "Rani Lakshmi Bai Central Agricultural University",
    value: "Rani Lakshmi Bai Central Agricultural University",
  },
  {
    label: "Ras al-Khaimah Medical and Health Sciences University",
    value: "Ras al-Khaimah Medical and Health Sciences University",
  },
  {
    label: "Ras Bihari Bose Subharti University",
    value: "Ras Bihari Bose Subharti University",
  },
  {
    label: "Rashtrasant Tukadoji Maharaj Nagpur University",
    value: "Rashtrasant Tukadoji Maharaj Nagpur University",
  },
  {
    label: "Rashtriya Raksha University",
    value: "Rashtriya Raksha University",
  },
  {
    label: "Rashtriya Sanskrit Sansthan University",
    value: "Rashtriya Sanskrit Sansthan University",
  },
  {
    label: "Rasmussen University",
    value: "Rasmussen University",
  },
  {
    label: "Ratchathani University",
    value: "Ratchathani University",
  },
  {
    label: "Rattana Bundit University",
    value: "Rattana Bundit University",
  },
  {
    label: "Rauf Denktas Üniversitesi",
    value: "Rauf Denktas Üniversitesi",
  },
  {
    label: "Ravensbourne University London",
    value: "Ravensbourne University London",
  },
  {
    label: "Ravenshaw University",
    value: "Ravenshaw University",
  },
  {
    label: "Rawalpindi Medical University",
    value: "Rawalpindi Medical University",
  },
  {
    label: "Rayalaseema University",
    value: "Rayalaseema University",
  },
  {
    label: "Rayat-Bahra University",
    value: "Rayat-Bahra University",
  },
  {
    label: "Razi University",
    value: "Razi University",
  },
  {
    label: "Recep Tayyip Erdogan Üniversitesi",
    value: "Recep Tayyip Erdogan Üniversitesi",
  },
  {
    label: "Red Sea University",
    value: "Red Sea University",
  },
  {
    label: "Redeemer University",
    value: "Redeemer University",
  },
  {
    label: "Redeemer's University",
    value: "Redeemer's University",
  },
  {
    label: "Reed College",
    value: "Reed College",
  },
  {
    label: "Reformed Church University",
    value: "Reformed Church University",
  },
  {
    label: "Regent University",
    value: "Regent University",
  },
  {
    label: "Regent University College of Science and Technology",
    value: "Regent University College of Science and Technology",
  },
  {
    label: "Regent's University London",
    value: "Regent's University London",
  },
  {
    label: "Regional Maritime University",
    value: "Regional Maritime University",
  },
  {
    label: "Regis College",
    value: "Regis College",
  },
  {
    label: "Regis University",
    value: "Regis University",
  },
  {
    label: "Reichman University",
    value: "Reichman University",
  },
  {
    label: "Reinhardt University",
    value: "Reinhardt University",
  },
  {
    label: "Reitaku University",
    value: "Reitaku University",
  },
  {
    label: "Relay Graduate School of Education",
    value: "Relay Graduate School of Education",
  },
  {
    label: "Renaissance University",
    value: "Renaissance University",
  },
  {
    label: "Renmin University of China",
    value: "Renmin University of China",
  },
  {
    label: "Rennes School of Business",
    value: "Rennes School of Business",
  },
  {
    label: "Rensselaer Polytechnic Institute",
    value: "Rensselaer Polytechnic Institute",
  },
  {
    label: "Republic Central Colleges",
    value: "Republic Central Colleges",
  },
  {
    label: "Research College of Nursing",
    value: "Research College of Nursing",
  },
  {
    label: "REVA University",
    value: "REVA University",
  },
  {
    label: "Rezeknes Tehnologiju Akademija",
    value: "Rezeknes Tehnologiju Akademija",
  },
  {
    label: "Rheinische Fachhochschule Köln",
    value: "Rheinische Fachhochschule Köln",
  },
  {
    label: "Rheinische Friedrich-Wilhelms-Universität Bonn",
    value: "Rheinische Friedrich-Wilhelms-Universität Bonn",
  },
  {
    label: "Rheinisch-Westfälische Technische Hochschule Aachen",
    value: "Rheinisch-Westfälische Technische Hochschule Aachen",
  },
  {
    label: "Rheinland-Pfälzische Technische Universität Kaiserslautern-Landau",
    value: "Rheinland-Pfälzische Technische Universität Kaiserslautern-Landau",
  },
  {
    label: "Rhema University",
    value: "Rhema University",
  },
  {
    label: "Rhode Island College",
    value: "Rhode Island College",
  },
  {
    label: "Rhode Island School of Design",
    value: "Rhode Island School of Design",
  },
  {
    label: "Rhodes College",
    value: "Rhodes College",
  },
  {
    label: "Rhodes University",
    value: "Rhodes University",
  },
  {
    label: "Riara University",
    value: "Riara University",
  },
  {
    label: "Rice University",
    value: "Rice University",
  },
  {
    label: "Richmond, The American International University in London",
    value: "Richmond, The American International University in London",
  },
  {
    label: "Richmont Graduate University",
    value: "Richmont Graduate University",
  },
  {
    label: "Rider University",
    value: "Rider University",
  },
  {
    label: "Rift Valley University",
    value: "Rift Valley University",
  },
  {
    label: "Rigas Aeronavigacijas instituts",
    value: "Rigas Aeronavigacijas instituts",
  },
  {
    label: "Rigas Ekonomikas augstskola",
    value: "Rigas Ekonomikas augstskola",
  },
  {
    label: "Rigas Juridiska augstskola",
    value: "Rigas Juridiska augstskola",
  },
  {
    label: "Rigas Stradina Universitate",
    value: "Rigas Stradina Universitate",
  },
  {
    label: "Rigas Tehniska universitate",
    value: "Rigas Tehniska universitate",
  },
  {
    label: "Rijksuniversiteit Groningen",
    value: "Rijksuniversiteit Groningen",
  },
  {
    label: "Rikkyo University",
    value: "Rikkyo University",
  },
  {
    label: "RIMT University",
    value: "RIMT University",
  },
  {
    label: "Ringling College of Art and Design",
    value: "Ringling College of Art and Design",
  },
  {
    label: "Riphah International University",
    value: "Riphah International University",
  },
  {
    label: "Ripon College",
    value: "Ripon College",
  },
  {
    label: "RISEBA University of Applied Sciences",
    value: "RISEBA University of Applied Sciences",
  },
  {
    label: "Rishihood University",
    value: "Rishihood University",
  },
  {
    label: "Rissho University",
    value: "Rissho University",
  },
  {
    label: "Ritman University",
    value: "Ritman University",
  },
  {
    label: "Ritsumeikan Asia Pacific University",
    value: "Ritsumeikan Asia Pacific University",
  },
  {
    label: "Ritsumeikan University",
    value: "Ritsumeikan University",
  },
  {
    label: "Rivers State University",
    value: "Rivers State University",
  },
  {
    label: "Rivier University",
    value: "Rivier University",
  },
  {
    label: "Rivne State Humanitarian University",
    value: "Rivne State Humanitarian University",
  },
  {
    label: "Rizal Technological University",
    value: "Rizal Technological University",
  },
  {
    label: "RK University",
    value: "RK University",
  },
  {
    label: "RKDF University",
    value: "RKDF University",
  },
  {
    label: "RMIT University",
    value: "RMIT University",
  },
  {
    label: "Roanoke College",
    value: "Roanoke College",
  },
  {
    label: "Robert Gordon University",
    value: "Robert Gordon University",
  },
  {
    label: "Robert Morris University",
    value: "Robert Morris University",
  },
  {
    label: "Robert Schumann Hochschule Düsseldorf",
    value: "Robert Schumann Hochschule Düsseldorf",
  },
  {
    label: "Roberts Wesleyan University",
    value: "Roberts Wesleyan University",
  },
  {
    label: "Rochester Institute of Technology",
    value: "Rochester Institute of Technology",
  },
  {
    label: "Rochester Institute of Technology Croatia",
    value: "Rochester Institute of Technology Croatia",
  },
  {
    label: "Rochester Institute of Technology, Dubai",
    value: "Rochester Institute of Technology, Dubai",
  },
  {
    label: "Rochester University",
    value: "Rochester University",
  },
  {
    label: "Rockford University",
    value: "Rockford University",
  },
  {
    label: "Rockhurst University",
    value: "Rockhurst University",
  },
  {
    label: "Rockview University",
    value: "Rockview University",
  },
  {
    label: "Rocky Mountain College",
    value: "Rocky Mountain College",
  },
  {
    label: "Rocky Mountain College of Art and Design",
    value: "Rocky Mountain College of Art and Design",
  },
  {
    label: "Rocky Mountain University of Health Professions",
    value: "Rocky Mountain University of Health Professions",
  },
  {
    label: "Rocky Vista University",
    value: "Rocky Vista University",
  },
  {
    label: "Röda Korsets högskola",
    value: "Röda Korsets högskola",
  },
  {
    label: "Roger Williams University",
    value: "Roger Williams University",
  },
  {
    label: "Rogers State University",
    value: "Rogers State University",
  },
  {
    label: "Roi-et Rajabhat University",
    value: "Roi-et Rajabhat University",
  },
  {
    label: "Rollins College",
    value: "Rollins College",
  },
  {
    label: "Romblon State University",
    value: "Romblon State University",
  },
  {
    label: "Rongo University",
    value: "Rongo University",
  },
  {
    label: "Roosevelt University",
    value: "Roosevelt University",
  },
  {
    label: "Rosalind Franklin University of Medicine and Science",
    value: "Rosalind Franklin University of Medicine and Science",
  },
  {
    label: "Rose Bruford College",
    value: "Rose Bruford College",
  },
  {
    label: "Rose-Hulman Institute of Technology",
    value: "Rose-Hulman Institute of Technology",
  },
  {
    label: "Roseman University of Health Sciences",
    value: "Roseman University of Health Sciences",
  },
  {
    label: "Rosemont College",
    value: "Rosemont College",
  },
  {
    label: "Roskilde Universitet",
    value: "Roskilde Universitet",
  },
  {
    label: "Ross University School of Medicine",
    value: "Ross University School of Medicine",
  },
  {
    label:
      "Rossiya Davlat Neft va Gaz Universitetining Toshkent Shahridagi Filiali",
    value:
      "Rossiya Davlat Neft va Gaz Universitetining Toshkent Shahridagi Filiali",
  },
  {
    label: "Rossiya iqtisodiyot universitetining Toshkent shahridagi filiali",
    value: "Rossiya iqtisodiyot universitetining Toshkent shahridagi filiali",
  },
  {
    label: "Rostov State Medical University",
    value: "Rostov State Medical University",
  },
  {
    label: "Rostov State University of Economics",
    value: "Rostov State University of Economics",
  },
  {
    label: "Rowan University",
    value: "Rowan University",
  },
  {
    label: "Royal Academy of Cambodia",
    value: "Royal Academy of Cambodia",
  },
  {
    label: "Royal College of Art",
    value: "Royal College of Art",
  },
  {
    label: "Royal College of Music",
    value: "Royal College of Music",
  },
  {
    label: "Royal College of Surgeons in Ireland",
    value: "Royal College of Surgeons in Ireland",
  },
  {
    label:
      "Royal College of Surgeons in Ireland - Medical University of Bahrain",
    value:
      "Royal College of Surgeons in Ireland - Medical University of Bahrain",
  },
  {
    label: "Royal Conservatoire of Scotland",
    value: "Royal Conservatoire of Scotland",
  },
  {
    label: "Royal Holloway, University of London",
    value: "Royal Holloway, University of London",
  },
  {
    label: "Royal Irish Academy of Music",
    value: "Royal Irish Academy of Music",
  },
  {
    label: "Royal Military College of Canada",
    value: "Royal Military College of Canada",
  },
  {
    label: "Royal Northern College of Music",
    value: "Royal Northern College of Music",
  },
  {
    label: "Royal Roads University",
    value: "Royal Roads University",
  },
  {
    label: "Royal University for Women",
    value: "Royal University for Women",
  },
  {
    label: "Royal University of Agriculture",
    value: "Royal University of Agriculture",
  },
  {
    label: "Royal University of Bhutan",
    value: "Royal University of Bhutan",
  },
  {
    label: "Royal University of Dhaka",
    value: "Royal University of Dhaka",
  },
  {
    label: "Royal University of Fine Arts",
    value: "Royal University of Fine Arts",
  },
  {
    label: "Royal University of Law and Economics",
    value: "Royal University of Law and Economics",
  },
  {
    label: "Royal University of Phnom Penh",
    value: "Royal University of Phnom Penh",
  },
  {
    label: "Royan Institute of Higher Education",
    value: "Royan Institute of Higher Education",
  },
  {
    label: "RRiF Visoka škola za financijski menadžment",
    value: "RRiF Visoka škola za financijski menadžment",
  },
  {
    label: "Ruaha Catholic University",
    value: "Ruaha Catholic University",
  },
  {
    label: "RUDN University",
    value: "RUDN University",
  },
  {
    label: "Rudny Industrial Institute",
    value: "Rudny Industrial Institute",
  },
  {
    label: "Ruhr-Universität Bochum",
    value: "Ruhr-Universität Bochum",
  },
  {
    label: "Rumbek University",
    value: "Rumbek University",
  },
  {
    label: "Ruppin Academic Center",
    value: "Ruppin Academic Center",
  },
  {
    label: "Ruprecht-Karls-Universität Heidelberg",
    value: "Ruprecht-Karls-Universität Heidelberg",
  },
  {
    label: "Rusangu University",
    value: "Rusangu University",
  },
  {
    label: "Rush University",
    value: "Rush University",
  },
  {
    label: "Rusizi International University",
    value: "Rusizi International University",
  },
  {
    label: "Russian National Research Medical University",
    value: "Russian National Research Medical University",
  },
  {
    label: "Russian New University",
    value: "Russian New University",
  },
  {
    label:
      "Russian Presidential Academy of National Economy and Public Administration",
    value:
      "Russian Presidential Academy of National Economy and Public Administration",
  },
  {
    label: "Russian State Agricultural University",
    value: "Russian State Agricultural University",
  },
  {
    label: "Russian State Geological Prospecting University",
    value: "Russian State Geological Prospecting University",
  },
  {
    label: "Russian State Hydrometeorological University",
    value: "Russian State Hydrometeorological University",
  },
  {
    label: "Russian State Institute of Performing Arts",
    value: "Russian State Institute of Performing Arts",
  },
  {
    label: "Russian State Social University",
    value: "Russian State Social University",
  },
  {
    label: "Russian State University A.N. Kosygin",
    value: "Russian State University A.N. Kosygin",
  },
  {
    label: "Russian State University for the Humanities",
    value: "Russian State University for the Humanities",
  },
  {
    label: "Russian State University of Oil and Gas",
    value: "Russian State University of Oil and Gas",
  },
  {
    label: "Russian State University of Tourism and Services",
    value: "Russian State University of Tourism and Services",
  },
  {
    label: "Russian University of Sport",
    value: "Russian University of Sport",
  },
  {
    label: "Russian University of Transport",
    value: "Russian University of Transport",
  },
  {
    label: "Russian-Armenian University",
    value: "Russian-Armenian University",
  },
  {
    label: "Russian-Tajik Slavonic University",
    value: "Russian-Tajik Slavonic University",
  },
  {
    label: "Rust College",
    value: "Rust College",
  },
  {
    label: "Rutgers, The State University of New Jersey",
    value: "Rutgers, The State University of New Jersey",
  },
  {
    label: "Ryazan State Agrotechnological University",
    value: "Ryazan State Agrotechnological University",
  },
  {
    label: "Ryazan State Medical University",
    value: "Ryazan State Medical University",
  },
  {
    label: "Ryazan State Radio Engineering University",
    value: "Ryazan State Radio Engineering University",
  },
  {
    label: "Ryazan State University",
    value: "Ryazan State University",
  },
  {
    label: "Rybinsk State Aviation Technical University",
    value: "Rybinsk State Aviation Technical University",
  },
  {
    label: "Ryotokuji University",
    value: "Ryotokuji University",
  },
  {
    label: "Ryukoku University",
    value: "Ryukoku University",
  },
  {
    label: "Ryutsu Keizai University",
    value: "Ryutsu Keizai University",
  },
  {
    label: "S. Toraighyrov Pavlodar State University",
    value: "S. Toraighyrov Pavlodar State University",
  },
  {
    label: "Saba University",
    value: "Saba University",
  },
  {
    label: "Saba University School of Medicine",
    value: "Saba University School of Medicine",
  },
  {
    label: "Sabanci Üniversitesi",
    value: "Sabanci Üniversitesi",
  },
  {
    label: "Sabaragamuwa University of Sri Lanka",
    value: "Sabaragamuwa University of Sri Lanka",
  },
  {
    label: "Sabarmati University",
    value: "Sabarmati University",
  },
  {
    label: "Saber Institute of Higher Education",
    value: "Saber Institute of Higher Education",
  },
  {
    label: "Sabratha University",
    value: "Sabratha University",
  },
  {
    label: "Sabzevar University of Medical Sciences",
    value: "Sabzevar University of Medical Sciences",
  },
  {
    label: "Sabzevar University of New Technologies",
    value: "Sabzevar University of New Technologies",
  },
  {
    label: "Sacred Heart College",
    value: "Sacred Heart College",
  },
  {
    label: "Sacred Heart University",
    value: "Sacred Heart University",
  },
  {
    label: "Sadat Institute of Higher Education",
    value: "Sadat Institute of Higher Education",
  },
  {
    label: "Sadjad University of Technology",
    value: "Sadjad University of Technology",
  },
  {
    label: "Saga University",
    value: "Saga University",
  },
  {
    label: "Sagaing University",
    value: "Sagaing University",
  },
  {
    label: "Sagaing University of Education",
    value: "Sagaing University of Education",
  },
  {
    label: "Sagami Women's University",
    value: "Sagami Women's University",
  },
  {
    label: "Sage University",
    value: "Sage University",
  },
  {
    label: "Saginaw Valley State University",
    value: "Saginaw Valley State University",
  },
  {
    label: "Saglik Bilimleri Üniversitesi",
    value: "Saglik Bilimleri Üniversitesi",
  },
  {
    label: "Sahand University of Technology",
    value: "Sahand University of Technology",
  },
  {
    label: "Sahmyook University",
    value: "Sahmyook University",
  },
  {
    label: "Sai Nath University",
    value: "Sai Nath University",
  },
  {
    label: "Sai Tirupati University",
    value: "Sai Tirupati University",
  },
  {
    label: "Saigon International University",
    value: "Saigon International University",
  },
  {
    label: "Saigon University",
    value: "Saigon University",
  },
  {
    label: "Saint Andrew the First-Called Georgian University",
    value: "Saint Andrew the First-Called Georgian University",
  },
  {
    label: "Saint Anselm College",
    value: "Saint Anselm College",
  },
  {
    label: "Saint Anthony College of Nursing",
    value: "Saint Anthony College of Nursing",
  },
  {
    label: "Saint Augustine College",
    value: "Saint Augustine College",
  },
  {
    label: "Saint Augustine's University",
    value: "Saint Augustine's University",
  },
  {
    label: "Saint Elizabeth University",
    value: "Saint Elizabeth University",
  },
  {
    label: "Saint Francis Medical Center College of Nursing",
    value: "Saint Francis Medical Center College of Nursing",
  },
  {
    label: "Saint Francis University",
    value: "Saint Francis University",
  },
  {
    label: "Saint James School of Medicine",
    value: "Saint James School of Medicine",
  },
  {
    label: "Saint John's University",
    value: "Saint John's University",
  },
  {
    label: "Saint Joseph Institute of Technology",
    value: "Saint Joseph Institute of Technology",
  },
  {
    label: "Saint Joseph's College of Maine",
    value: "Saint Joseph's College of Maine",
  },
  {
    label: "Saint Joseph's University",
    value: "Saint Joseph's University",
  },
  {
    label: "Saint Jude College",
    value: "Saint Jude College",
  },
  {
    label: "Saint Leo University",
    value: "Saint Leo University",
  },
  {
    label: "Saint Louis University",
    value: "Saint Louis University",
  },
  {
    label: "Saint Louis University, Baguio City",
    value: "Saint Louis University, Baguio City",
  },
  {
    label: "Saint Martin's University",
    value: "Saint Martin's University",
  },
  {
    label: "Saint Mary-of-the-Woods College",
    value: "Saint Mary-of-the-Woods College",
  },
  {
    label: "Saint Mary's College",
    value: "Saint Mary's College",
  },
  {
    label: "Saint Mary's College of California",
    value: "Saint Mary's College of California",
  },
  {
    label: "Saint Mary's University",
    value: "Saint Mary's University",
  },
  {
    label: "Saint Mary's University of Bayombong",
    value: "Saint Mary's University of Bayombong",
  },
  {
    label: "Saint Mary's University of Minnesota",
    value: "Saint Mary's University of Minnesota",
  },
  {
    label: "Saint Michael's College",
    value: "Saint Michael's College",
  },
  {
    label: "Saint Michael's College of Laguna",
    value: "Saint Michael's College of Laguna",
  },
  {
    label: "Saint Pedro Poveda College",
    value: "Saint Pedro Poveda College",
  },
  {
    label: "Saint Peter's University",
    value: "Saint Peter's University",
  },
  {
    label: "Saint Petersburg Mining University",
    value: "Saint Petersburg Mining University",
  },
  {
    label: "Saint Petersburg State Electrotechnical University",
    value: "Saint Petersburg State Electrotechnical University",
  },
  {
    label: "Saint Petersburg State Institute of Technology",
    value: "Saint Petersburg State Institute of Technology",
  },
  {
    label: "Saint Petersburg State Pediatric Medical Academy",
    value: "Saint Petersburg State Pediatric Medical Academy",
  },
  {
    label: "Saint Tikhon's Orthodox University",
    value: "Saint Tikhon's Orthodox University",
  },
  {
    label: "Saint Vincent College",
    value: "Saint Vincent College",
  },
  {
    label: "Saint Xavier University",
    value: "Saint Xavier University",
  },
  {
    label: "Saint-Petersburg State Chemical Pharmaceutical University",
    value: "Saint-Petersburg State Chemical Pharmaceutical University",
  },
  {
    label: "Saint-Petersburg State University of Film and Television",
    value: "Saint-Petersburg State University of Film and Television",
  },
  {
    label: "Saitama Gakuen University",
    value: "Saitama Gakuen University",
  },
  {
    label: "Saitama Institute of Technology",
    value: "Saitama Institute of Technology",
  },
  {
    label: "Saitama Medical University",
    value: "Saitama Medical University",
  },
  {
    label: "Saitama Prefectural University",
    value: "Saitama Prefectural University",
  },
  {
    label: "Saitama University",
    value: "Saitama University",
  },
  {
    label: "Sakarya Üniversitesi",
    value: "Sakarya Üniversitesi",
  },
  {
    label: "Saken Seifullin Kazakh Agrotechnical University",
    value: "Saken Seifullin Kazakh Agrotechnical University",
  },
  {
    label: "Sakhalin State University",
    value: "Sakhalin State University",
  },
  {
    label: "Sakon Nakhon Rajabhat University",
    value: "Sakon Nakhon Rajabhat University",
  },
  {
    label: "Saku University",
    value: "Saku University",
  },
  {
    label: "Sakushin Gakuin University",
    value: "Sakushin Gakuin University",
  },
  {
    label: "Salahaddin University-Erbil",
    value: "Salahaddin University-Erbil",
  },
  {
    label: "Salam University",
    value: "Salam University",
  },
  {
    label: "Salem College",
    value: "Salem College",
  },
  {
    label: "Salem State University",
    value: "Salem State University",
  },
  {
    label: "Salem University",
    value: "Salem University",
  },
  {
    label: "Salem University",
    value: "Salem University",
  },
  {
    label: "Salim Habib University",
    value: "Salim Habib University",
  },
  {
    label: "Salisbury University",
    value: "Salisbury University",
  },
  {
    label: "Salman Farsi University of Kazerun",
    value: "Salman Farsi University of Kazerun",
  },
  {
    label: "Salus University",
    value: "Salus University",
  },
  {
    label: "Salve Regina University",
    value: "Salve Regina University",
  },
  {
    label: "Salymbekov University",
    value: "Salymbekov University",
  },
  {
    label: "Sam Higginbottom Institute of Agriculture, Technology and Sciences",
    value: "Sam Higginbottom Institute of Agriculture, Technology and Sciences",
  },
  {
    label: "Sam Houston State University",
    value: "Sam Houston State University",
  },
  {
    label: "Samar State University",
    value: "Samar State University",
  },
  {
    label: "Samara National Research University",
    value: "Samara National Research University",
  },
  {
    label: "Samara State Academy of Social Sciences and Humanities",
    value: "Samara State Academy of Social Sciences and Humanities",
  },
  {
    label: "Samara State Economic University",
    value: "Samara State Economic University",
  },
  {
    label: "Samara State Medical University",
    value: "Samara State Medical University",
  },
  {
    label: "Samara State Technical University",
    value: "Samara State Technical University",
  },
  {
    label: "Samara State University",
    value: "Samara State University",
  },
  {
    label: "Samara University",
    value: "Samara University",
  },
  {
    label: "Samarkand Davlat Universiteti",
    value: "Samarkand Davlat Universiteti",
  },
  {
    label: "Samarqand davlat arxitektura-qurilish universiteti",
    value: "Samarqand davlat arxitektura-qurilish universiteti",
  },
  {
    label: "Samarqand Davlat Chet Tillar Instituti",
    value: "Samarqand Davlat Chet Tillar Instituti",
  },
  {
    label: "Samarqand Davlat Tibbiyot Universiteti",
    value: "Samarqand Davlat Tibbiyot Universiteti",
  },
  {
    label:
      "Samarqand davlat veterinariya meditsinasi, chorvachilik va biotexnologiyalar universiteti",
    value:
      "Samarqand davlat veterinariya meditsinasi, chorvachilik va biotexnologiyalar universiteti",
  },
  {
    label: "Samarqand Iqtisodiyot va Servis Instituti",
    value: "Samarqand Iqtisodiyot va Servis Instituti",
  },
  {
    label: "Sambalpur University",
    value: "Sambalpur University",
  },
  {
    label: "SAMBHRAM Universiteti",
    value: "SAMBHRAM Universiteti",
  },
  {
    label: "Samford University",
    value: "Samford University",
  },
  {
    label: "Sámi allskuvla",
    value: "Sámi allskuvla",
  },
  {
    label: "Sampurnanand Sanskrit Vishvavidyalaya",
    value: "Sampurnanand Sanskrit Vishvavidyalaya",
  },
  {
    label: "Samtskhe-Javakheti State University",
    value: "Samtskhe-Javakheti State University",
  },
  {
    label: "Samuel Merritt University",
    value: "Samuel Merritt University",
  },
  {
    label: "San Beda University",
    value: "San Beda University",
  },
  {
    label: "San Diego Christian College",
    value: "San Diego Christian College",
  },
  {
    label: "San Diego State University",
    value: "San Diego State University",
  },
  {
    label: "San Francisco Conservatory of Music",
    value: "San Francisco Conservatory of Music",
  },
  {
    label: "San Francisco State University",
    value: "San Francisco State University",
  },
  {
    label: "San Joaquin College of Law",
    value: "San Joaquin College of Law",
  },
  {
    label: "San José State University",
    value: "San José State University",
  },
  {
    label: "San Sebastian College-Recoletos de Cavite",
    value: "San Sebastian College-Recoletos de Cavite",
  },
  {
    label: "Sana'a University",
    value: "Sana'a University",
  },
  {
    label: "Sanchi University of Buddhist-Indic Studies",
    value: "Sanchi University of Buddhist-Indic Studies",
  },
  {
    label: "Sanda University",
    value: "Sanda University",
  },
  {
    label: "Sandip University",
    value: "Sandip University",
  },
  {
    label: "Sandip University, Sijoul",
    value: "Sandip University, Sijoul",
  },
  {
    label: "Sangai International University",
    value: "Sangai International University",
  },
  {
    label: "Sangam University",
    value: "Sangam University",
  },
  {
    label: "Sangji University",
    value: "Sangji University",
  },
  {
    label: "Sangmyung University",
    value: "Sangmyung University",
  },
  {
    label: "Saniku Gakuin College",
    value: "Saniku Gakuin College",
  },
  {
    label: "Sanjay Gandhi Post Graduate Institute of Medical Sciences",
    value: "Sanjay Gandhi Post Graduate Institute of Medical Sciences",
  },
  {
    label: "Sanjay Ghodawat University",
    value: "Sanjay Ghodawat University",
  },
  {
    label: "Sanjiang University",
    value: "Sanjiang University",
  },
  {
    label: "Sanjo City University",
    value: "Sanjo City University",
  },
  {
    label: "Sankalchand Patel University",
    value: "Sankalchand Patel University",
  },
  {
    label: "Sanko Üniversitesi",
    value: "Sanko Üniversitesi",
  },
  {
    label: "Sanming University",
    value: "Sanming University",
  },
  {
    label: "Sanno University",
    value: "Sanno University",
  },
  {
    label: "SanQuan Medical College",
    value: "SanQuan Medical College",
  },
  {
    label: "Sanskriti University",
    value: "Sanskriti University",
  },
  {
    label: "Sant Baba Bhag Singh University",
    value: "Sant Baba Bhag Singh University",
  },
  {
    label: "Sant Gadge Baba Amravati University",
    value: "Sant Gadge Baba Amravati University",
  },
  {
    label: "Sant Longowal Institute of Engineering and Technology",
    value: "Sant Longowal Institute of Engineering and Technology",
  },
  {
    label: "Santa Clara University",
    value: "Santa Clara University",
  },
  {
    label: "Santa Fe College",
    value: "Santa Fe College",
  },
  {
    label: "Santa Isabel College",
    value: "Santa Isabel College",
  },
  {
    label: "Santosh University",
    value: "Santosh University",
  },
  {
    label: "Sanya University",
    value: "Sanya University",
  },
  {
    label: "Sanyo Gakuen University",
    value: "Sanyo Gakuen University",
  },
  {
    label: "Sanyo-onoda City University",
    value: "Sanyo-onoda City University",
  },
  {
    label: "Sapienza Università di Roma",
    value: "Sapienza Università di Roma",
  },
  {
    label: "Sapir College",
    value: "Sapir College",
  },
  {
    label: "Sapporo City University",
    value: "Sapporo City University",
  },
  {
    label: "Sapporo Gakuin University",
    value: "Sapporo Gakuin University",
  },
  {
    label: "Sapporo International University",
    value: "Sapporo International University",
  },
  {
    label: "Sapporo Medical University",
    value: "Sapporo Medical University",
  },
  {
    label: "Sapporo Otani University",
    value: "Sapporo Otani University",
  },
  {
    label: "Sapporo University",
    value: "Sapporo University",
  },
  {
    label: "Sapporo University of Health Sciences",
    value: "Sapporo University of Health Sciences",
  },
  {
    label: "Sarah Lawrence College",
    value: "Sarah Lawrence College",
  },
  {
    label: "Sarajevo School of Science and Technology",
    value: "Sarajevo School of Science and Technology",
  },
  {
    label: "Sarala Birla University",
    value: "Sarala Birla University",
  },
  {
    label: "Saratov State Academy of Law",
    value: "Saratov State Academy of Law",
  },
  {
    label: "Saratov State Medical University",
    value: "Saratov State Medical University",
  },
  {
    label: "Saratov State Technical University",
    value: "Saratov State Technical University",
  },
  {
    label: "Saratov State University",
    value: "Saratov State University",
  },
  {
    label:
      "Saratov State University of Genetics, Biotechnology and Engineering named after N.I. Vavilova",
    value:
      "Saratov State University of Genetics, Biotechnology and Engineering named after N.I. Vavilova",
  },
  {
    label: "Sardar Bahadur Khan Women's University",
    value: "Sardar Bahadur Khan Women's University",
  },
  {
    label: "Sardar Patel University",
    value: "Sardar Patel University",
  },
  {
    label: "Sardar Patel University of Police, Security and Criminal Justice",
    value: "Sardar Patel University of Police, Security and Criminal Justice",
  },
  {
    label: "Sardar Vallabhbhai National Institute of Technology, Surat",
    value: "Sardar Vallabhbhai National Institute of Technology, Surat",
  },
  {
    label: "Sardar Vallabhbhai Patel University of Agriculture and Technology",
    value: "Sardar Vallabhbhai Patel University of Agriculture and Technology",
  },
  {
    label: "Sardarkrushinagar Dantiwada Agricultural University",
    value: "Sardarkrushinagar Dantiwada Agricultural University",
  },
  {
    label: "Sarguja University",
    value: "Sarguja University",
  },
  {
    label: "Sarhad University of Science and Information Technology",
    value: "Sarhad University of Science and Information Technology",
  },
  {
    label: "Sari Agricultural Sciences and Natural Resources University",
    value: "Sari Agricultural Sciences and Natural Resources University",
  },
  {
    label: "Sariwon Pharmaceutical College of Koryo",
    value: "Sariwon Pharmaceutical College of Koryo",
  },
  {
    label: "Sarvepalli Radhakrishnan University",
    value: "Sarvepalli Radhakrishnan University",
  },
  {
    label: "SASTRA University",
    value: "SASTRA University",
  },
  {
    label: "Satakunnan ammattikorkeakoulu",
    value: "Satakunnan ammattikorkeakoulu",
  },
  {
    label: "Satavahana University",
    value: "Satavahana University",
  },
  {
    label: "Satbayev University",
    value: "Satbayev University",
  },
  {
    label: "Sathyabama Institute of Science and Technology",
    value: "Sathyabama Institute of Science and Technology",
  },
  {
    label: "Saurashtra University",
    value: "Saurashtra University",
  },
  {
    label: "Savannah College of Art and Design",
    value: "Savannah College of Art and Design",
  },
  {
    label: "Savannah State University",
    value: "Savannah State University",
  },
  {
    label: "Saveetha Institute of Medical and Technical Sciences",
    value: "Saveetha Institute of Medical and Technical Sciences",
  },
  {
    label: "Savitribai Phule Pune University",
    value: "Savitribai Phule Pune University",
  },
  {
    label: "Savonia-ammattikorkeakoulu",
    value: "Savonia-ammattikorkeakoulu",
  },
  {
    label: "Saybrook University",
    value: "Saybrook University",
  },
  {
    label: "Sayyed Jamaleddin Asadabadi University",
    value: "Sayyed Jamaleddin Asadabadi University",
  },
  {
    label: "Schechter Institute of Jewish Studies",
    value: "Schechter Institute of Jewish Studies",
  },
  {
    label: "School of Advanced Study, University of London",
    value: "School of Advanced Study, University of London",
  },
  {
    label: "School of International Relations",
    value: "School of International Relations",
  },
  {
    label: "School of Planning and Architecture, Bhopal",
    value: "School of Planning and Architecture, Bhopal",
  },
  {
    label: "School of Planning and Architecture, Delhi",
    value: "School of Planning and Architecture, Delhi",
  },
  {
    label: "School of Planning and Architecture, Vijayawada",
    value: "School of Planning and Architecture, Vijayawada",
  },
  {
    label: "School of the Art Institute of Chicago",
    value: "School of the Art Institute of Chicago",
  },
  {
    label: "School of Visual Arts",
    value: "School of Visual Arts",
  },
  {
    label: "Schreiner University",
    value: "Schreiner University",
  },
  {
    label: "Science and Arts University",
    value: "Science and Arts University",
  },
  {
    label: "Scientific College of Design",
    value: "Scientific College of Design",
  },
  {
    label: "Scoala Nationala de Studii Politice si Administrative",
    value: "Scoala Nationala de Studii Politice si Administrative",
  },
  {
    label: "Scotland's Rural College",
    value: "Scotland's Rural College",
  },
  {
    label: "Scott Christian University",
    value: "Scott Christian University",
  },
  {
    label: "Scripps College",
    value: "Scripps College",
  },
  {
    label: "Scuola IMT Alti Studi Lucca",
    value: "Scuola IMT Alti Studi Lucca",
  },
  {
    label: "Scuola Internazionale Superiore di Studi Avanzati",
    value: "Scuola Internazionale Superiore di Studi Avanzati",
  },
  {
    label: "Scuola Normale Superiore di Pisa",
    value: "Scuola Normale Superiore di Pisa",
  },
  {
    label: "Scuola Superiore di Studi Universitari e Perfezionamento Sant'Anna",
    value: "Scuola Superiore di Studi Universitari e Perfezionamento Sant'Anna",
  },
  {
    label: "Scuola universitaria professionale della Svizzera italiana",
    value: "Scuola universitaria professionale della Svizzera italiana",
  },
  {
    label: "Seacom Skills University",
    value: "Seacom Skills University",
  },
  {
    label: "Seattle Central College",
    value: "Seattle Central College",
  },
  {
    label: "Seattle Pacific University",
    value: "Seattle Pacific University",
  },
  {
    label: "Seattle University",
    value: "Seattle University",
  },
  {
    label: "Sebha University",
    value: "Sebha University",
  },
  {
    label: "Sefako Makgatho Health Sciences University",
    value: "Sefako Makgatho Health Sciences University",
  },
  {
    label: "Sehan University",
    value: "Sehan University",
  },
  {
    label: "Seian University of Art and Design",
    value: "Seian University of Art and Design",
  },
  {
    label: "Seigakuin University",
    value: "Seigakuin University",
  },
  {
    label: "Seijo University",
    value: "Seijo University",
  },
  {
    label: "Seijoh University",
    value: "Seijoh University",
  },
  {
    label: "Seikei University",
    value: "Seikei University",
  },
  {
    label: "Seinäjoen ammattikorkeakoulu",
    value: "Seinäjoen ammattikorkeakoulu",
  },
  {
    label: "Seinan Gakuin University",
    value: "Seinan Gakuin University",
  },
  {
    label: "Seinan Jo Gakuin University",
    value: "Seinan Jo Gakuin University",
  },
  {
    label: "Seirei Christopher University",
    value: "Seirei Christopher University",
  },
  {
    label: "Seisa Dohto University",
    value: "Seisa Dohto University",
  },
  {
    label: "Seisa University",
    value: "Seisa University",
  },
  {
    label: "Seisen Jogakuin College",
    value: "Seisen Jogakuin College",
  },
  {
    label: "Seisen University",
    value: "Seisen University",
  },
  {
    label: "Seisen University",
    value: "Seisen University",
  },
  {
    label: "Seitoku University",
    value: "Seitoku University",
  },
  {
    label: "Seiwa University",
    value: "Seiwa University",
  },
  {
    label: "Sejong University",
    value: "Sejong University",
  },
  {
    label: "Selçuk Üniversitesi",
    value: "Selçuk Üniversitesi",
  },
  {
    label: "Semey Medical University",
    value: "Semey Medical University",
  },
  {
    label: "Seminole State College of Florida",
    value: "Seminole State College of Florida",
  },
  {
    label: "Semipalatinsk State University",
    value: "Semipalatinsk State University",
  },
  {
    label: "Semmelweis Egyetem",
    value: "Semmelweis Egyetem",
  },
  {
    label: "Semnan University",
    value: "Semnan University",
  },
  {
    label: "Semnan University of Medical Sciences",
    value: "Semnan University of Medical Sciences",
  },
  {
    label: "Semyung University",
    value: "Semyung University",
  },
  {
    label: "Sendai Shirayuri Women's College",
    value: "Sendai Shirayuri Women's College",
  },
  {
    label: "Sendai University",
    value: "Sendai University",
  },
  {
    label: "Senri Kinran University",
    value: "Senri Kinran University",
  },
  {
    label: "Senshu University",
    value: "Senshu University",
  },
  {
    label: "Senzoku Gakuen College of Music",
    value: "Senzoku Gakuen College of Music",
  },
  {
    label: "Seokyeong University",
    value: "Seokyeong University",
  },
  {
    label: "Seoul Christian University",
    value: "Seoul Christian University",
  },
  {
    label: "Seoul Jangsin University",
    value: "Seoul Jangsin University",
  },
  {
    label: "Seoul National University",
    value: "Seoul National University",
  },
  {
    label: "Seoul National University of Education",
    value: "Seoul National University of Education",
  },
  {
    label: "Seoul National University of Science and Technology",
    value: "Seoul National University of Science and Technology",
  },
  {
    label: "Seoul Theological University",
    value: "Seoul Theological University",
  },
  {
    label: "Seoul Women's University",
    value: "Seoul Women's University",
  },
  {
    label: "Seowon University",
    value: "Seowon University",
  },
  {
    label: "Sergei Witte University of Moscow",
    value: "Sergei Witte University of Moscow",
  },
  {
    label: "Seton Hall University",
    value: "Seton Hall University",
  },
  {
    label: "Seton Hill University",
    value: "Seton Hill University",
  },
  {
    label: "Setsunan University",
    value: "Setsunan University",
  },
  {
    label: "Sevastopol State University",
    value: "Sevastopol State University",
  },
  {
    label: "Sewanee: The University of the South",
    value: "Sewanee: The University of the South",
  },
  {
    label: "Shaanxi Fashion Engineering University",
    value: "Shaanxi Fashion Engineering University",
  },
  {
    label: "Shaanxi Institute of International Trade and Commerce",
    value: "Shaanxi Institute of International Trade and Commerce",
  },
  {
    label: "Shaanxi Normal University",
    value: "Shaanxi Normal University",
  },
  {
    label: "Shaanxi University of Chinese Medicine",
    value: "Shaanxi University of Chinese Medicine",
  },
  {
    label: "Shaanxi University of Science and Technology",
    value: "Shaanxi University of Science and Technology",
  },
  {
    label: "Shaanxi University of Technology",
    value: "Shaanxi University of Technology",
  },
  {
    label: "Shaanxi Xueqian Normal University",
    value: "Shaanxi Xueqian Normal University",
  },
  {
    label: "Shah Abdul Latif University",
    value: "Shah Abdul Latif University",
  },
  {
    label: "Shahed University",
    value: "Shahed University",
  },
  {
    label: "Shaheed Benazir Bhutto City University",
    value: "Shaheed Benazir Bhutto City University",
  },
  {
    label: "Shaheed Benazir Bhutto University",
    value: "Shaheed Benazir Bhutto University",
  },
  {
    label:
      "Shaheed Benazir Bhutto University of Veterinary and Animal Sciences",
    value:
      "Shaheed Benazir Bhutto University of Veterinary and Animal Sciences",
  },
  {
    label: "Shaheed Benazir Bhutto University Shaheed Benazirabad",
    value: "Shaheed Benazir Bhutto University Shaheed Benazirabad",
  },
  {
    label: "Shaheed Benazir Bhutto Women University",
    value: "Shaheed Benazir Bhutto Women University",
  },
  {
    label: "Shaheed Mahendra Karma Vishwavidyalaya",
    value: "Shaheed Mahendra Karma Vishwavidyalaya",
  },
  {
    label: "Shaheed Mohtarma Benazir Bhutto Medical University",
    value: "Shaheed Mohtarma Benazir Bhutto Medical University",
  },
  {
    label: "Shaheed Rabani Education University",
    value: "Shaheed Rabani Education University",
  },
  {
    label:
      "Shaheed Zulfikar Ali Bhutto Institute of Science and Technology Dubai",
    value:
      "Shaheed Zulfikar Ali Bhutto Institute of Science and Technology Dubai",
  },
  {
    label: "Shaheed Zulfiqar Ali Bhutto Institute of Science and Technology",
    value: "Shaheed Zulfiqar Ali Bhutto Institute of Science and Technology",
  },
  {
    label: "Shaheed Zulfiqar Ali Bhutto Medical University",
    value: "Shaheed Zulfiqar Ali Bhutto Medical University",
  },
  {
    label: "Shaheed Zulfiqar Ali Bhutto University of Law",
    value: "Shaheed Zulfiqar Ali Bhutto University of Law",
  },
  {
    label: "Shahid Bahonar University of Kerman",
    value: "Shahid Bahonar University of Kerman",
  },
  {
    label: "Shahid Beheshti University",
    value: "Shahid Beheshti University",
  },
  {
    label: "Shahid Beheshti University of Medical Sciences",
    value: "Shahid Beheshti University of Medical Sciences",
  },
  {
    label: "Shahid Chamran University of Ahvaz",
    value: "Shahid Chamran University of Ahvaz",
  },
  {
    label: "Shahid Rajaee Teacher Training University",
    value: "Shahid Rajaee Teacher Training University",
  },
  {
    label: "Shahid Sadoughi University of Medical Sciences and Health Services",
    value: "Shahid Sadoughi University of Medical Sciences and Health Services",
  },
  {
    label: "Shahid Sattari University of Aeronautical Engineering",
    value: "Shahid Sattari University of Aeronautical Engineering",
  },
  {
    label: "Shahjalal University of Science and Technology",
    value: "Shahjalal University of Science and Technology",
  },
  {
    label: "Shahrekord University",
    value: "Shahrekord University",
  },
  {
    label: "Shahrekord University of Medical Sciences",
    value: "Shahrekord University of Medical Sciences",
  },
  {
    label: "Shahrood University of Technology",
    value: "Shahrood University of Technology",
  },
  {
    label: "Shahroud University of Medical Sciences",
    value: "Shahroud University of Medical Sciences",
  },
  {
    label: "Shaikh Zayed University, Khost",
    value: "Shaikh Zayed University, Khost",
  },
  {
    label: "Shalem College",
    value: "Shalem College",
  },
  {
    label: "Shamoon College of Engineering",
    value: "Shamoon College of Engineering",
  },
  {
    label: "Shandong Agricultural University",
    value: "Shandong Agricultural University",
  },
  {
    label: "Shandong Agriculture and Engineering University",
    value: "Shandong Agriculture and Engineering University",
  },
  {
    label: "Shandong First Medical University",
    value: "Shandong First Medical University",
  },
  {
    label: "Shandong Huayu University of Technology",
    value: "Shandong Huayu University of Technology",
  },
  {
    label: "Shandong Jianzhu University",
    value: "Shandong Jianzhu University",
  },
  {
    label: "Shandong Jiaotong University",
    value: "Shandong Jiaotong University",
  },
  {
    label: "Shandong Management University",
    value: "Shandong Management University",
  },
  {
    label: "Shandong Normal University",
    value: "Shandong Normal University",
  },
  {
    label: "Shandong Sport University",
    value: "Shandong Sport University",
  },
  {
    label: "Shandong Technology and Business University",
    value: "Shandong Technology and Business University",
  },
  {
    label: "Shandong University",
    value: "Shandong University",
  },
  {
    label: "Shandong University of Art and Design",
    value: "Shandong University of Art and Design",
  },
  {
    label: "Shandong University of Arts",
    value: "Shandong University of Arts",
  },
  {
    label: "Shandong University of Finance and Economics",
    value: "Shandong University of Finance and Economics",
  },
  {
    label: "Shandong University of Political Science and Law",
    value: "Shandong University of Political Science and Law",
  },
  {
    label: "Shandong University of Science and Technology",
    value: "Shandong University of Science and Technology",
  },
  {
    label: "Shandong University of Technology",
    value: "Shandong University of Technology",
  },
  {
    label: "Shandong University of Traditional Chinese Medicine",
    value: "Shandong University of Traditional Chinese Medicine",
  },
  {
    label: "Shandong Women's University",
    value: "Shandong Women's University",
  },
  {
    label: "Shandong Xiandai University",
    value: "Shandong Xiandai University",
  },
  {
    label: "Shandong Xiehe University",
    value: "Shandong Xiehe University",
  },
  {
    label: "Shandong Yingcai University",
    value: "Shandong Yingcai University",
  },
  {
    label: "Shandong Youth University of Political Science",
    value: "Shandong Youth University of Political Science",
  },
  {
    label: "Shanghai Business School",
    value: "Shanghai Business School",
  },
  {
    label: "Shanghai Conservatory of Music",
    value: "Shanghai Conservatory of Music",
  },
  {
    label: "Shanghai Dianji University",
    value: "Shanghai Dianji University",
  },
  {
    label: "Shanghai Institute of Technology",
    value: "Shanghai Institute of Technology",
  },
  {
    label: "Shanghai Institute of Visual Art",
    value: "Shanghai Institute of Visual Art",
  },
  {
    label: "Shanghai International Studies University",
    value: "Shanghai International Studies University",
  },
  {
    label: "Shanghai Jianqiao University",
    value: "Shanghai Jianqiao University",
  },
  {
    label: "Shanghai Jiao Tong University",
    value: "Shanghai Jiao Tong University",
  },
  {
    label: "Shanghai Lixin University of Accounting and Finance",
    value: "Shanghai Lixin University of Accounting and Finance",
  },
  {
    label: "Shanghai Maritime University",
    value: "Shanghai Maritime University",
  },
  {
    label: "Shanghai Normal University",
    value: "Shanghai Normal University",
  },
  {
    label: "Shanghai Ocean University",
    value: "Shanghai Ocean University",
  },
  {
    label: "Shanghai Second Polytechnic University",
    value: "Shanghai Second Polytechnic University",
  },
  {
    label: "Shanghai Tech University",
    value: "Shanghai Tech University",
  },
  {
    label: "Shanghai Theatre Academy",
    value: "Shanghai Theatre Academy",
  },
  {
    label: "Shanghai University",
    value: "Shanghai University",
  },
  {
    label: "Shanghai University of Electric Power",
    value: "Shanghai University of Electric Power",
  },
  {
    label: "Shanghai University of Engineering Science",
    value: "Shanghai University of Engineering Science",
  },
  {
    label: "Shanghai University of Finance and Economics",
    value: "Shanghai University of Finance and Economics",
  },
  {
    label: "Shanghai University of International Business and Economics",
    value: "Shanghai University of International Business and Economics",
  },
  {
    label: "Shanghai University of Medicine and Health Sciences",
    value: "Shanghai University of Medicine and Health Sciences",
  },
  {
    label: "Shanghai University of Political Science and Law",
    value: "Shanghai University of Political Science and Law",
  },
  {
    label: "Shanghai University of Sport",
    value: "Shanghai University of Sport",
  },
  {
    label: "Shanghai University of Traditional Chinese Medicine",
    value: "Shanghai University of Traditional Chinese Medicine",
  },
  {
    label: "Shanghai Xingwei College",
    value: "Shanghai Xingwei College",
  },
  {
    label: "Shangluo University",
    value: "Shangluo University",
  },
  {
    label: "Shangqiu Institute of Technology",
    value: "Shangqiu Institute of Technology",
  },
  {
    label: "Shangqiu Normal University",
    value: "Shangqiu Normal University",
  },
  {
    label: "Shangqiu University",
    value: "Shangqiu University",
  },
  {
    label: "Shangrao Normal University",
    value: "Shangrao Normal University",
  },
  {
    label: "Shanto Mariam University of Creative Technology",
    value: "Shanto Mariam University of Creative Technology",
  },
  {
    label: "Shantou University",
    value: "Shantou University",
  },
  {
    label: "Shanxi Agricultural University",
    value: "Shanxi Agricultural University",
  },
  {
    label: "Shanxi College of Applied Science and Technology",
    value: "Shanxi College of Applied Science and Technology",
  },
  {
    label: "Shanxi Datong University",
    value: "Shanxi Datong University",
  },
  {
    label: "Shanxi Institute of Energy",
    value: "Shanxi Institute of Energy",
  },
  {
    label: "Shanxi Institute of Technology",
    value: "Shanxi Institute of Technology",
  },
  {
    label: "Shanxi Medical University",
    value: "Shanxi Medical University",
  },
  {
    label: "Shanxi Normal University",
    value: "Shanxi Normal University",
  },
  {
    label: "Shanxi Technology and Business College",
    value: "Shanxi Technology and Business College",
  },
  {
    label: "Shanxi University",
    value: "Shanxi University",
  },
  {
    label: "Shanxi University of Finance and Economics",
    value: "Shanxi University of Finance and Economics",
  },
  {
    label: "Shanxi University of Traditional Chinese Medicine",
    value: "Shanxi University of Traditional Chinese Medicine",
  },
  {
    label: "Shaoguan University",
    value: "Shaoguan University",
  },
  {
    label: "Shaoxing University",
    value: "Shaoxing University",
  },
  {
    label: "Shaoyang University",
    value: "Shaoyang University",
  },
  {
    label: "Shaqra University",
    value: "Shaqra University",
  },
  {
    label: "Sharda University",
    value: "Sharda University",
  },
  {
    label: "Sharif University of Technology",
    value: "Sharif University of Technology",
  },
  {
    label: "Sharnbasva University",
    value: "Sharnbasva University",
  },
  {
    label: "Sharq Institute of Higher Education",
    value: "Sharq Institute of Higher Education",
  },
  {
    label: "Shatt Al-Arab University College",
    value: "Shatt Al-Arab University College",
  },
  {
    label: "Shaw University",
    value: "Shaw University",
  },
  {
    label: "Shawnee State University",
    value: "Shawnee State University",
  },
  {
    label: "Sheffield Hallam University",
    value: "Sheffield Hallam University",
  },
  {
    label: "Sheikh Fazilatunnesa Mujib University",
    value: "Sheikh Fazilatunnesa Mujib University",
  },
  {
    label: "Sheikh Hasina University",
    value: "Sheikh Hasina University",
  },
  {
    label: "Sheikhbahaee University",
    value: "Sheikhbahaee University",
  },
  {
    label: "Shenandoah University",
    value: "Shenandoah University",
  },
  {
    label: "Shenkar College of Engineering and Design",
    value: "Shenkar College of Engineering and Design",
  },
  {
    label: "Shenyang Aerospace University",
    value: "Shenyang Aerospace University",
  },
  {
    label: "Shenyang Agricultural University",
    value: "Shenyang Agricultural University",
  },
  {
    label: "Shenyang City University",
    value: "Shenyang City University",
  },
  {
    label: "Shenyang Conservatory of Music",
    value: "Shenyang Conservatory of Music",
  },
  {
    label: "Shenyang Institute of Engineering",
    value: "Shenyang Institute of Engineering",
  },
  {
    label: "Shenyang Institute of Science and Technology",
    value: "Shenyang Institute of Science and Technology",
  },
  {
    label: "Shenyang Institute of Technology",
    value: "Shenyang Institute of Technology",
  },
  {
    label: "Shenyang Jianzhu University",
    value: "Shenyang Jianzhu University",
  },
  {
    label: "Shenyang Ligong University",
    value: "Shenyang Ligong University",
  },
  {
    label: "Shenyang Medical College",
    value: "Shenyang Medical College",
  },
  {
    label: "Shenyang Normal University",
    value: "Shenyang Normal University",
  },
  {
    label: "Shenyang Pharmaceutical University",
    value: "Shenyang Pharmaceutical University",
  },
  {
    label: "Shenyang Sport University",
    value: "Shenyang Sport University",
  },
  {
    label: "Shenyang University",
    value: "Shenyang University",
  },
  {
    label: "Shenyang University of Chemical Technology",
    value: "Shenyang University of Chemical Technology",
  },
  {
    label: "Shenyang University of Technology",
    value: "Shenyang University of Technology",
  },
  {
    label: "Shenyang Urban Construction University",
    value: "Shenyang Urban Construction University",
  },
  {
    label: "Shenzhen MSU-BIT University",
    value: "Shenzhen MSU-BIT University",
  },
  {
    label: "Shenzhen University",
    value: "Shenzhen University",
  },
  {
    label: "Shepherd University",
    value: "Shepherd University",
  },
  {
    label: "Sher-e-Bangla Agricultural University",
    value: "Sher-e-Bangla Agricultural University",
  },
  {
    label:
      "Sher-e-Kashmir University of Agricultural Sciences and Technology of Jammu",
    value:
      "Sher-e-Kashmir University of Agricultural Sciences and Technology of Jammu",
  },
  {
    label:
      "Sher-e-Kashmir University of Agricultural Sciences and Technology of Kashmir",
    value:
      "Sher-e-Kashmir University of Agricultural Sciences and Technology of Kashmir",
  },
  {
    label: "Sher-i-Kashmir Institute of Medical Sciences",
    value: "Sher-i-Kashmir Institute of Medical Sciences",
  },
  {
    label: "Shibata Gakuen University",
    value: "Shibata Gakuen University",
  },
  {
    label: "Shibaura Institute of Technology",
    value: "Shibaura Institute of Technology",
  },
  {
    label: "Shifa Institute of Higher Education",
    value: "Shifa Institute of Higher Education",
  },
  {
    label: "Shifa Tameer-e-Millat University",
    value: "Shifa Tameer-e-Millat University",
  },
  {
    label: "Shiga University",
    value: "Shiga University",
  },
  {
    label: "Shiga University of Medical Science",
    value: "Shiga University of Medical Science",
  },
  {
    label: "Shigakkan University",
    value: "Shigakkan University",
  },
  {
    label: "Shigakukan University",
    value: "Shigakukan University",
  },
  {
    label: "Shih Chien University",
    value: "Shih Chien University",
  },
  {
    label: "Shih Hsin University",
    value: "Shih Hsin University",
  },
  {
    label: "Shihezi University",
    value: "Shihezi University",
  },
  {
    label: "Shihihutug Law Institute",
    value: "Shihihutug Law Institute",
  },
  {
    label: "Shijiazhuang Tiedao University",
    value: "Shijiazhuang Tiedao University",
  },
  {
    label: "Shijiazhuang University",
    value: "Shijiazhuang University",
  },
  {
    label: "Shijonawate Gakuen University",
    value: "Shijonawate Gakuen University",
  },
  {
    label: "Shikoku Gakuin University",
    value: "Shikoku Gakuin University",
  },
  {
    label: "Shikoku University",
    value: "Shikoku University",
  },
  {
    label: "Shimane University",
    value: "Shimane University",
  },
  {
    label: "Shimonoseki City University",
    value: "Shimonoseki City University",
  },
  {
    label: "Shinshu University",
    value: "Shinshu University",
  },
  {
    label: "Shippensburg University of Pennsylvania",
    value: "Shippensburg University of Pennsylvania",
  },
  {
    label: "Shirak State University",
    value: "Shirak State University",
  },
  {
    label: "Shiraume Gakuen University",
    value: "Shiraume Gakuen University",
  },
  {
    label: "Shirayuri University",
    value: "Shirayuri University",
  },
  {
    label: "Shiraz Art University",
    value: "Shiraz Art University",
  },
  {
    label: "Shiraz University",
    value: "Shiraz University",
  },
  {
    label: "Shiraz University of Applied Science and Technology",
    value: "Shiraz University of Applied Science and Technology",
  },
  {
    label: "Shiraz University of Medical Sciences",
    value: "Shiraz University of Medical Sciences",
  },
  {
    label: "Shiraz University of Technology",
    value: "Shiraz University of Technology",
  },
  {
    label: "Shiseikan University",
    value: "Shiseikan University",
  },
  {
    label: "Shitennoji University",
    value: "Shitennoji University",
  },
  {
    label: "Shiv Nadar University",
    value: "Shiv Nadar University",
  },
  {
    label: "Shivaji University",
    value: "Shivaji University",
  },
  {
    label: "Shizuoka Eiwa Gakuin University",
    value: "Shizuoka Eiwa Gakuin University",
  },
  {
    label: "Shizuoka Graduate University of Public Health",
    value: "Shizuoka Graduate University of Public Health",
  },
  {
    label: "Shizuoka Institute of Science and Technology",
    value: "Shizuoka Institute of Science and Technology",
  },
  {
    label: "Shizuoka Sangyo University",
    value: "Shizuoka Sangyo University",
  },
  {
    label: "Shizuoka University",
    value: "Shizuoka University",
  },
  {
    label: "Shizuoka University of Art and Culture",
    value: "Shizuoka University of Art and Culture",
  },
  {
    label: "Shizuoka University of Welfare",
    value: "Shizuoka University of Welfare",
  },
  {
    label: "Shobhit Institute of Engineering and Technology",
    value: "Shobhit Institute of Engineering and Technology",
  },
  {
    label: "Shobi University",
    value: "Shobi University",
  },
  {
    label: "Shohadaye Hoveizeh University of Technology",
    value: "Shohadaye Hoveizeh University of Technology",
  },
  {
    label: "Shoin University",
    value: "Shoin University",
  },
  {
    label: "Shokei Gakuin University",
    value: "Shokei Gakuin University",
  },
  {
    label: "Shokei University",
    value: "Shokei University",
  },
  {
    label: "Shomal University",
    value: "Shomal University",
  },
  {
    label: "Shonan Institute of Technology",
    value: "Shonan Institute of Technology",
  },
  {
    label: "Shonan Kamakura University of Medical Sciences",
    value: "Shonan Kamakura University of Medical Sciences",
  },
  {
    label: "Shonan University of Medical Sciences",
    value: "Shonan University of Medical Sciences",
  },
  {
    label: "Shoolini University of Biotechnology and Management Sciences",
    value: "Shoolini University of Biotechnology and Management Sciences",
  },
  {
    label: "Shorter University",
    value: "Shorter University",
  },
  {
    label: "Shota Meskhia State Teaching University",
    value: "Shota Meskhia State Teaching University",
  },
  {
    label: "Shota Rustaveli Theatre and Film Georgian State University",
    value: "Shota Rustaveli Theatre and Film Georgian State University",
  },
  {
    label: "Shougang Institute of Technology",
    value: "Shougang Institute of Technology",
  },
  {
    label: "Showa Pharmaceutical University",
    value: "Showa Pharmaceutical University",
  },
  {
    label: "Showa University",
    value: "Showa University",
  },
  {
    label: "Showa University of Music",
    value: "Showa University of Music",
  },
  {
    label: "Showa Women's University",
    value: "Showa Women's University",
  },
  {
    label: "Shree Guru Gobind Singh Tricentenary University",
    value: "Shree Guru Gobind Singh Tricentenary University",
  },
  {
    label: "Shree Somnath Sanskrit University",
    value: "Shree Somnath Sanskrit University",
  },
  {
    label: "Shreemati Nathibai Damodar Thackersey Women's University",
    value: "Shreemati Nathibai Damodar Thackersey Women's University",
  },
  {
    label: "Shri Govind Guru University",
    value: "Shri Govind Guru University",
  },
  {
    label: "Shri Guru Ram Rai Education Mission",
    value: "Shri Guru Ram Rai Education Mission",
  },
  {
    label: "Shri Guru Ram Rai University",
    value: "Shri Guru Ram Rai University",
  },
  {
    label: "Shri Jagannath Sanskrit Vishvavidyalaya",
    value: "Shri Jagannath Sanskrit Vishvavidyalaya",
  },
  {
    label: "Shri Jagdishprasad Jhabrmal Tibrewala University",
    value: "Shri Jagdishprasad Jhabrmal Tibrewala University",
  },
  {
    label: "Shri Lal Bahadur Shastri Rashtriya Sanskrit Vidyapeetha",
    value: "Shri Lal Bahadur Shastri Rashtriya Sanskrit Vidyapeetha",
  },
  {
    label: "Shri Mata Vaishno Devi University",
    value: "Shri Mata Vaishno Devi University",
  },
  {
    label: "Shri Ramswaroop Memorial University",
    value: "Shri Ramswaroop Memorial University",
  },
  {
    label: "Shri Vaishnav Vidyapeeth Vishwavidyalaya",
    value: "Shri Vaishnav Vidyapeeth Vishwavidyalaya",
  },
  {
    label: "Shri Venkateshwara University",
    value: "Shri Venkateshwara University",
  },
  {
    label: "Shri Vishwakarma Skill University",
    value: "Shri Vishwakarma Skill University",
  },
  {
    label: "Shridhar University",
    value: "Shridhar University",
  },
  {
    label: "Shubun University",
    value: "Shubun University",
  },
  {
    label: "Shuchiin University",
    value: "Shuchiin University",
  },
  {
    label: "Shujitsu University",
    value: "Shujitsu University",
  },
  {
    label: "Shukutoku University",
    value: "Shukutoku University",
  },
  {
    label: "Shumei University",
    value: "Shumei University",
  },
  {
    label: "Shunan University",
    value: "Shunan University",
  },
  {
    label: "Shupyk National Healthcare University of Ukraine",
    value: "Shupyk National Healthcare University of Ukraine",
  },
  {
    label: "Shu-Te University",
    value: "Shu-Te University",
  },
  {
    label: "Shwebo University",
    value: "Shwebo University",
  },
  {
    label: "Shymkent University",
    value: "Shymkent University",
  },
  {
    label: "Siam University",
    value: "Siam University",
  },
  {
    label: "Šiauliu valstybine kolegija",
    value: "Šiauliu valstybine kolegija",
  },
  {
    label: "Šiaures Lietuvos kolegija",
    value: "Šiaures Lietuvos kolegija",
  },
  {
    label: "Siberian Federal University",
    value: "Siberian Federal University",
  },
  {
    label: "Siberian State Aerospace University",
    value: "Siberian State Aerospace University",
  },
  {
    label: "Siberian State Industrial University",
    value: "Siberian State Industrial University",
  },
  {
    label: "Siberian State Medical University",
    value: "Siberian State Medical University",
  },
  {
    label: "Siberian State Transport University",
    value: "Siberian State Transport University",
  },
  {
    label: "Siberian State University of Physical Culture and Sports",
    value: "Siberian State University of Physical Culture and Sports",
  },
  {
    label: "Siberian State University of Telecommunications and Informatics",
    value: "Siberian State University of Telecommunications and Informatics",
  },
  {
    label: "Sichuan Agricultural University",
    value: "Sichuan Agricultural University",
  },
  {
    label: "Sichuan Conservatory of Music",
    value: "Sichuan Conservatory of Music",
  },
  {
    label: "Sichuan Film and Television University",
    value: "Sichuan Film and Television University",
  },
  {
    label: "Sichuan Fine Arts Institute",
    value: "Sichuan Fine Arts Institute",
  },
  {
    label: "Sichuan Institute of Industrial Technology",
    value: "Sichuan Institute of Industrial Technology",
  },
  {
    label: "Sichuan International Studies University",
    value: "Sichuan International Studies University",
  },
  {
    label: "Sichuan Normal University",
    value: "Sichuan Normal University",
  },
  {
    label: "Sichuan Tourism University",
    value: "Sichuan Tourism University",
  },
  {
    label: "Sichuan University",
    value: "Sichuan University",
  },
  {
    label: "Sichuan University for Nationalities",
    value: "Sichuan University for Nationalities",
  },
  {
    label: "Sichuan University of Arts and Science",
    value: "Sichuan University of Arts and Science",
  },
  {
    label: "Sichuan University of Culture and Arts",
    value: "Sichuan University of Culture and Arts",
  },
  {
    label: "Sichuan University of Media and Communications",
    value: "Sichuan University of Media and Communications",
  },
  {
    label: "Sichuan University of Science and Engineering",
    value: "Sichuan University of Science and Engineering",
  },
  {
    label: "Siddharth University",
    value: "Siddharth University",
  },
  {
    label: "Sidho Kanho Birsha University",
    value: "Sidho Kanho Birsha University",
  },
  {
    label: "Sido Kanhu Murmu University",
    value: "Sido Kanhu Murmu University",
  },
  {
    label: "Siena College",
    value: "Siena College",
  },
  {
    label: "Siena College of Taytay",
    value: "Siena College of Taytay",
  },
  {
    label: "Siena Heights University",
    value: "Siena Heights University",
  },
  {
    label: "Sigmund Freud Privatuniversität Wien",
    value: "Sigmund Freud Privatuniversität Wien",
  },
  {
    label: "Siirt Üniversitesi",
    value: "Siirt Üniversitesi",
  },
  {
    label: "Sikkim Manipal University",
    value: "Sikkim Manipal University",
  },
  {
    label: "Sikkim University",
    value: "Sikkim University",
  },
  {
    label: "Siksha 'O' Anusandhan",
    value: "Siksha 'O' Anusandhan",
  },
  {
    label: "SILKWAY International University",
    value: "SILKWAY International University",
  },
  {
    label: "Silla University",
    value: "Silla University",
  },
  {
    label: "Silliman University",
    value: "Silliman University",
  },
  {
    label: "Silpakorn University",
    value: "Silpakorn University",
  },
  {
    label: "Simmons University",
    value: "Simmons University",
  },
  {
    label:
      "Simon Diedong Dombo University of Business and Integrated Development Studies",
    value:
      "Simon Diedong Dombo University of Business and Integrated Development Studies",
  },
  {
    label: "Simon Fraser University",
    value: "Simon Fraser University",
  },
  {
    label: "Simon Kuznets Kharkiv National University of Economics",
    value: "Simon Kuznets Kharkiv National University of Economics",
  },
  {
    label: "Simpson College",
    value: "Simpson College",
  },
  {
    label: "Simpson University",
    value: "Simpson University",
  },
  {
    label: "Sinai University",
    value: "Sinai University",
  },
  {
    label: "Sindh Agriculture University",
    value: "Sindh Agriculture University",
  },
  {
    label: "Sindh Madresatul Islam University",
    value: "Sindh Madresatul Islam University",
  },
  {
    label: "Singapore Institute of Technology",
    value: "Singapore Institute of Technology",
  },
  {
    label: "Singapore Management University",
    value: "Singapore Management University",
  },
  {
    label: "Singapore University of Social Sciences",
    value: "Singapore University of Social Sciences",
  },
  {
    label: "Singapore University of Technology and Design",
    value: "Singapore University of Technology and Design",
  },
  {
    label: "Singhania University",
    value: "Singhania University",
  },
  {
    label: "Singyeongju University",
    value: "Singyeongju University",
  },
  {
    label: "Sinnar University",
    value: "Sinnar University",
  },
  {
    label: "Sinop Üniversitesi",
    value: "Sinop Üniversitesi",
  },
  {
    label: "Sir Padampat Singhania University",
    value: "Sir Padampat Singhania University",
  },
  {
    label: "Sir Syed University of Engineering and Technology",
    value: "Sir Syed University of Engineering and Technology",
  },
  {
    label: "Sirjan University of Technology",
    value: "Sirjan University of Technology",
  },
  {
    label: "Sirnak Üniversitesi",
    value: "Sirnak Üniversitesi",
  },
  {
    label: "Sirte University",
    value: "Sirte University",
  },
  {
    label: "Sisaket Rajabhat University",
    value: "Sisaket Rajabhat University",
  },
  {
    label: "Sisekaitseakadeemia",
    value: "Sisekaitseakadeemia",
  },
  {
    label: "SIT Graduate Institute",
    value: "SIT Graduate Institute",
  },
  {
    label: "Sittway University",
    value: "Sittway University",
  },
  {
    label: "Sivas Cumhuriyet Üniversitesi",
    value: "Sivas Cumhuriyet Üniversitesi",
  },
  {
    label: "SKEMA Business School",
    value: "SKEMA Business School",
  },
  {
    label: "Skidmore College",
    value: "Skidmore College",
  },
  {
    label: "Škoda Auto Vysoká škola",
    value: "Škoda Auto Vysoká škola",
  },
  {
    label: "Skyline University College",
    value: "Skyline University College",
  },
  {
    label: "Skyline University Nigeria",
    value: "Skyline University Nigeria",
  },
  {
    label: "Slaski Uniwersytet Medyczny w Katowicach",
    value: "Slaski Uniwersytet Medyczny w Katowicach",
  },
  {
    label: "Slezská univerzita v Opave",
    value: "Slezská univerzita v Opave",
  },
  {
    label: "Slippery Rock University of Pennsylvania",
    value: "Slippery Rock University of Pennsylvania",
  },
  {
    label: "Slobomir P Univerzitet",
    value: "Slobomir P Univerzitet",
  },
  {
    label: "Slovenská polnohospodárska univerzita v Nitre",
    value: "Slovenská polnohospodárska univerzita v Nitre",
  },
  {
    label: "Slovenská technická univerzita v Bratislave",
    value: "Slovenská technická univerzita v Bratislave",
  },
  {
    label: "Slovenská zdravotnícka univerzita v Bratislave",
    value: "Slovenská zdravotnícka univerzita v Bratislave",
  },
  {
    label: "Smith College",
    value: "Smith College",
  },
  {
    label: "Smolensk State University",
    value: "Smolensk State University",
  },
  {
    label: "Smythe University College",
    value: "Smythe University College",
  },
  {
    label: "Snow College",
    value: "Snow College",
  },
  {
    label: "Soai University",
    value: "Soai University",
  },
  {
    label: "SOAS, University of London",
    value: "SOAS, University of London",
  },
  {
    label: "Sociala darba un socialas pedagogijas augstskola Attistiba",
    value: "Sociala darba un socialas pedagogijas augstskola Attistiba",
  },
  {
    label: "Socialiniu mokslu kolegija",
    value: "Socialiniu mokslu kolegija",
  },
  {
    label: "Södertörns högskola",
    value: "Södertörns högskola",
  },
  {
    label: "Sofia University",
    value: "Sofia University",
  },
  {
    label: "Sofia University St. Kliment Ohridski",
    value: "Sofia University St. Kliment Ohridski",
  },
  {
    label: "Sogang University",
    value: "Sogang University",
  },
  {
    label: "Sohag university",
    value: "Sohag university",
  },
  {
    label: "Sohar University",
    value: "Sohar University",
  },
  {
    label: "Sojo University",
    value: "Sojo University",
  },
  {
    label: "Soka University",
    value: "Soka University",
  },
  {
    label: "Soka University of America",
    value: "Soka University of America",
  },
  {
    label: "Sokhumi State University",
    value: "Sokhumi State University",
  },
  {
    label: "Sokoine University of Agriculture",
    value: "Sokoine University of Agriculture",
  },
  {
    label: "Sokoto State University",
    value: "Sokoto State University",
  },
  {
    label: "Sol Plaatje University",
    value: "Sol Plaatje University",
  },
  {
    label: "Solent University",
    value: "Solent University",
  },
  {
    label: "Solomon Islands National University",
    value: "Solomon Islands National University",
  },
  {
    label: "Solusi University",
    value: "Solusi University",
  },
  {
    label: "Sonargaon University",
    value: "Sonargaon University",
  },
  {
    label: "Songkhla Rajabhat University",
    value: "Songkhla Rajabhat University",
  },
  {
    label: "Sonoda Women's University",
    value: "Sonoda Women's University",
  },
  {
    label: "Sonoma State University",
    value: "Sonoma State University",
  },
  {
    label: "Soochow University",
    value: "Soochow University",
  },
  {
    label: "Soochow University, Taiwan",
    value: "Soochow University, Taiwan",
  },
  {
    label: "Sookmyung Women's University",
    value: "Sookmyung Women's University",
  },
  {
    label: "Soonchunhyang University",
    value: "Soonchunhyang University",
  },
  {
    label: "Soongsil University",
    value: "Soongsil University",
  },
  {
    label: "Sophia University",
    value: "Sophia University",
  },
  {
    label: "Sophiahemmet Högskola",
    value: "Sophiahemmet Högskola",
  },
  {
    label: "Soproni Egyetem",
    value: "Soproni Egyetem",
  },
  {
    label: "Soran University",
    value: "Soran University",
  },
  {
    label: "Sorbonne Université",
    value: "Sorbonne Université",
  },
  {
    label: "Soroti University",
    value: "Soroti University",
  },
  {
    label: "Sorsogon State University",
    value: "Sorsogon State University",
  },
  {
    label: "South Asian University",
    value: "South Asian University",
  },
  {
    label: "South Carolina State University",
    value: "South Carolina State University",
  },
  {
    label: "South Champagne Business School",
    value: "South Champagne Business School",
  },
  {
    label: "South China Agricultural University",
    value: "South China Agricultural University",
  },
  {
    label: "South China Normal University",
    value: "South China Normal University",
  },
  {
    label: "South China University of Technology",
    value: "South China University of Technology",
  },
  {
    label: "South College",
    value: "South College",
  },
  {
    label: "South Dakota School of Mines and Technology",
    value: "South Dakota School of Mines and Technology",
  },
  {
    label: "South Dakota State University",
    value: "South Dakota State University",
  },
  {
    label: "South East European University",
    value: "South East European University",
  },
  {
    label: "South East Technological University",
    value: "South East Technological University",
  },
  {
    label: "South Eastern Kenya University",
    value: "South Eastern Kenya University",
  },
  {
    label: "South Eastern University of Sri Lanka",
    value: "South Eastern University of Sri Lanka",
  },
  {
    label: "South Georgia State College",
    value: "South Georgia State College",
  },
  {
    label: "South Kazakhstan Medical Academy",
    value: "South Kazakhstan Medical Academy",
  },
  {
    label: "South Kazakhstan State Pedagogical University",
    value: "South Kazakhstan State Pedagogical University",
  },
  {
    label: "South Mediterranean University",
    value: "South Mediterranean University",
  },
  {
    label: "South Texas College",
    value: "South Texas College",
  },
  {
    label: "South Texas College of Law",
    value: "South Texas College of Law",
  },
  {
    label: "South Ukrainian National Pedagogical University",
    value: "South Ukrainian National Pedagogical University",
  },
  {
    label: "South University",
    value: "South University",
  },
  {
    label: "South University of Science and Technology",
    value: "South University of Science and Technology",
  },
  {
    label: "South Ural State Agrarian University",
    value: "South Ural State Agrarian University",
  },
  {
    label: "South Ural State Medical University",
    value: "South Ural State Medical University",
  },
  {
    label: "South Ural State University",
    value: "South Ural State University",
  },
  {
    label: "South Valley University",
    value: "South Valley University",
  },
  {
    label: "South Valley University",
    value: "South Valley University",
  },
  {
    label: "South-Central University for Nationalities",
    value: "South-Central University for Nationalities",
  },
  {
    label: "South-East Asia University",
    value: "South-East Asia University",
  },
  {
    label: "Southeast Missouri State University",
    value: "Southeast Missouri State University",
  },
  {
    label: "Southeast University",
    value: "Southeast University",
  },
  {
    label: "Southeast University, Bangladesh",
    value: "Southeast University, Bangladesh",
  },
  {
    label: "Southeastern Baptist College",
    value: "Southeastern Baptist College",
  },
  {
    label: "Southeastern Louisiana University",
    value: "Southeastern Louisiana University",
  },
  {
    label: "Southeastern Oklahoma State University",
    value: "Southeastern Oklahoma State University",
  },
  {
    label: "Southeastern University",
    value: "Southeastern University",
  },
  {
    label: "Southern Adventist University",
    value: "Southern Adventist University",
  },
  {
    label: "Southern African Nazarene University",
    value: "Southern African Nazarene University",
  },
  {
    label: "Southern Alberta Institute of Technology",
    value: "Southern Alberta Institute of Technology",
  },
  {
    label: "Southern Arkansas University",
    value: "Southern Arkansas University",
  },
  {
    label: "Southern California Institute of Architecture",
    value: "Southern California Institute of Architecture",
  },
  {
    label: "Southern College of Optometry",
    value: "Southern College of Optometry",
  },
  {
    label: "Southern Connecticut State University",
    value: "Southern Connecticut State University",
  },
  {
    label: "Southern Cross University",
    value: "Southern Cross University",
  },
  {
    label: "Southern Federal University",
    value: "Southern Federal University",
  },
  {
    label: "Southern Illinois University Carbondale",
    value: "Southern Illinois University Carbondale",
  },
  {
    label: "Southern Illinois University Edwardsville",
    value: "Southern Illinois University Edwardsville",
  },
  {
    label: "Southern Leyte State University",
    value: "Southern Leyte State University",
  },
  {
    label: "Southern Luzon State University",
    value: "Southern Luzon State University",
  },
  {
    label: "Southern Medical University",
    value: "Southern Medical University",
  },
  {
    label: "Southern Methodist University",
    value: "Southern Methodist University",
  },
  {
    label: "Southern Nazarene University",
    value: "Southern Nazarene University",
  },
  {
    label: "Southern New Hampshire University",
    value: "Southern New Hampshire University",
  },
  {
    label: "Southern Oregon University",
    value: "Southern Oregon University",
  },
  {
    label: "Southern Taiwan University of Science and Technology",
    value: "Southern Taiwan University of Science and Technology",
  },
  {
    label: "Southern Technical University",
    value: "Southern Technical University",
  },
  {
    label: "Southern University and A&M College",
    value: "Southern University and A&M College",
  },
  {
    label: "Southern University at New Orleans",
    value: "Southern University at New Orleans",
  },
  {
    label: "Southern University Bangladesh",
    value: "Southern University Bangladesh",
  },
  {
    label: "Southern University Law Center",
    value: "Southern University Law Center",
  },
  {
    label: "Southern Utah University",
    value: "Southern Utah University",
  },
  {
    label: "Southern Virginia University",
    value: "Southern Virginia University",
  },
  {
    label: "Southern Wesleyan University",
    value: "Southern Wesleyan University",
  },
  {
    label: "South-Kazakhstan Humanitarian Institute",
    value: "South-Kazakhstan Humanitarian Institute",
  },
  {
    label: "South-Russian State Technical University",
    value: "South-Russian State Technical University",
  },
  {
    label: "Southwest Baptist University",
    value: "Southwest Baptist University",
  },
  {
    label: "Southwest Forestry University",
    value: "Southwest Forestry University",
  },
  {
    label: "Southwest Jiaotong University",
    value: "Southwest Jiaotong University",
  },
  {
    label: "Southwest Medical University",
    value: "Southwest Medical University",
  },
  {
    label: "Southwest Minnesota State University",
    value: "Southwest Minnesota State University",
  },
  {
    label: "Southwest Petroleum University",
    value: "Southwest Petroleum University",
  },
  {
    label: "Southwest University",
    value: "Southwest University",
  },
  {
    label: "South-West University 'Neofit Rilski'",
    value: "South-West University 'Neofit Rilski'",
  },
  {
    label: "Southwest University for Nationalities",
    value: "Southwest University for Nationalities",
  },
  {
    label: "Southwest University of Political Science and Law",
    value: "Southwest University of Political Science and Law",
  },
  {
    label: "Southwest University of Science and Technology",
    value: "Southwest University of Science and Technology",
  },
  {
    label: "Southwestern Adventist University",
    value: "Southwestern Adventist University",
  },
  {
    label: "Southwestern Assemblies of God University",
    value: "Southwestern Assemblies of God University",
  },
  {
    label: "Southwestern Christian University",
    value: "Southwestern Christian University",
  },
  {
    label: "Southwestern College",
    value: "Southwestern College",
  },
  {
    label: "Southwestern College, Santa Fe",
    value: "Southwestern College, Santa Fe",
  },
  {
    label: "Southwestern Law School",
    value: "Southwestern Law School",
  },
  {
    label: "Southwestern Oklahoma State University",
    value: "Southwestern Oklahoma State University",
  },
  {
    label: "South-Western State University",
    value: "South-Western State University",
  },
  {
    label: "Southwestern University",
    value: "Southwestern University",
  },
  {
    label: "Southwestern University - PHINMA",
    value: "Southwestern University - PHINMA",
  },
  {
    label: "Southwestern University of Finance and Economics",
    value: "Southwestern University of Finance and Economics",
  },
  {
    label: "Southwestern University, Nigeria",
    value: "Southwestern University, Nigeria",
  },
  {
    label: "Soyol-Erdem College",
    value: "Soyol-Erdem College",
  },
  {
    label: "Spalding University",
    value: "Spalding University",
  },
  {
    label: "Spelman College",
    value: "Spelman College",
  },
  {
    label: "Sphinx University",
    value: "Sphinx University",
  },
  {
    label: "Spicer Adventist University",
    value: "Spicer Adventist University",
  },
  {
    label: "Spiritan University College",
    value: "Spiritan University College",
  },
  {
    label: "Spiritan University Nneochi",
    value: "Spiritan University Nneochi",
  },
  {
    label: "Spring Arbor University",
    value: "Spring Arbor University",
  },
  {
    label: "Spring Hill College",
    value: "Spring Hill College",
  },
  {
    label: "Springfield College",
    value: "Springfield College",
  },
  {
    label: "Sree Chitra Thirunal Institute of Medical Sciences and Technology",
    value: "Sree Chitra Thirunal Institute of Medical Sciences and Technology",
  },
  {
    label: "Sree Sankaracharya University of Sanskrit",
    value: "Sree Sankaracharya University of Sanskrit",
  },
  {
    label: "SRH Fachhochschule für Gesundheit Gera",
    value: "SRH Fachhochschule für Gesundheit Gera",
  },
  {
    label: "SRH Fernhochschule",
    value: "SRH Fernhochschule",
  },
  {
    label: "SRH Hochschule Berlin",
    value: "SRH Hochschule Berlin",
  },
  {
    label: "SRH Hochschule Heidelberg",
    value: "SRH Hochschule Heidelberg",
  },
  {
    label: "SRH Hochschule in Nordrhein-Westfalen",
    value: "SRH Hochschule in Nordrhein-Westfalen",
  },
  {
    label: "Sri Balaji Vidyapeeth",
    value: "Sri Balaji Vidyapeeth",
  },
  {
    label: "Sri Chandrasekharendra Saraswathi Viswa Mahavidyalaya",
    value: "Sri Chandrasekharendra Saraswathi Viswa Mahavidyalaya",
  },
  {
    label: "Sri Dev Suman Uttarakhand University",
    value: "Sri Dev Suman Uttarakhand University",
  },
  {
    label: "Sri Devaraj Urs Academy of Higher Education and Research",
    value: "Sri Devaraj Urs Academy of Higher Education and Research",
  },
  {
    label: "Sri Guru Granth Sahib World University",
    value: "Sri Guru Granth Sahib World University",
  },
  {
    label: "Sri Guru Ram Das University of Health Sciences",
    value: "Sri Guru Ram Das University of Health Sciences",
  },
  {
    label: "Sri Konda Laxman Telangana State Horticultural University",
    value: "Sri Konda Laxman Telangana State Horticultural University",
  },
  {
    label: "Sri Krishnadevaraya University",
    value: "Sri Krishnadevaraya University",
  },
  {
    label: "Sri Padmavati Mahila Visvavidyalayam",
    value: "Sri Padmavati Mahila Visvavidyalayam",
  },
  {
    label: "Sri Ramachandra Institute of Higher Education and Research",
    value: "Sri Ramachandra Institute of Higher Education and Research",
  },
  {
    label: "Sri Sai University",
    value: "Sri Sai University",
  },
  {
    label: "Sri Sathya Sai Institute of Higher Learning",
    value: "Sri Sathya Sai Institute of Higher Learning",
  },
  {
    label: "Sri Satya Sai University of Technology and Medical Sciences",
    value: "Sri Satya Sai University of Technology and Medical Sciences",
  },
  {
    label: "Sri Siddhartha Academy of Higher Education",
    value: "Sri Siddhartha Academy of Higher Education",
  },
  {
    label: "Sri Sri University",
    value: "Sri Sri University",
  },
  {
    label: "Sri Venkateswara Institute of Medical Sciences",
    value: "Sri Venkateswara Institute of Medical Sciences",
  },
  {
    label: "Sri Venkateswara University",
    value: "Sri Venkateswara University",
  },
  {
    label: "Sri Venkateswara Vedic University",
    value: "Sri Venkateswara Vedic University",
  },
  {
    label: "Sri Venkateswara Veterinary University",
    value: "Sri Venkateswara Veterinary University",
  },
  {
    label: "Srimanta Sankaradeva University of Health Sciences",
    value: "Srimanta Sankaradeva University of Health Sciences",
  },
  {
    label: "Srinakharinwirot University",
    value: "Srinakharinwirot University",
  },
  {
    label: "Srinivas University",
    value: "Srinivas University",
  },
  {
    label: "Sripatum University",
    value: "Sripatum University",
  },
  {
    label: "SRM Institute of Science and Technology",
    value: "SRM Institute of Science and Technology",
  },
  {
    label: "SRM University Haryana",
    value: "SRM University Haryana",
  },
  {
    label: "SRM University, Sikkim",
    value: "SRM University, Sikkim",
  },
  {
    label: "St Andrews University",
    value: "St Andrews University",
  },
  {
    label: "St Catherine University",
    value: "St Catherine University",
  },
  {
    label: "St George's, University of London",
    value: "St George's, University of London",
  },
  {
    label: "St John's College",
    value: "St John's College",
  },
  {
    label: "St John's University",
    value: "St John's University",
  },
  {
    label: "St John's University of Tanzania",
    value: "St John's University of Tanzania",
  },
  {
    label: "St Lawrence University",
    value: "St Lawrence University",
  },
  {
    label: "St Mary's College",
    value: "St Mary's College",
  },
  {
    label: "St Mary's University",
    value: "St Mary's University",
  },
  {
    label: "St Mary's University, Twickenham",
    value: "St Mary's University, Twickenham",
  },
  {
    label: "St Patrick's Pontifical University",
    value: "St Patrick's Pontifical University",
  },
  {
    label: "St Petersburg College",
    value: "St Petersburg College",
  },
  {
    label: "St. Ambrose University",
    value: "St. Ambrose University",
  },
  {
    label: "St. Augustine University of Tanzania",
    value: "St. Augustine University of Tanzania",
  },
  {
    label: "St. Bonaventure University",
    value: "St. Bonaventure University",
  },
  {
    label: "St. Bonaventure University",
    value: "St. Bonaventure University",
  },
  {
    label: "St. Catherine University",
    value: "St. Catherine University",
  },
  {
    label: "St. Cloud State University",
    value: "St. Cloud State University",
  },
  {
    label: "St. Cyril and St. Methodius University of Veliko Tarnovo",
    value: "St. Cyril and St. Methodius University of Veliko Tarnovo",
  },
  {
    label: "St. Edward's University",
    value: "St. Edward's University",
  },
  {
    label: "St. Francis College",
    value: "St. Francis College",
  },
  {
    label: "St. Francis Xavier University",
    value: "St. Francis Xavier University",
  },
  {
    label: "St. George's University",
    value: "St. George's University",
  },
  {
    label: "St. John Fisher University",
    value: "St. John Fisher University",
  },
  {
    label: "St. John the Baptist University",
    value: "St. John the Baptist University",
  },
  {
    label: "St. Johns River State College",
    value: "St. Johns River State College",
  },
  {
    label: "St. John's University",
    value: "St. John's University",
  },
  {
    label: "St. Joseph University",
    value: "St. Joseph University",
  },
  {
    label: "St. Joseph University in Tanzania",
    value: "St. Joseph University in Tanzania",
  },
  {
    label: "St. Joseph's College of Quezon City",
    value: "St. Joseph's College of Quezon City",
  },
  {
    label: "St. Joseph's University",
    value: "St. Joseph's University",
  },
  {
    label: "St. King Tamar University of Patriarchate of Georgia",
    value: "St. King Tamar University of Patriarchate of Georgia",
  },
  {
    label: "St. Lawrence University",
    value: "St. Lawrence University",
  },
  {
    label: "St. Louis Christian College",
    value: "St. Louis Christian College",
  },
  {
    label: "St. Louis College Valenzuela",
    value: "St. Louis College Valenzuela",
  },
  {
    label: "St. Luke's College of Medicine - WHQM",
    value: "St. Luke's College of Medicine - WHQM",
  },
  {
    label: "St. Luke's International University",
    value: "St. Luke's International University",
  },
  {
    label: "St. Marianna University School of Medicine",
    value: "St. Marianna University School of Medicine",
  },
  {
    label: "St. Mary’s College",
    value: "St. Mary’s College",
  },
  {
    label: "St. Mary's College",
    value: "St. Mary's College",
  },
  {
    label: "St. Mary's College of Maryland",
    value: "St. Mary's College of Maryland",
  },
  {
    label: "St. Mary's University",
    value: "St. Mary's University",
  },
  {
    label: "St. Matthew's University",
    value: "St. Matthew's University",
  },
  {
    label: "St. Norbert College",
    value: "St. Norbert College",
  },
  {
    label: "St. Olaf College",
    value: "St. Olaf College",
  },
  {
    label: "St. Paul University Dumaguete",
    value: "St. Paul University Dumaguete",
  },
  {
    label: "St. Paul University Iloilo",
    value: "St. Paul University Iloilo",
  },
  {
    label: "St. Paul University Manila",
    value: "St. Paul University Manila",
  },
  {
    label: "St. Paul University Philippines",
    value: "St. Paul University Philippines",
  },
  {
    label: "St. Paul University Quezon City",
    value: "St. Paul University Quezon City",
  },
  {
    label: "St. Paul University Surigao",
    value: "St. Paul University Surigao",
  },
  {
    label: "St. Paul's University",
    value: "St. Paul's University",
  },
  {
    label: "St. Peter's Institute of Higher Education and Research",
    value: "St. Peter's Institute of Higher Education and Research",
  },
  {
    label: "St. Petersburg State Agrarian University",
    value: "St. Petersburg State Agrarian University",
  },
  {
    label: "St. Petersburg State Conservatory",
    value: "St. Petersburg State Conservatory",
  },
  {
    label: "St. Petersburg State Marine Technical University",
    value: "St. Petersburg State Marine Technical University",
  },
  {
    label: "St. Petersburg State University",
    value: "St. Petersburg State University",
  },
  {
    label: "St. Petersburg State University for Culture and Arts",
    value: "St. Petersburg State University for Culture and Arts",
  },
  {
    label: "St. Petersburg State University of Aerospace Instrumentation",
    value: "St. Petersburg State University of Aerospace Instrumentation",
  },
  {
    label:
      "St. Petersburg State University of Architecture and Civil Engineering",
    value:
      "St. Petersburg State University of Architecture and Civil Engineering",
  },
  {
    label: "St. Petersburg State University of Civil Aviation",
    value: "St. Petersburg State University of Civil Aviation",
  },
  {
    label: "St. Petersburg State University of Economics",
    value: "St. Petersburg State University of Economics",
  },
  {
    label:
      "St. Petersburg State University of Industrial Technologies and Design",
    value:
      "St. Petersburg State University of Industrial Technologies and Design",
  },
  {
    label: "St. Petersburg University of Management Technologies and Economics",
    value: "St. Petersburg University of Management Technologies and Economics",
  },
  {
    label: "St. Scholastica's College",
    value: "St. Scholastica's College",
  },
  {
    label: "St. Stephen's University",
    value: "St. Stephen's University",
  },
  {
    label: "St. Theresa Medical University of Yerevan",
    value: "St. Theresa Medical University of Yerevan",
  },
  {
    label: "St. Thomas Aquinas College",
    value: "St. Thomas Aquinas College",
  },
  {
    label: "St. Thomas More College",
    value: "St. Thomas More College",
  },
  {
    label: "St. Thomas University",
    value: "St. Thomas University",
  },
  {
    label: "St. Thomas University",
    value: "St. Thomas University",
  },
  {
    label: "St. Xavier's University",
    value: "St. Xavier's University",
  },
  {
    label: "Staatliche Akademie der Bildenden Künste Karlsruhe",
    value: "Staatliche Akademie der Bildenden Künste Karlsruhe",
  },
  {
    label: "Staatliche Akademie der Bildenden Künste Stuttgart",
    value: "Staatliche Akademie der Bildenden Künste Stuttgart",
  },
  {
    label: "Staatliche Hochschule für Gestaltung Karlsruhe",
    value: "Staatliche Hochschule für Gestaltung Karlsruhe",
  },
  {
    label: "Staatliche Hochschule für Musik Trossingen",
    value: "Staatliche Hochschule für Musik Trossingen",
  },
  {
    label: "Staatliche Hochschule für Musik und Darstellende Kunst Mannheim",
    value: "Staatliche Hochschule für Musik und Darstellende Kunst Mannheim",
  },
  {
    label: "Staatliche Hochschule für Musik und Darstellende Kunst Stuttgart",
    value: "Staatliche Hochschule für Musik und Darstellende Kunst Stuttgart",
  },
  {
    label: "Stafford University Uganda",
    value: "Stafford University Uganda",
  },
  {
    label: "Staffordshire University",
    value: "Staffordshire University",
  },
  {
    label: "Stamford International University",
    value: "Stamford International University",
  },
  {
    label: "Stamford University Bangladesh",
    value: "Stamford University Bangladesh",
  },
  {
    label: "Stanford University",
    value: "Stanford University",
  },
  {
    label: "Starex University",
    value: "Starex University",
  },
  {
    label: "Staropolska Szkola Wyzsza w Kielcach",
    value: "Staropolska Szkola Wyzsza w Kielcach",
  },
  {
    label: "Starptautiska praktiskas psihologijas augstskola",
    value: "Starptautiska praktiskas psihologijas augstskola",
  },
  {
    label: "Starz University",
    value: "Starz University",
  },
  {
    label: "State Academy of Fine Arts of Armenia",
    value: "State Academy of Fine Arts of Armenia",
  },
  {
    label: "State Academy of Fine Arts of Turkmenistan",
    value: "State Academy of Fine Arts of Turkmenistan",
  },
  {
    label: "State Biotechnological University",
    value: "State Biotechnological University",
  },
  {
    label: "State College of Florida-Manatee-Sarasota",
    value: "State College of Florida-Manatee-Sarasota",
  },
  {
    label: "State Energy Institute of Turkmenistan",
    value: "State Energy Institute of Turkmenistan",
  },
  {
    label: "State Financial and Economic University of Tajikistan",
    value: "State Financial and Economic University of Tajikistan",
  },
  {
    label: "State Tax University",
    value: "State Tax University",
  },
  {
    label: "State University of Bangladesh",
    value: "State University of Bangladesh",
  },
  {
    label: "State University of Education",
    value: "State University of Education",
  },
  {
    label: "State University of Information and Communication Technology",
    value: "State University of Information and Communication Technology",
  },
  {
    label: "State University of Infrastructure and Technology",
    value: "State University of Infrastructure and Technology",
  },
  {
    label: "State University of Intellectual Technologies and Communications",
    value: "State University of Intellectual Technologies and Communications",
  },
  {
    label: "State University of Land Management",
    value: "State University of Land Management",
  },
  {
    label: "State University of New York at Fredonia",
    value: "State University of New York at Fredonia",
  },
  {
    label: "State University of New York at New Paltz",
    value: "State University of New York at New Paltz",
  },
  {
    label: "State University of New York at Oswego",
    value: "State University of New York at Oswego",
  },
  {
    label: "State University of New York College at Plattsburgh",
    value: "State University of New York College at Plattsburgh",
  },
  {
    label: "State University of Performing and Visual Arts",
    value: "State University of Performing and Visual Arts",
  },
  {
    label: "Stavropol State Agrarian University",
    value: "Stavropol State Agrarian University",
  },
  {
    label: "Stavropol State Medical University",
    value: "Stavropol State Medical University",
  },
  {
    label: "Steinbeis-Hochschule",
    value: "Steinbeis-Hochschule",
  },
  {
    label: "Stephen F. Austin State University",
    value: "Stephen F. Austin State University",
  },
  {
    label: "Stephens College",
    value: "Stephens College",
  },
  {
    label: "Sterling College",
    value: "Sterling College",
  },
  {
    label: "Sterling College, Vermont",
    value: "Sterling College, Vermont",
  },
  {
    label: "Stetson University",
    value: "Stetson University",
  },
  {
    label: "Stevens Institute of Technology",
    value: "Stevens Institute of Technology",
  },
  {
    label: "Stevenson University",
    value: "Stevenson University",
  },
  {
    label: "STI West Negros University",
    value: "STI West Negros University",
  },
  {
    label: "Stillman College",
    value: "Stillman College",
  },
  {
    label: "Stockholms konstnärliga högskola",
    value: "Stockholms konstnärliga högskola",
  },
  {
    label: "Stockholms universitet",
    value: "Stockholms universitet",
  },
  {
    label: "Stockton University",
    value: "Stockton University",
  },
  {
    label: "Stonehill College",
    value: "Stonehill College",
  },
  {
    label: "Stony Brook University",
    value: "Stony Brook University",
  },
  {
    label: "Strate Ecole de Design",
    value: "Strate Ecole de Design",
  },
  {
    label: "Strathmore University",
    value: "Strathmore University",
  },
  {
    label: "Strayer University",
    value: "Strayer University",
  },
  {
    label: "Stredoeurópska vysoká škola v Skalici",
    value: "Stredoeurópska vysoká škola v Skalici",
  },
  {
    label: "Suamandeep Vidyapeeth",
    value: "Suamandeep Vidyapeeth",
  },
  {
    label: "Suan Dusit University",
    value: "Suan Dusit University",
  },
  {
    label: "Suan Sunandha Rajabhat University",
    value: "Suan Sunandha Rajabhat University",
  },
  {
    label: "Sudan Academy of Sciences",
    value: "Sudan Academy of Sciences",
  },
  {
    label: "Sudan International University",
    value: "Sudan International University",
  },
  {
    label: "Sudan Technological University",
    value: "Sudan Technological University",
  },
  {
    label: "Sudan University of Science and Technology",
    value: "Sudan University of Science and Technology",
  },
  {
    label: "Suez Canal University",
    value: "Suez Canal University",
  },
  {
    label: "Suez University",
    value: "Suez University",
  },
  {
    label: "Suffolk University",
    value: "Suffolk University",
  },
  {
    label: "Sugino Fashion College",
    value: "Sugino Fashion College",
  },
  {
    label: "Sugiyama Jogakuen University",
    value: "Sugiyama Jogakuen University",
  },
  {
    label: "Suihua University",
    value: "Suihua University",
  },
  {
    label: "Sukhoi State Technical University of Gomel",
    value: "Sukhoi State Technical University of Gomel",
  },
  {
    label: "Sukkur Institute of Business Administration",
    value: "Sukkur Institute of Business Administration",
  },
  {
    label: "Sul Ross State University",
    value: "Sul Ross State University",
  },
  {
    label: "Sulaimani Polytechnic University",
    value: "Sulaimani Polytechnic University",
  },
  {
    label: "Sule Lamido University",
    value: "Sule Lamido University",
  },
  {
    label: "Süleyman Demirel Üniversitesi",
    value: "Süleyman Demirel Üniversitesi",
  },
  {
    label: "Suleyman Demirel University",
    value: "Suleyman Demirel University",
  },
  {
    label: "Sulkhan-Saba Orbeliani Teaching University",
    value: "Sulkhan-Saba Orbeliani Teaching University",
  },
  {
    label: "Sullivan University",
    value: "Sullivan University",
  },
  {
    label: "Sultan Kudarat State University",
    value: "Sultan Kudarat State University",
  },
  {
    label: "Sultan Qaboos University",
    value: "Sultan Qaboos University",
  },
  {
    label: "Summit University Offa",
    value: "Summit University Offa",
  },
  {
    label: "Sumqayit Dövlet Universiteti",
    value: "Sumqayit Dövlet Universiteti",
  },
  {
    label: "Sumy National Agrarian University",
    value: "Sumy National Agrarian University",
  },
  {
    label: "Sumy State Pedagogical University",
    value: "Sumy State Pedagogical University",
  },
  {
    label: "Sumy State University",
    value: "Sumy State University",
  },
  {
    label: "Sun Moon University",
    value: "Sun Moon University",
  },
  {
    label: "Sun University",
    value: "Sun University",
  },
  {
    label: "Sun Yat-Sen University",
    value: "Sun Yat-Sen University",
  },
  {
    label: "Sunchon National University",
    value: "Sunchon National University",
  },
  {
    label: "Sungkonghoe University",
    value: "Sungkonghoe University",
  },
  {
    label: "Sungkyul University",
    value: "Sungkyul University",
  },
  {
    label: "Sungkyunkwan University",
    value: "Sungkyunkwan University",
  },
  {
    label: "Sungshin University",
    value: "Sungshin University",
  },
  {
    label: "Sunningdale University",
    value: "Sunningdale University",
  },
  {
    label: "Sunrise University",
    value: "Sunrise University",
  },
  {
    label: "Sunway University",
    value: "Sunway University",
  },
  {
    label: "SUNY Brockport",
    value: "SUNY Brockport",
  },
  {
    label: "SUNY Canton",
    value: "SUNY Canton",
  },
  {
    label: "SUNY Cobleskill",
    value: "SUNY Cobleskill",
  },
  {
    label: "SUNY College at Old Westbury",
    value: "SUNY College at Old Westbury",
  },
  {
    label: "SUNY College at Oneonta",
    value: "SUNY College at Oneonta",
  },
  {
    label: "SUNY College of Environmental Science and Forestry",
    value: "SUNY College of Environmental Science and Forestry",
  },
  {
    label: "SUNY College of Optometry",
    value: "SUNY College of Optometry",
  },
  {
    label: "SUNY Cortland",
    value: "SUNY Cortland",
  },
  {
    label: "SUNY Delhi",
    value: "SUNY Delhi",
  },
  {
    label: "SUNY Downstate Medical Center",
    value: "SUNY Downstate Medical Center",
  },
  {
    label: "SUNY Geneseo",
    value: "SUNY Geneseo",
  },
  {
    label: "SUNY Maritime College",
    value: "SUNY Maritime College",
  },
  {
    label: "SUNY Polytechnic Institute",
    value: "SUNY Polytechnic Institute",
  },
  {
    label: "Sunyani Technical University",
    value: "Sunyani Technical University",
  },
  {
    label: "Superior University",
    value: "Superior University",
  },
  {
    label: "Supershine University",
    value: "Supershine University",
  },
  {
    label: "Supméca - Institut Supérieur de Mécanique",
    value: "Supméca - Institut Supérieur de Mécanique",
  },
  {
    label: "Suqian University",
    value: "Suqian University",
  },
  {
    label: "Sur University College",
    value: "Sur University College",
  },
  {
    label: "Suranaree University of Technology",
    value: "Suranaree University of Technology",
  },
  {
    label: "Suratthani Rajabhat University",
    value: "Suratthani Rajabhat University",
  },
  {
    label: "Suresh Gyan Vihar University",
    value: "Suresh Gyan Vihar University",
  },
  {
    label: "Surgut State University",
    value: "Surgut State University",
  },
  {
    label: "Surindra Rajabhat University",
    value: "Surindra Rajabhat University",
  },
  {
    label: "Surugadai University",
    value: "Surugadai University",
  },
  {
    label: "Sushant University",
    value: "Sushant University",
  },
  {
    label: "Susquehanna University",
    value: "Susquehanna University",
  },
  {
    label: "Sutai Institute",
    value: "Sutai Institute",
  },
  {
    label: "Suwa University of Science",
    value: "Suwa University of Science",
  },
  {
    label: "Suwon Catholic University",
    value: "Suwon Catholic University",
  },
  {
    label: "Suzhou University",
    value: "Suzhou University",
  },
  {
    label: "Suzhou University of Science and Technology",
    value: "Suzhou University of Science and Technology",
  },
  {
    label: "Suzuka University",
    value: "Suzuka University",
  },
  {
    label: "Suzuka University of Medical Science",
    value: "Suzuka University of Medical Science",
  },
  {
    label: "Svay Rieng University",
    value: "Svay Rieng University",
  },
  {
    label: "Sveriges lantbruksuniversitet",
    value: "Sveriges lantbruksuniversitet",
  },
  {
    label: "Sveucilište Hercegovina",
    value: "Sveucilište Hercegovina",
  },
  {
    label: "Sveucilište Josipa Jurja Strossmayera u Osijeku",
    value: "Sveucilište Josipa Jurja Strossmayera u Osijeku",
  },
  {
    label: "Sveucilište Jurja Dobrile u Puli",
    value: "Sveucilište Jurja Dobrile u Puli",
  },
  {
    label: "Sveucilište Sjever",
    value: "Sveucilište Sjever",
  },
  {
    label: "Sveucilište u Dubrovniku",
    value: "Sveucilište u Dubrovniku",
  },
  {
    label: "Sveucilište u Mostaru",
    value: "Sveucilište u Mostaru",
  },
  {
    label: "Sveucilište u Rijeci",
    value: "Sveucilište u Rijeci",
  },
  {
    label: "Sveucilište u Slavonskom Brodu",
    value: "Sveucilište u Slavonskom Brodu",
  },
  {
    label: "Sveucilište u Splitu",
    value: "Sveucilište u Splitu",
  },
  {
    label: "Sveucilište u Zadru",
    value: "Sveucilište u Zadru",
  },
  {
    label: "Sveucilište u Zagrebu",
    value: "Sveucilište u Zagrebu",
  },
  {
    label: "Sveucilište/Univerzitet VITEZ",
    value: "Sveucilište/Univerzitet VITEZ",
  },
  {
    label: "Swami Keshwanand Rajasthan Agricultural University",
    value: "Swami Keshwanand Rajasthan Agricultural University",
  },
  {
    label: "Swami Rama Himalayan University",
    value: "Swami Rama Himalayan University",
  },
  {
    label: "Swami Ramanand Teerth Marathwada University",
    value: "Swami Ramanand Teerth Marathwada University",
  },
  {
    label: "Swami Vivekanand Subharti University",
    value: "Swami Vivekanand Subharti University",
  },
  {
    label: "Swami Vivekanand University",
    value: "Swami Vivekanand University",
  },
  {
    label: "Swami Vivekananda Yoga Anusandhana Samsthana",
    value: "Swami Vivekananda Yoga Anusandhana Samsthana",
  },
  {
    label: "Swansea University",
    value: "Swansea University",
  },
  {
    label: "Swarnim Gujarat Sports University",
    value: "Swarnim Gujarat Sports University",
  },
  {
    label: "Swarnim Startup and Innovation University",
    value: "Swarnim Startup and Innovation University",
  },
  {
    label: "Swarthmore College",
    value: "Swarthmore College",
  },
  {
    label: "Sweet Briar College",
    value: "Sweet Briar College",
  },
  {
    label: "Swinburne University of Technology",
    value: "Swinburne University of Technology",
  },
  {
    label: "Syddansk Musikkonservatorium",
    value: "Syddansk Musikkonservatorium",
  },
  {
    label: "Syddansk Universitet",
    value: "Syddansk Universitet",
  },
  {
    label: "Syed Jamaluddin Afghan Institute of Higher Education",
    value: "Syed Jamaluddin Afghan Institute of Higher Education",
  },
  {
    label: "Syktyvkar State University",
    value: "Syktyvkar State University",
  },
  {
    label: "Sylhet Agricultural University",
    value: "Sylhet Agricultural University",
  },
  {
    label: "Sylhet International University",
    value: "Sylhet International University",
  },
  {
    label: "Symbiosis International University",
    value: "Symbiosis International University",
  },
  {
    label: "Symbiosis University of Applied Sciences",
    value: "Symbiosis University of Applied Sciences",
  },
  {
    label: "Synergy University",
    value: "Synergy University",
  },
  {
    label: "Syracuse University",
    value: "Syracuse University",
  },
  {
    label: "Syrdariya University",
    value: "Syrdariya University",
  },
  {
    label: "Syrian Private University",
    value: "Syrian Private University",
  },
  {
    label: "Széchényi István Egyetem",
    value: "Széchényi István Egyetem",
  },
  {
    label: "Szegedi Tudományegyetem",
    value: "Szegedi Tudományegyetem",
  },
  {
    label: "Színház- és Filmmuvészeti Egyetem",
    value: "Színház- és Filmmuvészeti Egyetem",
  },
  {
    label: "Szkola Filmowa w Lodzi",
    value: "Szkola Filmowa w Lodzi",
  },
  {
    label: "Szkola Glówna Gospodarstwa Wiejskiego",
    value: "Szkola Glówna Gospodarstwa Wiejskiego",
  },
  {
    label: "Szkola Glówna Handlowa w Warszawie",
    value: "Szkola Glówna Handlowa w Warszawie",
  },
  {
    label: "Szkola Wyzsza im. Pawla Wlodkowica w Plocku",
    value: "Szkola Wyzsza im. Pawla Wlodkowica w Plocku",
  },
  {
    label: "T.H. Shevchenko National University 'Chernihiv Collegium'",
    value: "T.H. Shevchenko National University 'Chernihiv Collegium'",
  },
  {
    label: "Tabesh University",
    value: "Tabesh University",
  },
  {
    label: "Tabor College",
    value: "Tabor College",
  },
  {
    label: "Tabriz Islamic Art University",
    value: "Tabriz Islamic Art University",
  },
  {
    label: "Tabriz University of Medical Sciences",
    value: "Tabriz University of Medical Sciences",
  },
  {
    label: "Tafila Technical University",
    value: "Tafila Technical University",
  },
  {
    label: "Tafresh University",
    value: "Tafresh University",
  },
  {
    label: "Tai Solarin University of Education",
    value: "Tai Solarin University of Education",
  },
  {
    label: "Taibah University",
    value: "Taibah University",
  },
  {
    label: "Taideyliopisto",
    value: "Taideyliopisto",
  },
  {
    label: "Taif University",
    value: "Taif University",
  },
  {
    label: "Tainan National University of the Arts",
    value: "Tainan National University of the Arts",
  },
  {
    label: "Tainan University of Technology",
    value: "Tainan University of Technology",
  },
  {
    label: "Taipei City University of Science and Technology",
    value: "Taipei City University of Science and Technology",
  },
  {
    label: "Taipei Medical University",
    value: "Taipei Medical University",
  },
  {
    label: "Taipei National University of the Arts",
    value: "Taipei National University of the Arts",
  },
  {
    label: "Taipei University of Maritime Technology",
    value: "Taipei University of Maritime Technology",
  },
  {
    label: "Taisei Gakuin University",
    value: "Taisei Gakuin University",
  },
  {
    label: "Taishan University",
    value: "Taishan University",
  },
  {
    label: "Taisho University",
    value: "Taisho University",
  },
  {
    label: "Taita Taveta University",
    value: "Taita Taveta University",
  },
  {
    label: "Taiwan Shoufu University",
    value: "Taiwan Shoufu University",
  },
  {
    label: "Taiyuan Institute of Technology",
    value: "Taiyuan Institute of Technology",
  },
  {
    label: "Taiyuan Normal University",
    value: "Taiyuan Normal University",
  },
  {
    label: "Taiyuan University",
    value: "Taiyuan University",
  },
  {
    label: "Taiyuan University of Science and Technology",
    value: "Taiyuan University of Science and Technology",
  },
  {
    label: "Taiyuan University of Technology",
    value: "Taiyuan University of Technology",
  },
  {
    label: "Taiz University",
    value: "Taiz University",
  },
  {
    label: "TaiZhou University",
    value: "TaiZhou University",
  },
  {
    label: "Taizhou University",
    value: "Taizhou University",
  },
  {
    label: "Taj Institute of Higher Education",
    value: "Taj Institute of Higher Education",
  },
  {
    label: "Tajen University",
    value: "Tajen University",
  },
  {
    label: "Tajik Agrarian University",
    value: "Tajik Agrarian University",
  },
  {
    label: "Tajik Institute of Languages",
    value: "Tajik Institute of Languages",
  },
  {
    label: "Tajik Institute of Physical Education",
    value: "Tajik Institute of Physical Education",
  },
  {
    label: "Tajik National Conservatory",
    value: "Tajik National Conservatory",
  },
  {
    label: "Tajik National University",
    value: "Tajik National University",
  },
  {
    label: "Tajik State Medical University",
    value: "Tajik State Medical University",
  },
  {
    label: "Tajik State Pedagogical University",
    value: "Tajik State Pedagogical University",
  },
  {
    label: "Tajik State University of Commerce",
    value: "Tajik State University of Commerce",
  },
  {
    label: "Tajik Technical University",
    value: "Tajik Technical University",
  },
  {
    label: "Tajikistan State Institute of Art",
    value: "Tajikistan State Institute of Art",
  },
  {
    label: "Tajikistan State University of Law, Business and Politics",
    value: "Tajikistan State University of Law, Business and Politics",
  },
  {
    label: "Takachiho University",
    value: "Takachiho University",
  },
  {
    label: "Takamatsu University",
    value: "Takamatsu University",
  },
  {
    label: "Takaoka University of Law",
    value: "Takaoka University of Law",
  },
  {
    label: "Takarazuka University",
    value: "Takarazuka University",
  },
  {
    label: "Takarazuka University of Medical and Health Care",
    value: "Takarazuka University of Medical and Health Care",
  },
  {
    label: "Takasaki City University of Economics",
    value: "Takasaki City University of Economics",
  },
  {
    label: "Takasaki University of Commerce",
    value: "Takasaki University of Commerce",
  },
  {
    label: "Takasaki University of Health and Welfare",
    value: "Takasaki University of Health and Welfare",
  },
  {
    label: "Takhar University",
    value: "Takhar University",
  },
  {
    label: "Takming University of Science and Technology",
    value: "Takming University of Science and Technology",
  },
  {
    label: "Takoradi Technical University",
    value: "Takoradi Technical University",
  },
  {
    label: "Takushoku University",
    value: "Takushoku University",
  },
  {
    label: "Talas State University",
    value: "Talas State University",
  },
  {
    label: "Talladega College",
    value: "Talladega College",
  },
  {
    label: "Tallinna Tehnikakõrgkool",
    value: "Tallinna Tehnikakõrgkool",
  },
  {
    label: "Tallinna Tehnikaülikool",
    value: "Tallinna Tehnikaülikool",
  },
  {
    label: "Tallinna Tervishoiu Kõrgkool",
    value: "Tallinna Tervishoiu Kõrgkool",
  },
  {
    label: "Tallinna Ülikool",
    value: "Tallinna Ülikool",
  },
  {
    label: "Tama Art University",
    value: "Tama Art University",
  },
  {
    label: "Tama University",
    value: "Tama University",
  },
  {
    label: "Tamagawa University",
    value: "Tamagawa University",
  },
  {
    label: "Tamale Technical University",
    value: "Tamale Technical University",
  },
  {
    label:
      "Tambov State Musical-Pedagogical Institute named after S.V. Rachmaninov",
    value:
      "Tambov State Musical-Pedagogical Institute named after S.V. Rachmaninov",
  },
  {
    label: "Tambov State Technical University",
    value: "Tambov State Technical University",
  },
  {
    label: "Tambov State University",
    value: "Tambov State University",
  },
  {
    label: "Tamil Nadu Agricultural University",
    value: "Tamil Nadu Agricultural University",
  },
  {
    label: "Tamil Nadu Dr Ambedkar Law University",
    value: "Tamil Nadu Dr Ambedkar Law University",
  },
  {
    label: "Tamil Nadu Dr. J. Jayalalithaa Fisheries University",
    value: "Tamil Nadu Dr. J. Jayalalithaa Fisheries University",
  },
  {
    label: "Tamil Nadu Dr. M.G.R.Medical University",
    value: "Tamil Nadu Dr. M.G.R.Medical University",
  },
  {
    label: "Tamil Nadu Dr.J Jayalalithaa Music and Fine Arts University",
    value: "Tamil Nadu Dr.J Jayalalithaa Music and Fine Arts University",
  },
  {
    label: "Tamil Nadu National Law University",
    value: "Tamil Nadu National Law University",
  },
  {
    label: "Tamil Nadu Physical Education and Sports University",
    value: "Tamil Nadu Physical Education and Sports University",
  },
  {
    label: "Tamil Nadu Teacher Education University",
    value: "Tamil Nadu Teacher Education University",
  },
  {
    label: "Tamil Nadu Veterinary and Animal Sciences University",
    value: "Tamil Nadu Veterinary and Animal Sciences University",
  },
  {
    label: "Tamil University",
    value: "Tamil University",
  },
  {
    label: "Tamkang University",
    value: "Tamkang University",
  },
  {
    label: "Tampereen yliopisto",
    value: "Tampereen yliopisto",
  },
  {
    label: "Tangshan College",
    value: "Tangshan College",
  },
  {
    label: "Tangshan Normal University",
    value: "Tangshan Normal University",
  },
  {
    label: "Tansian University",
    value: "Tansian University",
  },
  {
    label: "Tanta University",
    value: "Tanta University",
  },
  {
    label: "Tantia University",
    value: "Tantia University",
  },
  {
    label: "Tapee University",
    value: "Tapee University",
  },
  {
    label: "Taraba State University",
    value: "Taraba State University",
  },
  {
    label: "Taras Shevchenko National University of Kyiv",
    value: "Taras Shevchenko National University of Kyiv",
  },
  {
    label: "Taraz Innovative-Humanitarian University",
    value: "Taraz Innovative-Humanitarian University",
  },
  {
    label: "Tarbiat Modares University",
    value: "Tarbiat Modares University",
  },
  {
    label: "Tarim University",
    value: "Tarim University",
  },
  {
    label: "Tarlac Agricultural University",
    value: "Tarlac Agricultural University",
  },
  {
    label: "Tarlac State University",
    value: "Tarlac State University",
  },
  {
    label: "Tarleton State University",
    value: "Tarleton State University",
  },
  {
    label: "Tarptautine teises ir verslo aukštoji mokykla",
    value: "Tarptautine teises ir verslo aukštoji mokykla",
  },
  {
    label: "Tartu Tervishoiu Kõrgkool",
    value: "Tartu Tervishoiu Kõrgkool",
  },
  {
    label: "Tartu Ülikool",
    value: "Tartu Ülikool",
  },
  {
    label: "Tata Institute of Fundamental Research",
    value: "Tata Institute of Fundamental Research",
  },
  {
    label: "Tata Institute of Social Sciences",
    value: "Tata Institute of Social Sciences",
  },
  {
    label: "Tatung Institute of Commerce and Technology",
    value: "Tatung Institute of Commerce and Technology",
  },
  {
    label: "Tatung University",
    value: "Tatung University",
  },
  {
    label: "Taunggyi University",
    value: "Taunggyi University",
  },
  {
    label: "Taungoo University",
    value: "Taungoo University",
  },
  {
    label: "Tavria State Agrotechnological University",
    value: "Tavria State Agrotechnological University",
  },
  {
    label: "Tay Bac University",
    value: "Tay Bac University",
  },
  {
    label: "Taylor University",
    value: "Taylor University",
  },
  {
    label: "Taylor's University",
    value: "Taylor's University",
  },
  {
    label: "Tbel Abuserisdze Teaching University of Georgian Patriarchate",
    value: "Tbel Abuserisdze Teaching University of Georgian Patriarchate",
  },
  {
    label: "Tbilisi Humanitarian Teaching University",
    value: "Tbilisi Humanitarian Teaching University",
  },
  {
    label: "Tbilisi State Academy of Arts",
    value: "Tbilisi State Academy of Arts",
  },
  {
    label: "Tbilisi State Medical University",
    value: "Tbilisi State Medical University",
  },
  {
    label: "Tchaikovsky State Academy of Physical Culture and Sports",
    value: "Tchaikovsky State Academy of Physical Culture and Sports",
  },
  {
    label: "Teaching University Geomedi",
    value: "Teaching University Geomedi",
  },
  {
    label: "Team University",
    value: "Team University",
  },
  {
    label: "TeamLease Skills University",
    value: "TeamLease Skills University",
  },
  {
    label: "Tech University of Korea",
    value: "Tech University of Korea",
  },
  {
    label: "Technical and Vocational University",
    value: "Technical and Vocational University",
  },
  {
    label: "Technical University - Varna",
    value: "Technical University - Varna",
  },
  {
    label: "Technical University of Crete",
    value: "Technical University of Crete",
  },
  {
    label: "Technical University of Gabrovo",
    value: "Technical University of Gabrovo",
  },
  {
    label: "Technical University of Kenya",
    value: "Technical University of Kenya",
  },
  {
    label: "Technical University of Mombasa",
    value: "Technical University of Mombasa",
  },
  {
    label: "Technical University of Sofia",
    value: "Technical University of Sofia",
  },
  {
    label: "Technická univerzita v Košiciach",
    value: "Technická univerzita v Košiciach",
  },
  {
    label: "Technická Univerzita v Liberci",
    value: "Technická Univerzita v Liberci",
  },
  {
    label: "Technická univerzita vo Zvolene",
    value: "Technická univerzita vo Zvolene",
  },
  {
    label: "Technion - Israel Institute of Technology",
    value: "Technion - Israel Institute of Technology",
  },
  {
    label: "Technische Hochschule Augsburg",
    value: "Technische Hochschule Augsburg",
  },
  {
    label: "Technische Hochschule Brandenburg",
    value: "Technische Hochschule Brandenburg",
  },
  {
    label: "Technische Hochschule Deggendorf",
    value: "Technische Hochschule Deggendorf",
  },
  {
    label: "Technische Hochschule Georg Agricola",
    value: "Technische Hochschule Georg Agricola",
  },
  {
    label: "Technische Hochschule Ingolstadt",
    value: "Technische Hochschule Ingolstadt",
  },
  {
    label: "Technische Hochschule Köln",
    value: "Technische Hochschule Köln",
  },
  {
    label: "Technische Hochschule Lübeck",
    value: "Technische Hochschule Lübeck",
  },
  {
    label: "Technische Hochschule Mittelhessen",
    value: "Technische Hochschule Mittelhessen",
  },
  {
    label: "Technische Hochschule Nürnberg Georg Simon Ohm",
    value: "Technische Hochschule Nürnberg Georg Simon Ohm",
  },
  {
    label: "Technische Hochschule Ostwestfalen-Lippe",
    value: "Technische Hochschule Ostwestfalen-Lippe",
  },
  {
    label: "Technische Hochschule Ulm",
    value: "Technische Hochschule Ulm",
  },
  {
    label: "Technische Hochschule Wildau",
    value: "Technische Hochschule Wildau",
  },
  {
    label: "Technische Hochschule Würzburg-Schweinfurt",
    value: "Technische Hochschule Würzburg-Schweinfurt",
  },
  {
    label: "Technische Universität Bergakademie Freiberg",
    value: "Technische Universität Bergakademie Freiberg",
  },
  {
    label: "Technische Universität Berlin",
    value: "Technische Universität Berlin",
  },
  {
    label: "Technische Universität Braunschweig",
    value: "Technische Universität Braunschweig",
  },
  {
    label: "Technische Universität Chemnitz",
    value: "Technische Universität Chemnitz",
  },
  {
    label: "Technische Universität Clausthal",
    value: "Technische Universität Clausthal",
  },
  {
    label: "Technische Universität Darmstadt",
    value: "Technische Universität Darmstadt",
  },
  {
    label: "Technische Universität Dortmund",
    value: "Technische Universität Dortmund",
  },
  {
    label: "Technische Universität Dresden",
    value: "Technische Universität Dresden",
  },
  {
    label: "Technische Universität Graz",
    value: "Technische Universität Graz",
  },
  {
    label: "Technische Universität Hamburg",
    value: "Technische Universität Hamburg",
  },
  {
    label: "Technische Universität Ilmenau",
    value: "Technische Universität Ilmenau",
  },
  {
    label: "Technische Universität München",
    value: "Technische Universität München",
  },
  {
    label: "Technische Universität Wien",
    value: "Technische Universität Wien",
  },
  {
    label: "Technische Universiteit Delft",
    value: "Technische Universiteit Delft",
  },
  {
    label: "Technische Universiteit Eindhoven",
    value: "Technische Universiteit Eindhoven",
  },
  {
    label: "Technischen Hochschule Bingen",
    value: "Technischen Hochschule Bingen",
  },
  {
    label: "Techno India University",
    value: "Techno India University",
  },
  {
    label: "Technological Institute of the Philippines",
    value: "Technological Institute of the Philippines",
  },
  {
    label: "Technological University Dublin",
    value: "Technological University Dublin",
  },
  {
    label: "Technological University of Tajikistan",
    value: "Technological University of Tajikistan",
  },
  {
    label: "Technological University of the Philippines",
    value: "Technological University of the Philippines",
  },
  {
    label: "Technological University of the Shannon",
    value: "Technological University of the Shannon",
  },
  {
    label: "Technological University, Banmaw",
    value: "Technological University, Banmaw",
  },
  {
    label: "Technological University, Dawei",
    value: "Technological University, Dawei",
  },
  {
    label: "Technological University, Hinthada",
    value: "Technological University, Hinthada",
  },
  {
    label: "Technological University, Hmawbi",
    value: "Technological University, Hmawbi",
  },
  {
    label: "Technological University, Hpaan",
    value: "Technological University, Hpaan",
  },
  {
    label: "Technological University, Kalay",
    value: "Technological University, Kalay",
  },
  {
    label: "Technological University, Kyaing Tong",
    value: "Technological University, Kyaing Tong",
  },
  {
    label: "Technological University, Lashio",
    value: "Technological University, Lashio",
  },
  {
    label: "Technological University, Loikaw",
    value: "Technological University, Loikaw",
  },
  {
    label: "Technological University, Magway",
    value: "Technological University, Magway",
  },
  {
    label: "Technological University, Mandalay",
    value: "Technological University, Mandalay",
  },
  {
    label: "Technological University, Maubin",
    value: "Technological University, Maubin",
  },
  {
    label: "Technological University, Mawlamyine",
    value: "Technological University, Mawlamyine",
  },
  {
    label: "Technological University, Meikhtila",
    value: "Technological University, Meikhtila",
  },
  {
    label: "Technological University, Monywa",
    value: "Technological University, Monywa",
  },
  {
    label: "Technological University, Myeik",
    value: "Technological University, Myeik",
  },
  {
    label: "Technological University, Myitkyina",
    value: "Technological University, Myitkyina",
  },
  {
    label: "Technological University, Pakokku",
    value: "Technological University, Pakokku",
  },
  {
    label: "Technological University, Panglong",
    value: "Technological University, Panglong",
  },
  {
    label: "Technological University, Pathein",
    value: "Technological University, Pathein",
  },
  {
    label: "Technological University, Sagaing",
    value: "Technological University, Sagaing",
  },
  {
    label: "Technological University, Sittwe",
    value: "Technological University, Sittwe",
  },
  {
    label: "Technological University, Taunggyi",
    value: "Technological University, Taunggyi",
  },
  {
    label: "Technological University, Taungoo",
    value: "Technological University, Taungoo",
  },
  {
    label: "Technological University, Yamethin",
    value: "Technological University, Yamethin",
  },
  {
    label: "TecNM Campus Altiplano de Tlaxcala",
    value: "TecNM Campus Altiplano de Tlaxcala",
  },
  {
    label: "TecNM Campus Comitán",
    value: "TecNM Campus Comitán",
  },
  {
    label: "TecNM campus Oaxaca",
    value: "TecNM campus Oaxaca",
  },
  {
    label: "TecNM Campus Zitácuaro",
    value: "TecNM Campus Zitácuaro",
  },
  {
    label: "Tecnológico de Antioquia",
    value: "Tecnológico de Antioquia",
  },
  {
    label: "Tecnológico de Monterrey",
    value: "Tecnológico de Monterrey",
  },
  {
    label: "Ted Üniversitesi",
    value: "Ted Üniversitesi",
  },
  {
    label: "Teerthanker Mahaveer University",
    value: "Teerthanker Mahaveer University",
  },
  {
    label: "Teesside University",
    value: "Teesside University",
  },
  {
    label: "Tehnicko veleucilište u Zagrebu",
    value: "Tehnicko veleucilište u Zagrebu",
  },
  {
    label: "Tehran University of Medical Sciences",
    value: "Tehran University of Medical Sciences",
  },
  {
    label: "Teikyo Heisei University",
    value: "Teikyo Heisei University",
  },
  {
    label: "Teikyo University",
    value: "Teikyo University",
  },
  {
    label: "Teikyo University of Science",
    value: "Teikyo University of Science",
  },
  {
    label: "Tekirdag Namik Kemal Üniversitesi",
    value: "Tekirdag Namik Kemal Üniversitesi",
  },
  {
    label: "Tel Aviv University",
    value: "Tel Aviv University",
  },
  {
    label: "Telangana University",
    value: "Telangana University",
  },
  {
    label: "Télécom Paris",
    value: "Télécom Paris",
  },
  {
    label: "Télécom SudParis",
    value: "Télécom SudParis",
  },
  {
    label: "Tel-Hai Academic College",
    value: "Tel-Hai Academic College",
  },
  {
    label: "Temple University",
    value: "Temple University",
  },
  {
    label: "Tenger Institute",
    value: "Tenger Institute",
  },
  {
    label: "Tennessee State University",
    value: "Tennessee State University",
  },
  {
    label: "Tennessee Tech University",
    value: "Tennessee Tech University",
  },
  {
    label: "Tennessee Wesleyan University",
    value: "Tennessee Wesleyan University",
  },
  {
    label: "Tenri University",
    value: "Tenri University",
  },
  {
    label: "Tenshi College",
    value: "Tenshi College",
  },
  {
    label: "Teofilo Kisanji University",
    value: "Teofilo Kisanji University",
  },
  {
    label: "TERI School of Advanced Studies",
    value: "TERI School of Advanced Studies",
  },
  {
    label: "Termiz Davlat Universiteti",
    value: "Termiz Davlat Universiteti",
  },
  {
    label: "Ternopil National Technical University",
    value: "Ternopil National Technical University",
  },
  {
    label: "Ternopil Volodymyr Hnatiuk National Pedagogical University",
    value: "Ternopil Volodymyr Hnatiuk National Pedagogical University",
  },
  {
    label: "Texas A&M International University",
    value: "Texas A&M International University",
  },
  {
    label: "Texas A&M University",
    value: "Texas A&M University",
  },
  {
    label: "Texas A&M University at Galveston",
    value: "Texas A&M University at Galveston",
  },
  {
    label: "Texas A&M University at Qatar",
    value: "Texas A&M University at Qatar",
  },
  {
    label: "Texas A&M University-Commerce",
    value: "Texas A&M University-Commerce",
  },
  {
    label: "Texas A&M University-Corpus Christi",
    value: "Texas A&M University-Corpus Christi",
  },
  {
    label: "Texas A&M University-Kingsville",
    value: "Texas A&M University-Kingsville",
  },
  {
    label: "Texas A&M University-San Antonio",
    value: "Texas A&M University-San Antonio",
  },
  {
    label: "Texas A&M University-Texarkana",
    value: "Texas A&M University-Texarkana",
  },
  {
    label: "Texas Christian University",
    value: "Texas Christian University",
  },
  {
    label: "Texas College",
    value: "Texas College",
  },
  {
    label: "Texas Lutheran University",
    value: "Texas Lutheran University",
  },
  {
    label: "Texas Southern University",
    value: "Texas Southern University",
  },
  {
    label: "Texas State University",
    value: "Texas State University",
  },
  {
    label: "Texas Tech University",
    value: "Texas Tech University",
  },
  {
    label: "Texas Tech University Health Sciences Center",
    value: "Texas Tech University Health Sciences Center",
  },
  {
    label: "Texas Wesleyan University",
    value: "Texas Wesleyan University",
  },
  {
    label: "Texas Woman's University",
    value: "Texas Woman's University",
  },
  {
    label: "Texila American University Zambia",
    value: "Texila American University Zambia",
  },
  {
    label: "Texila American University, Guyana",
    value: "Texila American University, Guyana",
  },
  {
    label: "Textile Institute of Pakistan",
    value: "Textile Institute of Pakistan",
  },
  {
    label: "Tezpur University",
    value: "Tezpur University",
  },
  {
    label: "Tezukayama Gakuin University",
    value: "Tezukayama Gakuin University",
  },
  {
    label: "Tezukayama University",
    value: "Tezukayama University",
  },
  {
    label: "Thai Binh University of Medicine and Pharmacy",
    value: "Thai Binh University of Medicine and Pharmacy",
  },
  {
    label: "Thai Nguyen University",
    value: "Thai Nguyen University",
  },
  {
    label: "Thaksin University",
    value: "Thaksin University",
  },
  {
    label: "Thamar University",
    value: "Thamar University",
  },
  {
    label: "Thammasat University",
    value: "Thammasat University",
  },
  {
    label: "Thanlyin Technological University",
    value: "Thanlyin Technological University",
  },
  {
    label: "Thapar Institute of Engineering and Technology",
    value: "Thapar Institute of Engineering and Technology",
  },
  {
    label: "The Academic College of Law and Science",
    value: "The Academic College of Law and Science",
  },
  {
    label: "The Academic College of Tel-Aviv-Yaffo",
    value: "The Academic College of Tel-Aviv-Yaffo",
  },
  {
    label: "The Academy of Management",
    value: "The Academy of Management",
  },
  {
    label: "The American College of Financial Services",
    value: "The American College of Financial Services",
  },
  {
    label: "The American College of Greece",
    value: "The American College of Greece",
  },
  {
    label: "The American College of Thessaloniki",
    value: "The American College of Thessaloniki",
  },
  {
    label: "The American University in Cairo",
    value: "The American University in Cairo",
  },
  {
    label: "The American University of Afghanistan",
    value: "The American University of Afghanistan",
  },
  {
    label: "The American University of Iraq, Sulaimani",
    value: "The American University of Iraq, Sulaimani",
  },
  {
    label: "The American University of Kurdistan",
    value: "The American University of Kurdistan",
  },
  {
    label: "The American University of Paris",
    value: "The American University of Paris",
  },
  {
    label: "The Arab Academy for Management, Banking and Financial Sciences",
    value: "The Arab Academy for Management, Banking and Financial Sciences",
  },
  {
    label:
      "The Bonch-Bruevich St. Petersburg State University of Telecommunications",
    value:
      "The Bonch-Bruevich St. Petersburg State University of Telecommunications",
  },
  {
    label: "The British University in Dubai",
    value: "The British University in Dubai",
  },
  {
    label: "The British University in Egypt",
    value: "The British University in Egypt",
  },
  {
    label: "The Catholic University of America",
    value: "The Catholic University of America",
  },
  {
    label: "The Catholic University of Eastern Africa",
    value: "The Catholic University of Eastern Africa",
  },
  {
    label: "The Catholic University of Korea",
    value: "The Catholic University of Korea",
  },
  {
    label: "The Catholic University of Malawi",
    value: "The Catholic University of Malawi",
  },
  {
    label: "The Catholic University of South Sudan",
    value: "The Catholic University of South Sudan",
  },
  {
    label: "The Central Academy of Drama",
    value: "The Central Academy of Drama",
  },
  {
    label: "The Chicago School of Professional Psychology",
    value: "The Chicago School of Professional Psychology",
  },
  {
    label: "The Chinese University of Hong Kong",
    value: "The Chinese University of Hong Kong",
  },
  {
    label: "The Chinese University of Hong Kong, Shenzhen",
    value: "The Chinese University of Hong Kong, Shenzhen",
  },
  {
    label: "The Citadel, The Military College of South Carolina",
    value: "The Citadel, The Military College of South Carolina",
  },
  {
    label: "The City College of New York",
    value: "The City College of New York",
  },
  {
    label: "The College of Idaho",
    value: "The College of Idaho",
  },
  {
    label: "The College of Management - Academic Studies",
    value: "The College of Management - Academic Studies",
  },
  {
    label: "The College of New Jersey",
    value: "The College of New Jersey",
  },
  {
    label: "The College of Saint Rose",
    value: "The College of Saint Rose",
  },
  {
    label: "The College of St. Scholastica",
    value: "The College of St. Scholastica",
  },
  {
    label: "The College of Westchester",
    value: "The College of Westchester",
  },
  {
    label: "The College of Wooster",
    value: "The College of Wooster",
  },
  {
    label: "The Cooper Union for the Advancement of Science and Art",
    value: "The Cooper Union for the Advancement of Science and Art",
  },
  {
    label: "The Co-operative University of Kenya",
    value: "The Co-operative University of Kenya",
  },
  {
    label: "The Copperbelt University",
    value: "The Copperbelt University",
  },
  {
    label: "The Courtauld Institute of Art, University of London",
    value: "The Courtauld Institute of Art, University of London",
  },
  {
    label: "The CTL Eurocollege",
    value: "The CTL Eurocollege",
  },
  {
    label: "The Culinary Institute of America",
    value: "The Culinary Institute of America",
  },
  {
    label: "The Cyprus Institute",
    value: "The Cyprus Institute",
  },
  {
    label: "The Cyprus Institute of Neurology and Genetics",
    value: "The Cyprus Institute of Neurology and Genetics",
  },
  {
    label: "The East African University",
    value: "The East African University",
  },
  {
    label: "The Eastern University of Management and Technology",
    value: "The Eastern University of Management and Technology",
  },
  {
    label: "The Education University of Hong Kong",
    value: "The Education University of Hong Kong",
  },
  {
    label: "The Emirates Academy of Hospitality Management",
    value: "The Emirates Academy of Hospitality Management",
  },
  {
    label: "The English and Foreign Languages University",
    value: "The English and Foreign Languages University",
  },
  {
    label: "The European Graduate School",
    value: "The European Graduate School",
  },
  {
    label: "The Evergreen State College",
    value: "The Evergreen State College",
  },
  {
    label: "The Far Eastern University",
    value: "The Far Eastern University",
  },
  {
    label: "The Future University",
    value: "The Future University",
  },
  {
    label: "The German University in Cairo",
    value: "The German University in Cairo",
  },
  {
    label: "The Glasgow School of Art",
    value: "The Glasgow School of Art",
  },
  {
    label: "The Government Sadiq College Women University",
    value: "The Government Sadiq College Women University",
  },
  {
    label: "The Graduate Center, CUNY",
    value: "The Graduate Center, CUNY",
  },
  {
    label: "The Graduate School for the Creation of New Photonics Industries",
    value: "The Graduate School for the Creation of New Photonics Industries",
  },
  {
    label: "The Graduate University for Advanced Studies, SOKENDAI",
    value: "The Graduate University for Advanced Studies, SOKENDAI",
  },
  {
    label: "The Hashemite University",
    value: "The Hashemite University",
  },
  {
    label: "The Hong Kong Polytechnic University",
    value: "The Hong Kong Polytechnic University",
  },
  {
    label: "The Hong Kong University of Science and Technology",
    value: "The Hong Kong University of Science and Technology",
  },
  {
    label: "The IIS University",
    value: "The IIS University",
  },
  {
    label: "The Ikh Zasag University",
    value: "The Ikh Zasag University",
  },
  {
    label: "The Indian Law Institute",
    value: "The Indian Law Institute",
  },
  {
    label: "The Institute of International Studies",
    value: "The Institute of International Studies",
  },
  {
    label: "The Institute of Management Sciences",
    value: "The Institute of Management Sciences",
  },
  {
    label:
      "The Institute of Telecommunications and Informatics of Turkmenistan",
    value:
      "The Institute of Telecommunications and Informatics of Turkmenistan",
  },
  {
    label: "The Institute of World Politics",
    value: "The Institute of World Politics",
  },
  {
    label: "The International University of Kagoshima",
    value: "The International University of Kagoshima",
  },
  {
    label: "The International University of Management",
    value: "The International University of Management",
  },
  {
    label: "The International University of Scholars",
    value: "The International University of Scholars",
  },
  {
    label: "The Islamia University of Bahawalpur",
    value: "The Islamia University of Bahawalpur",
  },
  {
    label: "The Japanese Red Cross Kyushu International College of Nursing",
    value: "The Japanese Red Cross Kyushu International College of Nursing",
  },
  {
    label: "The Jerusalem Academy of Music and Dance",
    value: "The Jerusalem Academy of Music and Dance",
  },
  {
    label: "The Jikei University School of Medicine",
    value: "The Jikei University School of Medicine",
  },
  {
    label: "The Juilliard School",
    value: "The Juilliard School",
  },
  {
    label: "The King's College",
    value: "The King's College",
  },
  {
    label: "The King's University",
    value: "The King's University",
  },
  {
    label: "The King's University",
    value: "The King's University",
  },
  {
    label: "The Limassol College",
    value: "The Limassol College",
  },
  {
    label: "The Liverpool Institute for Performing Arts",
    value: "The Liverpool Institute for Performing Arts",
  },
  {
    label: "The LNM Institute of Information Technology",
    value: "The LNM Institute of Information Technology",
  },
  {
    label: "The London Institute of Banking and Finance",
    value: "The London Institute of Banking and Finance",
  },
  {
    label: "The London School of Economics and Political Science",
    value: "The London School of Economics and Political Science",
  },
  {
    label: "The Maharaja Sayajirao University of Baroda",
    value: "The Maharaja Sayajirao University of Baroda",
  },
  {
    label: "The Maldives National University",
    value: "The Maldives National University",
  },
  {
    label: "The Master's University",
    value: "The Master's University",
  },
  {
    label: "The Millenium University",
    value: "The Millenium University",
  },
  {
    label: "The National Academy of Chinese Theatre Arts",
    value: "The National Academy of Chinese Theatre Arts",
  },
  {
    label: "The National University of Advanced Legal Studies",
    value: "The National University of Advanced Legal Studies",
  },
  {
    label: "The Neotia University",
    value: "The Neotia University",
  },
  {
    label: "The New School",
    value: "The New School",
  },
  {
    label: "The Nippon Dental University",
    value: "The Nippon Dental University",
  },
  {
    label: "The Northcap University",
    value: "The Northcap University",
  },
  {
    label: "The Ohio State University",
    value: "The Ohio State University",
  },
  {
    label: "The People's University of Bangladesh",
    value: "The People's University of Bangladesh",
  },
  {
    label: "The Philippine Women's University",
    value: "The Philippine Women's University",
  },
  {
    label: "The Philips College",
    value: "The Philips College",
  },
  {
    label: "The Presbyterian University of East Africa",
    value: "The Presbyterian University of East Africa",
  },
  {
    label: "The Regional Social and Innovation University",
    value: "The Regional Social and Innovation University",
  },
  {
    label: "The Rockefeller University",
    value: "The Rockefeller University",
  },
  {
    label: "The Rostov State Conservatoire",
    value: "The Rostov State Conservatoire",
  },
  {
    label: "The Royal Academy of Music, University of London",
    value: "The Royal Academy of Music, University of London",
  },
  {
    label: "The Royal Agricultural University",
    value: "The Royal Agricultural University",
  },
  {
    label: "The Royal Central School of Speech and Drama",
    value: "The Royal Central School of Speech and Drama",
  },
  {
    label: "The Royal Veterinary College University of London",
    value: "The Royal Veterinary College University of London",
  },
  {
    label: "The Sage Colleges",
    value: "The Sage Colleges",
  },
  {
    label: "The Sanskrit College and University",
    value: "The Sanskrit College and University",
  },
  {
    label: "The School of Architecture",
    value: "The School of Architecture",
  },
  {
    label: "The State University of Management",
    value: "The State University of Management",
  },
  {
    label: "The State University of New York at Potsdam",
    value: "The State University of New York at Potsdam",
  },
  {
    label: "The State University of Zanzibar",
    value: "The State University of Zanzibar",
  },
  {
    label: "The Technical University",
    value: "The Technical University",
  },
  {
    label: "The United Church of Zambia University",
    value: "The United Church of Zambia University",
  },
  {
    label: "The University of Adelaide",
    value: "The University of Adelaide",
  },
  {
    label: "The University of Agriculture, Peshawar",
    value: "The University of Agriculture, Peshawar",
  },
  {
    label: "The University of Aizu",
    value: "The University of Aizu",
  },
  {
    label: "The University of Alabama",
    value: "The University of Alabama",
  },
  {
    label: "The University of Alabama in Huntsville",
    value: "The University of Alabama in Huntsville",
  },
  {
    label: "The University of Arizona",
    value: "The University of Arizona",
  },
  {
    label: "The University of Arusha",
    value: "The University of Arusha",
  },
  {
    label: "The University of Barotseland",
    value: "The University of Barotseland",
  },
  {
    label: "The University of British Columbia",
    value: "The University of British Columbia",
  },
  {
    label: "The University of Buckingham",
    value: "The University of Buckingham",
  },
  {
    label: "The University of Cambodia",
    value: "The University of Cambodia",
  },
  {
    label: "The University of Central Thailand",
    value: "The University of Central Thailand",
  },
  {
    label: "The University of Da nang",
    value: "The University of Da nang",
  },
  {
    label: "The University of Dodoma",
    value: "The University of Dodoma",
  },
  {
    label: "The University of Duhok",
    value: "The University of Duhok",
  },
  {
    label: "The University of Electro-Communications",
    value: "The University of Electro-Communications",
  },
  {
    label: "The University of Faisalabad",
    value: "The University of Faisalabad",
  },
  {
    label: "The University of Fiji",
    value: "The University of Fiji",
  },
  {
    label: "The University of Fukuchiyama",
    value: "The University of Fukuchiyama",
  },
  {
    label: "The University of Georgia",
    value: "The University of Georgia",
  },
  {
    label: "The University of Guilan",
    value: "The University of Guilan",
  },
  {
    label: "The University of Hong Kong",
    value: "The University of Hong Kong",
  },
  {
    label: "The University of Kitakyushu",
    value: "The University of Kitakyushu",
  },
  {
    label: "The University of Lahore",
    value: "The University of Lahore",
  },
  {
    label: "The University of Law",
    value: "The University of Law",
  },
  {
    label: "The University of Maine",
    value: "The University of Maine",
  },
  {
    label: "The University of Manila",
    value: "The University of Manila",
  },
  {
    label: "The University of Medicine and Pharmacy at Ho Chi Minh City",
    value: "The University of Medicine and Pharmacy at Ho Chi Minh City",
  },
  {
    label: "The University of Melbourne",
    value: "The University of Melbourne",
  },
  {
    label: "The University of Memphis",
    value: "The University of Memphis",
  },
  {
    label: "The University of Montana Western",
    value: "The University of Montana Western",
  },
  {
    label: "The University of Mustansiriyah",
    value: "The University of Mustansiriyah",
  },
  {
    label: "The University of Nagano",
    value: "The University of Nagano",
  },
  {
    label: "The University of Newcastle",
    value: "The University of Newcastle",
  },
  {
    label: "The University of Nizwa",
    value: "The University of Nizwa",
  },
  {
    label: "The University of Northampton",
    value: "The University of Northampton",
  },
  {
    label: "The University of Notre Dame Australia",
    value: "The University of Notre Dame Australia",
  },
  {
    label: "The University of Nottingham Ningbo, China",
    value: "The University of Nottingham Ningbo, China",
  },
  {
    label: "The University of Oklahoma",
    value: "The University of Oklahoma",
  },
  {
    label: "The University of Oklahoma Health Sciences Center",
    value: "The University of Oklahoma Health Sciences Center",
  },
  {
    label: "The University of Olivet",
    value: "The University of Olivet",
  },
  {
    label: "The University of Queensland",
    value: "The University of Queensland",
  },
  {
    label: "The University of Shiga Prefecture",
    value: "The University of Shiga Prefecture",
  },
  {
    label: "The University of Shimane",
    value: "The University of Shimane",
  },
  {
    label: "The University of Suwon",
    value: "The University of Suwon",
  },
  {
    label: "The University of Sydney",
    value: "The University of Sydney",
  },
  {
    label: "The University of Tampa",
    value: "The University of Tampa",
  },
  {
    label: "The University of Tennessee at Chattanooga",
    value: "The University of Tennessee at Chattanooga",
  },
  {
    label: "The University of Tennessee at Martin",
    value: "The University of Tennessee at Martin",
  },
  {
    label: "The University of Tennessee Health Science Center",
    value: "The University of Tennessee Health Science Center",
  },
  {
    label: "The University of Tennessee Southern",
    value: "The University of Tennessee Southern",
  },
  {
    label: "The University of Tennessee, Knoxville",
    value: "The University of Tennessee, Knoxville",
  },
  {
    label: "The University of Texas at Arlington",
    value: "The University of Texas at Arlington",
  },
  {
    label: "The University of Texas at Austin",
    value: "The University of Texas at Austin",
  },
  {
    label: "The University of Texas at Dallas",
    value: "The University of Texas at Dallas",
  },
  {
    label: "The University of Texas at El Paso",
    value: "The University of Texas at El Paso",
  },
  {
    label: "The University of Texas at San Antonio",
    value: "The University of Texas at San Antonio",
  },
  {
    label: "The University of Texas at Tyler",
    value: "The University of Texas at Tyler",
  },
  {
    label: "The University of Texas Health Science Center at Houston",
    value: "The University of Texas Health Science Center at Houston",
  },
  {
    label: "The University of Texas Health Science Center at San Antonio",
    value: "The University of Texas Health Science Center at San Antonio",
  },
  {
    label: "The University of Texas Health Science Center at Tyler",
    value: "The University of Texas Health Science Center at Tyler",
  },
  {
    label: "The University of Texas MD Anderson Cancer Center",
    value: "The University of Texas MD Anderson Cancer Center",
  },
  {
    label: "The University of Texas Medical Branch at Galveston",
    value: "The University of Texas Medical Branch at Galveston",
  },
  {
    label: "The University of Texas Permian Basin",
    value: "The University of Texas Permian Basin",
  },
  {
    label: "The University of the Arts",
    value: "The University of the Arts",
  },
  {
    label: "The University of the South Pacific",
    value: "The University of the South Pacific",
  },
  {
    label: "The University of the West Indies, Cave Hill Campus",
    value: "The University of the West Indies, Cave Hill Campus",
  },
  {
    label: "The University of the West Indies, Mona",
    value: "The University of the West Indies, Mona",
  },
  {
    label: "The University of the West Indies, St. Augustine",
    value: "The University of the West Indies, St. Augustine",
  },
  {
    label: "The University of Tokyo",
    value: "The University of Tokyo",
  },
  {
    label: "The University of Trinidad and Tobago",
    value: "The University of Trinidad and Tobago",
  },
  {
    label: "The University of Tulsa",
    value: "The University of Tulsa",
  },
  {
    label: "The University of Utah",
    value: "The University of Utah",
  },
  {
    label: "The University of Virginia's College at Wise",
    value: "The University of Virginia's College at Wise",
  },
  {
    label: "The University of West Alabama",
    value: "The University of West Alabama",
  },
  {
    label: "The University of West Los Angeles",
    value: "The University of West Los Angeles",
  },
  {
    label: "The University of Western Australia",
    value: "The University of Western Australia",
  },
  {
    label: "The University of Winnipeg",
    value: "The University of Winnipeg",
  },
  {
    label: "The University of York",
    value: "The University of York",
  },
  {
    label: "The West Bengal National University of Juridical Sciences",
    value: "The West Bengal National University of Juridical Sciences",
  },
  {
    label: "The Women University Multan",
    value: "The Women University Multan",
  },
  {
    label: "The World Islamic Sciences and Education University",
    value: "The World Islamic Sciences and Education University",
  },
  {
    label: "The Wright Institute",
    value: "The Wright Institute",
  },
  {
    label: "The Zambia Catholic University",
    value: "The Zambia Catholic University",
  },
  {
    label: "Theologische Hochschule Friedensau",
    value: "Theologische Hochschule Friedensau",
  },
  {
    label: "Theologische Hochschule Reutlingen",
    value: "Theologische Hochschule Reutlingen",
  },
  {
    label: "Thepsatri Rajabhat University",
    value: "Thepsatri Rajabhat University",
  },
  {
    label: "Thiel College",
    value: "Thiel College",
  },
  {
    label: "Thiruvalluvar University",
    value: "Thiruvalluvar University",
  },
  {
    label: "Thomas Aquinas College",
    value: "Thomas Aquinas College",
  },
  {
    label: "Thomas College",
    value: "Thomas College",
  },
  {
    label: "Thomas Edison State University",
    value: "Thomas Edison State University",
  },
  {
    label: "Thomas Jefferson School of Law",
    value: "Thomas Jefferson School of Law",
  },
  {
    label: "Thomas Jefferson University",
    value: "Thomas Jefferson University",
  },
  {
    label: "Thomas More College of Liberal Arts",
    value: "Thomas More College of Liberal Arts",
  },
  {
    label: "Thomas More Hogeschool",
    value: "Thomas More Hogeschool",
  },
  {
    label: "Thomas More University",
    value: "Thomas More University",
  },
  {
    label: "Thomas University",
    value: "Thomas University",
  },
  {
    label: "Thompson Rivers University",
    value: "Thompson Rivers University",
  },
  {
    label: "Thonburi University",
    value: "Thonburi University",
  },
  {
    label: "Thunchath Ezhuthachan Malayalam University",
    value: "Thunchath Ezhuthachan Malayalam University",
  },
  {
    label: "Thuongmai University",
    value: "Thuongmai University",
  },
  {
    label: "Thuyloi University",
    value: "Thuyloi University",
  },
  {
    label: "Tiangong University",
    value: "Tiangong University",
  },
  {
    label: "Tianjin Academy of Fine Arts",
    value: "Tianjin Academy of Fine Arts",
  },
  {
    label: "Tianjin Agricultural University",
    value: "Tianjin Agricultural University",
  },
  {
    label: "Tianjin Chengjian University",
    value: "Tianjin Chengjian University",
  },
  {
    label: "Tianjin Conservatory of Music",
    value: "Tianjin Conservatory of Music",
  },
  {
    label: "Tianjin Foreign Studies University",
    value: "Tianjin Foreign Studies University",
  },
  {
    label: "Tianjin Medical University",
    value: "Tianjin Medical University",
  },
  {
    label: "Tianjin Normal University",
    value: "Tianjin Normal University",
  },
  {
    label: "Tianjin Tianshi College",
    value: "Tianjin Tianshi College",
  },
  {
    label: "Tianjin University",
    value: "Tianjin University",
  },
  {
    label: "Tianjin University of Commerce",
    value: "Tianjin University of Commerce",
  },
  {
    label: "Tianjin University of Finance and Economics",
    value: "Tianjin University of Finance and Economics",
  },
  {
    label: "Tianjin University of Science and Technology",
    value: "Tianjin University of Science and Technology",
  },
  {
    label: "Tianjin University of Sport",
    value: "Tianjin University of Sport",
  },
  {
    label: "Tianjin University of Technology",
    value: "Tianjin University of Technology",
  },
  {
    label: "Tianjin University of Technology and Education",
    value: "Tianjin University of Technology and Education",
  },
  {
    label: "Tianjin University of Traditional Chinese Medicine",
    value: "Tianjin University of Traditional Chinese Medicine",
  },
  {
    label: "Tianjin Zhongde University of Applied Sciences",
    value: "Tianjin Zhongde University of Applied Sciences",
  },
  {
    label: "Tianshui Normal University",
    value: "Tianshui Normal University",
  },
  {
    label: "TIAS School for Business and Society",
    value: "TIAS School for Business and Society",
  },
  {
    label: "Tibet University",
    value: "Tibet University",
  },
  {
    label: "Tibetan Traditional Medical College",
    value: "Tibetan Traditional Medical College",
  },
  {
    label: "Tierärztliche Hochschule Hannover",
    value: "Tierärztliche Hochschule Hannover",
  },
  {
    label: "Tiffin University",
    value: "Tiffin University",
  },
  {
    label: "Tilak Maharashtra Vidyapeeth",
    value: "Tilak Maharashtra Vidyapeeth",
  },
  {
    label: "Tilburg University",
    value: "Tilburg University",
  },
  {
    label: "Tilka Manjhi Bhagalpur University",
    value: "Tilka Manjhi Bhagalpur University",
  },
  {
    label: "TIME Université",
    value: "TIME Université",
  },
  {
    label: "Times University of Bangladesh",
    value: "Times University of Bangladesh",
  },
  {
    label: "Tirana Business University College",
    value: "Tirana Business University College",
  },
  {
    label: "Tishk International University",
    value: "Tishk International University",
  },
  {
    label: "Tishreen University",
    value: "Tishreen University",
  },
  {
    label: "Tobago Hospitality and Tourism Institute",
    value: "Tobago Hospitality and Tourism Institute",
  },
  {
    label: "TOBB Ekonomi ve Teknoloji Üniversitesi",
    value: "TOBB Ekonomi ve Teknoloji Üniversitesi",
  },
  {
    label: "Tobruk University",
    value: "Tobruk University",
  },
  {
    label: "Toccoa Falls College",
    value: "Toccoa Falls College",
  },
  {
    label: "Togliatti State University",
    value: "Togliatti State University",
  },
  {
    label: "Toho College of Music",
    value: "Toho College of Music",
  },
  {
    label: "Toho Gakuen School of Music",
    value: "Toho Gakuen School of Music",
  },
  {
    label: "Toho University",
    value: "Toho University",
  },
  {
    label: "Tohoku Bunka Gakuen University",
    value: "Tohoku Bunka Gakuen University",
  },
  {
    label: "Tohoku Bunkyo College",
    value: "Tohoku Bunkyo College",
  },
  {
    label: "Tohoku Fukushi University",
    value: "Tohoku Fukushi University",
  },
  {
    label: "Tohoku Gakuin University",
    value: "Tohoku Gakuin University",
  },
  {
    label: "Tohoku Institute of Technology",
    value: "Tohoku Institute of Technology",
  },
  {
    label: "Tohoku Medical and Pharmaceutical University",
    value: "Tohoku Medical and Pharmaceutical University",
  },
  {
    label: "Tohoku Seikatsu Bunka University",
    value: "Tohoku Seikatsu Bunka University",
  },
  {
    label: "Tohoku University",
    value: "Tohoku University",
  },
  {
    label: "Tohoku University of Art and Design",
    value: "Tohoku University of Art and Design",
  },
  {
    label: "Tohoku University of Community Service and Science",
    value: "Tohoku University of Community Service and Science",
  },
  {
    label: "Tohto University",
    value: "Tohto University",
  },
  {
    label: "Toin University of Yokohama",
    value: "Toin University of Yokohama",
  },
  {
    label: "Tokai Gakuen University",
    value: "Tokai Gakuen University",
  },
  {
    label: "Tokai Gakuin University",
    value: "Tokai Gakuin University",
  },
  {
    label: "Tokai University",
    value: "Tokai University",
  },
  {
    label: "Tokat Gaziosmanpasa Üniversitesi",
    value: "Tokat Gaziosmanpasa Üniversitesi",
  },
  {
    label: "Tokiwa University",
    value: "Tokiwa University",
  },
  {
    label: "Tokiwakai Gakuen University",
    value: "Tokiwakai Gakuen University",
  },
  {
    label: "Toko University",
    value: "Toko University",
  },
  {
    label: "Tokoha University",
    value: "Tokoha University",
  },
  {
    label: "Tokushima Bunri University",
    value: "Tokushima Bunri University",
  },
  {
    label: "Tokushima University",
    value: "Tokushima University",
  },
  {
    label: "Tokyo Ariake University of Medical and Health Sciences",
    value: "Tokyo Ariake University of Medical and Health Sciences",
  },
  {
    label: "Tokyo Christian University",
    value: "Tokyo Christian University",
  },
  {
    label: "Tokyo City University",
    value: "Tokyo City University",
  },
  {
    label: "Tokyo College of Music",
    value: "Tokyo College of Music",
  },
  {
    label: "Tokyo Denki University",
    value: "Tokyo Denki University",
  },
  {
    label: "Tokyo Dental College",
    value: "Tokyo Dental College",
  },
  {
    label: "Tokyo Fuji University",
    value: "Tokyo Fuji University",
  },
  {
    label: "Tokyo Future University",
    value: "Tokyo Future University",
  },
  {
    label: "Tokyo Gakugei University",
    value: "Tokyo Gakugei University",
  },
  {
    label: "Tokyo Healthcare University",
    value: "Tokyo Healthcare University",
  },
  {
    label: "Tokyo Institute of Technology",
    value: "Tokyo Institute of Technology",
  },
  {
    label: "Tokyo International University",
    value: "Tokyo International University",
  },
  {
    label: "Tokyo Junshin University",
    value: "Tokyo Junshin University",
  },
  {
    label: "Tokyo Kasei Gakuin University",
    value: "Tokyo Kasei Gakuin University",
  },
  {
    label: "Tokyo Kasei University",
    value: "Tokyo Kasei University",
  },
  {
    label: "Tokyo Keizai University",
    value: "Tokyo Keizai University",
  },
  {
    label: "Tokyo Medical and Dental University",
    value: "Tokyo Medical and Dental University",
  },
  {
    label: "Tokyo Medical University",
    value: "Tokyo Medical University",
  },
  {
    label: "Tokyo Metropolitan University",
    value: "Tokyo Metropolitan University",
  },
  {
    label: "Tokyo Polytechnic University",
    value: "Tokyo Polytechnic University",
  },
  {
    label: "Tokyo Seiei College",
    value: "Tokyo Seiei College",
  },
  {
    label: "Tokyo Seitoku University",
    value: "Tokyo Seitoku University",
  },
  {
    label: "Tokyo Union Theological Seminary",
    value: "Tokyo Union Theological Seminary",
  },
  {
    label: "Tokyo University of Agriculture",
    value: "Tokyo University of Agriculture",
  },
  {
    label: "Tokyo University of Agriculture and Technology",
    value: "Tokyo University of Agriculture and Technology",
  },
  {
    label: "Tokyo University of Foreign Studies",
    value: "Tokyo University of Foreign Studies",
  },
  {
    label: "Tokyo University of Information Sciences",
    value: "Tokyo University of Information Sciences",
  },
  {
    label: "Tokyo University of Marine Science and Technology",
    value: "Tokyo University of Marine Science and Technology",
  },
  {
    label: "Tokyo University of Pharmacy and Life Sciences",
    value: "Tokyo University of Pharmacy and Life Sciences",
  },
  {
    label: "Tokyo University of Science",
    value: "Tokyo University of Science",
  },
  {
    label: "Tokyo University of Social Welfare",
    value: "Tokyo University of Social Welfare",
  },
  {
    label: "Tokyo University of Technology",
    value: "Tokyo University of Technology",
  },
  {
    label: "Tokyo University of the Arts",
    value: "Tokyo University of the Arts",
  },
  {
    label: "Tokyo Woman's Christian University",
    value: "Tokyo Woman's Christian University",
  },
  {
    label: "Tokyo Women's College of Physical Education",
    value: "Tokyo Women's College of Physical Education",
  },
  {
    label: "Tokyo Women's Medical University",
    value: "Tokyo Women's Medical University",
  },
  {
    label: "Tokyo Zokei University",
    value: "Tokyo Zokei University",
  },
  {
    label: "Tolo-e-Aftab Institute of Higher Education",
    value: "Tolo-e-Aftab Institute of Higher Education",
  },
  {
    label: "Tomori Pál Foiskola",
    value: "Tomori Pál Foiskola",
  },
  {
    label: "Tomsk Polytechnic University",
    value: "Tomsk Polytechnic University",
  },
  {
    label: "Tomsk State Pedagogical University",
    value: "Tomsk State Pedagogical University",
  },
  {
    label: "Tomsk State University",
    value: "Tomsk State University",
  },
  {
    label: "Tomsk State University of Architecture and Building",
    value: "Tomsk State University of Architecture and Building",
  },
  {
    label: "Tomsk State University of Control Systems and Radioelectronics",
    value: "Tomsk State University of Control Systems and Radioelectronics",
  },
  {
    label: "Tonghua Normal University",
    value: "Tonghua Normal University",
  },
  {
    label: "Tongji University",
    value: "Tongji University",
  },
  {
    label: "Tongling University",
    value: "Tongling University",
  },
  {
    label: "Tongmyung University",
    value: "Tongmyung University",
  },
  {
    label: "Tongren University",
    value: "Tongren University",
  },
  {
    label: "Toronto Metropolitan University",
    value: "Toronto Metropolitan University",
  },
  {
    label: "Toros Üniversitesi",
    value: "Toros Üniversitesi",
  },
  {
    label: "Torrens University Australia",
    value: "Torrens University Australia",
  },
  {
    label: "Toshkent Arxitektura-Qurilish Universiteti",
    value: "Toshkent Arxitektura-Qurilish Universiteti",
  },
  {
    label: "Toshkent Davlat Agrar Universiteti",
    value: "Toshkent Davlat Agrar Universiteti",
  },
  {
    label: "Toshkent Davlat Iqtisodiyot Universiteti",
    value: "Toshkent Davlat Iqtisodiyot Universiteti",
  },
  {
    label: "Toshkent Davlat Pedagogika Universiteti",
    value: "Toshkent Davlat Pedagogika Universiteti",
  },
  {
    label: "Toshkent Davlat Sharqshunoslik Universiteti",
    value: "Toshkent Davlat Sharqshunoslik Universiteti",
  },
  {
    label: "Toshkent Davlat Stomatologiya Instituti",
    value: "Toshkent Davlat Stomatologiya Instituti",
  },
  {
    label: "Toshkent Davlat Texnika Universiteti",
    value: "Toshkent Davlat Texnika Universiteti",
  },
  {
    label: "Toshkent davlat transport universiteti",
    value: "Toshkent davlat transport universiteti",
  },
  {
    label: "Toshkent Davlat Yuridik Universiteti",
    value: "Toshkent Davlat Yuridik Universiteti",
  },
  {
    label: "Toshkent Farmatsevtika Instituti",
    value: "Toshkent Farmatsevtika Instituti",
  },
  {
    label:
      "Toshkent irrigatsiya va qishloq xo'jaligini mexanizatsiyalash muhandislari instituti",
    value:
      "Toshkent irrigatsiya va qishloq xo'jaligini mexanizatsiyalash muhandislari instituti",
  },
  {
    label: "Toshkent Kimyo-Texnologiya Instituti",
    value: "Toshkent Kimyo-Texnologiya Instituti",
  },
  {
    label: "Toshkent Moliya Instituti",
    value: "Toshkent Moliya Instituti",
  },
  {
    label: "Toshkent Pediatriya Tibbiyot Instituti",
    value: "Toshkent Pediatriya Tibbiyot Instituti",
  },
  {
    label: "Toshkent Shahridagi Inha Universiteti",
    value: "Toshkent Shahridagi Inha Universiteti",
  },
  {
    label: "Toshkent Shahridagi Singapur Menejmentni Rivojlantirish Instituti",
    value: "Toshkent Shahridagi Singapur Menejmentni Rivojlantirish Instituti",
  },
  {
    label: "Toshkent Shahridagi Turin Politexnika Universiteti",
    value: "Toshkent Shahridagi Turin Politexnika Universiteti",
  },
  {
    label: "Toshkent Shahridagi Xalqaro Vestminster Universiteti",
    value: "Toshkent Shahridagi Xalqaro Vestminster Universiteti",
  },
  {
    label: "Toshkent Tibbiyot Akademiyasi",
    value: "Toshkent Tibbiyot Akademiyasi",
  },
  {
    label: "Toshkent To'qimachilik va Yengil Sanoat Instituti",
    value: "Toshkent To'qimachilik va Yengil Sanoat Instituti",
  },
  {
    label: "Toshkent viloyati chirchiq davlat pedagogika instituti",
    value: "Toshkent viloyati chirchiq davlat pedagogika instituti",
  },
  {
    label: "Toshkentagi M. V. Lomonosov nomidagi Moskva Davlat Universiteti",
    value: "Toshkentagi M. V. Lomonosov nomidagi Moskva Davlat Universiteti",
  },
  {
    label: "Tottori College of Nursing",
    value: "Tottori College of Nursing",
  },
  {
    label: "Tottori University",
    value: "Tottori University",
  },
  {
    label: "Tottori University of Environmental Studies",
    value: "Tottori University of Environmental Studies",
  },
  {
    label: "Tougaloo College",
    value: "Tougaloo College",
  },
  {
    label: "Toulouse Business School",
    value: "Toulouse Business School",
  },
  {
    label: "Touro University",
    value: "Touro University",
  },
  {
    label: "Touro University Berlin",
    value: "Touro University Berlin",
  },
  {
    label: "Touro University California",
    value: "Touro University California",
  },
  {
    label: "Towson University",
    value: "Towson University",
  },
  {
    label: "Toyama Prefectural University",
    value: "Toyama Prefectural University",
  },
  {
    label: "Toyama University of International Studies",
    value: "Toyama University of International Studies",
  },
  {
    label: "Toyo Eiwa University",
    value: "Toyo Eiwa University",
  },
  {
    label: "Toyo Gakuen University",
    value: "Toyo Gakuen University",
  },
  {
    label: "Toyo University",
    value: "Toyo University",
  },
  {
    label: "Toyohashi Sozo University",
    value: "Toyohashi Sozo University",
  },
  {
    label: "Toyohashi University of Technology",
    value: "Toyohashi University of Technology",
  },
  {
    label: "Toyota Technological Institute",
    value: "Toyota Technological Institute",
  },
  {
    label: "Trakia University",
    value: "Trakia University",
  },
  {
    label: "Trakya Üniversitesi",
    value: "Trakya Üniversitesi",
  },
  {
    label: "Trans-Africa Christian University",
    value: "Trans-Africa Christian University",
  },
  {
    label: "Transbaikal State University",
    value: "Transbaikal State University",
  },
  {
    label: "Transporta un sakaru instituts",
    value: "Transporta un sakaru instituts",
  },
  {
    label: "TransWorld University",
    value: "TransWorld University",
  },
  {
    label: "Transylvania University",
    value: "Transylvania University",
  },
  {
    label: "Trencianska Univerzita Alexandra Dubceka v Trencíne",
    value: "Trencianska Univerzita Alexandra Dubceka v Trencíne",
  },
  {
    label: "Trent University",
    value: "Trent University",
  },
  {
    label: "Trevecca Nazarene University",
    value: "Trevecca Nazarene University",
  },
  {
    label: "Tribhuvan University",
    value: "Tribhuvan University",
  },
  {
    label: "Trine University",
    value: "Trine University",
  },
  {
    label: "Trinity Bible College",
    value: "Trinity Bible College",
  },
  {
    label: "Trinity Christian College",
    value: "Trinity Christian College",
  },
  {
    label: "Trinity College",
    value: "Trinity College",
  },
  {
    label: "Trinity College Dublin, University of Dublin",
    value: "Trinity College Dublin, University of Dublin",
  },
  {
    label: "Trinity College of Florida",
    value: "Trinity College of Florida",
  },
  {
    label: "Trinity College of Nursing & Health Sciences",
    value: "Trinity College of Nursing & Health Sciences",
  },
  {
    label: "Trinity International University",
    value: "Trinity International University",
  },
  {
    label: "Trinity Laban Conservatoire of Music and Dance",
    value: "Trinity Laban Conservatoire of Music and Dance",
  },
  {
    label: "Trinity University",
    value: "Trinity University",
  },
  {
    label: "Trinity University of Asia",
    value: "Trinity University of Asia",
  },
  {
    label: "Trinity University, Zambia",
    value: "Trinity University, Zambia",
  },
  {
    label: "Trinity Washington University",
    value: "Trinity Washington University",
  },
  {
    label: "Trinity Western University",
    value: "Trinity Western University",
  },
  {
    label: "Tripura University",
    value: "Tripura University",
  },
  {
    label: "Tri-State Bible College",
    value: "Tri-State Bible College",
  },
  {
    label: "Trnavská univerzita v Trnave",
    value: "Trnavská univerzita v Trnave",
  },
  {
    label: "Trocaire College",
    value: "Trocaire College",
  },
  {
    label: "Troy University",
    value: "Troy University",
  },
  {
    label: "Truett McConnell University",
    value: "Truett McConnell University",
  },
  {
    label: "Truman Bodden Law School",
    value: "Truman Bodden Law School",
  },
  {
    label: "Truman State University",
    value: "Truman State University",
  },
  {
    label: "Tsetsee Goun Institute of Management",
    value: "Tsetsee Goun Institute of Management",
  },
  {
    label: "Tshwane University of Technology",
    value: "Tshwane University of Technology",
  },
  {
    label: "Tsinghua University",
    value: "Tsinghua University",
  },
  {
    label: "Tsuda University",
    value: "Tsuda University",
  },
  {
    label: "Tsukuba Gakuin University",
    value: "Tsukuba Gakuin University",
  },
  {
    label: "Tsukuba International University",
    value: "Tsukuba International University",
  },
  {
    label: "Tsukuba University of Technology",
    value: "Tsukuba University of Technology",
  },
  {
    label: "Tsuru University",
    value: "Tsuru University",
  },
  {
    label: "Tsuruga Nursing University",
    value: "Tsuruga Nursing University",
  },
  {
    label: "Tsurumi University",
    value: "Tsurumi University",
  },
  {
    label: "Tufts University",
    value: "Tufts University",
  },
  {
    label: "Tula State Pedagogical University",
    value: "Tula State Pedagogical University",
  },
  {
    label: "Tula State University",
    value: "Tula State University",
  },
  {
    label: "Tulane University",
    value: "Tulane University",
  },
  {
    label: "Tumaini University Makumira",
    value: "Tumaini University Makumira",
  },
  {
    label: "Tumkur University",
    value: "Tumkur University",
  },
  {
    label: "Tung Fang Design of University",
    value: "Tung Fang Design of University",
  },
  {
    label: "Tunghai University",
    value: "Tunghai University",
  },
  {
    label: "Tungnan University",
    value: "Tungnan University",
  },
  {
    label: "Tunisia Tech University",
    value: "Tunisia Tech University",
  },
  {
    label: "Turan International University",
    value: "Turan International University",
  },
  {
    label: "Turan University",
    value: "Turan University",
  },
  {
    label: "Turan-Astana University",
    value: "Turan-Astana University",
  },
  {
    label: "Türk Hava Kurumu Üniversitesi",
    value: "Türk Hava Kurumu Üniversitesi",
  },
  {
    label: "Türk-Alman Üniversitesi",
    value: "Türk-Alman Üniversitesi",
  },
  {
    label: "Turkestan Institute of Higher Education",
    value: "Turkestan Institute of Higher Education",
  },
  {
    label: "Turkmen Agricultural University",
    value: "Turkmen Agricultural University",
  },
  {
    label: "Turkmen National Conservatory",
    value: "Turkmen National Conservatory",
  },
  {
    label: "Turkmen State Institute of Architecture and Construction",
    value: "Turkmen State Institute of Architecture and Construction",
  },
  {
    label: "Turkmen State Institute of Culture",
    value: "Turkmen State Institute of Culture",
  },
  {
    label: "Turkmen State Institute of Economics and Management",
    value: "Turkmen State Institute of Economics and Management",
  },
  {
    label: "Turkmen State Institute of Finance",
    value: "Turkmen State Institute of Finance",
  },
  {
    label: "Turkmen State Medical University",
    value: "Turkmen State Medical University",
  },
  {
    label: "Turkmen State Pedagogical Institute",
    value: "Turkmen State Pedagogical Institute",
  },
  {
    label: "Turun ammattikorkeakoulu",
    value: "Turun ammattikorkeakoulu",
  },
  {
    label: "Turun yliopisto",
    value: "Turun yliopisto",
  },
  {
    label: "Tusculum University",
    value: "Tusculum University",
  },
  {
    label: "Tushee Institute",
    value: "Tushee Institute",
  },
  {
    label: "Tuskegee University",
    value: "Tuskegee University",
  },
  {
    label: "Tver State Medical University",
    value: "Tver State Medical University",
  },
  {
    label: "Tver State Technical University",
    value: "Tver State Technical University",
  },
  {
    label: "Tver State University",
    value: "Tver State University",
  },
  {
    label: "Twin Palm Leadership University",
    value: "Twin Palm Leadership University",
  },
  {
    label: "Tyumen State Agricultural Academy",
    value: "Tyumen State Agricultural Academy",
  },
  {
    label: "Tyva State University",
    value: "Tyva State University",
  },
  {
    label: "Tzu Chi University",
    value: "Tzu Chi University",
  },
  {
    label: "Tzu Chi University of Science and Technology",
    value: "Tzu Chi University of Science and Technology",
  },
  {
    label:
      "U.P. Pt. Deen Dayal Upadhyaya Veterinary Science University and Cattle Research Institute",
    value:
      "U.P. Pt. Deen Dayal Upadhyaya Veterinary Science University and Cattle Research Institute",
  },
  {
    label: "U1 University",
    value: "U1 University",
  },
  {
    label: "Ube Frontier University",
    value: "Ube Frontier University",
  },
  {
    label: "Ubon Ratchathani Rajabhat University",
    value: "Ubon Ratchathani Rajabhat University",
  },
  {
    label: "Ubon Ratchathani University",
    value: "Ubon Ratchathani University",
  },
  {
    label: "UC Leuven-Limburg",
    value: "UC Leuven-Limburg",
  },
  {
    label: "UCSI University",
    value: "UCSI University",
  },
  {
    label: "Uczelnia Jana Wyzykowskiego",
    value: "Uczelnia Jana Wyzykowskiego",
  },
  {
    label: "Uczelnia Lazarskiego",
    value: "Uczelnia Lazarskiego",
  },
  {
    label: "Uczelnia Medyczna im. Marii Sklodowskiej - Curie w Warszawie",
    value: "Uczelnia Medyczna im. Marii Sklodowskiej - Curie w Warszawie",
  },
  {
    label: "Uczelnia Techniczno-Handlowa im. Heleny Chodkowskiej",
    value: "Uczelnia Techniczno-Handlowa im. Heleny Chodkowskiej",
  },
  {
    label: "Uczelnie WSB Merito",
    value: "Uczelnie WSB Merito",
  },
  {
    label: "Udmurt State Agrarian University",
    value: "Udmurt State Agrarian University",
  },
  {
    label: "Udmurt State University",
    value: "Udmurt State University",
  },
  {
    label: "Udon Thani Rajabhat University",
    value: "Udon Thani Rajabhat University",
  },
  {
    label: "Uekusa Gakuen University",
    value: "Uekusa Gakuen University",
  },
  {
    label: "Ueno Gakuen University",
    value: "Ueno Gakuen University",
  },
  {
    label: "Ufa State Petroleum Technological University",
    value: "Ufa State Petroleum Technological University",
  },
  {
    label: "Ufa University of Science and Technology",
    value: "Ufa University of Science and Technology",
  },
  {
    label: "Ufuk Üniversitesi",
    value: "Ufuk Üniversitesi",
  },
  {
    label: "Uganda Christian University",
    value: "Uganda Christian University",
  },
  {
    label: "Uganda Martyrs University",
    value: "Uganda Martyrs University",
  },
  {
    label: "Uganda Pentecostal University",
    value: "Uganda Pentecostal University",
  },
  {
    label: "Uganda Technology and Management University",
    value: "Uganda Technology and Management University",
  },
  {
    label: "UGMEX",
    value: "UGMEX",
  },
  {
    label: "Ugra State University",
    value: "Ugra State University",
  },
  {
    label: "Uiduk University",
    value: "Uiduk University",
  },
  {
    label: "UiT Norges arktiske universitet",
    value: "UiT Norges arktiske universitet",
  },
  {
    label: "Uka Tarsadia University",
    value: "Uka Tarsadia University",
  },
  {
    label: "Ukhta State Technical University",
    value: "Ukhta State Technical University",
  },
  {
    label: "Ukraine Sigmund Freud University",
    value: "Ukraine Sigmund Freud University",
  },
  {
    label: "Ukrainian Academy of Printing",
    value: "Ukrainian Academy of Printing",
  },
  {
    label: "Ukrainian Catholic University",
    value: "Ukrainian Catholic University",
  },
  {
    label: "Ukrainian Engineering and Pedagogical Academy",
    value: "Ukrainian Engineering and Pedagogical Academy",
  },
  {
    label: "Ukrainian State University named after Mykhailo Drahomanov",
    value: "Ukrainian State University named after Mykhailo Drahomanov",
  },
  {
    label: "Ukrainian State University of Chemical Technology",
    value: "Ukrainian State University of Chemical Technology",
  },
  {
    label: "Ukrainian State University of Railway Transport",
    value: "Ukrainian State University of Railway Transport",
  },
  {
    label: "Ukrainian State University of Science and Technologies",
    value: "Ukrainian State University of Science and Technologies",
  },
  {
    label: "Ulaanbaatar State University",
    value: "Ulaanbaatar State University",
  },
  {
    label: "Ulaanbaatar University",
    value: "Ulaanbaatar University",
  },
  {
    label: "Ulsan National Institute of Science and Technology",
    value: "Ulsan National Institute of Science and Technology",
  },
  {
    label: "Ulster University",
    value: "Ulster University",
  },
  {
    label: "Uludag Üniversitesi",
    value: "Uludag Üniversitesi",
  },
  {
    label: "Uluslararasi Final Üniversitesi",
    value: "Uluslararasi Final Üniversitesi",
  },
  {
    label: "Uluslararasi Kibris Üniversitesi",
    value: "Uluslararasi Kibris Üniversitesi",
  },
  {
    label: "Uluslararasi Vizyon Üniversitesi",
    value: "Uluslararasi Vizyon Üniversitesi",
  },
  {
    label: "Ulyanovsk State Pedagogical University",
    value: "Ulyanovsk State Pedagogical University",
  },
  {
    label: "Ulyanovsk State Technical University",
    value: "Ulyanovsk State Technical University",
  },
  {
    label: "Ulyanovsk State University",
    value: "Ulyanovsk State University",
  },
  {
    label: "Uman National University of Horticulture",
    value: "Uman National University of Horticulture",
  },
  {
    label: "Uman State Pedagogical University",
    value: "Uman State Pedagogical University",
  },
  {
    label: "Umaru Musa Yar'Adua University",
    value: "Umaru Musa Yar'Adua University",
  },
  {
    label: "UMass Chan Medical School",
    value: "UMass Chan Medical School",
  },
  {
    label: "Umeå universitet",
    value: "Umeå universitet",
  },
  {
    label: "Umm Al Quwain University",
    value: "Umm Al Quwain University",
  },
  {
    label: "Umm Al-Qura University",
    value: "Umm Al-Qura University",
  },
  {
    label: "Umma University",
    value: "Umma University",
  },
  {
    label: "UNICAF University, Malawi",
    value: "UNICAF University, Malawi",
  },
  {
    label: "UniCamillus University",
    value: "UniCamillus University",
  },
  {
    label: "Unicorn University",
    value: "Unicorn University",
  },
  {
    label: "Unidad Central del Valle del Cauca",
    value: "Unidad Central del Valle del Cauca",
  },
  {
    label: "Uniformed Services University of the Health Sciences",
    value: "Uniformed Services University of the Health Sciences",
  },
  {
    label: "UniLaSalle",
    value: "UniLaSalle",
  },
  {
    label: "Unilasallista Corporación Universitaria",
    value: "Unilasallista Corporación Universitaria",
  },
  {
    label: "Union Christian College",
    value: "Union Christian College",
  },
  {
    label: "Union College",
    value: "Union College",
  },
  {
    label: "Union College, Kentucky",
    value: "Union College, Kentucky",
  },
  {
    label: "Union College, Nebraska",
    value: "Union College, Nebraska",
  },
  {
    label: "Union Institute & University",
    value: "Union Institute & University",
  },
  {
    label: "Union University",
    value: "Union University",
  },
  {
    label: "Union University of Science and Technology",
    value: "Union University of Science and Technology",
  },
  {
    label: "UNITAR International University",
    value: "UNITAR International University",
  },
  {
    label: "United African University of Tanzania",
    value: "United African University of Tanzania",
  },
  {
    label: "United Arab Emirates University",
    value: "United Arab Emirates University",
  },
  {
    label: "United International College",
    value: "United International College",
  },
  {
    label: "United International University",
    value: "United International University",
  },
  {
    label: "United Methodist University",
    value: "United Methodist University",
  },
  {
    label: "United States Air Force Academy",
    value: "United States Air Force Academy",
  },
  {
    label: "United States Coast Guard Academy",
    value: "United States Coast Guard Academy",
  },
  {
    label: "United States International University Africa",
    value: "United States International University Africa",
  },
  {
    label: "United States Merchant Marine Academy",
    value: "United States Merchant Marine Academy",
  },
  {
    label: "United States Military Academy",
    value: "United States Military Academy",
  },
  {
    label: "United States Naval Academy",
    value: "United States Naval Academy",
  },
  {
    label: "United States Sports Academy",
    value: "United States Sports Academy",
  },
  {
    label: "United States University",
    value: "United States University",
  },
  {
    label: "Unity Environmental University",
    value: "Unity Environmental University",
  },
  {
    label: "Unity University",
    value: "Unity University",
  },
  {
    label: "Universidad Abat Oliba CEU",
    value: "Universidad Abat Oliba CEU",
  },
  {
    label: "Universidad Abierta Interamericana",
    value: "Universidad Abierta Interamericana",
  },
  {
    label: "Universidad Academia de Humanismo Cristiano",
    value: "Universidad Academia de Humanismo Cristiano",
  },
  {
    label: "Universidad Adolfo Ibañez",
    value: "Universidad Adolfo Ibañez",
  },
  {
    label: "Universidad Adventista de Bolivia",
    value: "Universidad Adventista de Bolivia",
  },
  {
    label: "Universidad Adventista de Centro América",
    value: "Universidad Adventista de Centro América",
  },
  {
    label: "Universidad Adventista de Chile",
    value: "Universidad Adventista de Chile",
  },
  {
    label: "Universidad Adventista de las Antillas",
    value: "Universidad Adventista de las Antillas",
  },
  {
    label: "Universidad Adventista de Nicaragua",
    value: "Universidad Adventista de Nicaragua",
  },
  {
    label: "Universidad Adventista del Plata",
    value: "Universidad Adventista del Plata",
  },
  {
    label: "Universidad Adventista Dominicana",
    value: "Universidad Adventista Dominicana",
  },
  {
    label: "Universidad Agraria de La Habana Fructuoso Rodríguez Pérez",
    value: "Universidad Agraria de La Habana Fructuoso Rodríguez Pérez",
  },
  {
    label: "Universidad Agraria del Ecuador",
    value: "Universidad Agraria del Ecuador",
  },
  {
    label: "Universidad Agroforestal Fernando Arturo de Meriño",
    value: "Universidad Agroforestal Fernando Arturo de Meriño",
  },
  {
    label: "Universidad Alas Peruanas",
    value: "Universidad Alas Peruanas",
  },
  {
    label: "Universidad Albert Einstein",
    value: "Universidad Albert Einstein",
  },
  {
    label: "Universidad Albert Einstein, Mexico",
    value: "Universidad Albert Einstein, Mexico",
  },
  {
    label: "Universidad Alberto Hurtado",
    value: "Universidad Alberto Hurtado",
  },
  {
    label: "Universidad Albizu",
    value: "Universidad Albizu",
  },
  {
    label: "Universidad Alejandro de Humboldt",
    value: "Universidad Alejandro de Humboldt",
  },
  {
    label: "Universidad Alfonso X el Sabio",
    value: "Universidad Alfonso X el Sabio",
  },
  {
    label: "Universidad Alonso de Ojeda",
    value: "Universidad Alonso de Ojeda",
  },
  {
    label: "Universidad Alva Edison",
    value: "Universidad Alva Edison",
  },
  {
    label: "Universidad Alzate de Ozumba",
    value: "Universidad Alzate de Ozumba",
  },
  {
    label: "Universidad Amazónica de Pando",
    value: "Universidad Amazónica de Pando",
  },
  {
    label: "Universidad American College",
    value: "Universidad American College",
  },
  {
    label: "Universidad Americana",
    value: "Universidad Americana",
  },
  {
    label: "Universidad Americana de Acapulco",
    value: "Universidad Americana de Acapulco",
  },
  {
    label: "Universidad Americana, Costa Rica",
    value: "Universidad Americana, Costa Rica",
  },
  {
    label: "Universidad Americana, Nicaragua",
    value: "Universidad Americana, Nicaragua",
  },
  {
    label: "Universidad Americana, Panama",
    value: "Universidad Americana, Panama",
  },
  {
    label: "Universidad Ana G. Méndez, Recinto de Carolina",
    value: "Universidad Ana G. Méndez, Recinto de Carolina",
  },
  {
    label: "Universidad Ana G. Méndez, Recinto de Cupey",
    value: "Universidad Ana G. Méndez, Recinto de Cupey",
  },
  {
    label: "Universidad Ana G. Méndez, Recinto de Gurabo",
    value: "Universidad Ana G. Méndez, Recinto de Gurabo",
  },
  {
    label: "Universidad Anáhuac Cancún",
    value: "Universidad Anáhuac Cancún",
  },
  {
    label: "Universidad Anáhuac de Oaxaca",
    value: "Universidad Anáhuac de Oaxaca",
  },
  {
    label: "Universidad Anáhuac de Xalapa",
    value: "Universidad Anáhuac de Xalapa",
  },
  {
    label: "Universidad Anáhuac Mayab",
    value: "Universidad Anáhuac Mayab",
  },
  {
    label: "Universidad Anáhuac México Norte",
    value: "Universidad Anáhuac México Norte",
  },
  {
    label: "Universidad Anáhuac México Sur",
    value: "Universidad Anáhuac México Sur",
  },
  {
    label: "Universidad Anáhuac Puebla",
    value: "Universidad Anáhuac Puebla",
  },
  {
    label: "Universidad Anáhuac Querétaro",
    value: "Universidad Anáhuac Querétaro",
  },
  {
    label: "Universidad Andina del Cusco",
    value: "Universidad Andina del Cusco",
  },
  {
    label: "Universidad Andina Néstor Cáceres Velásquez",
    value: "Universidad Andina Néstor Cáceres Velásquez",
  },
  {
    label: "Universidad Andina Simón Bolivar",
    value: "Universidad Andina Simón Bolivar",
  },
  {
    label: "Universidad Andina Simón Bolívar, Ecuador",
    value: "Universidad Andina Simón Bolívar, Ecuador",
  },
  {
    label: "Universidad Andrés Bello",
    value: "Universidad Andrés Bello",
  },
  {
    label: "Universidad Antonio de Nebrija",
    value: "Universidad Antonio de Nebrija",
  },
  {
    label: "Universidad Antonio Nariño",
    value: "Universidad Antonio Nariño",
  },
  {
    label: "Universidad Antonio Ruiz de Montoya",
    value: "Universidad Antonio Ruiz de Montoya",
  },
  {
    label: "Universidad Anunciata",
    value: "Universidad Anunciata",
  },
  {
    label: "Universidad APEC",
    value: "Universidad APEC",
  },
  {
    label: "Universidad Argentina de la Empresa",
    value: "Universidad Argentina de la Empresa",
  },
  {
    label: "Universidad Argentina John F. Kennedy",
    value: "Universidad Argentina John F. Kennedy",
  },
  {
    label: "Universidad Arturo Michelena",
    value: "Universidad Arturo Michelena",
  },
  {
    label: "Universidad Arturo Prat",
    value: "Universidad Arturo Prat",
  },
  {
    label: "Universidad Arzobispo Loayza",
    value: "Universidad Arzobispo Loayza",
  },
  {
    label: "Universidad Ateneo de Monterrey",
    value: "Universidad Ateneo de Monterrey",
  },
  {
    label: "Universidad Atlántida Argentina",
    value: "Universidad Atlántida Argentina",
  },
  {
    label: "Universidad Austral",
    value: "Universidad Austral",
  },
  {
    label: "Universidad Austral de Chile",
    value: "Universidad Austral de Chile",
  },
  {
    label: "Universidad Autónoma Agraria Antonio Narro",
    value: "Universidad Autónoma Agraria Antonio Narro",
  },
  {
    label: "Universidad Autónoma Benito Juárez de Oaxaca",
    value: "Universidad Autónoma Benito Juárez de Oaxaca",
  },
  {
    label: "Universidad Autónoma de Aguascalientes",
    value: "Universidad Autónoma de Aguascalientes",
  },
  {
    label: "Universidad Autónoma de Asunción",
    value: "Universidad Autónoma de Asunción",
  },
  {
    label: "Universidad Autónoma de Baja California",
    value: "Universidad Autónoma de Baja California",
  },
  {
    label: "Universidad Autónoma de Baja California Sur",
    value: "Universidad Autónoma de Baja California Sur",
  },
  {
    label: "Universidad Autónoma de Barcelona",
    value: "Universidad Autónoma de Barcelona",
  },
  {
    label: "Universidad Autónoma de Bucaramanga",
    value: "Universidad Autónoma de Bucaramanga",
  },
  {
    label: "Universidad Autónoma de Campeche",
    value: "Universidad Autónoma de Campeche",
  },
  {
    label: "Universidad Autónoma de Centro América",
    value: "Universidad Autónoma de Centro América",
  },
  {
    label: "Universidad Autónoma de Chapingo",
    value: "Universidad Autónoma de Chapingo",
  },
  {
    label: "Universidad Autónoma de Chiapas",
    value: "Universidad Autónoma de Chiapas",
  },
  {
    label: "Universidad Autónoma de Chihuahua",
    value: "Universidad Autónoma de Chihuahua",
  },
  {
    label: "Universidad Autónoma de Chile",
    value: "Universidad Autónoma de Chile",
  },
  {
    label: "Universidad Autonoma de Chinandega",
    value: "Universidad Autonoma de Chinandega",
  },
  {
    label: "Universidad Autonoma de Chiriqui",
    value: "Universidad Autonoma de Chiriqui",
  },
  {
    label: "Universidad Autónoma de Ciudad Juárez",
    value: "Universidad Autónoma de Ciudad Juárez",
  },
  {
    label: "Universidad Autónoma de Coahuila",
    value: "Universidad Autónoma de Coahuila",
  },
  {
    label: "Universidad Autónoma de Colombia",
    value: "Universidad Autónoma de Colombia",
  },
  {
    label: "Universidad Autónoma de Durango",
    value: "Universidad Autónoma de Durango",
  },
  {
    label: "Universidad Autónoma de Encarnación",
    value: "Universidad Autónoma de Encarnación",
  },
  {
    label: "Universidad Autónoma de Entre Ríos",
    value: "Universidad Autónoma de Entre Ríos",
  },
  {
    label: "Universidad Autónoma de Fresnillo",
    value: "Universidad Autónoma de Fresnillo",
  },
  {
    label: "Universidad Autónoma de Guadalajara",
    value: "Universidad Autónoma de Guadalajara",
  },
  {
    label: "Universidad Autónoma de Guerrero",
    value: "Universidad Autónoma de Guerrero",
  },
  {
    label: "Universidad Autónoma de Ica",
    value: "Universidad Autónoma de Ica",
  },
  {
    label: "Universidad Autónoma de la Ciudad de México",
    value: "Universidad Autónoma de la Ciudad de México",
  },
  {
    label: "Universidad Autónoma de la Laguna",
    value: "Universidad Autónoma de la Laguna",
  },
  {
    label: "Universidad Autónoma de Luque",
    value: "Universidad Autónoma de Luque",
  },
  {
    label: "Universidad Autónoma de Madrid",
    value: "Universidad Autónoma de Madrid",
  },
  {
    label: "Universidad Autónoma de Manizales",
    value: "Universidad Autónoma de Manizales",
  },
  {
    label: "Universidad Autónoma de Nayarit",
    value: "Universidad Autónoma de Nayarit",
  },
  {
    label: "Universidad Autónoma de Nuevo León",
    value: "Universidad Autónoma de Nuevo León",
  },
  {
    label: "Universidad Autónoma de Occidente",
    value: "Universidad Autónoma de Occidente",
  },
  {
    label: "Universidad Autónoma de Occidente",
    value: "Universidad Autónoma de Occidente",
  },
  {
    label: "Universidad Autónoma de Piedras Negras",
    value: "Universidad Autónoma de Piedras Negras",
  },
  {
    label: "Universidad Autónoma de Querétaro",
    value: "Universidad Autónoma de Querétaro",
  },
  {
    label: "Universidad Autónoma de San Luis Potosí",
    value: "Universidad Autónoma de San Luis Potosí",
  },
  {
    label: "Universidad Autónoma de Santa Ana",
    value: "Universidad Autónoma de Santa Ana",
  },
  {
    label: "Universidad Autónoma de Santo Domingo",
    value: "Universidad Autónoma de Santo Domingo",
  },
  {
    label: "Universidad Autónoma de Sinaloa",
    value: "Universidad Autónoma de Sinaloa",
  },
  {
    label: "Universidad Autónoma de Tamaulipas",
    value: "Universidad Autónoma de Tamaulipas",
  },
  {
    label: "Universidad Autónoma de Tlaxcala",
    value: "Universidad Autónoma de Tlaxcala",
  },
  {
    label: "Universidad Autónoma de Yucatán",
    value: "Universidad Autónoma de Yucatán",
  },
  {
    label: "Universidad Autónoma de Zacatecas",
    value: "Universidad Autónoma de Zacatecas",
  },
  {
    label: "Universidad Autónoma del Beni",
    value: "Universidad Autónoma del Beni",
  },
  {
    label: "Universidad Autónoma del Caribe",
    value: "Universidad Autónoma del Caribe",
  },
  {
    label: "Universidad Autónoma del Carmen",
    value: "Universidad Autónoma del Carmen",
  },
  {
    label: "Universidad Autónoma del Estado de Hidalgo",
    value: "Universidad Autónoma del Estado de Hidalgo",
  },
  {
    label: "Universidad Autónoma del Estado de México",
    value: "Universidad Autónoma del Estado de México",
  },
  {
    label: "Universidad Autónoma del Estado de Morelos",
    value: "Universidad Autónoma del Estado de Morelos",
  },
  {
    label: "Universidad Autónoma del Noreste",
    value: "Universidad Autónoma del Noreste",
  },
  {
    label: "Universidad Autónoma del Paraguay",
    value: "Universidad Autónoma del Paraguay",
  },
  {
    label: "Universidad Autónoma del Perú",
    value: "Universidad Autónoma del Perú",
  },
  {
    label: "Universidad Autónoma Gabriel René Moreno",
    value: "Universidad Autónoma Gabriel René Moreno",
  },
  {
    label: "Universidad Autónoma Indígena Intercultural",
    value: "Universidad Autónoma Indígena Intercultural",
  },
  {
    label: "Universidad Autónoma Intercultural de Sinaloa",
    value: "Universidad Autónoma Intercultural de Sinaloa",
  },
  {
    label: "Universidad Autónoma Juan Misael Saracho",
    value: "Universidad Autónoma Juan Misael Saracho",
  },
  {
    label: "Universidad Autónoma Latinoamericana",
    value: "Universidad Autónoma Latinoamericana",
  },
  {
    label: "Universidad Autónoma Metropolitana",
    value: "Universidad Autónoma Metropolitana",
  },
  {
    label: "Universidad Autónoma Municipal de Los Olivos",
    value: "Universidad Autónoma Municipal de Los Olivos",
  },
  {
    label: "Universidad Autónoma San Francisco",
    value: "Universidad Autónoma San Francisco",
  },
  {
    label: "Universidad Autónoma San Sebastián",
    value: "Universidad Autónoma San Sebastián",
  },
  {
    label: "Universidad Autónoma Tomás Frías",
    value: "Universidad Autónoma Tomás Frías",
  },
  {
    label: "Universidad Benito Juarez",
    value: "Universidad Benito Juarez",
  },
  {
    label: "Universidad Bernardo O'Higgins",
    value: "Universidad Bernardo O'Higgins",
  },
  {
    label: "Universidad Bethesda",
    value: "Universidad Bethesda",
  },
  {
    label: "Universidad Bíblica Latinoamericana",
    value: "Universidad Bíblica Latinoamericana",
  },
  {
    label: "Universidad Bicentenaria de Aragua",
    value: "Universidad Bicentenaria de Aragua",
  },
  {
    label: "Universidad Blas Pascal",
    value: "Universidad Blas Pascal",
  },
  {
    label: "Universidad Bolivariana",
    value: "Universidad Bolivariana",
  },
  {
    label: "Universidad Bolivariana de Trabajadores Jesús Rivero",
    value: "Universidad Bolivariana de Trabajadores Jesús Rivero",
  },
  {
    label: "Universidad Bolivariana de Venezuela",
    value: "Universidad Bolivariana de Venezuela",
  },
  {
    label: "Universidad Boliviana de Informática",
    value: "Universidad Boliviana de Informática",
  },
  {
    label: "Universidad Braulio Carrillo",
    value: "Universidad Braulio Carrillo",
  },
  {
    label: "Universidad CAECE",
    value: "Universidad CAECE",
  },
  {
    label: "Universidad Camilo José Cela",
    value: "Universidad Camilo José Cela",
  },
  {
    label: "Universidad Campesina de Venezuela Argimiro Gabaldón",
    value: "Universidad Campesina de Venezuela Argimiro Gabaldón",
  },
  {
    label: "Universidad Capitán General Gerardo Barrios",
    value: "Universidad Capitán General Gerardo Barrios",
  },
  {
    label: "Universidad Carlos III de Madrid",
    value: "Universidad Carlos III de Madrid",
  },
  {
    label: "Universidad Casa Grande",
    value: "Universidad Casa Grande",
  },
  {
    label: "Universidad Castro Carazo",
    value: "Universidad Castro Carazo",
  },
  {
    label: "Universidad Católica Andres Bello",
    value: "Universidad Católica Andres Bello",
  },
  {
    label: "Universidad Católica Boliviana",
    value: "Universidad Católica Boliviana",
  },
  {
    label: "Universidad Católica Cecilio Acosta",
    value: "Universidad Católica Cecilio Acosta",
  },
  {
    label: "Universidad Católica de Ávila",
    value: "Universidad Católica de Ávila",
  },
  {
    label: "Universidad Católica de Colombia",
    value: "Universidad Católica de Colombia",
  },
  {
    label: "Universidad Católica de Córdoba",
    value: "Universidad Católica de Córdoba",
  },
  {
    label: "Universidad Católica de Costa Rica",
    value: "Universidad Católica de Costa Rica",
  },
  {
    label: "Universidad Catolica de Cuenca",
    value: "Universidad Catolica de Cuenca",
  },
  {
    label: "Universidad Catolica de Culiacan A.C.",
    value: "Universidad Catolica de Culiacan A.C.",
  },
  {
    label: "Universidad Católica de Cuyo",
    value: "Universidad Católica de Cuyo",
  },
  {
    label: "Universidad Católica de El Salvador",
    value: "Universidad Católica de El Salvador",
  },
  {
    label: "Universidad Catolica de Honduras",
    value: "Universidad Catolica de Honduras",
  },
  {
    label: "Universidad Católica de La Plata",
    value: "Universidad Católica de La Plata",
  },
  {
    label: "Universidad Católica de la Santísima Concepción",
    value: "Universidad Católica de la Santísima Concepción",
  },
  {
    label: "Universidad Católica de las Misiones",
    value: "Universidad Católica de las Misiones",
  },
  {
    label: "Universidad Católica de Manizales",
    value: "Universidad Católica de Manizales",
  },
  {
    label: "Universidad Católica de Oriente",
    value: "Universidad Católica de Oriente",
  },
  {
    label: "Universidad Católica de Pereira",
    value: "Universidad Católica de Pereira",
  },
  {
    label: "Universidad Católica de Salta",
    value: "Universidad Católica de Salta",
  },
  {
    label: "Universidad Católica de Santa Fe",
    value: "Universidad Católica de Santa Fe",
  },
  {
    label: "Universidad Católica de Santa María",
    value: "Universidad Católica de Santa María",
  },
  {
    label: "Universidad Católica de Santiago de Guayaquil",
    value: "Universidad Católica de Santiago de Guayaquil",
  },
  {
    label: "Universidad Católica de Santiago del Estero",
    value: "Universidad Católica de Santiago del Estero",
  },
  {
    label: "Universidad Católica de Temuco",
    value: "Universidad Católica de Temuco",
  },
  {
    label: "Universidad Católica de Trujillo Benedicto XVI",
    value: "Universidad Católica de Trujillo Benedicto XVI",
  },
  {
    label: "Universidad Católica de Valencia San Vicente Màrtir",
    value: "Universidad Católica de Valencia San Vicente Màrtir",
  },
  {
    label: "Universidad Católica del Cibao",
    value: "Universidad Católica del Cibao",
  },
  {
    label: "Universidad Católica del Este",
    value: "Universidad Católica del Este",
  },
  {
    label: "Universidad Católica del Maule",
    value: "Universidad Católica del Maule",
  },
  {
    label: "Universidad Católica del Norte",
    value: "Universidad Católica del Norte",
  },
  {
    label: "Universidad Católica del Táchira",
    value: "Universidad Católica del Táchira",
  },
  {
    label: "Universidad Católica del Uruguay",
    value: "Universidad Católica del Uruguay",
  },
  {
    label:
      "Universidad Católica Inmaculada Concepción de la Arquidiócesis de Managua",
    value:
      "Universidad Católica Inmaculada Concepción de la Arquidiócesis de Managua",
  },
  {
    label: "Universidad Católica Juan Pablo II",
    value: "Universidad Católica Juan Pablo II",
  },
  {
    label: "Universidad Católica Los Ángeles de Chimbote",
    value: "Universidad Católica Los Ángeles de Chimbote",
  },
  {
    label: "Universidad Católica Luis Amigó",
    value: "Universidad Católica Luis Amigó",
  },
  {
    label: "Universidad Católica Nordestana",
    value: "Universidad Católica Nordestana",
  },
  {
    label: "Universidad Católica Nuestra Señora de la Asunción",
    value: "Universidad Católica Nuestra Señora de la Asunción",
  },
  {
    label: "Universidad Catolica Redemptoris Mater",
    value: "Universidad Catolica Redemptoris Mater",
  },
  {
    label: "Universidad Católica San Antonio de Murcia",
    value: "Universidad Católica San Antonio de Murcia",
  },
  {
    label: "Universidad Católica San Pablo",
    value: "Universidad Católica San Pablo",
  },
  {
    label: "Universidad Católica Santa María La Antigua",
    value: "Universidad Católica Santa María La Antigua",
  },
  {
    label: "Universidad Católica Santa Rosa",
    value: "Universidad Católica Santa Rosa",
  },
  {
    label: "Universidad Católica Santo Domingo",
    value: "Universidad Católica Santo Domingo",
  },
  {
    label: "Universidad Católica Santo Toribio de Mogrovejo",
    value: "Universidad Católica Santo Toribio de Mogrovejo",
  },
  {
    label: "Universidad Católica Sedes Sapientiae",
    value: "Universidad Católica Sedes Sapientiae",
  },
  {
    label: "Universidad Católica Silva Henriquez",
    value: "Universidad Católica Silva Henriquez",
  },
  {
    label: "Universidad Católica Tecnológica de Barahona",
    value: "Universidad Católica Tecnológica de Barahona",
  },
  {
    label: "Universidad Cenfotec",
    value: "Universidad Cenfotec",
  },
  {
    label: "Universidad Central",
    value: "Universidad Central",
  },
  {
    label: "Universidad Central de Bayamón",
    value: "Universidad Central de Bayamón",
  },
  {
    label: "Universidad Central de Chile",
    value: "Universidad Central de Chile",
  },
  {
    label: "Universidad Central de Nicaragua",
    value: "Universidad Central de Nicaragua",
  },
  {
    label: "Universidad Central de Venezuela",
    value: "Universidad Central de Venezuela",
  },
  {
    label: "Universidad Central del Caribe",
    value: "Universidad Central del Caribe",
  },
  {
    label: "Universidad Central del Ecuador",
    value: "Universidad Central del Ecuador",
  },
  {
    label: "Universidad Central del Este",
    value: "Universidad Central del Este",
  },
  {
    label: "Universidad Central Marta Abreu de Las Villas",
    value: "Universidad Central Marta Abreu de Las Villas",
  },
  {
    label: "Universidad Central, Bolivia",
    value: "Universidad Central, Bolivia",
  },
  {
    label: "Universidad Central, Costa Rica",
    value: "Universidad Central, Costa Rica",
  },
  {
    label: "Universidad Centro Médico Bautista",
    value: "Universidad Centro Médico Bautista",
  },
  {
    label: "Universidad Centro Occidental Lisandro Alvarado",
    value: "Universidad Centro Occidental Lisandro Alvarado",
  },
  {
    label: "Universidad Centroamericana",
    value: "Universidad Centroamericana",
  },
  {
    label: "Universidad Centroamericana de Ciencias Empresariales",
    value: "Universidad Centroamericana de Ciencias Empresariales",
  },
  {
    label: "Universidad Centroamericana de Ciencias Sociales",
    value: "Universidad Centroamericana de Ciencias Sociales",
  },
  {
    label: "Universidad Centroamericana José Simeón Cañas",
    value: "Universidad Centroamericana José Simeón Cañas",
  },
  {
    label: "Universidad CES",
    value: "Universidad CES",
  },
  {
    label: "Universidad César Vallejo",
    value: "Universidad César Vallejo",
  },
  {
    label: "Universidad CESMAG",
    value: "Universidad CESMAG",
  },
  {
    label: "Universidad CEU Cardenal Herrera",
    value: "Universidad CEU Cardenal Herrera",
  },
  {
    label: "Universidad CEU San Pablo",
    value: "Universidad CEU San Pablo",
  },
  {
    label: "Universidad Champagnat",
    value: "Universidad Champagnat",
  },
  {
    label: "Universidad Chapultepéc A.C.",
    value: "Universidad Chapultepéc A.C.",
  },
  {
    label: "Universidad Ciencias de la Salud",
    value: "Universidad Ciencias de la Salud",
  },
  {
    label: "Universidad Científica del Perú",
    value: "Universidad Científica del Perú",
  },
  {
    label: "Universidad Cientifica del Sur",
    value: "Universidad Cientifica del Sur",
  },
  {
    label: "Universidad Cientifica Latino Americana de Hidalgo",
    value: "Universidad Cientifica Latino Americana de Hidalgo",
  },
  {
    label: "Universidad Colegio Mayor de Cundinamarca",
    value: "Universidad Colegio Mayor de Cundinamarca",
  },
  {
    label: "Universidad Columbia del Paraguay",
    value: "Universidad Columbia del Paraguay",
  },
  {
    label: "Universidad Complutense de Madrid",
    value: "Universidad Complutense de Madrid",
  },
  {
    label: "Universidad Comunera",
    value: "Universidad Comunera",
  },
  {
    label: "Universidad Continental",
    value: "Universidad Continental",
  },
  {
    label: "Universidad Continental de las Ciencias y las Artes",
    value: "Universidad Continental de las Ciencias y las Artes",
  },
  {
    label: "Universidad Continental Justo Sierra",
    value: "Universidad Continental Justo Sierra",
  },
  {
    label: "Universidad Cooperativa de Colombia",
    value: "Universidad Cooperativa de Colombia",
  },
  {
    label: "Universidad Creativa",
    value: "Universidad Creativa",
  },
  {
    label: "Universidad Cristiana Autónoma de Nicaragua",
    value: "Universidad Cristiana Autónoma de Nicaragua",
  },
  {
    label: "Universidad Cristiana de Bolivia",
    value: "Universidad Cristiana de Bolivia",
  },
  {
    label: "Universidad Cristiana de las Asambleas de Dios",
    value: "Universidad Cristiana de las Asambleas de Dios",
  },
  {
    label: "Universidad Cristiana de Panamá",
    value: "Universidad Cristiana de Panamá",
  },
  {
    label: "Universidad Cristiana Evangélica Nuevo Milenio",
    value: "Universidad Cristiana Evangélica Nuevo Milenio",
  },
  {
    label: "Universidad Cristóbal Colón",
    value: "Universidad Cristóbal Colón",
  },
  {
    label: "Universidad Cuauhnáhuac",
    value: "Universidad Cuauhnáhuac",
  },
  {
    label: "Universidad Cuauhtémoc",
    value: "Universidad Cuauhtémoc",
  },
  {
    label: "Universidad Da Vinci de Guatemala",
    value: "Universidad Da Vinci de Guatemala",
  },
  {
    label: "Universidad de Aconcagua",
    value: "Universidad de Aconcagua",
  },
  {
    label: "Universidad de Administración, Comercio y Aduana",
    value: "Universidad de Administración, Comercio y Aduana",
  },
  {
    label: "Universidad de Alcalá",
    value: "Universidad de Alcalá",
  },
  {
    label: "Universidad de Alicante",
    value: "Universidad de Alicante",
  },
  {
    label: "Universidad de Almería",
    value: "Universidad de Almería",
  },
  {
    label: "Universidad de América",
    value: "Universidad de América",
  },
  {
    label: "Universidad de Antioquía",
    value: "Universidad de Antioquía",
  },
  {
    label: "Universidad de Antofagasta",
    value: "Universidad de Antofagasta",
  },
  {
    label: "Universidad de Aquino Bolivia",
    value: "Universidad de Aquino Bolivia",
  },
  {
    label: "Universidad de Artemisa",
    value: "Universidad de Artemisa",
  },
  {
    label: "Universidad de Artes, Ciencias y Comunicación",
    value: "Universidad de Artes, Ciencias y Comunicación",
  },
  {
    label: "Universidad de Atacama",
    value: "Universidad de Atacama",
  },
  {
    label: "Universidad de Ayacucho Federico Froebel",
    value: "Universidad de Ayacucho Federico Froebel",
  },
  {
    label: "Universidad de Aysén",
    value: "Universidad de Aysén",
  },
  {
    label: "Universidad de Barcelona",
    value: "Universidad de Barcelona",
  },
  {
    label: "Universidad de Belgrano",
    value: "Universidad de Belgrano",
  },
  {
    label: "Universidad de Bogotá Jorge Tadeo Lozano",
    value: "Universidad de Bogotá Jorge Tadeo Lozano",
  },
  {
    label: "Universidad de Boyacá",
    value: "Universidad de Boyacá",
  },
  {
    label: "Universidad de Buenos Aires",
    value: "Universidad de Buenos Aires",
  },
  {
    label: "Universidad de Burgos",
    value: "Universidad de Burgos",
  },
  {
    label: "Universidad de Cádiz",
    value: "Universidad de Cádiz",
  },
  {
    label: "Universidad de Caldas",
    value: "Universidad de Caldas",
  },
  {
    label: "Universidad de Camagüey Ignacio Agramonte Loynaz",
    value: "Universidad de Camagüey Ignacio Agramonte Loynaz",
  },
  {
    label: "Universidad de Cantabria",
    value: "Universidad de Cantabria",
  },
  {
    label: "Universidad de Carabobo",
    value: "Universidad de Carabobo",
  },
  {
    label: "Universidad de Cartagena",
    value: "Universidad de Cartagena",
  },
  {
    label: "Universidad de Cartago Florencio del Castillo",
    value: "Universidad de Cartago Florencio del Castillo",
  },
  {
    label: "Universidad de Castilla-La Mancha",
    value: "Universidad de Castilla-La Mancha",
  },
  {
    label: "Universidad de Celaya",
    value: "Universidad de Celaya",
  },
  {
    label: "Universidad de Chile",
    value: "Universidad de Chile",
  },
  {
    label: "Universidad de Ciego de Ávila Máximo Gómez Báez",
    value: "Universidad de Ciego de Ávila Máximo Gómez Báez",
  },
  {
    label: "Universidad de Ciencias Aplicadas y Ambientales",
    value: "Universidad de Ciencias Aplicadas y Ambientales",
  },
  {
    label: "Universidad de Ciencias Comerciales",
    value: "Universidad de Ciencias Comerciales",
  },
  {
    label:
      "Universidad de Ciencias de la Cultura Física y el Deporte Manuel Fajardo",
    value:
      "Universidad de Ciencias de la Cultura Física y el Deporte Manuel Fajardo",
  },
  {
    label: "Universidad de Ciencias de la Salud",
    value: "Universidad de Ciencias de la Salud",
  },
  {
    label: "Universidad de Ciencias de la Salud y Energías Renovables",
    value: "Universidad de Ciencias de la Salud y Energías Renovables",
  },
  {
    label: "Universidad de Ciencias Empresariales",
    value: "Universidad de Ciencias Empresariales",
  },
  {
    label: "Universidad de Ciencias Empresariales y Sociales",
    value: "Universidad de Ciencias Empresariales y Sociales",
  },
  {
    label: "Universidad de Ciencias Médicas de Camagüey",
    value: "Universidad de Ciencias Médicas de Camagüey",
  },
  {
    label: "Universidad de Ciencias Médicas de Ciego de Ávila",
    value: "Universidad de Ciencias Médicas de Ciego de Ávila",
  },
  {
    label: "Universidad de Ciencias Médicas de Granma",
    value: "Universidad de Ciencias Médicas de Granma",
  },
  {
    label: "Universidad de Ciencias Médicas de Guantánamo",
    value: "Universidad de Ciencias Médicas de Guantánamo",
  },
  {
    label: "Universidad de Ciencias Médicas de Holguín",
    value: "Universidad de Ciencias Médicas de Holguín",
  },
  {
    label: "Universidad de Ciencias Médicas de La Habana",
    value: "Universidad de Ciencias Médicas de La Habana",
  },
  {
    label: "Universidad de Ciencias Médicas de Las Tunas",
    value: "Universidad de Ciencias Médicas de Las Tunas",
  },
  {
    label: "Universidad de Ciencias Médicas de Matanzas",
    value: "Universidad de Ciencias Médicas de Matanzas",
  },
  {
    label: "Universidad de Ciencias Médicas de Pinar del Río",
    value: "Universidad de Ciencias Médicas de Pinar del Río",
  },
  {
    label: "Universidad de Ciencias Médicas de Sancti Spíritus",
    value: "Universidad de Ciencias Médicas de Sancti Spíritus",
  },
  {
    label: "Universidad de Ciencias Médicas de Santiago de Cuba",
    value: "Universidad de Ciencias Médicas de Santiago de Cuba",
  },
  {
    label: "Universidad de Ciencias Médicas de Villa Clara",
    value: "Universidad de Ciencias Médicas de Villa Clara",
  },
  {
    label: "Universidad de Ciencias Médicas, Cienfuegos",
    value: "Universidad de Ciencias Médicas, Cienfuegos",
  },
  {
    label: "Universidad de Ciencias Médicas, Costa Rica",
    value: "Universidad de Ciencias Médicas, Costa Rica",
  },
  {
    label: "Universidad de Ciencias Médicas, Nicaragua",
    value: "Universidad de Ciencias Médicas, Nicaragua",
  },
  {
    label: "Universidad de Ciencias Pedagógicas Enrique José Varona",
    value: "Universidad de Ciencias Pedagógicas Enrique José Varona",
  },
  {
    label: "Universidad de Ciencias Pedagógicas Félix Varela Morales",
    value: "Universidad de Ciencias Pedagógicas Félix Varela Morales",
  },
  {
    label: "Universidad de Ciencias Pedagógicas Frank País García",
    value: "Universidad de Ciencias Pedagógicas Frank País García",
  },
  {
    label: "Universidad de Ciencias Pedagógicas Héctor Alfredo Pineda Zaldívar",
    value: "Universidad de Ciencias Pedagógicas Héctor Alfredo Pineda Zaldívar",
  },
  {
    label: "Universidad de Ciencias Pedagógicas José de la Luz y Caballero",
    value: "Universidad de Ciencias Pedagógicas José de la Luz y Caballero",
  },
  {
    label: "Universidad de Ciencias Pedagógicas Pepito Tey",
    value: "Universidad de Ciencias Pedagógicas Pepito Tey",
  },
  {
    label: "Universidad de Ciencias y Artes de América Latina",
    value: "Universidad de Ciencias y Artes de América Latina",
  },
  {
    label: "Universidad de Ciencias y Artes de Chiapas",
    value: "Universidad de Ciencias y Artes de Chiapas",
  },
  {
    label: "Universidad de Ciencias y Humanidades",
    value: "Universidad de Ciencias y Humanidades",
  },
  {
    label: "Universidad de Cienfuegos Carlos Rafael Rodríguez",
    value: "Universidad de Cienfuegos Carlos Rafael Rodríguez",
  },
  {
    label: "Universidad de Colima",
    value: "Universidad de Colima",
  },
  {
    label: "Universidad de Comunicación Avanzada",
    value: "Universidad de Comunicación Avanzada",
  },
  {
    label: "Universidad de Concepción",
    value: "Universidad de Concepción",
  },
  {
    label: "Universidad de Concepción del Uruguay",
    value: "Universidad de Concepción del Uruguay",
  },
  {
    label: "Universidad de Congreso",
    value: "Universidad de Congreso",
  },
  {
    label: "Universidad de Córdoba",
    value: "Universidad de Córdoba",
  },
  {
    label: "Universidad de Córdoba, Colombia",
    value: "Universidad de Córdoba, Colombia",
  },
  {
    label: "Universidad de Costa Rica",
    value: "Universidad de Costa Rica",
  },
  {
    label: "Universidad de Cuautitlán Izcalli",
    value: "Universidad de Cuautitlán Izcalli",
  },
  {
    label: "Universidad de Cuenca",
    value: "Universidad de Cuenca",
  },
  {
    label: "Universidad de Cundinamarca",
    value: "Universidad de Cundinamarca",
  },
  {
    label: "Universidad de Desarrollo Sustentable",
    value: "Universidad de Desarrollo Sustentable",
  },
  {
    label: "Universidad de Deusto",
    value: "Universidad de Deusto",
  },
  {
    label: "Universidad de Ecatepec",
    value: "Universidad de Ecatepec",
  },
  {
    label: "Universidad de El Salvador",
    value: "Universidad de El Salvador",
  },
  {
    label: "Universidad de Especialidades del Espíritu Santo",
    value: "Universidad de Especialidades del Espíritu Santo",
  },
  {
    label: "Universidad de Especialidades Turísticas",
    value: "Universidad de Especialidades Turísticas",
  },
  {
    label: "Universidad de Estudios Avanzados",
    value: "Universidad de Estudios Avanzados",
  },
  {
    label: "Universidad de Extremadura",
    value: "Universidad de Extremadura",
  },
  {
    label: "Universidad de Falcón",
    value: "Universidad de Falcón",
  },
  {
    label: "Universidad de Flores",
    value: "Universidad de Flores",
  },
  {
    label: "Universidad de Gerona",
    value: "Universidad de Gerona",
  },
  {
    label: "Universidad de Granada",
    value: "Universidad de Granada",
  },
  {
    label: "Universidad de Granma",
    value: "Universidad de Granma",
  },
  {
    label: "Universidad de Guadalajara",
    value: "Universidad de Guadalajara",
  },
  {
    label: "Universidad de Guanajuato",
    value: "Universidad de Guanajuato",
  },
  {
    label: "Universidad de Guantánamo",
    value: "Universidad de Guantánamo",
  },
  {
    label: "Universidad de Guayaquil",
    value: "Universidad de Guayaquil",
  },
  {
    label: "Universidad de Hermosillo A.C.",
    value: "Universidad de Hermosillo A.C.",
  },
  {
    label: "Universidad de Holguín",
    value: "Universidad de Holguín",
  },
  {
    label: "Universidad de Huánuco",
    value: "Universidad de Huánuco",
  },
  {
    label: "Universidad de Huelva",
    value: "Universidad de Huelva",
  },
  {
    label: "Universidad de Ibagué",
    value: "Universidad de Ibagué",
  },
  {
    label: "Universidad de Iberoamérica",
    value: "Universidad de Iberoamérica",
  },
  {
    label: "Universidad de Ingeniería y Tecnología",
    value: "Universidad de Ingeniería y Tecnología",
  },
  {
    label: "Universidad de Jaén",
    value: "Universidad de Jaén",
  },
  {
    label: "Universidad de la Amazonia",
    value: "Universidad de la Amazonia",
  },
  {
    label: "Universidad de la Amazonía Boliviana",
    value: "Universidad de la Amazonía Boliviana",
  },
  {
    label: "Universidad de la Cañada",
    value: "Universidad de la Cañada",
  },
  {
    label: "Universidad de la Ciénega del Estado de Michoacán de Ocampo",
    value: "Universidad de la Ciénega del Estado de Michoacán de Ocampo",
  },
  {
    label: "Universidad de la Comunicación S.C.",
    value: "Universidad de la Comunicación S.C.",
  },
  {
    label: "Universidad de la Cordillera",
    value: "Universidad de la Cordillera",
  },
  {
    label: "Universidad de la Cuenca del Plata",
    value: "Universidad de la Cuenca del Plata",
  },
  {
    label: "Universidad de la Empresa",
    value: "Universidad de la Empresa",
  },
  {
    label: "Universidad de La Frontera",
    value: "Universidad de La Frontera",
  },
  {
    label: "Universidad de La Guajira",
    value: "Universidad de La Guajira",
  },
  {
    label: "Universidad de La Habana",
    value: "Universidad de La Habana",
  },
  {
    label: "Universidad de la Integración de las Américas",
    value: "Universidad de la Integración de las Américas",
  },
  {
    label: "Universidad de la Isla de la Juventud Jesús Montané Oropesa",
    value: "Universidad de la Isla de la Juventud Jesús Montané Oropesa",
  },
  {
    label: "Universidad de La Laguna",
    value: "Universidad de La Laguna",
  },
  {
    label: "Universidad de la Marina Mercante",
    value: "Universidad de la Marina Mercante",
  },
  {
    label: "Universidad de la República",
    value: "Universidad de la República",
  },
  {
    label: "Universidad de La Rioja",
    value: "Universidad de La Rioja",
  },
  {
    label: "Universidad de La Sabana",
    value: "Universidad de La Sabana",
  },
  {
    label: "Universidad de La Salle",
    value: "Universidad de La Salle",
  },
  {
    label: "Universidad de la Salle Bajío A.C.",
    value: "Universidad de la Salle Bajío A.C.",
  },
  {
    label: "Universidad de la Salle Costa Rica",
    value: "Universidad de la Salle Costa Rica",
  },
  {
    label: "Universidad de La Serena",
    value: "Universidad de La Serena",
  },
  {
    label: "Universidad de la Sierra",
    value: "Universidad de la Sierra",
  },
  {
    label: "Universidad de la Sierra A.C.",
    value: "Universidad de la Sierra A.C.",
  },
  {
    label: "Universidad de la Sierra Juárez",
    value: "Universidad de la Sierra Juárez",
  },
  {
    label: "Universidad de la Sierra Sur",
    value: "Universidad de la Sierra Sur",
  },
  {
    label: "Universidad de Las Américas",
    value: "Universidad de Las Américas",
  },
  {
    label: "Universidad de Las Américas",
    value: "Universidad de Las Américas",
  },
  {
    label: "Universidad de las Américas A.C.",
    value: "Universidad de las Américas A.C.",
  },
  {
    label: "Universidad de las Américas Puebla",
    value: "Universidad de las Américas Puebla",
  },
  {
    label: "Universidad de las Américas, Nicaragua",
    value: "Universidad de las Américas, Nicaragua",
  },
  {
    label: "Universidad de las Artes",
    value: "Universidad de las Artes",
  },
  {
    label: "Universidad de las Californias Internacional S.C.",
    value: "Universidad de las Californias Internacional S.C.",
  },
  {
    label: "Universidad de las Ciencias de la Comunicación de Puebla S.C.",
    value: "Universidad de las Ciencias de la Comunicación de Puebla S.C.",
  },
  {
    label: "Universidad de las Ciencias Informáticas",
    value: "Universidad de las Ciencias Informáticas",
  },
  {
    label: "Universidad de las Ciencias y el Arte de Costa Rica",
    value: "Universidad de las Ciencias y el Arte de Costa Rica",
  },
  {
    label: "Universidad de Las Palmas de Gran Canaria",
    value: "Universidad de Las Palmas de Gran Canaria",
  },
  {
    label:
      "Universidad de las Regiones Autónomas de la Costa Caribe Nicaragüense",
    value:
      "Universidad de las Regiones Autónomas de la Costa Caribe Nicaragüense",
  },
  {
    label: "Universidad de Las Tunas",
    value: "Universidad de Las Tunas",
  },
  {
    label: "Universidad de León",
    value: "Universidad de León",
  },
  {
    label: "Universidad de León, Mexico",
    value: "Universidad de León, Mexico",
  },
  {
    label: "Universidad de les Illes Balears",
    value: "Universidad de les Illes Balears",
  },
  {
    label: "Universidad de Lima",
    value: "Universidad de Lima",
  },
  {
    label: "Universidad de Londres A.C.",
    value: "Universidad de Londres A.C.",
  },
  {
    label: "Universidad de Los Altos de Chiapas S.C.",
    value: "Universidad de Los Altos de Chiapas S.C.",
  },
  {
    label: "Universidad de Los Andes",
    value: "Universidad de Los Andes",
  },
  {
    label: "Universidad de los Andes, Bolivia",
    value: "Universidad de los Andes, Bolivia",
  },
  {
    label: "Universidad de los Andes, Chile",
    value: "Universidad de los Andes, Chile",
  },
  {
    label: "Universidad de los Andes, Colombia",
    value: "Universidad de los Andes, Colombia",
  },
  {
    label: "Universidad de Los Hemisferios",
    value: "Universidad de Los Hemisferios",
  },
  {
    label: "Universidad de los Lagos",
    value: "Universidad de los Lagos",
  },
  {
    label: "Universidad de los Llanos",
    value: "Universidad de los Llanos",
  },
  {
    label: "Universidad de Magallanes",
    value: "Universidad de Magallanes",
  },
  {
    label: "Universidad de Málaga",
    value: "Universidad de Málaga",
  },
  {
    label: "Universidad de Managua",
    value: "Universidad de Managua",
  },
  {
    label: "Universidad de Manizales",
    value: "Universidad de Manizales",
  },
  {
    label: "Universidad de Margarita",
    value: "Universidad de Margarita",
  },
  {
    label: "Universidad de Matanzas",
    value: "Universidad de Matanzas",
  },
  {
    label: "Universidad de Medellín",
    value: "Universidad de Medellín",
  },
  {
    label: "Universidad de Mendoza",
    value: "Universidad de Mendoza",
  },
  {
    label: "Universidad de Moa Dr Antonio Núñez Jiménez",
    value: "Universidad de Moa Dr Antonio Núñez Jiménez",
  },
  {
    label: "Universidad de Mondragón",
    value: "Universidad de Mondragón",
  },
  {
    label: "Universidad de Montemorelos A.C.",
    value: "Universidad de Montemorelos A.C.",
  },
  {
    label: "Universidad de Monterrey",
    value: "Universidad de Monterrey",
  },
  {
    label: "Universidad de Montevideo",
    value: "Universidad de Montevideo",
  },
  {
    label: "Universidad de Morelia A.C.",
    value: "Universidad de Morelia A.C.",
  },
  {
    label: "Universidad de Morón",
    value: "Universidad de Morón",
  },
  {
    label: "Universidad de Murcia",
    value: "Universidad de Murcia",
  },
  {
    label: "Universidad de Nariño",
    value: "Universidad de Nariño",
  },
  {
    label: "Universidad de Navarra",
    value: "Universidad de Navarra",
  },
  {
    label: "Universidad de Negocios ISEC",
    value: "Universidad de Negocios ISEC",
  },
  {
    label: "Universidad de Norteamerica",
    value: "Universidad de Norteamerica",
  },
  {
    label: "Universidad de Occidente UDO",
    value: "Universidad de Occidente UDO",
  },
  {
    label: "Universidad de Occidente, Guatemala",
    value: "Universidad de Occidente, Guatemala",
  },
  {
    label: "Universidad de O'Higgins",
    value: "Universidad de O'Higgins",
  },
  {
    label: "Universidad de Oriente",
    value: "Universidad de Oriente",
  },
  {
    label: "Universidad de Oriente, El Salvador",
    value: "Universidad de Oriente, El Salvador",
  },
  {
    label: "Universidad de Oriente, Mexico",
    value: "Universidad de Oriente, Mexico",
  },
  {
    label: "Universidad de Oriente, Venezuela",
    value: "Universidad de Oriente, Venezuela",
  },
  {
    label: "Universidad de Otavalo",
    value: "Universidad de Otavalo",
  },
  {
    label: "Universidad de Oviedo",
    value: "Universidad de Oviedo",
  },
  {
    label: "Universidad de Palermo",
    value: "Universidad de Palermo",
  },
  {
    label: "Universidad de Pamplona",
    value: "Universidad de Pamplona",
  },
  {
    label: "Universidad de Panamá",
    value: "Universidad de Panamá",
  },
  {
    label: "Universidad de Pinar del Río Hermanos Saíz Montes de Oca",
    value: "Universidad de Pinar del Río Hermanos Saíz Montes de Oca",
  },
  {
    label: "Universidad de Piura",
    value: "Universidad de Piura",
  },
  {
    label: "Universidad de Playa Ancha de Ciencias de la Educacion",
    value: "Universidad de Playa Ancha de Ciencias de la Educacion",
  },
  {
    label: "Universidad de Puerto Rico",
    value: "Universidad de Puerto Rico",
  },
  {
    label: "Universidad de Puerto Rico Bayamón",
    value: "Universidad de Puerto Rico Bayamón",
  },
  {
    label: "Universidad de Puerto Rico Carolina",
    value: "Universidad de Puerto Rico Carolina",
  },
  {
    label: "Universidad de Puerto Rico en Aguadilla",
    value: "Universidad de Puerto Rico en Aguadilla",
  },
  {
    label: "Universidad de Puerto Rico en Arecibo",
    value: "Universidad de Puerto Rico en Arecibo",
  },
  {
    label: "Universidad de Puerto Rico en Ponce",
    value: "Universidad de Puerto Rico en Ponce",
  },
  {
    label: "Universidad de Puerto Rico en Utuado",
    value: "Universidad de Puerto Rico en Utuado",
  },
  {
    label: "Universidad de Puerto Rico Humacao",
    value: "Universidad de Puerto Rico Humacao",
  },
  {
    label: "Universidad de Puerto Rico, Recinto de Ciencias Médicas",
    value: "Universidad de Puerto Rico, Recinto de Ciencias Médicas",
  },
  {
    label: "Universidad de Puerto Rico, Recinto de Río Piedras",
    value: "Universidad de Puerto Rico, Recinto de Río Piedras",
  },
  {
    label: "Universidad de Puerto Rico, Recinto Universitario de Mayagüez",
    value: "Universidad de Puerto Rico, Recinto Universitario de Mayagüez",
  },
  {
    label: "Universidad de Quintana Roo",
    value: "Universidad de Quintana Roo",
  },
  {
    label: "Universidad de Rubén Darío",
    value: "Universidad de Rubén Darío",
  },
  {
    label: "Universidad de Salamanca",
    value: "Universidad de Salamanca",
  },
  {
    label: "Universidad de San Andrés",
    value: "Universidad de San Andrés",
  },
  {
    label: "Universidad de San Buenaventura",
    value: "Universidad de San Buenaventura",
  },
  {
    label: "Universidad de San Carlos de Guatemala",
    value: "Universidad de San Carlos de Guatemala",
  },
  {
    label: "Universidad de San Isidro",
    value: "Universidad de San Isidro",
  },
  {
    label: "Universidad de San José",
    value: "Universidad de San José",
  },
  {
    label: "Universidad de San Martín de Porres",
    value: "Universidad de San Martín de Porres",
  },
  {
    label: "Universidad de San Miguel A.C.",
    value: "Universidad de San Miguel A.C.",
  },
  {
    label: "Universidad de San Pablo-T",
    value: "Universidad de San Pablo-T",
  },
  {
    label: "Universidad de San Pedro Sula",
    value: "Universidad de San Pedro Sula",
  },
  {
    label: "Universidad de Sancti Spíritus José Martí Pérez",
    value: "Universidad de Sancti Spíritus José Martí Pérez",
  },
  {
    label: "Universidad de Santander",
    value: "Universidad de Santander",
  },
  {
    label: "Universidad de Santiago de Chile",
    value: "Universidad de Santiago de Chile",
  },
  {
    label: "Universidad de Santiago de Compostela",
    value: "Universidad de Santiago de Compostela",
  },
  {
    label: "Universidad de Sevilla",
    value: "Universidad de Sevilla",
  },
  {
    label: "Universidad de Sonora",
    value: "Universidad de Sonora",
  },
  {
    label: "Universidad de Sonsonate",
    value: "Universidad de Sonsonate",
  },
  {
    label: "Universidad de Sotavento A.C.",
    value: "Universidad de Sotavento A.C.",
  },
  {
    label: "Universidad de Sta. Isabel",
    value: "Universidad de Sta. Isabel",
  },
  {
    label: "Universidad de Sucre",
    value: "Universidad de Sucre",
  },
  {
    label: "Universidad de Talca",
    value: "Universidad de Talca",
  },
  {
    label: "Universidad de Tarapacá",
    value: "Universidad de Tarapacá",
  },
  {
    label: "Universidad de Tecnología y Comercio",
    value: "Universidad de Tecnología y Comercio",
  },
  {
    label: "Universidad de Tijuana",
    value: "Universidad de Tijuana",
  },
  {
    label: "Universidad de Valencia",
    value: "Universidad de Valencia",
  },
  {
    label: "Universidad de Valladolid",
    value: "Universidad de Valladolid",
  },
  {
    label: "Universidad de Valparaíso",
    value: "Universidad de Valparaíso",
  },
  {
    label: "Universidad de Vich - Universidad Central de Cataluña",
    value: "Universidad de Vich - Universidad Central de Cataluña",
  },
  {
    label: "Universidad de Viña del Mar",
    value: "Universidad de Viña del Mar",
  },
  {
    label: "Universidad de Xalapa A.C.",
    value: "Universidad de Xalapa A.C.",
  },
  {
    label: "Universidad de Zamboanga",
    value: "Universidad de Zamboanga",
  },
  {
    label: "Universidad de Zaragoza",
    value: "Universidad de Zaragoza",
  },
  {
    label: "Universidad del Aconcagua",
    value: "Universidad del Aconcagua",
  },
  {
    label: "Universidad del Alba",
    value: "Universidad del Alba",
  },
  {
    label: "Universidad del Alica",
    value: "Universidad del Alica",
  },
  {
    label: "Universidad del Altiplano",
    value: "Universidad del Altiplano",
  },
  {
    label: "Universidad del Arte Ganexa",
    value: "Universidad del Arte Ganexa",
  },
  {
    label: "Universidad del Atlántico",
    value: "Universidad del Atlántico",
  },
  {
    label: "Universidad del Atlántico Medio",
    value: "Universidad del Atlántico Medio",
  },
  {
    label: "Universidad del Azuay",
    value: "Universidad del Azuay",
  },
  {
    label: "Universidad del Bío-Bío",
    value: "Universidad del Bío-Bío",
  },
  {
    label: "Universidad del Caribe",
    value: "Universidad del Caribe",
  },
  {
    label: "Universidad del Caribe, Mexico",
    value: "Universidad del Caribe, Mexico",
  },
  {
    label: "Universidad del Cauca",
    value: "Universidad del Cauca",
  },
  {
    label: "Universidad del CEMA",
    value: "Universidad del CEMA",
  },
  {
    label: "Universidad del Centro de México",
    value: "Universidad del Centro de México",
  },
  {
    label: "Universidad del Centro del Bajío",
    value: "Universidad del Centro del Bajío",
  },
  {
    label: "Universidad del Centro Educativo Latinoamericano",
    value: "Universidad del Centro Educativo Latinoamericano",
  },
  {
    label: "Universidad del Cine",
    value: "Universidad del Cine",
  },
  {
    label: "Universidad del Claustro de Sor Juana",
    value: "Universidad del Claustro de Sor Juana",
  },
  {
    label: "Universidad del Cono Sur de las Américas",
    value: "Universidad del Cono Sur de las Américas",
  },
  {
    label: "Universidad del Desarrollo",
    value: "Universidad del Desarrollo",
  },
  {
    label: "Universidad del Desarrollo Empresarial y Pedagógico",
    value: "Universidad del Desarrollo Empresarial y Pedagógico",
  },
  {
    label: "Universidad del Distrito Federal S.C.",
    value: "Universidad del Distrito Federal S.C.",
  },
  {
    label: "Universidad del Este",
    value: "Universidad del Este",
  },
  {
    label: "Universidad del Golfo",
    value: "Universidad del Golfo",
  },
  {
    label: "Universidad del Golfo de México Norte",
    value: "Universidad del Golfo de México Norte",
  },
  {
    label: "Universidad del Gran Rosario",
    value: "Universidad del Gran Rosario",
  },
  {
    label: "Universidad del Istmo",
    value: "Universidad del Istmo",
  },
  {
    label: "Universidad del Istmo, Guatemala",
    value: "Universidad del Istmo, Guatemala",
  },
  {
    label: "Universidad del Istmo, Oaxaca",
    value: "Universidad del Istmo, Oaxaca",
  },
  {
    label: "Universidad del Magdalena",
    value: "Universidad del Magdalena",
  },
  {
    label: "Universidad del Mar",
    value: "Universidad del Mar",
  },
  {
    label: "Universidad del Museo Social Argentino",
    value: "Universidad del Museo Social Argentino",
  },
  {
    label: "Universidad del Noreste A.C.",
    value: "Universidad del Noreste A.C.",
  },
  {
    label: "Universidad del Norte",
    value: "Universidad del Norte",
  },
  {
    label: "Universidad del Norte A.C.",
    value: "Universidad del Norte A.C.",
  },
  {
    label: "Universidad del Norte de Nicaragua",
    value: "Universidad del Norte de Nicaragua",
  },
  {
    label: "Universidad del Norte Santo Tomás de Aquino",
    value: "Universidad del Norte Santo Tomás de Aquino",
  },
  {
    label: "Universidad del Norte, Paraguay",
    value: "Universidad del Norte, Paraguay",
  },
  {
    label: "Universidad del Pacifico",
    value: "Universidad del Pacifico",
  },
  {
    label: "Universidad del Pacífico de Chiapas",
    value: "Universidad del Pacífico de Chiapas",
  },
  {
    label: "Universidad del Pacifico, Colombia",
    value: "Universidad del Pacifico, Colombia",
  },
  {
    label: "Universidad del Pacifico, Ecuador",
    value: "Universidad del Pacifico, Ecuador",
  },
  {
    label: "Universidad del Pacifico, Paraguay",
    value: "Universidad del Pacifico, Paraguay",
  },
  {
    label: "Universidad del País Vasco",
    value: "Universidad del País Vasco",
  },
  {
    label: "Universidad del Papaloapan",
    value: "Universidad del Papaloapan",
  },
  {
    label: "Universidad del Pedregal",
    value: "Universidad del Pedregal",
  },
  {
    label: "Universidad del Quindío",
    value: "Universidad del Quindío",
  },
  {
    label: "Universidad del Rosario",
    value: "Universidad del Rosario",
  },
  {
    label: "Universidad del Sagrado Corazon",
    value: "Universidad del Sagrado Corazon",
  },
  {
    label: "Universidad del Salvador",
    value: "Universidad del Salvador",
  },
  {
    label: "Universidad del Sinú",
    value: "Universidad del Sinú",
  },
  {
    label: "Universidad del Sol",
    value: "Universidad del Sol",
  },
  {
    label: "Universidad del Tepeyac",
    value: "Universidad del Tepeyac",
  },
  {
    label: "Universidad del Tolima",
    value: "Universidad del Tolima",
  },
  {
    label: "Universidad del Turismo",
    value: "Universidad del Turismo",
  },
  {
    label: "Universidad del Valle",
    value: "Universidad del Valle",
  },
  {
    label: "Universidad del Valle de Atemajac A.C.",
    value: "Universidad del Valle de Atemajac A.C.",
  },
  {
    label: "Universidad del Valle de Cuernavaca",
    value: "Universidad del Valle de Cuernavaca",
  },
  {
    label: "Universidad del Valle de Guadiana",
    value: "Universidad del Valle de Guadiana",
  },
  {
    label: "Universidad del Valle de Guatemala",
    value: "Universidad del Valle de Guatemala",
  },
  {
    label: "Universidad del Valle de Matatipac S.C.",
    value: "Universidad del Valle de Matatipac S.C.",
  },
  {
    label: "Universidad del Valle de México A.C.",
    value: "Universidad del Valle de México A.C.",
  },
  {
    label: "Universidad del Valle de Orizaba",
    value: "Universidad del Valle de Orizaba",
  },
  {
    label: "Universidad del Valle de Puebla S.C.",
    value: "Universidad del Valle de Puebla S.C.",
  },
  {
    label: "Universidad del Valle de Tlaxcala",
    value: "Universidad del Valle de Tlaxcala",
  },
  {
    label: "Universidad del Valle de Toluca",
    value: "Universidad del Valle de Toluca",
  },
  {
    label: "Universidad del Valle, Nicaragua",
    value: "Universidad del Valle, Nicaragua",
  },
  {
    label: "Universidad del Zulia",
    value: "Universidad del Zulia",
  },
  {
    label: "Universidad Deportiva del Sur",
    value: "Universidad Deportiva del Sur",
  },
  {
    label: "Universidad Diego Portales",
    value: "Universidad Diego Portales",
  },
  {
    label: "Universidad Distrital Francisco José de Caldas",
    value: "Universidad Distrital Francisco José de Caldas",
  },
  {
    label: "Universidad Dominicana O&M",
    value: "Universidad Dominicana O&M",
  },
  {
    label: "Universidad Domínico-Americana",
    value: "Universidad Domínico-Americana",
  },
  {
    label: "Universidad Don Bosco",
    value: "Universidad Don Bosco",
  },
  {
    label: "Universidad Don Vasco A.C.",
    value: "Universidad Don Vasco A.C.",
  },
  {
    label: "Universidad Dorados",
    value: "Universidad Dorados",
  },
  {
    label: "Universidad Dr. Andrés Bello",
    value: "Universidad Dr. Andrés Bello",
  },
  {
    label: "Universidad Dr. José Gregorio Hernández",
    value: "Universidad Dr. José Gregorio Hernández",
  },
  {
    label: "Universidad Dr. Jose Matias Delgado",
    value: "Universidad Dr. Jose Matias Delgado",
  },
  {
    label: "Universidad Dr. Rafael Belloso Chacín",
    value: "Universidad Dr. Rafael Belloso Chacín",
  },
  {
    label: "Universidad EAFIT",
    value: "Universidad EAFIT",
  },
  {
    label: "Universidad EAN",
    value: "Universidad EAN",
  },
  {
    label: "Universidad EARTH",
    value: "Universidad EARTH",
  },
  {
    label: "Universidad ECCI",
    value: "Universidad ECCI",
  },
  {
    label: "Universidad Ecotec",
    value: "Universidad Ecotec",
  },
  {
    label: "Universidad EIA",
    value: "Universidad EIA",
  },
  {
    label: "Universidad El Bosque",
    value: "Universidad El Bosque",
  },
  {
    label: "Universidad Empresarial de Costa Rica",
    value: "Universidad Empresarial de Costa Rica",
  },
  {
    label: "Universidad Empresarial Siglo 21",
    value: "Universidad Empresarial Siglo 21",
  },
  {
    label: "Universidad ESAN",
    value: "Universidad ESAN",
  },
  {
    label: "Universidad Escuela Libre de Derecho",
    value: "Universidad Escuela Libre de Derecho",
  },
  {
    label: "Universidad España",
    value: "Universidad España",
  },
  {
    label: "Universidad Especializada de Las Americas",
    value: "Universidad Especializada de Las Americas",
  },
  {
    label: "Universidad Especializada del Contador Público de Panamá",
    value: "Universidad Especializada del Contador Público de Panamá",
  },
  {
    label: "Universidad Estatal Amazonica",
    value: "Universidad Estatal Amazonica",
  },
  {
    label: "Universidad Estatal de Bolívar",
    value: "Universidad Estatal de Bolívar",
  },
  {
    label: "Universidad Estatal de Milagro",
    value: "Universidad Estatal de Milagro",
  },
  {
    label: "Universidad Estatal de Sonora",
    value: "Universidad Estatal de Sonora",
  },
  {
    label: "Universidad Estatal del Sur de Manabi",
    value: "Universidad Estatal del Sur de Manabi",
  },
  {
    label: "Universidad Estatal del Valle de Ecatepec",
    value: "Universidad Estatal del Valle de Ecatepec",
  },
  {
    label: "Universidad Estatal Península de Santa Elena",
    value: "Universidad Estatal Península de Santa Elena",
  },
  {
    label: "Universidad ETAC",
    value: "Universidad ETAC",
  },
  {
    label: "Universidad Eugenio María de Hostos",
    value: "Universidad Eugenio María de Hostos",
  },
  {
    label: "Universidad Europea de Madrid",
    value: "Universidad Europea de Madrid",
  },
  {
    label: "Universidad Europea del Atlántico",
    value: "Universidad Europea del Atlántico",
  },
  {
    label: "Universidad Europea Miguel de Cervantes",
    value: "Universidad Europea Miguel de Cervantes",
  },
  {
    label: "Universidad Evangélica Boliviana",
    value: "Universidad Evangélica Boliviana",
  },
  {
    label: "Universidad Evangélica de El Salvador",
    value: "Universidad Evangélica de El Salvador",
  },
  {
    label: "Universidad Evangélica de las Américas",
    value: "Universidad Evangélica de las Américas",
  },
  {
    label: "Universidad Evangélica del Paraguay",
    value: "Universidad Evangélica del Paraguay",
  },
  {
    label: "Universidad Evangélica Nicaragüense Martin Luther King",
    value: "Universidad Evangélica Nicaragüense Martin Luther King",
  },
  {
    label: "Universidad Experimental Felix Adam",
    value: "Universidad Experimental Felix Adam",
  },
  {
    label: "Universidad Externado de Colombia",
    value: "Universidad Externado de Colombia",
  },
  {
    label: "Universidad FASTA",
    value: "Universidad FASTA",
  },
  {
    label: "Universidad Favaloro",
    value: "Universidad Favaloro",
  },
  {
    label: "Universidad Federada San Judas Tadeo",
    value: "Universidad Federada San Judas Tadeo",
  },
  {
    label: "Universidad Federico Henriquez y Carvajal",
    value: "Universidad Federico Henriquez y Carvajal",
  },
  {
    label: "Universidad Femenina del Sagrado Corazón",
    value: "Universidad Femenina del Sagrado Corazón",
  },
  {
    label: "Universidad Fermín Toro",
    value: "Universidad Fermín Toro",
  },
  {
    label: "Universidad Fernando Pessoa Canarias",
    value: "Universidad Fernando Pessoa Canarias",
  },
  {
    label: "Universidad Fidélitas",
    value: "Universidad Fidélitas",
  },
  {
    label: "Universidad Finis Terrae",
    value: "Universidad Finis Terrae",
  },
  {
    label: "Universidad Francisco de Paula Santander",
    value: "Universidad Francisco de Paula Santander",
  },
  {
    label: "Universidad Francisco de Vitoria",
    value: "Universidad Francisco de Vitoria",
  },
  {
    label: "Universidad Francisco Gavidia",
    value: "Universidad Francisco Gavidia",
  },
  {
    label: "Universidad Francisco Marroquín",
    value: "Universidad Francisco Marroquín",
  },
  {
    label: "Universidad Franco-Mexicana S.C.",
    value: "Universidad Franco-Mexicana S.C.",
  },
  {
    label: "Universidad Fray Luca Paccioli",
    value: "Universidad Fray Luca Paccioli",
  },
  {
    label: "Universidad Fundepos Alma Mater",
    value: "Universidad Fundepos Alma Mater",
  },
  {
    label: "Universidad Gabriela Mistral",
    value: "Universidad Gabriela Mistral",
  },
  {
    label: "Universidad Galileo",
    value: "Universidad Galileo",
  },
  {
    label: "Universidad Gastón Dachary",
    value: "Universidad Gastón Dachary",
  },
  {
    label: "Universidad Global del Cusco",
    value: "Universidad Global del Cusco",
  },
  {
    label: "Universidad Hebraica",
    value: "Universidad Hebraica",
  },
  {
    label: "Universidad Hipócrates",
    value: "Universidad Hipócrates",
  },
  {
    label: "Universidad Hispana",
    value: "Universidad Hispana",
  },
  {
    label: "Universidad Hispanoamericana",
    value: "Universidad Hispanoamericana",
  },
  {
    label: "Universidad Hispanoamericana Justo Sierra",
    value: "Universidad Hispanoamericana Justo Sierra",
  },
  {
    label: "Universidad Hispanoamericana, Nicaragua",
    value: "Universidad Hispanoamericana, Nicaragua",
  },
  {
    label: "Universidad Humanitas",
    value: "Universidad Humanitas",
  },
  {
    label: "Universidad Iberoamericana",
    value: "Universidad Iberoamericana",
  },
  {
    label: "Universidad Iberoamericana A.C.",
    value: "Universidad Iberoamericana A.C.",
  },
  {
    label: "Universidad Iberoamericana de Ciencia y Tecnologia",
    value: "Universidad Iberoamericana de Ciencia y Tecnologia",
  },
  {
    label: "Universidad Iberoamericana del Ecuador",
    value: "Universidad Iberoamericana del Ecuador",
  },
  {
    label: "Universidad Iberoamericana del Paraguay",
    value: "Universidad Iberoamericana del Paraguay",
  },
  {
    label: "Universidad ICEL",
    value: "Universidad ICEL",
  },
  {
    label: "Universidad ICESI",
    value: "Universidad ICESI",
  },
  {
    label: "Universidad Inca Garcilaso de la Vega",
    value: "Universidad Inca Garcilaso de la Vega",
  },
  {
    label: "Universidad INCCA de Colombia",
    value: "Universidad INCCA de Colombia",
  },
  {
    label: "Universidad INCE",
    value: "Universidad INCE",
  },
  {
    label: "Universidad Independiente de Costa Rica",
    value: "Universidad Independiente de Costa Rica",
  },
  {
    label: "Universidad Indoamérica",
    value: "Universidad Indoamérica",
  },
  {
    label: "Universidad Industrial de Santander",
    value: "Universidad Industrial de Santander",
  },
  {
    label: "Universidad Insurgentes S.C.",
    value: "Universidad Insurgentes S.C.",
  },
  {
    label: "Universidad Interamericana",
    value: "Universidad Interamericana",
  },
  {
    label: "Universidad Interamericana A.C.",
    value: "Universidad Interamericana A.C.",
  },
  {
    label: "Universidad Interamericana de Panamá",
    value: "Universidad Interamericana de Panamá",
  },
  {
    label: "Universidad Interamericana de Puerto Rico",
    value: "Universidad Interamericana de Puerto Rico",
  },
  {
    label: "Universidad Interamericana del Norte y Tecnológico Sierra Madre",
    value: "Universidad Interamericana del Norte y Tecnológico Sierra Madre",
  },
  {
    label: "Universidad Interamericana para el Desarrollo",
    value: "Universidad Interamericana para el Desarrollo",
  },
  {
    label: "Universidad Interamericana para el Desarrollo, Peru",
    value: "Universidad Interamericana para el Desarrollo, Peru",
  },
  {
    label: "Universidad Intercontinental",
    value: "Universidad Intercontinental",
  },
  {
    label: "Universidad Internacional",
    value: "Universidad Internacional",
  },
  {
    label: "Universidad Internacional Antonio de Valdivieso",
    value: "Universidad Internacional Antonio de Valdivieso",
  },
  {
    label: "Universidad Internacional de Andalucía",
    value: "Universidad Internacional de Andalucía",
  },
  {
    label: "Universidad Internacional de Integración de América Latina",
    value: "Universidad Internacional de Integración de América Latina",
  },
  {
    label: "Universidad Internacional de La Paz",
    value: "Universidad Internacional de La Paz",
  },
  {
    label: "Universidad Internacional de las Américas",
    value: "Universidad Internacional de las Américas",
  },
  {
    label: "Universidad Internacional del Ecuador",
    value: "Universidad Internacional del Ecuador",
  },
  {
    label: "Universidad Internacional Menéndez Pelayo",
    value: "Universidad Internacional Menéndez Pelayo",
  },
  {
    label: "Universidad Internacional para el Desarrollo Sostenible",
    value: "Universidad Internacional para el Desarrollo Sostenible",
  },
  {
    label: "Universidad Internacional San Isidro Labrador",
    value: "Universidad Internacional San Isidro Labrador",
  },
  {
    label: "Universidad Internacional SEK",
    value: "Universidad Internacional SEK",
  },
  {
    label: "Universidad InterNaciones",
    value: "Universidad InterNaciones",
  },
  {
    label: "Universidad Interserrana del Estado de Puebla Ahuacatlán",
    value: "Universidad Interserrana del Estado de Puebla Ahuacatlán",
  },
  {
    label: "Universidad Interserrana del Estado de Puebla-Chilchotla",
    value: "Universidad Interserrana del Estado de Puebla-Chilchotla",
  },
  {
    label: "Universidad Invenio",
    value: "Universidad Invenio",
  },
  {
    label: "Universidad ISA",
    value: "Universidad ISA",
  },
  {
    label: "Universidad Isaac Newton",
    value: "Universidad Isaac Newton",
  },
  {
    label: "Universidad ISALUD",
    value: "Universidad ISALUD",
  },
  {
    label: "Universidad Isidro Fabela de Toluca S.C.",
    value: "Universidad Isidro Fabela de Toluca S.C.",
  },
  {
    label: "Universidad Israel",
    value: "Universidad Israel",
  },
  {
    label: "Universidad Jaime Bausate y Meza",
    value: "Universidad Jaime Bausate y Meza",
  },
  {
    label: "Universidad Jaime I",
    value: "Universidad Jaime I",
  },
  {
    label: "Universidad Jean Jacques Rousseau",
    value: "Universidad Jean Jacques Rousseau",
  },
  {
    label: "Universidad José Antonio Páez",
    value: "Universidad José Antonio Páez",
  },
  {
    label: "Universidad José Carlos Mariátegui",
    value: "Universidad José Carlos Mariátegui",
  },
  {
    label: "Universidad José Cecilio del Valle",
    value: "Universidad José Cecilio del Valle",
  },
  {
    label: "Universidad José María Vargas",
    value: "Universidad José María Vargas",
  },
  {
    label: "Universidad José Vasconcelos",
    value: "Universidad José Vasconcelos",
  },
  {
    label: "Universidad Juan Agustín Maza",
    value: "Universidad Juan Agustín Maza",
  },
  {
    label: "Universidad Juan Pablo II",
    value: "Universidad Juan Pablo II",
  },
  {
    label: "Universidad Juárez Autónoma de Tabasco",
    value: "Universidad Juárez Autónoma de Tabasco",
  },
  {
    label: "Universidad Juárez del Estado de Durango",
    value: "Universidad Juárez del Estado de Durango",
  },
  {
    label: "Universidad Justo Sierra A.C.",
    value: "Universidad Justo Sierra A.C.",
  },
  {
    label: "Universidad Kino A.C.",
    value: "Universidad Kino A.C.",
  },
  {
    label: "Universidad La Concordia",
    value: "Universidad La Concordia",
  },
  {
    label: "Universidad La Gran Colombia",
    value: "Universidad La Gran Colombia",
  },
  {
    label: "Universidad La República",
    value: "Universidad La República",
  },
  {
    label: "Universidad La Salle",
    value: "Universidad La Salle",
  },
  {
    label: "Universidad La Salle Benavente A.C.",
    value: "Universidad La Salle Benavente A.C.",
  },
  {
    label: "Universidad La Salle Cancún A.C.",
    value: "Universidad La Salle Cancún A.C.",
  },
  {
    label: "Universidad La Salle Chihuahua A.C.",
    value: "Universidad La Salle Chihuahua A.C.",
  },
  {
    label: "Universidad La Salle Cuernavaca",
    value: "Universidad La Salle Cuernavaca",
  },
  {
    label: "Universidad La Salle Laguna",
    value: "Universidad La Salle Laguna",
  },
  {
    label: "Universidad La Salle Morelia A.C.",
    value: "Universidad La Salle Morelia A.C.",
  },
  {
    label: "Universidad La Salle Noroeste A.C.",
    value: "Universidad La Salle Noroeste A.C.",
  },
  {
    label: "Universidad La Salle Pachuca A.C.",
    value: "Universidad La Salle Pachuca A.C.",
  },
  {
    label: "Universidad La Salle Saltillo",
    value: "Universidad La Salle Saltillo",
  },
  {
    label: "Universidad La Salle Victoria",
    value: "Universidad La Salle Victoria",
  },
  {
    label: "Universidad La Salle, Bolivia",
    value: "Universidad La Salle, Bolivia",
  },
  {
    label: "Universidad La Salle, Peru",
    value: "Universidad La Salle, Peru",
  },
  {
    label: "Universidad Laica Eloy Alfaro de Manabi",
    value: "Universidad Laica Eloy Alfaro de Manabi",
  },
  {
    label: "Universidad Laica Vicente Rocafuerte de Guayaquil",
    value: "Universidad Laica Vicente Rocafuerte de Guayaquil",
  },
  {
    label: "Universidad Lasallista Benavente S.C.",
    value: "Universidad Lasallista Benavente S.C.",
  },
  {
    label: "Universidad Latina",
    value: "Universidad Latina",
  },
  {
    label: "Universidad Latina de America",
    value: "Universidad Latina de America",
  },
  {
    label: "Universidad Latina de Costa Rica",
    value: "Universidad Latina de Costa Rica",
  },
  {
    label: "Universidad Latina de México S.C.",
    value: "Universidad Latina de México S.C.",
  },
  {
    label: "Universidad Latina de Panamá",
    value: "Universidad Latina de Panamá",
  },
  {
    label: "Universidad Latinamericana de Comercio Exterior",
    value: "Universidad Latinamericana de Comercio Exterior",
  },
  {
    label: "Universidad Latinoamericana",
    value: "Universidad Latinoamericana",
  },
  {
    label: "Universidad Latinoamericana CIMA",
    value: "Universidad Latinoamericana CIMA",
  },
  {
    label: "Universidad Latinoamericana de Ciencia y Tecnología",
    value: "Universidad Latinoamericana de Ciencia y Tecnología",
  },
  {
    label: "Universidad Latinoamericana de Ciencia y Tecnologia, Panama",
    value: "Universidad Latinoamericana de Ciencia y Tecnologia, Panama",
  },
  {
    label: "Universidad Latinoamericana S.C.",
    value: "Universidad Latinoamericana S.C.",
  },
  {
    label: "Universidad Latinoamericana y del Caribe",
    value: "Universidad Latinoamericana y del Caribe",
  },
  {
    label: "Universidad LCI VERITAS",
    value: "Universidad LCI VERITAS",
  },
  {
    label: "Universidad Le Cordon Bleu",
    value: "Universidad Le Cordon Bleu",
  },
  {
    label: "Universidad Leonardo Da Vinci",
    value: "Universidad Leonardo Da Vinci",
  },
  {
    label: "Universidad Libre",
    value: "Universidad Libre",
  },
  {
    label: "Universidad Libre de Costa Rica",
    value: "Universidad Libre de Costa Rica",
  },
  {
    label: "Universidad Linda Vista",
    value: "Universidad Linda Vista",
  },
  {
    label: "Universidad Los Leones",
    value: "Universidad Los Leones",
  },
  {
    label: "Universidad Loyola",
    value: "Universidad Loyola",
  },
  {
    label: "Universidad Loyola Andalucía",
    value: "Universidad Loyola Andalucía",
  },
  {
    label: "Universidad Loyola de America",
    value: "Universidad Loyola de America",
  },
  {
    label: "Universidad Loyola del Pacífico A.C.",
    value: "Universidad Loyola del Pacífico A.C.",
  },
  {
    label: "Universidad Lucerna S.C.",
    value: "Universidad Lucerna S.C.",
  },
  {
    label: "Universidad Luterana Salvadoreña",
    value: "Universidad Luterana Salvadoreña",
  },
  {
    label: "Universidad Madero",
    value: "Universidad Madero",
  },
  {
    label: "Universidad Magister",
    value: "Universidad Magister",
  },
  {
    label: "Universidad Maimónides",
    value: "Universidad Maimónides",
  },
  {
    label: "Universidad Manuela Beltrán",
    value: "Universidad Manuela Beltrán",
  },
  {
    label: "Universidad Marcelino Champagnat",
    value: "Universidad Marcelino Champagnat",
  },
  {
    label: "Universidad María Auxiliadora",
    value: "Universidad María Auxiliadora",
  },
  {
    label: "Universidad Mariana",
    value: "Universidad Mariana",
  },
  {
    label: "Universidad Mariano Gálvez de Guatemala",
    value: "Universidad Mariano Gálvez de Guatemala",
  },
  {
    label: "Universidad Marista A.C.",
    value: "Universidad Marista A.C.",
  },
  {
    label: "Universidad Marista de Guadalajara",
    value: "Universidad Marista de Guadalajara",
  },
  {
    label: "Universidad Marítima del Perú",
    value: "Universidad Marítima del Perú",
  },
  {
    label: "Universidad Marítima Internacional de Panamá",
    value: "Universidad Marítima Internacional de Panamá",
  },
  {
    label: "Universidad Martín Lutero",
    value: "Universidad Martín Lutero",
  },
  {
    label: "Universidad Maya",
    value: "Universidad Maya",
  },
  {
    label: "Universidad Mayor",
    value: "Universidad Mayor",
  },
  {
    label: "Universidad Mayor de San Andrés",
    value: "Universidad Mayor de San Andrés",
  },
  {
    label: "Universidad Mayor de San Simón",
    value: "Universidad Mayor de San Simón",
  },
  {
    label: "Universidad Mesoamericana",
    value: "Universidad Mesoamericana",
  },
  {
    label: "Universidad Mesoamericana de San Agustín A.C.",
    value: "Universidad Mesoamericana de San Agustín A.C.",
  },
  {
    label: "Universidad Mesoamericana Puebla",
    value: "Universidad Mesoamericana Puebla",
  },
  {
    label: "Universidad Mesoamericana, Guatemala",
    value: "Universidad Mesoamericana, Guatemala",
  },
  {
    label: "Universidad Metodista de Costa Rica",
    value: "Universidad Metodista de Costa Rica",
  },
  {
    label: "Universidad Metropolitana",
    value: "Universidad Metropolitana",
  },
  {
    label: "Universidad Metropolitana de Asunción",
    value: "Universidad Metropolitana de Asunción",
  },
  {
    label: "Universidad Metropolitana de Ciencias de la Educación",
    value: "Universidad Metropolitana de Ciencias de la Educación",
  },
  {
    label: "Universidad Metropolitana de Educacion, Ciencia y Tecnologia",
    value: "Universidad Metropolitana de Educacion, Ciencia y Tecnologia",
  },
  {
    label: "Universidad Metropolitana de Honduras",
    value: "Universidad Metropolitana de Honduras",
  },
  {
    label: "Universidad Metropolitana de Monterrey",
    value: "Universidad Metropolitana de Monterrey",
  },
  {
    label: "Universidad Metropolitana para la Educación y el Trabajo",
    value: "Universidad Metropolitana para la Educación y el Trabajo",
  },
  {
    label: "Universidad Metropolitana, Colombia",
    value: "Universidad Metropolitana, Colombia",
  },
  {
    label: "Universidad Metropolitana, Ecuador",
    value: "Universidad Metropolitana, Ecuador",
  },
  {
    label: "Universidad Metropolitana, Nicaragua",
    value: "Universidad Metropolitana, Nicaragua",
  },
  {
    label: "Universidad Mexicana S.C.",
    value: "Universidad Mexicana S.C.",
  },
  {
    label: "Universidad México Americana del Norte A.C.",
    value: "Universidad México Americana del Norte A.C.",
  },
  {
    label: "Universidad Mexiquense",
    value: "Universidad Mexiquense",
  },
  {
    label: "Universidad Mexiquense del Bicentenario",
    value: "Universidad Mexiquense del Bicentenario",
  },
  {
    label: "Universidad Michoacana de San Nicolás de Hidalgo",
    value: "Universidad Michoacana de San Nicolás de Hidalgo",
  },
  {
    label: "Universidad Miguel de Cervantes",
    value: "Universidad Miguel de Cervantes",
  },
  {
    label: "Universidad Miguel Hernández de Elche",
    value: "Universidad Miguel Hernández de Elche",
  },
  {
    label: "Universidad Militar Nueva Granada",
    value: "Universidad Militar Nueva Granada",
  },
  {
    label: "Universidad Modelo",
    value: "Universidad Modelo",
  },
  {
    label: "Universidad Monseñor Oscar Arnulfo Romero",
    value: "Universidad Monseñor Oscar Arnulfo Romero",
  },
  {
    label: "Universidad Monteávila",
    value: "Universidad Monteávila",
  },
  {
    label: "Universidad Motolinia del Pedregal A.C.",
    value: "Universidad Motolinia del Pedregal A.C.",
  },
  {
    label: "Universidad Multicultural CUDEC",
    value: "Universidad Multicultural CUDEC",
  },
  {
    label: "Universidad Mundial",
    value: "Universidad Mundial",
  },
  {
    label: "Universidad Mundo Maya",
    value: "Universidad Mundo Maya",
  },
  {
    label: "Universidad Nacional",
    value: "Universidad Nacional",
  },
  {
    label: "Universidad Nacional Agraria",
    value: "Universidad Nacional Agraria",
  },
  {
    label: "Universidad Nacional Agraria de la Selva",
    value: "Universidad Nacional Agraria de la Selva",
  },
  {
    label: "Universidad Nacional Agraria La Molina",
    value: "Universidad Nacional Agraria La Molina",
  },
  {
    label: "Universidad Nacional Amazónica de Madre de Dios",
    value: "Universidad Nacional Amazónica de Madre de Dios",
  },
  {
    label: "Universidad Nacional Arturo Jauretche",
    value: "Universidad Nacional Arturo Jauretche",
  },
  {
    label: "Universidad Nacional Autónoma Altoandina de Tarma",
    value: "Universidad Nacional Autónoma Altoandina de Tarma",
  },
  {
    label: "Universidad Nacional Autónoma de Alto Amazonas",
    value: "Universidad Nacional Autónoma de Alto Amazonas",
  },
  {
    label: "Universidad Nacional Autónoma de Chota",
    value: "Universidad Nacional Autónoma de Chota",
  },
  {
    label: "Universidad Nacional Autónoma de Honduras",
    value: "Universidad Nacional Autónoma de Honduras",
  },
  {
    label: "Universidad Nacional Autónoma de Huanta",
    value: "Universidad Nacional Autónoma de Huanta",
  },
  {
    label: "Universidad Nacional Autónoma de México",
    value: "Universidad Nacional Autónoma de México",
  },
  {
    label: "Universidad Nacional Autónoma de Nicaragua, León",
    value: "Universidad Nacional Autónoma de Nicaragua, León",
  },
  {
    label: "Universidad Nacional Autónoma de Nicaragua, Managua",
    value: "Universidad Nacional Autónoma de Nicaragua, Managua",
  },
  {
    label: "Universidad Nacional Autónoma de Tayacaja",
    value: "Universidad Nacional Autónoma de Tayacaja",
  },
  {
    label: "Universidad Nacional Ciro Alegría",
    value: "Universidad Nacional Ciro Alegría",
  },
  {
    label: "Universidad Nacional Daniel Alcides Carrion",
    value: "Universidad Nacional Daniel Alcides Carrion",
  },
  {
    label: "Universidad Nacional de Asunción",
    value: "Universidad Nacional de Asunción",
  },
  {
    label: "Universidad Nacional de Avellaneda",
    value: "Universidad Nacional de Avellaneda",
  },
  {
    label: "Universidad Nacional de Barranca",
    value: "Universidad Nacional de Barranca",
  },
  {
    label: "Universidad Nacional de Cajamarca",
    value: "Universidad Nacional de Cajamarca",
  },
  {
    label: "Universidad Nacional de Cañete",
    value: "Universidad Nacional de Cañete",
  },
  {
    label: "Universidad Nacional de Canindeyú",
    value: "Universidad Nacional de Canindeyú",
  },
  {
    label: "Universidad Nacional de Catamarca",
    value: "Universidad Nacional de Catamarca",
  },
  {
    label: "Universidad Nacional de Chilecito",
    value: "Universidad Nacional de Chilecito",
  },
  {
    label: "Universidad Nacional de Chimborazo",
    value: "Universidad Nacional de Chimborazo",
  },
  {
    label: "Universidad Nacional de Colombia",
    value: "Universidad Nacional de Colombia",
  },
  {
    label: "Universidad Nacional de Córdoba",
    value: "Universidad Nacional de Córdoba",
  },
  {
    label: "Universidad Nacional de Cuyo",
    value: "Universidad Nacional de Cuyo",
  },
  {
    label: "Universidad Nacional de Educación",
    value: "Universidad Nacional de Educación",
  },
  {
    label: "Universidad Nacional de Educación Enrique Guzmán y Valle",
    value: "Universidad Nacional de Educación Enrique Guzmán y Valle",
  },
  {
    label: "Universidad Nacional de Entre Ríos",
    value: "Universidad Nacional de Entre Ríos",
  },
  {
    label: "Universidad Nacional de Formosa",
    value: "Universidad Nacional de Formosa",
  },
  {
    label: "Universidad Nacional de Frontera",
    value: "Universidad Nacional de Frontera",
  },
  {
    label: "Universidad Nacional de General Sarmiento",
    value: "Universidad Nacional de General Sarmiento",
  },
  {
    label: "Universidad Nacional de Guinea Ecuatorial",
    value: "Universidad Nacional de Guinea Ecuatorial",
  },
  {
    label: "Universidad Nacional de Huancavelica",
    value: "Universidad Nacional de Huancavelica",
  },
  {
    label: "Universidad Nacional de Hurlingham",
    value: "Universidad Nacional de Hurlingham",
  },
  {
    label: "Universidad Nacional de Ingenieria",
    value: "Universidad Nacional de Ingenieria",
  },
  {
    label: "Universidad Nacional de Ingeniería",
    value: "Universidad Nacional de Ingeniería",
  },
  {
    label: "Universidad Nacional de Itapúa",
    value: "Universidad Nacional de Itapúa",
  },
  {
    label: "Universidad Nacional de Jaén",
    value: "Universidad Nacional de Jaén",
  },
  {
    label: "Universidad Nacional de José C. Paz",
    value: "Universidad Nacional de José C. Paz",
  },
  {
    label: "Universidad Nacional de Jujuy",
    value: "Universidad Nacional de Jujuy",
  },
  {
    label: "Universidad Nacional de Juliaca",
    value: "Universidad Nacional de Juliaca",
  },
  {
    label: "Universidad Nacional de la Amazonía Peruana",
    value: "Universidad Nacional de la Amazonía Peruana",
  },
  {
    label: "Universidad Nacional de La Matanza",
    value: "Universidad Nacional de La Matanza",
  },
  {
    label: "Universidad Nacional de La Pampa",
    value: "Universidad Nacional de La Pampa",
  },
  {
    label: "Universidad Nacional de la Patagonia Austral",
    value: "Universidad Nacional de la Patagonia Austral",
  },
  {
    label: "Universidad Nacional de la Patagonia San Juan Bosco",
    value: "Universidad Nacional de la Patagonia San Juan Bosco",
  },
  {
    label: "Universidad Nacional de La Plata",
    value: "Universidad Nacional de La Plata",
  },
  {
    label: "Universidad Nacional de La Rioja",
    value: "Universidad Nacional de La Rioja",
  },
  {
    label: "Universidad Nacional de Lanús",
    value: "Universidad Nacional de Lanús",
  },
  {
    label: "Universidad Nacional de las Artes",
    value: "Universidad Nacional de las Artes",
  },
  {
    label: "Universidad Nacional de Loja",
    value: "Universidad Nacional de Loja",
  },
  {
    label: "Universidad Nacional de Lomas de Zamora",
    value: "Universidad Nacional de Lomas de Zamora",
  },
  {
    label: "Universidad Nacional de los Comechingones",
    value: "Universidad Nacional de los Comechingones",
  },
  {
    label: "Universidad Nacional de Luján",
    value: "Universidad Nacional de Luján",
  },
  {
    label: "Universidad Nacional de Mar del Plata",
    value: "Universidad Nacional de Mar del Plata",
  },
  {
    label: "Universidad Nacional de Misiones",
    value: "Universidad Nacional de Misiones",
  },
  {
    label: "Universidad Nacional de Moquegua",
    value: "Universidad Nacional de Moquegua",
  },
  {
    label: "Universidad Nacional de Moreno",
    value: "Universidad Nacional de Moreno",
  },
  {
    label: "Universidad Nacional de Pilar",
    value: "Universidad Nacional de Pilar",
  },
  {
    label: "Universidad Nacional de Piura",
    value: "Universidad Nacional de Piura",
  },
  {
    label: "Universidad Nacional de Quilmes",
    value: "Universidad Nacional de Quilmes",
  },
  {
    label: "Universidad Nacional de Rafaela",
    value: "Universidad Nacional de Rafaela",
  },
  {
    label: "Universidad Nacional de Río Cuarto",
    value: "Universidad Nacional de Río Cuarto",
  },
  {
    label: "Universidad Nacional de Río Negro",
    value: "Universidad Nacional de Río Negro",
  },
  {
    label: "Universidad Nacional de Rosario",
    value: "Universidad Nacional de Rosario",
  },
  {
    label: "Universidad Nacional de Salta",
    value: "Universidad Nacional de Salta",
  },
  {
    label: "Universidad Nacional de San Agustín de Arequipa",
    value: "Universidad Nacional de San Agustín de Arequipa",
  },
  {
    label: "Universidad Nacional de San Antonio Abad del Cusco",
    value: "Universidad Nacional de San Antonio Abad del Cusco",
  },
  {
    label: "Universidad Nacional de San Antonio de Areco",
    value: "Universidad Nacional de San Antonio de Areco",
  },
  {
    label: "Universidad Nacional de San Cristóbal de Huamanga",
    value: "Universidad Nacional de San Cristóbal de Huamanga",
  },
  {
    label: "Universidad Nacional de San Juan",
    value: "Universidad Nacional de San Juan",
  },
  {
    label: "Universidad Nacional de San Luis",
    value: "Universidad Nacional de San Luis",
  },
  {
    label: "Universidad Nacional de San Martín",
    value: "Universidad Nacional de San Martín",
  },
  {
    label: "Universidad Nacional de San Martín, Argentina",
    value: "Universidad Nacional de San Martín, Argentina",
  },
  {
    label: "Universidad Nacional de Santiago del Estero",
    value: "Universidad Nacional de Santiago del Estero",
  },
  {
    label: "Universidad Nacional de Siglo XX",
    value: "Universidad Nacional de Siglo XX",
  },
  {
    label:
      "Universidad Nacional de Tierra del Fuego, Antártida e Islas del Atlántico Sur",
    value:
      "Universidad Nacional de Tierra del Fuego, Antártida e Islas del Atlántico Sur",
  },
  {
    label: "Universidad Nacional de Tres de Febrero",
    value: "Universidad Nacional de Tres de Febrero",
  },
  {
    label: "Universidad Nacional de Trujillo",
    value: "Universidad Nacional de Trujillo",
  },
  {
    label: "Universidad Nacional de Tucumán",
    value: "Universidad Nacional de Tucumán",
  },
  {
    label: "Universidad Nacional de Tumbes",
    value: "Universidad Nacional de Tumbes",
  },
  {
    label: "Universidad Nacional de Ucayali",
    value: "Universidad Nacional de Ucayali",
  },
  {
    label: "Universidad Nacional de Villa María",
    value: "Universidad Nacional de Villa María",
  },
  {
    label: "Universidad Nacional de Villa Mercedes",
    value: "Universidad Nacional de Villa Mercedes",
  },
  {
    label: "Universidad Nacional de Villarrica del Espíritu Santo",
    value: "Universidad Nacional de Villarrica del Espíritu Santo",
  },
  {
    label: "Universidad Nacional del Altiplano",
    value: "Universidad Nacional del Altiplano",
  },
  {
    label: "Universidad Nacional del Alto Uruguay",
    value: "Universidad Nacional del Alto Uruguay",
  },
  {
    label: "Universidad Nacional del Callao",
    value: "Universidad Nacional del Callao",
  },
  {
    label: "Universidad Nacional del Centro de la Provincia de Buenos Aires",
    value: "Universidad Nacional del Centro de la Provincia de Buenos Aires",
  },
  {
    label: "Universidad Nacional del Centro del Perú",
    value: "Universidad Nacional del Centro del Perú",
  },
  {
    label: "Universidad Nacional del Chaco Austral",
    value: "Universidad Nacional del Chaco Austral",
  },
  {
    label: "Universidad Nacional del Comahue",
    value: "Universidad Nacional del Comahue",
  },
  {
    label: "Universidad Nacional del Este",
    value: "Universidad Nacional del Este",
  },
  {
    label: "Universidad Nacional del Litoral",
    value: "Universidad Nacional del Litoral",
  },
  {
    label: "Universidad Nacional del Nordeste",
    value: "Universidad Nacional del Nordeste",
  },
  {
    label: "Universidad Nacional del Noroeste de la Provincia de Buenos Aires",
    value: "Universidad Nacional del Noroeste de la Provincia de Buenos Aires",
  },
  {
    label: "Universidad Nacional del Oeste",
    value: "Universidad Nacional del Oeste",
  },
  {
    label: "Universidad Nacional del Oriente",
    value: "Universidad Nacional del Oriente",
  },
  {
    label: "Universidad Nacional del Santa",
    value: "Universidad Nacional del Santa",
  },
  {
    label: "Universidad Nacional del Sur",
    value: "Universidad Nacional del Sur",
  },
  {
    label: "Universidad Nacional Ecológica",
    value: "Universidad Nacional Ecológica",
  },
  {
    label: "Universidad Nacional Evangélica",
    value: "Universidad Nacional Evangélica",
  },
  {
    label: "Universidad Nacional Experimental de Guayana",
    value: "Universidad Nacional Experimental de Guayana",
  },
  {
    label: "Universidad Nacional Experimental de la Seguridad",
    value: "Universidad Nacional Experimental de la Seguridad",
  },
  {
    label: "Universidad Nacional Experimental de las Artes",
    value: "Universidad Nacional Experimental de las Artes",
  },
  {
    label: "Universidad Nacional Experimental de los Llanos Centrales",
    value: "Universidad Nacional Experimental de los Llanos Centrales",
  },
  {
    label: "Universidad Nacional Experimental de los Llanos Occidentales",
    value: "Universidad Nacional Experimental de los Llanos Occidentales",
  },
  {
    label: "Universidad Nacional Experimental del Táchira",
    value: "Universidad Nacional Experimental del Táchira",
  },
  {
    label: "Universidad Nacional Experimental del Yaracuy",
    value: "Universidad Nacional Experimental del Yaracuy",
  },
  {
    label: "Universidad Nacional Experimental Francisco de Miranda",
    value: "Universidad Nacional Experimental Francisco de Miranda",
  },
  {
    label: "Universidad Nacional Experimental Indígena del Tauca",
    value: "Universidad Nacional Experimental Indígena del Tauca",
  },
  {
    label: "Universidad Nacional Experimental Marítima del Caribe",
    value: "Universidad Nacional Experimental Marítima del Caribe",
  },
  {
    label:
      "Universidad Nacional Experimental Politécnica Antonio José de Sucre",
    value:
      "Universidad Nacional Experimental Politécnica Antonio José de Sucre",
  },
  {
    label: "Universidad Nacional Experimental Rafael Maria Baralt",
    value: "Universidad Nacional Experimental Rafael Maria Baralt",
  },
  {
    label: "Universidad Nacional Experimental Simón Rodríguez",
    value: "Universidad Nacional Experimental Simón Rodríguez",
  },
  {
    label: "Universidad Nacional Experimental Sur del Lago Jesús Maria Semprum",
    value: "Universidad Nacional Experimental Sur del Lago Jesús Maria Semprum",
  },
  {
    label: "Universidad Nacional Federico Villarreal",
    value: "Universidad Nacional Federico Villarreal",
  },
  {
    label: "Universidad Nacional Francisco Luis Espinoza Pineda",
    value: "Universidad Nacional Francisco Luis Espinoza Pineda",
  },
  {
    label: "Universidad Nacional Guillermo Brown",
    value: "Universidad Nacional Guillermo Brown",
  },
  {
    label: "Universidad Nacional Hermilio Valdizan",
    value: "Universidad Nacional Hermilio Valdizan",
  },
  {
    label: "Universidad Nacional Intercultural de Bagua",
    value: "Universidad Nacional Intercultural de Bagua",
  },
  {
    label: "Universidad Nacional Intercultural de la Amazonía",
    value: "Universidad Nacional Intercultural de la Amazonía",
  },
  {
    label: "Universidad Nacional Intercultural de la Selva Central",
    value: "Universidad Nacional Intercultural de la Selva Central",
  },
  {
    label: "Universidad Nacional Intercultural de Quillabamba",
    value: "Universidad Nacional Intercultural de Quillabamba",
  },
  {
    label: "Universidad Nacional Jorge Basadre Grohmann",
    value: "Universidad Nacional Jorge Basadre Grohmann",
  },
  {
    label: "Universidad Nacional José Faustino Sánchez Carrión",
    value: "Universidad Nacional José Faustino Sánchez Carrión",
  },
  {
    label: "Universidad Nacional José María Arguedas",
    value: "Universidad Nacional José María Arguedas",
  },
  {
    label: "Universidad Nacional Mayor de San Marcos",
    value: "Universidad Nacional Mayor de San Marcos",
  },
  {
    label: "Universidad Nacional Micaela Bastidas de Apurímac",
    value: "Universidad Nacional Micaela Bastidas de Apurímac",
  },
  {
    label: "Universidad Nacional Pedro Henríquez Ureña",
    value: "Universidad Nacional Pedro Henríquez Ureña",
  },
  {
    label: "Universidad Nacional Pedro Ruíz Gallo",
    value: "Universidad Nacional Pedro Ruíz Gallo",
  },
  {
    label: "Universidad Nacional Raúl Scalabrini Ortiz",
    value: "Universidad Nacional Raúl Scalabrini Ortiz",
  },
  {
    label: "Universidad Nacional San Luis Gonzaga",
    value: "Universidad Nacional San Luis Gonzaga",
  },
  {
    label: "Universidad Nacional Santiago Antúnez de Mayolo",
    value: "Universidad Nacional Santiago Antúnez de Mayolo",
  },
  {
    label: "Universidad Nacional Tecnológica",
    value: "Universidad Nacional Tecnológica",
  },
  {
    label: "Universidad Nacional Tecnológica de Lima Sur",
    value: "Universidad Nacional Tecnológica de Lima Sur",
  },
  {
    label: "Universidad Nacional Tecnológica de San Juan de Lurigancho",
    value: "Universidad Nacional Tecnológica de San Juan de Lurigancho",
  },
  {
    label: "Universidad Nacional Toribio Rodríguez de Mendoza",
    value: "Universidad Nacional Toribio Rodríguez de Mendoza",
  },
  {
    label: "Universidad Neotropical",
    value: "Universidad Neotropical",
  },
  {
    label: "Universidad Nicaragüense de Ciencia y Tecnología",
    value: "Universidad Nicaragüense de Ciencia y Tecnología",
  },
  {
    label: "Universidad Nordeste del Paraguay",
    value: "Universidad Nordeste del Paraguay",
  },
  {
    label: "Universidad Nororiental privada Gran Mariscal de Ayacucho",
    value: "Universidad Nororiental privada Gran Mariscal de Ayacucho",
  },
  {
    label: "Universidad Notarial Argentina",
    value: "Universidad Notarial Argentina",
  },
  {
    label: "Universidad Nuestra Señora de La Paz",
    value: "Universidad Nuestra Señora de La Paz",
  },
  {
    label: "Universidad Nueva Esparta",
    value: "Universidad Nueva Esparta",
  },
  {
    label: "Universidad Nueva San Salvador",
    value: "Universidad Nueva San Salvador",
  },
  {
    label: "Universidad Nur",
    value: "Universidad Nur",
  },
  {
    label: "Universidad Obrera de México",
    value: "Universidad Obrera de México",
  },
  {
    label: "Universidad Odontológica Dominicana",
    value: "Universidad Odontológica Dominicana",
  },
  {
    label: "Universidad Olmeca A.C.",
    value: "Universidad Olmeca A.C.",
  },
  {
    label: "Universidad ORT Uruguay",
    value: "Universidad ORT Uruguay",
  },
  {
    label: "Universidad Pablo de Olavide",
    value: "Universidad Pablo de Olavide",
  },
  {
    label: "Universidad Paccioli de Córdoba",
    value: "Universidad Paccioli de Córdoba",
  },
  {
    label: "Universidad Panamericana",
    value: "Universidad Panamericana",
  },
  {
    label: "Universidad Panamericana del Puerto",
    value: "Universidad Panamericana del Puerto",
  },
  {
    label: "Universidad Panamericana, Costa Rica",
    value: "Universidad Panamericana, Costa Rica",
  },
  {
    label: "Universidad Panamericana, El Salvador",
    value: "Universidad Panamericana, El Salvador",
  },
  {
    label: "Universidad Panamericana, Guatemala",
    value: "Universidad Panamericana, Guatemala",
  },
  {
    label: "Universidad para el Desarrollo y la Innovación",
    value: "Universidad para el Desarrollo y la Innovación",
  },
  {
    label: "Universidad para la Cooperación Internacional",
    value: "Universidad para la Cooperación Internacional",
  },
  {
    label: "Universidad para la Investigación Estratégica en Bolivia",
    value: "Universidad para la Investigación Estratégica en Bolivia",
  },
  {
    label: "Universidad Paraguayo Alemana",
    value: "Universidad Paraguayo Alemana",
  },
  {
    label: "Universidad Partenón Cozumel A.C.",
    value: "Universidad Partenón Cozumel A.C.",
  },
  {
    label: "Universidad Particular de Chiclayo",
    value: "Universidad Particular de Chiclayo",
  },
  {
    label: "Universidad Particular San Gregorio de Portoviejo",
    value: "Universidad Particular San Gregorio de Portoviejo",
  },
  {
    label: "Universidad Pedagógica de Durango",
    value: "Universidad Pedagógica de Durango",
  },
  {
    label: "Universidad Pedagógica de El Salvador",
    value: "Universidad Pedagógica de El Salvador",
  },
  {
    label: "Universidad Pedagógica Experimental Libertador",
    value: "Universidad Pedagógica Experimental Libertador",
  },
  {
    label: "Universidad Pedagógica Nacional",
    value: "Universidad Pedagógica Nacional",
  },
  {
    label: "Universidad Pedagógica Nacional",
    value: "Universidad Pedagógica Nacional",
  },
  {
    label: "Universidad Pedagógica Nacional Francisco Morazán",
    value: "Universidad Pedagógica Nacional Francisco Morazán",
  },
  {
    label: "Universidad Pedagógica Nacional, Mexico",
    value: "Universidad Pedagógica Nacional, Mexico",
  },
  {
    label: "Universidad Pedagógica Veracruzana",
    value: "Universidad Pedagógica Veracruzana",
  },
  {
    label: "Universidad Pedagógica y Tecnológica de Colombia",
    value: "Universidad Pedagógica y Tecnológica de Colombia",
  },
  {
    label: "Universidad Pedro de Gante",
    value: "Universidad Pedro de Gante",
  },
  {
    label: "Universidad Peruana Austral del Cusco",
    value: "Universidad Peruana Austral del Cusco",
  },
  {
    label: "Universidad Peruana Cayetano Heredia",
    value: "Universidad Peruana Cayetano Heredia",
  },
  {
    label: "Universidad Peruana de Ciencias Aplicadas",
    value: "Universidad Peruana de Ciencias Aplicadas",
  },
  {
    label: "Universidad Peruana de Ciencias e Informatica",
    value: "Universidad Peruana de Ciencias e Informatica",
  },
  {
    label: "Universidad Peruana de Integración Global",
    value: "Universidad Peruana de Integración Global",
  },
  {
    label: "Universidad Peruana de las Américas",
    value: "Universidad Peruana de las Américas",
  },
  {
    label: "Universidad Peruana del Centro",
    value: "Universidad Peruana del Centro",
  },
  {
    label: "Universidad Peruana del Oriente",
    value: "Universidad Peruana del Oriente",
  },
  {
    label: "Universidad Peruana Los Andes",
    value: "Universidad Peruana Los Andes",
  },
  {
    label: "Universidad Peruana Simón Bolivar",
    value: "Universidad Peruana Simón Bolivar",
  },
  {
    label: "Universidad Peruana Unión",
    value: "Universidad Peruana Unión",
  },
  {
    label: "Universidad Piloto de Colombia",
    value: "Universidad Piloto de Colombia",
  },
  {
    label: "Universidad Politécnica Amazónica",
    value: "Universidad Politécnica Amazónica",
  },
  {
    label: "Universidad Politécnica Cuencamé",
    value: "Universidad Politécnica Cuencamé",
  },
  {
    label: "Universidad Politécnica de Aguascalientes",
    value: "Universidad Politécnica de Aguascalientes",
  },
  {
    label: "Universidad Politécnica de Altamira",
    value: "Universidad Politécnica de Altamira",
  },
  {
    label: "Universidad Politécnica de Amozoc",
    value: "Universidad Politécnica de Amozoc",
  },
  {
    label: "Universidad Politécnica de Apodaca",
    value: "Universidad Politécnica de Apodaca",
  },
  {
    label: "Universidad Politécnica de Bacalar",
    value: "Universidad Politécnica de Bacalar",
  },
  {
    label: "Universidad Politécnica de Baja California",
    value: "Universidad Politécnica de Baja California",
  },
  {
    label: "Universidad Politécnica de Cartagena",
    value: "Universidad Politécnica de Cartagena",
  },
  {
    label: "Universidad Politécnica de Cataluña",
    value: "Universidad Politécnica de Cataluña",
  },
  {
    label: "Universidad Politécnica de Chiapas",
    value: "Universidad Politécnica de Chiapas",
  },
  {
    label: "Universidad Politécnica de Chihuahua",
    value: "Universidad Politécnica de Chihuahua",
  },
  {
    label: "Universidad Politécnica de Durango",
    value: "Universidad Politécnica de Durango",
  },
  {
    label: "Universidad Politécnica de El Salvador",
    value: "Universidad Politécnica de El Salvador",
  },
  {
    label: "Universidad Politécnica de Francisco I. Madero",
    value: "Universidad Politécnica de Francisco I. Madero",
  },
  {
    label: "Universidad Politécnica de Gómez Palacio",
    value: "Universidad Politécnica de Gómez Palacio",
  },
  {
    label: "Universidad Politécnica de Guanajuato",
    value: "Universidad Politécnica de Guanajuato",
  },
  {
    label: "Universidad Politécnica de Huatusco",
    value: "Universidad Politécnica de Huatusco",
  },
  {
    label: "Universidad Politécnica de Huejutla",
    value: "Universidad Politécnica de Huejutla",
  },
  {
    label: "Universidad Politécnica de Ingeniería",
    value: "Universidad Politécnica de Ingeniería",
  },
  {
    label: "Universidad Politécnica de la Región Ribereña",
    value: "Universidad Politécnica de la Región Ribereña",
  },
  {
    label: "Universidad Politécnica de la Zona Metropolitana de Guadalajara",
    value: "Universidad Politécnica de la Zona Metropolitana de Guadalajara",
  },
  {
    label: "Universidad Politécnica de Lázaro Cárdenas",
    value: "Universidad Politécnica de Lázaro Cárdenas",
  },
  {
    label: "Universidad Politécnica de Madrid",
    value: "Universidad Politécnica de Madrid",
  },
  {
    label: "Universidad Politécnica de Pachuca",
    value: "Universidad Politécnica de Pachuca",
  },
  {
    label: "Universidad Politécnica de Pénjamo",
    value: "Universidad Politécnica de Pénjamo",
  },
  {
    label: "Universidad Politécnica de Piedras Negras",
    value: "Universidad Politécnica de Piedras Negras",
  },
  {
    label: "Universidad Politécnica de Puebla",
    value: "Universidad Politécnica de Puebla",
  },
  {
    label: "Universidad Politécnica de Puerto Rico",
    value: "Universidad Politécnica de Puerto Rico",
  },
  {
    label: "Universidad Politécnica de Querétaro",
    value: "Universidad Politécnica de Querétaro",
  },
  {
    label: "Universidad Politécnica de Quintana Roo",
    value: "Universidad Politécnica de Quintana Roo",
  },
  {
    label: "Universidad Politécnica de Ramos Arizpe",
    value: "Universidad Politécnica de Ramos Arizpe",
  },
  {
    label: "Universidad Politécnica de San Luís Potosí",
    value: "Universidad Politécnica de San Luís Potosí",
  },
  {
    label: "Universidad Politécnica de Santa Rosa Jáuregui",
    value: "Universidad Politécnica de Santa Rosa Jáuregui",
  },
  {
    label: "Universidad Politécnica de Sinaloa",
    value: "Universidad Politécnica de Sinaloa",
  },
  {
    label: "Universidad Politécnica de Tapachula",
    value: "Universidad Politécnica de Tapachula",
  },
  {
    label: "Universidad Politécnica de Tecámac",
    value: "Universidad Politécnica de Tecámac",
  },
  {
    label: "Universidad Politécnica de Texcoco",
    value: "Universidad Politécnica de Texcoco",
  },
  {
    label: "Universidad Politécnica de Tlaxcala",
    value: "Universidad Politécnica de Tlaxcala",
  },
  {
    label: "Universidad Politécnica de Tlaxcala Región Poniente",
    value: "Universidad Politécnica de Tlaxcala Región Poniente",
  },
  {
    label: "Universidad Politécnica de Tulancingo",
    value: "Universidad Politécnica de Tulancingo",
  },
  {
    label: "Universidad Politécnica de Uruapan",
    value: "Universidad Politécnica de Uruapan",
  },
  {
    label: "Universidad Politécnica de València",
    value: "Universidad Politécnica de València",
  },
  {
    label: "Universidad Politécnica de Victoria",
    value: "Universidad Politécnica de Victoria",
  },
  {
    label: "Universidad Politécnica de Zacatecas",
    value: "Universidad Politécnica de Zacatecas",
  },
  {
    label: "Universidad Politécnica del Bicentenario",
    value: "Universidad Politécnica del Bicentenario",
  },
  {
    label: "Universidad Politécnica del Centro",
    value: "Universidad Politécnica del Centro",
  },
  {
    label: "Universidad Politécnica del Estado de Guerrero",
    value: "Universidad Politécnica del Estado de Guerrero",
  },
  {
    label: "Universidad Politécnica del Estado de Morelos",
    value: "Universidad Politécnica del Estado de Morelos",
  },
  {
    label: "Universidad Politécnica del Golfo de México",
    value: "Universidad Politécnica del Golfo de México",
  },
  {
    label: "Universidad Politécnica del Mar y la Sierra",
    value: "Universidad Politécnica del Mar y la Sierra",
  },
  {
    label: "Universidad Politécnica del Sur de Zacatecas",
    value: "Universidad Politécnica del Sur de Zacatecas",
  },
  {
    label: "Universidad Politécnica del Valle de Évora",
    value: "Universidad Politécnica del Valle de Évora",
  },
  {
    label: "Universidad Politécnica del Valle de México",
    value: "Universidad Politécnica del Valle de México",
  },
  {
    label: "Universidad Politécnica del Valle de Toluca",
    value: "Universidad Politécnica del Valle de Toluca",
  },
  {
    label: "Universidad Politecnica Estatal del Carchi",
    value: "Universidad Politecnica Estatal del Carchi",
  },
  {
    label: "Universidad Politecnica Hispano Mexicana",
    value: "Universidad Politecnica Hispano Mexicana",
  },
  {
    label: "Universidad Politécnica Internacional",
    value: "Universidad Politécnica Internacional",
  },
  {
    label: "Universidad Politécnica Jose Felix Ribas",
    value: "Universidad Politécnica Jose Felix Ribas",
  },
  {
    label: "Universidad Politécnica Juventino Rosas",
    value: "Universidad Politécnica Juventino Rosas",
  },
  {
    label: "Universidad Politécnica Mesoamericana",
    value: "Universidad Politécnica Mesoamericana",
  },
  {
    label: "Universidad Politécnica Metropolitana de Hidalgo",
    value: "Universidad Politécnica Metropolitana de Hidalgo",
  },
  {
    label: "Universidad Politécnica Metropolitana de Puebla",
    value: "Universidad Politécnica Metropolitana de Puebla",
  },
  {
    label: "Universidad Politécnica Salesiana",
    value: "Universidad Politécnica Salesiana",
  },
  {
    label: "Universidad Politecnica Taiwán Paraguay",
    value: "Universidad Politecnica Taiwán Paraguay",
  },
  {
    label: "Universidad Politécnica y Artística del Paraguay",
    value: "Universidad Politécnica y Artística del Paraguay",
  },
  {
    label: "Universidad Pompeu Fabra",
    value: "Universidad Pompeu Fabra",
  },
  {
    label: "Universidad Pontificia Bolivariana",
    value: "Universidad Pontificia Bolivariana",
  },
  {
    label: "Universidad Pontificia Comillas",
    value: "Universidad Pontificia Comillas",
  },
  {
    label: "Universidad Pontificia de Mexico",
    value: "Universidad Pontificia de Mexico",
  },
  {
    label: "Universidad Pontificia de Salamanca",
    value: "Universidad Pontificia de Salamanca",
  },
  {
    label: "Universidad Popular Autonóma del Estado de Puebla",
    value: "Universidad Popular Autonóma del Estado de Puebla",
  },
  {
    label: "Universidad Popular de la Chontalpa",
    value: "Universidad Popular de la Chontalpa",
  },
  {
    label: "Universidad Popular de Nicaragua",
    value: "Universidad Popular de Nicaragua",
  },
  {
    label: "Universidad Popular del Cesar",
    value: "Universidad Popular del Cesar",
  },
  {
    label: "Universidad Privada Abierta Latinoamericana",
    value: "Universidad Privada Abierta Latinoamericana",
  },
  {
    label: "Universidad Privada Antenor Orrego",
    value: "Universidad Privada Antenor Orrego",
  },
  {
    label: "Universidad Privada Antonio Guillermo Urrelo",
    value: "Universidad Privada Antonio Guillermo Urrelo",
  },
  {
    label: "Universidad Privada Autónoma del Sur",
    value: "Universidad Privada Autónoma del Sur",
  },
  {
    label: "Universidad Privada Boliviana",
    value: "Universidad Privada Boliviana",
  },
  {
    label: "Universidad Privada Cumbre",
    value: "Universidad Privada Cumbre",
  },
  {
    label: "Universidad Privada de Ciencias Administrativas y Tecnologicas",
    value: "Universidad Privada de Ciencias Administrativas y Tecnologicas",
  },
  {
    label: "Universidad Privada de Huancayo Franklin Roosevelt",
    value: "Universidad Privada de Huancayo Franklin Roosevelt",
  },
  {
    label: "Universidad Privada de Irapuato",
    value: "Universidad Privada de Irapuato",
  },
  {
    label: "Universidad Privada de Oruro",
    value: "Universidad Privada de Oruro",
  },
  {
    label: "Universidad Privada de Pucallpa",
    value: "Universidad Privada de Pucallpa",
  },
  {
    label: "Universidad Privada de Santa Cruz de la Sierra",
    value: "Universidad Privada de Santa Cruz de la Sierra",
  },
  {
    label: "Universidad Privada de Tacna",
    value: "Universidad Privada de Tacna",
  },
  {
    label: "Universidad Privada de Trujillo",
    value: "Universidad Privada de Trujillo",
  },
  {
    label: "Universidad Privada del Chaco",
    value: "Universidad Privada del Chaco",
  },
  {
    label: "Universidad Privada del Estado de México",
    value: "Universidad Privada del Estado de México",
  },
  {
    label: "Universidad Privada del Estado de Morelos S.C.",
    value: "Universidad Privada del Estado de Morelos S.C.",
  },
  {
    label: "Universidad Privada del Este",
    value: "Universidad Privada del Este",
  },
  {
    label: "Universidad Privada del Guairá",
    value: "Universidad Privada del Guairá",
  },
  {
    label: "Universidad Privada del Norte",
    value: "Universidad Privada del Norte",
  },
  {
    label: "Universidad Privada del Valle",
    value: "Universidad Privada del Valle",
  },
  {
    label: "Universidad Privada Domingo Savio",
    value: "Universidad Privada Domingo Savio",
  },
  {
    label: "Universidad Privada Franz Tamayo",
    value: "Universidad Privada Franz Tamayo",
  },
  {
    label: "Universidad Privada Juan Mejía Baca",
    value: "Universidad Privada Juan Mejía Baca",
  },
  {
    label: "Universidad Privada Juan Pablo II",
    value: "Universidad Privada Juan Pablo II",
  },
  {
    label: "Universidad Privada Leonardo Da Vinci",
    value: "Universidad Privada Leonardo Da Vinci",
  },
  {
    label: "Universidad Privada Líder Peruana",
    value: "Universidad Privada Líder Peruana",
  },
  {
    label: "Universidad Privada Norbert Wiener",
    value: "Universidad Privada Norbert Wiener",
  },
  {
    label: "Universidad Privada Peruano Alemana",
    value: "Universidad Privada Peruano Alemana",
  },
  {
    label: "Universidad Privada San Carlos",
    value: "Universidad Privada San Carlos",
  },
  {
    label: "Universidad Privada San Juan Bautista",
    value: "Universidad Privada San Juan Bautista",
  },
  {
    label: "Universidad Privada TELESUP",
    value: "Universidad Privada TELESUP",
  },
  {
    label: "Universidad Provincial de Córdoba",
    value: "Universidad Provincial de Córdoba",
  },
  {
    label: "Universidad Provincial de Ezeiza",
    value: "Universidad Provincial de Ezeiza",
  },
  {
    label: "Universidad Provincial del Sudoeste",
    value: "Universidad Provincial del Sudoeste",
  },
  {
    label: "Universidad Psicología Industrial Dominicana",
    value: "Universidad Psicología Industrial Dominicana",
  },
  {
    label: "Universidad Pública de El Alto",
    value: "Universidad Pública de El Alto",
  },
  {
    label: "Universidad Pública de Navarra",
    value: "Universidad Pública de Navarra",
  },
  {
    label: "Universidad Quetzalcóatl",
    value: "Universidad Quetzalcóatl",
  },
  {
    label: "Universidad Rafael Landívar",
    value: "Universidad Rafael Landívar",
  },
  {
    label: "Universidad Rafael Urdaneta",
    value: "Universidad Rafael Urdaneta",
  },
  {
    label: "Universidad Ramon Llull",
    value: "Universidad Ramon Llull",
  },
  {
    label: "Universidad Real",
    value: "Universidad Real",
  },
  {
    label: "Universidad Realística de México",
    value: "Universidad Realística de México",
  },
  {
    label: "Universidad Regiomontana",
    value: "Universidad Regiomontana",
  },
  {
    label: "Universidad Regional Amazónica IKIAM",
    value: "Universidad Regional Amazónica IKIAM",
  },
  {
    label: "Universidad Regional Autonoma de los Andes",
    value: "Universidad Regional Autonoma de los Andes",
  },
  {
    label: "Universidad Regional de Guatemala",
    value: "Universidad Regional de Guatemala",
  },
  {
    label: "Universidad Regional del Norte",
    value: "Universidad Regional del Norte",
  },
  {
    label: "Universidad Regional del Sureste A.C.",
    value: "Universidad Regional del Sureste A.C.",
  },
  {
    label: "Universidad Rey Juan Carlos",
    value: "Universidad Rey Juan Carlos",
  },
  {
    label: "Universidad Ricardo Palma",
    value: "Universidad Ricardo Palma",
  },
  {
    label: "Universidad Rovira i Virgili",
    value: "Universidad Rovira i Virgili",
  },
  {
    label: "Universidad Rural de Guatemala",
    value: "Universidad Rural de Guatemala",
  },
  {
    label: "Universidad Salazar",
    value: "Universidad Salazar",
  },
  {
    label: "Universidad Salesiana",
    value: "Universidad Salesiana",
  },
  {
    label: "Universidad Salesiana",
    value: "Universidad Salesiana",
  },
  {
    label: "Universidad Salesiana de Bolivia",
    value: "Universidad Salesiana de Bolivia",
  },
  {
    label: "Universidad Salvadoreña Alberto Masferrer",
    value: "Universidad Salvadoreña Alberto Masferrer",
  },
  {
    label: "Universidad San Carlos",
    value: "Universidad San Carlos",
  },
  {
    label: "Universidad San Francisco de Asís",
    value: "Universidad San Francisco de Asís",
  },
  {
    label: "Universidad San Francisco de Quito",
    value: "Universidad San Francisco de Quito",
  },
  {
    label: "Universidad San Francisco Xavier",
    value: "Universidad San Francisco Xavier",
  },
  {
    label: "Universidad San Ignacio de Loyola",
    value: "Universidad San Ignacio de Loyola",
  },
  {
    label: "Universidad San Ignacio de Loyola",
    value: "Universidad San Ignacio de Loyola",
  },
  {
    label: "Universidad San Jorge",
    value: "Universidad San Jorge",
  },
  {
    label: "Universidad San Juan de la Cruz",
    value: "Universidad San Juan de la Cruz",
  },
  {
    label: "Universidad San Lorenzo",
    value: "Universidad San Lorenzo",
  },
  {
    label: "Universidad San Marcos",
    value: "Universidad San Marcos",
  },
  {
    label: "Universidad San Marcos S.C.",
    value: "Universidad San Marcos S.C.",
  },
  {
    label: "Universidad San Pablo de Guatemala",
    value: "Universidad San Pablo de Guatemala",
  },
  {
    label: "Universidad San Pedro",
    value: "Universidad San Pedro",
  },
  {
    label: "Universidad San Sebastián",
    value: "Universidad San Sebastián",
  },
  {
    label: "Universidad Santa Clara de Asís",
    value: "Universidad Santa Clara de Asís",
  },
  {
    label: "Universidad Santa Fe A.C.",
    value: "Universidad Santa Fe A.C.",
  },
  {
    label: "Universidad Santa Lucía",
    value: "Universidad Santa Lucía",
  },
  {
    label: "Universidad Santa María",
    value: "Universidad Santa María",
  },
  {
    label: "Universidad Santa María, Campus Guayaquil",
    value: "Universidad Santa María, Campus Guayaquil",
  },
  {
    label: "Universidad Santa Paula",
    value: "Universidad Santa Paula",
  },
  {
    label: "Universidad Santander",
    value: "Universidad Santander",
  },
  {
    label: "Universidad Santiago de Cali",
    value: "Universidad Santiago de Cali",
  },
  {
    label: "Universidad Santo Domingo de Guzmán",
    value: "Universidad Santo Domingo de Guzmán",
  },
  {
    label: "Universidad Santo Tomás",
    value: "Universidad Santo Tomás",
  },
  {
    label: "Universidad Santo Tomás de Aquino",
    value: "Universidad Santo Tomás de Aquino",
  },
  {
    label: "Universidad Santo Tomás, Chile",
    value: "Universidad Santo Tomás, Chile",
  },
  {
    label: "Universidad SEK",
    value: "Universidad SEK",
  },
  {
    label: "Universidad Señor de Sipán",
    value: "Universidad Señor de Sipán",
  },
  {
    label: "Universidad Sergio Arboleda",
    value: "Universidad Sergio Arboleda",
  },
  {
    label: "Universidad Sergio Bernales",
    value: "Universidad Sergio Bernales",
  },
  {
    label: "Universidad Simón Bolivar",
    value: "Universidad Simón Bolivar",
  },
  {
    label: "Universidad Simón Bolívar",
    value: "Universidad Simón Bolívar",
  },
  {
    label: "Universidad Simón Bolívar, Colombia",
    value: "Universidad Simón Bolívar, Colombia",
  },
  {
    label: "Universidad Simón I. Patiño",
    value: "Universidad Simón I. Patiño",
  },
  {
    label: "Universidad Sudamericana",
    value: "Universidad Sudamericana",
  },
  {
    label: "Universidad Surcolombiana",
    value: "Universidad Surcolombiana",
  },
  {
    label: "Universidad Tangamanga S.C.",
    value: "Universidad Tangamanga S.C.",
  },
  {
    label: "Universidad TecMilenio",
    value: "Universidad TecMilenio",
  },
  {
    label: "Universidad Técnica de Ambato",
    value: "Universidad Técnica de Ambato",
  },
  {
    label: "Universidad Técnica de Babahoyo",
    value: "Universidad Técnica de Babahoyo",
  },
  {
    label: "Universidad Técnica de Comercialización y Desarrollo",
    value: "Universidad Técnica de Comercialización y Desarrollo",
  },
  {
    label: "Universidad Técnica de Comercio",
    value: "Universidad Técnica de Comercio",
  },
  {
    label: "Universidad Técnica de Cotopaxi",
    value: "Universidad Técnica de Cotopaxi",
  },
  {
    label: "Universidad Tecnica de Machala",
    value: "Universidad Tecnica de Machala",
  },
  {
    label: "Universidad Técnica de Manabí",
    value: "Universidad Técnica de Manabí",
  },
  {
    label: "Universidad Técnica de Oruro",
    value: "Universidad Técnica de Oruro",
  },
  {
    label: "Universidad Técnica del Norte",
    value: "Universidad Técnica del Norte",
  },
  {
    label: "Universidad Técnica Estatal de Quevedo",
    value: "Universidad Técnica Estatal de Quevedo",
  },
  {
    label: "Universidad Técnica Federico Santa María",
    value: "Universidad Técnica Federico Santa María",
  },
  {
    label: "Universidad Técnica Latinoamericana",
    value: "Universidad Técnica Latinoamericana",
  },
  {
    label: "Universidad Tecnica Luis Vargas Torres",
    value: "Universidad Tecnica Luis Vargas Torres",
  },
  {
    label: "Universidad Técnica Nacional",
    value: "Universidad Técnica Nacional",
  },
  {
    label: "Universidad Técnica Particular de Loja",
    value: "Universidad Técnica Particular de Loja",
  },
  {
    label: "Universidad Técnica Privada Cosmos",
    value: "Universidad Técnica Privada Cosmos",
  },
  {
    label: "Universidad Tecnológica",
    value: "Universidad Tecnológica",
  },
  {
    label: "Universidad Tecnológica Americana",
    value: "Universidad Tecnológica Americana",
  },
  {
    label: "Universidad Tecnológica Boliviana",
    value: "Universidad Tecnológica Boliviana",
  },
  {
    label: "Universidad Tecnológica Centroamericana",
    value: "Universidad Tecnológica Centroamericana",
  },
  {
    label: "Universidad Tecnológica Costarricense",
    value: "Universidad Tecnológica Costarricense",
  },
  {
    label: "Universidad Tecnológica de Acapulco",
    value: "Universidad Tecnológica de Acapulco",
  },
  {
    label: "Universidad Tecnológica de Aguascalientes",
    value: "Universidad Tecnológica de Aguascalientes",
  },
  {
    label: "Universidad Tecnológica de Altamira",
    value: "Universidad Tecnológica de Altamira",
  },
  {
    label: "Universidad Tecnológica de Bahía de Banderas",
    value: "Universidad Tecnológica de Bahía de Banderas",
  },
  {
    label: "Universidad Tecnológica de Bolívar",
    value: "Universidad Tecnológica de Bolívar",
  },
  {
    label: "Universidad Tecnológica de Cadereyta",
    value: "Universidad Tecnológica de Cadereyta",
  },
  {
    label: "Universidad Tecnológica de Calvillo",
    value: "Universidad Tecnológica de Calvillo",
  },
  {
    label: "Universidad Tecnológica de Camargo",
    value: "Universidad Tecnológica de Camargo",
  },
  {
    label: "Universidad Tecnológica de Campeche",
    value: "Universidad Tecnológica de Campeche",
  },
  {
    label: "Universidad Tecnológica de Cancún",
    value: "Universidad Tecnológica de Cancún",
  },
  {
    label: "Universidad Tecnológica de Candelaria",
    value: "Universidad Tecnológica de Candelaria",
  },
  {
    label: "Universidad Tecnológica de Chetumal",
    value: "Universidad Tecnológica de Chetumal",
  },
  {
    label: "Universidad Tecnológica de Chihuahua",
    value: "Universidad Tecnológica de Chihuahua",
  },
  {
    label: "Universidad Tecnológica de Chihuhahua Sur",
    value: "Universidad Tecnológica de Chihuhahua Sur",
  },
  {
    label: "Universidad Tecnológica de Chile INACAP",
    value: "Universidad Tecnológica de Chile INACAP",
  },
  {
    label: "Universidad Tecnológica de Ciudad Juárez",
    value: "Universidad Tecnológica de Ciudad Juárez",
  },
  {
    label: "Universidad Tecnológica de Coahuila",
    value: "Universidad Tecnológica de Coahuila",
  },
  {
    label: "Universidad Tecnológica de Corregidora",
    value: "Universidad Tecnológica de Corregidora",
  },
  {
    label: "Universidad Tecnológica de Culiacán",
    value: "Universidad Tecnológica de Culiacán",
  },
  {
    label: "Universidad Tecnológica de Durango",
    value: "Universidad Tecnológica de Durango",
  },
  {
    label: "Universidad Tecnológica de El Salvador",
    value: "Universidad Tecnológica de El Salvador",
  },
  {
    label: "Universidad Tecnológica de Escuinapa",
    value: "Universidad Tecnológica de Escuinapa",
  },
  {
    label: "Universidad Tecnológica de Etchojoa",
    value: "Universidad Tecnológica de Etchojoa",
  },
  {
    label: "Universidad Tecnológica de Guaymas",
    value: "Universidad Tecnológica de Guaymas",
  },
  {
    label: "Universidad Tecnológica de Gutiérrez Zamora",
    value: "Universidad Tecnológica de Gutiérrez Zamora",
  },
  {
    label: "Universidad Tecnológica de Hermosillo, Sonora",
    value: "Universidad Tecnológica de Hermosillo, Sonora",
  },
  {
    label: "Universidad Tecnológica de Honduras",
    value: "Universidad Tecnológica de Honduras",
  },
  {
    label: "Universidad Tecnológica de Huejotzingo",
    value: "Universidad Tecnológica de Huejotzingo",
  },
  {
    label: "Universidad Tecnológica de Izúcar de Matamoros",
    value: "Universidad Tecnológica de Izúcar de Matamoros",
  },
  {
    label: "Universidad Tecnológica de Jalisco",
    value: "Universidad Tecnológica de Jalisco",
  },
  {
    label: "Universidad Tecnológica de la Babícora",
    value: "Universidad Tecnológica de la Babícora",
  },
  {
    label: "Universidad Tecnológica de la Costa",
    value: "Universidad Tecnológica de la Costa",
  },
  {
    label: "Universidad Tecnológica de la Costa Grande de Guerrero",
    value: "Universidad Tecnológica de la Costa Grande de Guerrero",
  },
  {
    label: "Universidad Tecnológica de la Habana José Antonio Echeverría",
    value: "Universidad Tecnológica de la Habana José Antonio Echeverría",
  },
  {
    label: "Universidad Tecnológica de La Huasteca Hidalguense",
    value: "Universidad Tecnológica de La Huasteca Hidalguense",
  },
  {
    label: "Universidad Tecnológica de La Laguna Durango",
    value: "Universidad Tecnológica de La Laguna Durango",
  },
  {
    label: "Universidad Tecnológica de la Mixteca",
    value: "Universidad Tecnológica de la Mixteca",
  },
  {
    label: "Universidad Tecnológica de La Paz",
    value: "Universidad Tecnológica de La Paz",
  },
  {
    label: "Universidad Tecnológica de la Región Carbonífera",
    value: "Universidad Tecnológica de la Región Carbonífera",
  },
  {
    label: "Universidad Tecnológica de la Región Centro de Coahuila",
    value: "Universidad Tecnológica de la Región Centro de Coahuila",
  },
  {
    label: "Universidad Tecnológica de la Región Norte de Guerrero",
    value: "Universidad Tecnológica de la Región Norte de Guerrero",
  },
  {
    label: "Universidad Tecnológica de La Riviera Maya",
    value: "Universidad Tecnológica de La Riviera Maya",
  },
  {
    label: "Universidad Tecnológica de la Selva",
    value: "Universidad Tecnológica de la Selva",
  },
  {
    label: "Universidad Tecnológica de la Sierra",
    value: "Universidad Tecnológica de la Sierra",
  },
  {
    label: "Universidad Tecnológica de la Sierra Hidalguense",
    value: "Universidad Tecnológica de la Sierra Hidalguense",
  },
  {
    label: "Universidad Tecnológica de la Sierra Sur de Oaxaca",
    value: "Universidad Tecnológica de la Sierra Sur de Oaxaca",
  },
  {
    label: "Universidad Tecnológica de la Tarahumara",
    value: "Universidad Tecnológica de la Tarahumara",
  },
  {
    label: "Universidad Tecnológica de la Tierra Caliente",
    value: "Universidad Tecnológica de la Tierra Caliente",
  },
  {
    label: "Universidad Tecnológica de la Zona Metropolitana de Guadalajara",
    value: "Universidad Tecnológica de la Zona Metropolitana de Guadalajara",
  },
  {
    label:
      "Universidad Tecnológica de la Zona Metropolitana del Valle de México",
    value:
      "Universidad Tecnológica de la Zona Metropolitana del Valle de México",
  },
  {
    label: "Universidad Tecnológica de León",
    value: "Universidad Tecnológica de León",
  },
  {
    label: "Universidad Tecnológica de los Valles Centrales de Oaxaca",
    value: "Universidad Tecnológica de los Valles Centrales de Oaxaca",
  },
  {
    label: "Universidad Tecnológica de Manzanillo",
    value: "Universidad Tecnológica de Manzanillo",
  },
  {
    label: "Universidad Tecnológica de Matamoros",
    value: "Universidad Tecnológica de Matamoros",
  },
  {
    label: "Universidad Tecnológica de México",
    value: "Universidad Tecnológica de México",
  },
  {
    label: "Universidad Tecnológica de Morelia",
    value: "Universidad Tecnológica de Morelia",
  },
  {
    label: "Universidad Tecnológica de Nayarit",
    value: "Universidad Tecnológica de Nayarit",
  },
  {
    label: "Universidad Tecnológica de Nezahualcóyotl",
    value: "Universidad Tecnológica de Nezahualcóyotl",
  },
  {
    label: "Universidad Tecnológica de Nogales, Sonora",
    value: "Universidad Tecnológica de Nogales, Sonora",
  },
  {
    label: "Universidad Tecnológica de Nuevo Laredo",
    value: "Universidad Tecnológica de Nuevo Laredo",
  },
  {
    label: "Universidad Tecnológica de Oriental",
    value: "Universidad Tecnológica de Oriental",
  },
  {
    label: "Universidad Tecnológica de Panamá",
    value: "Universidad Tecnológica de Panamá",
  },
  {
    label: "Universidad Tecnológica de Paquimé",
    value: "Universidad Tecnológica de Paquimé",
  },
  {
    label: "Universidad Tecnológica de Parral",
    value: "Universidad Tecnológica de Parral",
  },
  {
    label: "Universidad Tecnológica de Pereira",
    value: "Universidad Tecnológica de Pereira",
  },
  {
    label: "Universidad Tecnológica de Poanas",
    value: "Universidad Tecnológica de Poanas",
  },
  {
    label: "Universidad Tecnológica de Puebla",
    value: "Universidad Tecnológica de Puebla",
  },
  {
    label: "Universidad Tecnológica de Puerto Peñasco",
    value: "Universidad Tecnológica de Puerto Peñasco",
  },
  {
    label: "Universidad Tecnológica de Querétaro",
    value: "Universidad Tecnológica de Querétaro",
  },
  {
    label: "Universidad Tecnológica de Rodeo",
    value: "Universidad Tecnológica de Rodeo",
  },
  {
    label: "Universidad Tecnológica de Salamanca",
    value: "Universidad Tecnológica de Salamanca",
  },
  {
    label: "Universidad Tecnológica de Saltillo",
    value: "Universidad Tecnológica de Saltillo",
  },
  {
    label: "Universidad Tecnológica de San Juan del Río",
    value: "Universidad Tecnológica de San Juan del Río",
  },
  {
    label: "Universidad Tecnológica de San Luis Potosí",
    value: "Universidad Tecnológica de San Luis Potosí",
  },
  {
    label: "Universidad Tecnológica de San Luis Río Colorado",
    value: "Universidad Tecnológica de San Luis Río Colorado",
  },
  {
    label: "Universidad Tecnológica de San Miguel de Allende",
    value: "Universidad Tecnológica de San Miguel de Allende",
  },
  {
    label: "Universidad Tecnológica de Santa Catarina",
    value: "Universidad Tecnológica de Santa Catarina",
  },
  {
    label: "Universidad Tecnológica de Santiago",
    value: "Universidad Tecnológica de Santiago",
  },
  {
    label: "Universidad Tecnológica de Tabasco",
    value: "Universidad Tecnológica de Tabasco",
  },
  {
    label: "Universidad Tecnológica de Tamaulipas Norte",
    value: "Universidad Tecnológica de Tamaulipas Norte",
  },
  {
    label: "Universidad Tecnológica de Tecámac",
    value: "Universidad Tecnológica de Tecámac",
  },
  {
    label: "Universidad Tecnológica de Tecamachalco",
    value: "Universidad Tecnológica de Tecamachalco",
  },
  {
    label: "Universidad Tecnológica de Tehuacán",
    value: "Universidad Tecnológica de Tehuacán",
  },
  {
    label: "Universidad Tecnológica de Tijuana",
    value: "Universidad Tecnológica de Tijuana",
  },
  {
    label: "Universidad Tecnológica de Tlaxcala",
    value: "Universidad Tecnológica de Tlaxcala",
  },
  {
    label: "Universidad Tecnológica de Torreón",
    value: "Universidad Tecnológica de Torreón",
  },
  {
    label: "Universidad Tecnológica de Tulancingo",
    value: "Universidad Tecnológica de Tulancingo",
  },
  {
    label: "Universidad Tecnológica de Tula-Tepeji",
    value: "Universidad Tecnológica de Tula-Tepeji",
  },
  {
    label: "Universidad Tecnológica de Xicotepec de Juárez",
    value: "Universidad Tecnológica de Xicotepec de Juárez",
  },
  {
    label: "Universidad Tecnológica de Zinacantepec",
    value: "Universidad Tecnológica de Zinacantepec",
  },
  {
    label: "Universidad Tecnológica del Centro",
    value: "Universidad Tecnológica del Centro",
  },
  {
    label: "Universidad Tecnológica del Centro de Mexico S.C.",
    value: "Universidad Tecnológica del Centro de Mexico S.C.",
  },
  {
    label: "Universidad Tecnológica del Centro de Veracruz",
    value: "Universidad Tecnológica del Centro de Veracruz",
  },
  {
    label: "Universidad Tecnológica del Centro, Mexico",
    value: "Universidad Tecnológica del Centro, Mexico",
  },
  {
    label: "Universidad Tecnológica del Choco",
    value: "Universidad Tecnológica del Choco",
  },
  {
    label: "Universidad Tecnológica del Cibao Oriental",
    value: "Universidad Tecnológica del Cibao Oriental",
  },
  {
    label: "Universidad Tecnológica del Estado de Zacatecas",
    value: "Universidad Tecnológica del Estado de Zacatecas",
  },
  {
    label: "Universidad Tecnológica del Mar de Tamaulipas Bicentenario",
    value: "Universidad Tecnológica del Mar de Tamaulipas Bicentenario",
  },
  {
    label: "Universidad Tecnológica del Mar del Estado de Guerrero",
    value: "Universidad Tecnológica del Mar del Estado de Guerrero",
  },
  {
    label: "Universidad Tecnológica del Mayab",
    value: "Universidad Tecnológica del Mayab",
  },
  {
    label: "Universidad Tecnológica del Norte de Aguascalientes",
    value: "Universidad Tecnológica del Norte de Aguascalientes",
  },
  {
    label: "Universidad Tecnológica del Norte de Coahuila",
    value: "Universidad Tecnológica del Norte de Coahuila",
  },
  {
    label: "Universidad Tecnológica del Norte de Guanajuato",
    value: "Universidad Tecnológica del Norte de Guanajuato",
  },
  {
    label: "Universidad Tecnológica del Peru",
    value: "Universidad Tecnológica del Peru",
  },
  {
    label: "Universidad Tecnológica del Poniente",
    value: "Universidad Tecnológica del Poniente",
  },
  {
    label: "Universidad Tecnológica del Sur",
    value: "Universidad Tecnológica del Sur",
  },
  {
    label: "Universidad Tecnológica del Sur de Sonora",
    value: "Universidad Tecnológica del Sur de Sonora",
  },
  {
    label: "Universidad Tecnológica del Sur del Estado de México",
    value: "Universidad Tecnológica del Sur del Estado de México",
  },
  {
    label: "Universidad Tecnológica del Sur del Estado de Morelos",
    value: "Universidad Tecnológica del Sur del Estado de Morelos",
  },
  {
    label: "Universidad Tecnológica del Sureste de Veracruz",
    value: "Universidad Tecnológica del Sureste de Veracruz",
  },
  {
    label: "Universidad Tecnológica del Suroeste de Guanajuato",
    value: "Universidad Tecnológica del Suroeste de Guanajuato",
  },
  {
    label: "Universidad Tecnológica del Usumacinta",
    value: "Universidad Tecnológica del Usumacinta",
  },
  {
    label: "Universidad Tecnológica del Valle de Toluca",
    value: "Universidad Tecnológica del Valle de Toluca",
  },
  {
    label: "Universidad Tecnológica del Valle del Mezquital",
    value: "Universidad Tecnológica del Valle del Mezquital",
  },
  {
    label: "Universidad Tecnológica El Retoño",
    value: "Universidad Tecnológica El Retoño",
  },
  {
    label: "Universidad Tecnológica Emiliano Zapata del Estado de Morelos",
    value: "Universidad Tecnológica Emiliano Zapata del Estado de Morelos",
  },
  {
    label: "Universidad Tecnológica Empresarial de Guayaquil",
    value: "Universidad Tecnológica Empresarial de Guayaquil",
  },
  {
    label: "Universidad Tecnológica Equinoccial",
    value: "Universidad Tecnológica Equinoccial",
  },
  {
    label: "Universidad Tecnológica Fidel Velázquez",
    value: "Universidad Tecnológica Fidel Velázquez",
  },
  {
    label: "Universidad Tecnológica General Mariano Escobedo",
    value: "Universidad Tecnológica General Mariano Escobedo",
  },
  {
    label: "Universidad Tecnológica Intercontinental",
    value: "Universidad Tecnológica Intercontinental",
  },
  {
    label: "Universidad Tecnológica La Salle",
    value: "Universidad Tecnológica La Salle",
  },
  {
    label: "Universidad Tecnológica Linares",
    value: "Universidad Tecnológica Linares",
  },
  {
    label: "Universidad Tecnológica Metropolitana",
    value: "Universidad Tecnológica Metropolitana",
  },
  {
    label: "Universidad Tecnológica Metropolitana, Mexico",
    value: "Universidad Tecnológica Metropolitana, Mexico",
  },
  {
    label: "Universidad Tecnológica Minera de Zimapán",
    value: "Universidad Tecnológica Minera de Zimapán",
  },
  {
    label: "Universidad Tecnológica Nacional",
    value: "Universidad Tecnológica Nacional",
  },
  {
    label: "Universidad Tecnológica Nicaragüense",
    value: "Universidad Tecnológica Nicaragüense",
  },
  {
    label: "Universidad Tecnológica Oteima",
    value: "Universidad Tecnológica Oteima",
  },
  {
    label: "Universidad Tecnológica Privada de Santa Cruz",
    value: "Universidad Tecnológica Privada de Santa Cruz",
  },
  {
    label: "Universidad Tecnológica Regional del Sur",
    value: "Universidad Tecnológica Regional del Sur",
  },
  {
    label: "Universidad Thomas More",
    value: "Universidad Thomas More",
  },
  {
    label: "Universidad Torcuato di Tella",
    value: "Universidad Torcuato di Tella",
  },
  {
    label: "Universidad Unidad",
    value: "Universidad Unidad",
  },
  {
    label: "Universidad Unión Bolivariana",
    value: "Universidad Unión Bolivariana",
  },
  {
    label: "Universidad Valle del Grijalva S.C.",
    value: "Universidad Valle del Grijalva S.C.",
  },
  {
    label: "Universidad Valle del Momboy",
    value: "Universidad Valle del Momboy",
  },
  {
    label: "Universidad Vasco de Quiroga A.C.",
    value: "Universidad Vasco de Quiroga A.C.",
  },
  {
    label: "Universidad Venezolana de los Hidrocarburos",
    value: "Universidad Venezolana de los Hidrocarburos",
  },
  {
    label: "Universidad Veracruzana",
    value: "Universidad Veracruzana",
  },
  {
    label: "Universidad Villasunción",
    value: "Universidad Villasunción",
  },
  {
    label: "Universidad Westhill",
    value: "Universidad Westhill",
  },
  {
    label: "Universidad Xicotepetl A.C.",
    value: "Universidad Xicotepetl A.C.",
  },
  {
    label: "Universidad Yacambú",
    value: "Universidad Yacambú",
  },
  {
    label: "Universidad Yachay Tech",
    value: "Universidad Yachay Tech",
  },
  {
    label: "Universidad YMCA",
    value: "Universidad YMCA",
  },
  {
    label: "Universidade 11 de Novembro",
    value: "Universidade 11 de Novembro",
  },
  {
    label: "Universidade Agostinho Neto",
    value: "Universidade Agostinho Neto",
  },
  {
    label: "Universidade Alto Vale do Rio do Peixe",
    value: "Universidade Alto Vale do Rio do Peixe",
  },
  {
    label: "Universidade Anhanguera de São Paulo",
    value: "Universidade Anhanguera de São Paulo",
  },
  {
    label: "Universidade Anhanguera-Uniderp",
    value: "Universidade Anhanguera-Uniderp",
  },
  {
    label: "Universidade Anhembi Morumbi",
    value: "Universidade Anhembi Morumbi",
  },
  {
    label: "Universidade Atlântica",
    value: "Universidade Atlântica",
  },
  {
    label: "Universidade Autónoma de Lisboa Luís de Camões",
    value: "Universidade Autónoma de Lisboa Luís de Camões",
  },
  {
    label: "Universidade Brasil",
    value: "Universidade Brasil",
  },
  {
    label: "Universidade Cândido Mendes",
    value: "Universidade Cândido Mendes",
  },
  {
    label: "Universidade Castelo Branco",
    value: "Universidade Castelo Branco",
  },
  {
    label: "Universidade Católica de Angola",
    value: "Universidade Católica de Angola",
  },
  {
    label: "Universidade Católica de Brasília",
    value: "Universidade Católica de Brasília",
  },
  {
    label: "Universidade Católica de Moçambique",
    value: "Universidade Católica de Moçambique",
  },
  {
    label: "Universidade Católica de Pelotas",
    value: "Universidade Católica de Pelotas",
  },
  {
    label: "Universidade Católica de Pernambuco",
    value: "Universidade Católica de Pernambuco",
  },
  {
    label: "Universidade Católica de Petrópolis",
    value: "Universidade Católica de Petrópolis",
  },
  {
    label: "Universidade Católica de Santos",
    value: "Universidade Católica de Santos",
  },
  {
    label: "Universidade Católica do Salvador",
    value: "Universidade Católica do Salvador",
  },
  {
    label: "Universidade Católica Dom Bosco",
    value: "Universidade Católica Dom Bosco",
  },
  {
    label: "Universidade Católica Portuguesa",
    value: "Universidade Católica Portuguesa",
  },
  {
    label: "Universidade Cesumar",
    value: "Universidade Cesumar",
  },
  {
    label: "Universidade Ceuma",
    value: "Universidade Ceuma",
  },
  {
    label: "Universidade Cidade de São Paulo",
    value: "Universidade Cidade de São Paulo",
  },
  {
    label: "Universidade Comunitária da Região de Chapecó",
    value: "Universidade Comunitária da Região de Chapecó",
  },
  {
    label: "Universidade Cruzeiro do Sul",
    value: "Universidade Cruzeiro do Sul",
  },
  {
    label: "Universidade Cuíto Cuanavale",
    value: "Universidade Cuíto Cuanavale",
  },
  {
    label: "Universidade da Amazônia",
    value: "Universidade da Amazônia",
  },
  {
    label: "Universidade da Beira Interior",
    value: "Universidade da Beira Interior",
  },
  {
    label: "Universidade da Coruña",
    value: "Universidade da Coruña",
  },
  {
    label:
      "Universidade da Integração Internacional da Lusofonia Afro-Brasileira",
    value:
      "Universidade da Integração Internacional da Lusofonia Afro-Brasileira",
  },
  {
    label: "Universidade da Madeira",
    value: "Universidade da Madeira",
  },
  {
    label: "Universidade da Maia",
    value: "Universidade da Maia",
  },
  {
    label: "Universidade da Paz",
    value: "Universidade da Paz",
  },
  {
    label: "Universidade da Região de Joinville",
    value: "Universidade da Região de Joinville",
  },
  {
    label: "Universidade de Araraquara",
    value: "Universidade de Araraquara",
  },
  {
    label: "Universidade de Aveiro",
    value: "Universidade de Aveiro",
  },
  {
    label: "Universidade de Belas",
    value: "Universidade de Belas",
  },
  {
    label: "Universidade de Brasília",
    value: "Universidade de Brasília",
  },
  {
    label: "Universidade de Cabo Verde",
    value: "Universidade de Cabo Verde",
  },
  {
    label: "Universidade de Caxias do Sul",
    value: "Universidade de Caxias do Sul",
  },
  {
    label: "Universidade de Coimbra",
    value: "Universidade de Coimbra",
  },
  {
    label: "Universidade de Cruz Alta",
    value: "Universidade de Cruz Alta",
  },
  {
    label: "Universidade de Cuiabá",
    value: "Universidade de Cuiabá",
  },
  {
    label: "Universidade de Díli",
    value: "Universidade de Díli",
  },
  {
    label: "Universidade de Évora",
    value: "Universidade de Évora",
  },
  {
    label: "Universidade de Fortaleza",
    value: "Universidade de Fortaleza",
  },
  {
    label: "Universidade de Franca",
    value: "Universidade de Franca",
  },
  {
    label: "Universidade de Gurupi",
    value: "Universidade de Gurupi",
  },
  {
    label: "Universidade de Itaúna",
    value: "Universidade de Itaúna",
  },
  {
    label: "Universidade de Lisboa",
    value: "Universidade de Lisboa",
  },
  {
    label: "Universidade de Luanda",
    value: "Universidade de Luanda",
  },
  {
    label: "Universidade de Macau",
    value: "Universidade de Macau",
  },
  {
    label: "Universidade de Marília",
    value: "Universidade de Marília",
  },
  {
    label: "Universidade de Mogi das Cruzes",
    value: "Universidade de Mogi das Cruzes",
  },
  {
    label: "Universidade de Passo Fundo",
    value: "Universidade de Passo Fundo",
  },
  {
    label: "Universidade de Pernambuco",
    value: "Universidade de Pernambuco",
  },
  {
    label: "Universidade de Ribeirão Preto",
    value: "Universidade de Ribeirão Preto",
  },
  {
    label: "Universidade de Rio Verde",
    value: "Universidade de Rio Verde",
  },
  {
    label: "Universidade de Santa Cruz do Sul",
    value: "Universidade de Santa Cruz do Sul",
  },
  {
    label: "Universidade de Santiago",
    value: "Universidade de Santiago",
  },
  {
    label: "Universidade de São Paulo",
    value: "Universidade de São Paulo",
  },
  {
    label: "Universidade de Sorocaba",
    value: "Universidade de Sorocaba",
  },
  {
    label: "Universidade de Taubaté",
    value: "Universidade de Taubaté",
  },
  {
    label: "Universidade de Trás-os-Montes e Alto Douro",
    value: "Universidade de Trás-os-Montes e Alto Douro",
  },
  {
    label: "Universidade de Uberaba",
    value: "Universidade de Uberaba",
  },
  {
    label: "Universidade de Vassouras",
    value: "Universidade de Vassouras",
  },
  {
    label: "Universidade de Vigo",
    value: "Universidade de Vigo",
  },
  {
    label: "Universidade do Algarve",
    value: "Universidade do Algarve",
  },
  {
    label: "Universidade do Contestado",
    value: "Universidade do Contestado",
  },
  {
    label: "Universidade do Estado da Bahia",
    value: "Universidade do Estado da Bahia",
  },
  {
    label: "Universidade do Estado de Mato Grosso",
    value: "Universidade do Estado de Mato Grosso",
  },
  {
    label: "Universidade do Estado de Minas Gerais",
    value: "Universidade do Estado de Minas Gerais",
  },
  {
    label: "Universidade do Estado de Santa Catarina",
    value: "Universidade do Estado de Santa Catarina",
  },
  {
    label: "Universidade do Estado do Amapá",
    value: "Universidade do Estado do Amapá",
  },
  {
    label: "Universidade do Estado do Amazonas",
    value: "Universidade do Estado do Amazonas",
  },
  {
    label: "Universidade do Estado do Pará",
    value: "Universidade do Estado do Pará",
  },
  {
    label: "Universidade do Estado do Rio de Janeiro",
    value: "Universidade do Estado do Rio de Janeiro",
  },
  {
    label: "Universidade do Estado do Rio Grande do Norte",
    value: "Universidade do Estado do Rio Grande do Norte",
  },
  {
    label: "Universidade do Extremo Sul Catarinense",
    value: "Universidade do Extremo Sul Catarinense",
  },
  {
    label: "Universidade do Grande Rio",
    value: "Universidade do Grande Rio",
  },
  {
    label: "Universidade do Mindelo",
    value: "Universidade do Mindelo",
  },
  {
    label: "Universidade do Minho",
    value: "Universidade do Minho",
  },
  {
    label: "Universidade do Oeste de Santa Catarina",
    value: "Universidade do Oeste de Santa Catarina",
  },
  {
    label: "Universidade do Oeste Paulista",
    value: "Universidade do Oeste Paulista",
  },
  {
    label: "Universidade do Planalto Catarinense",
    value: "Universidade do Planalto Catarinense",
  },
  {
    label: "Universidade do Porto",
    value: "Universidade do Porto",
  },
  {
    label: "Universidade do Sul de Santa Catarina",
    value: "Universidade do Sul de Santa Catarina",
  },
  {
    label: "Universidade do Vale do Itajaí",
    value: "Universidade do Vale do Itajaí",
  },
  {
    label: "Universidade do Vale do Paraíba",
    value: "Universidade do Vale do Paraíba",
  },
  {
    label: "Universidade do Vale do Rio dos Sinos",
    value: "Universidade do Vale do Rio dos Sinos",
  },
  {
    label: "Universidade do Vale do Sapucaí",
    value: "Universidade do Vale do Sapucaí",
  },
  {
    label: "Universidade do Vale do Taquari",
    value: "Universidade do Vale do Taquari",
  },
  {
    label: "Universidade dos Açores",
    value: "Universidade dos Açores",
  },
  {
    label: "Universidade Eduardo Mondlane",
    value: "Universidade Eduardo Mondlane",
  },
  {
    label: "Universidade Estácio de Sá",
    value: "Universidade Estácio de Sá",
  },
  {
    label: "Universidade Estadual da Paraíba",
    value: "Universidade Estadual da Paraíba",
  },
  {
    label: "Universidade Estadual da Região Tocantina do Maranhão",
    value: "Universidade Estadual da Região Tocantina do Maranhão",
  },
  {
    label: "Universidade Estadual de Alagoas",
    value: "Universidade Estadual de Alagoas",
  },
  {
    label: "Universidade Estadual de Campinas",
    value: "Universidade Estadual de Campinas",
  },
  {
    label: "Universidade Estadual de Ciências da Saúde de Alagoas",
    value: "Universidade Estadual de Ciências da Saúde de Alagoas",
  },
  {
    label: "Universidade Estadual de Feira de Santana",
    value: "Universidade Estadual de Feira de Santana",
  },
  {
    label: "Universidade Estadual de Goiás",
    value: "Universidade Estadual de Goiás",
  },
  {
    label: "Universidade Estadual de Londrina",
    value: "Universidade Estadual de Londrina",
  },
  {
    label: "Universidade Estadual de Maringá",
    value: "Universidade Estadual de Maringá",
  },
  {
    label: "Universidade Estadual de Mato Grosso do Sul",
    value: "Universidade Estadual de Mato Grosso do Sul",
  },
  {
    label: "Universidade Estadual de Montes Claros",
    value: "Universidade Estadual de Montes Claros",
  },
  {
    label: "Universidade Estadual de Ponta Grossa",
    value: "Universidade Estadual de Ponta Grossa",
  },
  {
    label: "Universidade Estadual de Roraima",
    value: "Universidade Estadual de Roraima",
  },
  {
    label: "Universidade Estadual de Santa Cruz",
    value: "Universidade Estadual de Santa Cruz",
  },
  {
    label: "Universidade Estadual do Ceará",
    value: "Universidade Estadual do Ceará",
  },
  {
    label: "Universidade Estadual do Centro-Oeste",
    value: "Universidade Estadual do Centro-Oeste",
  },
  {
    label: "Universidade Estadual do Maranhão",
    value: "Universidade Estadual do Maranhão",
  },
  {
    label: "Universidade Estadual do Norte do Paraná",
    value: "Universidade Estadual do Norte do Paraná",
  },
  {
    label: "Universidade Estadual do Norte Fluminense Darcy Ribeiro",
    value: "Universidade Estadual do Norte Fluminense Darcy Ribeiro",
  },
  {
    label: "Universidade Estadual do Oeste do Paraná",
    value: "Universidade Estadual do Oeste do Paraná",
  },
  {
    label: "Universidade Estadual do Paraná",
    value: "Universidade Estadual do Paraná",
  },
  {
    label: "Universidade Estadual do Piauí",
    value: "Universidade Estadual do Piauí",
  },
  {
    label: "Universidade Estadual do Rio Grande do Sul",
    value: "Universidade Estadual do Rio Grande do Sul",
  },
  {
    label: "Universidade Estadual do Sudoeste da Bahia",
    value: "Universidade Estadual do Sudoeste da Bahia",
  },
  {
    label: "Universidade Estadual do Tocantins",
    value: "Universidade Estadual do Tocantins",
  },
  {
    label: "Universidade Estadual Paulista",
    value: "Universidade Estadual Paulista",
  },
  {
    label: "Universidade Estadual Vale do Acaraú",
    value: "Universidade Estadual Vale do Acaraú",
  },
  {
    label: "Universidade Europeia",
    value: "Universidade Europeia",
  },
  {
    label: "Universidade Evangélica de Goiás",
    value: "Universidade Evangélica de Goiás",
  },
  {
    label: "Universidade Federal da Bahia",
    value: "Universidade Federal da Bahia",
  },
  {
    label: "Universidade Federal da Fronteira Sul",
    value: "Universidade Federal da Fronteira Sul",
  },
  {
    label: "Universidade Federal da Grande Dourados",
    value: "Universidade Federal da Grande Dourados",
  },
  {
    label: "Universidade Federal da Integração Latino-Americana",
    value: "Universidade Federal da Integração Latino-Americana",
  },
  {
    label: "Universidade Federal da Paraíba",
    value: "Universidade Federal da Paraíba",
  },
  {
    label: "Universidade Federal de Alagoas",
    value: "Universidade Federal de Alagoas",
  },
  {
    label: "Universidade Federal de Alfenas",
    value: "Universidade Federal de Alfenas",
  },
  {
    label: "Universidade Federal de Campina Grande",
    value: "Universidade Federal de Campina Grande",
  },
  {
    label: "Universidade Federal de Catalão",
    value: "Universidade Federal de Catalão",
  },
  {
    label: "Universidade Federal de Ciências da Saúde de Porto Alegre",
    value: "Universidade Federal de Ciências da Saúde de Porto Alegre",
  },
  {
    label: "Universidade Federal de Goiás",
    value: "Universidade Federal de Goiás",
  },
  {
    label: "Universidade Federal de Itajubá",
    value: "Universidade Federal de Itajubá",
  },
  {
    label: "Universidade Federal de Jataí",
    value: "Universidade Federal de Jataí",
  },
  {
    label: "Universidade Federal de Juiz de Fora",
    value: "Universidade Federal de Juiz de Fora",
  },
  {
    label: "Universidade Federal de Lavras",
    value: "Universidade Federal de Lavras",
  },
  {
    label: "Universidade Federal de Mato Grosso",
    value: "Universidade Federal de Mato Grosso",
  },
  {
    label: "Universidade Federal de Mato Grosso do Sul",
    value: "Universidade Federal de Mato Grosso do Sul",
  },
  {
    label: "Universidade Federal de Minas Gerais",
    value: "Universidade Federal de Minas Gerais",
  },
  {
    label: "Universidade Federal de Ouro Preto",
    value: "Universidade Federal de Ouro Preto",
  },
  {
    label: "Universidade Federal de Pelotas",
    value: "Universidade Federal de Pelotas",
  },
  {
    label: "Universidade Federal de Pernambuco",
    value: "Universidade Federal de Pernambuco",
  },
  {
    label: "Universidade Federal de Rondônia",
    value: "Universidade Federal de Rondônia",
  },
  {
    label: "Universidade Federal de Rondonópolis",
    value: "Universidade Federal de Rondonópolis",
  },
  {
    label: "Universidade Federal de Roraima",
    value: "Universidade Federal de Roraima",
  },
  {
    label: "Universidade Federal de Santa Catarina",
    value: "Universidade Federal de Santa Catarina",
  },
  {
    label: "Universidade Federal de Santa Maria",
    value: "Universidade Federal de Santa Maria",
  },
  {
    label: "Universidade Federal de São Carlos",
    value: "Universidade Federal de São Carlos",
  },
  {
    label: "Universidade Federal de São João Del Rei",
    value: "Universidade Federal de São João Del Rei",
  },
  {
    label: "Universidade Federal de São Paulo",
    value: "Universidade Federal de São Paulo",
  },
  {
    label: "Universidade Federal de Sergipe",
    value: "Universidade Federal de Sergipe",
  },
  {
    label: "Universidade Federal de Uberlândia",
    value: "Universidade Federal de Uberlândia",
  },
  {
    label: "Universidade Federal de Viçosa",
    value: "Universidade Federal de Viçosa",
  },
  {
    label: "Universidade Federal do ABC",
    value: "Universidade Federal do ABC",
  },
  {
    label: "Universidade Federal do Acre",
    value: "Universidade Federal do Acre",
  },
  {
    label: "Universidade Federal do Agreste de Pernambuco",
    value: "Universidade Federal do Agreste de Pernambuco",
  },
  {
    label: "Universidade Federal do Amapá",
    value: "Universidade Federal do Amapá",
  },
  {
    label: "Universidade Federal do Amazonas",
    value: "Universidade Federal do Amazonas",
  },
  {
    label: "Universidade Federal do Cariri",
    value: "Universidade Federal do Cariri",
  },
  {
    label: "Universidade Federal do Ceará",
    value: "Universidade Federal do Ceará",
  },
  {
    label: "Universidade Federal do Delta do Parnaíba",
    value: "Universidade Federal do Delta do Parnaíba",
  },
  {
    label: "Universidade Federal do Espírito Santo",
    value: "Universidade Federal do Espírito Santo",
  },
  {
    label: "Universidade Federal do Estado do Rio de Janeiro",
    value: "Universidade Federal do Estado do Rio de Janeiro",
  },
  {
    label: "Universidade Federal do Maranhão",
    value: "Universidade Federal do Maranhão",
  },
  {
    label: "Universidade Federal do Oeste da Bahia",
    value: "Universidade Federal do Oeste da Bahia",
  },
  {
    label: "Universidade Federal do Oeste do Pará",
    value: "Universidade Federal do Oeste do Pará",
  },
  {
    label: "Universidade Federal do Pampa",
    value: "Universidade Federal do Pampa",
  },
  {
    label: "Universidade Federal do Pará",
    value: "Universidade Federal do Pará",
  },
  {
    label: "Universidade Federal do Paraná",
    value: "Universidade Federal do Paraná",
  },
  {
    label: "Universidade Federal do Piauí",
    value: "Universidade Federal do Piauí",
  },
  {
    label: "Universidade Federal do Recôncavo da Bahia",
    value: "Universidade Federal do Recôncavo da Bahia",
  },
  {
    label: "Universidade Federal do Rio de Janeiro",
    value: "Universidade Federal do Rio de Janeiro",
  },
  {
    label: "Universidade Federal do Rio Grande",
    value: "Universidade Federal do Rio Grande",
  },
  {
    label: "Universidade Federal do Rio Grande do Norte",
    value: "Universidade Federal do Rio Grande do Norte",
  },
  {
    label: "Universidade Federal do Rio Grande do Sul",
    value: "Universidade Federal do Rio Grande do Sul",
  },
  {
    label: "Universidade Federal do Sul da Bahia",
    value: "Universidade Federal do Sul da Bahia",
  },
  {
    label: "Universidade Federal do Sul e Sudeste do Pará",
    value: "Universidade Federal do Sul e Sudeste do Pará",
  },
  {
    label: "Universidade Federal do Tocantins",
    value: "Universidade Federal do Tocantins",
  },
  {
    label: "Universidade Federal do Triângulo Mineiro",
    value: "Universidade Federal do Triângulo Mineiro",
  },
  {
    label: "Universidade Federal do Vale do São Francisco",
    value: "Universidade Federal do Vale do São Francisco",
  },
  {
    label: "Universidade Federal dos Vales do Jequitinhonha e Mucuri",
    value: "Universidade Federal dos Vales do Jequitinhonha e Mucuri",
  },
  {
    label: "Universidade Federal Fluminense",
    value: "Universidade Federal Fluminense",
  },
  {
    label: "Universidade Federal Rural da Amazônia",
    value: "Universidade Federal Rural da Amazônia",
  },
  {
    label: "Universidade Federal Rural de Pernambuco",
    value: "Universidade Federal Rural de Pernambuco",
  },
  {
    label: "Universidade Federal Rural do Rio de Janeiro",
    value: "Universidade Federal Rural do Rio de Janeiro",
  },
  {
    label: "Universidade Federal Rural do Semi-Árido",
    value: "Universidade Federal Rural do Semi-Árido",
  },
  {
    label: "Universidade Feevale",
    value: "Universidade Feevale",
  },
  {
    label: "Universidade Fernando Pessoa",
    value: "Universidade Fernando Pessoa",
  },
  {
    label: "Universidade Franciscana",
    value: "Universidade Franciscana",
  },
  {
    label: "Universidade FUMEC",
    value: "Universidade FUMEC",
  },
  {
    label: "Universidade Gregório Semedo",
    value: "Universidade Gregório Semedo",
  },
  {
    label: "Universidade Ibirapuera",
    value: "Universidade Ibirapuera",
  },
  {
    label: "Universidade Iguaçu",
    value: "Universidade Iguaçu",
  },
  {
    label: "Universidade Independente de Angola",
    value: "Universidade Independente de Angola",
  },
  {
    label: "Universidade Intercontinental de Cabo Verde",
    value: "Universidade Intercontinental de Cabo Verde",
  },
  {
    label: "Universidade Jean Piaget de Angola",
    value: "Universidade Jean Piaget de Angola",
  },
  {
    label: "Universidade Jean Piaget de Cabo Verde",
    value: "Universidade Jean Piaget de Cabo Verde",
  },
  {
    label: "Universidade Jean Piaget de Moçambique",
    value: "Universidade Jean Piaget de Moçambique",
  },
  {
    label: "Universidade José do Rosário Vellano",
    value: "Universidade José do Rosário Vellano",
  },
  {
    label: "Universidade José Eduardo dos Santos",
    value: "Universidade José Eduardo dos Santos",
  },
  {
    label: "Universidade Katyavala Bwila",
    value: "Universidade Katyavala Bwila",
  },
  {
    label: "Universidade Kimpa Vita",
    value: "Universidade Kimpa Vita",
  },
  {
    label: "Universidade La Salle",
    value: "Universidade La Salle",
  },
  {
    label: "Universidade Lueji A'Nkonde",
    value: "Universidade Lueji A'Nkonde",
  },
  {
    label: "Universidade Lúrio",
    value: "Universidade Lúrio",
  },
  {
    label: "Universidade Lusíada de Angola",
    value: "Universidade Lusíada de Angola",
  },
  {
    label: "Universidade Lusíada de Lisboa",
    value: "Universidade Lusíada de Lisboa",
  },
  {
    label: "Universidade Lusófona de Cabo Verde",
    value: "Universidade Lusófona de Cabo Verde",
  },
  {
    label: "Universidade Lusófona de Humanidades e Technologias",
    value: "Universidade Lusófona de Humanidades e Technologias",
  },
  {
    label: "Universidade Lusófona do Porto",
    value: "Universidade Lusófona do Porto",
  },
  {
    label: "Universidade Luterana do Brasil",
    value: "Universidade Luterana do Brasil",
  },
  {
    label: "Universidade Mandume Ya Ndemufayo",
    value: "Universidade Mandume Ya Ndemufayo",
  },
  {
    label: "Universidade Metodista de Angola",
    value: "Universidade Metodista de Angola",
  },
  {
    label: "Universidade Metodista de Piracicaba",
    value: "Universidade Metodista de Piracicaba",
  },
  {
    label: "Universidade Metodista de São Paulo",
    value: "Universidade Metodista de São Paulo",
  },
  {
    label: "Universidade Metropolitana de Santos",
    value: "Universidade Metropolitana de Santos",
  },
  {
    label: "Universidade Municipal de São Caetano do Sul",
    value: "Universidade Municipal de São Caetano do Sul",
  },
  {
    label: "Universidade Mussa Bin Bique",
    value: "Universidade Mussa Bin Bique",
  },
  {
    label: "Universidade Nacional Timor Lorosa'e",
    value: "Universidade Nacional Timor Lorosa'e",
  },
  {
    label: "Universidade Nilton Lins",
    value: "Universidade Nilton Lins",
  },
  {
    label: "Universidade Norte do Paraná",
    value: "Universidade Norte do Paraná",
  },
  {
    label: "Universidade Nova de Lisboa",
    value: "Universidade Nova de Lisboa",
  },
  {
    label: "Universidade Nove de Julho",
    value: "Universidade Nove de Julho",
  },
  {
    label: "Universidade Oriental Timor Lorosa'e",
    value: "Universidade Oriental Timor Lorosa'e",
  },
  {
    label: "Universidade Óscar Ribas",
    value: "Universidade Óscar Ribas",
  },
  {
    label: "Universidade Paranaense",
    value: "Universidade Paranaense",
  },
  {
    label: "Universidade Paulista",
    value: "Universidade Paulista",
  },
  {
    label: "Universidade Pedagógica",
    value: "Universidade Pedagógica",
  },
  {
    label: "Universidade Politécnica",
    value: "Universidade Politécnica",
  },
  {
    label: "Universidade Politécnica de Macau",
    value: "Universidade Politécnica de Macau",
  },
  {
    label: "Universidade Portucalense Infante D. Henrique",
    value: "Universidade Portucalense Infante D. Henrique",
  },
  {
    label: "Universidade Positivo",
    value: "Universidade Positivo",
  },
  {
    label: "Universidade Potiguar",
    value: "Universidade Potiguar",
  },
  {
    label: "Universidade Presbiteriana Mackenzie",
    value: "Universidade Presbiteriana Mackenzie",
  },
  {
    label: "Universidade Privada de Angola",
    value: "Universidade Privada de Angola",
  },
  {
    label: "Universidade Regional de Blumenau",
    value: "Universidade Regional de Blumenau",
  },
  {
    label: "Universidade Regional do Cariri",
    value: "Universidade Regional do Cariri",
  },
  {
    label: "Universidade Regional do Noroeste do Estado do Rio Grande do Sul",
    value: "Universidade Regional do Noroeste do Estado do Rio Grande do Sul",
  },
  {
    label: "Universidade Regional Integrada do Alto Uruguai e das Missões",
    value: "Universidade Regional Integrada do Alto Uruguai e das Missões",
  },
  {
    label: "Universidade Salgado de Oliveira",
    value: "Universidade Salgado de Oliveira",
  },
  {
    label: "Universidade Salvador",
    value: "Universidade Salvador",
  },
  {
    label: "Universidade Santa Cecília",
    value: "Universidade Santa Cecília",
  },
  {
    label: "Universidade Santa Úrsula",
    value: "Universidade Santa Úrsula",
  },
  {
    label: "Universidade Santo Amaro",
    value: "Universidade Santo Amaro",
  },
  {
    label: "Universidade São Francisco",
    value: "Universidade São Francisco",
  },
  {
    label: "Universidade São Judas Tadeu",
    value: "Universidade São Judas Tadeu",
  },
  {
    label: "Universidade São Tomás de Moçambique",
    value: "Universidade São Tomás de Moçambique",
  },
  {
    label: "Universidade Save",
    value: "Universidade Save",
  },
  {
    label: "Universidade Técnica de Angola",
    value: "Universidade Técnica de Angola",
  },
  {
    label: "Universidade Técnica de Moçambique",
    value: "Universidade Técnica de Moçambique",
  },
  {
    label: "Universidade Tecnológica Federal do Paraná",
    value: "Universidade Tecnológica Federal do Paraná",
  },
  {
    label: "Universidade Tiradentes",
    value: "Universidade Tiradentes",
  },
  {
    label: "Universidade Tuiuti do Paraná",
    value: "Universidade Tuiuti do Paraná",
  },
  {
    label: "Universidade Universus Veritas Guarulhos",
    value: "Universidade Universus Veritas Guarulhos",
  },
  {
    label: "Universidade Vale do Rio Doce",
    value: "Universidade Vale do Rio Doce",
  },
  {
    label: "Universidade Veiga de Almeida",
    value: "Universidade Veiga de Almeida",
  },
  {
    label: "Universidade Vila Velha",
    value: "Universidade Vila Velha",
  },
  {
    label: "Universidade Zambeze",
    value: "Universidade Zambeze",
  },
  {
    label: "Università Ca' Foscari di Venezia",
    value: "Università Ca' Foscari di Venezia",
  },
  {
    label: "Università Campus Bio-Medico di Roma",
    value: "Università Campus Bio-Medico di Roma",
  },
  {
    label: "Università Cattolica del Sacro Cuore",
    value: "Università Cattolica del Sacro Cuore",
  },
  {
    label: "Università Commerciale Luigi Bocconi",
    value: "Università Commerciale Luigi Bocconi",
  },
  {
    label: "Università degli Studi del Molise",
    value: "Università degli Studi del Molise",
  },
  {
    label: "Università degli Studi del Piemonte Orientale",
    value: "Università degli Studi del Piemonte Orientale",
  },
  {
    label: "Università degli Studi del Sannio di Benevento",
    value: "Università degli Studi del Sannio di Benevento",
  },
  {
    label: "Università degli Studi della Basilicata",
    value: "Università degli Studi della Basilicata",
  },
  {
    label: "Università degli Studi della Campania Luigi Vanvitelli",
    value: "Università degli Studi della Campania Luigi Vanvitelli",
  },
  {
    label: "Università degli Studi della Tuscia",
    value: "Università degli Studi della Tuscia",
  },
  {
    label: "Università degli Studi dell'Aquila",
    value: "Università degli Studi dell'Aquila",
  },
  {
    label: "Università degli Studi dell'Insubria",
    value: "Università degli Studi dell'Insubria",
  },
  {
    label: "Università degli Studi di Bari Aldo Moro",
    value: "Università degli Studi di Bari Aldo Moro",
  },
  {
    label: "Università degli Studi di Bergamo",
    value: "Università degli Studi di Bergamo",
  },
  {
    label: "Università degli Studi di Brescia",
    value: "Università degli Studi di Brescia",
  },
  {
    label: "Università degli Studi di Cagliari",
    value: "Università degli Studi di Cagliari",
  },
  {
    label: "Università degli Studi di Camerino",
    value: "Università degli Studi di Camerino",
  },
  {
    label: "Università degli Studi di Cassino e del Lazio Meridionale",
    value: "Università degli Studi di Cassino e del Lazio Meridionale",
  },
  {
    label: "Università degli Studi di Catania",
    value: "Università degli Studi di Catania",
  },
  {
    label: "Università degli Studi di Enna Kore",
    value: "Università degli Studi di Enna Kore",
  },
  {
    label: "Università degli Studi di Ferrara",
    value: "Università degli Studi di Ferrara",
  },
  {
    label: "Università degli Studi di Firenze",
    value: "Università degli Studi di Firenze",
  },
  {
    label: "Università degli Studi di Foggia",
    value: "Università degli Studi di Foggia",
  },
  {
    label: "Università degli Studi di Genova",
    value: "Università degli Studi di Genova",
  },
  {
    label: "Università degli Studi di Macerata",
    value: "Università degli Studi di Macerata",
  },
  {
    label: "Università degli Studi di Messina",
    value: "Università degli Studi di Messina",
  },
  {
    label: "Università degli Studi di Milano",
    value: "Università degli Studi di Milano",
  },
  {
    label: "Università degli Studi di Milano-Bicocca",
    value: "Università degli Studi di Milano-Bicocca",
  },
  {
    label: "Università degli Studi di Modena e Reggio Emilia",
    value: "Università degli Studi di Modena e Reggio Emilia",
  },
  {
    label: "Università degli Studi di Napoli 'L'Orientale'",
    value: "Università degli Studi di Napoli 'L'Orientale'",
  },
  {
    label: "Università degli Studi di Napoli Federico II",
    value: "Università degli Studi di Napoli Federico II",
  },
  {
    label: "Università degli Studi di Napoli Parthenope",
    value: "Università degli Studi di Napoli Parthenope",
  },
  {
    label: "Università degli Studi di Padova",
    value: "Università degli Studi di Padova",
  },
  {
    label: "Università degli Studi di Palermo",
    value: "Università degli Studi di Palermo",
  },
  {
    label: "Università degli Studi di Parma",
    value: "Università degli Studi di Parma",
  },
  {
    label: "Università degli Studi di Pavia",
    value: "Università degli Studi di Pavia",
  },
  {
    label: "Università degli Studi di Perugia",
    value: "Università degli Studi di Perugia",
  },
  {
    label: "Università degli Studi di Pisa",
    value: "Università degli Studi di Pisa",
  },
  {
    label: "Università degli Studi di Roma Foro Italico",
    value: "Università degli Studi di Roma Foro Italico",
  },
  {
    label: "Università degli Studi di Roma Tor Vergata",
    value: "Università degli Studi di Roma Tor Vergata",
  },
  {
    label: "Università degli Studi di Salerno",
    value: "Università degli Studi di Salerno",
  },
  {
    label: "Universita' degli Studi di San Marino",
    value: "Universita' degli Studi di San Marino",
  },
  {
    label: "Università degli Studi di Sassari",
    value: "Università degli Studi di Sassari",
  },
  {
    label: "Università degli Studi di Scienze Gastronomiche",
    value: "Università degli Studi di Scienze Gastronomiche",
  },
  {
    label: "Università degli Studi di Siena",
    value: "Università degli Studi di Siena",
  },
  {
    label: "Università degli Studi di Teramo",
    value: "Università degli Studi di Teramo",
  },
  {
    label: "Università degli Studi di Torino",
    value: "Università degli Studi di Torino",
  },
  {
    label: "Università degli Studi di Trento",
    value: "Università degli Studi di Trento",
  },
  {
    label: "Università degli Studi di Trieste",
    value: "Università degli Studi di Trieste",
  },
  {
    label: "Università degli Studi di Udine",
    value: "Università degli Studi di Udine",
  },
  {
    label: "Università degli Studi di Urbino Carlo Bo",
    value: "Università degli Studi di Urbino Carlo Bo",
  },
  {
    label: "Università degli Studi di Verona",
    value: "Università degli Studi di Verona",
  },
  {
    label: "Università degli Studi G. d'Annunzio Chieti-Pescara",
    value: "Università degli Studi G. d'Annunzio Chieti-Pescara",
  },
  {
    label: "Università degli Studi Internazionali di Roma",
    value: "Università degli Studi Internazionali di Roma",
  },
  {
    label: "Università degli Studi Magna Graecia di Catanzaro",
    value: "Università degli Studi Magna Graecia di Catanzaro",
  },
  {
    label: "Università degli Studi Mediterranea di Reggio Calabria",
    value: "Università degli Studi Mediterranea di Reggio Calabria",
  },
  {
    label: "Università degli Studi Roma Tre",
    value: "Università degli Studi Roma Tre",
  },
  {
    label: "Università degli Studi Suor Orsola Benincasa",
    value: "Università degli Studi Suor Orsola Benincasa",
  },
  {
    label: "Università del Salento",
    value: "Università del Salento",
  },
  {
    label: "Università della Calabria",
    value: "Università della Calabria",
  },
  {
    label: "Università della Svizzera Italiana",
    value: "Università della Svizzera Italiana",
  },
  {
    label: "Università della Valle d'Aosta",
    value: "Università della Valle d'Aosta",
  },
  {
    label: "Università Europea di Roma",
    value: "Università Europea di Roma",
  },
  {
    label: "Università HUMANITAS di Milano",
    value: "Università HUMANITAS di Milano",
  },
  {
    label: "Università Iuav di Venezia",
    value: "Università Iuav di Venezia",
  },
  {
    label: "Università LUM Jean Monnet",
    value: "Università LUM Jean Monnet",
  },
  {
    label: "Università per stranieri Dante Alighieri di Reggio Calabria",
    value: "Università per stranieri Dante Alighieri di Reggio Calabria",
  },
  {
    label: "Università per Stranieri di Perugia",
    value: "Università per Stranieri di Perugia",
  },
  {
    label: "Università per Stranieri di Siena",
    value: "Università per Stranieri di Siena",
  },
  {
    label: "Università Politecnica delle Marche",
    value: "Università Politecnica delle Marche",
  },
  {
    label: "Università Pontificia Salesiana",
    value: "Università Pontificia Salesiana",
  },
  {
    label: "Università Vita-Salute San Raffaele",
    value: "Università Vita-Salute San Raffaele",
  },
  {
    label: "Universitad Nacional de Derechos Humanos Madres de Plaza de Mayo",
    value: "Universitad Nacional de Derechos Humanos Madres de Plaza de Mayo",
  },
  {
    label: "Universitaria Agustiniana",
    value: "Universitaria Agustiniana",
  },
  {
    label: "Universitaria del Chicamocha",
    value: "Universitaria del Chicamocha",
  },
  {
    label: "Universitas 17 Agustus 1945",
    value: "Universitas 17 Agustus 1945",
  },
  {
    label: "Universitas 17 Agustus 1945 Banyuwangi",
    value: "Universitas 17 Agustus 1945 Banyuwangi",
  },
  {
    label: "Universitas 17 Agustus 1945 Cirebon",
    value: "Universitas 17 Agustus 1945 Cirebon",
  },
  {
    label: "Universitas 17 Agustus 1945 Samarinda",
    value: "Universitas 17 Agustus 1945 Samarinda",
  },
  {
    label: "Universitas 17 Agustus 1945 Semarang",
    value: "Universitas 17 Agustus 1945 Semarang",
  },
  {
    label: "Universitas 17 Agustus 1945 Surabaya",
    value: "Universitas 17 Agustus 1945 Surabaya",
  },
  {
    label: "Universitas 45 Mataram",
    value: "Universitas 45 Mataram",
  },
  {
    label: "Universitas 45 Surabaya",
    value: "Universitas 45 Surabaya",
  },
  {
    label: "Universitas Abdurachman Saleh",
    value: "Universitas Abdurachman Saleh",
  },
  {
    label: "Universitas Abdurrab",
    value: "Universitas Abdurrab",
  },
  {
    label: "Universitas Abulyatama",
    value: "Universitas Abulyatama",
  },
  {
    label: "Universitas Achmad Yani",
    value: "Universitas Achmad Yani",
  },
  {
    label: "Universitas Adhirajasa Reswara Sanjaya",
    value: "Universitas Adhirajasa Reswara Sanjaya",
  },
  {
    label: "Universitas Advent Indonesia",
    value: "Universitas Advent Indonesia",
  },
  {
    label: "Universitas Ahmad Dahlan",
    value: "Universitas Ahmad Dahlan",
  },
  {
    label: "Universitas Airlangga",
    value: "Universitas Airlangga",
  },
  {
    label: "Universitas 'Aisyiyah Surakarta",
    value: "Universitas 'Aisyiyah Surakarta",
  },
  {
    label: "Universitas Aisyiyah Yogyakarta",
    value: "Universitas Aisyiyah Yogyakarta",
  },
  {
    label: "Universitas AKI",
    value: "Universitas AKI",
  },
  {
    label: "Universitas Al Asyariah Mandar",
    value: "Universitas Al Asyariah Mandar",
  },
  {
    label: "Universitas Al Azhar Indonesia",
    value: "Universitas Al Azhar Indonesia",
  },
  {
    label: "Universitas Al Ghifari",
    value: "Universitas Al Ghifari",
  },
  {
    label: "Universitas Al Muslim",
    value: "Universitas Al Muslim",
  },
  {
    label: "Universitas Al-Azhar",
    value: "Universitas Al-Azhar",
  },
  {
    label: "Universitas Alkhairaat",
    value: "Universitas Alkhairaat",
  },
  {
    label: "Universitas Alma Ata",
    value: "Universitas Alma Ata",
  },
  {
    label: "Universitas Alwashliyah",
    value: "Universitas Alwashliyah",
  },
  {
    label: "Universitas Al-washliyah Labuhan Batu",
    value: "Universitas Al-washliyah Labuhan Batu",
  },
  {
    label: "Universitas AMIKOM Yogyakarta",
    value: "Universitas AMIKOM Yogyakarta",
  },
  {
    label: "Universitas Amir Hamzah",
    value: "Universitas Amir Hamzah",
  },
  {
    label: "Universitas Andalas",
    value: "Universitas Andalas",
  },
  {
    label: "Universitas Andi Djemma",
    value: "Universitas Andi Djemma",
  },
  {
    label: "Universitas Antakusuma",
    value: "Universitas Antakusuma",
  },
  {
    label: "Universitas Aryasatya Deo Muri",
    value: "Universitas Aryasatya Deo Muri",
  },
  {
    label: "Universitas Asahan",
    value: "Universitas Asahan",
  },
  {
    label: "Universitas Atma Jaya Makassar",
    value: "Universitas Atma Jaya Makassar",
  },
  {
    label: "Universitas Atma Jaya Yogyakarta",
    value: "Universitas Atma Jaya Yogyakarta",
  },
  {
    label: "Universitas Azzahra",
    value: "Universitas Azzahra",
  },
  {
    label: "Universitas Baiturrahmah",
    value: "Universitas Baiturrahmah",
  },
  {
    label: "Universitas Bakrie",
    value: "Universitas Bakrie",
  },
  {
    label: "Universitas Bakti Indonesia",
    value: "Universitas Bakti Indonesia",
  },
  {
    label: "Universitas Bale Bandung",
    value: "Universitas Bale Bandung",
  },
  {
    label: "Universitas Bali Internasional",
    value: "Universitas Bali Internasional",
  },
  {
    label: "Universitas Balikpapan",
    value: "Universitas Balikpapan",
  },
  {
    label: "Universitas Bandar Lampung",
    value: "Universitas Bandar Lampung",
  },
  {
    label: "Universitas Bandung Raya",
    value: "Universitas Bandung Raya",
  },
  {
    label: "Universitas Bangka Belitung",
    value: "Universitas Bangka Belitung",
  },
  {
    label: "Universitas Banten Jaya",
    value: "Universitas Banten Jaya",
  },
  {
    label: "Universitas Batam",
    value: "Universitas Batam",
  },
  {
    label: "Universitas Batanghari",
    value: "Universitas Batanghari",
  },
  {
    label: "Universitas Baturaja",
    value: "Universitas Baturaja",
  },
  {
    label: "Universitas Bengkulu",
    value: "Universitas Bengkulu",
  },
  {
    label: "Universitas Bhayangkara Jakarta Raya",
    value: "Universitas Bhayangkara Jakarta Raya",
  },
  {
    label: "Universitas Bhayangkara Surabaya",
    value: "Universitas Bhayangkara Surabaya",
  },
  {
    label: "Universitas Billfath",
    value: "Universitas Billfath",
  },
  {
    label: "Universitas Bina Bangsa Getsempena",
    value: "Universitas Bina Bangsa Getsempena",
  },
  {
    label: "Universitas Bina Darma",
    value: "Universitas Bina Darma",
  },
  {
    label: "Universitas Bina Insan",
    value: "Universitas Bina Insan",
  },
  {
    label: "Universitas Bina Insani",
    value: "Universitas Bina Insani",
  },
  {
    label: "Universitas Bina Nusantara",
    value: "Universitas Bina Nusantara",
  },
  {
    label: "Universitas Bina Sarana Informatika",
    value: "Universitas Bina Sarana Informatika",
  },
  {
    label: "Universitas Bojonegoro",
    value: "Universitas Bojonegoro",
  },
  {
    label: "Universitas Bondowoso",
    value: "Universitas Bondowoso",
  },
  {
    label: "Universitas Borneo Tarakan",
    value: "Universitas Borneo Tarakan",
  },
  {
    label: "Universitas Borobudur",
    value: "Universitas Borobudur",
  },
  {
    label: "Universitas Bosowa",
    value: "Universitas Bosowa",
  },
  {
    label: "Universitas Boyolali",
    value: "Universitas Boyolali",
  },
  {
    label: "Universitas Brawijaya",
    value: "Universitas Brawijaya",
  },
  {
    label: "Universitas Buana Perjuangan Karawang",
    value: "Universitas Buana Perjuangan Karawang",
  },
  {
    label: "Universitas Buddhi Dharma",
    value: "Universitas Buddhi Dharma",
  },
  {
    label: "Universitas Budi Luhur",
    value: "Universitas Budi Luhur",
  },
  {
    label: "Universitas Bumi Hijrah",
    value: "Universitas Bumi Hijrah",
  },
  {
    label: "Universitas Bunda Mulia",
    value: "Universitas Bunda Mulia",
  },
  {
    label: "Universitas Bung Hatta",
    value: "Universitas Bung Hatta",
  },
  {
    label: "Universitas Bung Karno",
    value: "Universitas Bung Karno",
  },
  {
    label: "Universitas Cenderawasih",
    value: "Universitas Cenderawasih",
  },
  {
    label: "Universitas Ciputra",
    value: "Universitas Ciputra",
  },
  {
    label: "Universitas Cokroaminoto Makassar",
    value: "Universitas Cokroaminoto Makassar",
  },
  {
    label: "Universitas Cokroaminoto Palopo",
    value: "Universitas Cokroaminoto Palopo",
  },
  {
    label: "Universitas Cokroaminoto Yogyakarta",
    value: "Universitas Cokroaminoto Yogyakarta",
  },
  {
    label: "Universitas Cordova",
    value: "Universitas Cordova",
  },
  {
    label: "Universitas Darma Agung",
    value: "Universitas Darma Agung",
  },
  {
    label: "Universitas Darma Persada",
    value: "Universitas Darma Persada",
  },
  {
    label: "Universitas Darul 'ulum",
    value: "Universitas Darul 'ulum",
  },
  {
    label: "Universitas Darul Ulum Islamic Centre Sudirman",
    value: "Universitas Darul Ulum Islamic Centre Sudirman",
  },
  {
    label: "Universitas Darussalam Ambon",
    value: "Universitas Darussalam Ambon",
  },
  {
    label: "Universitas Darussalam Gontor",
    value: "Universitas Darussalam Gontor",
  },
  {
    label: "Universitas Darwan Ali",
    value: "Universitas Darwan Ali",
  },
  {
    label: "Universitas Dayanu Ikhsanuddin",
    value: "Universitas Dayanu Ikhsanuddin",
  },
  {
    label: "Universitas Dehasen Bengkulu",
    value: "Universitas Dehasen Bengkulu",
  },
  {
    label: "Universitas Dharma Andalas",
    value: "Universitas Dharma Andalas",
  },
  {
    label: "Universitas Dharmas Indonesia",
    value: "Universitas Dharmas Indonesia",
  },
  {
    label: "Universitas Dharmawangsa",
    value: "Universitas Dharmawangsa",
  },
  {
    label: "Universitas Dhyana Pura",
    value: "Universitas Dhyana Pura",
  },
  {
    label: "Universitas Dian Nusantara",
    value: "Universitas Dian Nusantara",
  },
  {
    label: "Universitas Dian Nuswantoro",
    value: "Universitas Dian Nuswantoro",
  },
  {
    label: "Universitas Dinamika",
    value: "Universitas Dinamika",
  },
  {
    label: "Universitas Dinamika Bangsa",
    value: "Universitas Dinamika Bangsa",
  },
  {
    label: "Universitas Diponegoro",
    value: "Universitas Diponegoro",
  },
  {
    label: "Universitas Dirgantara Marsekal Suryadarma",
    value: "Universitas Dirgantara Marsekal Suryadarma",
  },
  {
    label: "Universitas Djuanda",
    value: "Universitas Djuanda",
  },
  {
    label: "Universitas Doktor Nugroho Magetan",
    value: "Universitas Doktor Nugroho Magetan",
  },
  {
    label: "Universitas Dr. Soetomo",
    value: "Universitas Dr. Soetomo",
  },
  {
    label: "Universitas Dumoga Kotamobagu",
    value: "Universitas Dumoga Kotamobagu",
  },
  {
    label: "Universitas Duta Bangsa Surakarta",
    value: "Universitas Duta Bangsa Surakarta",
  },
  {
    label: "Universitas Dwijendra",
    value: "Universitas Dwijendra",
  },
  {
    label: "Universitas Efarina",
    value: "Universitas Efarina",
  },
  {
    label: "Universitas Ekasakti",
    value: "Universitas Ekasakti",
  },
  {
    label: "Universitas Esa Unggul",
    value: "Universitas Esa Unggul",
  },
  {
    label: "Universitas Fajar",
    value: "Universitas Fajar",
  },
  {
    label: "Universitas Flores",
    value: "Universitas Flores",
  },
  {
    label: "Universitas Gadjah Mada",
    value: "Universitas Gadjah Mada",
  },
  {
    label: "Universitas Gajah Putih",
    value: "Universitas Gajah Putih",
  },
  {
    label: "Universitas Gajayana Malang",
    value: "Universitas Gajayana Malang",
  },
  {
    label: "Universitas Galuh Ciamis",
    value: "Universitas Galuh Ciamis",
  },
  {
    label: "Universitas Garut",
    value: "Universitas Garut",
  },
  {
    label: "Universitas Gorontalo",
    value: "Universitas Gorontalo",
  },
  {
    label: "Universitas Graha Nusantara Padangsidimpuan",
    value: "Universitas Graha Nusantara Padangsidimpuan",
  },
  {
    label: "Universitas Gresik",
    value: "Universitas Gresik",
  },
  {
    label: "Universitas Gunadarma",
    value: "Universitas Gunadarma",
  },
  {
    label: "Universitas Gunung Kidul",
    value: "Universitas Gunung Kidul",
  },
  {
    label: "Universitas Gunung Leuser Aceh",
    value: "Universitas Gunung Leuser Aceh",
  },
  {
    label: "Universitas Gunung Rinjani",
    value: "Universitas Gunung Rinjani",
  },
  {
    label: "Universitas Halmahera",
    value: "Universitas Halmahera",
  },
  {
    label: "Universitas Halu Oleo",
    value: "Universitas Halu Oleo",
  },
  {
    label: "Universitas Hamzanwadi",
    value: "Universitas Hamzanwadi",
  },
  {
    label: "Universitas Hang Tuah",
    value: "Universitas Hang Tuah",
  },
  {
    label: "Universitas Harapan Bangsa",
    value: "Universitas Harapan Bangsa",
  },
  {
    label: "Universitas Hasanuddin",
    value: "Universitas Hasanuddin",
  },
  {
    label: "Universitas Hasyim Asy'ari",
    value: "Universitas Hasyim Asy'ari",
  },
  {
    label: "Universitas Hein Namotemo",
    value: "Universitas Hein Namotemo",
  },
  {
    label: "Universitas Hindu Indonesia",
    value: "Universitas Hindu Indonesia",
  },
  {
    label: "Universitas HKBP Nommensen",
    value: "Universitas HKBP Nommensen",
  },
  {
    label: "Universitas IBA",
    value: "Universitas IBA",
  },
  {
    label: "Universitas Ibn Khaldun",
    value: "Universitas Ibn Khaldun",
  },
  {
    label: "Universitas Ibnu Chaldun",
    value: "Universitas Ibnu Chaldun",
  },
  {
    label: "Universitas Ichsan Gorontalo",
    value: "Universitas Ichsan Gorontalo",
  },
  {
    label: "Universitas Indo Global Mandiri",
    value: "Universitas Indo Global Mandiri",
  },
  {
    label: "Universitas Indonesia",
    value: "Universitas Indonesia",
  },
  {
    label: "Universitas Indonesia Membangun",
    value: "Universitas Indonesia Membangun",
  },
  {
    label: "Universitas Indonesia Timur",
    value: "Universitas Indonesia Timur",
  },
  {
    label: "Universitas Indraprasta PGRI",
    value: "Universitas Indraprasta PGRI",
  },
  {
    label: "Universitas Informatika Dan Bisnis Indonesia",
    value: "Universitas Informatika Dan Bisnis Indonesia",
  },
  {
    label: "Universitas Internasional Batam",
    value: "Universitas Internasional Batam",
  },
  {
    label: "Universitas Internasional Semen Indonesia",
    value: "Universitas Internasional Semen Indonesia",
  },
  {
    label: "Universitas Iqra Buru",
    value: "Universitas Iqra Buru",
  },
  {
    label: "Universitas Iskandarmuda",
    value: "Universitas Iskandarmuda",
  },
  {
    label: "Universitas Islam 45 Bekasi",
    value: "Universitas Islam 45 Bekasi",
  },
  {
    label: "Universitas Islam Al-azhar Mataram",
    value: "Universitas Islam Al-azhar Mataram",
  },
  {
    label: "Universitas Islam Al-Ihya Kuningan",
    value: "Universitas Islam Al-Ihya Kuningan",
  },
  {
    label: "Universitas Islam As-Syafiiyah",
    value: "Universitas Islam As-Syafiiyah",
  },
  {
    label: "Universitas Islam Attahiriyah",
    value: "Universitas Islam Attahiriyah",
  },
  {
    label: "Universitas Islam Balitar",
    value: "Universitas Islam Balitar",
  },
  {
    label: "Universitas Islam Bandung",
    value: "Universitas Islam Bandung",
  },
  {
    label: "Universitas Islam Batik",
    value: "Universitas Islam Batik",
  },
  {
    label: "Universitas Islam Darul Ulum Lamongan",
    value: "Universitas Islam Darul Ulum Lamongan",
  },
  {
    label: "Universitas Islam Indonesia",
    value: "Universitas Islam Indonesia",
  },
  {
    label: "Universitas Islam Indragiri",
    value: "Universitas Islam Indragiri",
  },
  {
    label: "Universitas Islam Internasional Indonesia",
    value: "Universitas Islam Internasional Indonesia",
  },
  {
    label: "Universitas Islam Jakarta",
    value: "Universitas Islam Jakarta",
  },
  {
    label: "Universitas Islam Jember",
    value: "Universitas Islam Jember",
  },
  {
    label: "Universitas Islam Kadiri",
    value: "Universitas Islam Kadiri",
  },
  {
    label: "Universitas Islam Kalimantan Muhammad Arsyad Al Banjari",
    value: "Universitas Islam Kalimantan Muhammad Arsyad Al Banjari",
  },
  {
    label: "Universitas Islam Kuantan Singingi",
    value: "Universitas Islam Kuantan Singingi",
  },
  {
    label: "Universitas Islam Labuhan Batu",
    value: "Universitas Islam Labuhan Batu",
  },
  {
    label: "Universitas Islam Lamongan",
    value: "Universitas Islam Lamongan",
  },
  {
    label: "Universitas Islam Madura Pamekasan",
    value: "Universitas Islam Madura Pamekasan",
  },
  {
    label: "Universitas Islam Majapahit",
    value: "Universitas Islam Majapahit",
  },
  {
    label: "Universitas Islam Makassar",
    value: "Universitas Islam Makassar",
  },
  {
    label: "Universitas Islam Malang",
    value: "Universitas Islam Malang",
  },
  {
    label: "Universitas Islam Nahdlatul Ulama",
    value: "Universitas Islam Nahdlatul Ulama",
  },
  {
    label: "Universitas Islam Negeri Alauddin Makassar",
    value: "Universitas Islam Negeri Alauddin Makassar",
  },
  {
    label: "Universitas Islam Negeri Antasari Banjarmasin",
    value: "Universitas Islam Negeri Antasari Banjarmasin",
  },
  {
    label: "Universitas Islam Negeri Ar-Raniry",
    value: "Universitas Islam Negeri Ar-Raniry",
  },
  {
    label: "Universitas Islam Negeri Datokarama Palu",
    value: "Universitas Islam Negeri Datokarama Palu",
  },
  {
    label: "Universitas Islam Negeri Imam Bonjol",
    value: "Universitas Islam Negeri Imam Bonjol",
  },
  {
    label: "Universitas Islam Negeri Mataram",
    value: "Universitas Islam Negeri Mataram",
  },
  {
    label: "Universitas Islam Negeri Maulana Malik Ibrahim Malang",
    value: "Universitas Islam Negeri Maulana Malik Ibrahim Malang",
  },
  {
    label: "Universitas Islam Negeri Raden Fatah",
    value: "Universitas Islam Negeri Raden Fatah",
  },
  {
    label: "Universitas Islam Negeri Raden Intan Lampung",
    value: "Universitas Islam Negeri Raden Intan Lampung",
  },
  {
    label: "Universitas Islam Negeri Sultan Maulana Hasanuddin Banten",
    value: "Universitas Islam Negeri Sultan Maulana Hasanuddin Banten",
  },
  {
    label: "Universitas Islam Negeri Sultan Syarif Kasim Riau",
    value: "Universitas Islam Negeri Sultan Syarif Kasim Riau",
  },
  {
    label: "Universitas Islam Negeri Sulthan Thaha Saifuddin Jambi",
    value: "Universitas Islam Negeri Sulthan Thaha Saifuddin Jambi",
  },
  {
    label: "Universitas Islam Negeri Sumatera Utara",
    value: "Universitas Islam Negeri Sumatera Utara",
  },
  {
    label: "Universitas Islam Negeri Sunan Ampel Surabaya",
    value: "Universitas Islam Negeri Sunan Ampel Surabaya",
  },
  {
    label: "Universitas Islam Negeri Sunan Gunung Djati",
    value: "Universitas Islam Negeri Sunan Gunung Djati",
  },
  {
    label: "Universitas Islam Negeri Sunan Kalijaga Yogyakarta",
    value: "Universitas Islam Negeri Sunan Kalijaga Yogyakarta",
  },
  {
    label: "Universitas Islam Negeri Syarif Hidayatullah Jakarta",
    value: "Universitas Islam Negeri Syarif Hidayatullah Jakarta",
  },
  {
    label: "Universitas Islam Negeri Walisongo",
    value: "Universitas Islam Negeri Walisongo",
  },
  {
    label: "Universitas Islam Nusantara",
    value: "Universitas Islam Nusantara",
  },
  {
    label: "Universitas Islam Ogan Komering Ilir Kayuagung",
    value: "Universitas Islam Ogan Komering Ilir Kayuagung",
  },
  {
    label: "Universitas Islam Raden Rahmat",
    value: "Universitas Islam Raden Rahmat",
  },
  {
    label: "Universitas Islam Riau",
    value: "Universitas Islam Riau",
  },
  {
    label: "Universitas Islam Sultan Agung",
    value: "Universitas Islam Sultan Agung",
  },
  {
    label: "Universitas Islam Sumatera Barat",
    value: "Universitas Islam Sumatera Barat",
  },
  {
    label: "Universitas Islam Sumatera Utara",
    value: "Universitas Islam Sumatera Utara",
  },
  {
    label: "Universitas Islam Syekh-Yusuf",
    value: "Universitas Islam Syekh-Yusuf",
  },
  {
    label: "Universitas Jabal Ghafur",
    value: "Universitas Jabal Ghafur",
  },
  {
    label: "Universitas Jakarta",
    value: "Universitas Jakarta",
  },
  {
    label: "Universitas Jambi",
    value: "Universitas Jambi",
  },
  {
    label: "Universitas Janabadra",
    value: "Universitas Janabadra",
  },
  {
    label: "Universitas Jayabaya",
    value: "Universitas Jayabaya",
  },
  {
    label: "Universitas Jember",
    value: "Universitas Jember",
  },
  {
    label: "Universitas Jenderal Achmad Yani",
    value: "Universitas Jenderal Achmad Yani",
  },
  {
    label: "Universitas Jenderal Soedirman",
    value: "Universitas Jenderal Soedirman",
  },
  {
    label: "Universitas Kader Bangsa",
    value: "Universitas Kader Bangsa",
  },
  {
    label: "Universitas Kadiri",
    value: "Universitas Kadiri",
  },
  {
    label: "Universitas Kahuripan Kediri",
    value: "Universitas Kahuripan Kediri",
  },
  {
    label: "Universitas Kaltara",
    value: "Universitas Kaltara",
  },
  {
    label: "Universitas Kanjuruhan Malang",
    value: "Universitas Kanjuruhan Malang",
  },
  {
    label: "Universitas Kapuas Sintang",
    value: "Universitas Kapuas Sintang",
  },
  {
    label: "Universitas Karimun",
    value: "Universitas Karimun",
  },
  {
    label: "Universitas Karo",
    value: "Universitas Karo",
  },
  {
    label: "Universitas Karya Dharma Makassar",
    value: "Universitas Karya Dharma Makassar",
  },
  {
    label: "Universitas Karyadarma Kupang",
    value: "Universitas Karyadarma Kupang",
  },
  {
    label: "Universitas Katolik Darma Cendika",
    value: "Universitas Katolik Darma Cendika",
  },
  {
    label: "Universitas Katolik De La Salle",
    value: "Universitas Katolik De La Salle",
  },
  {
    label: "Universitas Katolik Indonesia Atma Jaya",
    value: "Universitas Katolik Indonesia Atma Jaya",
  },
  {
    label: "Universitas Katolik Musi Charitas",
    value: "Universitas Katolik Musi Charitas",
  },
  {
    label: "Universitas Katolik Parahyangan",
    value: "Universitas Katolik Parahyangan",
  },
  {
    label: "Universitas Katolik Santo Thomas",
    value: "Universitas Katolik Santo Thomas",
  },
  {
    label: "Universitas Katolik Soegijapranata",
    value: "Universitas Katolik Soegijapranata",
  },
  {
    label: "Universitas Katolik Widya Karya",
    value: "Universitas Katolik Widya Karya",
  },
  {
    label: "Universitas Katolik Widya Mandala Madiun",
    value: "Universitas Katolik Widya Mandala Madiun",
  },
  {
    label: "Universitas Katolik Widya Mandala Surabaya",
    value: "Universitas Katolik Widya Mandala Surabaya",
  },
  {
    label: "Universitas Katolik Widya Mandira",
    value: "Universitas Katolik Widya Mandira",
  },
  {
    label: "Universitas Kebangsaan",
    value: "Universitas Kebangsaan",
  },
  {
    label: "Universitas KH. A. Wahab Hasbullah",
    value: "Universitas KH. A. Wahab Hasbullah",
  },
  {
    label: "Universitas Khairun",
    value: "Universitas Khairun",
  },
  {
    label: "Universitas Klabat",
    value: "Universitas Klabat",
  },
  {
    label: "Universitas Komputer Indonesia",
    value: "Universitas Komputer Indonesia",
  },
  {
    label: "Universitas Krisnadwipayana",
    value: "Universitas Krisnadwipayana",
  },
  {
    label: "Universitas Kristen Artha Wacana",
    value: "Universitas Kristen Artha Wacana",
  },
  {
    label: "Universitas Kristen Duta Wacana",
    value: "Universitas Kristen Duta Wacana",
  },
  {
    label: "Universitas Kristen Immanuel",
    value: "Universitas Kristen Immanuel",
  },
  {
    label: "Universitas Kristen Indonesia",
    value: "Universitas Kristen Indonesia",
  },
  {
    label: "Universitas Kristen Indonesia Maluku",
    value: "Universitas Kristen Indonesia Maluku",
  },
  {
    label: "Universitas Kristen Indonesia Paulus",
    value: "Universitas Kristen Indonesia Paulus",
  },
  {
    label: "Universitas Kristen Indonesia Tomohon",
    value: "Universitas Kristen Indonesia Tomohon",
  },
  {
    label: "Universitas Kristen Indonesia Toraja",
    value: "Universitas Kristen Indonesia Toraja",
  },
  {
    label: "Universitas Kristen Krida Wacana",
    value: "Universitas Kristen Krida Wacana",
  },
  {
    label: "Universitas Kristen Maranatha",
    value: "Universitas Kristen Maranatha",
  },
  {
    label: "Universitas Kristen Palangka Raya",
    value: "Universitas Kristen Palangka Raya",
  },
  {
    label: "Universitas Kristen Papua",
    value: "Universitas Kristen Papua",
  },
  {
    label: "Universitas Kristen Petra",
    value: "Universitas Kristen Petra",
  },
  {
    label: "Universitas Kristen Satya Wacana",
    value: "Universitas Kristen Satya Wacana",
  },
  {
    label: "Universitas Kristen Teknologi Solo",
    value: "Universitas Kristen Teknologi Solo",
  },
  {
    label: "Universitas Kristen Tentena",
    value: "Universitas Kristen Tentena",
  },
  {
    label: "Universitas Kristen Wira Wacana Sumba",
    value: "Universitas Kristen Wira Wacana Sumba",
  },
  {
    label: "Universitas Kuningan",
    value: "Universitas Kuningan",
  },
  {
    label: "Universitas Kutai Kartanegara",
    value: "Universitas Kutai Kartanegara",
  },
  {
    label: "Universitas Lakidende Unaaha",
    value: "Universitas Lakidende Unaaha",
  },
  {
    label: "Universitas Lambung Mangkurat",
    value: "Universitas Lambung Mangkurat",
  },
  {
    label: "Universitas Lampung",
    value: "Universitas Lampung",
  },
  {
    label: "Universitas Lancang Kuning",
    value: "Universitas Lancang Kuning",
  },
  {
    label: "Universitas Langlangbuana",
    value: "Universitas Langlangbuana",
  },
  {
    label: "Universitas Lintas Internasional Indonesia",
    value: "Universitas Lintas Internasional Indonesia",
  },
  {
    label: "Universitas Lumajang",
    value: "Universitas Lumajang",
  },
  {
    label: "Universitas Ma Chung",
    value: "Universitas Ma Chung",
  },
  {
    label: "Universitas Maarif Hasyim Latif",
    value: "Universitas Maarif Hasyim Latif",
  },
  {
    label: "Universitas Ma'arif Nahdlatul Ulama",
    value: "Universitas Ma'arif Nahdlatul Ulama",
  },
  {
    label: "Universitas Madako Toli-toli",
    value: "Universitas Madako Toli-toli",
  },
  {
    label: "Universitas Madura",
    value: "Universitas Madura",
  },
  {
    label: "Universitas Mahaputra Muhammad Yamin",
    value: "Universitas Mahaputra Muhammad Yamin",
  },
  {
    label: "Universitas Mahasaraswati Denpasar",
    value: "Universitas Mahasaraswati Denpasar",
  },
  {
    label: "Universitas Mahasaraswati Mataram",
    value: "Universitas Mahasaraswati Mataram",
  },
  {
    label: "Universitas Mahendradatta",
    value: "Universitas Mahendradatta",
  },
  {
    label: "Universitas Majalengka",
    value: "Universitas Majalengka",
  },
  {
    label: "Universitas Malahayati",
    value: "Universitas Malahayati",
  },
  {
    label: "Universitas Malikussaleh",
    value: "Universitas Malikussaleh",
  },
  {
    label: "Universitas Maritim Raja Ali Haji",
    value: "Universitas Maritim Raja Ali Haji",
  },
  {
    label: "Universitas Matana",
    value: "Universitas Matana",
  },
  {
    label: "Universitas Mataram",
    value: "Universitas Mataram",
  },
  {
    label: "Universitas Mathla'ul Anwar",
    value: "Universitas Mathla'ul Anwar",
  },
  {
    label: "Universitas Mayjen Sungkono",
    value: "Universitas Mayjen Sungkono",
  },
  {
    label: "Universitas Medan Area",
    value: "Universitas Medan Area",
  },
  {
    label: "Universitas Megou Pak Tulang Bawang",
    value: "Universitas Megou Pak Tulang Bawang",
  },
  {
    label: "Universitas Mercu Buana",
    value: "Universitas Mercu Buana",
  },
  {
    label: "Universitas Mercu Buana Yogyakarta",
    value: "Universitas Mercu Buana Yogyakarta",
  },
  {
    label: "Universitas Merdeka Madiun",
    value: "Universitas Merdeka Madiun",
  },
  {
    label: "Universitas Merdeka Malang",
    value: "Universitas Merdeka Malang",
  },
  {
    label: "Universitas Merdeka Pasuruan",
    value: "Universitas Merdeka Pasuruan",
  },
  {
    label: "Universitas Merdeka Ponorogo",
    value: "Universitas Merdeka Ponorogo",
  },
  {
    label: "Universitas Merdeka Surabaya",
    value: "Universitas Merdeka Surabaya",
  },
  {
    label: "Universitas Methodist Indonesia",
    value: "Universitas Methodist Indonesia",
  },
  {
    label: "Universitas Mochammad Sroedji",
    value: "Universitas Mochammad Sroedji",
  },
  {
    label: "Universitas Mohammad Husni Thamrin",
    value: "Universitas Mohammad Husni Thamrin",
  },
  {
    label: "Universitas Mohammad Natsir Bukittinggi",
    value: "Universitas Mohammad Natsir Bukittinggi",
  },
  {
    label: "Universitas Mpu Tantular",
    value: "Universitas Mpu Tantular",
  },
  {
    label: "Universitas Muara Bungo",
    value: "Universitas Muara Bungo",
  },
  {
    label: "Universitas Muhadi Setiabudi",
    value: "Universitas Muhadi Setiabudi",
  },
  {
    label: "Universitas Muhammadiyah Aceh",
    value: "Universitas Muhammadiyah Aceh",
  },
  {
    label: "Universitas Muhammadiyah Bandung",
    value: "Universitas Muhammadiyah Bandung",
  },
  {
    label: "Universitas Muhammadiyah Banjarmasin",
    value: "Universitas Muhammadiyah Banjarmasin",
  },
  {
    label: "Universitas Muhammadiyah Bengkulu",
    value: "Universitas Muhammadiyah Bengkulu",
  },
  {
    label: "Universitas Muhammadiyah Buton",
    value: "Universitas Muhammadiyah Buton",
  },
  {
    label: "Universitas Muhammadiyah Cirebon",
    value: "Universitas Muhammadiyah Cirebon",
  },
  {
    label: "Universitas Muhammadiyah Gorontalo",
    value: "Universitas Muhammadiyah Gorontalo",
  },
  {
    label: "Universitas Muhammadiyah Gresik",
    value: "Universitas Muhammadiyah Gresik",
  },
  {
    label: "Universitas Muhammadiyah Jakarta",
    value: "Universitas Muhammadiyah Jakarta",
  },
  {
    label: "Universitas Muhammadiyah Jambi",
    value: "Universitas Muhammadiyah Jambi",
  },
  {
    label: "Universitas Muhammadiyah Jember",
    value: "Universitas Muhammadiyah Jember",
  },
  {
    label: "Universitas Muhammadiyah Kalimantan Timur",
    value: "Universitas Muhammadiyah Kalimantan Timur",
  },
  {
    label: "Universitas Muhammadiyah Kendari",
    value: "Universitas Muhammadiyah Kendari",
  },
  {
    label: "Universitas Muhammadiyah Kudus",
    value: "Universitas Muhammadiyah Kudus",
  },
  {
    label: "Universitas Muhammadiyah Kupang",
    value: "Universitas Muhammadiyah Kupang",
  },
  {
    label: "Universitas Muhammadiyah Lamongan",
    value: "Universitas Muhammadiyah Lamongan",
  },
  {
    label: "Universitas Muhammadiyah Lampung",
    value: "Universitas Muhammadiyah Lampung",
  },
  {
    label: "Universitas Muhammadiyah Luwuk Banggai",
    value: "Universitas Muhammadiyah Luwuk Banggai",
  },
  {
    label: "Universitas Muhammadiyah Magelang",
    value: "Universitas Muhammadiyah Magelang",
  },
  {
    label: "Universitas Muhammadiyah Makassar",
    value: "Universitas Muhammadiyah Makassar",
  },
  {
    label: "Universitas Muhammadiyah Malang",
    value: "Universitas Muhammadiyah Malang",
  },
  {
    label: "Universitas Muhammadiyah Maluku Utara",
    value: "Universitas Muhammadiyah Maluku Utara",
  },
  {
    label: "Universitas Muhammadiyah Mataram",
    value: "Universitas Muhammadiyah Mataram",
  },
  {
    label: "Universitas Muhammadiyah Metro",
    value: "Universitas Muhammadiyah Metro",
  },
  {
    label: "Universitas Muhammadiyah Palangkaraya",
    value: "Universitas Muhammadiyah Palangkaraya",
  },
  {
    label: "Universitas Muhammadiyah Palembang",
    value: "Universitas Muhammadiyah Palembang",
  },
  {
    label: "Universitas Muhammadiyah Palopo",
    value: "Universitas Muhammadiyah Palopo",
  },
  {
    label: "Universitas Muhammadiyah Palu",
    value: "Universitas Muhammadiyah Palu",
  },
  {
    label: "Universitas Muhammadiyah Parepare",
    value: "Universitas Muhammadiyah Parepare",
  },
  {
    label: "Universitas Muhammadiyah Ponorogo",
    value: "Universitas Muhammadiyah Ponorogo",
  },
  {
    label: "Universitas Muhammadiyah Pontianak",
    value: "Universitas Muhammadiyah Pontianak",
  },
  {
    label: "Universitas Muhammadiyah Prof. Dr. Hamka",
    value: "Universitas Muhammadiyah Prof. Dr. Hamka",
  },
  {
    label: "Universitas Muhammadiyah Purwokerto",
    value: "Universitas Muhammadiyah Purwokerto",
  },
  {
    label: "Universitas Muhammadiyah Purworejo",
    value: "Universitas Muhammadiyah Purworejo",
  },
  {
    label: "Universitas Muhammadiyah Riau",
    value: "Universitas Muhammadiyah Riau",
  },
  {
    label: "Universitas Muhammadiyah Semarang",
    value: "Universitas Muhammadiyah Semarang",
  },
  {
    label: "Universitas Muhammadiyah Sidoarjo",
    value: "Universitas Muhammadiyah Sidoarjo",
  },
  {
    label: "Universitas Muhammadiyah Sorong",
    value: "Universitas Muhammadiyah Sorong",
  },
  {
    label: "Universitas Muhammadiyah Sukabumi",
    value: "Universitas Muhammadiyah Sukabumi",
  },
  {
    label: "Universitas Muhammadiyah Sumatera Barat",
    value: "Universitas Muhammadiyah Sumatera Barat",
  },
  {
    label: "Universitas Muhammadiyah Sumatera Utara",
    value: "Universitas Muhammadiyah Sumatera Utara",
  },
  {
    label: "Universitas Muhammadiyah Surabaya",
    value: "Universitas Muhammadiyah Surabaya",
  },
  {
    label: "Universitas Muhammadiyah Surakarta",
    value: "Universitas Muhammadiyah Surakarta",
  },
  {
    label: "Universitas Muhammadiyah Tangerang",
    value: "Universitas Muhammadiyah Tangerang",
  },
  {
    label: "Universitas Muhammadiyah Tapanuli Selatan",
    value: "Universitas Muhammadiyah Tapanuli Selatan",
  },
  {
    label: "Universitas Muhammadiyah Tasikmalaya",
    value: "Universitas Muhammadiyah Tasikmalaya",
  },
  {
    label: "Universitas Muhammadiyah Yogyakarta",
    value: "Universitas Muhammadiyah Yogyakarta",
  },
  {
    label: "Universitas Mulawarman",
    value: "Universitas Mulawarman",
  },
  {
    label: "Universitas Mulia",
    value: "Universitas Mulia",
  },
  {
    label: "Universitas Multi Data Palembang",
    value: "Universitas Multi Data Palembang",
  },
  {
    label: "Universitas Multimedia Nusantara",
    value: "Universitas Multimedia Nusantara",
  },
  {
    label: "Universitas Muria Kudus",
    value: "Universitas Muria Kudus",
  },
  {
    label: "Universitas Musamus",
    value: "Universitas Musamus",
  },
  {
    label: "Universitas Musi Rawas",
    value: "Universitas Musi Rawas",
  },
  {
    label: "Universitas Muslim Indonesia",
    value: "Universitas Muslim Indonesia",
  },
  {
    label: "Universitas Muslim Nusantara Al-Washliyah",
    value: "Universitas Muslim Nusantara Al-Washliyah",
  },
  {
    label: "Universitas Nahdlatul Ulama Al Ghazali",
    value: "Universitas Nahdlatul Ulama Al Ghazali",
  },
  {
    label: "Universitas Nahdlatul Ulama Blitar",
    value: "Universitas Nahdlatul Ulama Blitar",
  },
  {
    label: "Universitas Nahdlatul Ulama Cirebon",
    value: "Universitas Nahdlatul Ulama Cirebon",
  },
  {
    label: "Universitas Nahdlatul Ulama Indonesia",
    value: "Universitas Nahdlatul Ulama Indonesia",
  },
  {
    label: "Universitas Nahdlatul Ulama Kalimantan Barat",
    value: "Universitas Nahdlatul Ulama Kalimantan Barat",
  },
  {
    label: "Universitas Nahdlatul Ulama Kalimantan Selatan",
    value: "Universitas Nahdlatul Ulama Kalimantan Selatan",
  },
  {
    label: "Universitas Nahdlatul Ulama Kalimantan Timur",
    value: "Universitas Nahdlatul Ulama Kalimantan Timur",
  },
  {
    label: "Universitas Nahdlatul Ulama Lampung",
    value: "Universitas Nahdlatul Ulama Lampung",
  },
  {
    label: "Universitas Nahdlatul Ulama Nusa Tenggara Barat",
    value: "Universitas Nahdlatul Ulama Nusa Tenggara Barat",
  },
  {
    label: "Universitas Nahdlatul Ulama Purwokerto",
    value: "Universitas Nahdlatul Ulama Purwokerto",
  },
  {
    label: "Universitas Nahdlatul Ulama Sidoarjo",
    value: "Universitas Nahdlatul Ulama Sidoarjo",
  },
  {
    label: "Universitas Nahdlatul Ulama Sulawesi Tenggara",
    value: "Universitas Nahdlatul Ulama Sulawesi Tenggara",
  },
  {
    label: "Universitas Nahdlatul Ulama Sumatera Barat",
    value: "Universitas Nahdlatul Ulama Sumatera Barat",
  },
  {
    label: "Universitas Nahdlatul Ulama Sumatera Utara",
    value: "Universitas Nahdlatul Ulama Sumatera Utara",
  },
  {
    label: "Universitas Nahdlatul Ulama Sunan Giri",
    value: "Universitas Nahdlatul Ulama Sunan Giri",
  },
  {
    label: "Universitas Nahdlatul Ulama Surabaya",
    value: "Universitas Nahdlatul Ulama Surabaya",
  },
  {
    label: "Universitas Nahdlatul Ulama Surakarta",
    value: "Universitas Nahdlatul Ulama Surakarta",
  },
  {
    label: "Universitas Nahdlatul Ulama Yogyakarta",
    value: "Universitas Nahdlatul Ulama Yogyakarta",
  },
  {
    label: "Universitas Nahdlatul Wathan",
    value: "Universitas Nahdlatul Wathan",
  },
  {
    label: "Universitas Nani Bili Nusantara",
    value: "Universitas Nani Bili Nusantara",
  },
  {
    label: "Universitas Narotama",
    value: "Universitas Narotama",
  },
  {
    label: "Universitas Nasional",
    value: "Universitas Nasional",
  },
  {
    label: "Universitas Nasional Pasim",
    value: "Universitas Nasional Pasim",
  },
  {
    label: "Universitas Negeri Gorontalo",
    value: "Universitas Negeri Gorontalo",
  },
  {
    label: "Universitas Negeri Jakarta",
    value: "Universitas Negeri Jakarta",
  },
  {
    label: "Universitas Negeri Makassar",
    value: "Universitas Negeri Makassar",
  },
  {
    label: "Universitas Negeri Malang",
    value: "Universitas Negeri Malang",
  },
  {
    label: "Universitas Negeri Manado",
    value: "Universitas Negeri Manado",
  },
  {
    label: "Universitas Negeri Medan",
    value: "Universitas Negeri Medan",
  },
  {
    label: "Universitas Negeri Padang",
    value: "Universitas Negeri Padang",
  },
  {
    label: "Universitas Negeri Semarang",
    value: "Universitas Negeri Semarang",
  },
  {
    label: "Universitas Negeri Surabaya",
    value: "Universitas Negeri Surabaya",
  },
  {
    label: "Universitas Negeri Yogyakarta",
    value: "Universitas Negeri Yogyakarta",
  },
  {
    label: "Universitas Ngudi Waluyo",
    value: "Universitas Ngudi Waluyo",
  },
  {
    label: "Universitas Ngurah Rai",
    value: "Universitas Ngurah Rai",
  },
  {
    label: "Universitas Nuku",
    value: "Universitas Nuku",
  },
  {
    label: "Universitas Nurtanio",
    value: "Universitas Nurtanio",
  },
  {
    label: "Universitas Nurul Jadid",
    value: "Universitas Nurul Jadid",
  },
  {
    label: "Universitas Nusa Bangsa",
    value: "Universitas Nusa Bangsa",
  },
  {
    label: "Universitas Nusa Cendana",
    value: "Universitas Nusa Cendana",
  },
  {
    label: "Universitas Nusa Lontar Rote",
    value: "Universitas Nusa Lontar Rote",
  },
  {
    label: "Universitas Nusa Nipa",
    value: "Universitas Nusa Nipa",
  },
  {
    label: "Universitas Nusa Putra",
    value: "Universitas Nusa Putra",
  },
  {
    label: "Universitas Nusa Tenggara Barat",
    value: "Universitas Nusa Tenggara Barat",
  },
  {
    label: "Universitas Nusantara Manado",
    value: "Universitas Nusantara Manado",
  },
  {
    label: "Universitas Nusantara PGRI Kediric",
    value: "Universitas Nusantara PGRI Kediric",
  },
  {
    label: "Universitas Ottow Geissler",
    value: "Universitas Ottow Geissler",
  },
  {
    label: "Universitas Padjadjaran",
    value: "Universitas Padjadjaran",
  },
  {
    label: "Universitas Pahlawan Tuanku Tambusai",
    value: "Universitas Pahlawan Tuanku Tambusai",
  },
  {
    label: "Universitas Pakuan",
    value: "Universitas Pakuan",
  },
  {
    label: "Universitas Palangka Raya",
    value: "Universitas Palangka Raya",
  },
  {
    label: "Universitas Palembang",
    value: "Universitas Palembang",
  },
  {
    label: "Universitas Pamulang",
    value: "Universitas Pamulang",
  },
  {
    label: "Universitas Panca Bhakti",
    value: "Universitas Panca Bhakti",
  },
  {
    label: "Universitas Panca Marga",
    value: "Universitas Panca Marga",
  },
  {
    label: "Universitas Pancasakti",
    value: "Universitas Pancasakti",
  },
  {
    label: "Universitas Pancasakti Makassar",
    value: "Universitas Pancasakti Makassar",
  },
  {
    label: "Universitas Pancasila",
    value: "Universitas Pancasila",
  },
  {
    label: "Universitas Pandanaran",
    value: "Universitas Pandanaran",
  },
  {
    label: "Universitas Panji Sakti",
    value: "Universitas Panji Sakti",
  },
  {
    label: "Universitas Papua",
    value: "Universitas Papua",
  },
  {
    label: "Universitas Paramadina",
    value: "Universitas Paramadina",
  },
  {
    label: "Universitas Pasifik Morotai",
    value: "Universitas Pasifik Morotai",
  },
  {
    label: "Universitas Pasir Pengaraian",
    value: "Universitas Pasir Pengaraian",
  },
  {
    label: "Universitas Pasundan",
    value: "Universitas Pasundan",
  },
  {
    label: "Universitas Patria Artha",
    value: "Universitas Patria Artha",
  },
  {
    label: "Universitas Pattimura",
    value: "Universitas Pattimura",
  },
  {
    label: "Universitas Pawyatan Daha",
    value: "Universitas Pawyatan Daha",
  },
  {
    label: "Universitas Pejuang Republik Indonesia",
    value: "Universitas Pejuang Republik Indonesia",
  },
  {
    label: "Universitas Pekalongan",
    value: "Universitas Pekalongan",
  },
  {
    label: "Universitas Pelita Harapan",
    value: "Universitas Pelita Harapan",
  },
  {
    label: "Universitas Pembangunan Indonesia",
    value: "Universitas Pembangunan Indonesia",
  },
  {
    label: "Universitas Pembangunan Jaya",
    value: "Universitas Pembangunan Jaya",
  },
  {
    label: "Universitas Pembangunan Nasional Veteran Jakarta",
    value: "Universitas Pembangunan Nasional Veteran Jakarta",
  },
  {
    label: "Universitas Pembangunan Nasional Veteran Jawa Timur",
    value: "Universitas Pembangunan Nasional Veteran Jawa Timur",
  },
  {
    label: "Universitas Pembangunan Nasional Veteran Yogyakarta",
    value: "Universitas Pembangunan Nasional Veteran Yogyakarta",
  },
  {
    label: "Universitas Pembangunan Panca Budi",
    value: "Universitas Pembangunan Panca Budi",
  },
  {
    label: "Universitas Pembinaan Masyarakat Indonesia",
    value: "Universitas Pembinaan Masyarakat Indonesia",
  },
  {
    label: "Universitas Pendidikan Ganesha",
    value: "Universitas Pendidikan Ganesha",
  },
  {
    label: "Universitas Pendidikan Indonesia",
    value: "Universitas Pendidikan Indonesia",
  },
  {
    label: "Universitas Pendidikan Muhammadiyah Sorong",
    value: "Universitas Pendidikan Muhammadiyah Sorong",
  },
  {
    label: "Universitas Pendidikan Nasional",
    value: "Universitas Pendidikan Nasional",
  },
  {
    label: "Universitas Pepabri Makassar",
    value: "Universitas Pepabri Makassar",
  },
  {
    label: "Universitas Peradaban Bumiayu",
    value: "Universitas Peradaban Bumiayu",
  },
  {
    label: "Universitas Perjuangan Tasikmalaya",
    value: "Universitas Perjuangan Tasikmalaya",
  },
  {
    label: "Universitas Persada Indonesia YAI",
    value: "Universitas Persada Indonesia YAI",
  },
  {
    label: "Universitas Persatuan Guru 1945 NTT",
    value: "Universitas Persatuan Guru 1945 NTT",
  },
  {
    label: "Universitas Pertamina",
    value: "Universitas Pertamina",
  },
  {
    label: "Universitas Pesantren Tinggi Darul 'Ulum",
    value: "Universitas Pesantren Tinggi Darul 'Ulum",
  },
  {
    label: "Universitas PGRI Adi Buana",
    value: "Universitas PGRI Adi Buana",
  },
  {
    label: "Universitas PGRI Banyuwangi",
    value: "Universitas PGRI Banyuwangi",
  },
  {
    label: "Universitas PGRI Madiun",
    value: "Universitas PGRI Madiun",
  },
  {
    label: "Universitas PGRI Palangkaraya",
    value: "Universitas PGRI Palangkaraya",
  },
  {
    label: "Universitas PGRI Palembang",
    value: "Universitas PGRI Palembang",
  },
  {
    label: "Universitas PGRI Ronggolawe",
    value: "Universitas PGRI Ronggolawe",
  },
  {
    label: "Universitas PGRI Semarang",
    value: "Universitas PGRI Semarang",
  },
  {
    label: "Universitas PGRI Silampari",
    value: "Universitas PGRI Silampari",
  },
  {
    label: "Universitas PGRI Wiranegara",
    value: "Universitas PGRI Wiranegara",
  },
  {
    label: "Universitas PGRI Yogyakarta",
    value: "Universitas PGRI Yogyakarta",
  },
  {
    label: "Universitas Podomoro",
    value: "Universitas Podomoro",
  },
  {
    label: "Universitas Potensi Utama",
    value: "Universitas Potensi Utama",
  },
  {
    label: "Universitas Pramita Indonesia",
    value: "Universitas Pramita Indonesia",
  },
  {
    label: "Universitas Prasetiya Mulya",
    value: "Universitas Prasetiya Mulya",
  },
  {
    label: "Universitas Presiden",
    value: "Universitas Presiden",
  },
  {
    label: "Universitas Prima Indonesia",
    value: "Universitas Prima Indonesia",
  },
  {
    label: "Universitas Prisma",
    value: "Universitas Prisma",
  },
  {
    label: "Universitas Prof. DR. Hazairin SH.",
    value: "Universitas Prof. DR. Hazairin SH.",
  },
  {
    label: "Universitas Prof. Dr. Moestopo",
    value: "Universitas Prof. Dr. Moestopo",
  },
  {
    label: "Universitas Proklamasi 45",
    value: "Universitas Proklamasi 45",
  },
  {
    label: "Universitas Putera Batam",
    value: "Universitas Putera Batam",
  },
  {
    label: "Universitas Putra Indonesia",
    value: "Universitas Putra Indonesia",
  },
  {
    label: "Universitas Putra Indonesia YPTK Padang",
    value: "Universitas Putra Indonesia YPTK Padang",
  },
  {
    label: "Universitas Quality",
    value: "Universitas Quality",
  },
  {
    label: "Universitas Ratu Samban",
    value: "Universitas Ratu Samban",
  },
  {
    label: "Universitas Respati Indonesia",
    value: "Universitas Respati Indonesia",
  },
  {
    label: "Universitas Respati Yogyakarta",
    value: "Universitas Respati Yogyakarta",
  },
  {
    label: "Universitas Riau",
    value: "Universitas Riau",
  },
  {
    label: "Universitas Riau Kepulauan",
    value: "Universitas Riau Kepulauan",
  },
  {
    label: "Universitas Rokania",
    value: "Universitas Rokania",
  },
  {
    label: "Universitas Sahid",
    value: "Universitas Sahid",
  },
  {
    label: "Universitas Sahid Surakarta",
    value: "Universitas Sahid Surakarta",
  },
  {
    label: "Universitas Sains Al-Qur'an",
    value: "Universitas Sains Al-Qur'an",
  },
  {
    label: "Universitas Sains Cut Nyak Dhien",
    value: "Universitas Sains Cut Nyak Dhien",
  },
  {
    label: "Universitas Sains dan Teknologi Jayapura",
    value: "Universitas Sains dan Teknologi Jayapura",
  },
  {
    label: "Universitas Sains dan Teknologi Komputer",
    value: "Universitas Sains dan Teknologi Komputer",
  },
  {
    label: "Universitas Sam Ratulangi",
    value: "Universitas Sam Ratulangi",
  },
  {
    label: "Universitas Samawa",
    value: "Universitas Samawa",
  },
  {
    label: "Universitas Sampoerna",
    value: "Universitas Sampoerna",
  },
  {
    label: "Universitas Samudra Langsa",
    value: "Universitas Samudra Langsa",
  },
  {
    label: "Universitas San Pedro",
    value: "Universitas San Pedro",
  },
  {
    label: "Universitas Sanata Dharma",
    value: "Universitas Sanata Dharma",
  },
  {
    label: "Universitas Sang Bumi Ruwa Jurai",
    value: "Universitas Sang Bumi Ruwa Jurai",
  },
  {
    label: "Universitas Sangga Buana",
    value: "Universitas Sangga Buana",
  },
  {
    label: "Universitas Sari Mutiara Indonesia",
    value: "Universitas Sari Mutiara Indonesia",
  },
  {
    label: "Universitas Sari Putra Tomohon",
    value: "Universitas Sari Putra Tomohon",
  },
  {
    label: "Universitas Sarjanawiyata Tamansiswa",
    value: "Universitas Sarjanawiyata Tamansiswa",
  },
  {
    label: "Universitas Satya Negara Indonesia",
    value: "Universitas Satya Negara Indonesia",
  },
  {
    label: "Universitas Satya Wiyata Mandala",
    value: "Universitas Satya Wiyata Mandala",
  },
  {
    label: "Universitas Satyagama",
    value: "Universitas Satyagama",
  },
  {
    label: "Universitas Sawerigading Makassar",
    value: "Universitas Sawerigading Makassar",
  },
  {
    label: "Universitas Sebelas Maret",
    value: "Universitas Sebelas Maret",
  },
  {
    label: "Universitas Selamat Sri",
    value: "Universitas Selamat Sri",
  },
  {
    label: "Universitas Semarang",
    value: "Universitas Semarang",
  },
  {
    label: "Universitas Sembilanbelas November Kolaka",
    value: "Universitas Sembilanbelas November Kolaka",
  },
  {
    label: "Universitas Serambi Mekkah",
    value: "Universitas Serambi Mekkah",
  },
  {
    label: "Universitas Serang Raya",
    value: "Universitas Serang Raya",
  },
  {
    label: "Universitas Setia Budi Surakarta",
    value: "Universitas Setia Budi Surakarta",
  },
  {
    label: "Universitas Siber Asia",
    value: "Universitas Siber Asia",
  },
  {
    label: "Universitas Siliwangi",
    value: "Universitas Siliwangi",
  },
  {
    label: "Universitas Simalungun",
    value: "Universitas Simalungun",
  },
  {
    label: "Universitas Singaperbangsa Karawang",
    value: "Universitas Singaperbangsa Karawang",
  },
  {
    label: "Universitas Sintuwu Maroso",
    value: "Universitas Sintuwu Maroso",
  },
  {
    label: "Universitas Sisingamangaraja XII Tapanuli",
    value: "Universitas Sisingamangaraja XII Tapanuli",
  },
  {
    label: "Universitas Sjakhyakirti",
    value: "Universitas Sjakhyakirti",
  },
  {
    label: "Universitas Slamet Riyadi",
    value: "Universitas Slamet Riyadi",
  },
  {
    label: "Universitas Soerjo",
    value: "Universitas Soerjo",
  },
  {
    label: "Universitas Sriwijaya",
    value: "Universitas Sriwijaya",
  },
  {
    label: "Universitas Stikubank",
    value: "Universitas Stikubank",
  },
  {
    label: "Universitas Subang",
    value: "Universitas Subang",
  },
  {
    label: "Universitas Sulawesi Barat",
    value: "Universitas Sulawesi Barat",
  },
  {
    label: "Universitas Sulawesi Tenggara",
    value: "Universitas Sulawesi Tenggara",
  },
  {
    label: "Universitas Sultan Ageng Tirtayasa",
    value: "Universitas Sultan Ageng Tirtayasa",
  },
  {
    label: "Universitas Sultan Fatah",
    value: "Universitas Sultan Fatah",
  },
  {
    label: "Universitas Sumatera Selatan",
    value: "Universitas Sumatera Selatan",
  },
  {
    label: "Universitas Sumatera Utara",
    value: "Universitas Sumatera Utara",
  },
  {
    label: "Universitas Sunan Bonang",
    value: "Universitas Sunan Bonang",
  },
  {
    label: "Universitas Sunan Giri",
    value: "Universitas Sunan Giri",
  },
  {
    label: "Universitas Surabaya",
    value: "Universitas Surabaya",
  },
  {
    label: "Universitas Surakarta",
    value: "Universitas Surakarta",
  },
  {
    label: "Universitas Surapati",
    value: "Universitas Surapati",
  },
  {
    label: "Universitas Surya",
    value: "Universitas Surya",
  },
  {
    label: "Universitas Suryakancana",
    value: "Universitas Suryakancana",
  },
  {
    label: "Universitas Swadaya Gunung Jati",
    value: "Universitas Swadaya Gunung Jati",
  },
  {
    label: "Universitas Swiss German",
    value: "Universitas Swiss German",
  },
  {
    label: "Universitas Syiah Kuala",
    value: "Universitas Syiah Kuala",
  },
  {
    label: "Universitas Tabanan",
    value: "Universitas Tabanan",
  },
  {
    label: "Universitas Tadulako",
    value: "Universitas Tadulako",
  },
  {
    label: "Universitas Tama Jagakarsa",
    value: "Universitas Tama Jagakarsa",
  },
  {
    label: "Universitas Tamansiswa",
    value: "Universitas Tamansiswa",
  },
  {
    label: "Universitas Tamansiswa Palembang",
    value: "Universitas Tamansiswa Palembang",
  },
  {
    label: "Universitas Tanjungpura",
    value: "Universitas Tanjungpura",
  },
  {
    label: "Universitas Tanri Abeng",
    value: "Universitas Tanri Abeng",
  },
  {
    label: "Universitas Tarumanagara",
    value: "Universitas Tarumanagara",
  },
  {
    label: "Universitas Teknokrat Indonesia",
    value: "Universitas Teknokrat Indonesia",
  },
  {
    label: "Universitas Teknologi Digital Indonesia",
    value: "Universitas Teknologi Digital Indonesia",
  },
  {
    label: "Universitas Teknologi Indonesia",
    value: "Universitas Teknologi Indonesia",
  },
  {
    label: "Universitas Teknologi Nusantara",
    value: "Universitas Teknologi Nusantara",
  },
  {
    label: "Universitas Teknologi Sulawesi",
    value: "Universitas Teknologi Sulawesi",
  },
  {
    label: "Universitas Teknologi Sulawesi Utara",
    value: "Universitas Teknologi Sulawesi Utara",
  },
  {
    label: "Universitas Teknologi Sumbawa",
    value: "Universitas Teknologi Sumbawa",
  },
  {
    label: "Universitas Teknologi Surabaya",
    value: "Universitas Teknologi Surabaya",
  },
  {
    label: "Universitas Teknologi Yogyakarta",
    value: "Universitas Teknologi Yogyakarta",
  },
  {
    label: "Universitas Telkom",
    value: "Universitas Telkom",
  },
  {
    label: "Universitas Teuku Umar",
    value: "Universitas Teuku Umar",
  },
  {
    label: "Universitas Tidar",
    value: "Universitas Tidar",
  },
  {
    label: "Universitas Timbul Nusantara",
    value: "Universitas Timbul Nusantara",
  },
  {
    label: "Universitas Timika",
    value: "Universitas Timika",
  },
  {
    label: "Universitas Timor",
    value: "Universitas Timor",
  },
  {
    label: "Universitas Tjut Nyak Dhien",
    value: "Universitas Tjut Nyak Dhien",
  },
  {
    label: "Universitas Tomakaka",
    value: "Universitas Tomakaka",
  },
  {
    label: "Universitas Tompotika",
    value: "Universitas Tompotika",
  },
  {
    label: "Universitas Tribhuwana Tungga Dewi",
    value: "Universitas Tribhuwana Tungga Dewi",
  },
  {
    label: "Universitas Tribuana Kalabahi",
    value: "Universitas Tribuana Kalabahi",
  },
  {
    label: "Universitas Tridharma Balikpapan",
    value: "Universitas Tridharma Balikpapan",
  },
  {
    label: "Universitas Tridinanti Palembang",
    value: "Universitas Tridinanti Palembang",
  },
  {
    label: "Universitas Trilogi",
    value: "Universitas Trilogi",
  },
  {
    label: "Universitas Trisakti",
    value: "Universitas Trisakti",
  },
  {
    label: "Universitas Trunajaya",
    value: "Universitas Trunajaya",
  },
  {
    label: "Universitas Trunojoyo Madura",
    value: "Universitas Trunojoyo Madura",
  },
  {
    label: "Universitas Tulang Bawang",
    value: "Universitas Tulang Bawang",
  },
  {
    label: "Universitas Tulungagung",
    value: "Universitas Tulungagung",
  },
  {
    label: "Universitas Tunas Pembangunan",
    value: "Universitas Tunas Pembangunan",
  },
  {
    label: "Universitas Ubudiyah Indonesia",
    value: "Universitas Ubudiyah Indonesia",
  },
  {
    label: "Universitas Udayana",
    value: "Universitas Udayana",
  },
  {
    label: "Universitas Universal",
    value: "Universitas Universal",
  },
  {
    label: "Universitas Veteran Bangun Nusantara",
    value: "Universitas Veteran Bangun Nusantara",
  },
  {
    label: "Universitas Victory Sorong",
    value: "Universitas Victory Sorong",
  },
  {
    label: "Universitas Wahid Hasyim",
    value: "Universitas Wahid Hasyim",
  },
  {
    label: "Universitas Wahidiyah",
    value: "Universitas Wahidiyah",
  },
  {
    label: "Universitas Wanita Internasional",
    value: "Universitas Wanita Internasional",
  },
  {
    label: "Universitas Warmadewa",
    value: "Universitas Warmadewa",
  },
  {
    label: "Universitas Widya Dharma",
    value: "Universitas Widya Dharma",
  },
  {
    label: "Universitas Widya Gama",
    value: "Universitas Widya Gama",
  },
  {
    label: "Universitas Widya Gama Mahakam Samarinda",
    value: "Universitas Widya Gama Mahakam Samarinda",
  },
  {
    label: "Universitas Widya Kartika",
    value: "Universitas Widya Kartika",
  },
  {
    label: "Universitas Widya Mataram",
    value: "Universitas Widya Mataram",
  },
  {
    label: "Universitas Widyatama",
    value: "Universitas Widyatama",
  },
  {
    label: "Universitas Wijaya Kusuma Purwokerto",
    value: "Universitas Wijaya Kusuma Purwokerto",
  },
  {
    label: "Universitas Wijaya Kusuma Surabaya",
    value: "Universitas Wijaya Kusuma Surabaya",
  },
  {
    label: "Universitas Wijaya Putra",
    value: "Universitas Wijaya Putra",
  },
  {
    label: "Universitas Winaya Mukti",
    value: "Universitas Winaya Mukti",
  },
  {
    label: "Universitas Wiralodra",
    value: "Universitas Wiralodra",
  },
  {
    label: "Universitas Wiraraja",
    value: "Universitas Wiraraja",
  },
  {
    label: "Universitas Wiraswasta Indonesia",
    value: "Universitas Wiraswasta Indonesia",
  },
  {
    label: "Universitas Wisnuwardhana",
    value: "Universitas Wisnuwardhana",
  },
  {
    label: "Universitas WR Supratman",
    value: "Universitas WR Supratman",
  },
  {
    label: "Universitas Yapis Papua",
    value: "Universitas Yapis Papua",
  },
  {
    label: "Universitas YARSI",
    value: "Universitas YARSI",
  },
  {
    label: "Universitas Yos Soedarso",
    value: "Universitas Yos Soedarso",
  },
  {
    label: "Universitas Yudharta Pasuruan",
    value: "Universitas Yudharta Pasuruan",
  },
  {
    label: "Universität Augsburg",
    value: "Universität Augsburg",
  },
  {
    label: "Universität Basel",
    value: "Universität Basel",
  },
  {
    label: "Universität Bayreuth",
    value: "Universität Bayreuth",
  },
  {
    label: "Universität Bern",
    value: "Universität Bern",
  },
  {
    label: "Universität Bielefeld",
    value: "Universität Bielefeld",
  },
  {
    label: "Universität Bremen",
    value: "Universität Bremen",
  },
  {
    label: "Universitat d'Andorra",
    value: "Universitat d'Andorra",
  },
  {
    label: "Universitat de Lleida",
    value: "Universitat de Lleida",
  },
  {
    label: "Universität der Bundeswehr München",
    value: "Universität der Bundeswehr München",
  },
  {
    label: "Universität der Künste Berlin",
    value: "Universität der Künste Berlin",
  },
  {
    label: "Universität des Saarlandes",
    value: "Universität des Saarlandes",
  },
  {
    label: "Universität Duisburg-Essen",
    value: "Universität Duisburg-Essen",
  },
  {
    label: "Universität Erfurt",
    value: "Universität Erfurt",
  },
  {
    label: "Universität für angewandte Kunst Wien",
    value: "Universität für angewandte Kunst Wien",
  },
  {
    label: "Universität für Bodenkultur Wien",
    value: "Universität für Bodenkultur Wien",
  },
  {
    label: "Universität für Künstlerische und Industrielle Gestaltung Linz",
    value: "Universität für Künstlerische und Industrielle Gestaltung Linz",
  },
  {
    label: "Universität für Musik und darstellende Kunst Graz",
    value: "Universität für Musik und darstellende Kunst Graz",
  },
  {
    label: "Universität für Weiterbildung Krems",
    value: "Universität für Weiterbildung Krems",
  },
  {
    label: "Universität Graz",
    value: "Universität Graz",
  },
  {
    label: "Universität Hamburg",
    value: "Universität Hamburg",
  },
  {
    label: "Universität Hildesheim",
    value: "Universität Hildesheim",
  },
  {
    label: "Universität Hohenheim",
    value: "Universität Hohenheim",
  },
  {
    label: "Universität Innsbruck",
    value: "Universität Innsbruck",
  },
  {
    label: "Universitat Internacional de Catalunya",
    value: "Universitat Internacional de Catalunya",
  },
  {
    label: "Universität Kassel",
    value: "Universität Kassel",
  },
  {
    label: "Universität Koblenz",
    value: "Universität Koblenz",
  },
  {
    label: "Universität Konstanz",
    value: "Universität Konstanz",
  },
  {
    label: "Universität Leipzig",
    value: "Universität Leipzig",
  },
  {
    label: "Universität Liechtenstein",
    value: "Universität Liechtenstein",
  },
  {
    label: "Universität Luzern",
    value: "Universität Luzern",
  },
  {
    label: "Universität Mannheim",
    value: "Universität Mannheim",
  },
  {
    label: "Universität Mozarteum Salzburg",
    value: "Universität Mozarteum Salzburg",
  },
  {
    label: "Universität Osnabrück",
    value: "Universität Osnabrück",
  },
  {
    label: "Universität Paderborn",
    value: "Universität Paderborn",
  },
  {
    label: "Universität Passau",
    value: "Universität Passau",
  },
  {
    label: "Universität Potsdam",
    value: "Universität Potsdam",
  },
  {
    label: "Universität Regensburg",
    value: "Universität Regensburg",
  },
  {
    label: "Universität Rostock",
    value: "Universität Rostock",
  },
  {
    label: "Universität Siegen",
    value: "Universität Siegen",
  },
  {
    label: "Universität St.Gallen",
    value: "Universität St.Gallen",
  },
  {
    label: "Universität Stuttgart",
    value: "Universität Stuttgart",
  },
  {
    label: "Universität Trier",
    value: "Universität Trier",
  },
  {
    label: "Universität Ulm",
    value: "Universität Ulm",
  },
  {
    label: "Universität Vechta",
    value: "Universität Vechta",
  },
  {
    label: "Universität Wien",
    value: "Universität Wien",
  },
  {
    label: "Universität Witten/Herdecke",
    value: "Universität Witten/Herdecke",
  },
  {
    label: "Universität zu Köln",
    value: "Universität zu Köln",
  },
  {
    label: "Universität zu Lübeck",
    value: "Universität zu Lübeck",
  },
  {
    label: "Universität Zürich",
    value: "Universität Zürich",
  },
  {
    label: "Universitatea 'Perspectiva - INT'",
    value: "Universitatea 'Perspectiva - INT'",
  },
  {
    label: "Universitatea 1 Decembrie 1918 din Alba Iulia",
    value: "Universitatea 1 Decembrie 1918 din Alba Iulia",
  },
  {
    label: "Universitatea Academiei de Stiinte a Moldovei",
    value: "Universitatea Academiei de Stiinte a Moldovei",
  },
  {
    label: "Universitatea Agora din Oradea",
    value: "Universitatea Agora din Oradea",
  },
  {
    label: "Universitatea Alexandru Ioan Cuza din Iasi",
    value: "Universitatea Alexandru Ioan Cuza din Iasi",
  },
  {
    label: "Universitatea Andrei Saguna",
    value: "Universitatea Andrei Saguna",
  },
  {
    label: "Universitatea Apollonia din Iasi",
    value: "Universitatea Apollonia din Iasi",
  },
  {
    label: "Universitatea Artifex din Bucuresti",
    value: "Universitatea Artifex din Bucuresti",
  },
  {
    label: "Universitatea Athenaeum din Bucuresti",
    value: "Universitatea Athenaeum din Bucuresti",
  },
  {
    label: "Universitatea Aurel Vlaicu din Arad",
    value: "Universitatea Aurel Vlaicu din Arad",
  },
  {
    label: "Universitatea Avram Iancu din Cluj-Napoca",
    value: "Universitatea Avram Iancu din Cluj-Napoca",
  },
  {
    label: "Universitatea Babes-Bolyai",
    value: "Universitatea Babes-Bolyai",
  },
  {
    label: "Universitatea Bioterra din Bucuresti",
    value: "Universitatea Bioterra din Bucuresti",
  },
  {
    label: "Universitatea Bogdan Voda din Cluj-Napoca",
    value: "Universitatea Bogdan Voda din Cluj-Napoca",
  },
  {
    label: "Universitatea Constantin Brâncoveanu",
    value: "Universitatea Constantin Brâncoveanu",
  },
  {
    label: "Universitatea Constantin Brâncusi",
    value: "Universitatea Constantin Brâncusi",
  },
  {
    label: "Universitatea Cooperatist-Comerciala din Moldova",
    value: "Universitatea Cooperatist-Comerciala din Moldova",
  },
  {
    label: "Universitatea Crestina Dimitrie Cantemir",
    value: "Universitatea Crestina Dimitrie Cantemir",
  },
  {
    label: "Universitatea Crestina Partium",
    value: "Universitatea Crestina Partium",
  },
  {
    label: "Universitatea Danubius Galati",
    value: "Universitatea Danubius Galati",
  },
  {
    label: "Universitatea de Arhitectura si Urbanism Ion Mincu din Bucuresti",
    value: "Universitatea de Arhitectura si Urbanism Ion Mincu din Bucuresti",
  },
  {
    label: "Universitatea de Arta si Design din Cluj-Napoca",
    value: "Universitatea de Arta si Design din Cluj-Napoca",
  },
  {
    label: "Universitatea de Arte din Târgu Mures",
    value: "Universitatea de Arte din Târgu Mures",
  },
  {
    label: "Universitatea de Medicina si Farmacie Carol Davila din Bucuresti",
    value: "Universitatea de Medicina si Farmacie Carol Davila din Bucuresti",
  },
  {
    label: "Universitatea de Medicina si Farmacie din Craiova",
    value: "Universitatea de Medicina si Farmacie din Craiova",
  },
  {
    label: "Universitatea de Medicina si Farmacie Gr. T. Popa",
    value: "Universitatea de Medicina si Farmacie Gr. T. Popa",
  },
  {
    label: "Universitatea de Medicina si Farmacie Iuliu Hatieganu",
    value: "Universitatea de Medicina si Farmacie Iuliu Hatieganu",
  },
  {
    label: "Universitatea de Medicina si Farmacie Victor Babes din Timisoara",
    value: "Universitatea de Medicina si Farmacie Victor Babes din Timisoara",
  },
  {
    label:
      "Universitatea de Medicina, Farmacie, Stiinte si Tehnologie 'George Emil Palade' din Targu Mures",
    value:
      "Universitatea de Medicina, Farmacie, Stiinte si Tehnologie 'George Emil Palade' din Targu Mures",
  },
  {
    label: "Universitatea de Stat A. Russo",
    value: "Universitatea de Stat A. Russo",
  },
  {
    label: "Universitatea de Stat Bogdan Petriceicu Hasdeu",
    value: "Universitatea de Stat Bogdan Petriceicu Hasdeu",
  },
  {
    label: "Universitatea de Stat de Educatie Fizica si Sport",
    value: "Universitatea de Stat de Educatie Fizica si Sport",
  },
  {
    label: "Universitatea de Stat de Medicina si Farmacie",
    value: "Universitatea de Stat de Medicina si Farmacie",
  },
  {
    label: "Universitatea de Stat din Comrat",
    value: "Universitatea de Stat din Comrat",
  },
  {
    label: "Universitatea de Stat din Moldova",
    value: "Universitatea de Stat din Moldova",
  },
  {
    label: "Universitatea de Stat din Taraclia",
    value: "Universitatea de Stat din Taraclia",
  },
  {
    label:
      "Universitatea de stiinte Agricole si Medicina Veterinara a Banatului Timisoara",
    value:
      "Universitatea de stiinte Agricole si Medicina Veterinara a Banatului Timisoara",
  },
  {
    label:
      "Universitatea de stiinte Agricole si Medicina Veterinara din Cluj-Napoca",
    value:
      "Universitatea de stiinte Agricole si Medicina Veterinara din Cluj-Napoca",
  },
  {
    label:
      "Universitatea de stiinte Agronomice si Medicina Veterinara din Bucuresti",
    value:
      "Universitatea de stiinte Agronomice si Medicina Veterinara din Bucuresti",
  },
  {
    label: "Universitatea de Stiintele Vietii 'Ion Ionescu de la Brad'",
    value: "Universitatea de Stiintele Vietii 'Ion Ionescu de la Brad'",
  },
  {
    label: "Universitatea de Studii Aplicate din Moldova",
    value: "Universitatea de Studii Aplicate din Moldova",
  },
  {
    label: "Universitatea de Studii Europene din Moldova",
    value: "Universitatea de Studii Europene din Moldova",
  },
  {
    label: "Universitatea de Studii Politice si Economice Europene",
    value: "Universitatea de Studii Politice si Economice Europene",
  },
  {
    label: "Universitatea de Vest din Timisoara",
    value: "Universitatea de Vest din Timisoara",
  },
  {
    label: "Universitatea de Vest Vasile Goldis din Arad",
    value: "Universitatea de Vest Vasile Goldis din Arad",
  },
  {
    label: "Universitatea Dimitrie Cantemir",
    value: "Universitatea Dimitrie Cantemir",
  },
  {
    label: "Universitatea din Bucure?ti",
    value: "Universitatea din Bucure?ti",
  },
  {
    label: "Universitatea din Craiova",
    value: "Universitatea din Craiova",
  },
  {
    label: "Universitatea din Oradea",
    value: "Universitatea din Oradea",
  },
  {
    label: "Universitatea din Petrosani",
    value: "Universitatea din Petrosani",
  },
  {
    label: "Universitatea din Pitesti",
    value: "Universitatea din Pitesti",
  },
  {
    label: "Universitatea Dunarea de Jos din Galati",
    value: "Universitatea Dunarea de Jos din Galati",
  },
  {
    label: "Universitatea Ecologica din Bucuresti",
    value: "Universitatea Ecologica din Bucuresti",
  },
  {
    label: "Universitatea Emanuel din Oradea",
    value: "Universitatea Emanuel din Oradea",
  },
  {
    label: "Universitatea Europeana 'Dragan' din Lugoj",
    value: "Universitatea Europeana 'Dragan' din Lugoj",
  },
  {
    label: "Universitatea George Bacovia Bacau",
    value: "Universitatea George Bacovia Bacau",
  },
  {
    label: "Universitatea HYPERION",
    value: "Universitatea HYPERION",
  },
  {
    label: "Universitatea Libera Internationala din Moldova",
    value: "Universitatea Libera Internationala din Moldova",
  },
  {
    label: "Universitatea Lucian Blaga din Sibiu",
    value: "Universitatea Lucian Blaga din Sibiu",
  },
  {
    label: "Universitatea Maritima din Constanta",
    value: "Universitatea Maritima din Constanta",
  },
  {
    label: "Universitatea Mihail Kogalniceanu",
    value: "Universitatea Mihail Kogalniceanu",
  },
  {
    label: "Universitatea Na?ionala de Arte George Enescu Iasi",
    value: "Universitatea Na?ionala de Arte George Enescu Iasi",
  },
  {
    label:
      "Universitatea Nationala de Arta Teatrala si Cinematografica Ion Luca Caragiale",
    value:
      "Universitatea Nationala de Arta Teatrala si Cinematografica Ion Luca Caragiale",
  },
  {
    label: "Universitatea Nationala de Arte din Bucuresti",
    value: "Universitatea Nationala de Arte din Bucuresti",
  },
  {
    label: "Universitatea Nationala de Educatie Fizica si Sport",
    value: "Universitatea Nationala de Educatie Fizica si Sport",
  },
  {
    label: "Universitatea Nationala de Muzica din Bucuresti",
    value: "Universitatea Nationala de Muzica din Bucuresti",
  },
  {
    label: "Universitatea Nicolae Titulescu din Bucuresti",
    value: "Universitatea Nicolae Titulescu din Bucuresti",
  },
  {
    label: "Universitatea Ovidius Constanta",
    value: "Universitatea Ovidius Constanta",
  },
  {
    label: "Universitatea Pedagogica de Stat Ion Creanga",
    value: "Universitatea Pedagogica de Stat Ion Creanga",
  },
  {
    label: "Universitatea Petre Andrei din Iasi",
    value: "Universitatea Petre Andrei din Iasi",
  },
  {
    label: "Universitatea Petrol-Gaze din Ploiesti",
    value: "Universitatea Petrol-Gaze din Ploiesti",
  },
  {
    label: "Universitatea Politehnica din Bucuresti",
    value: "Universitatea Politehnica din Bucuresti",
  },
  {
    label: "Universitatea Politehnica din Timisoara",
    value: "Universitatea Politehnica din Timisoara",
  },
  {
    label: "Universitatea Româno-Americana",
    value: "Universitatea Româno-Americana",
  },
  {
    label: "Universitatea Româno-Germana din Sibiu",
    value: "Universitatea Româno-Germana din Sibiu",
  },
  {
    label: "Universitatea Sapientia",
    value: "Universitatea Sapientia",
  },
  {
    label: "Universitatea Slavona",
    value: "Universitatea Slavona",
  },
  {
    label: "Universitatea Spiru Haret",
    value: "Universitatea Spiru Haret",
  },
  {
    label: "Universitatea Stefan cel Mare Suceava",
    value: "Universitatea Stefan cel Mare Suceava",
  },
  {
    label: "Universitatea Technica din Cluj-Napoca",
    value: "Universitatea Technica din Cluj-Napoca",
  },
  {
    label: "Universitatea Tehnica a Moldovei",
    value: "Universitatea Tehnica a Moldovei",
  },
  {
    label: "Universitatea Tehnica de Constructii Bucuresti",
    value: "Universitatea Tehnica de Constructii Bucuresti",
  },
  {
    label: "Universitatea Tehnica Gheorghe Asachi din Iasi",
    value: "Universitatea Tehnica Gheorghe Asachi din Iasi",
  },
  {
    label: "Universitatea Tibiscus din Timisoara",
    value: "Universitatea Tibiscus din Timisoara",
  },
  {
    label: "Universitatea Titu Maiorescu",
    value: "Universitatea Titu Maiorescu",
  },
  {
    label: "Universitatea Transilvania din Brasov",
    value: "Universitatea Transilvania din Brasov",
  },
  {
    label: "Universitatea Valahia din Târgoviste",
    value: "Universitatea Valahia din Târgoviste",
  },
  {
    label: "Universitatea Vasile Alecsandri din Bacau",
    value: "Universitatea Vasile Alecsandri din Bacau",
  },
  {
    label: "Université 20 Août 1955 de Skikda",
    value: "Université 20 Août 1955 de Skikda",
  },
  {
    label: "Université 8 Mai 1945 Guelma",
    value: "Université 8 Mai 1945 Guelma",
  },
  {
    label: "Université Abbès Laghrour Khenchela",
    value: "Université Abbès Laghrour Khenchela",
  },
  {
    label: "Université Abdelhamid Ibn Badis de Mostaganem",
    value: "Université Abdelhamid Ibn Badis de Mostaganem",
  },
  {
    label: "Université Abdelhamid Mehri de Constantine 2",
    value: "Université Abdelhamid Mehri de Constantine 2",
  },
  {
    label: "Université Abdelmalek Essadi",
    value: "Université Abdelmalek Essadi",
  },
  {
    label: "Université Abderrahmane Mira de Béjaïa",
    value: "Université Abderrahmane Mira de Béjaïa",
  },
  {
    label: "Université Abdou Moumouni",
    value: "Université Abdou Moumouni",
  },
  {
    label: "Université Abou Bekr Belkaid de Tlemcen",
    value: "Université Abou Bekr Belkaid de Tlemcen",
  },
  {
    label: "Université Abou el Kacem Saâdallah d'Alger 2",
    value: "Université Abou el Kacem Saâdallah d'Alger 2",
  },
  {
    label: "Université Adam Barka d'Abéché",
    value: "Université Adam Barka d'Abéché",
  },
  {
    label: "Université Adventiste Cosendai",
    value: "Université Adventiste Cosendai",
  },
  {
    label: "Université Adventiste de Goma",
    value: "Université Adventiste de Goma",
  },
  {
    label: "Université Adventiste de Lukanga",
    value: "Université Adventiste de Lukanga",
  },
  {
    label: "Université Adventiste d'Haïti",
    value: "Université Adventiste d'Haïti",
  },
  {
    label: "Université Africaine de Technologie et de Management",
    value: "Université Africaine de Technologie et de Management",
  },
  {
    label: "Université Africaine des Sciences",
    value: "Université Africaine des Sciences",
  },
  {
    label: "Université Ahmed Ben Bella d'Oran 1",
    value: "Université Ahmed Ben Bella d'Oran 1",
  },
  {
    label: "Université Ahmed Draia d'Adrar",
    value: "Université Ahmed Draia d'Adrar",
  },
  {
    label: "Université Akli Mohand Oulhadj de Bouira",
    value: "Université Akli Mohand Oulhadj de Bouira",
  },
  {
    label: "Université Al Akhawayn",
    value: "Université Al Akhawayn",
  },
  {
    label: "Université Al Quaraouiyine",
    value: "Université Al Quaraouiyine",
  },
  {
    label: "Université Alassane Ouattara",
    value: "Université Alassane Ouattara",
  },
  {
    label: "Université Alioune Diop de Bambey",
    value: "Université Alioune Diop de Bambey",
  },
  {
    label: "Université Al-Kafaat",
    value: "Université Al-Kafaat",
  },
  {
    label: "Université Amadou Mahtar Mbow",
    value: "Université Amadou Mahtar Mbow",
  },
  {
    label: "Université Amar Telidji de Laghouat",
    value: "Université Amar Telidji de Laghouat",
  },
  {
    label: "Université Américaine des Sciences Modernes d'Haïti",
    value: "Université Américaine des Sciences Modernes d'Haïti",
  },
  {
    label: "Université Anglicane du Congo",
    value: "Université Anglicane du Congo",
  },
  {
    label: "Université Antonine",
    value: "Université Antonine",
  },
  {
    label: "Université Arabe des Sciences",
    value: "Université Arabe des Sciences",
  },
  {
    label: "Université Assane SECK de Ziguinchor",
    value: "Université Assane SECK de Ziguinchor",
  },
  {
    label: "Université Aube Nouvelle",
    value: "Université Aube Nouvelle",
  },
  {
    label: "Université Autonome de Port-au-Prince",
    value: "Université Autonome de Port-au-Prince",
  },
  {
    label: "Université Badji Mokhtar de Annaba",
    value: "Université Badji Mokhtar de Annaba",
  },
  {
    label: "Université Benyoucef Benkhedda d'Alger 1",
    value: "Université Benyoucef Benkhedda d'Alger 1",
  },
  {
    label: "Université Bordeaux Montaigne",
    value: "Université Bordeaux Montaigne",
  },
  {
    label: "Université Brahim Soltane Chaibout d'Alger 3",
    value: "Université Brahim Soltane Chaibout d'Alger 3",
  },
  {
    label: "Université Bretagne Sud",
    value: "Université Bretagne Sud",
  },
  {
    label: "Université Cadi Ayyad",
    value: "Université Cadi Ayyad",
  },
  {
    label: "Université Caraibe",
    value: "Université Caraibe",
  },
  {
    label: "Université Catholique de Bukavu",
    value: "Université Catholique de Bukavu",
  },
  {
    label:
      "Université Catholique de l'Afrique de l'Ouest - Unité Universitaire du Togo",
    value:
      "Université Catholique de l'Afrique de l'Ouest - Unité Universitaire du Togo",
  },
  {
    label: "Université Catholique de l'Afrique de l'Ouest, Benin",
    value: "Université Catholique de l'Afrique de l'Ouest, Benin",
  },
  {
    label: "Université Catholique de l'Afrique de l'Ouest, Burkina Faso",
    value: "Université Catholique de l'Afrique de l'Ouest, Burkina Faso",
  },
  {
    label: "Université Catholique de Lille",
    value: "Université Catholique de Lille",
  },
  {
    label: "Université Catholique de l'Ouest",
    value: "Université Catholique de l'Ouest",
  },
  {
    label: "Université Catholique de Louvain",
    value: "Université Catholique de Louvain",
  },
  {
    label: "Université Catholique de Lyon",
    value: "Université Catholique de Lyon",
  },
  {
    label: "Université Catholique Don Peti",
    value: "Université Catholique Don Peti",
  },
  {
    label: "Université Catholique du Congo",
    value: "Université Catholique du Congo",
  },
  {
    label: "Université Catholique du Graben",
    value: "Université Catholique du Graben",
  },
  {
    label: "Université Centrale",
    value: "Université Centrale",
  },
  {
    label: "Université Chadli Bendjedid d'El Tarf",
    value: "Université Chadli Bendjedid d'El Tarf",
  },
  {
    label: "Université Cheikh Ahmadou Bamba",
    value: "Université Cheikh Ahmadou Bamba",
  },
  {
    label: "Université Cheikh Anta Diop",
    value: "Université Cheikh Anta Diop",
  },
  {
    label: "Université Chouaib Doukkali",
    value: "Université Chouaib Doukkali",
  },
  {
    label: "Université Chrétienne Cardinal Malula",
    value: "Université Chrétienne Cardinal Malula",
  },
  {
    label: "Université Chrétienne de Bujumbura",
    value: "Université Chrétienne de Bujumbura",
  },
  {
    label: "Université Chrétienne de Kinshasa",
    value: "Université Chrétienne de Kinshasa",
  },
  {
    label: "Université Chrétienne du Nord d'Haïti",
    value: "Université Chrétienne du Nord d'Haïti",
  },
  {
    label: "Université Claude Bernard Lyon 1",
    value: "Université Claude Bernard Lyon 1",
  },
  {
    label: "Université Clermont Auvergne",
    value: "Université Clermont Auvergne",
  },
  {
    label: "Université Côte d'Azur",
    value: "Université Côte d'Azur",
  },
  {
    label: "Université d'Abomey-Calavi",
    value: "Université d'Abomey-Calavi",
  },
  {
    label: "Université Dakar Bourguiba",
    value: "Université Dakar Bourguiba",
  },
  {
    label: "Université d'Angers",
    value: "Université d'Angers",
  },
  {
    label: "Université d'Antananarivo",
    value: "Université d'Antananarivo",
  },
  {
    label: "Université d'Antsiranana",
    value: "Université d'Antsiranana",
  },
  {
    label: "Université d'Artois",
    value: "Université d'Artois",
  },
  {
    label: "Université de Ain Témouchent",
    value: "Université de Ain Témouchent",
  },
  {
    label: "Université de Bamenda",
    value: "Université de Bamenda",
  },
  {
    label: "Université de Bandundu",
    value: "Université de Bandundu",
  },
  {
    label: "Université de Bangui",
    value: "Université de Bangui",
  },
  {
    label: "Université de Batna 2",
    value: "Université de Batna 2",
  },
  {
    label: "Université de Bordeaux",
    value: "Université de Bordeaux",
  },
  {
    label: "Université de Bourgogne",
    value: "Université de Bourgogne",
  },
  {
    label: "Université de Bretagne Occidentale",
    value: "Université de Bretagne Occidentale",
  },
  {
    label: "Université de Buéa",
    value: "Université de Buéa",
  },
  {
    label: "Université de Bunia",
    value: "Université de Bunia",
  },
  {
    label: "Université de Caen Normandie",
    value: "Université de Caen Normandie",
  },
  {
    label: "Université de Carthage",
    value: "Université de Carthage",
  },
  {
    label: "Université de Conservation de la Nature et de Développement",
    value: "Université de Conservation de la Nature et de Développement",
  },
  {
    label: "Université de Corse Pasquale Paoli",
    value: "Université de Corse Pasquale Paoli",
  },
  {
    label: "Université de Dédougou",
    value: "Université de Dédougou",
  },
  {
    label: "Université de Djibouti",
    value: "Université de Djibouti",
  },
  {
    label: "Université de Doba",
    value: "Université de Doba",
  },
  {
    label: "Université de Douala",
    value: "Université de Douala",
  },
  {
    label: "Université de Dschang",
    value: "Université de Dschang",
  },
  {
    label: "Université de Fianarantsoa",
    value: "Université de Fianarantsoa",
  },
  {
    label: "Université de Fondwa",
    value: "Université de Fondwa",
  },
  {
    label: "Université de Franche-Comté",
    value: "Université de Franche-Comté",
  },
  {
    label: "Université de Fribourg",
    value: "Université de Fribourg",
  },
  {
    label: "Université de Gabès",
    value: "Université de Gabès",
  },
  {
    label: "Université de Gafsa",
    value: "Université de Gafsa",
  },
  {
    label: "Université de Gbadolite",
    value: "Université de Gbadolite",
  },
  {
    label: "Université de Genève",
    value: "Université de Genève",
  },
  {
    label: "Université de Ghardaia",
    value: "Université de Ghardaia",
  },
  {
    label: "Université de Goma",
    value: "Université de Goma",
  },
  {
    label: "Université de Guyane",
    value: "Université de Guyane",
  },
  {
    label: "Université de Haute-Alsace",
    value: "Université de Haute-Alsace",
  },
  {
    label: "Université de Hearst",
    value: "Université de Hearst",
  },
  {
    label: "Université de Jendouba",
    value: "Université de Jendouba",
  },
  {
    label: "Université de Kabinda",
    value: "Université de Kabinda",
  },
  {
    label: "Université de Kairouan",
    value: "Université de Kairouan",
  },
  {
    label: "Université de Kalemie",
    value: "Université de Kalemie",
  },
  {
    label: "Université de Kamina",
    value: "Université de Kamina",
  },
  {
    label: "Université de Kananga",
    value: "Université de Kananga",
  },
  {
    label: "Université de Kara",
    value: "Université de Kara",
  },
  {
    label: "Université de Kikwit",
    value: "Université de Kikwit",
  },
  {
    label: "Université de Kindu",
    value: "Université de Kindu",
  },
  {
    label: "Université de Kinshasa",
    value: "Université de Kinshasa",
  },
  {
    label: "Université de Kisangani",
    value: "Université de Kisangani",
  },
  {
    label: "Université de Kolwezi",
    value: "Université de Kolwezi",
  },
  {
    label: "Université de l’Atlantique",
    value: "Université de l’Atlantique",
  },
  {
    label: "Université de la Manouba",
    value: "Université de la Manouba",
  },
  {
    label: "Université de la Nouvelle Grand'Anse",
    value: "Université de la Nouvelle Grand'Anse",
  },
  {
    label: "Université de la Nouvelle-Calédonie",
    value: "Université de la Nouvelle-Calédonie",
  },
  {
    label: "Université de la Polynésie Française",
    value: "Université de la Polynésie Française",
  },
  {
    label: "Université de la Reunion",
    value: "Université de la Reunion",
  },
  {
    label: "Université de Lausanne",
    value: "Université de Lausanne",
  },
  {
    label: "Université de Liège",
    value: "Université de Liège",
  },
  {
    label: "Université de Likasi",
    value: "Université de Likasi",
  },
  {
    label: "Université de Lille",
    value: "Université de Lille",
  },
  {
    label: "Université de Limoges",
    value: "Université de Limoges",
  },
  {
    label: "Université de Lisala",
    value: "Université de Lisala",
  },
  {
    label: "Université de Lodja",
    value: "Université de Lodja",
  },
  {
    label: "Université de Lomé",
    value: "Université de Lomé",
  },
  {
    label: "Université de Lorraine",
    value: "Université de Lorraine",
  },
  {
    label: "Université de Lubumbashi",
    value: "Université de Lubumbashi",
  },
  {
    label: "Université de l'Uélé",
    value: "Université de l'Uélé",
  },
  {
    label: "Université de Mahajanga",
    value: "Université de Mahajanga",
  },
  {
    label: "Université de Malemba Nkulu",
    value: "Université de Malemba Nkulu",
  },
  {
    label: "Université de Man",
    value: "Université de Man",
  },
  {
    label: "Université de Maroua",
    value: "Université de Maroua",
  },
  {
    label: "Université de Mbandaka",
    value: "Université de Mbandaka",
  },
  {
    label: "Université de Mbuji Mayi",
    value: "Université de Mbuji Mayi",
  },
  {
    label: "Université de Monastir",
    value: "Université de Monastir",
  },
  {
    label: "Université de Moncton",
    value: "Université de Moncton",
  },
  {
    label: "Université de Mons",
    value: "Université de Mons",
  },
  {
    label: "Université de Montpellier",
    value: "Université de Montpellier",
  },
  {
    label: "Université de Montréal",
    value: "Université de Montréal",
  },
  {
    label: "Université de Moundou",
    value: "Université de Moundou",
  },
  {
    label: "Université de Mwaro",
    value: "Université de Mwaro",
  },
  {
    label: "Université de Mwene-Ditu",
    value: "Université de Mwene-Ditu",
  },
  {
    label: "Université de Namur",
    value: "Université de Namur",
  },
  {
    label: "Université de N'Djaména",
    value: "Université de N'Djaména",
  },
  {
    label: "Université de Neuchâtel",
    value: "Université de Neuchâtel",
  },
  {
    label: "Université de Ngaoundéré",
    value: "Université de Ngaoundéré",
  },
  {
    label: "Université de Ngozi",
    value: "Université de Ngozi",
  },
  {
    label: "Université de Nîmes",
    value: "Université de Nîmes",
  },
  {
    label: "Université de Ouahigouya",
    value: "Université de Ouahigouya",
  },
  {
    label: "Université de Parakou",
    value: "Université de Parakou",
  },
  {
    label: "Université de Paris",
    value: "Université de Paris",
  },
  {
    label: "Université de Pau et des Pays de l'Adour",
    value: "Université de Pau et des Pays de l'Adour",
  },
  {
    label: "Université de Perpignan Via Domitia",
    value: "Université de Perpignan Via Domitia",
  },
  {
    label: "Université de Picardie Jules Verne",
    value: "Université de Picardie Jules Verne",
  },
  {
    label: "Université de Poitiers",
    value: "Université de Poitiers",
  },
  {
    label: "Université de Port-au-Prince",
    value: "Université de Port-au-Prince",
  },
  {
    label: "Université de Reims Champagne-Ardenne",
    value: "Université de Reims Champagne-Ardenne",
  },
  {
    label: "Université de Rennes",
    value: "Université de Rennes",
  },
  {
    label: "Université de Rouen Normandie",
    value: "Université de Rouen Normandie",
  },
  {
    label: "Université de Saint-Boniface",
    value: "Université de Saint-Boniface",
  },
  {
    label: "Université de San Pedro",
    value: "Université de San Pedro",
  },
  {
    label: "Université de Sarh",
    value: "Université de Sarh",
  },
  {
    label: "Université de Ségou",
    value: "Université de Ségou",
  },
  {
    label: "Université de Sfax",
    value: "Université de Sfax",
  },
  {
    label: "Université de Sherbrooke",
    value: "Université de Sherbrooke",
  },
  {
    label: "Université de Sousse",
    value: "Université de Sousse",
  },
  {
    label: "Université de Strasbourg",
    value: "Université de Strasbourg",
  },
  {
    label: "Université de Technologie de Belfort-Montbéliard",
    value: "Université de Technologie de Belfort-Montbéliard",
  },
  {
    label: "Université de Technologie de Compiègne",
    value: "Université de Technologie de Compiègne",
  },
  {
    label: "Université de Technologie de Troyes",
    value: "Université de Technologie de Troyes",
  },
  {
    label:
      "Université de Technologie et de Sciences Appliquées Libano-Française",
    value:
      "Université de Technologie et de Sciences Appliquées Libano-Française",
  },
  {
    label: "Université de Thiès",
    value: "Université de Thiès",
  },
  {
    label: "Université de Tissemsilt",
    value: "Université de Tissemsilt",
  },
  {
    label: "Université de Toamasina",
    value: "Université de Toamasina",
  },
  {
    label: "Université de Toliara",
    value: "Université de Toliara",
  },
  {
    label: "Université de Toulon",
    value: "Université de Toulon",
  },
  {
    label: "Université de Tours",
    value: "Université de Tours",
  },
  {
    label: "Université de Tunis",
    value: "Université de Tunis",
  },
  {
    label: "Université de Tunis El Manar",
    value: "Université de Tunis El Manar",
  },
  {
    label: "Université de Versailles Saint-Quentin-en-Yvelines",
    value: "Université de Versailles Saint-Quentin-en-Yvelines",
  },
  {
    label: "Université de Yaoundé I",
    value: "Université de Yaoundé I",
  },
  {
    label: "Université de Yaoundé II",
    value: "Université de Yaoundé II",
  },
  {
    label: "Université des Antilles",
    value: "Université des Antilles",
  },
  {
    label: "Université des Grands Lacs",
    value: "Université des Grands Lacs",
  },
  {
    label: "Université des lettres et des sciences humaines de Bamako",
    value: "Université des lettres et des sciences humaines de Bamako",
  },
  {
    label: "Universite des Mascareignes",
    value: "Universite des Mascareignes",
  },
  {
    label: "Université des Montagnes",
    value: "Université des Montagnes",
  },
  {
    label: "Université des Sciences de la Santé",
    value: "Université des Sciences de la Santé",
  },
  {
    label: "Université des Sciences d'Informatique Appliquée",
    value: "Université des Sciences d'Informatique Appliquée",
  },
  {
    label:
      "Université des Sciences et de la Technologie d'Oran Mohamed Boudiaf",
    value:
      "Université des Sciences et de la Technologie d'Oran Mohamed Boudiaf",
  },
  {
    label: "Université des Sciences et de la Technologie Houari Boumediène",
    value: "Université des Sciences et de la Technologie Houari Boumediène",
  },
  {
    label: "Université des Sciences et de Technologie d'Ati",
    value: "Université des Sciences et de Technologie d'Ati",
  },
  {
    label: "Université des Sciences et Techniques de Masuku",
    value: "Université des Sciences et Techniques de Masuku",
  },
  {
    label: "Université des Sciences et Technologies de Lodja",
    value: "Université des Sciences et Technologies de Lodja",
  },
  {
    label: "Université des Sciences et Technologies du Togo",
    value: "Université des Sciences et Technologies du Togo",
  },
  {
    label: "Université des Sciences Islamiques Emir Abdelkader",
    value: "Université des Sciences Islamiques Emir Abdelkader",
  },
  {
    label: "Université des sciences juridiques et politiques de Bamako",
    value: "Université des sciences juridiques et politiques de Bamako",
  },
  {
    label: "Université des sciences sociales et de gestion de Bamako",
    value: "Université des sciences sociales et de gestion de Bamako",
  },
  {
    label: "Université des Sciences, de Technologie et de Médecine",
    value: "Université des Sciences, de Technologie et de Médecine",
  },
  {
    label:
      "Université des sciences, des techniques et des technologies de Bamako",
    value:
      "Université des sciences, des techniques et des technologies de Bamako",
  },
  {
    label: "Université d'Etat d'Haiti",
    value: "Université d'Etat d'Haiti",
  },
  {
    label: "Université d'Évry-Val d'Essonne",
    value: "Université d'Évry-Val d'Essonne",
  },
  {
    label: "Université Divina Gloria",
    value: "Université Divina Gloria",
  },
  {
    label: "Université Djilali Bounaama de Khemis Miliana",
    value: "Université Djilali Bounaama de Khemis Miliana",
  },
  {
    label: "Université Djillali Liabès de Sidi-Bel-Abbès",
    value: "Université Djillali Liabès de Sidi-Bel-Abbès",
  },
  {
    label: "Université d'Orléans",
    value: "Université d'Orléans",
  },
  {
    label: "Université du Burundi",
    value: "Université du Burundi",
  },
  {
    label: "Université du Cepromad",
    value: "Université du Cepromad",
  },
  {
    label: "Université du Cinquantenaire de Lwiro",
    value: "Université du Cinquantenaire de Lwiro",
  },
  {
    label: "Université du Faso",
    value: "Université du Faso",
  },
  {
    label: "Université du Havre",
    value: "Université du Havre",
  },
  {
    label: "Université du Kwango",
    value: "Université du Kwango",
  },
  {
    label: "Université du Lac Tanganyika",
    value: "Université du Lac Tanganyika",
  },
  {
    label: "Université du Littoral Côte d'Opale",
    value: "Université du Littoral Côte d'Opale",
  },
  {
    label: "Université du Luxembourg",
    value: "Université du Luxembourg",
  },
  {
    label: "Université du Moyen Lualaba de Kalima au Maniema",
    value: "Université du Moyen Lualaba de Kalima au Maniema",
  },
  {
    label: "Université du Québec",
    value: "Université du Québec",
  },
  {
    label: "Université du Québec à Chicoutimi",
    value: "Université du Québec à Chicoutimi",
  },
  {
    label: "Université du Québec à Montréal",
    value: "Université du Québec à Montréal",
  },
  {
    label: "Université du Québec à Rimouski",
    value: "Université du Québec à Rimouski",
  },
  {
    label: "Université du Québec à Trois-Rivières",
    value: "Université du Québec à Trois-Rivières",
  },
  {
    label: "Université du Québec en Abitibi-Témiscamingue",
    value: "Université du Québec en Abitibi-Témiscamingue",
  },
  {
    label: "Université du Québec en Outaouais",
    value: "Université du Québec en Outaouais",
  },
  {
    label: "Université du Sahel",
    value: "Université du Sahel",
  },
  {
    label: "Université du Tripoli",
    value: "Université du Tripoli",
  },
  {
    label: "Université Echahid Hamma Lakhdar d'El Oued",
    value: "Université Echahid Hamma Lakhdar d'El Oued",
  },
  {
    label: "Université Emi Koussi",
    value: "Université Emi Koussi",
  },
  {
    label: "Université Épiscopale d'Haiti",
    value: "Université Épiscopale d'Haiti",
  },
  {
    label: "Université Espoir d'Afrique",
    value: "Université Espoir d'Afrique",
  },
  {
    label: "Université Euro-Afrique",
    value: "Université Euro-Afrique",
  },
  {
    label: "Université Euro-Méditerranéenne de Fès",
    value: "Université Euro-Méditerranéenne de Fès",
  },
  {
    label: "Université Européenne de Tunis",
    value: "Université Européenne de Tunis",
  },
  {
    label: "Université Evangélique en Afrique",
    value: "Université Evangélique en Afrique",
  },
  {
    label: "Université Ez-Zitouna",
    value: "Université Ez-Zitouna",
  },
  {
    label: "Université Félix Houphouët-Boigny",
    value: "Université Félix Houphouët-Boigny",
  },
  {
    label: "Université Ferhat Abbas Sétif 1",
    value: "Université Ferhat Abbas Sétif 1",
  },
  {
    label: "Université Française d'Égypte",
    value: "Université Française d'Égypte",
  },
  {
    label: "Université Française en Arménie",
    value: "Université Française en Arménie",
  },
  {
    label: "Université Franco-Gabonaise Saint-Exupéry",
    value: "Université Franco-Gabonaise Saint-Exupéry",
  },
  {
    label: "Université Franco-Haïtienne du Cap-Haïtien",
    value: "Université Franco-Haïtienne du Cap-Haïtien",
  },
  {
    label: "Université Frères Mentouri Constantine 1",
    value: "Université Frères Mentouri Constantine 1",
  },
  {
    label: "Université G.O.C.",
    value: "Université G.O.C.",
  },
  {
    label: "Université Gaston Berger",
    value: "Université Gaston Berger",
  },
  {
    label: "Université Grenoble Alpes",
    value: "Université Grenoble Alpes",
  },
  {
    label: "Université Gustave Eiffel",
    value: "Université Gustave Eiffel",
  },
  {
    label: "Université Hadj Lakhder de Batna 1",
    value: "Université Hadj Lakhder de Batna 1",
  },
  {
    label: "Université Hassan 1er",
    value: "Université Hassan 1er",
  },
  {
    label: "Université Hassan II de Casablanca",
    value: "Université Hassan II de Casablanca",
  },
  {
    label: "Université Hassiba Ben Bouali de Chlef",
    value: "Université Hassiba Ben Bouali de Chlef",
  },
  {
    label: "Université Ibn Khaldoun",
    value: "Université Ibn Khaldoun",
  },
  {
    label: "Université Ibn Khaldoun de Tiaret",
    value: "Université Ibn Khaldoun de Tiaret",
  },
  {
    label: "Université Ibn Tofail",
    value: "Université Ibn Tofail",
  },
  {
    label: "Université Ibn Zohr",
    value: "Université Ibn Zohr",
  },
  {
    label: "Université Internationale Abulcasis des Sciences de la Santé",
    value: "Université Internationale Abulcasis des Sciences de la Santé",
  },
  {
    label: "Université Internationale d'Agadir",
    value: "Université Internationale d'Agadir",
  },
  {
    label: "Université Internationale de Casablanca",
    value: "Université Internationale de Casablanca",
  },
  {
    label: "Université Internationale de Rabat",
    value: "Université Internationale de Rabat",
  },
  {
    label: "Université Internationale de Tunis",
    value: "Université Internationale de Tunis",
  },
  {
    label: "Université INUKA",
    value: "Université INUKA",
  },
  {
    label: "Université IRGIB Africa",
    value: "Université IRGIB Africa",
  },
  {
    label: "Université Islamique de Say",
    value: "Université Islamique de Say",
  },
  {
    label: "Université Jean Lorougnon Guédé",
    value: "Université Jean Lorougnon Guédé",
  },
  {
    label: "Université Jean Monnet",
    value: "Université Jean Monnet",
  },
  {
    label: "Université Jean Moulin Lyon 3",
    value: "Université Jean Moulin Lyon 3",
  },
  {
    label: "Université Joseph Kasa-Vubu",
    value: "Université Joseph Kasa-Vubu",
  },
  {
    label: "Université Joseph Lafortune",
    value: "Université Joseph Lafortune",
  },
  {
    label: "Université Kasdi Merbah de Ouargla",
    value: "Université Kasdi Merbah de Ouargla",
  },
  {
    label: "Université Kocc Barma Saint-Louis",
    value: "Université Kocc Barma Saint-Louis",
  },
  {
    label: "Université Kofi Annan de Guinée",
    value: "Université Kofi Annan de Guinée",
  },
  {
    label: "Université Kongo",
    value: "Université Kongo",
  },
  {
    label: "Université la Sagesse",
    value: "Université la Sagesse",
  },
  {
    label: "Université Larbi Ben Mhidi de Oum El Bouaghi",
    value: "Université Larbi Ben Mhidi de Oum El Bouaghi",
  },
  {
    label: "Université Larbi Tebessi de Tébessa",
    value: "Université Larbi Tebessi de Tébessa",
  },
  {
    label: "Université Laval",
    value: "Université Laval",
  },
  {
    label: "Université Libanaise",
    value: "Université Libanaise",
  },
  {
    label: "Université Libanaise Internationale en Mauritanie",
    value: "Université Libanaise Internationale en Mauritanie",
  },
  {
    label: "Université Libano-Canadienne",
    value: "Université Libano-Canadienne",
  },
  {
    label: "Université Libre de Bruxelles",
    value: "Université Libre de Bruxelles",
  },
  {
    label: "Université Libre de Kigali",
    value: "Université Libre de Kigali",
  },
  {
    label: "Université Libre de Kinshasa",
    value: "Université Libre de Kinshasa",
  },
  {
    label: "Université Libre de Luozi",
    value: "Université Libre de Luozi",
  },
  {
    label: "Université Libre de Tunis",
    value: "Université Libre de Tunis",
  },
  {
    label: "Université Libre des Pays des Grands Lacs",
    value: "Université Libre des Pays des Grands Lacs",
  },
  {
    label: "Université Libre du Burkina",
    value: "Université Libre du Burkina",
  },
  {
    label: "Université Lounici Ali de Blida 2",
    value: "Université Lounici Ali de Blida 2",
  },
  {
    label: "Université Loyola du Congo",
    value: "Université Loyola du Congo",
  },
  {
    label: "Université Lumière de Bujumbura",
    value: "Université Lumière de Bujumbura",
  },
  {
    label: "Université Lumière Lyon 2",
    value: "Université Lumière Lyon 2",
  },
  {
    label: "Université Lumière MEBSH",
    value: "Université Lumière MEBSH",
  },
  {
    label: "Université Mahmoud El Materi",
    value: "Université Mahmoud El Materi",
  },
  {
    label: "Université Mandé Bukari",
    value: "Université Mandé Bukari",
  },
  {
    label: "Université Marien Ngouabi",
    value: "Université Marien Ngouabi",
  },
  {
    label: "Université Martin Luther King",
    value: "Université Martin Luther King",
  },
  {
    label: "Université Méditerranéenne",
    value: "Université Méditerranéenne",
  },
  {
    label: "Université Méthodiste au Katanga",
    value: "Université Méthodiste au Katanga",
  },
  {
    label: "Université M'hamed Bouguerra de Boumerdès",
    value: "Université M'hamed Bouguerra de Boumerdès",
  },
  {
    label: "Université Mohamed Ben Ahmed d'Oran 2",
    value: "Université Mohamed Ben Ahmed d'Oran 2",
  },
  {
    label: "Université Mohamed Boudiaf de M'sila",
    value: "Université Mohamed Boudiaf de M'sila",
  },
  {
    label: "Université Mohamed El Bachir El Ibrahimi de Bordj Bou Arréridj",
    value: "Université Mohamed El Bachir El Ibrahimi de Bordj Bou Arréridj",
  },
  {
    label: "Université Mohamed Khider de Biskra",
    value: "Université Mohamed Khider de Biskra",
  },
  {
    label: "Université Mohamed Lamine Debaghine de Sétif 2",
    value: "Université Mohamed Lamine Debaghine de Sétif 2",
  },
  {
    label: "Université Mohamed Seddik Ben Yahia de Jijel",
    value: "Université Mohamed Seddik Ben Yahia de Jijel",
  },
  {
    label: "Université Mohamed-Chérif Messaadia de Souk Ahras",
    value: "Université Mohamed-Chérif Messaadia de Souk Ahras",
  },
  {
    label: "Université Mohammed Premier",
    value: "Université Mohammed Premier",
  },
  {
    label: "Université Mohammed V",
    value: "Université Mohammed V",
  },
  {
    label: "Université Mohammed VI des Sciences de la Santé",
    value: "Université Mohammed VI des Sciences de la Santé",
  },
  {
    label: "Université Mohammed VI Polytechnique",
    value: "Université Mohammed VI Polytechnique",
  },
  {
    label: "Université Montplaisir Tunis",
    value: "Université Montplaisir Tunis",
  },
  {
    label: "Université Moulay Ismail",
    value: "Université Moulay Ismail",
  },
  {
    label: "Université Mouloud Mammeri de Tizi-Ouzou",
    value: "Université Mouloud Mammeri de Tizi-Ouzou",
  },
  {
    label: "Université Mundiapolis",
    value: "Université Mundiapolis",
  },
  {
    label: "Université Mustapha Stambouli de Mascara",
    value: "Université Mustapha Stambouli de Mascara",
  },
  {
    label: "Université Nangui Abrogoua",
    value: "Université Nangui Abrogoua",
  },
  {
    label: "Université Nationale d'Agriculture",
    value: "Université Nationale d'Agriculture",
  },
  {
    label:
      "Université Nationale des Sciences, Technologies, Ingénierie et Mathématiques",
    value:
      "Université Nationale des Sciences, Technologies, Ingénierie et Mathématiques",
  },
  {
    label: "Université Nazi Boni",
    value: "Université Nazi Boni",
  },
  {
    label: "Université Nobel d'Haiti",
    value: "Université Nobel d'Haiti",
  },
  {
    label: "Université Norbert Zongo",
    value: "Université Norbert Zongo",
  },
  {
    label: "Université Notre Dame de Lomami",
    value: "Université Notre Dame de Lomami",
  },
  {
    label: "Université Notre Dame de Tshumbe",
    value: "Université Notre Dame de Tshumbe",
  },
  {
    label: "Université Notre Dame d'Haïti",
    value: "Université Notre Dame d'Haïti",
  },
  {
    label: "Université Notre Dame du Kasayi",
    value: "Université Notre Dame du Kasayi",
  },
  {
    label: "Université Officielle de Bukavu",
    value: "Université Officielle de Bukavu",
  },
  {
    label: "Université Officielle de Mbujimayi",
    value: "Université Officielle de Mbujimayi",
  },
  {
    label: "Université Officielle de Mweka",
    value: "Université Officielle de Mweka",
  },
  {
    label: "Université Officielle de Ruwenzori",
    value: "Université Officielle de Ruwenzori",
  },
  {
    label: "Université Officielle de Semuliki",
    value: "Université Officielle de Semuliki",
  },
  {
    label: "Université Omar Bongo",
    value: "Université Omar Bongo",
  },
  {
    label: "Université Ouaga I Joseph Ki-Zerbo",
    value: "Université Ouaga I Joseph Ki-Zerbo",
  },
  {
    label: "Université Ouaga II",
    value: "Université Ouaga II",
  },
  {
    label: "Université Paris 1 Panthéon-Sorbonne",
    value: "Université Paris 1 Panthéon-Sorbonne",
  },
  {
    label: "Université Paris 8 Vincennes-Saint-Denis",
    value: "Université Paris 8 Vincennes-Saint-Denis",
  },
  {
    label: "Université Paris Dauphine-PSL, Campus de Tunis",
    value: "Université Paris Dauphine-PSL, Campus de Tunis",
  },
  {
    label: "Université Paris Nanterre",
    value: "Université Paris Nanterre",
  },
  {
    label: "Université Paris-Dauphine",
    value: "Université Paris-Dauphine",
  },
  {
    label: "Université Paris-Est Créteil Val de Marne",
    value: "Université Paris-Est Créteil Val de Marne",
  },
  {
    label: "Université Paris-Panthéon-Assas",
    value: "Université Paris-Panthéon-Assas",
  },
  {
    label: "Université Paris-Saclay",
    value: "Université Paris-Saclay",
  },
  {
    label: "Université Paris-Sorbonne Abou Dhabi",
    value: "Université Paris-Sorbonne Abou Dhabi",
  },
  {
    label: "Université Patrice Emery Lumumba",
    value: "Université Patrice Emery Lumumba",
  },
  {
    label: "Université Paul Valéry Montpellier 3",
    value: "Université Paul Valéry Montpellier 3",
  },
  {
    label: "Université Pédagogique de Kananga",
    value: "Université Pédagogique de Kananga",
  },
  {
    label: "Université Pedagogique Nationale",
    value: "Université Pedagogique Nationale",
  },
  {
    label: "Université Péléforo-Gbon-Coulibaly",
    value: "Université Péléforo-Gbon-Coulibaly",
  },
  {
    label: "Université Polytechnique de Gitega",
    value: "Université Polytechnique de Gitega",
  },
  {
    label: "Université Polytechnique Hauts-de-France",
    value: "Université Polytechnique Hauts-de-France",
  },
  {
    label: "Université Polytechnique Intégrée",
    value: "Université Polytechnique Intégrée",
  },
  {
    label: "Université Polytechnique Internationale Obiang Nguema Mbasogo",
    value: "Université Polytechnique Internationale Obiang Nguema Mbasogo",
  },
  {
    label: "Université Privée de Fès",
    value: "Université Privée de Fès",
  },
  {
    label: "Université Privée de Marrakech",
    value: "Université Privée de Marrakech",
  },
  {
    label: "Université Privée de Ouagadougou",
    value: "Université Privée de Ouagadougou",
  },
  {
    label: "Université Privée de Sousse",
    value: "Université Privée de Sousse",
  },
  {
    label:
      "Université Privée des Etudes Scientifiques et Technologiques de Mégrine",
    value:
      "Université Privée des Etudes Scientifiques et Technologiques de Mégrine",
  },
  {
    label: "Université Protestante d'Afrique Centrale",
    value: "Université Protestante d'Afrique Centrale",
  },
  {
    label: "Université Protestante de Kimpese",
    value: "Université Protestante de Kimpese",
  },
  {
    label: "Université Protestante de l'Afrique de l'Ouest",
    value: "Université Protestante de l'Afrique de l'Ouest",
  },
  {
    label: "Université Protestante de Lubumbashi",
    value: "Université Protestante de Lubumbashi",
  },
  {
    label: "Université Protestante du Congo",
    value: "Université Protestante du Congo",
  },
  {
    label: "Université Publique de l'Artibonite aux Gonaïves",
    value: "Université Publique de l'Artibonite aux Gonaïves",
  },
  {
    label: "Université Publique du Nord au Cap-haïtien",
    value: "Université Publique du Nord au Cap-haïtien",
  },
  {
    label: "Université Publique du Sud au Cayes",
    value: "Université Publique du Sud au Cayes",
  },
  {
    label: "Université Quisqueya",
    value: "Université Quisqueya",
  },
  {
    label: "Université Rennes 2",
    value: "Université Rennes 2",
  },
  {
    label: "Université Roi Fayçal",
    value: "Université Roi Fayçal",
  },
  {
    label: "Université Roi Henri Christophe",
    value: "Université Roi Henri Christophe",
  },
  {
    label: "Université Royale d'Haïti",
    value: "Université Royale d'Haïti",
  },
  {
    label: "Université Saad Dahlab de Blida 1",
    value: "Université Saad Dahlab de Blida 1",
  },
  {
    label: "Université Sagesse d’Afrique",
    value: "Université Sagesse d’Afrique",
  },
  {
    label: "Université Saint Augustin de Kinshasa",
    value: "Université Saint Augustin de Kinshasa",
  },
  {
    label: "Université Saint Thomas d'Aquin",
    value: "Université Saint Thomas d'Aquin",
  },
  {
    label: "Université Sainte Famille",
    value: "Université Sainte Famille",
  },
  {
    label: "Université Sainte-Anne",
    value: "Université Sainte-Anne",
  },
  {
    label: "Université Sainte-Croix de Mulo",
    value: "Université Sainte-Croix de Mulo",
  },
  {
    label: "Université Saint-Esprit de Kaslik",
    value: "Université Saint-Esprit de Kaslik",
  },
  {
    label: "Université Saint-Joseph de Beyrouth",
    value: "Université Saint-Joseph de Beyrouth",
  },
  {
    label: "Université Saint-Joseph de Dubai",
    value: "Université Saint-Joseph de Dubai",
  },
  {
    label: "Université Saint-Louis - Bruxelles",
    value: "Université Saint-Louis - Bruxelles",
  },
  {
    label: "Université Salah Boubnider de Constantine 3",
    value: "Université Salah Boubnider de Constantine 3",
  },
  {
    label: "Université Savoie Mont Blanc",
    value: "Université Savoie Mont Blanc",
  },
  {
    label: "Université SESAME",
    value: "Université SESAME",
  },
  {
    label: "Université Shalom de Bunia",
    value: "Université Shalom de Bunia",
  },
  {
    label: "Université Sidi Mohamed Ben Abdellah",
    value: "Université Sidi Mohamed Ben Abdellah",
  },
  {
    label: "Université Simon Kimbangu",
    value: "Université Simon Kimbangu",
  },
  {
    label: "Université Sine-Saloum El Hadji Ibrahima Niasse",
    value: "Université Sine-Saloum El Hadji Ibrahima Niasse",
  },
  {
    label: "Université Sorbonne Nouvelle - Paris 3",
    value: "Université Sorbonne Nouvelle - Paris 3",
  },
  {
    label: "Université Sorbonne Paris Nord",
    value: "Université Sorbonne Paris Nord",
  },
  {
    label: "Université Sultan Moulay Slimane",
    value: "Université Sultan Moulay Slimane",
  },
  {
    label: "Université Tahar Moulay de Saida",
    value: "Université Tahar Moulay de Saida",
  },
  {
    label: "Université Tahri Mohammed de Béchar",
    value: "Université Tahri Mohammed de Béchar",
  },
  {
    label: "Université Technologique Bel Campus",
    value: "Université Technologique Bel Campus",
  },
  {
    label: "Université Technologique Privée de Gabès",
    value: "Université Technologique Privée de Gabès",
  },
  {
    label: "Université Toulouse - Jean Jaurès",
    value: "Université Toulouse - Jean Jaurès",
  },
  {
    label: "Université Toulouse Capitole",
    value: "Université Toulouse Capitole",
  },
  {
    label: "Université Toulouse III - Paul Sabatier",
    value: "Université Toulouse III - Paul Sabatier",
  },
  {
    label: "Université Tunis Carthage",
    value: "Université Tunis Carthage",
  },
  {
    label: "Université William Booth",
    value: "Université William Booth",
  },
  {
    label: "Université Yahia Fares de Médéa",
    value: "Université Yahia Fares de Médéa",
  },
  {
    label: "Université Ziane Achour de Djelfa",
    value: "Université Ziane Achour de Djelfa",
  },
  {
    label: "Universiteit Antwerpen",
    value: "Universiteit Antwerpen",
  },
  {
    label: "Universiteit Gent",
    value: "Universiteit Gent",
  },
  {
    label: "Universiteit Hasselt",
    value: "Universiteit Hasselt",
  },
  {
    label: "Universiteit Leiden",
    value: "Universiteit Leiden",
  },
  {
    label: "Universiteit Maastricht",
    value: "Universiteit Maastricht",
  },
  {
    label: "Universiteit Stellenbosch",
    value: "Universiteit Stellenbosch",
  },
  {
    label: "Universiteit Twente",
    value: "Universiteit Twente",
  },
  {
    label: "Universiteit Utrecht",
    value: "Universiteit Utrecht",
  },
  {
    label: "Universiteit van Amsterdam",
    value: "Universiteit van Amsterdam",
  },
  {
    label: "Universiteit van Curaçao",
    value: "Universiteit van Curaçao",
  },
  {
    label: "Universiteit voor Humanistiek",
    value: "Universiteit voor Humanistiek",
  },
  {
    label: "Universitetet i Agder",
    value: "Universitetet i Agder",
  },
  {
    label: "Universitetet i Bergen",
    value: "Universitetet i Bergen",
  },
  {
    label: "Universitetet i Nordland",
    value: "Universitetet i Nordland",
  },
  {
    label: "Universitetet i Oslo",
    value: "Universitetet i Oslo",
  },
  {
    label: "Universitetet i Sørøst-Norge",
    value: "Universitetet i Sørøst-Norge",
  },
  {
    label: "Universitetet i Stavanger",
    value: "Universitetet i Stavanger",
  },
  {
    label: "Universiteti Albanian University",
    value: "Universiteti Albanian University",
  },
  {
    label: "Universiteti Aldent",
    value: "Universiteti Aldent",
  },
  {
    label: "Universiteti Aleksandër Moisiu, Durrës",
    value: "Universiteti Aleksandër Moisiu, Durrës",
  },
  {
    label: "Universiteti Bujqësor i Tiranës",
    value: "Universiteti Bujqësor i Tiranës",
  },
  {
    label: "Universiteti Epoka",
    value: "Universiteti Epoka",
  },
  {
    label: "Universiteti Eqrem Çabej, Gjirokastër",
    value: "Universiteti Eqrem Çabej, Gjirokastër",
  },
  {
    label: "Universiteti Europian i Tiranës",
    value: "Universiteti Europian i Tiranës",
  },
  {
    label: "Universiteti Fan S. Noli, Korçë",
    value: "Universiteti Fan S. Noli, Korçë",
  },
  {
    label: "Universiteti Haxhi Zeka",
    value: "Universiteti Haxhi Zeka",
  },
  {
    label: "Universiteti i Arteve",
    value: "Universiteti i Arteve",
  },
  {
    label: "Universiteti i Elbasanit Aleksandër Xhuvani",
    value: "Universiteti i Elbasanit Aleksandër Xhuvani",
  },
  {
    label: "Universiteti i Gjakovës Fehmi Agani",
    value: "Universiteti i Gjakovës Fehmi Agani",
  },
  {
    label: "Universiteti i Mitrovicës Isa Boletini",
    value: "Universiteti i Mitrovicës Isa Boletini",
  },
  {
    label: "Universiteti i Mjekësisë, Tiranë",
    value: "Universiteti i Mjekësisë, Tiranë",
  },
  {
    label: "Universiteti i New York-ut në Tiranë",
    value: "Universiteti i New York-ut në Tiranë",
  },
  {
    label: "Universiteti i Prishtinës",
    value: "Universiteti i Prishtinës",
  },
  {
    label: "Universiteti i Prizrenit Ukshin Hoti",
    value: "Universiteti i Prizrenit Ukshin Hoti",
  },
  {
    label: "Universiteti i Shkencave të Aplikuara në Ferizaj",
    value: "Universiteti i Shkencave të Aplikuara në Ferizaj",
  },
  {
    label: "Universiteti i Shkodrës Luigj Gurakuqi",
    value: "Universiteti i Shkodrës Luigj Gurakuqi",
  },
  {
    label: "Universiteti i Sporteve të Tiranës",
    value: "Universiteti i Sporteve të Tiranës",
  },
  {
    label: "Universiteti i Tetovës",
    value: "Universiteti i Tetovës",
  },
  {
    label: "Universiteti i Tiranës",
    value: "Universiteti i Tiranës",
  },
  {
    label: "Universiteti i Vlorës, Ismail Qemali",
    value: "Universiteti i Vlorës, Ismail Qemali",
  },
  {
    label: "Universiteti Kadri Zeka Gjilan",
    value: "Universiteti Kadri Zeka Gjilan",
  },
  {
    label: "Universiteti Katolik Zoja e Këshillit Të Mirë",
    value: "Universiteti Katolik Zoja e Këshillit Të Mirë",
  },
  {
    label: "Universiteti Luarasi",
    value: "Universiteti Luarasi",
  },
  {
    label: "Universiteti Marin Barleti",
    value: "Universiteti Marin Barleti",
  },
  {
    label: "Universiteti Mesdhetar i Shqipërisë",
    value: "Universiteti Mesdhetar i Shqipërisë",
  },
  {
    label: "Universiteti Metropolitan Tirana",
    value: "Universiteti Metropolitan Tirana",
  },
  {
    label: "Universiteti Nderkombetar i Struges",
    value: "Universiteti Nderkombetar i Struges",
  },
  {
    label: "Universiteti Polis",
    value: "Universiteti Polis",
  },
  {
    label: "Universiteti Politeknik i Tiranës",
    value: "Universiteti Politeknik i Tiranës",
  },
  {
    label: "Universitetssenteret på Svalbard",
    value: "Universitetssenteret på Svalbard",
  },
  {
    label: "Universiti AIMST",
    value: "Universiti AIMST",
  },
  {
    label: "Universiti Antarabangsa AlBukhary",
    value: "Universiti Antarabangsa AlBukhary",
  },
  {
    label: "Universiti Brunei Darussalam",
    value: "Universiti Brunei Darussalam",
  },
  {
    label: "Universiti Islam Antarabangsa Malaysia",
    value: "Universiti Islam Antarabangsa Malaysia",
  },
  {
    label: "Universiti Islam Sultan Sharif Ali",
    value: "Universiti Islam Sultan Sharif Ali",
  },
  {
    label: "Universiti Kebangsaan Malaysia",
    value: "Universiti Kebangsaan Malaysia",
  },
  {
    label: "Universiti Kuala Lumpur",
    value: "Universiti Kuala Lumpur",
  },
  {
    label: "Universiti Malaya",
    value: "Universiti Malaya",
  },
  {
    label: "Universiti Malaysia Kelantan",
    value: "Universiti Malaysia Kelantan",
  },
  {
    label: "Universiti Malaysia Pahang Al-Sultan Abdullah",
    value: "Universiti Malaysia Pahang Al-Sultan Abdullah",
  },
  {
    label: "Universiti Malaysia Perlis",
    value: "Universiti Malaysia Perlis",
  },
  {
    label: "Universiti Malaysia Sabah",
    value: "Universiti Malaysia Sabah",
  },
  {
    label: "Universiti Malaysia Sarawak",
    value: "Universiti Malaysia Sarawak",
  },
  {
    label: "Universiti Malaysia Terengganu",
    value: "Universiti Malaysia Terengganu",
  },
  {
    label: "Universiti Pendidikan Sultan Idris",
    value: "Universiti Pendidikan Sultan Idris",
  },
  {
    label: "Universiti Pertahanan Nasional Malaysia",
    value: "Universiti Pertahanan Nasional Malaysia",
  },
  {
    label: "Universiti Perubatan Antarabangsa",
    value: "Universiti Perubatan Antarabangsa",
  },
  {
    label: "Universiti Putra Malaysia",
    value: "Universiti Putra Malaysia",
  },
  {
    label: "Universiti Sains Islam Malaysia",
    value: "Universiti Sains Islam Malaysia",
  },
  {
    label: "Universiti Sains Malaysia",
    value: "Universiti Sains Malaysia",
  },
  {
    label: "Universiti Selangor",
    value: "Universiti Selangor",
  },
  {
    label: "Universiti Sultan Zainal Abidin",
    value: "Universiti Sultan Zainal Abidin",
  },
  {
    label: "Universiti Teknikal Malaysia Melaka",
    value: "Universiti Teknikal Malaysia Melaka",
  },
  {
    label: "Universiti Teknologi Brunei",
    value: "Universiti Teknologi Brunei",
  },
  {
    label: "Universiti Teknologi Kreatif Limkokwing",
    value: "Universiti Teknologi Kreatif Limkokwing",
  },
  {
    label: "Universiti Teknologi Malaysia",
    value: "Universiti Teknologi Malaysia",
  },
  {
    label: "Universiti Teknologi MARA",
    value: "Universiti Teknologi MARA",
  },
  {
    label: "Universiti Teknologi Petronas",
    value: "Universiti Teknologi Petronas",
  },
  {
    label: "Universiti Tenaga Nasional",
    value: "Universiti Tenaga Nasional",
  },
  {
    label: "Universiti Tun Abdul Razak",
    value: "Universiti Tun Abdul Razak",
  },
  {
    label: "Universiti Tun Hussein Onn Malaysia",
    value: "Universiti Tun Hussein Onn Malaysia",
  },
  {
    label: "Universiti Tunku Abdul Rahman",
    value: "Universiti Tunku Abdul Rahman",
  },
  {
    label: "Universiti Utara Malaysia",
    value: "Universiti Utara Malaysia",
  },
  {
    label: "University 'Miras'",
    value: "University 'Miras'",
  },
  {
    label: "University American College Skopje",
    value: "University American College Skopje",
  },
  {
    label: "University at Albany, State University of New York",
    value: "University at Albany, State University of New York",
  },
  {
    label: "University at Buffalo, State University of New York",
    value: "University at Buffalo, State University of New York",
  },
  {
    label: "University Canada West",
    value: "University Canada West",
  },
  {
    label: "University College Birmingham",
    value: "University College Birmingham",
  },
  {
    label: "University College Cork",
    value: "University College Cork",
  },
  {
    label: "University College Dublin",
    value: "University College Dublin",
  },
  {
    label: "University College Lillebaelt",
    value: "University College Lillebaelt",
  },
  {
    label: "University College London",
    value: "University College London",
  },
  {
    label: "University College of Agriculture and Environmental Studies",
    value: "University College of Agriculture and Environmental Studies",
  },
  {
    label: "University College of Applied Sciences",
    value: "University College of Applied Sciences",
  },
  {
    label: "University College of Bahrain",
    value: "University College of Bahrain",
  },
  {
    label: "University College of Management Studies",
    value: "University College of Management Studies",
  },
  {
    label: "University College of Science and Technology",
    value: "University College of Science and Technology",
  },
  {
    label: "University College of Technology",
    value: "University College of Technology",
  },
  {
    label: "University College of the Cayman Islands",
    value: "University College of the Cayman Islands",
  },
  {
    label: "University College Prague",
    value: "University College Prague",
  },
  {
    label: "University for Development Studies",
    value: "University for Development Studies",
  },
  {
    label:
      "University for Information Science and Technology St. Paul the Apostle",
    value:
      "University for Information Science and Technology St. Paul the Apostle",
  },
  {
    label: "University for the Creative Arts",
    value: "University for the Creative Arts",
  },
  {
    label: "University of Aberdeen",
    value: "University of Aberdeen",
  },
  {
    label: "University of Abuja",
    value: "University of Abuja",
  },
  {
    label: "University of Aden",
    value: "University of Aden",
  },
  {
    label: "University of Advancing Technology",
    value: "University of Advancing Technology",
  },
  {
    label: "University of Africa",
    value: "University of Africa",
  },
  {
    label: "University of Agribusiness and Rural Development",
    value: "University of Agribusiness and Rural Development",
  },
  {
    label: "University of Agricultural and Horticultural Sciences, Shivamogga",
    value: "University of Agricultural and Horticultural Sciences, Shivamogga",
  },
  {
    label: "University of Agricultural Sciences, Bangalore",
    value: "University of Agricultural Sciences, Bangalore",
  },
  {
    label: "University of Agricultural Sciences, Dharwad",
    value: "University of Agricultural Sciences, Dharwad",
  },
  {
    label: "University of Agricultural Sciences, Raichur",
    value: "University of Agricultural Sciences, Raichur",
  },
  {
    label: "University of Agriculture, Faisalabad",
    value: "University of Agriculture, Faisalabad",
  },
  {
    label: "University of Ajdabia",
    value: "University of Ajdabia",
  },
  {
    label: "University of Akron",
    value: "University of Akron",
  },
  {
    label: "University of Al Hamdaniya",
    value: "University of Al Hamdaniya",
  },
  {
    label: "University of Alabama at Birmingham",
    value: "University of Alabama at Birmingham",
  },
  {
    label: "University of Alaska Anchorage",
    value: "University of Alaska Anchorage",
  },
  {
    label: "University of Alaska Fairbanks",
    value: "University of Alaska Fairbanks",
  },
  {
    label: "University of Alaska Southeast",
    value: "University of Alaska Southeast",
  },
  {
    label: "University of Alberta",
    value: "University of Alberta",
  },
  {
    label: "University of Albutana",
    value: "University of Albutana",
  },
  {
    label: "University of Aleppo",
    value: "University of Aleppo",
  },
  {
    label: "University of Alhadera",
    value: "University of Alhadera",
  },
  {
    label: "University of Alkafeel",
    value: "University of Alkafeel",
  },
  {
    label: "University of Allahabad",
    value: "University of Allahabad",
  },
  {
    label: "University of Al-Qadisiyah",
    value: "University of Al-Qadisiyah",
  },
  {
    label: "University of Anbar",
    value: "University of Anbar",
  },
  {
    label: "University of Antique",
    value: "University of Antique",
  },
  {
    label: "University of Applied Science and Technology",
    value: "University of Applied Science and Technology",
  },
  {
    label: "University of Applied Sciences Europe",
    value: "University of Applied Sciences Europe",
  },
  {
    label: "University of Architecture, Civil Engineering and Geodesy",
    value: "University of Architecture, Civil Engineering and Geodesy",
  },
  {
    label: "University of Arkansas",
    value: "University of Arkansas",
  },
  {
    label: "University of Arkansas - Fort Smith",
    value: "University of Arkansas - Fort Smith",
  },
  {
    label: "University of Arkansas at Little Rock",
    value: "University of Arkansas at Little Rock",
  },
  {
    label: "University of Arkansas at Monticello",
    value: "University of Arkansas at Monticello",
  },
  {
    label: "University of Arkansas at Pine Bluff",
    value: "University of Arkansas at Pine Bluff",
  },
  {
    label: "University of Arkansas for Medical Sciences",
    value: "University of Arkansas for Medical Sciences",
  },
  {
    label: "University of Art",
    value: "University of Art",
  },
  {
    label: "University of Aruba",
    value: "University of Aruba",
  },
  {
    label: "University of Asia and the Pacific",
    value: "University of Asia and the Pacific",
  },
  {
    label: "University of Asia Pacific",
    value: "University of Asia Pacific",
  },
  {
    label: "University of Auckland",
    value: "University of Auckland",
  },
  {
    label: "University of Azad Jammu and Kashmirs",
    value: "University of Azad Jammu and Kashmirs",
  },
  {
    label: "University of Babylon",
    value: "University of Babylon",
  },
  {
    label: "University of Baghdad",
    value: "University of Baghdad",
  },
  {
    label: "University of Baguio",
    value: "University of Baguio",
  },
  {
    label: "University of Bahr El-Ghazal",
    value: "University of Bahr El-Ghazal",
  },
  {
    label: "University of Bahrain",
    value: "University of Bahrain",
  },
  {
    label: "University of Bahri",
    value: "University of Bahri",
  },
  {
    label: "University of Bakhtalruda",
    value: "University of Bakhtalruda",
  },
  {
    label: "University of Balamand",
    value: "University of Balamand",
  },
  {
    label: "University of Balochistan",
    value: "University of Balochistan",
  },
  {
    label: "University of Baltimore",
    value: "University of Baltimore",
  },
  {
    label: "University of Baltistan, Skardu",
    value: "University of Baltistan, Skardu",
  },
  {
    label: "University of Barisal",
    value: "University of Barisal",
  },
  {
    label: "University of Basrah",
    value: "University of Basrah",
  },
  {
    label: "University of Batangas",
    value: "University of Batangas",
  },
  {
    label: "University of Bath",
    value: "University of Bath",
  },
  {
    label: "University of Bedfordshire",
    value: "University of Bedfordshire",
  },
  {
    label: "University of Belize",
    value: "University of Belize",
  },
  {
    label: "University of Benghazi",
    value: "University of Benghazi",
  },
  {
    label: "University of Benin",
    value: "University of Benin",
  },
  {
    label: "University of Birjand",
    value: "University of Birjand",
  },
  {
    label: "University of Birmingham",
    value: "University of Birmingham",
  },
  {
    label: "University of Birmingham Dubai",
    value: "University of Birmingham Dubai",
  },
  {
    label: "University of Bisha",
    value: "University of Bisha",
  },
  {
    label: "University of Blantyre Synod",
    value: "University of Blantyre Synod",
  },
  {
    label: "University of Blue Nile",
    value: "University of Blue Nile",
  },
  {
    label: "University of Bohol",
    value: "University of Bohol",
  },
  {
    label: "University of Bojnord",
    value: "University of Bojnord",
  },
  {
    label: "University of Bolton",
    value: "University of Bolton",
  },
  {
    label: "University of Bonab",
    value: "University of Bonab",
  },
  {
    label: "University of Botswana",
    value: "University of Botswana",
  },
  {
    label: "University of Bradford",
    value: "University of Bradford",
  },
  {
    label: "University of Bridgeport",
    value: "University of Bridgeport",
  },
  {
    label: "University of Brighton",
    value: "University of Brighton",
  },
  {
    label: "University of Bristol",
    value: "University of Bristol",
  },
  {
    label: "University of Buraimi",
    value: "University of Buraimi",
  },
  {
    label: "University of Burdwan",
    value: "University of Burdwan",
  },
  {
    label: "University of Business and Technology",
    value: "University of Business and Technology",
  },
  {
    label: "University of Cagayan Valley",
    value: "University of Cagayan Valley",
  },
  {
    label: "University of Calabar",
    value: "University of Calabar",
  },
  {
    label: "University of Calcutta",
    value: "University of Calcutta",
  },
  {
    label: "University of Calgary",
    value: "University of Calgary",
  },
  {
    label: "University of Calgary in Qatar",
    value: "University of Calgary in Qatar",
  },
  {
    label: "University of Calicut",
    value: "University of Calicut",
  },
  {
    label: "University of California College of the Law, San Francisco",
    value: "University of California College of the Law, San Francisco",
  },
  {
    label: "University of California, Berkeley",
    value: "University of California, Berkeley",
  },
  {
    label: "University of California, Davis",
    value: "University of California, Davis",
  },
  {
    label: "University of California, Irvine",
    value: "University of California, Irvine",
  },
  {
    label: "University of California, Los Angeles",
    value: "University of California, Los Angeles",
  },
  {
    label: "University of California, Merced",
    value: "University of California, Merced",
  },
  {
    label: "University of California, Riverside",
    value: "University of California, Riverside",
  },
  {
    label: "University of California, San Diego",
    value: "University of California, San Diego",
  },
  {
    label: "University of California, San Francisco",
    value: "University of California, San Francisco",
  },
  {
    label: "University of California, Santa Barbara",
    value: "University of California, Santa Barbara",
  },
  {
    label: "University of California, Santa Cruz",
    value: "University of California, Santa Cruz",
  },
  {
    label: "University of Cambridge",
    value: "University of Cambridge",
  },
  {
    label: "University of Canberra",
    value: "University of Canberra",
  },
  {
    label: "University of Canterbury",
    value: "University of Canterbury",
  },
  {
    label: "University of Cape Coast",
    value: "University of Cape Coast",
  },
  {
    label: "University of Cape Town",
    value: "University of Cape Town",
  },
  {
    label: "University of Cebu",
    value: "University of Cebu",
  },
  {
    label: "University of Central Arkansas",
    value: "University of Central Arkansas",
  },
  {
    label: "University of Central Asia",
    value: "University of Central Asia",
  },
  {
    label: "University of Central Florida",
    value: "University of Central Florida",
  },
  {
    label: "University of Central Lancashire",
    value: "University of Central Lancashire",
  },
  {
    label: "University of Central Lancashire, Cyprus",
    value: "University of Central Lancashire, Cyprus",
  },
  {
    label: "University of Central Missouri",
    value: "University of Central Missouri",
  },
  {
    label: "University of Central Oklahoma",
    value: "University of Central Oklahoma",
  },
  {
    label: "University of Central Punjab",
    value: "University of Central Punjab",
  },
  {
    label: "University of Charleston",
    value: "University of Charleston",
  },
  {
    label: "University of Chemical Technology and Metallurgy",
    value: "University of Chemical Technology and Metallurgy",
  },
  {
    label: "University of Chester",
    value: "University of Chester",
  },
  {
    label: "University of Chicago",
    value: "University of Chicago",
  },
  {
    label: "University of Chichester",
    value: "University of Chichester",
  },
  {
    label: "University of Chitral",
    value: "University of Chitral",
  },
  {
    label: "University of Chittagong",
    value: "University of Chittagong",
  },
  {
    label: "University of Cincinnati",
    value: "University of Cincinnati",
  },
  {
    label: "University of Civilization",
    value: "University of Civilization",
  },
  {
    label: "University of Colombo",
    value: "University of Colombo",
  },
  {
    label: "University of Colorado Boulder",
    value: "University of Colorado Boulder",
  },
  {
    label: "University of Colorado Colorado Springs",
    value: "University of Colorado Colorado Springs",
  },
  {
    label: "University of Colorado Denver",
    value: "University of Colorado Denver",
  },
  {
    label: "University of Community Health, Magway",
    value: "University of Community Health, Magway",
  },
  {
    label: "University of Computer Studies, Mandalay",
    value: "University of Computer Studies, Mandalay",
  },
  {
    label: "University of Computer Studies, Yangon",
    value: "University of Computer Studies, Yangon",
  },
  {
    label: "University of Connecticut",
    value: "University of Connecticut",
  },
  {
    label: "University of Creative Technology Chittagong",
    value: "University of Creative Technology Chittagong",
  },
  {
    label: "University of Crete",
    value: "University of Crete",
  },
  {
    label: "University of Cross River State",
    value: "University of Cross River State",
  },
  {
    label: "University of Cumbria",
    value: "University of Cumbria",
  },
  {
    label: "University of Customs and Finance",
    value: "University of Customs and Finance",
  },
  {
    label: "University of Cyprus",
    value: "University of Cyprus",
  },
  {
    label: "University of Dallas",
    value: "University of Dallas",
  },
  {
    label: "University of Dar es Salaam",
    value: "University of Dar es Salaam",
  },
  {
    label: "University of Dayton",
    value: "University of Dayton",
  },
  {
    label: "University of Delaware",
    value: "University of Delaware",
  },
  {
    label: "University of Delhi",
    value: "University of Delhi",
  },
  {
    label: "University of Dental Medicine, Mandalay",
    value: "University of Dental Medicine, Mandalay",
  },
  {
    label: "University of Dental Medicine, Yangon",
    value: "University of Dental Medicine, Yangon",
  },
  {
    label: "University of Denver",
    value: "University of Denver",
  },
  {
    label: "University of Derby",
    value: "University of Derby",
  },
  {
    label: "University of Detroit Mercy",
    value: "University of Detroit Mercy",
  },
  {
    label: "University of Development Alternative",
    value: "University of Development Alternative",
  },
  {
    label: "University of Dhaka",
    value: "University of Dhaka",
  },
  {
    label: "University of Diyala",
    value: "University of Diyala",
  },
  {
    label: "University of Doha for Science and Technology",
    value: "University of Doha for Science and Technology",
  },
  {
    label: "University of Dongola",
    value: "University of Dongola",
  },
  {
    label: "University of Dubai",
    value: "University of Dubai",
  },
  {
    label: "University of Dubuque",
    value: "University of Dubuque",
  },
  {
    label: "University of Dundee",
    value: "University of Dundee",
  },
  {
    label: "University of East Anglia",
    value: "University of East Anglia",
  },
  {
    label: "University of East Asia",
    value: "University of East Asia",
  },
  {
    label: "University of East Kordofan",
    value: "University of East Kordofan",
  },
  {
    label: "University of East London",
    value: "University of East London",
  },
  {
    label: "University of Eastern Africa, Baraton",
    value: "University of Eastern Africa, Baraton",
  },
  {
    label: "University of Eastern Philippines",
    value: "University of Eastern Philippines",
  },
  {
    label: "University of Economics - Technology for Industries",
    value: "University of Economics - Technology for Industries",
  },
  {
    label: "University of Economics - Varna",
    value: "University of Economics - Varna",
  },
  {
    label: "University of Economics and Law",
    value: "University of Economics and Law",
  },
  {
    label: "University of Economics Ho Chi Minh City",
    value: "University of Economics Ho Chi Minh City",
  },
  {
    label: "University of Economy and Law after Avetik Mkrtchyan",
    value: "University of Economy and Law after Avetik Mkrtchyan",
  },
  {
    label: "University of Edenberg",
    value: "University of Edenberg",
  },
  {
    label: "University of Edinburgh",
    value: "University of Edinburgh",
  },
  {
    label: "University of Education",
    value: "University of Education",
  },
  {
    label: "University of Education, Winneba",
    value: "University of Education, Winneba",
  },
  {
    label: "University of Educational Management",
    value: "University of Educational Management",
  },
  {
    label: "University of El Geneina",
    value: "University of El Geneina",
  },
  {
    label: "University of El Imam El Mahdi",
    value: "University of El Imam El Mahdi",
  },
  {
    label: "University of Eldoret",
    value: "University of Eldoret",
  },
  {
    label: "University of Electronic Science and Technology of China",
    value: "University of Electronic Science and Technology of China",
  },
  {
    label: "University of Embu",
    value: "University of Embu",
  },
  {
    label: "University of Energy and Natural Resources",
    value: "University of Energy and Natural Resources",
  },
  {
    label: "University of Engineering and Applied Sciences Swat",
    value: "University of Engineering and Applied Sciences Swat",
  },
  {
    label: "University of Engineering and Management, Kolkata",
    value: "University of Engineering and Management, Kolkata",
  },
  {
    label: "University of Engineering and Technology, Lahore",
    value: "University of Engineering and Technology, Lahore",
  },
  {
    label: "University of Engineering and Technology, Peshawar",
    value: "University of Engineering and Technology, Peshawar",
  },
  {
    label: "University of Engineering and Technology, Taxila",
    value: "University of Engineering and Technology, Taxila",
  },
  {
    label: "University of Essex",
    value: "University of Essex",
  },
  {
    label: "University of Eswatini",
    value: "University of Eswatini",
  },
  {
    label: "University of Evansville",
    value: "University of Evansville",
  },
  {
    label: "University of Exeter",
    value: "University of Exeter",
  },
  {
    label: "University of Fallujah",
    value: "University of Fallujah",
  },
  {
    label: "University of Finance and Economics",
    value: "University of Finance and Economics",
  },
  {
    label: "University of Findlay",
    value: "University of Findlay",
  },
  {
    label: "University of Florida",
    value: "University of Florida",
  },
  {
    label: "University of Food Technologies",
    value: "University of Food Technologies",
  },
  {
    label: "University of Foreign Languages and Business Career",
    value: "University of Foreign Languages and Business Career",
  },
  {
    label: "University of Foreign Languages, Yangon",
    value: "University of Foreign Languages, Yangon",
  },
  {
    label: "University of Forestry",
    value: "University of Forestry",
  },
  {
    label: "University of Forestry and Environmental Science, Yezin",
    value: "University of Forestry and Environmental Science, Yezin",
  },
  {
    label: "University of Fort Hare",
    value: "University of Fort Hare",
  },
  {
    label: "University of Fujairah",
    value: "University of Fujairah",
  },
  {
    label: "University of Fukui",
    value: "University of Fukui",
  },
  {
    label: "University of Gadarif",
    value: "University of Gadarif",
  },
  {
    label: "University of Galway",
    value: "University of Galway",
  },
  {
    label: "University of Garden City",
    value: "University of Garden City",
  },
  {
    label: "University of Garmian",
    value: "University of Garmian",
  },
  {
    label: "University of Garmsar",
    value: "University of Garmsar",
  },
  {
    label: "University of Georgia",
    value: "University of Georgia",
  },
  {
    label: "University of Gezira",
    value: "University of Gezira",
  },
  {
    label: "University of Ghana",
    value: "University of Ghana",
  },
  {
    label: "University of Gharyan",
    value: "University of Gharyan",
  },
  {
    label: "University of Gitwe",
    value: "University of Gitwe",
  },
  {
    label: "University of Glasgow",
    value: "University of Glasgow",
  },
  {
    label: "University of Global Health Equity",
    value: "University of Global Health Equity",
  },
  {
    label: "University of Global Village",
    value: "University of Global Village",
  },
  {
    label: "University of Gloucestershire",
    value: "University of Gloucestershire",
  },
  {
    label: "University of Gonabad",
    value: "University of Gonabad",
  },
  {
    label: "University of Gondar",
    value: "University of Gondar",
  },
  {
    label: "University of Goroka",
    value: "University of Goroka",
  },
  {
    label: "University of Gour Banga",
    value: "University of Gour Banga",
  },
  {
    label: "University of Greenwich",
    value: "University of Greenwich",
  },
  {
    label: "University of Guam",
    value: "University of Guam",
  },
  {
    label: "University of Guelph",
    value: "University of Guelph",
  },
  {
    label: "University of Gujrat",
    value: "University of Gujrat",
  },
  {
    label: "University of Guyana",
    value: "University of Guyana",
  },
  {
    label: "University of Hafr Al Batin",
    value: "University of Hafr Al Batin",
  },
  {
    label: "University of Hai Duong",
    value: "University of Hai Duong",
  },
  {
    label: "University of Haifa",
    value: "University of Haifa",
  },
  {
    label: "University of Ha'il",
    value: "University of Ha'il",
  },
  {
    label: "University of Halabja",
    value: "University of Halabja",
  },
  {
    label: "University of Hama",
    value: "University of Hama",
  },
  {
    label: "University of Haripur",
    value: "University of Haripur",
  },
  {
    label: "University of Hartford",
    value: "University of Hartford",
  },
  {
    label: "University of Hawaii at Hilo",
    value: "University of Hawaii at Hilo",
  },
  {
    label: "University of Hawaii at Manoa",
    value: "University of Hawaii at Manoa",
  },
  {
    label: "University of Hawaii-West Oahu",
    value: "University of Hawaii-West Oahu",
  },
  {
    label: "University of Health and Allied Sciences",
    value: "University of Health and Allied Sciences",
  },
  {
    label: "University of Health Sciences and Pharmacy in St. Louis",
    value: "University of Health Sciences and Pharmacy in St. Louis",
  },
  {
    label: "University of Health Sciences Antigua",
    value: "University of Health Sciences Antigua",
  },
  {
    label: "University of Health Sciences, Lahore",
    value: "University of Health Sciences, Lahore",
  },
  {
    label: "University of Hertfordshire",
    value: "University of Hertfordshire",
  },
  {
    label: "University of Holy Cross",
    value: "University of Holy Cross",
  },
  {
    label: "University of Horticultural Sciences, Bagalkot",
    value: "University of Horticultural Sciences, Bagalkot",
  },
  {
    label: "University of Houston",
    value: "University of Houston",
  },
  {
    label: "University of Houston-Clear Lake",
    value: "University of Houston-Clear Lake",
  },
  {
    label: "University of Houston-Downtown",
    value: "University of Houston-Downtown",
  },
  {
    label: "University of Houston-Victoria",
    value: "University of Houston-Victoria",
  },
  {
    label: "University of Huddersfield",
    value: "University of Huddersfield",
  },
  {
    label: "University of Hull",
    value: "University of Hull",
  },
  {
    label: "University of Human Arts and Sciences",
    value: "University of Human Arts and Sciences",
  },
  {
    label: "University of Human Development",
    value: "University of Human Development",
  },
  {
    label: "University of Human Environments",
    value: "University of Human Environments",
  },
  {
    label: "University of Humanities",
    value: "University of Humanities",
  },
  {
    label: "University of Hyderabad",
    value: "University of Hyderabad",
  },
  {
    label: "University of Hyogo",
    value: "University of Hyogo",
  },
  {
    label: "University of Ibadan",
    value: "University of Ibadan",
  },
  {
    label: "University of Idaho",
    value: "University of Idaho",
  },
  {
    label: "University of Illinois at Springfield",
    value: "University of Illinois at Springfield",
  },
  {
    label: "University of Illinois Chicago",
    value: "University of Illinois Chicago",
  },
  {
    label: "University of Illinois Urbana-Champaign",
    value: "University of Illinois Urbana-Champaign",
  },
  {
    label: "University of Iloilo - PHINMA",
    value: "University of Iloilo - PHINMA",
  },
  {
    label: "University of Ilorin",
    value: "University of Ilorin",
  },
  {
    label: "University of Incheon",
    value: "University of Incheon",
  },
  {
    label: "University of Indianapolis",
    value: "University of Indianapolis",
  },
  {
    label: "University of Information Technology and Communications",
    value: "University of Information Technology and Communications",
  },
  {
    label: "University of Information Technology and Sciences",
    value: "University of Information Technology and Sciences",
  },
  {
    label: "University of Innovation and Technology of Western Kazakhstan",
    value: "University of Innovation and Technology of Western Kazakhstan",
  },
  {
    label: "University of International Business",
    value: "University of International Business",
  },
  {
    label: "University of International Business and Economics",
    value: "University of International Business and Economics",
  },
  {
    label: "University of International Economic Relations",
    value: "University of International Economic Relations",
  },
  {
    label: "University of International Relations",
    value: "University of International Relations",
  },
  {
    label: "University of Ioannina",
    value: "University of Ioannina",
  },
  {
    label: "University of Iowa",
    value: "University of Iowa",
  },
  {
    label: "University of Iringa",
    value: "University of Iringa",
  },
  {
    label: "University of Isfahan",
    value: "University of Isfahan",
  },
  {
    label: "University of Islamic Sciences Al Hudaydah",
    value: "University of Islamic Sciences Al Hudaydah",
  },
  {
    label: "University of Jaffna",
    value: "University of Jaffna",
  },
  {
    label: "University of Jamestown",
    value: "University of Jamestown",
  },
  {
    label: "University of Jammu",
    value: "University of Jammu",
  },
  {
    label: "University of Jeddah",
    value: "University of Jeddah",
  },
  {
    label: "University of Jinan",
    value: "University of Jinan",
  },
  {
    label: "University of Jiroft",
    value: "University of Jiroft",
  },
  {
    label: "University of Johannesburg",
    value: "University of Johannesburg",
  },
  {
    label: "University of Jordan",
    value: "University of Jordan",
  },
  {
    label: "University of Jos",
    value: "University of Jos",
  },
  {
    label: "University of Juba",
    value: "University of Juba",
  },
  {
    label: "University of Kabianga",
    value: "University of Kabianga",
  },
  {
    label: "University of Kalamoon",
    value: "University of Kalamoon",
  },
  {
    label: "University of Kalyani",
    value: "University of Kalyani",
  },
  {
    label: "University of Kang Ning",
    value: "University of Kang Ning",
  },
  {
    label: "University of Kansas",
    value: "University of Kansas",
  },
  {
    label: "University of Karachi",
    value: "University of Karachi",
  },
  {
    label: "University of Kashan",
    value: "University of Kashan",
  },
  {
    label: "University of Kashmir",
    value: "University of Kashmir",
  },
  {
    label: "University of Kassala",
    value: "University of Kassala",
  },
  {
    label: "University of Kelaniya",
    value: "University of Kelaniya",
  },
  {
    label: "University of Kent",
    value: "University of Kent",
  },
  {
    label: "University of Kentucky",
    value: "University of Kentucky",
  },
  {
    label: "University of Kerala",
    value: "University of Kerala",
  },
  {
    label: "University of Kerbala",
    value: "University of Kerbala",
  },
  {
    label: "University of Khartoum",
    value: "University of Khartoum",
  },
  {
    label: "University of Kibungo",
    value: "University of Kibungo",
  },
  {
    label: "University of Kigali",
    value: "University of Kigali",
  },
  {
    label: "University of King's College",
    value: "University of King's College",
  },
  {
    label: "University of Kirkuk",
    value: "University of Kirkuk",
  },
  {
    label: "University of Kochi",
    value: "University of Kochi",
  },
  {
    label: "University of Kordofan",
    value: "University of Kordofan",
  },
  {
    label: "University of Kota",
    value: "University of Kota",
  },
  {
    label: "University of Kotli Azad Jammu and Kashmir",
    value: "University of Kotli Azad Jammu and Kashmir",
  },
  {
    label: "University of Kufa",
    value: "University of Kufa",
  },
  {
    label: "University of Kurdistan",
    value: "University of Kurdistan",
  },
  {
    label: "University of Kurdistan Hewlêr",
    value: "University of Kurdistan Hewlêr",
  },
  {
    label: "University of KwaZulu-Natal",
    value: "University of KwaZulu-Natal",
  },
  {
    label: "University of La Salette",
    value: "University of La Salette",
  },
  {
    label: "University of La Verne",
    value: "University of La Verne",
  },
  {
    label: "University of Lagos",
    value: "University of Lagos",
  },
  {
    label: "University of Lay Adventists of Kigali",
    value: "University of Lay Adventists of Kigali",
  },
  {
    label: "University of Leeds",
    value: "University of Leeds",
  },
  {
    label: "University of Leicester",
    value: "University of Leicester",
  },
  {
    label: "University of Lethbridge",
    value: "University of Lethbridge",
  },
  {
    label: "University of Liberal Arts Bangladesh",
    value: "University of Liberal Arts Bangladesh",
  },
  {
    label: "University of Liberia",
    value: "University of Liberia",
  },
  {
    label: "University of Library Studies and Information Technologies",
    value: "University of Library Studies and Information Technologies",
  },
  {
    label: "University of Lilongwe",
    value: "University of Lilongwe",
  },
  {
    label: "University of Limerick",
    value: "University of Limerick",
  },
  {
    label: "University of Limpopo",
    value: "University of Limpopo",
  },
  {
    label: "University of Lincoln",
    value: "University of Lincoln",
  },
  {
    label: "University of Liverpool",
    value: "University of Liverpool",
  },
  {
    label: "University of Livingstonia",
    value: "University of Livingstonia",
  },
  {
    label: "University of London",
    value: "University of London",
  },
  {
    label: "University of Loralai",
    value: "University of Loralai",
  },
  {
    label: "University of Louisiana at Lafayette",
    value: "University of Louisiana at Lafayette",
  },
  {
    label: "University of Louisiana at Monroe",
    value: "University of Louisiana at Monroe",
  },
  {
    label: "University of Louisville",
    value: "University of Louisville",
  },
  {
    label: "University of Lucknow",
    value: "University of Lucknow",
  },
  {
    label: "University of Lusaka",
    value: "University of Lusaka",
  },
  {
    label: "University of Luzon",
    value: "University of Luzon",
  },
  {
    label: "University of Lynchburg",
    value: "University of Lynchburg",
  },
  {
    label: "University of Macedonia",
    value: "University of Macedonia",
  },
  {
    label: "University of Madras",
    value: "University of Madras",
  },
  {
    label: "University of Maiduguri",
    value: "University of Maiduguri",
  },
  {
    label: "University of Maine at Augusta",
    value: "University of Maine at Augusta",
  },
  {
    label: "University of Maine at Farmington",
    value: "University of Maine at Farmington",
  },
  {
    label: "University of Maine at Fort Kent",
    value: "University of Maine at Fort Kent",
  },
  {
    label: "University of Maine at Machias",
    value: "University of Maine at Machias",
  },
  {
    label: "University of Maine at Presque Isle",
    value: "University of Maine at Presque Isle",
  },
  {
    label: "University of Makeni",
    value: "University of Makeni",
  },
  {
    label: "University of Malakand",
    value: "University of Malakand",
  },
  {
    label: "University of Malawi",
    value: "University of Malawi",
  },
  {
    label: "University of Management and Economics",
    value: "University of Management and Economics",
  },
  {
    label: "University of Management and Technology",
    value: "University of Management and Technology",
  },
  {
    label: "University of Manchester",
    value: "University of Manchester",
  },
  {
    label: "University of Manitoba",
    value: "University of Manitoba",
  },
  {
    label: "University of Maragheh",
    value: "University of Maragheh",
  },
  {
    label: "University of Marketing and Distribution Sciences",
    value: "University of Marketing and Distribution Sciences",
  },
  {
    label: "University of Mary",
    value: "University of Mary",
  },
  {
    label: "University of Mary Hardin-Baylor",
    value: "University of Mary Hardin-Baylor",
  },
  {
    label: "University of Mary Washington",
    value: "University of Mary Washington",
  },
  {
    label: "University of Maryland",
    value: "University of Maryland",
  },
  {
    label: "University of Maryland Eastern Shore",
    value: "University of Maryland Eastern Shore",
  },
  {
    label: "University of Maryland, Baltimore",
    value: "University of Maryland, Baltimore",
  },
  {
    label: "University of Maryland, Baltimore County",
    value: "University of Maryland, Baltimore County",
  },
  {
    label: "University of Massachusetts Amherst",
    value: "University of Massachusetts Amherst",
  },
  {
    label: "University of Massachusetts Boston",
    value: "University of Massachusetts Boston",
  },
  {
    label: "University of Massachusetts Dartmouth",
    value: "University of Massachusetts Dartmouth",
  },
  {
    label: "University of Massachusetts Global",
    value: "University of Massachusetts Global",
  },
  {
    label: "University of Massachusetts Lowell",
    value: "University of Massachusetts Lowell",
  },
  {
    label: "University of Mauritius",
    value: "University of Mauritius",
  },
  {
    label: "University of Mazandaran",
    value: "University of Mazandaran",
  },
  {
    label: "University of Medical Sciences",
    value: "University of Medical Sciences",
  },
  {
    label: "University of Medical Sciences and Technology",
    value: "University of Medical Sciences and Technology",
  },
  {
    label: "University of Medical Technology, Mandalay",
    value: "University of Medical Technology, Mandalay",
  },
  {
    label: "University of Medical Technology, Yangon",
    value: "University of Medical Technology, Yangon",
  },
  {
    label: "University of Medicine 1, Yangon",
    value: "University of Medicine 1, Yangon",
  },
  {
    label: "University of Medicine 2, Yangon",
    value: "University of Medicine 2, Yangon",
  },
  {
    label: "University of Medicine, Magway",
    value: "University of Medicine, Magway",
  },
  {
    label: "University of Medicine, Mandalay",
    value: "University of Medicine, Mandalay",
  },
  {
    label: "University of Medicine, Taunggyi",
    value: "University of Medicine, Taunggyi",
  },
  {
    label: "University of Miami",
    value: "University of Miami",
  },
  {
    label: "University of Michigan",
    value: "University of Michigan",
  },
  {
    label: "University of Michigan-Dearborn",
    value: "University of Michigan-Dearborn",
  },
  {
    label: "University of Michigan-Flint",
    value: "University of Michigan-Flint",
  },
  {
    label: "University of Mindanao",
    value: "University of Mindanao",
  },
  {
    label: "University of Mines and Technology",
    value: "University of Mines and Technology",
  },
  {
    label: "University of Mining and Geology St Ivan Rilski",
    value: "University of Mining and Geology St Ivan Rilski",
  },
  {
    label: "University of Minnesota Twin Cities",
    value: "University of Minnesota Twin Cities",
  },
  {
    label: "University of Misan",
    value: "University of Misan",
  },
  {
    label: "University of Mississippi",
    value: "University of Mississippi",
  },
  {
    label: "University of Mississippi Medical Center",
    value: "University of Mississippi Medical Center",
  },
  {
    label: "University of Missouri",
    value: "University of Missouri",
  },
  {
    label: "University of Missouri-Kansas City",
    value: "University of Missouri-Kansas City",
  },
  {
    label: "University of Missouri-St. Louis",
    value: "University of Missouri-St. Louis",
  },
  {
    label: "University of Miyazaki",
    value: "University of Miyazaki",
  },
  {
    label: "University of Mkar",
    value: "University of Mkar",
  },
  {
    label: "University of Mobile",
    value: "University of Mobile",
  },
  {
    label: "University of Modern Sciences",
    value: "University of Modern Sciences",
  },
  {
    label: "University of Mohaghegh Ardabili",
    value: "University of Mohaghegh Ardabili",
  },
  {
    label: "University of Montana",
    value: "University of Montana",
  },
  {
    label: "University of Montevallo",
    value: "University of Montevallo",
  },
  {
    label: "University of Moratuwa",
    value: "University of Moratuwa",
  },
  {
    label: "University of Mosul",
    value: "University of Mosul",
  },
  {
    label: "University of Mount Olive",
    value: "University of Mount Olive",
  },
  {
    label: "University of Mount Union",
    value: "University of Mount Union",
  },
  {
    label: "University of Mpumalanga",
    value: "University of Mpumalanga",
  },
  {
    label: "University of Mumbai",
    value: "University of Mumbai",
  },
  {
    label: "University of Myitkyina",
    value: "University of Myitkyina",
  },
  {
    label: "University of Mysore",
    value: "University of Mysore",
  },
  {
    label: "University of Nagasaki",
    value: "University of Nagasaki",
  },
  {
    label: "University of Nairobi",
    value: "University of Nairobi",
  },
  {
    label: "University of Namibia",
    value: "University of Namibia",
  },
  {
    label: "University of National and World Economy",
    value: "University of National and World Economy",
  },
  {
    label: "University of Nebraska at Kearney",
    value: "University of Nebraska at Kearney",
  },
  {
    label: "University of Nebraska at Omaha",
    value: "University of Nebraska at Omaha",
  },
  {
    label: "University of Nebraska Medical Center",
    value: "University of Nebraska Medical Center",
  },
  {
    label: "University of Nebraska-Lincoln",
    value: "University of Nebraska-Lincoln",
  },
  {
    label: "University of Negros Occidental - Recoletos",
    value: "University of Negros Occidental - Recoletos",
  },
  {
    label: "University of Nevada, Las Vegas",
    value: "University of Nevada, Las Vegas",
  },
  {
    label: "University of Nevada, Reno",
    value: "University of Nevada, Reno",
  },
  {
    label: "University of New Brunswick",
    value: "University of New Brunswick",
  },
  {
    label: "University of New England",
    value: "University of New England",
  },
  {
    label: "University of New England, Australia",
    value: "University of New England, Australia",
  },
  {
    label: "University of New Hampshire",
    value: "University of New Hampshire",
  },
  {
    label: "University of New Haven",
    value: "University of New Haven",
  },
  {
    label: "University of New Mexico",
    value: "University of New Mexico",
  },
  {
    label: "University of New Orleans",
    value: "University of New Orleans",
  },
  {
    label: "University of New South Wales",
    value: "University of New South Wales",
  },
  {
    label: "University of New York in Prague",
    value: "University of New York in Prague",
  },
  {
    label: "University of Neyshabur",
    value: "University of Neyshabur",
  },
  {
    label: "University of Nicosia",
    value: "University of Nicosia",
  },
  {
    label: "University of Nigeria",
    value: "University of Nigeria",
  },
  {
    label: "University of Niigata Prefecture",
    value: "University of Niigata Prefecture",
  },
  {
    label: "University of North Alabama",
    value: "University of North Alabama",
  },
  {
    label: "University of North Bengal",
    value: "University of North Bengal",
  },
  {
    label: "University of North Carolina at Asheville",
    value: "University of North Carolina at Asheville",
  },
  {
    label: "University of North Carolina at Chapel Hill",
    value: "University of North Carolina at Chapel Hill",
  },
  {
    label: "University of North Carolina at Charlotte",
    value: "University of North Carolina at Charlotte",
  },
  {
    label: "University of North Carolina at Greensboro",
    value: "University of North Carolina at Greensboro",
  },
  {
    label: "University of North Carolina at Pembroke",
    value: "University of North Carolina at Pembroke",
  },
  {
    label: "University of North Carolina School of the Arts",
    value: "University of North Carolina School of the Arts",
  },
  {
    label: "University of North Carolina Wilmington",
    value: "University of North Carolina Wilmington",
  },
  {
    label: "University of North Dakota",
    value: "University of North Dakota",
  },
  {
    label: "University of North Florida",
    value: "University of North Florida",
  },
  {
    label: "University of North Georgia",
    value: "University of North Georgia",
  },
  {
    label: "University of North Texas",
    value: "University of North Texas",
  },
  {
    label: "University of North Texas Health Science Center",
    value: "University of North Texas Health Science Center",
  },
  {
    label: "University of Northern Bahr El-Ghazal",
    value: "University of Northern Bahr El-Ghazal",
  },
  {
    label: "University of Northern British Columbia",
    value: "University of Northern British Columbia",
  },
  {
    label: "University of Northern Colorado",
    value: "University of Northern Colorado",
  },
  {
    label: "University of Northern Iowa",
    value: "University of Northern Iowa",
  },
  {
    label: "University of Northern Philippines",
    value: "University of Northern Philippines",
  },
  {
    label: "University of Northwestern - St. Paul",
    value: "University of Northwestern - St. Paul",
  },
  {
    label: "University of Northwestern Ohio",
    value: "University of Northwestern Ohio",
  },
  {
    label: "University of Notre Dame",
    value: "University of Notre Dame",
  },
  {
    label: "University of Nottingham",
    value: "University of Nottingham",
  },
  {
    label: "University of Nueva Caceres",
    value: "University of Nueva Caceres",
  },
  {
    label: "University of Nursing, Mandalay",
    value: "University of Nursing, Mandalay",
  },
  {
    label: "University of Nursing, Yangon",
    value: "University of Nursing, Yangon",
  },
  {
    label: "University of Nyala",
    value: "University of Nyala",
  },
  {
    label: "University of Occupational and Environmental Health, Japan",
    value: "University of Occupational and Environmental Health, Japan",
  },
  {
    label: "University of Oregon",
    value: "University of Oregon",
  },
  {
    label: "University of Otago",
    value: "University of Otago",
  },
  {
    label: "University of Ottawa",
    value: "University of Ottawa",
  },
  {
    label: "University of Oxford",
    value: "University of Oxford",
  },
  {
    label: "University of Palestine",
    value: "University of Palestine",
  },
  {
    label: "University of Pangasinan - PHINMA",
    value: "University of Pangasinan - PHINMA",
  },
  {
    label: "University of Papua New Guinea",
    value: "University of Papua New Guinea",
  },
  {
    label: "University of Patanjali",
    value: "University of Patanjali",
  },
  {
    label: "University of Patras",
    value: "University of Patras",
  },
  {
    label: "University of Peloponnese",
    value: "University of Peloponnese",
  },
  {
    label: "University of Pennsylvania",
    value: "University of Pennsylvania",
  },
  {
    label: "University of Peradeniya",
    value: "University of Peradeniya",
  },
  {
    label: "University of Perpetual Help System DALTA",
    value: "University of Perpetual Help System DALTA",
  },
  {
    label: "University of Perpetual Help System Jonelta",
    value: "University of Perpetual Help System Jonelta",
  },
  {
    label: "University of Peshawar",
    value: "University of Peshawar",
  },
  {
    label: "University of Petra",
    value: "University of Petra",
  },
  {
    label: "University of Petroleum and Energy Studies",
    value: "University of Petroleum and Energy Studies",
  },
  {
    label: "University of Pharmaceutical Science",
    value: "University of Pharmaceutical Science",
  },
  {
    label: "University of Pharmacy, Mandalay",
    value: "University of Pharmacy, Mandalay",
  },
  {
    label: "University of Pharmacy, Yangon",
    value: "University of Pharmacy, Yangon",
  },
  {
    label: "University of Phayao",
    value: "University of Phayao",
  },
  {
    label: "University of Pikeville",
    value: "University of Pikeville",
  },
  {
    label: "University of Piraeus",
    value: "University of Piraeus",
  },
  {
    label: "University of Pittsburgh",
    value: "University of Pittsburgh",
  },
  {
    label: "University of Plovdiv Paisii Hilendarski",
    value: "University of Plovdiv Paisii Hilendarski",
  },
  {
    label: "University of Plymouth",
    value: "University of Plymouth",
  },
  {
    label: "University of Poonch Rawalakot",
    value: "University of Poonch Rawalakot",
  },
  {
    label: "University of Port Harcourt",
    value: "University of Port Harcourt",
  },
  {
    label: "University of Portland",
    value: "University of Portland",
  },
  {
    label: "University of Portsmouth",
    value: "University of Portsmouth",
  },
  {
    label: "University of Pretoria",
    value: "University of Pretoria",
  },
  {
    label: "University of Prince Edward Island",
    value: "University of Prince Edward Island",
  },
  {
    label: "University of Professional Studies, Accra",
    value: "University of Professional Studies, Accra",
  },
  {
    label: "University of Providence",
    value: "University of Providence",
  },
  {
    label: "University of Public Health, Yangon",
    value: "University of Public Health, Yangon",
  },
  {
    label: "University of Puget Sound",
    value: "University of Puget Sound",
  },
  {
    label: "University of Puthisastra",
    value: "University of Puthisastra",
  },
  {
    label: "University of Pyay",
    value: "University of Pyay",
  },
  {
    label: "University of Qom",
    value: "University of Qom",
  },
  {
    label: "University of Quran and Hadith",
    value: "University of Quran and Hadith",
  },
  {
    label: "University of Rajasthan",
    value: "University of Rajasthan",
  },
  {
    label: "University of Raparin",
    value: "University of Raparin",
  },
  {
    label: "University of Reading",
    value: "University of Reading",
  },
  {
    label: "University of Redlands",
    value: "University of Redlands",
  },
  {
    label: "University of Regina",
    value: "University of Regina",
  },
  {
    label: "University of Religions and Denominations",
    value: "University of Religions and Denominations",
  },
  {
    label: "University of Rhode Island",
    value: "University of Rhode Island",
  },
  {
    label: "University of Richmond",
    value: "University of Richmond",
  },
  {
    label: "University of Rio Grande",
    value: "University of Rio Grande",
  },
  {
    label: "University of Rizal System",
    value: "University of Rizal System",
  },
  {
    label: "University of Rochester",
    value: "University of Rochester",
  },
  {
    label: "University of Roehampton",
    value: "University of Roehampton",
  },
  {
    label: "University of Ruhuna",
    value: "University of Ruhuna",
  },
  {
    label: "University of Rwanda",
    value: "University of Rwanda",
  },
  {
    label: "University of Sadat City",
    value: "University of Sadat City",
  },
  {
    label: "University of Saint Francis",
    value: "University of Saint Francis",
  },
  {
    label: "University of Saint Joseph",
    value: "University of Saint Joseph",
  },
  {
    label: "University of Saint Joseph, Macao",
    value: "University of Saint Joseph, Macao",
  },
  {
    label: "University of Saint Louis",
    value: "University of Saint Louis",
  },
  {
    label: "University of Saint Mary",
    value: "University of Saint Mary",
  },
  {
    label: "University of Salford",
    value: "University of Salford",
  },
  {
    label: "University of Samarra",
    value: "University of Samarra",
  },
  {
    label: "University of San Agustin",
    value: "University of San Agustin",
  },
  {
    label: "University of San Carlos",
    value: "University of San Carlos",
  },
  {
    label: "University of San Diego",
    value: "University of San Diego",
  },
  {
    label: "University of San Francisco",
    value: "University of San Francisco",
  },
  {
    label: "University of San Jose-Recoletos",
    value: "University of San Jose-Recoletos",
  },
  {
    label: "University of Santo Tomas",
    value: "University of Santo Tomas",
  },
  {
    label: "University of Sargodha",
    value: "University of Sargodha",
  },
  {
    label: "University of Saskatchewan",
    value: "University of Saskatchewan",
  },
  {
    label: "University of Science and Arts of Oklahoma",
    value: "University of Science and Arts of Oklahoma",
  },
  {
    label: "University of Science and Technology",
    value: "University of Science and Technology",
  },
  {
    label: "University of Science and Technology",
    value: "University of Science and Technology",
  },
  {
    label: "University of Science and Technology at Zewail City",
    value: "University of Science and Technology at Zewail City",
  },
  {
    label: "University of Science and Technology Beijing",
    value: "University of Science and Technology Beijing",
  },
  {
    label: "University of Science and Technology Chittagong",
    value: "University of Science and Technology Chittagong",
  },
  {
    label: "University of Science and Technology Korea",
    value: "University of Science and Technology Korea",
  },
  {
    label: "University of Science and Technology Liaoning",
    value: "University of Science and Technology Liaoning",
  },
  {
    label: "University of Science and Technology of China",
    value: "University of Science and Technology of China",
  },
  {
    label: "University of Science and Technology of Fujairah",
    value: "University of Science and Technology of Fujairah",
  },
  {
    label: "University of Science and Technology of Mazandaran",
    value: "University of Science and Technology of Mazandaran",
  },
  {
    label: "University of Science and Technology of Southern Philippines",
    value: "University of Science and Technology of Southern Philippines",
  },
  {
    label: "University of Science and Technology, Bannu",
    value: "University of Science and Technology, Bannu",
  },
  {
    label: "University of Science and Technology, Meghalaya",
    value: "University of Science and Technology, Meghalaya",
  },
  {
    label: "University of Scranton",
    value: "University of Scranton",
  },
  {
    label: "University of Security and Economics",
    value: "University of Security and Economics",
  },
  {
    label: "University of Seoul",
    value: "University of Seoul",
  },
  {
    label: "University of Seychelles",
    value: "University of Seychelles",
  },
  {
    label: "University of Shahreza",
    value: "University of Shahreza",
  },
  {
    label: "University of Shanghai for Science and Technology",
    value: "University of Shanghai for Science and Technology",
  },
  {
    label: "University of Sharjah",
    value: "University of Sharjah",
  },
  {
    label: "University of Sheffield",
    value: "University of Sheffield",
  },
  {
    label: "University of Shendi",
    value: "University of Shendi",
  },
  {
    label: "University of Shizuoka",
    value: "University of Shizuoka",
  },
  {
    label: "University of Sierra Leone",
    value: "University of Sierra Leone",
  },
  {
    label: "University of Silicon Valley",
    value: "University of Silicon Valley",
  },
  {
    label: "University of Sindh",
    value: "University of Sindh",
  },
  {
    label: "University of Sioux Falls",
    value: "University of Sioux Falls",
  },
  {
    label: "University of Sistan and Baluchestan",
    value: "University of Sistan and Baluchestan",
  },
  {
    label: "University of Skopje",
    value: "University of Skopje",
  },
  {
    label: "University of Social Welfare and Rehabilitation Sciences",
    value: "University of Social Welfare and Rehabilitation Sciences",
  },
  {
    label: "University of South Alabama",
    value: "University of South Alabama",
  },
  {
    label: "University of South Asia",
    value: "University of South Asia",
  },
  {
    label: "University of South Asia, Bangladesh",
    value: "University of South Asia, Bangladesh",
  },
  {
    label: "University of South Australia",
    value: "University of South Australia",
  },
  {
    label: "University of South Carolina",
    value: "University of South Carolina",
  },
  {
    label: "University of South Carolina-Aiken",
    value: "University of South Carolina-Aiken",
  },
  {
    label: "University of South Carolina-Beaufort",
    value: "University of South Carolina-Beaufort",
  },
  {
    label: "University of South Carolina-Upstate",
    value: "University of South Carolina-Upstate",
  },
  {
    label: "University of South China",
    value: "University of South China",
  },
  {
    label: "University of South Dakota",
    value: "University of South Dakota",
  },
  {
    label: "University of South Florida",
    value: "University of South Florida",
  },
  {
    label: "University of South Wales",
    value: "University of South Wales",
  },
  {
    label: "University of Southampton",
    value: "University of Southampton",
  },
  {
    label: "University of Southeast Asia",
    value: "University of Southeast Asia",
  },
  {
    label: "University of Southeastern Philippines",
    value: "University of Southeastern Philippines",
  },
  {
    label: "University of Southern California",
    value: "University of Southern California",
  },
  {
    label: "University of Southern Indiana",
    value: "University of Southern Indiana",
  },
  {
    label: "University of Southern Maine",
    value: "University of Southern Maine",
  },
  {
    label: "University of Southern Mindanao",
    value: "University of Southern Mindanao",
  },
  {
    label: "University of Southern Mississippi",
    value: "University of Southern Mississippi",
  },
  {
    label: "University of Southern Philippines Foundation",
    value: "University of Southern Philippines Foundation",
  },
  {
    label: "University of Southern Queensland",
    value: "University of Southern Queensland",
  },
  {
    label: "University of Sri Jayewardenepura",
    value: "University of Sri Jayewardenepura",
  },
  {
    label: "University of St Andrews",
    value: "University of St Andrews",
  },
  {
    label: "University of St. Augustine for Health Sciences",
    value: "University of St. Augustine for Health Sciences",
  },
  {
    label: "University of St. Francis",
    value: "University of St. Francis",
  },
  {
    label: "University of St. La Salle",
    value: "University of St. La Salle",
  },
  {
    label: "University of St. Thomas",
    value: "University of St. Thomas",
  },
  {
    label: "University of St. Thomas",
    value: "University of St. Thomas",
  },
  {
    label: "University of Stirling",
    value: "University of Stirling",
  },
  {
    label: "University of Strathclyde",
    value: "University of Strathclyde",
  },
  {
    label: "University of Suffolk",
    value: "University of Suffolk",
  },
  {
    label: "University of Sulaimani",
    value: "University of Sulaimani",
  },
  {
    label: "University of Sumer",
    value: "University of Sumer",
  },
  {
    label: "University of Sunderland",
    value: "University of Sunderland",
  },
  {
    label: "University of Surrey",
    value: "University of Surrey",
  },
  {
    label: "University of Sussex",
    value: "University of Sussex",
  },
  {
    label: "University of Swabi",
    value: "University of Swabi",
  },
  {
    label: "University of Swat",
    value: "University of Swat",
  },
  {
    label: "University of Tabriz",
    value: "University of Tabriz",
  },
  {
    label: "University of Tabuk",
    value: "University of Tabuk",
  },
  {
    label: "University of Taipei",
    value: "University of Taipei",
  },
  {
    label: "University of Tartous",
    value: "University of Tartous",
  },
  {
    label: "University of Tasmania",
    value: "University of Tasmania",
  },
  {
    label: "University of Teacher Education Fukuoka",
    value: "University of Teacher Education Fukuoka",
  },
  {
    label: "University of Technology",
    value: "University of Technology",
  },
  {
    label: "University of Technology",
    value: "University of Technology",
  },
  {
    label: "University of Technology & Management",
    value: "University of Technology & Management",
  },
  {
    label: "University of Technology and Applied Sciences",
    value: "University of Technology and Applied Sciences",
  },
  {
    label: "University of Technology and Arts of Byumba",
    value: "University of Technology and Arts of Byumba",
  },
  {
    label: "University of Technology Bahrain",
    value: "University of Technology Bahrain",
  },
  {
    label: "University of Technology Khartoum",
    value: "University of Technology Khartoum",
  },
  {
    label: "University of Technology Sydney",
    value: "University of Technology Sydney",
  },
  {
    label: "University of Technology, Jamaica",
    value: "University of Technology, Jamaica",
  },
  {
    label: "University of Technology, Mauritius",
    value: "University of Technology, Mauritius",
  },
  {
    label: "University of Technology, Yadanabon Cyber City",
    value: "University of Technology, Yadanabon Cyber City",
  },
  {
    label: "University of Tehran",
    value: "University of Tehran",
  },
  {
    label: "University of Telafer",
    value: "University of Telafer",
  },
  {
    label: "University of Telecommunications and Post",
    value: "University of Telecommunications and Post",
  },
  {
    label: "University of Texas Rio Grande Valley",
    value: "University of Texas Rio Grande Valley",
  },
  {
    label: "University of Texas Southwestern Medical Center",
    value: "University of Texas Southwestern Medical Center",
  },
  {
    label: "University of the Aegean",
    value: "University of the Aegean",
  },
  {
    label: "University of the Arts London",
    value: "University of the Arts London",
  },
  {
    label: "University of the Assumption",
    value: "University of the Assumption",
  },
  {
    label: "University of The Bahamas",
    value: "University of The Bahamas",
  },
  {
    label: "University of the Chinese Academy of Sciences",
    value: "University of the Chinese Academy of Sciences",
  },
  {
    label: "University of the Commonwealth Caribbean",
    value: "University of the Commonwealth Caribbean",
  },
  {
    label: "University of the Cordilleras",
    value: "University of the Cordilleras",
  },
  {
    label: "University of the Cumberlands",
    value: "University of the Cumberlands",
  },
  {
    label: "University of the District of Columbia",
    value: "University of the District of Columbia",
  },
  {
    label: "University of the East",
    value: "University of the East",
  },
  {
    label: "University of the East Ramon Magsaysay",
    value: "University of the East Ramon Magsaysay",
  },
  {
    label: "University of the Fraser Valley",
    value: "University of the Fraser Valley",
  },
  {
    label: "University of the Free State",
    value: "University of the Free State",
  },
  {
    label: "University of the Gambia",
    value: "University of the Gambia",
  },
  {
    label: "University of the Highlands and Islands",
    value: "University of the Highlands and Islands",
  },
  {
    label: "University of the Holy Quran and Islamic Sciences",
    value: "University of the Holy Quran and Islamic Sciences",
  },
  {
    label: "University of the Humanities",
    value: "University of the Humanities",
  },
  {
    label: "University of the Immaculate Conception",
    value: "University of the Immaculate Conception",
  },
  {
    label: "University of the Incarnate Word",
    value: "University of the Incarnate Word",
  },
  {
    label: "University of the National Academy of Sciences of Belarus",
    value: "University of the National Academy of Sciences of Belarus",
  },
  {
    label: "University of the Ozarks",
    value: "University of the Ozarks",
  },
  {
    label: "University of the Pacific",
    value: "University of the Pacific",
  },
  {
    label: "University of the Philippines Baguio",
    value: "University of the Philippines Baguio",
  },
  {
    label: "University of the Philippines Diliman",
    value: "University of the Philippines Diliman",
  },
  {
    label: "University of the Philippines in the Visayas",
    value: "University of the Philippines in the Visayas",
  },
  {
    label: "University of the Philippines Los Baños",
    value: "University of the Philippines Los Baños",
  },
  {
    label: "University of the Philippines Manila",
    value: "University of the Philippines Manila",
  },
  {
    label: "University of the Philippines Mindanao",
    value: "University of the Philippines Mindanao",
  },
  {
    label: "University of the Philippines System",
    value: "University of the Philippines System",
  },
  {
    label: "University of the Potomac",
    value: "University of the Potomac",
  },
  {
    label: "University of the Punjab",
    value: "University of the Punjab",
  },
  {
    label: "University of the Ryukyus",
    value: "University of the Ryukyus",
  },
  {
    label: "University of the Sacred Heart Gulu",
    value: "University of the Sacred Heart Gulu",
  },
  {
    label: "University of the Sacred Heart, Tokyo",
    value: "University of the Sacred Heart, Tokyo",
  },
  {
    label: "University of the Southern Caribbean",
    value: "University of the Southern Caribbean",
  },
  {
    label: "University of the Southwest",
    value: "University of the Southwest",
  },
  {
    label: "University of the Sunshine Coast",
    value: "University of the Sunshine Coast",
  },
  {
    label: "University of the Thai Chamber of Commerce",
    value: "University of the Thai Chamber of Commerce",
  },
  {
    label: "University of the Virgin Islands",
    value: "University of the Virgin Islands",
  },
  {
    label: "University of the Visayas",
    value: "University of the Visayas",
  },
  {
    label: "University of the Visual and Performing Arts",
    value: "University of the Visual and Performing Arts",
  },
  {
    label: "University of the West",
    value: "University of the West",
  },
  {
    label: "University of the West of England",
    value: "University of the West of England",
  },
  {
    label: "University of the West of Scotland",
    value: "University of the West of Scotland",
  },
  {
    label: "University of the Western Cape",
    value: "University of the Western Cape",
  },
  {
    label: "University of the Witwatersrand",
    value: "University of the Witwatersrand",
  },
  {
    label: "University of Thessaly",
    value: "University of Thessaly",
  },
  {
    label: "University of Thi-Qar",
    value: "University of Thi-Qar",
  },
  {
    label: "University of Tikrit",
    value: "University of Tikrit",
  },
  {
    label: "University of Toledo",
    value: "University of Toledo",
  },
  {
    label: "University of Torbat-e-Heydarieh",
    value: "University of Torbat-e-Heydarieh",
  },
  {
    label: "University of Torit",
    value: "University of Torit",
  },
  {
    label: "University of Toronto",
    value: "University of Toronto",
  },
  {
    label: "University of Tourism Technology and Business Studies",
    value: "University of Tourism Technology and Business Studies",
  },
  {
    label: "University of Toyama",
    value: "University of Toyama",
  },
  {
    label: "University of Traditional Medicine",
    value: "University of Traditional Medicine",
  },
  {
    label: "University of Trans-Disciplinary Health Sciences and Technology",
    value: "University of Trans-Disciplinary Health Sciences and Technology",
  },
  {
    label: "University of Transport and Communications",
    value: "University of Transport and Communications",
  },
  {
    label: "University of Transport Todor Kableshkov",
    value: "University of Transport Todor Kableshkov",
  },
  {
    label: "University of Tripoli",
    value: "University of Tripoli",
  },
  {
    label: "University of Tripoli Alahlia",
    value: "University of Tripoli Alahlia",
  },
  {
    label: "University of Tsukuba",
    value: "University of Tsukuba",
  },
  {
    label: "University of Turbat",
    value: "University of Turbat",
  },
  {
    label: "University of Tyumen",
    value: "University of Tyumen",
  },
  {
    label: "University of Ulsan",
    value: "University of Ulsan",
  },
  {
    label: "University of United Popular Nations",
    value: "University of United Popular Nations",
  },
  {
    label: "University of Uyo",
    value: "University of Uyo",
  },
  {
    label: "University of Valley Forge",
    value: "University of Valley Forge",
  },
  {
    label: "University of Vavuniya",
    value: "University of Vavuniya",
  },
  {
    label: "University of Venda",
    value: "University of Venda",
  },
  {
    label: "University of Vermont",
    value: "University of Vermont",
  },
  {
    label: "University of Veterinary and Animal Sciences",
    value: "University of Veterinary and Animal Sciences",
  },
  {
    label: "University of Veterinary Science, Yezin",
    value: "University of Veterinary Science, Yezin",
  },
  {
    label: "University of Victoria",
    value: "University of Victoria",
  },
  {
    label: "University of Virginia",
    value: "University of Virginia",
  },
  {
    label: "University of Vocational Technology",
    value: "University of Vocational Technology",
  },
  {
    label: "University of Wah",
    value: "University of Wah",
  },
  {
    label: "University of Waikato",
    value: "University of Waikato",
  },
  {
    label: "University of Wales",
    value: "University of Wales",
  },
  {
    label: "University of Wales Trinity Saint David",
    value: "University of Wales Trinity Saint David",
  },
  {
    label: "University of Warwick",
    value: "University of Warwick",
  },
  {
    label: "University of Washington",
    value: "University of Washington",
  },
  {
    label: "University of Wasit",
    value: "University of Wasit",
  },
  {
    label: "University of Waterloo",
    value: "University of Waterloo",
  },
  {
    label: "University of West Attica",
    value: "University of West Attica",
  },
  {
    label: "University of West Florida",
    value: "University of West Florida",
  },
  {
    label: "University of West Georgia",
    value: "University of West Georgia",
  },
  {
    label: "University of West London",
    value: "University of West London",
  },
  {
    label: "University of West Yangon",
    value: "University of West Yangon",
  },
  {
    label: "University of Western Equatoria",
    value: "University of Western Equatoria",
  },
  {
    label: "University of Western Macedonia",
    value: "University of Western Macedonia",
  },
  {
    label: "University of Western States",
    value: "University of Western States",
  },
  {
    label: "University of Westminster",
    value: "University of Westminster",
  },
  {
    label: "University of Winchester",
    value: "University of Winchester",
  },
  {
    label: "University of Windsor",
    value: "University of Windsor",
  },
  {
    label: "University of Wisconsin-Eau Claire",
    value: "University of Wisconsin-Eau Claire",
  },
  {
    label: "University of Wisconsin-Green Bay",
    value: "University of Wisconsin-Green Bay",
  },
  {
    label: "University of Wisconsin-La Crosse",
    value: "University of Wisconsin-La Crosse",
  },
  {
    label: "University of Wisconsin-Madison",
    value: "University of Wisconsin-Madison",
  },
  {
    label: "University of Wisconsin-Milwaukee",
    value: "University of Wisconsin-Milwaukee",
  },
  {
    label: "University of Wisconsin-Oshkosh",
    value: "University of Wisconsin-Oshkosh",
  },
  {
    label: "University of Wisconsin-Parkside",
    value: "University of Wisconsin-Parkside",
  },
  {
    label: "University of Wisconsin-Platteville",
    value: "University of Wisconsin-Platteville",
  },
  {
    label: "University of Wisconsin-River Falls",
    value: "University of Wisconsin-River Falls",
  },
  {
    label: "University of Wisconsin-Stevens Point",
    value: "University of Wisconsin-Stevens Point",
  },
  {
    label: "University of Wisconsin-Stout",
    value: "University of Wisconsin-Stout",
  },
  {
    label: "University of Wisconsin-Superior",
    value: "University of Wisconsin-Superior",
  },
  {
    label: "University of Wisconsin-Whitewater",
    value: "University of Wisconsin-Whitewater",
  },
  {
    label: "University of Wollongong",
    value: "University of Wollongong",
  },
  {
    label: "University of Wollongong in Dubai",
    value: "University of Wollongong in Dubai",
  },
  {
    label: "University of Wolverhampton",
    value: "University of Wolverhampton",
  },
  {
    label: "University of Worcester",
    value: "University of Worcester",
  },
  {
    label: "University of Wyoming",
    value: "University of Wyoming",
  },
  {
    label: "University of Yamanashi",
    value: "University of Yamanashi",
  },
  {
    label: "University of Zabol",
    value: "University of Zabol",
  },
  {
    label: "University of Zakho",
    value: "University of Zakho",
  },
  {
    label: "University of Zalingei",
    value: "University of Zalingei",
  },
  {
    label: "University of Zambia",
    value: "University of Zambia",
  },
  {
    label: "University of Zawia",
    value: "University of Zawia",
  },
  {
    label: "University of Zimbabwe",
    value: "University of Zimbabwe",
  },
  {
    label: "University of Zululand",
    value: "University of Zululand",
  },
  {
    label: "University Prof. Dr. Assen Zlatarov",
    value: "University Prof. Dr. Assen Zlatarov",
  },
  {
    label: "Univerza na Primorskem",
    value: "Univerza na Primorskem",
  },
  {
    label: "Univerza v Ljubljani",
    value: "Univerza v Ljubljani",
  },
  {
    label: "Univerza v Mariboru",
    value: "Univerza v Mariboru",
  },
  {
    label: "Univerza v Novem mestu",
    value: "Univerza v Novem mestu",
  },
  {
    label: "Univerza v Novi Gorici",
    value: "Univerza v Novi Gorici",
  },
  {
    label: "Univerzita Hradec Králové",
    value: "Univerzita Hradec Králové",
  },
  {
    label: "Univerzita J. Selyeho",
    value: "Univerzita J. Selyeho",
  },
  {
    label: "Univerzita Jana Amose Komenského Praha",
    value: "Univerzita Jana Amose Komenského Praha",
  },
  {
    label: "Univerzita Jana Evangelisty Purkyne v Ústí nad Labem",
    value: "Univerzita Jana Evangelisty Purkyne v Ústí nad Labem",
  },
  {
    label: "Univerzita Karlova",
    value: "Univerzita Karlova",
  },
  {
    label: "Univerzita Komenského v Bratislave",
    value: "Univerzita Komenského v Bratislave",
  },
  {
    label: "Univerzita Konštantína Filozofa v Nitre",
    value: "Univerzita Konštantína Filozofa v Nitre",
  },
  {
    label: "Univerzita Mateja Bela v Banskej Bystrici",
    value: "Univerzita Mateja Bela v Banskej Bystrici",
  },
  {
    label: "Univerzita Palackého v Olomouci",
    value: "Univerzita Palackého v Olomouci",
  },
  {
    label: "Univerzita Pardubice",
    value: "Univerzita Pardubice",
  },
  {
    label: "Univerzita Pavla Jozefa Šafárika v Košiciach",
    value: "Univerzita Pavla Jozefa Šafárika v Košiciach",
  },
  {
    label: "Univerzita sv. Cyrila a Metoda v Trnave",
    value: "Univerzita sv. Cyrila a Metoda v Trnave",
  },
  {
    label: "Univerzita Tomáše Bati ve Zlíne",
    value: "Univerzita Tomáše Bati ve Zlíne",
  },
  {
    label: "Univerzita Veterinárskeho Lekárstva a Farmácie v Košiciach",
    value: "Univerzita Veterinárskeho Lekárstva a Farmácie v Košiciach",
  },
  {
    label: "Univerzitet Bijeljina",
    value: "Univerzitet Bijeljina",
  },
  {
    label: "Univerzitet Crne Gore",
    value: "Univerzitet Crne Gore",
  },
  {
    label: "Univerzitet Džemal Bijedic u Mostaru",
    value: "Univerzitet Džemal Bijedic u Mostaru",
  },
  {
    label: "Univerzitet Educons",
    value: "Univerzitet Educons",
  },
  {
    label: "Univerzitet Megatrend",
    value: "Univerzitet Megatrend",
  },
  {
    label: "Univerzitet Metropolitan",
    value: "Univerzitet Metropolitan",
  },
  {
    label: "Univerzitet Privredna akademija",
    value: "Univerzitet Privredna akademija",
  },
  {
    label: "Univerzitet Sinergija Bijeljina",
    value: "Univerzitet Sinergija Bijeljina",
  },
  {
    label: "Univerzitet Singidunum",
    value: "Univerzitet Singidunum",
  },
  {
    label: "Univerzitet Sv. Kiril i Metódij vo Skopje",
    value: "Univerzitet Sv. Kiril i Metódij vo Skopje",
  },
  {
    label: "Univerzitet Sv. Kliment Ohridski vo Bitola",
    value: "Univerzitet Sv. Kliment Ohridski vo Bitola",
  },
  {
    label: "Univerzitet u Banjoj Luci",
    value: "Univerzitet u Banjoj Luci",
  },
  {
    label: "Univerzitet u Beogradu",
    value: "Univerzitet u Beogradu",
  },
  {
    label: "Univerzitet u Bihacu",
    value: "Univerzitet u Bihacu",
  },
  {
    label: "Univerzitet u Istocnom Sarajevu",
    value: "Univerzitet u Istocnom Sarajevu",
  },
  {
    label: "Univerzitet u Kragujevcu",
    value: "Univerzitet u Kragujevcu",
  },
  {
    label: "Univerzitet u Nišu",
    value: "Univerzitet u Nišu",
  },
  {
    label: "Univerzitet u Novom Sadu",
    value: "Univerzitet u Novom Sadu",
  },
  {
    label: "Univerzitet u Sarajevu",
    value: "Univerzitet u Sarajevu",
  },
  {
    label: "Univerzitet u Travniku",
    value: "Univerzitet u Travniku",
  },
  {
    label: "Univerzitet u Tuzli",
    value: "Univerzitet u Tuzli",
  },
  {
    label: "Univerzitet u Zenici",
    value: "Univerzitet u Zenici",
  },
  {
    label: "Univerzitet umetnosti u Beogradu",
    value: "Univerzitet umetnosti u Beogradu",
  },
  {
    label: "Univerzitet Union",
    value: "Univerzitet Union",
  },
  {
    label: "Univerzitet za poslovne studije",
    value: "Univerzitet za poslovne studije",
  },
  {
    label: "Univerzitet za poslovni inženjering i menadžment",
    value: "Univerzitet za poslovni inženjering i menadžment",
  },
  {
    label: "Uniwersytet Artystyczny w Poznaniu",
    value: "Uniwersytet Artystyczny w Poznaniu",
  },
  {
    label: "Uniwersytet Bielsko-Bialski",
    value: "Uniwersytet Bielsko-Bialski",
  },
  {
    label: "Uniwersytet Ekonomiczny w Katowicach",
    value: "Uniwersytet Ekonomiczny w Katowicach",
  },
  {
    label: "Uniwersytet Ekonomiczny w Krakowie",
    value: "Uniwersytet Ekonomiczny w Krakowie",
  },
  {
    label: "Uniwersytet Ekonomiczny w Poznaniu",
    value: "Uniwersytet Ekonomiczny w Poznaniu",
  },
  {
    label: "Uniwersytet Ekonomiczny we Wroclawiu",
    value: "Uniwersytet Ekonomiczny we Wroclawiu",
  },
  {
    label: "Uniwersytet Gdanski",
    value: "Uniwersytet Gdanski",
  },
  {
    label: "Uniwersytet im. Adama Mickiewicza w Poznaniu",
    value: "Uniwersytet im. Adama Mickiewicza w Poznaniu",
  },
  {
    label: "Uniwersytet Jagiellonski",
    value: "Uniwersytet Jagiellonski",
  },
  {
    label: "Uniwersytet Jana Dlugosza w Czestochowie",
    value: "Uniwersytet Jana Dlugosza w Czestochowie",
  },
  {
    label: "Uniwersytet Jana Kochanowskiego w Kielcach",
    value: "Uniwersytet Jana Kochanowskiego w Kielcach",
  },
  {
    label: "Uniwersytet Kardynala Stefana Wyszynskiego w Warszawie",
    value: "Uniwersytet Kardynala Stefana Wyszynskiego w Warszawie",
  },
  {
    label: "Uniwersytet Kazimierza Wielkiego w Bydgoszczy",
    value: "Uniwersytet Kazimierza Wielkiego w Bydgoszczy",
  },
  {
    label: "Uniwersytet Lódzki",
    value: "Uniwersytet Lódzki",
  },
  {
    label: "Uniwersytet Marii Curie-Sklodowskiej w Lublinie",
    value: "Uniwersytet Marii Curie-Sklodowskiej w Lublinie",
  },
  {
    label: "Uniwersytet Medyczny im. Karola Marcinkowskiego w Poznaniu",
    value: "Uniwersytet Medyczny im. Karola Marcinkowskiego w Poznaniu",
  },
  {
    label: "Uniwersytet Medyczny im. Piastów Slaskich we Wroclawiu",
    value: "Uniwersytet Medyczny im. Piastów Slaskich we Wroclawiu",
  },
  {
    label: "Uniwersytet Medyczny w Bialymstoku",
    value: "Uniwersytet Medyczny w Bialymstoku",
  },
  {
    label: "Uniwersytet Medyczny w Lodzi",
    value: "Uniwersytet Medyczny w Lodzi",
  },
  {
    label: "Uniwersytet Medyczny w Lublinie",
    value: "Uniwersytet Medyczny w Lublinie",
  },
  {
    label: "Uniwersytet Mikolaja Kopernika w Toruniu",
    value: "Uniwersytet Mikolaja Kopernika w Toruniu",
  },
  {
    label: "Uniwersytet Morski w Gdyn",
    value: "Uniwersytet Morski w Gdyn",
  },
  {
    label: "Uniwersytet Muzyczny Fryderyka Chopina",
    value: "Uniwersytet Muzyczny Fryderyka Chopina",
  },
  {
    label: "Uniwersytet Opolski",
    value: "Uniwersytet Opolski",
  },
  {
    label: "Uniwersytet Pomorski w Slupsku",
    value: "Uniwersytet Pomorski w Slupsku",
  },
  {
    label: "Uniwersytet Przyrodniczo-Humanistyczny w Siedlcach",
    value: "Uniwersytet Przyrodniczo-Humanistyczny w Siedlcach",
  },
  {
    label: "Uniwersytet Przyrodniczy w Lublinie",
    value: "Uniwersytet Przyrodniczy w Lublinie",
  },
  {
    label: "Uniwersytet Przyrodniczy w Poznaniu",
    value: "Uniwersytet Przyrodniczy w Poznaniu",
  },
  {
    label: "Uniwersytet Przyrodniczy we Wroclawiu",
    value: "Uniwersytet Przyrodniczy we Wroclawiu",
  },
  {
    label: "Uniwersytet Rolniczy w Krakowie",
    value: "Uniwersytet Rolniczy w Krakowie",
  },
  {
    label: "Uniwersytet Rzeszowski",
    value: "Uniwersytet Rzeszowski",
  },
  {
    label: "Uniwersytet Slaski w Katowicach",
    value: "Uniwersytet Slaski w Katowicach",
  },
  {
    label: "Uniwersytet SWPS",
    value: "Uniwersytet SWPS",
  },
  {
    label: "Uniwersytet Szczecinski",
    value: "Uniwersytet Szczecinski",
  },
  {
    label:
      "Uniwersytet Technologiczno-Humanistyczny im. Kazimierza Pulaskiego w Radomiu",
    value:
      "Uniwersytet Technologiczno-Humanistyczny im. Kazimierza Pulaskiego w Radomiu",
  },
  {
    label: "Uniwersytet w Bialymstoku",
    value: "Uniwersytet w Bialymstoku",
  },
  {
    label: "Uniwersytet Warminsko-Mazurski w Olsztynie",
    value: "Uniwersytet Warminsko-Mazurski w Olsztynie",
  },
  {
    label: "Uniwersytet Warszawski",
    value: "Uniwersytet Warszawski",
  },
  {
    label: "Uniwersytet Wroclawski",
    value: "Uniwersytet Wroclawski",
  },
  {
    label: "Uniwersytet Zielonogórski",
    value: "Uniwersytet Zielonogórski",
  },
  {
    label: "Uniwersytetu Komisji Edukacji Narodowej w Krakowie",
    value: "Uniwersytetu Komisji Edukacji Narodowej w Krakowie",
  },
  {
    label: "Unversidad Nihon Gakko",
    value: "Unversidad Nihon Gakko",
  },
  {
    label: "Upper Iowa University",
    value: "Upper Iowa University",
  },
  {
    label: "Upper Nile University",
    value: "Upper Nile University",
  },
  {
    label: "Uppsala Universitet",
    value: "Uppsala Universitet",
  },
  {
    label: "Upstate Medical University",
    value: "Upstate Medical University",
  },
  {
    label: "Ural Federal University",
    value: "Ural Federal University",
  },
  {
    label: "Ural State Conservatory",
    value: "Ural State Conservatory",
  },
  {
    label: "Ural State Forestry University",
    value: "Ural State Forestry University",
  },
  {
    label: "Ural State Law Academy",
    value: "Ural State Law Academy",
  },
  {
    label: "Ural State Mining University",
    value: "Ural State Mining University",
  },
  {
    label: "Ural State Pedagogical University",
    value: "Ural State Pedagogical University",
  },
  {
    label: "Ural State University of Economics",
    value: "Ural State University of Economics",
  },
  {
    label: "Ural State University of Physical Culture",
    value: "Ural State University of Physical Culture",
  },
  {
    label: "Ural State University of Railway Transport",
    value: "Ural State University of Railway Transport",
  },
  {
    label: "Urartu University of Practical Psychology and Sociology",
    value: "Urartu University of Practical Psychology and Sociology",
  },
  {
    label: "Urawa University",
    value: "Urawa University",
  },
  {
    label: "Urdaneta City University",
    value: "Urdaneta City University",
  },
  {
    label: "Urganch Davlat Universiteti",
    value: "Urganch Davlat Universiteti",
  },
  {
    label: "Urganch shahridagi xalqaro Binary universiteti",
    value: "Urganch shahridagi xalqaro Binary universiteti",
  },
  {
    label: "Urmia University",
    value: "Urmia University",
  },
  {
    label: "Urmia University of Medical Sciences",
    value: "Urmia University of Medical Sciences",
  },
  {
    label: "Urmia University of Technology",
    value: "Urmia University of Technology",
  },
  {
    label: "Ursinus College",
    value: "Ursinus College",
  },
  {
    label: "Ursuline College",
    value: "Ursuline College",
  },
  {
    label: "Uruk University",
    value: "Uruk University",
  },
  {
    label: "Usak Üniversitesi",
    value: "Usak Üniversitesi",
  },
  {
    label: "Usha Martin University",
    value: "Usha Martin University",
  },
  {
    label: "Üsküdar Üniversitesi",
    value: "Üsküdar Üniversitesi",
  },
  {
    label: "Usmanu Danfodio University",
    value: "Usmanu Danfodio University",
  },
  {
    label: "Utah State University",
    value: "Utah State University",
  },
  {
    label: "Utah Tech University",
    value: "Utah Tech University",
  },
  {
    label: "Utah Valley University",
    value: "Utah Valley University",
  },
  {
    label: "Utenos kolegija",
    value: "Utenos kolegija",
  },
  {
    label: "Utica University",
    value: "Utica University",
  },
  {
    label: "Utkal University",
    value: "Utkal University",
  },
  {
    label: "Utkal University of Culture",
    value: "Utkal University of Culture",
  },
  {
    label: "Utsunomiya Kyowa University",
    value: "Utsunomiya Kyowa University",
  },
  {
    label: "Utsunomiya University",
    value: "Utsunomiya University",
  },
  {
    label: "Uttar Banga Krishi Viswavidyalaya",
    value: "Uttar Banga Krishi Viswavidyalaya",
  },
  {
    label: "Uttar Pradesh University of Medical Sciences",
    value: "Uttar Pradesh University of Medical Sciences",
  },
  {
    label: "Uttara University",
    value: "Uttara University",
  },
  {
    label: "Uttaradit Rajabhat University",
    value: "Uttaradit Rajabhat University",
  },
  {
    label: "Uttarakhand Aawasiya Vishwavidyalaya, Almora",
    value: "Uttarakhand Aawasiya Vishwavidyalaya, Almora",
  },
  {
    label: "Uttarakhand Ayurved University",
    value: "Uttarakhand Ayurved University",
  },
  {
    label: "Uttarakhand Sanskrit University",
    value: "Uttarakhand Sanskrit University",
  },
  {
    label: "Uttarakhand Technical University",
    value: "Uttarakhand Technical University",
  },
  {
    label: "Uttaranchal University",
    value: "Uttaranchal University",
  },
  {
    label: "Uva Wellassa University",
    value: "Uva Wellassa University",
  },
  {
    label: "Uzhhorod National University",
    value: "Uzhhorod National University",
  },
  {
    label: "Uzima University",
    value: "Uzima University",
  },
  {
    label: "V. N. Karazin Kharkiv National University",
    value: "V. N. Karazin Kharkiv National University",
  },
  {
    label: "V. Sarajishvili Tbilisi State Conservatoire",
    value: "V. Sarajishvili Tbilisi State Conservatoire",
  },
  {
    label: "V.I. Vernadsky Crimean Federal University",
    value: "V.I. Vernadsky Crimean Federal University",
  },
  {
    label: "V.I. Vernadsky Taurida National University",
    value: "V.I. Vernadsky Taurida National University",
  },
  {
    label: "Vaal University of Technology",
    value: "Vaal University of Technology",
  },
  {
    label: "Vaasan ammattikorkeakoulu",
    value: "Vaasan ammattikorkeakoulu",
  },
  {
    label: "Vaasan yliopisto",
    value: "Vaasan yliopisto",
  },
  {
    label: "Valaya Alongkorn Rajabhat University",
    value: "Valaya Alongkorn Rajabhat University",
  },
  {
    label: "Valdosta State University",
    value: "Valdosta State University",
  },
  {
    label: "Valencia College",
    value: "Valencia College",
  },
  {
    label: "ValiAsr University of Rafsanjan",
    value: "ValiAsr University of Rafsanjan",
  },
  {
    label: "Valley City State University",
    value: "Valley City State University",
  },
  {
    label: "Valley University of Science and Technology",
    value: "Valley University of Science and Technology",
  },
  {
    label: "Valley View University",
    value: "Valley View University",
  },
  {
    label: "Valparaiso University",
    value: "Valparaiso University",
  },
  {
    label: "Van Hall Larenstein University of Applied Sciences",
    value: "Van Hall Larenstein University of Applied Sciences",
  },
  {
    label: "Van Lang University",
    value: "Van Lang University",
  },
  {
    label: "Van Yüzüncü Yil Üniversitesi",
    value: "Van Yüzüncü Yil Üniversitesi",
  },
  {
    label: "Vanadzor State University",
    value: "Vanadzor State University",
  },
  {
    label: "Vancouver Island University",
    value: "Vancouver Island University",
  },
  {
    label: "Vanda Institute",
    value: "Vanda Institute",
  },
  {
    label: "Vanderbilt University",
    value: "Vanderbilt University",
  },
  {
    label: "VanderCook College of Music",
    value: "VanderCook College of Music",
  },
  {
    label: "Vanguard University of Southern California",
    value: "Vanguard University of Southern California",
  },
  {
    label: "Vanung University",
    value: "Vanung University",
  },
  {
    label: "Varendra University",
    value: "Varendra University",
  },
  {
    label: "Varna Free University 'Chernorizets Hrabar'",
    value: "Varna Free University 'Chernorizets Hrabar'",
  },
  {
    label: "Varna University of Management",
    value: "Varna University of Management",
  },
  {
    label: "Vasantrao Naik Marathwada Krishi Vidyapeeth",
    value: "Vasantrao Naik Marathwada Krishi Vidyapeeth",
  },
  {
    label: "Vassar College",
    value: "Vassar College",
  },
  {
    label: "Vasyl' Stus Donetsk National University",
    value: "Vasyl' Stus Donetsk National University",
  },
  {
    label: "Vatel School Rwanda",
    value: "Vatel School Rwanda",
  },
  {
    label: "Vaughn College of Aeronautics and Technology",
    value: "Vaughn College of Aeronautics and Technology",
  },
  {
    label: "Veer Bahadur Singh Purvanchal University",
    value: "Veer Bahadur Singh Purvanchal University",
  },
  {
    label:
      "Veer Chandra Singh Garhwali Uttarakhand University of Horticulture & Forestry",
    value:
      "Veer Chandra Singh Garhwali Uttarakhand University of Horticulture & Forestry",
  },
  {
    label: "Veer Kunwar Singh University",
    value: "Veer Kunwar Singh University",
  },
  {
    label: "Veer Narmad South Gujarat University",
    value: "Veer Narmad South Gujarat University",
  },
  {
    label: "Veer Surendra Sai University of Technology",
    value: "Veer Surendra Sai University of Technology",
  },
  {
    label:
      "Vel Tech Rangarajan Dr. Sagunthala R&D Institute of Science and Technology",
    value:
      "Vel Tech Rangarajan Dr. Sagunthala R&D Institute of Science and Technology",
  },
  {
    label: "Velayat University",
    value: "Velayat University",
  },
  {
    label: "Veleucilište Baltazar, Zaprešic",
    value: "Veleucilište Baltazar, Zaprešic",
  },
  {
    label: "Veleucilište Edward Bernays",
    value: "Veleucilište Edward Bernays",
  },
  {
    label: "Veleucilište Hrvatsko Zagorje Krapina",
    value: "Veleucilište Hrvatsko Zagorje Krapina",
  },
  {
    label: "Veleucilište Lavoslav Ružicka u Vukovaru",
    value: "Veleucilište Lavoslav Ružicka u Vukovaru",
  },
  {
    label: "Veleucilište Marko Marulic u Kninu",
    value: "Veleucilište Marko Marulic u Kninu",
  },
  {
    label: "Veleucilište Nikola Tesla u Gospicu",
    value: "Veleucilište Nikola Tesla u Gospicu",
  },
  {
    label: "Veleucilište u Bjelovaru",
    value: "Veleucilište u Bjelovaru",
  },
  {
    label: "Veleucilište u Karlovcu",
    value: "Veleucilište u Karlovcu",
  },
  {
    label: "Veleucilište u Rijeci",
    value: "Veleucilište u Rijeci",
  },
  {
    label: "Veleucilište u Šibeniku",
    value: "Veleucilište u Šibeniku",
  },
  {
    label: "Veleucilište u Virovitici",
    value: "Veleucilište u Virovitici",
  },
  {
    label: "Veleucilište Velika Gorica",
    value: "Veleucilište Velika Gorica",
  },
  {
    label: "Veleucilište VERN",
    value: "Veleucilište VERN",
  },
  {
    label: "Vellore Institute of Technology",
    value: "Vellore Institute of Technology",
  },
  {
    label: "Vels University",
    value: "Vels University",
  },
  {
    label: "Ventspils Augstskola",
    value: "Ventspils Augstskola",
  },
  {
    label: "Veritas University",
    value: "Veritas University",
  },
  {
    label: "Vermont College of Fine Arts",
    value: "Vermont College of Fine Arts",
  },
  {
    label: "Vermont Law School",
    value: "Vermont Law School",
  },
  {
    label: "Vermont State University",
    value: "Vermont State University",
  },
  {
    label: "VetAgro Sup",
    value: "VetAgro Sup",
  },
  {
    label: "Veterinärmedizinische Universität Wien",
    value: "Veterinärmedizinische Universität Wien",
  },
  {
    label: "Veterinární univerzita Brno",
    value: "Veterinární univerzita Brno",
  },
  {
    label: "Victoria Falls University of Technology",
    value: "Victoria Falls University of Technology",
  },
  {
    label: "Victoria International University",
    value: "Victoria International University",
  },
  {
    label: "VICTORIA Internationale Hochschule",
    value: "VICTORIA Internationale Hochschule",
  },
  {
    label: "Victoria University",
    value: "Victoria University",
  },
  {
    label: "Victoria University of Bangladesh",
    value: "Victoria University of Bangladesh",
  },
  {
    label: "Victoria University of Wellington",
    value: "Victoria University of Wellington",
  },
  {
    label: "Victoria University, Kampala",
    value: "Victoria University, Kampala",
  },
  {
    label: "VID vitenskapelige høgskole",
    value: "VID vitenskapelige høgskole",
  },
  {
    label: "Vidyasagar University",
    value: "Vidyasagar University",
  },
  {
    label: "Vidzemes Augstskola",
    value: "Vidzemes Augstskola",
  },
  {
    label: "Vietnam Maritime University",
    value: "Vietnam Maritime University",
  },
  {
    label: "Vietnam National University of Agriculture",
    value: "Vietnam National University of Agriculture",
  },
  {
    label: "Vietnam National University, Hanoi",
    value: "Vietnam National University, Hanoi",
  },
  {
    label: "Vietnam National University, Ho Chi Minh City",
    value: "Vietnam National University, Ho Chi Minh City",
  },
  {
    label: "Vignan University",
    value: "Vignan University",
  },
  {
    label: "Vijayanagara Sri Krishnadevaraya University",
    value: "Vijayanagara Sri Krishnadevaraya University",
  },
  {
    label: "Vikram University",
    value: "Vikram University",
  },
  {
    label: "Vikrama Simhapuri University",
    value: "Vikrama Simhapuri University",
  },
  {
    label: "Villa Maria College",
    value: "Villa Maria College",
  },
  {
    label: "Villanova University",
    value: "Villanova University",
  },
  {
    label: "Vilniaus Dailes Akademija",
    value: "Vilniaus Dailes Akademija",
  },
  {
    label: "Vilniaus dizaino kolegija",
    value: "Vilniaus dizaino kolegija",
  },
  {
    label: "Vilniaus Gedimino Technikos Universitetas",
    value: "Vilniaus Gedimino Technikos Universitetas",
  },
  {
    label: "Vilniaus kolegija",
    value: "Vilniaus kolegija",
  },
  {
    label: "Vilniaus technologiju ir dizaino kolegija",
    value: "Vilniaus technologiju ir dizaino kolegija",
  },
  {
    label: "Vilniaus Universitetas",
    value: "Vilniaus Universitetas",
  },
  {
    label: "Vilniaus verslo kolegija",
    value: "Vilniaus verslo kolegija",
  },
  {
    label: "Vinayaka Mission's Research Foundation",
    value: "Vinayaka Mission's Research Foundation",
  },
  {
    label: "Vinayaka Missions Sikkim University",
    value: "Vinayaka Missions Sikkim University",
  },
  {
    label: "Vincennes University",
    value: "Vincennes University",
  },
  {
    label: "Vinh University",
    value: "Vinh University",
  },
  {
    label: "Vinnitsa National Medical University",
    value: "Vinnitsa National Medical University",
  },
  {
    label: "Vinnitsa State Pedagogical University",
    value: "Vinnitsa State Pedagogical University",
  },
  {
    label: "Vinnytsia National Agrarian University",
    value: "Vinnytsia National Agrarian University",
  },
  {
    label: "Vinnytsia National Technical University",
    value: "Vinnytsia National Technical University",
  },
  {
    label: "Vinoba Bhave University",
    value: "Vinoba Bhave University",
  },
  {
    label: "Vinzenz Pallotti University",
    value: "Vinzenz Pallotti University",
  },
  {
    label: "Virgen Milagrosa University Foundation",
    value: "Virgen Milagrosa University Foundation",
  },
  {
    label: "Virginia Commonwealth University",
    value: "Virginia Commonwealth University",
  },
  {
    label: "Virginia Commonwealth University School of the Arts in Qatar",
    value: "Virginia Commonwealth University School of the Arts in Qatar",
  },
  {
    label: "Virginia Military Institute",
    value: "Virginia Military Institute",
  },
  {
    label: "Virginia Polytechnic Institute and State University",
    value: "Virginia Polytechnic Institute and State University",
  },
  {
    label: "Virginia State University",
    value: "Virginia State University",
  },
  {
    label: "Virginia Union University",
    value: "Virginia Union University",
  },
  {
    label: "Virginia Wesleyan University",
    value: "Virginia Wesleyan University",
  },
  {
    label: "Visayas State University",
    value: "Visayas State University",
  },
  {
    label: "Vishwakarma University",
    value: "Vishwakarma University",
  },
  {
    label: "Visoka medicinska škola Prijedor",
    value: "Visoka medicinska škola Prijedor",
  },
  {
    label: "Visoka medunarodna škola Cazin",
    value: "Visoka medunarodna škola Cazin",
  },
  {
    label: "Visoka poslovna škola PAR",
    value: "Visoka poslovna škola PAR",
  },
  {
    label: "Visoka poslovno tehnicka škola Doboj",
    value: "Visoka poslovno tehnicka škola Doboj",
  },
  {
    label: "Visoka škola Arca",
    value: "Visoka škola Arca",
  },
  {
    label: "Visoka škola Logos centar",
    value: "Visoka škola Logos centar",
  },
  {
    label: "Visoka škola medunarodnih odnosa i diplomacije Dag Hammarskjöld",
    value: "Visoka škola medunarodnih odnosa i diplomacije Dag Hammarskjöld",
  },
  {
    label: "Visoka škola racunarstva i informatike eMPIRICOM",
    value: "Visoka škola racunarstva i informatike eMPIRICOM",
  },
  {
    label: "Visoka škola za ekonomiju i informatiku Prijedor",
    value: "Visoka škola za ekonomiju i informatiku Prijedor",
  },
  {
    label: "Visoka škola za finansije i racunovodstvo",
    value: "Visoka škola za finansije i racunovodstvo",
  },
  {
    label: "Visoka škola za informacijske tehnologije",
    value: "Visoka škola za informacijske tehnologije",
  },
  {
    label: "Visoka škola za menadžment i dizajn Aspira",
    value: "Visoka škola za menadžment i dizajn Aspira",
  },
  {
    label: "Visoka škola za primijenjene i pravne nauke Prometej",
    value: "Visoka škola za primijenjene i pravne nauke Prometej",
  },
  {
    label: "Visoka škola za sigurnost",
    value: "Visoka škola za sigurnost",
  },
  {
    label: "Visoka škola za turizam i hotelijerstvo Trebinje",
    value: "Visoka škola za turizam i hotelijerstvo Trebinje",
  },
  {
    label: "Visoka škola za turizam i menadžment Konjic",
    value: "Visoka škola za turizam i menadžment Konjic",
  },
  {
    label: "Visoka škola za uslužni biznis",
    value: "Visoka škola za uslužni biznis",
  },
  {
    label: "Visoka šola Ravne na Koroškem",
    value: "Visoka šola Ravne na Koroškem",
  },
  {
    label: "Visoka šola za management Bled",
    value: "Visoka šola za management Bled",
  },
  {
    label: "Visoka šola za proizvodno inženirstvo",
    value: "Visoka šola za proizvodno inženirstvo",
  },
  {
    label: "Visoka šola za racunovodstvo in finance",
    value: "Visoka šola za racunovodstvo in finance",
  },
  {
    label: "Visoko gospodarsko ucilište u Križevcima",
    value: "Visoko gospodarsko ucilište u Križevcima",
  },
  {
    label: "Visoko ucilište Algebra",
    value: "Visoko ucilište Algebra",
  },
  {
    label: "Visoko ucilište EFFECTUS",
    value: "Visoko ucilište EFFECTUS",
  },
  {
    label: "Visokošolski zavod Fizioterapevtika",
    value: "Visokošolski zavod Fizioterapevtika",
  },
  {
    label: "Visva-Bharati University",
    value: "Visva-Bharati University",
  },
  {
    label: "Visvesvaraya National Institute of Technology",
    value: "Visvesvaraya National Institute of Technology",
  },
  {
    label: "Visvesvaraya Technological University",
    value: "Visvesvaraya Technological University",
  },
  {
    label: "VIT Bhopal University",
    value: "VIT Bhopal University",
  },
  {
    label: "Vitebsk State Academy of Veterinary Medicine",
    value: "Vitebsk State Academy of Veterinary Medicine",
  },
  {
    label: "Vitebsk State Order of Peoples' Friendship Medical University",
    value: "Vitebsk State Order of Peoples' Friendship Medical University",
  },
  {
    label: "Vitebsk State Technological University",
    value: "Vitebsk State Technological University",
  },
  {
    label: "Vitebsk State University",
    value: "Vitebsk State University",
  },
  {
    label: "Viterbo University",
    value: "Viterbo University",
  },
  {
    label: "Vivekananda Global University",
    value: "Vivekananda Global University",
  },
  {
    label: "VIVES",
    value: "VIVES",
  },
  {
    label: "Vladikavkaz Institute of Economics, Management and Law",
    value: "Vladikavkaz Institute of Economics, Management and Law",
  },
  {
    label: "Vladimir State University for the Humanities",
    value: "Vladimir State University for the Humanities",
  },
  {
    label: "Vladivostok State University of Economics and Service",
    value: "Vladivostok State University of Economics and Service",
  },
  {
    label: "Vlerick Business School",
    value: "Vlerick Business School",
  },
  {
    label: "VNU University of Science",
    value: "VNU University of Science",
  },
  {
    label: "VNUHCM - University of Science",
    value: "VNUHCM - University of Science",
  },
  {
    label: "Vo Truong Toan University",
    value: "Vo Truong Toan University",
  },
  {
    label: "Volga State University of Physical Culture, Sports and Tourism",
    value: "Volga State University of Physical Culture, Sports and Tourism",
  },
  {
    label: "Volga State University of Technology",
    value: "Volga State University of Technology",
  },
  {
    label: "Volga State University of Telecommunications and Informatics",
    value: "Volga State University of Telecommunications and Informatics",
  },
  {
    label: "Volgograd State Medical Academy",
    value: "Volgograd State Medical Academy",
  },
  {
    label: "Volgograd State Socio-Pedagogical University",
    value: "Volgograd State Socio-Pedagogical University",
  },
  {
    label: "Volgograd State Technical University",
    value: "Volgograd State Technical University",
  },
  {
    label: "Volgograd State University",
    value: "Volgograd State University",
  },
  {
    label: "Volgograd State University of Architecture and Civil Engineering",
    value: "Volgograd State University of Architecture and Civil Engineering",
  },
  {
    label: "Vologda State Dairy Farming Academy",
    value: "Vologda State Dairy Farming Academy",
  },
  {
    label: "Vologda State University",
    value: "Vologda State University",
  },
  {
    label: "Vongchavalitkul University",
    value: "Vongchavalitkul University",
  },
  {
    label: "Voorhees University",
    value: "Voorhees University",
  },
  {
    label: "Voronezh State Agricultural University",
    value: "Voronezh State Agricultural University",
  },
  {
    label: "Voronezh State Medical University",
    value: "Voronezh State Medical University",
  },
  {
    label: "Voronezh State Pedagogical University",
    value: "Voronezh State Pedagogical University",
  },
  {
    label: "Voronezh State Technical University",
    value: "Voronezh State Technical University",
  },
  {
    label: "Voronezh State University",
    value: "Voronezh State University",
  },
  {
    label: "Voronezh State University of Engineering Technology",
    value: "Voronezh State University of Engineering Technology",
  },
  {
    label: "Vrije Universiteit Amsterdam",
    value: "Vrije Universiteit Amsterdam",
  },
  {
    label: "Vrije Universiteit Brussel",
    value: "Vrije Universiteit Brussel",
  },
  {
    label: "VŠB - Technická univerzita Ostrava",
    value: "VŠB - Technická univerzita Ostrava",
  },
  {
    label: "VWA-Hochschule für berufsbegleitendes Studium",
    value: "VWA-Hochschule für berufsbegleitendes Studium",
  },
  {
    label: "Vyatka State Humanities University",
    value: "Vyatka State Humanities University",
  },
  {
    label: "Vyatka State University",
    value: "Vyatka State University",
  },
  {
    label: "Vysoká škola Ambis",
    value: "Vysoká škola Ambis",
  },
  {
    label: "Vysoká škola aplikované psychologie",
    value: "Vysoká škola aplikované psychologie",
  },
  {
    label: "Vysoká Škola Bezpecnostného Manažérstva v Košiciach",
    value: "Vysoká Škola Bezpecnostného Manažérstva v Košiciach",
  },
  {
    label: "Vysoká škola chemicko-technologická v Praze",
    value: "Vysoká škola chemicko-technologická v Praze",
  },
  {
    label: "Vysoká škola Danubius",
    value: "Vysoká škola Danubius",
  },
  {
    label: "Vysoká škola DTI",
    value: "Vysoká škola DTI",
  },
  {
    label: "Vysoká škola ekonomická v Praze",
    value: "Vysoká škola ekonomická v Praze",
  },
  {
    label: "Vysoká škola ekonomie a managementu",
    value: "Vysoká škola ekonomie a managementu",
  },
  {
    label: "Vysoká škola ekonómie a manažmentu verejnej správy v Bratislave",
    value: "Vysoká škola ekonómie a manažmentu verejnej správy v Bratislave",
  },
  {
    label: "Vysoká škola evropských a regionálních studií",
    value: "Vysoká škola evropských a regionálních studií",
  },
  {
    label: "Vysoká škola financní a správní",
    value: "Vysoká škola financní a správní",
  },
  {
    label: "Vysoká škola hotelová a ekonomická",
    value: "Vysoká škola hotelová a ekonomická",
  },
  {
    label: "Vysoká škola kreativní komunikace",
    value: "Vysoká škola kreativní komunikace",
  },
  {
    label: "Vysoká škola logistiky",
    value: "Vysoká škola logistiky",
  },
  {
    label: "Vysoká škola manažmentu, City University of Seattle",
    value: "Vysoká škola manažmentu, City University of Seattle",
  },
  {
    label: "Vysoká škola medzinárodného podnikania ISM Slovakia v Prešove",
    value: "Vysoká škola medzinárodného podnikania ISM Slovakia v Prešove",
  },
  {
    label: "Vysoká škola múzických umení v Bratislave",
    value: "Vysoká škola múzických umení v Bratislave",
  },
  {
    label: "Vysoká škola obchodní a hotelová",
    value: "Vysoká škola obchodní a hotelová",
  },
  {
    label: "Vysoká škola polytechnická Jihlava",
    value: "Vysoká škola polytechnická Jihlava",
  },
  {
    label: "Vysoká škola PRIGO",
    value: "Vysoká škola PRIGO",
  },
  {
    label: "Vysoká škola technická a ekonomická v Ceských Budejovicích",
    value: "Vysoká škola technická a ekonomická v Ceských Budejovicích",
  },
  {
    label: "Vysoká škola telesné výchovy a sportu Palestra",
    value: "Vysoká škola telesné výchovy a sportu Palestra",
  },
  {
    label: "Vysoká škola umeleckoprumyslová v Praze",
    value: "Vysoká škola umeleckoprumyslová v Praze",
  },
  {
    label: "Vysoká škola výtvarných umení v Bratislave",
    value: "Vysoká škola výtvarných umení v Bratislave",
  },
  {
    label: "Vysoká škola zdravotnická",
    value: "Vysoká škola zdravotnická",
  },
  {
    label:
      "Vysoká Škola Zdravotníctva a Sociálnej Práce sv. Alžbety v Bratislave",
    value:
      "Vysoká Škola Zdravotníctva a Sociálnej Práce sv. Alžbety v Bratislave",
  },
  {
    label: "Vysoké ucení technické v Brne",
    value: "Vysoké ucení technické v Brne",
  },
  {
    label: "Vytauto Didžiojo universitetas",
    value: "Vytauto Didžiojo universitetas",
  },
  {
    label: "Wabash College",
    value: "Wabash College",
  },
  {
    label: "Wachamo University",
    value: "Wachamo University",
  },
  {
    label: "Wad Medani Ahlia University",
    value: "Wad Medani Ahlia University",
  },
  {
    label: "Wade College",
    value: "Wade College",
  },
  {
    label: "Wadi International University",
    value: "Wadi International University",
  },
  {
    label: "Wageningen Universiteit",
    value: "Wageningen Universiteit",
  },
  {
    label: "Wagner College",
    value: "Wagner College",
  },
  {
    label: "Wakayama Medical University",
    value: "Wakayama Medical University",
  },
  {
    label: "Wakayama University",
    value: "Wakayama University",
  },
  {
    label: "Wake Forest University",
    value: "Wake Forest University",
  },
  {
    label: "Wako University",
    value: "Wako University",
  },
  {
    label: "Walailak University",
    value: "Walailak University",
  },
  {
    label: "Waldorf University",
    value: "Waldorf University",
  },
  {
    label: "Waljat Colleges of Applied Sciences",
    value: "Waljat Colleges of Applied Sciences",
  },
  {
    label: "Walla Walla University",
    value: "Walla Walla University",
  },
  {
    label: "Walsh College",
    value: "Walsh College",
  },
  {
    label: "Walsh University",
    value: "Walsh University",
  },
  {
    label: "Walter Sisulu University",
    value: "Walter Sisulu University",
  },
  {
    label: "Wannan Medical College",
    value: "Wannan Medical College",
  },
  {
    label: "Warner Pacific University",
    value: "Warner Pacific University",
  },
  {
    label: "Warner University",
    value: "Warner University",
  },
  {
    label: "Warren Wilson College",
    value: "Warren Wilson College",
  },
  {
    label: "Warszawski Uniwersytet Medyczny",
    value: "Warszawski Uniwersytet Medyczny",
  },
  {
    label: "Wartburg College",
    value: "Wartburg College",
  },
  {
    label: "Waseda University",
    value: "Waseda University",
  },
  {
    label: "Washburn University",
    value: "Washburn University",
  },
  {
    label: "Washington & Jefferson College",
    value: "Washington & Jefferson College",
  },
  {
    label: "Washington Adventist University",
    value: "Washington Adventist University",
  },
  {
    label: "Washington and Lee University",
    value: "Washington and Lee University",
  },
  {
    label: "Washington College",
    value: "Washington College",
  },
  {
    label: "Washington State University",
    value: "Washington State University",
  },
  {
    label: "Washington University in St. Louis",
    value: "Washington University in St. Louis",
  },
  {
    label: "Wayamba University of Sri Lanka",
    value: "Wayamba University of Sri Lanka",
  },
  {
    label: "Wayland Baptist University",
    value: "Wayland Baptist University",
  },
  {
    label: "Wayne State College",
    value: "Wayne State College",
  },
  {
    label: "Wayne State University",
    value: "Wayne State University",
  },
  {
    label: "Waynesburg University",
    value: "Waynesburg University",
  },
  {
    label: "Wayo Women's University",
    value: "Wayo Women's University",
  },
  {
    label: "Webb Institute",
    value: "Webb Institute",
  },
  {
    label: "Webber International University",
    value: "Webber International University",
  },
  {
    label: "Weber State University",
    value: "Weber State University",
  },
  {
    label: "Webster University",
    value: "Webster University",
  },
  {
    label: "Webster University Geneva",
    value: "Webster University Geneva",
  },
  {
    label: "Webster Vienna Private University",
    value: "Webster Vienna Private University",
  },
  {
    label: "Weifang Medical University",
    value: "Weifang Medical University",
  },
  {
    label: "Weifang University",
    value: "Weifang University",
  },
  {
    label: "Weifang University of Science and Technology",
    value: "Weifang University of Science and Technology",
  },
  {
    label: "Weill Cornell Medicine - Qatar",
    value: "Weill Cornell Medicine - Qatar",
  },
  {
    label: "Weinan Normal University",
    value: "Weinan Normal University",
  },
  {
    label: "Weissensee Kunsthochschule Berlin",
    value: "Weissensee Kunsthochschule Berlin",
  },
  {
    label: "Weizmann Institute of Science",
    value: "Weizmann Institute of Science",
  },
  {
    label: "Wekerle Sándor Üzleti Foiskola",
    value: "Wekerle Sándor Üzleti Foiskola",
  },
  {
    label: "Welch College",
    value: "Welch College",
  },
  {
    label: "Wellesley College",
    value: "Wellesley College",
  },
  {
    label: "Wells College",
    value: "Wells College",
  },
  {
    label: "Wellspring University",
    value: "Wellspring University",
  },
  {
    label: "Wenhua University",
    value: "Wenhua University",
  },
  {
    label: "Wenshan University",
    value: "Wenshan University",
  },
  {
    label: "Wentworth Institute of Technology",
    value: "Wentworth Institute of Technology",
  },
  {
    label: "Wenzao Ursuline University of Languages",
    value: "Wenzao Ursuline University of Languages",
  },
  {
    label: "Wenzhou Business College",
    value: "Wenzhou Business College",
  },
  {
    label: "Wenzhou Medical University",
    value: "Wenzhou Medical University",
  },
  {
    label: "Wenzhou University",
    value: "Wenzhou University",
  },
  {
    label: "Wenzhou-Kean University",
    value: "Wenzhou-Kean University",
  },
  {
    label: "Wesley János Lelkészképzo Foiskola",
    value: "Wesley János Lelkészképzo Foiskola",
  },
  {
    label: "Wesley University of Science and Technology",
    value: "Wesley University of Science and Technology",
  },
  {
    label: "Wesleyan College",
    value: "Wesleyan College",
  },
  {
    label: "Wesleyan University",
    value: "Wesleyan University",
  },
  {
    label: "Wesleyan University-Philippines",
    value: "Wesleyan University-Philippines",
  },
  {
    label: "West Anhui University",
    value: "West Anhui University",
  },
  {
    label: "West Bengal State University",
    value: "West Bengal State University",
  },
  {
    label: "West Bengal University of Animal and Fishery Sciences",
    value: "West Bengal University of Animal and Fishery Sciences",
  },
  {
    label: "West Bengal University of Health Sciences",
    value: "West Bengal University of Health Sciences",
  },
  {
    label:
      "West Bengal University of Teachers' Training, Education Planning and Administration",
    value:
      "West Bengal University of Teachers' Training, Education Planning and Administration",
  },
  {
    label: "West Chester University of Pennsylvania",
    value: "West Chester University of Pennsylvania",
  },
  {
    label: "West Coast University-Los Angeles",
    value: "West Coast University-Los Angeles",
  },
  {
    label: "West End University College",
    value: "West End University College",
  },
  {
    label: "West Kazakhstan Agro-Technical University",
    value: "West Kazakhstan Agro-Technical University",
  },
  {
    label: "West Kazakhstan Marat Ospanov Medical University",
    value: "West Kazakhstan Marat Ospanov Medical University",
  },
  {
    label: "West Kazakhstan State University",
    value: "West Kazakhstan State University",
  },
  {
    label: "West Kordofan University",
    value: "West Kordofan University",
  },
  {
    label: "West Liberty University",
    value: "West Liberty University",
  },
  {
    label: "West Texas A&M University",
    value: "West Texas A&M University",
  },
  {
    label: "West Ukrainian National University",
    value: "West Ukrainian National University",
  },
  {
    label: "West Virginia School of Osteopathic Medicine",
    value: "West Virginia School of Osteopathic Medicine",
  },
  {
    label: "West Virginia State University",
    value: "West Virginia State University",
  },
  {
    label: "West Virginia University",
    value: "West Virginia University",
  },
  {
    label: "West Virginia University at Parkersburg",
    value: "West Virginia University at Parkersburg",
  },
  {
    label: "West Virginia Wesleyan College",
    value: "West Virginia Wesleyan College",
  },
  {
    label: "West Visayas State University",
    value: "West Visayas State University",
  },
  {
    label: "West Yangon Technological University",
    value: "West Yangon Technological University",
  },
  {
    label: "West Yunnan University",
    value: "West Yunnan University",
  },
  {
    label: "West Yunnan University of Applied Sciences",
    value: "West Yunnan University of Applied Sciences",
  },
  {
    label: "Western Carolina University",
    value: "Western Carolina University",
  },
  {
    label: "Western Colorado University",
    value: "Western Colorado University",
  },
  {
    label: "Western Connecticut State University",
    value: "Western Connecticut State University",
  },
  {
    label: "Western Delta University",
    value: "Western Delta University",
  },
  {
    label: "Western Galilee College",
    value: "Western Galilee College",
  },
  {
    label: "Western Illinois University",
    value: "Western Illinois University",
  },
  {
    label: "Western Institute of Technology",
    value: "Western Institute of Technology",
  },
  {
    label: "Western Kentucky University",
    value: "Western Kentucky University",
  },
  {
    label: "Western Michigan University",
    value: "Western Michigan University",
  },
  {
    label: "Western Mindanao State University",
    value: "Western Mindanao State University",
  },
  {
    label: "Western Nevada College",
    value: "Western Nevada College",
  },
  {
    label: "Western New England University",
    value: "Western New England University",
  },
  {
    label: "Western New Mexico University",
    value: "Western New Mexico University",
  },
  {
    label: "Western Oregon University",
    value: "Western Oregon University",
  },
  {
    label: "Western Philippines University",
    value: "Western Philippines University",
  },
  {
    label: "Western Sydney University",
    value: "Western Sydney University",
  },
  {
    label: "Western University",
    value: "Western University",
  },
  {
    label: "Western University",
    value: "Western University",
  },
  {
    label: "Western University of Health Sciences",
    value: "Western University of Health Sciences",
  },
  {
    label: "Western University, Cambodia",
    value: "Western University, Cambodia",
  },
  {
    label: "Western Washington University",
    value: "Western Washington University",
  },
  {
    label: "Westfälische Hochschule Gelsenkirchen Bocholt Recklinghausen",
    value: "Westfälische Hochschule Gelsenkirchen Bocholt Recklinghausen",
  },
  {
    label: "Westfälische Wilhelms-Universität Münster",
    value: "Westfälische Wilhelms-Universität Münster",
  },
  {
    label: "Westfield State University",
    value: "Westfield State University",
  },
  {
    label: "Westminster College",
    value: "Westminster College",
  },
  {
    label: "Westminster College, Missouri",
    value: "Westminster College, Missouri",
  },
  {
    label: "Westminster College, Pennsylvania",
    value: "Westminster College, Pennsylvania",
  },
  {
    label: "Westmont College",
    value: "Westmont College",
  },
  {
    label: "Westsächsische Hochschule Zwickau",
    value: "Westsächsische Hochschule Zwickau",
  },
  {
    label: "Wheaton College",
    value: "Wheaton College",
  },
  {
    label: "Wheaton College, Massachusetts",
    value: "Wheaton College, Massachusetts",
  },
  {
    label: "Wheeling University",
    value: "Wheeling University",
  },
  {
    label: "White Nile University",
    value: "White Nile University",
  },
  {
    label: "Whitman College",
    value: "Whitman College",
  },
  {
    label: "Whittier College",
    value: "Whittier College",
  },
  {
    label: "Whitworth University",
    value: "Whitworth University",
  },
  {
    label: "WHU - Otto Beisheim School of Management",
    value: "WHU - Otto Beisheim School of Management",
  },
  {
    label: "Wichita State University",
    value: "Wichita State University",
  },
  {
    label: "Widener University",
    value: "Widener University",
  },
  {
    label: "Wilberforce University",
    value: "Wilberforce University",
  },
  {
    label: "Wiley College",
    value: "Wiley College",
  },
  {
    label: "Wilfrid Laurier University",
    value: "Wilfrid Laurier University",
  },
  {
    label: "Wilhelm Löhe Hochschule",
    value: "Wilhelm Löhe Hochschule",
  },
  {
    label: "Wilkes University",
    value: "Wilkes University",
  },
  {
    label: "Willamette University",
    value: "Willamette University",
  },
  {
    label: "William Carey University",
    value: "William Carey University",
  },
  {
    label: "William Carey University, Shillong",
    value: "William Carey University, Shillong",
  },
  {
    label: "William James College",
    value: "William James College",
  },
  {
    label: "William Jewell College",
    value: "William Jewell College",
  },
  {
    label: "William Paterson University",
    value: "William Paterson University",
  },
  {
    label: "William Peace University",
    value: "William Peace University",
  },
  {
    label: "William Penn University",
    value: "William Penn University",
  },
  {
    label: "William V. S. Tubman University",
    value: "William V. S. Tubman University",
  },
  {
    label: "William Woods University",
    value: "William Woods University",
  },
  {
    label: "Williams Baptist University",
    value: "Williams Baptist University",
  },
  {
    label: "Williams College",
    value: "Williams College",
  },
  {
    label: "Wilmington College",
    value: "Wilmington College",
  },
  {
    label: "Wilmington University",
    value: "Wilmington University",
  },
  {
    label: "Wilson College",
    value: "Wilson College",
  },
  {
    label: "Windsor University School of Medicine",
    value: "Windsor University School of Medicine",
  },
  {
    label: "Wingate University",
    value: "Wingate University",
  },
  {
    label: "Winona State University",
    value: "Winona State University",
  },
  {
    label: "Winston-Salem State University",
    value: "Winston-Salem State University",
  },
  {
    label: "Winthrop University",
    value: "Winthrop University",
  },
  {
    label: "Wirtschaftsuniversität Wien",
    value: "Wirtschaftsuniversität Wien",
  },
  {
    label: "Wisconsin International University College",
    value: "Wisconsin International University College",
  },
  {
    label: "Wisconsin Lutheran College",
    value: "Wisconsin Lutheran College",
  },
  {
    label: "Wisconsin School of Professional Psychology",
    value: "Wisconsin School of Professional Psychology",
  },
  {
    label: "Wittenberg University",
    value: "Wittenberg University",
  },
  {
    label: "Wittenborg University of Applied Sciences",
    value: "Wittenborg University of Applied Sciences",
  },
  {
    label: "Wofford College",
    value: "Wofford College",
  },
  {
    label: "Wojskowa Akademia Techniczna im. Jaroslawa Dabrowskiego",
    value: "Wojskowa Akademia Techniczna im. Jaroslawa Dabrowskiego",
  },
  {
    label: "Wolaita Sodo University",
    value: "Wolaita Sodo University",
  },
  {
    label: "Woldia University",
    value: "Woldia University",
  },
  {
    label: "Wolkite University",
    value: "Wolkite University",
  },
  {
    label: "Wollega University",
    value: "Wollega University",
  },
  {
    label: "Wollo University",
    value: "Wollo University",
  },
  {
    label: "Women University of Azad Jammu and Kashmir Bagh",
    value: "Women University of Azad Jammu and Kashmir Bagh",
  },
  {
    label: "Women University Swabi",
    value: "Women University Swabi",
  },
  {
    label: "Women's University in Africa",
    value: "Women's University in Africa",
  },
  {
    label: "WON Institute of Graduate Studies",
    value: "WON Institute of Graduate Studies",
  },
  {
    label: "Wonkwang University",
    value: "Wonkwang University",
  },
  {
    label: "Wonsan Agricultural University",
    value: "Wonsan Agricultural University",
  },
  {
    label: "Woodbury University",
    value: "Woodbury University",
  },
  {
    label: "Woosong University",
    value: "Woosong University",
  },
  {
    label: "Woosuk University",
    value: "Woosuk University",
  },
  {
    label: "Worcester Polytechnic Institute",
    value: "Worcester Polytechnic Institute",
  },
  {
    label: "Worcester State University",
    value: "Worcester State University",
  },
  {
    label: "World Maritime University",
    value: "World Maritime University",
  },
  {
    label: "World University of Bangladesh",
    value: "World University of Bangladesh",
  },
  {
    label: "Wrexham University",
    value: "Wrexham University",
  },
  {
    label: "Wright State University",
    value: "Wright State University",
  },
  {
    label: "Writtle University College",
    value: "Writtle University College",
  },
  {
    label: "Wschodnioeuropejska Akademia Nauk Stosowanych w Bialymstoku",
    value: "Wschodnioeuropejska Akademia Nauk Stosowanych w Bialymstoku",
  },
  {
    label: "Wuchang Institute of Technology",
    value: "Wuchang Institute of Technology",
  },
  {
    label: "Wuchang Shouyi University",
    value: "Wuchang Shouyi University",
  },
  {
    label: "Wuchang University of Technology",
    value: "Wuchang University of Technology",
  },
  {
    label: "WuFeng University",
    value: "WuFeng University",
  },
  {
    label: "Wuhan Business University",
    value: "Wuhan Business University",
  },
  {
    label: "Wuhan College",
    value: "Wuhan College",
  },
  {
    label: "Wuhan College of Media and Communications",
    value: "Wuhan College of Media and Communications",
  },
  {
    label: "Wuhan Conservatory of Music",
    value: "Wuhan Conservatory of Music",
  },
  {
    label: "Wuhan Donghu University",
    value: "Wuhan Donghu University",
  },
  {
    label: "Wuhan Huaxia Institute of Technology",
    value: "Wuhan Huaxia Institute of Technology",
  },
  {
    label: "Wuhan Institute of Bioengineering",
    value: "Wuhan Institute of Bioengineering",
  },
  {
    label: "Wuhan Institute of Design and Sciences",
    value: "Wuhan Institute of Design and Sciences",
  },
  {
    label: "Wuhan Institute of Technology",
    value: "Wuhan Institute of Technology",
  },
  {
    label: "Wuhan Polytechnic University",
    value: "Wuhan Polytechnic University",
  },
  {
    label: "Wuhan Qingchuan University",
    value: "Wuhan Qingchuan University",
  },
  {
    label: "Wuhan Sports University",
    value: "Wuhan Sports University",
  },
  {
    label: "Wuhan Technology and Business University",
    value: "Wuhan Technology and Business University",
  },
  {
    label: "Wuhan Textile University",
    value: "Wuhan Textile University",
  },
  {
    label: "Wuhan University",
    value: "Wuhan University",
  },
  {
    label: "Wuhan University of Engineering Science",
    value: "Wuhan University of Engineering Science",
  },
  {
    label: "Wuhan University of Science and Technology",
    value: "Wuhan University of Science and Technology",
  },
  {
    label: "Wuhan University of Technology",
    value: "Wuhan University of Technology",
  },
  {
    label: "Wuxi Taihu University",
    value: "Wuxi Taihu University",
  },
  {
    label: "Wuyi University",
    value: "Wuyi University",
  },
  {
    label: "Wuyi University, Guangdong",
    value: "Wuyi University, Guangdong",
  },
  {
    label: "Wuzhou University",
    value: "Wuzhou University",
  },
  {
    label: "Wyzsza Szkola Biznesu - National-Louis University",
    value: "Wyzsza Szkola Biznesu - National-Louis University",
  },
  {
    label: "Wyzsza Szkola Ekonomii i Informatyki w Krakowie",
    value: "Wyzsza Szkola Ekonomii i Informatyki w Krakowie",
  },
  {
    label: "Wyzsza Szkola Ekonomii i Innowacji w Lublinie",
    value: "Wyzsza Szkola Ekonomii i Innowacji w Lublinie",
  },
  {
    label: "Wyzsza Szkola Ekonomii, Prawa i Nauk Medycznych",
    value: "Wyzsza Szkola Ekonomii, Prawa i Nauk Medycznych",
  },
  {
    label: "Wyzsza Szkola Informatyki i Umiejetnosci z siedziba w Lodzi",
    value: "Wyzsza Szkola Informatyki i Umiejetnosci z siedziba w Lodzi",
  },
  {
    label:
      "Wyzsza Szkola Informatyki i Zarzadzania im. Prof. Tadeusza Kotarbinskiego",
    value:
      "Wyzsza Szkola Informatyki i Zarzadzania im. Prof. Tadeusza Kotarbinskiego",
  },
  {
    label: "Wyzsza Szkola Informatyki Stosowanej i Zarzadzania",
    value: "Wyzsza Szkola Informatyki Stosowanej i Zarzadzania",
  },
  {
    label: "Wyzsza Szkola Lingwistyczna w Czestochowie",
    value: "Wyzsza Szkola Lingwistyczna w Czestochowie",
  },
  {
    label: "Wyzsza Szkola Pedagogiczna im. Janusza Korczaka w Warszawie",
    value: "Wyzsza Szkola Pedagogiczna im. Janusza Korczaka w Warszawie",
  },
  {
    label: "Wyzsza Szkola Przedsiebiorczosci i Administracji w Lublinie",
    value: "Wyzsza Szkola Przedsiebiorczosci i Administracji w Lublinie",
  },
  {
    label: "Wyzsza Szkola Spoleczno-Ekonomiczna w Gdansku",
    value: "Wyzsza Szkola Spoleczno-Ekonomiczna w Gdansku",
  },
  {
    label: "Wyzsza Szkola Zarzadzania i Administracji w Zamosciu",
    value: "Wyzsza Szkola Zarzadzania i Administracji w Zamosciu",
  },
  {
    label: "Wyzsza Szkola Zarzadzania i Bankowosci w Krakowie",
    value: "Wyzsza Szkola Zarzadzania i Bankowosci w Krakowie",
  },
  {
    label: "Wyzsza Szkola Zdrowia w Gdansku",
    value: "Wyzsza Szkola Zdrowia w Gdansku",
  },
  {
    label: "Xavier University",
    value: "Xavier University",
  },
  {
    label: "Xavier University of Louisiana",
    value: "Xavier University of Louisiana",
  },
  {
    label: "Xavier University School of Medicine",
    value: "Xavier University School of Medicine",
  },
  {
    label: "Xavier University-Ateneo de Cagayan",
    value: "Xavier University-Ateneo de Cagayan",
  },
  {
    label: "Xezer Universiteti",
    value: "Xezer Universiteti",
  },
  {
    label: "Xiamen Huaxia University",
    value: "Xiamen Huaxia University",
  },
  {
    label: "Xiamen Institude of Technology",
    value: "Xiamen Institude of Technology",
  },
  {
    label: "Xiamen University",
    value: "Xiamen University",
  },
  {
    label: "Xiamen University of Technology",
    value: "Xiamen University of Technology",
  },
  {
    label: "Xi'an Academy of Fine Arts",
    value: "Xi'an Academy of Fine Arts",
  },
  {
    label: "Xi'an Aeronautical University",
    value: "Xi'an Aeronautical University",
  },
  {
    label: "Xi'an Conservatory of Music",
    value: "Xi'an Conservatory of Music",
  },
  {
    label: "Xi'an Eurasia University",
    value: "Xi'an Eurasia University",
  },
  {
    label: "Xi'an Fanyi University",
    value: "Xi'an Fanyi University",
  },
  {
    label: "Xi'an International Studies University",
    value: "Xi'an International Studies University",
  },
  {
    label: "Xi'an International University",
    value: "Xi'an International University",
  },
  {
    label: "Xi'an Jiaotong University",
    value: "Xi'an Jiaotong University",
  },
  {
    label: "Xi'an Jiaotong-Liverpool University",
    value: "Xi'an Jiaotong-Liverpool University",
  },
  {
    label: "Xi'an Medical University",
    value: "Xi'an Medical University",
  },
  {
    label: "Xi'an Peihua University",
    value: "Xi'an Peihua University",
  },
  {
    label: "Xi'an Physical Education University",
    value: "Xi'an Physical Education University",
  },
  {
    label: "Xi'an Polytechnic University",
    value: "Xi'an Polytechnic University",
  },
  {
    label: "Xi'an Shiyou University",
    value: "Xi'an Shiyou University",
  },
  {
    label: "Xi'an Siyuan University",
    value: "Xi'an Siyuan University",
  },
  {
    label: "Xi'an Technological University",
    value: "Xi'an Technological University",
  },
  {
    label: "Xi'an Traffic Engineering Institute",
    value: "Xi'an Traffic Engineering Institute",
  },
  {
    label: "Xi'an University",
    value: "Xi'an University",
  },
  {
    label: "Xi'an University of Architecture and Technology",
    value: "Xi'an University of Architecture and Technology",
  },
  {
    label: "Xi'an University of Finance and Economics",
    value: "Xi'an University of Finance and Economics",
  },
  {
    label: "Xi'an University of Posts and Telecommunications",
    value: "Xi'an University of Posts and Telecommunications",
  },
  {
    label: "Xi'an University of Science and Technology",
    value: "Xi'an University of Science and Technology",
  },
  {
    label: "Xi'an University of Technology",
    value: "Xi'an University of Technology",
  },
  {
    label: "Xiangnan University",
    value: "Xiangnan University",
  },
  {
    label: "XiangTan University",
    value: "XiangTan University",
  },
  {
    label: "Xianyang Normal University",
    value: "Xianyang Normal University",
  },
  {
    label: "Xichang College",
    value: "Xichang College",
  },
  {
    label: "Xidian University",
    value: "Xidian University",
  },
  {
    label: "Xihua University",
    value: "Xihua University",
  },
  {
    label: "Xijing University",
    value: "Xijing University",
  },
  {
    label: "XIM University",
    value: "XIM University",
  },
  {
    label: "Xinghai Conservatory of Music",
    value: "Xinghai Conservatory of Music",
  },
  {
    label: "Xingtai University",
    value: "Xingtai University",
  },
  {
    label: "Xingyi Normal University for Nationalities",
    value: "Xingyi Normal University for Nationalities",
  },
  {
    label: "Xinjiang Agricultural University",
    value: "Xinjiang Agricultural University",
  },
  {
    label: "Xinjiang Arts University",
    value: "Xinjiang Arts University",
  },
  {
    label: "Xinjiang Institute of Engineering",
    value: "Xinjiang Institute of Engineering",
  },
  {
    label: "Xinjiang Medical University",
    value: "Xinjiang Medical University",
  },
  {
    label: "Xinjiang Normal University",
    value: "Xinjiang Normal University",
  },
  {
    label: "Xinjiang University",
    value: "Xinjiang University",
  },
  {
    label: "Xinjiang University of Finance and Economics",
    value: "Xinjiang University of Finance and Economics",
  },
  {
    label: "Xinxiang Medical University",
    value: "Xinxiang Medical University",
  },
  {
    label: "Xinxiang University",
    value: "Xinxiang University",
  },
  {
    label: "Xinyang Agriculture and Forestry University",
    value: "Xinyang Agriculture and Forestry University",
  },
  {
    label: "Xinyang Normal University",
    value: "Xinyang Normal University",
  },
  {
    label: "Xinyang University",
    value: "Xinyang University",
  },
  {
    label: "Xinyu University",
    value: "Xinyu University",
  },
  {
    label: "Xinzhou Teachers University",
    value: "Xinzhou Teachers University",
  },
  {
    label: "Xizang Minzu University",
    value: "Xizang Minzu University",
  },
  {
    label: "Xuchang University",
    value: "Xuchang University",
  },
  {
    label: "Xuzhou Institute of Technology",
    value: "Xuzhou Institute of Technology",
  },
  {
    label: "Xuzhou Medical University",
    value: "Xuzhou Medical University",
  },
  {
    label: "Yadanabon University",
    value: "Yadanabon University",
  },
  {
    label: "Yakin Dogu Üniversitesi",
    value: "Yakin Dogu Üniversitesi",
  },
  {
    label: "Yala Rajabhat University",
    value: "Yala Rajabhat University",
  },
  {
    label: "Yale University",
    value: "Yale University",
  },
  {
    label: "Yalova Üniversitesi",
    value: "Yalova Üniversitesi",
  },
  {
    label: "Yamagata Prefectural University of Health Sciences",
    value: "Yamagata Prefectural University of Health Sciences",
  },
  {
    label: "Yamagata Prefectural Yonezawa University of Nutrition Sciences",
    value: "Yamagata Prefectural Yonezawa University of Nutrition Sciences",
  },
  {
    label: "Yamagata University",
    value: "Yamagata University",
  },
  {
    label: "Yamaguchi Gakugei University",
    value: "Yamaguchi Gakugei University",
  },
  {
    label: "Yamaguchi Prefectural University",
    value: "Yamaguchi Prefectural University",
  },
  {
    label: "Yamaguchi University",
    value: "Yamaguchi University",
  },
  {
    label: "Yamanashi Eiwa College",
    value: "Yamanashi Eiwa College",
  },
  {
    label: "Yamanashi Gakuin University",
    value: "Yamanashi Gakuin University",
  },
  {
    label: "Yamanashi Prefectural University",
    value: "Yamanashi Prefectural University",
  },
  {
    label: "Yamato University",
    value: "Yamato University",
  },
  {
    label: "Yan'an University",
    value: "Yan'an University",
  },
  {
    label: "Yanbian University",
    value: "Yanbian University",
  },
  {
    label: "Yancheng Institute of Technology",
    value: "Yancheng Institute of Technology",
  },
  {
    label: "Yancheng Teachers University",
    value: "Yancheng Teachers University",
  },
  {
    label: "Yang-En University",
    value: "Yang-En University",
  },
  {
    label: "Yangon Technological University",
    value: "Yangon Technological University",
  },
  {
    label: "Yangon University",
    value: "Yangon University",
  },
  {
    label: "Yangon University of Economics",
    value: "Yangon University of Economics",
  },
  {
    label: "Yangon University of Education",
    value: "Yangon University of Education",
  },
  {
    label: "Yangtze Normal University",
    value: "Yangtze Normal University",
  },
  {
    label: "Yangtze University",
    value: "Yangtze University",
  },
  {
    label: "Yangzhou University",
    value: "Yangzhou University",
  },
  {
    label: "Yanjing Institute of Technology",
    value: "Yanjing Institute of Technology",
  },
  {
    label: "Yanka Kupala State University of Grodno",
    value: "Yanka Kupala State University of Grodno",
  },
  {
    label: "Yanshan University",
    value: "Yanshan University",
  },
  {
    label: "Yantai Nanshan University",
    value: "Yantai Nanshan University",
  },
  {
    label: "Yantai University",
    value: "Yantai University",
  },
  {
    label: "Yarmouk Private University",
    value: "Yarmouk Private University",
  },
  {
    label: "Yarmouk University",
    value: "Yarmouk University",
  },
  {
    label: "Yaroslav Mudryi National Law University",
    value: "Yaroslav Mudryi National Law University",
  },
  {
    label: "Yaroslavl State Academy of Agriculture",
    value: "Yaroslavl State Academy of Agriculture",
  },
  {
    label: "Yaroslavl State Medical University",
    value: "Yaroslavl State Medical University",
  },
  {
    label: "Yaroslavl State Pedagogical University",
    value: "Yaroslavl State Pedagogical University",
  },
  {
    label: "Yaroslavl State Technical University",
    value: "Yaroslavl State Technical University",
  },
  {
    label: "Yaroslavl State University",
    value: "Yaroslavl State University",
  },
  {
    label: "Yasar Üniversitesi",
    value: "Yasar Üniversitesi",
  },
  {
    label: "Yashima Gakuen University",
    value: "Yashima Gakuen University",
  },
  {
    label: "Yasuda Women's University",
    value: "Yasuda Women's University",
  },
  {
    label: "Yasuj University",
    value: "Yasuj University",
  },
  {
    label: "Yasuj University of Medical Sciences",
    value: "Yasuj University of Medical Sciences",
  },
  {
    label: "Yazd University",
    value: "Yazd University",
  },
  {
    label: "YBN University",
    value: "YBN University",
  },
  {
    label: "Yeditepe Üniversitesi",
    value: "Yeditepe Üniversitesi",
  },
  {
    label: "Yei Agricultural and Mechanical University",
    value: "Yei Agricultural and Mechanical University",
  },
  {
    label: "Yelets State University",
    value: "Yelets State University",
  },
  {
    label: "Yemen and the Gulf University of Science and Technology",
    value: "Yemen and the Gulf University of Science and Technology",
  },
  {
    label: "Yemeni Jordanian University",
    value: "Yemeni Jordanian University",
  },
  {
    label: "Yemeni University",
    value: "Yemeni University",
  },
  {
    label: "Yemenia University",
    value: "Yemenia University",
  },
  {
    label: "Yenepoya University",
    value: "Yenepoya University",
  },
  {
    label: "Yerevan Brusov State University of Languages and Social Sciences",
    value: "Yerevan Brusov State University of Languages and Social Sciences",
  },
  {
    label: "Yerevan Gladzor University",
    value: "Yerevan Gladzor University",
  },
  {
    label: "Yerevan Haybusak University",
    value: "Yerevan Haybusak University",
  },
  {
    label: "Yerevan Komitas State Conservatory",
    value: "Yerevan Komitas State Conservatory",
  },
  {
    label: "Yerevan Medical Institute after Mehrabyan",
    value: "Yerevan Medical Institute after Mehrabyan",
  },
  {
    label: "Yerevan Mesrop Mashtots University",
    value: "Yerevan Mesrop Mashtots University",
  },
  {
    label: "Yerevan Northern University",
    value: "Yerevan Northern University",
  },
  {
    label: "Yerevan State Institute of Theatre and Cinema",
    value: "Yerevan State Institute of Theatre and Cinema",
  },
  {
    label: "Yerevan State Medical University",
    value: "Yerevan State Medical University",
  },
  {
    label: "Yerevan State University",
    value: "Yerevan State University",
  },
  {
    label: "Yerevan University after Movses Khorenatsi",
    value: "Yerevan University after Movses Khorenatsi",
  },
  {
    label: "Yeshiva University",
    value: "Yeshiva University",
  },
  {
    label: "Yeungnam University",
    value: "Yeungnam University",
  },
  {
    label: "Yewon Arts University",
    value: "Yewon Arts University",
  },
  {
    label: "Yezin Agricultural University",
    value: "Yezin Agricultural University",
  },
  {
    label: "Yibin University",
    value: "Yibin University",
  },
  {
    label: "Yichun University",
    value: "Yichun University",
  },
  {
    label: "Yildiz Teknik Üniversitesi",
    value: "Yildiz Teknik Üniversitesi",
  },
  {
    label: "Yili Normal University",
    value: "Yili Normal University",
  },
  {
    label: "Yinchuan Energy College",
    value: "Yinchuan Energy College",
  },
  {
    label: "Yingkou Institute of Technology",
    value: "Yingkou Institute of Technology",
  },
  {
    label: "Yobe State University",
    value: "Yobe State University",
  },
  {
    label: "Yogi Vemana University",
    value: "Yogi Vemana University",
  },
  {
    label: "Yokkaichi Nursing and Medical Care University",
    value: "Yokkaichi Nursing and Medical Care University",
  },
  {
    label: "Yokkaichi University",
    value: "Yokkaichi University",
  },
  {
    label: "Yokohama City University",
    value: "Yokohama City University",
  },
  {
    label: "Yokohama College of Commerce",
    value: "Yokohama College of Commerce",
  },
  {
    label: "Yokohama National University",
    value: "Yokohama National University",
  },
  {
    label: "Yokohama Soei University",
    value: "Yokohama Soei University",
  },
  {
    label: "Yokohama University of Art and Design",
    value: "Yokohama University of Art and Design",
  },
  {
    label: "Yokohama University of Pharmacy",
    value: "Yokohama University of Pharmacy",
  },
  {
    label: "Yong-In University",
    value: "Yong-In University",
  },
  {
    label: "Yonsei University",
    value: "Yonsei University",
  },
  {
    label: "York College of Pennsylvania",
    value: "York College of Pennsylvania",
  },
  {
    label: "York College, City University of New York",
    value: "York College, City University of New York",
  },
  {
    label: "York St John University",
    value: "York St John University",
  },
  {
    label: "York University",
    value: "York University",
  },
  {
    label: "York University",
    value: "York University",
  },
  {
    label: "Yorkville University",
    value: "Yorkville University",
  },
  {
    label: "Youjiang Medical University for Nationalities",
    value: "Youjiang Medical University for Nationalities",
  },
  {
    label: "Young Harris College",
    value: "Young Harris College",
  },
  {
    label: "Youngnam Theological University and Seminary",
    value: "Youngnam Theological University and Seminary",
  },
  {
    label: "Youngsan University",
    value: "Youngsan University",
  },
  {
    label: "Youngsan University of Son Studies",
    value: "Youngsan University of Son Studies",
  },
  {
    label: "Youngstown State University",
    value: "Youngstown State University",
  },
  {
    label: "Yozgat Bozok Üniversitesi",
    value: "Yozgat Bozok Üniversitesi",
  },
  {
    label: "Yrkeshögskolan Arcada",
    value: "Yrkeshögskolan Arcada",
  },
  {
    label: "Yrkeshögskolan Novia",
    value: "Yrkeshögskolan Novia",
  },
  {
    label: "Yu Da University of Science and Technology",
    value: "Yu Da University of Science and Technology",
  },
  {
    label: "Yuan Ze University",
    value: "Yuan Ze University",
  },
  {
    label: "Yuanpei University",
    value: "Yuanpei University",
  },
  {
    label: "Yüksek Ihtisas Üniversitesi",
    value: "Yüksek Ihtisas Üniversitesi",
  },
  {
    label: "Yulin Normal University",
    value: "Yulin Normal University",
  },
  {
    label: "Yulin University",
    value: "Yulin University",
  },
  {
    label: "Yuncheng University",
    value: "Yuncheng University",
  },
  {
    label: "Yunnan Agricultural University",
    value: "Yunnan Agricultural University",
  },
  {
    label: "Yunnan Arts University",
    value: "Yunnan Arts University",
  },
  {
    label: "Yunnan College of Business Management",
    value: "Yunnan College of Business Management",
  },
  {
    label: "Yunnan Minzu University",
    value: "Yunnan Minzu University",
  },
  {
    label: "Yunnan Normal University",
    value: "Yunnan Normal University",
  },
  {
    label: "Yunnan Technology and Business University",
    value: "Yunnan Technology and Business University",
  },
  {
    label: "Yunnan University",
    value: "Yunnan University",
  },
  {
    label: "Yunnan University of Chinese Medicine",
    value: "Yunnan University of Chinese Medicine",
  },
  {
    label: "Yunnan University of Finance and Economics",
    value: "Yunnan University of Finance and Economics",
  },
  {
    label: "Yuriy Fedkovych Chernivtsi National University",
    value: "Yuriy Fedkovych Chernivtsi National University",
  },
  {
    label: "Yusuf Maitama Sule University, Kano",
    value: "Yusuf Maitama Sule University, Kano",
  },
  {
    label: "Yuxi Normal University",
    value: "Yuxi Normal University",
  },
  {
    label: "Yuzhang Normal University",
    value: "Yuzhang Normal University",
  },
  {
    label: "Z.H. Sikder University of Science and Technology ",
    value: "Z.H. Sikder University of Science and Technology ",
  },
  {
    label: "Zabol University of Medical Sciences",
    value: "Zabol University of Medical Sciences",
  },
  {
    label: "Zachodniopomorska Szkola Biznesu w Szczecinie",
    value: "Zachodniopomorska Szkola Biznesu w Szczecinie",
  },
  {
    label: "Zachodniopomorski Uniwersytet Technologiczny w Szczecinie",
    value: "Zachodniopomorski Uniwersytet Technologiczny w Szczecinie",
  },
  {
    label: "Zagazig University",
    value: "Zagazig University",
  },
  {
    label: "Zagrebacka škola ekonomije i managementa",
    value: "Zagrebacka škola ekonomije i managementa",
  },
  {
    label: "Zahedan University of Medical Sciences",
    value: "Zahedan University of Medical Sciences",
  },
  {
    label: "Zambian Christian University",
    value: "Zambian Christian University",
  },
  {
    label: "Zambian Royal Medical University",
    value: "Zambian Royal Medical University",
  },
  {
    label: "Zamboanga State College of Marine Sciences and Technology",
    value: "Zamboanga State College of Marine Sciences and Technology",
  },
  {
    label: "Zamfara State University",
    value: "Zamfara State University",
  },
  {
    label: "Zanjan University",
    value: "Zanjan University",
  },
  {
    label: "Zanjan University of Medical Sciences",
    value: "Zanjan University of Medical Sciences",
  },
  {
    label: "Zanzibar University",
    value: "Zanzibar University",
  },
  {
    label: "Zaozhuang University",
    value: "Zaozhuang University",
  },
  {
    label: "Západoceská Univerzita v Plzni",
    value: "Západoceská Univerzita v Plzni",
  },
  {
    label: "Zaporizhia Medical Academy of Postgraduate Education",
    value: "Zaporizhia Medical Academy of Postgraduate Education",
  },
  {
    label: "Zaporizhia State Medical and Pharmaceutical University",
    value: "Zaporizhia State Medical and Pharmaceutical University",
  },
  {
    label: "Zaporizhzhya Institute of Economics and Information Technology",
    value: "Zaporizhzhya Institute of Economics and Information Technology",
  },
  {
    label: "Zaporizhzhya National University",
    value: "Zaporizhzhya National University",
  },
  {
    label: "Zarqa University",
    value: "Zarqa University",
  },
  {
    label: "Zasagt Khan Institute",
    value: "Zasagt Khan Institute",
  },
  {
    label: "Zawul Institute of Higher Education",
    value: "Zawul Institute of Higher Education",
  },
  {
    label: "Zayed University",
    value: "Zayed University",
  },
  {
    label: "ZCAS University",
    value: "ZCAS University",
  },
  {
    label: "Zdravstveno veleucilište Zagreb",
    value: "Zdravstveno veleucilište Zagreb",
  },
  {
    label: "Zefat Academic College",
    value: "Zefat Academic College",
  },
  {
    label: "Zenith University College",
    value: "Zenith University College",
  },
  {
    label: "Zeppelin Universität",
    value: "Zeppelin Universität",
  },
  {
    label: "Zetech University",
    value: "Zetech University",
  },
  {
    label: "Zhangjiakou University",
    value: "Zhangjiakou University",
  },
  {
    label: "Zhaoqing University",
    value: "Zhaoqing University",
  },
  {
    label: "Zhaotong University",
    value: "Zhaotong University",
  },
  {
    label: "Zhejiang Chinese Medical University",
    value: "Zhejiang Chinese Medical University",
  },
  {
    label: "Zhejiang Conservatory of Music",
    value: "Zhejiang Conservatory of Music",
  },
  {
    label: "Zhejiang Forestry University",
    value: "Zhejiang Forestry University",
  },
  {
    label: "Zhejiang Gongshang University",
    value: "Zhejiang Gongshang University",
  },
  {
    label: "Zhejiang International Studies University",
    value: "Zhejiang International Studies University",
  },
  {
    label: "Zhejiang Normal University",
    value: "Zhejiang Normal University",
  },
  {
    label: "Zhejiang Ocean University",
    value: "Zhejiang Ocean University",
  },
  {
    label: "Zhejiang Sci-Tech University",
    value: "Zhejiang Sci-Tech University",
  },
  {
    label: "Zhejiang Shuren University",
    value: "Zhejiang Shuren University",
  },
  {
    label: "Zhejiang University",
    value: "Zhejiang University",
  },
  {
    label: "Zhejiang University of Finance and Economics",
    value: "Zhejiang University of Finance and Economics",
  },
  {
    label: "Zhejiang University of Science and Technology",
    value: "Zhejiang University of Science and Technology",
  },
  {
    label: "Zhejiang University of Technology",
    value: "Zhejiang University of Technology",
  },
  {
    label: "Zhejiang University of Water Resources and Electric Power",
    value: "Zhejiang University of Water Resources and Electric Power",
  },
  {
    label: "Zhejiang Wanli University",
    value: "Zhejiang Wanli University",
  },
  {
    label: "Zhejiang Yuexiu University of Foreign Languages",
    value: "Zhejiang Yuexiu University of Foreign Languages",
  },
  {
    label: "Zhengzhou Business School",
    value: "Zhengzhou Business School",
  },
  {
    label: "Zhengzhou Institute of Finance and Economics",
    value: "Zhengzhou Institute of Finance and Economics",
  },
  {
    label: "Zhengzhou Institute of Technology",
    value: "Zhengzhou Institute of Technology",
  },
  {
    label: "Zhengzhou Normal University",
    value: "Zhengzhou Normal University",
  },
  {
    label: "Zhengzhou Shengda University of Economics, Business and Management",
    value: "Zhengzhou Shengda University of Economics, Business and Management",
  },
  {
    label: "Zhengzhou Technology and Business University",
    value: "Zhengzhou Technology and Business University",
  },
  {
    label: "Zhengzhou University",
    value: "Zhengzhou University",
  },
  {
    label: "Zhengzhou University of Aeronautics",
    value: "Zhengzhou University of Aeronautics",
  },
  {
    label: "Zhengzhou University of Industrial Technology",
    value: "Zhengzhou University of Industrial Technology",
  },
  {
    label: "Zhengzhou University of Light Industry",
    value: "Zhengzhou University of Light Industry",
  },
  {
    label: "Zhengzhou University of Science and Technology",
    value: "Zhengzhou University of Science and Technology",
  },
  {
    label: "Zhetysu State University",
    value: "Zhetysu State University",
  },
  {
    label: "Zhezkazgan University",
    value: "Zhezkazgan University",
  },
  {
    label: "Zhongkai University of Agriculture and Engineering",
    value: "Zhongkai University of Agriculture and Engineering",
  },
  {
    label: "Zhongnan University of Economics and Law",
    value: "Zhongnan University of Economics and Law",
  },
  {
    label: "Zhongyuan University of Technology",
    value: "Zhongyuan University of Technology",
  },
  {
    label: "Zhoukou Normal University",
    value: "Zhoukou Normal University",
  },
  {
    label: "Zhytomyr Ivan Franko State University",
    value: "Zhytomyr Ivan Franko State University",
  },
  {
    label: "Zhytomyr State Technological University",
    value: "Zhytomyr State Technological University",
  },
  {
    label: "Ziauddin University",
    value: "Ziauddin University",
  },
  {
    label: "Žilinská univerzita v Žiline",
    value: "Žilinská univerzita v Žiline",
  },
  {
    label: "Zimbabwe Ezekiel Guti University",
    value: "Zimbabwe Ezekiel Guti University",
  },
  {
    label: "Zintan University",
    value: "Zintan University",
  },
  {
    label: "ZNRF University of Management Sciences",
    value: "ZNRF University of Management Sciences",
  },
  {
    label: "Zonguldak Bülent Ecevit Üniversitesi",
    value: "Zonguldak Bülent Ecevit Üniversitesi",
  },
  {
    label: "Zunyi Medical University",
    value: "Zunyi Medical University",
  },
  {
    label: "Zunyi Normal College",
    value: "Zunyi Normal College",
  },
  {
    label: "Zürcher Hochschule für Angewandte Wissenschaften",
    value: "Zürcher Hochschule für Angewandte Wissenschaften",
  },
  {
    label: "Zuyd Hogeschool",
    value: "Zuyd Hogeschool",
  },
];
